function _defineProperty2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _slicedToArray2(arr, i) { return _arrayWithHoles2(arr) || _iterableToArrayLimit2(arr, i) || _unsupportedIterableToArray2(arr, i) || _nonIterableRest2(); }

function _nonIterableRest2() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit2(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles2(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof2(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray2(o, minLen); }

function _arrayLikeToArray2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

(function webpackUniversalModuleDefinition(root, factory) {
  if ((typeof exports === "undefined" ? "undefined" : _typeof2(exports)) === 'object' && (typeof module === "undefined" ? "undefined" : _typeof2(module)) === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define([], factory);else if ((typeof exports === "undefined" ? "undefined" : _typeof2(exports)) === 'object') exports["charts"] = factory();else root["charts"] = factory();
})(self, function () {
  return (
    /******/
    function () {
      // webpackBootstrap

      /******/
      var __webpack_modules__ = {
        /***/
        539:
        /***/
        function _(module, __webpack_exports__, __webpack_require__) {
          "use strict";
          /* harmony export */

          __webpack_require__.d(__webpack_exports__, {
            /* harmony export */
            "Z": function Z() {
              return __WEBPACK_DEFAULT_EXPORT__;
            }
            /* harmony export */

          });
          /* harmony import */


          var _node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4015);
          /* harmony import */


          var _node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0__);
          /* harmony import */


          var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
          /* harmony import */


          var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__); // Imports


          var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()(_node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0___default()); // Module


          ___CSS_LOADER_EXPORT___.push([module.id, "svg g.tick line{opacity:.1}svg g.tick:nth-of-type(1) .y-axis-grid{opacity:1}svg path.domain{display:none}.tooltip{position:absolute;border:1px solid rgba(0,0,0,.125);border-radius:5px;padding:10px;background:#fff;pointer-events:none}.tooltip ul{font-size:12px;margin:0;padding:0;list-style:none;color:#000}.tooltip ul li{white-space:nowrap}.overlay{fill:none;pointer-events:all}.focus circle{fill:#ff7b00}", "", {
            "version": 3,
            "sources": ["webpack://./src/style.scss"],
            "names": [],
            "mappings": "AAAA,gBACE,UAAA,CAGF,uCACE,SAAA,CAGF,gBACE,YAAA,CAGF,SACE,iBAAA,CACA,iCAAA,CACA,iBAAA,CACA,YAAA,CACA,eAAA,CACA,mBAAA,CAEA,YACE,cAAA,CACA,QAAA,CACA,SAAA,CACA,eAAA,CACA,UAAA,CACA,eACE,kBAAA,CAKN,SACE,SAAA,CACA,kBAAA,CAGF,cACE,YAAA",
            "sourcesContent": ["svg g.tick line {\n  opacity: 0.1;\n}\n\nsvg g.tick:nth-of-type(1) .y-axis-grid {\n  opacity: 1;\n}\n\nsvg path.domain {\n  display: none;\n}\n\n.tooltip {\n  position: absolute;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  border-radius: 5px;\n  padding: 10px;\n  background: white;\n  pointer-events: none;\n  // transition: all 0.2s ease-out;\n  ul {\n    font-size: 12px;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    color: black;\n    li {\n      white-space: nowrap;\n    }\n  }\n}\n\n.overlay {\n  fill: none;\n  pointer-events: all;\n}\n\n.focus circle {\n  fill: rgb(255, 123, 0);\n}\n"],
            "sourceRoot": ""
          }]); // Exports

          /* harmony default export */


          var __WEBPACK_DEFAULT_EXPORT__ = ___CSS_LOADER_EXPORT___;
          /***/
        },

        /***/
        3645:
        /***/
        function _(module) {
          "use strict";
          /*
            MIT License http://www.opensource.org/licenses/mit-license.php
            Author Tobias Koppers @sokra
          */
          // css base code, injected by the css-loader
          // eslint-disable-next-line func-names

          module.exports = function (cssWithMappingToString) {
            var list = []; // return the list of modules as css string

            list.toString = function toString() {
              return this.map(function (item) {
                var content = cssWithMappingToString(item);

                if (item[2]) {
                  return "@media ".concat(item[2], " {").concat(content, "}");
                }

                return content;
              }).join("");
            }; // import a list of modules into the list
            // eslint-disable-next-line func-names


            list.i = function (modules, mediaQuery, dedupe) {
              if (typeof modules === "string") {
                // eslint-disable-next-line no-param-reassign
                modules = [[null, modules, ""]];
              }

              var alreadyImportedModules = {};

              if (dedupe) {
                for (var i = 0; i < this.length; i++) {
                  // eslint-disable-next-line prefer-destructuring
                  var id = this[i][0];

                  if (id != null) {
                    alreadyImportedModules[id] = true;
                  }
                }
              }

              for (var _i = 0; _i < modules.length; _i++) {
                var item = [].concat(modules[_i]);

                if (dedupe && alreadyImportedModules[item[0]]) {
                  // eslint-disable-next-line no-continue
                  continue;
                }

                if (mediaQuery) {
                  if (!item[2]) {
                    item[2] = mediaQuery;
                  } else {
                    item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
                  }
                }

                list.push(item);
              }
            };

            return list;
          };
          /***/

        },

        /***/
        4015:
        /***/
        function _(module) {
          "use strict";

          function _slicedToArray(arr, i) {
            return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
          }

          function _nonIterableRest() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }

          function _unsupportedIterableToArray(o, minLen) {
            if (!o) return;
            if (typeof o === "string") return _arrayLikeToArray(o, minLen);
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if (n === "Object" && o.constructor) n = o.constructor.name;
            if (n === "Map" || n === "Set") return Array.from(o);
            if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
          }

          function _arrayLikeToArray(arr, len) {
            if (len == null || len > arr.length) len = arr.length;

            for (var i = 0, arr2 = new Array(len); i < len; i++) {
              arr2[i] = arr[i];
            }

            return arr2;
          }

          function _iterableToArrayLimit(arr, i) {
            var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

            if (_i == null) return;
            var _arr = [];
            var _n = true;
            var _d = false;

            var _s, _e;

            try {
              for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);

                if (i && _arr.length === i) break;
              }
            } catch (err) {
              _d = true;
              _e = err;
            } finally {
              try {
                if (!_n && _i["return"] != null) _i["return"]();
              } finally {
                if (_d) throw _e;
              }
            }

            return _arr;
          }

          function _arrayWithHoles(arr) {
            if (Array.isArray(arr)) return arr;
          }

          module.exports = function cssWithMappingToString(item) {
            var _item = _slicedToArray(item, 4),
                content = _item[1],
                cssMapping = _item[3];

            if (!cssMapping) {
              return content;
            }

            if (typeof btoa === "function") {
              // eslint-disable-next-line no-undef
              var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(cssMapping))));
              var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
              var sourceMapping = "/*# ".concat(data, " */");
              var sourceURLs = cssMapping.sources.map(function (source) {
                return "/*# sourceURL=".concat(cssMapping.sourceRoot || "").concat(source, " */");
              });
              return [content].concat(sourceURLs).concat([sourceMapping]).join("\n");
            }

            return [content].join("\n");
          };
          /***/

        },

        /***/
        6486:
        /***/
        function _(module, exports, __webpack_require__) {
          /* module decorator */
          module = __webpack_require__.nmd(module);

          var __WEBPACK_AMD_DEFINE_RESULT__;
          /**
          * @license
          * Lodash <https://lodash.com/>
          * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
          * Released under MIT license <https://lodash.com/license>
          * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
          * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
          */


          ;
          (function () {
            /** Used as a safe reference for `undefined` in pre-ES5 environments. */
            var undefined;
            /** Used as the semantic version number. */

            var VERSION = '4.17.21';
            /** Used as the size to enable large array optimizations. */

            var LARGE_ARRAY_SIZE = 200;
            /** Error message constants. */

            var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
                FUNC_ERROR_TEXT = 'Expected a function',
                INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
            /** Used to stand-in for `undefined` hash values. */

            var HASH_UNDEFINED = '__lodash_hash_undefined__';
            /** Used as the maximum memoize cache size. */

            var MAX_MEMOIZE_SIZE = 500;
            /** Used as the internal argument placeholder. */

            var PLACEHOLDER = '__lodash_placeholder__';
            /** Used to compose bitmasks for cloning. */

            var CLONE_DEEP_FLAG = 1,
                CLONE_FLAT_FLAG = 2,
                CLONE_SYMBOLS_FLAG = 4;
            /** Used to compose bitmasks for value comparisons. */

            var COMPARE_PARTIAL_FLAG = 1,
                COMPARE_UNORDERED_FLAG = 2;
            /** Used to compose bitmasks for function metadata. */

            var WRAP_BIND_FLAG = 1,
                WRAP_BIND_KEY_FLAG = 2,
                WRAP_CURRY_BOUND_FLAG = 4,
                WRAP_CURRY_FLAG = 8,
                WRAP_CURRY_RIGHT_FLAG = 16,
                WRAP_PARTIAL_FLAG = 32,
                WRAP_PARTIAL_RIGHT_FLAG = 64,
                WRAP_ARY_FLAG = 128,
                WRAP_REARG_FLAG = 256,
                WRAP_FLIP_FLAG = 512;
            /** Used as default options for `_.truncate`. */

            var DEFAULT_TRUNC_LENGTH = 30,
                DEFAULT_TRUNC_OMISSION = '...';
            /** Used to detect hot functions by number of calls within a span of milliseconds. */

            var HOT_COUNT = 800,
                HOT_SPAN = 16;
            /** Used to indicate the type of lazy iteratees. */

            var LAZY_FILTER_FLAG = 1,
                LAZY_MAP_FLAG = 2,
                LAZY_WHILE_FLAG = 3;
            /** Used as references for various `Number` constants. */

            var INFINITY = 1 / 0,
                MAX_SAFE_INTEGER = 9007199254740991,
                MAX_INTEGER = 1.7976931348623157e+308,
                NAN = 0 / 0;
            /** Used as references for the maximum length and index of an array. */

            var MAX_ARRAY_LENGTH = 4294967295,
                MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
                HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
            /** Used to associate wrap methods with their bit flags. */

            var wrapFlags = [['ary', WRAP_ARY_FLAG], ['bind', WRAP_BIND_FLAG], ['bindKey', WRAP_BIND_KEY_FLAG], ['curry', WRAP_CURRY_FLAG], ['curryRight', WRAP_CURRY_RIGHT_FLAG], ['flip', WRAP_FLIP_FLAG], ['partial', WRAP_PARTIAL_FLAG], ['partialRight', WRAP_PARTIAL_RIGHT_FLAG], ['rearg', WRAP_REARG_FLAG]];
            /** `Object#toString` result references. */

            var argsTag = '[object Arguments]',
                arrayTag = '[object Array]',
                asyncTag = '[object AsyncFunction]',
                boolTag = '[object Boolean]',
                dateTag = '[object Date]',
                domExcTag = '[object DOMException]',
                errorTag = '[object Error]',
                funcTag = '[object Function]',
                genTag = '[object GeneratorFunction]',
                mapTag = '[object Map]',
                numberTag = '[object Number]',
                nullTag = '[object Null]',
                objectTag = '[object Object]',
                promiseTag = '[object Promise]',
                proxyTag = '[object Proxy]',
                regexpTag = '[object RegExp]',
                setTag = '[object Set]',
                stringTag = '[object String]',
                symbolTag = '[object Symbol]',
                undefinedTag = '[object Undefined]',
                weakMapTag = '[object WeakMap]',
                weakSetTag = '[object WeakSet]';
            var arrayBufferTag = '[object ArrayBuffer]',
                dataViewTag = '[object DataView]',
                float32Tag = '[object Float32Array]',
                float64Tag = '[object Float64Array]',
                int8Tag = '[object Int8Array]',
                int16Tag = '[object Int16Array]',
                int32Tag = '[object Int32Array]',
                uint8Tag = '[object Uint8Array]',
                uint8ClampedTag = '[object Uint8ClampedArray]',
                uint16Tag = '[object Uint16Array]',
                uint32Tag = '[object Uint32Array]';
            /** Used to match empty string literals in compiled template source. */

            var reEmptyStringLeading = /\b__p \+= '';/g,
                reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
                reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
            /** Used to match HTML entities and HTML characters. */

            var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
                reUnescapedHtml = /[&<>"']/g,
                reHasEscapedHtml = RegExp(reEscapedHtml.source),
                reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
            /** Used to match template delimiters. */

            var reEscape = /<%-([\s\S]+?)%>/g,
                reEvaluate = /<%([\s\S]+?)%>/g,
                reInterpolate = /<%=([\s\S]+?)%>/g;
            /** Used to match property names within property paths. */

            var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
                reIsPlainProp = /^\w*$/,
                rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
            /**
             * Used to match `RegExp`
             * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
             */

            var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
                reHasRegExpChar = RegExp(reRegExpChar.source);
            /** Used to match leading whitespace. */

            var reTrimStart = /^\s+/;
            /** Used to match a single whitespace character. */

            var reWhitespace = /\s/;
            /** Used to match wrap detail comments. */

            var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
                reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
                reSplitDetails = /,? & /;
            /** Used to match words composed of alphanumeric characters. */

            var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
            /**
             * Used to validate the `validate` option in `_.template` variable.
             *
             * Forbids characters which could potentially change the meaning of the function argument definition:
             * - "()," (modification of function parameters)
             * - "=" (default value)
             * - "[]{}" (destructuring of function parameters)
             * - "/" (beginning of a comment)
             * - whitespace
             */

            var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
            /** Used to match backslashes in property paths. */

            var reEscapeChar = /\\(\\)?/g;
            /**
             * Used to match
             * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
             */

            var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
            /** Used to match `RegExp` flags from their coerced string values. */

            var reFlags = /\w*$/;
            /** Used to detect bad signed hexadecimal string values. */

            var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
            /** Used to detect binary string values. */

            var reIsBinary = /^0b[01]+$/i;
            /** Used to detect host constructors (Safari). */

            var reIsHostCtor = /^\[object .+?Constructor\]$/;
            /** Used to detect octal string values. */

            var reIsOctal = /^0o[0-7]+$/i;
            /** Used to detect unsigned integer values. */

            var reIsUint = /^(?:0|[1-9]\d*)$/;
            /** Used to match Latin Unicode letters (excluding mathematical operators). */

            var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
            /** Used to ensure capturing order of template delimiters. */

            var reNoMatch = /($^)/;
            /** Used to match unescaped characters in compiled string literals. */

            var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
            /** Used to compose unicode character classes. */

            var rsAstralRange = "\\ud800-\\udfff",
                rsComboMarksRange = "\\u0300-\\u036f",
                reComboHalfMarksRange = "\\ufe20-\\ufe2f",
                rsComboSymbolsRange = "\\u20d0-\\u20ff",
                rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
                rsDingbatRange = "\\u2700-\\u27bf",
                rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
                rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
                rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
                rsPunctuationRange = "\\u2000-\\u206f",
                rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
                rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
                rsVarRange = "\\ufe0e\\ufe0f",
                rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
            /** Used to compose unicode capture groups. */

            var rsApos = "['\u2019]",
                rsAstral = '[' + rsAstralRange + ']',
                rsBreak = '[' + rsBreakRange + ']',
                rsCombo = '[' + rsComboRange + ']',
                rsDigits = '\\d+',
                rsDingbat = '[' + rsDingbatRange + ']',
                rsLower = '[' + rsLowerRange + ']',
                rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
                rsFitz = "\\ud83c[\\udffb-\\udfff]",
                rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
                rsNonAstral = '[^' + rsAstralRange + ']',
                rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
                rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
                rsUpper = '[' + rsUpperRange + ']',
                rsZWJ = "\\u200d";
            /** Used to compose unicode regexes. */

            var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
                rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
                rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
                rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
                reOptMod = rsModifier + '?',
                rsOptVar = '[' + rsVarRange + ']?',
                rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
                rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
                rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
                rsSeq = rsOptVar + reOptMod + rsOptJoin,
                rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
                rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
            /** Used to match apostrophes. */

            var reApos = RegExp(rsApos, 'g');
            /**
             * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
             * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
             */

            var reComboMark = RegExp(rsCombo, 'g');
            /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */

            var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
            /** Used to match complex or compound words. */

            var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')', rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower, rsUpper + '+' + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join('|'), 'g');
            /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */

            var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
            /** Used to detect strings that need a more robust regexp to match words. */

            var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
            /** Used to assign default `context` object properties. */

            var contextProps = ['Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array', 'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object', 'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap', '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'];
            /** Used to make template sourceURLs easier to identify. */

            var templateCounter = -1;
            /** Used to identify `toStringTag` values of typed arrays. */

            var typedArrayTags = {};
            typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
            typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
            /** Used to identify `toStringTag` values supported by `_.clone`. */

            var cloneableTags = {};
            cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
            cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
            /** Used to map Latin Unicode letters to basic Latin letters. */

            var deburredLetters = {
              // Latin-1 Supplement block.
              '\xc0': 'A',
              '\xc1': 'A',
              '\xc2': 'A',
              '\xc3': 'A',
              '\xc4': 'A',
              '\xc5': 'A',
              '\xe0': 'a',
              '\xe1': 'a',
              '\xe2': 'a',
              '\xe3': 'a',
              '\xe4': 'a',
              '\xe5': 'a',
              '\xc7': 'C',
              '\xe7': 'c',
              '\xd0': 'D',
              '\xf0': 'd',
              '\xc8': 'E',
              '\xc9': 'E',
              '\xca': 'E',
              '\xcb': 'E',
              '\xe8': 'e',
              '\xe9': 'e',
              '\xea': 'e',
              '\xeb': 'e',
              '\xcc': 'I',
              '\xcd': 'I',
              '\xce': 'I',
              '\xcf': 'I',
              '\xec': 'i',
              '\xed': 'i',
              '\xee': 'i',
              '\xef': 'i',
              '\xd1': 'N',
              '\xf1': 'n',
              '\xd2': 'O',
              '\xd3': 'O',
              '\xd4': 'O',
              '\xd5': 'O',
              '\xd6': 'O',
              '\xd8': 'O',
              '\xf2': 'o',
              '\xf3': 'o',
              '\xf4': 'o',
              '\xf5': 'o',
              '\xf6': 'o',
              '\xf8': 'o',
              '\xd9': 'U',
              '\xda': 'U',
              '\xdb': 'U',
              '\xdc': 'U',
              '\xf9': 'u',
              '\xfa': 'u',
              '\xfb': 'u',
              '\xfc': 'u',
              '\xdd': 'Y',
              '\xfd': 'y',
              '\xff': 'y',
              '\xc6': 'Ae',
              '\xe6': 'ae',
              '\xde': 'Th',
              '\xfe': 'th',
              '\xdf': 'ss',
              // Latin Extended-A block.
              "\u0100": 'A',
              "\u0102": 'A',
              "\u0104": 'A',
              "\u0101": 'a',
              "\u0103": 'a',
              "\u0105": 'a',
              "\u0106": 'C',
              "\u0108": 'C',
              "\u010A": 'C',
              "\u010C": 'C',
              "\u0107": 'c',
              "\u0109": 'c',
              "\u010B": 'c',
              "\u010D": 'c',
              "\u010E": 'D',
              "\u0110": 'D',
              "\u010F": 'd',
              "\u0111": 'd',
              "\u0112": 'E',
              "\u0114": 'E',
              "\u0116": 'E',
              "\u0118": 'E',
              "\u011A": 'E',
              "\u0113": 'e',
              "\u0115": 'e',
              "\u0117": 'e',
              "\u0119": 'e',
              "\u011B": 'e',
              "\u011C": 'G',
              "\u011E": 'G',
              "\u0120": 'G',
              "\u0122": 'G',
              "\u011D": 'g',
              "\u011F": 'g',
              "\u0121": 'g',
              "\u0123": 'g',
              "\u0124": 'H',
              "\u0126": 'H',
              "\u0125": 'h',
              "\u0127": 'h',
              "\u0128": 'I',
              "\u012A": 'I',
              "\u012C": 'I',
              "\u012E": 'I',
              "\u0130": 'I',
              "\u0129": 'i',
              "\u012B": 'i',
              "\u012D": 'i',
              "\u012F": 'i',
              "\u0131": 'i',
              "\u0134": 'J',
              "\u0135": 'j',
              "\u0136": 'K',
              "\u0137": 'k',
              "\u0138": 'k',
              "\u0139": 'L',
              "\u013B": 'L',
              "\u013D": 'L',
              "\u013F": 'L',
              "\u0141": 'L',
              "\u013A": 'l',
              "\u013C": 'l',
              "\u013E": 'l',
              "\u0140": 'l',
              "\u0142": 'l',
              "\u0143": 'N',
              "\u0145": 'N',
              "\u0147": 'N',
              "\u014A": 'N',
              "\u0144": 'n',
              "\u0146": 'n',
              "\u0148": 'n',
              "\u014B": 'n',
              "\u014C": 'O',
              "\u014E": 'O',
              "\u0150": 'O',
              "\u014D": 'o',
              "\u014F": 'o',
              "\u0151": 'o',
              "\u0154": 'R',
              "\u0156": 'R',
              "\u0158": 'R',
              "\u0155": 'r',
              "\u0157": 'r',
              "\u0159": 'r',
              "\u015A": 'S',
              "\u015C": 'S',
              "\u015E": 'S',
              "\u0160": 'S',
              "\u015B": 's',
              "\u015D": 's',
              "\u015F": 's',
              "\u0161": 's',
              "\u0162": 'T',
              "\u0164": 'T',
              "\u0166": 'T',
              "\u0163": 't',
              "\u0165": 't',
              "\u0167": 't',
              "\u0168": 'U',
              "\u016A": 'U',
              "\u016C": 'U',
              "\u016E": 'U',
              "\u0170": 'U',
              "\u0172": 'U',
              "\u0169": 'u',
              "\u016B": 'u',
              "\u016D": 'u',
              "\u016F": 'u',
              "\u0171": 'u',
              "\u0173": 'u',
              "\u0174": 'W',
              "\u0175": 'w',
              "\u0176": 'Y',
              "\u0177": 'y',
              "\u0178": 'Y',
              "\u0179": 'Z',
              "\u017B": 'Z',
              "\u017D": 'Z',
              "\u017A": 'z',
              "\u017C": 'z',
              "\u017E": 'z',
              "\u0132": 'IJ',
              "\u0133": 'ij',
              "\u0152": 'Oe',
              "\u0153": 'oe',
              "\u0149": "'n",
              "\u017F": 's'
            };
            /** Used to map characters to HTML entities. */

            var htmlEscapes = {
              '&': '&amp;',
              '<': '&lt;',
              '>': '&gt;',
              '"': '&quot;',
              "'": '&#39;'
            };
            /** Used to map HTML entities to characters. */

            var htmlUnescapes = {
              '&amp;': '&',
              '&lt;': '<',
              '&gt;': '>',
              '&quot;': '"',
              '&#39;': "'"
            };
            /** Used to escape characters for inclusion in compiled string literals. */

            var stringEscapes = {
              '\\': '\\',
              "'": "'",
              '\n': 'n',
              '\r': 'r',
              "\u2028": 'u2028',
              "\u2029": 'u2029'
            };
            /** Built-in method references without a dependency on `root`. */

            var freeParseFloat = parseFloat,
                freeParseInt = parseInt;
            /** Detect free variable `global` from Node.js. */

            var freeGlobal = _typeof2(__webpack_require__.g) == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;
            /** Detect free variable `self`. */


            var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof2(self)) == 'object' && self && self.Object === Object && self;
            /** Used as a reference to the global object. */

            var root = freeGlobal || freeSelf || Function('return this')();
            /** Detect free variable `exports`. */

            var freeExports = true && exports && !exports.nodeType && exports;
            /** Detect free variable `module`. */

            var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;
            /** Detect the popular CommonJS extension `module.exports`. */

            var moduleExports = freeModule && freeModule.exports === freeExports;
            /** Detect free variable `process` from Node.js. */

            var freeProcess = moduleExports && freeGlobal.process;
            /** Used to access faster Node.js helpers. */

            var nodeUtil = function () {
              try {
                // Use `util.types` for Node.js 10+.
                var types = freeModule && freeModule.require && freeModule.require('util').types;

                if (types) {
                  return types;
                } // Legacy `process.binding('util')` for Node.js < 10.


                return freeProcess && freeProcess.binding && freeProcess.binding('util');
              } catch (e) {}
            }();
            /* Node.js helper references. */


            var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
                nodeIsDate = nodeUtil && nodeUtil.isDate,
                nodeIsMap = nodeUtil && nodeUtil.isMap,
                nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
                nodeIsSet = nodeUtil && nodeUtil.isSet,
                nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
            /*--------------------------------------------------------------------------*/

            /**
             * A faster alternative to `Function#apply`, this function invokes `func`
             * with the `this` binding of `thisArg` and the arguments of `args`.
             *
             * @private
             * @param {Function} func The function to invoke.
             * @param {*} thisArg The `this` binding of `func`.
             * @param {Array} args The arguments to invoke `func` with.
             * @returns {*} Returns the result of `func`.
             */

            function apply(func, thisArg, args) {
              switch (args.length) {
                case 0:
                  return func.call(thisArg);

                case 1:
                  return func.call(thisArg, args[0]);

                case 2:
                  return func.call(thisArg, args[0], args[1]);

                case 3:
                  return func.call(thisArg, args[0], args[1], args[2]);
              }

              return func.apply(thisArg, args);
            }
            /**
             * A specialized version of `baseAggregator` for arrays.
             *
             * @private
             * @param {Array} [array] The array to iterate over.
             * @param {Function} setter The function to set `accumulator` values.
             * @param {Function} iteratee The iteratee to transform keys.
             * @param {Object} accumulator The initial aggregated object.
             * @returns {Function} Returns `accumulator`.
             */


            function arrayAggregator(array, setter, iteratee, accumulator) {
              var index = -1,
                  length = array == null ? 0 : array.length;

              while (++index < length) {
                var value = array[index];
                setter(accumulator, value, iteratee(value), array);
              }

              return accumulator;
            }
            /**
             * A specialized version of `_.forEach` for arrays without support for
             * iteratee shorthands.
             *
             * @private
             * @param {Array} [array] The array to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @returns {Array} Returns `array`.
             */


            function arrayEach(array, iteratee) {
              var index = -1,
                  length = array == null ? 0 : array.length;

              while (++index < length) {
                if (iteratee(array[index], index, array) === false) {
                  break;
                }
              }

              return array;
            }
            /**
             * A specialized version of `_.forEachRight` for arrays without support for
             * iteratee shorthands.
             *
             * @private
             * @param {Array} [array] The array to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @returns {Array} Returns `array`.
             */


            function arrayEachRight(array, iteratee) {
              var length = array == null ? 0 : array.length;

              while (length--) {
                if (iteratee(array[length], length, array) === false) {
                  break;
                }
              }

              return array;
            }
            /**
             * A specialized version of `_.every` for arrays without support for
             * iteratee shorthands.
             *
             * @private
             * @param {Array} [array] The array to iterate over.
             * @param {Function} predicate The function invoked per iteration.
             * @returns {boolean} Returns `true` if all elements pass the predicate check,
             *  else `false`.
             */


            function arrayEvery(array, predicate) {
              var index = -1,
                  length = array == null ? 0 : array.length;

              while (++index < length) {
                if (!predicate(array[index], index, array)) {
                  return false;
                }
              }

              return true;
            }
            /**
             * A specialized version of `_.filter` for arrays without support for
             * iteratee shorthands.
             *
             * @private
             * @param {Array} [array] The array to iterate over.
             * @param {Function} predicate The function invoked per iteration.
             * @returns {Array} Returns the new filtered array.
             */


            function arrayFilter(array, predicate) {
              var index = -1,
                  length = array == null ? 0 : array.length,
                  resIndex = 0,
                  result = [];

              while (++index < length) {
                var value = array[index];

                if (predicate(value, index, array)) {
                  result[resIndex++] = value;
                }
              }

              return result;
            }
            /**
             * A specialized version of `_.includes` for arrays without support for
             * specifying an index to search from.
             *
             * @private
             * @param {Array} [array] The array to inspect.
             * @param {*} target The value to search for.
             * @returns {boolean} Returns `true` if `target` is found, else `false`.
             */


            function arrayIncludes(array, value) {
              var length = array == null ? 0 : array.length;
              return !!length && baseIndexOf(array, value, 0) > -1;
            }
            /**
             * This function is like `arrayIncludes` except that it accepts a comparator.
             *
             * @private
             * @param {Array} [array] The array to inspect.
             * @param {*} target The value to search for.
             * @param {Function} comparator The comparator invoked per element.
             * @returns {boolean} Returns `true` if `target` is found, else `false`.
             */


            function arrayIncludesWith(array, value, comparator) {
              var index = -1,
                  length = array == null ? 0 : array.length;

              while (++index < length) {
                if (comparator(value, array[index])) {
                  return true;
                }
              }

              return false;
            }
            /**
             * A specialized version of `_.map` for arrays without support for iteratee
             * shorthands.
             *
             * @private
             * @param {Array} [array] The array to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @returns {Array} Returns the new mapped array.
             */


            function arrayMap(array, iteratee) {
              var index = -1,
                  length = array == null ? 0 : array.length,
                  result = Array(length);

              while (++index < length) {
                result[index] = iteratee(array[index], index, array);
              }

              return result;
            }
            /**
             * Appends the elements of `values` to `array`.
             *
             * @private
             * @param {Array} array The array to modify.
             * @param {Array} values The values to append.
             * @returns {Array} Returns `array`.
             */


            function arrayPush(array, values) {
              var index = -1,
                  length = values.length,
                  offset = array.length;

              while (++index < length) {
                array[offset + index] = values[index];
              }

              return array;
            }
            /**
             * A specialized version of `_.reduce` for arrays without support for
             * iteratee shorthands.
             *
             * @private
             * @param {Array} [array] The array to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @param {*} [accumulator] The initial value.
             * @param {boolean} [initAccum] Specify using the first element of `array` as
             *  the initial value.
             * @returns {*} Returns the accumulated value.
             */


            function arrayReduce(array, iteratee, accumulator, initAccum) {
              var index = -1,
                  length = array == null ? 0 : array.length;

              if (initAccum && length) {
                accumulator = array[++index];
              }

              while (++index < length) {
                accumulator = iteratee(accumulator, array[index], index, array);
              }

              return accumulator;
            }
            /**
             * A specialized version of `_.reduceRight` for arrays without support for
             * iteratee shorthands.
             *
             * @private
             * @param {Array} [array] The array to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @param {*} [accumulator] The initial value.
             * @param {boolean} [initAccum] Specify using the last element of `array` as
             *  the initial value.
             * @returns {*} Returns the accumulated value.
             */


            function arrayReduceRight(array, iteratee, accumulator, initAccum) {
              var length = array == null ? 0 : array.length;

              if (initAccum && length) {
                accumulator = array[--length];
              }

              while (length--) {
                accumulator = iteratee(accumulator, array[length], length, array);
              }

              return accumulator;
            }
            /**
             * A specialized version of `_.some` for arrays without support for iteratee
             * shorthands.
             *
             * @private
             * @param {Array} [array] The array to iterate over.
             * @param {Function} predicate The function invoked per iteration.
             * @returns {boolean} Returns `true` if any element passes the predicate check,
             *  else `false`.
             */


            function arraySome(array, predicate) {
              var index = -1,
                  length = array == null ? 0 : array.length;

              while (++index < length) {
                if (predicate(array[index], index, array)) {
                  return true;
                }
              }

              return false;
            }
            /**
             * Gets the size of an ASCII `string`.
             *
             * @private
             * @param {string} string The string inspect.
             * @returns {number} Returns the string size.
             */


            var asciiSize = baseProperty('length');
            /**
             * Converts an ASCII `string` to an array.
             *
             * @private
             * @param {string} string The string to convert.
             * @returns {Array} Returns the converted array.
             */

            function asciiToArray(string) {
              return string.split('');
            }
            /**
             * Splits an ASCII `string` into an array of its words.
             *
             * @private
             * @param {string} The string to inspect.
             * @returns {Array} Returns the words of `string`.
             */


            function asciiWords(string) {
              return string.match(reAsciiWord) || [];
            }
            /**
             * The base implementation of methods like `_.findKey` and `_.findLastKey`,
             * without support for iteratee shorthands, which iterates over `collection`
             * using `eachFunc`.
             *
             * @private
             * @param {Array|Object} collection The collection to inspect.
             * @param {Function} predicate The function invoked per iteration.
             * @param {Function} eachFunc The function to iterate over `collection`.
             * @returns {*} Returns the found element or its key, else `undefined`.
             */


            function baseFindKey(collection, predicate, eachFunc) {
              var result;
              eachFunc(collection, function (value, key, collection) {
                if (predicate(value, key, collection)) {
                  result = key;
                  return false;
                }
              });
              return result;
            }
            /**
             * The base implementation of `_.findIndex` and `_.findLastIndex` without
             * support for iteratee shorthands.
             *
             * @private
             * @param {Array} array The array to inspect.
             * @param {Function} predicate The function invoked per iteration.
             * @param {number} fromIndex The index to search from.
             * @param {boolean} [fromRight] Specify iterating from right to left.
             * @returns {number} Returns the index of the matched value, else `-1`.
             */


            function baseFindIndex(array, predicate, fromIndex, fromRight) {
              var length = array.length,
                  index = fromIndex + (fromRight ? 1 : -1);

              while (fromRight ? index-- : ++index < length) {
                if (predicate(array[index], index, array)) {
                  return index;
                }
              }

              return -1;
            }
            /**
             * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
             *
             * @private
             * @param {Array} array The array to inspect.
             * @param {*} value The value to search for.
             * @param {number} fromIndex The index to search from.
             * @returns {number} Returns the index of the matched value, else `-1`.
             */


            function baseIndexOf(array, value, fromIndex) {
              return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
            }
            /**
             * This function is like `baseIndexOf` except that it accepts a comparator.
             *
             * @private
             * @param {Array} array The array to inspect.
             * @param {*} value The value to search for.
             * @param {number} fromIndex The index to search from.
             * @param {Function} comparator The comparator invoked per element.
             * @returns {number} Returns the index of the matched value, else `-1`.
             */


            function baseIndexOfWith(array, value, fromIndex, comparator) {
              var index = fromIndex - 1,
                  length = array.length;

              while (++index < length) {
                if (comparator(array[index], value)) {
                  return index;
                }
              }

              return -1;
            }
            /**
             * The base implementation of `_.isNaN` without support for number objects.
             *
             * @private
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
             */


            function baseIsNaN(value) {
              return value !== value;
            }
            /**
             * The base implementation of `_.mean` and `_.meanBy` without support for
             * iteratee shorthands.
             *
             * @private
             * @param {Array} array The array to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @returns {number} Returns the mean.
             */


            function baseMean(array, iteratee) {
              var length = array == null ? 0 : array.length;
              return length ? baseSum(array, iteratee) / length : NAN;
            }
            /**
             * The base implementation of `_.property` without support for deep paths.
             *
             * @private
             * @param {string} key The key of the property to get.
             * @returns {Function} Returns the new accessor function.
             */


            function baseProperty(key) {
              return function (object) {
                return object == null ? undefined : object[key];
              };
            }
            /**
             * The base implementation of `_.propertyOf` without support for deep paths.
             *
             * @private
             * @param {Object} object The object to query.
             * @returns {Function} Returns the new accessor function.
             */


            function basePropertyOf(object) {
              return function (key) {
                return object == null ? undefined : object[key];
              };
            }
            /**
             * The base implementation of `_.reduce` and `_.reduceRight`, without support
             * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
             *
             * @private
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @param {*} accumulator The initial value.
             * @param {boolean} initAccum Specify using the first or last element of
             *  `collection` as the initial value.
             * @param {Function} eachFunc The function to iterate over `collection`.
             * @returns {*} Returns the accumulated value.
             */


            function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
              eachFunc(collection, function (value, index, collection) {
                accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
              });
              return accumulator;
            }
            /**
             * The base implementation of `_.sortBy` which uses `comparer` to define the
             * sort order of `array` and replaces criteria objects with their corresponding
             * values.
             *
             * @private
             * @param {Array} array The array to sort.
             * @param {Function} comparer The function to define sort order.
             * @returns {Array} Returns `array`.
             */


            function baseSortBy(array, comparer) {
              var length = array.length;
              array.sort(comparer);

              while (length--) {
                array[length] = array[length].value;
              }

              return array;
            }
            /**
             * The base implementation of `_.sum` and `_.sumBy` without support for
             * iteratee shorthands.
             *
             * @private
             * @param {Array} array The array to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @returns {number} Returns the sum.
             */


            function baseSum(array, iteratee) {
              var result,
                  index = -1,
                  length = array.length;

              while (++index < length) {
                var current = iteratee(array[index]);

                if (current !== undefined) {
                  result = result === undefined ? current : result + current;
                }
              }

              return result;
            }
            /**
             * The base implementation of `_.times` without support for iteratee shorthands
             * or max array length checks.
             *
             * @private
             * @param {number} n The number of times to invoke `iteratee`.
             * @param {Function} iteratee The function invoked per iteration.
             * @returns {Array} Returns the array of results.
             */


            function baseTimes(n, iteratee) {
              var index = -1,
                  result = Array(n);

              while (++index < n) {
                result[index] = iteratee(index);
              }

              return result;
            }
            /**
             * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
             * of key-value pairs for `object` corresponding to the property names of `props`.
             *
             * @private
             * @param {Object} object The object to query.
             * @param {Array} props The property names to get values for.
             * @returns {Object} Returns the key-value pairs.
             */


            function baseToPairs(object, props) {
              return arrayMap(props, function (key) {
                return [key, object[key]];
              });
            }
            /**
             * The base implementation of `_.trim`.
             *
             * @private
             * @param {string} string The string to trim.
             * @returns {string} Returns the trimmed string.
             */


            function baseTrim(string) {
              return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
            }
            /**
             * The base implementation of `_.unary` without support for storing metadata.
             *
             * @private
             * @param {Function} func The function to cap arguments for.
             * @returns {Function} Returns the new capped function.
             */


            function baseUnary(func) {
              return function (value) {
                return func(value);
              };
            }
            /**
             * The base implementation of `_.values` and `_.valuesIn` which creates an
             * array of `object` property values corresponding to the property names
             * of `props`.
             *
             * @private
             * @param {Object} object The object to query.
             * @param {Array} props The property names to get values for.
             * @returns {Object} Returns the array of property values.
             */


            function baseValues(object, props) {
              return arrayMap(props, function (key) {
                return object[key];
              });
            }
            /**
             * Checks if a `cache` value for `key` exists.
             *
             * @private
             * @param {Object} cache The cache to query.
             * @param {string} key The key of the entry to check.
             * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
             */


            function cacheHas(cache, key) {
              return cache.has(key);
            }
            /**
             * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
             * that is not found in the character symbols.
             *
             * @private
             * @param {Array} strSymbols The string symbols to inspect.
             * @param {Array} chrSymbols The character symbols to find.
             * @returns {number} Returns the index of the first unmatched string symbol.
             */


            function charsStartIndex(strSymbols, chrSymbols) {
              var index = -1,
                  length = strSymbols.length;

              while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}

              return index;
            }
            /**
             * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
             * that is not found in the character symbols.
             *
             * @private
             * @param {Array} strSymbols The string symbols to inspect.
             * @param {Array} chrSymbols The character symbols to find.
             * @returns {number} Returns the index of the last unmatched string symbol.
             */


            function charsEndIndex(strSymbols, chrSymbols) {
              var index = strSymbols.length;

              while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}

              return index;
            }
            /**
             * Gets the number of `placeholder` occurrences in `array`.
             *
             * @private
             * @param {Array} array The array to inspect.
             * @param {*} placeholder The placeholder to search for.
             * @returns {number} Returns the placeholder count.
             */


            function countHolders(array, placeholder) {
              var length = array.length,
                  result = 0;

              while (length--) {
                if (array[length] === placeholder) {
                  ++result;
                }
              }

              return result;
            }
            /**
             * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
             * letters to basic Latin letters.
             *
             * @private
             * @param {string} letter The matched letter to deburr.
             * @returns {string} Returns the deburred letter.
             */


            var deburrLetter = basePropertyOf(deburredLetters);
            /**
             * Used by `_.escape` to convert characters to HTML entities.
             *
             * @private
             * @param {string} chr The matched character to escape.
             * @returns {string} Returns the escaped character.
             */

            var escapeHtmlChar = basePropertyOf(htmlEscapes);
            /**
             * Used by `_.template` to escape characters for inclusion in compiled string literals.
             *
             * @private
             * @param {string} chr The matched character to escape.
             * @returns {string} Returns the escaped character.
             */

            function escapeStringChar(chr) {
              return '\\' + stringEscapes[chr];
            }
            /**
             * Gets the value at `key` of `object`.
             *
             * @private
             * @param {Object} [object] The object to query.
             * @param {string} key The key of the property to get.
             * @returns {*} Returns the property value.
             */


            function getValue(object, key) {
              return object == null ? undefined : object[key];
            }
            /**
             * Checks if `string` contains Unicode symbols.
             *
             * @private
             * @param {string} string The string to inspect.
             * @returns {boolean} Returns `true` if a symbol is found, else `false`.
             */


            function hasUnicode(string) {
              return reHasUnicode.test(string);
            }
            /**
             * Checks if `string` contains a word composed of Unicode symbols.
             *
             * @private
             * @param {string} string The string to inspect.
             * @returns {boolean} Returns `true` if a word is found, else `false`.
             */


            function hasUnicodeWord(string) {
              return reHasUnicodeWord.test(string);
            }
            /**
             * Converts `iterator` to an array.
             *
             * @private
             * @param {Object} iterator The iterator to convert.
             * @returns {Array} Returns the converted array.
             */


            function iteratorToArray(iterator) {
              var data,
                  result = [];

              while (!(data = iterator.next()).done) {
                result.push(data.value);
              }

              return result;
            }
            /**
             * Converts `map` to its key-value pairs.
             *
             * @private
             * @param {Object} map The map to convert.
             * @returns {Array} Returns the key-value pairs.
             */


            function mapToArray(map) {
              var index = -1,
                  result = Array(map.size);
              map.forEach(function (value, key) {
                result[++index] = [key, value];
              });
              return result;
            }
            /**
             * Creates a unary function that invokes `func` with its argument transformed.
             *
             * @private
             * @param {Function} func The function to wrap.
             * @param {Function} transform The argument transform.
             * @returns {Function} Returns the new function.
             */


            function overArg(func, transform) {
              return function (arg) {
                return func(transform(arg));
              };
            }
            /**
             * Replaces all `placeholder` elements in `array` with an internal placeholder
             * and returns an array of their indexes.
             *
             * @private
             * @param {Array} array The array to modify.
             * @param {*} placeholder The placeholder to replace.
             * @returns {Array} Returns the new array of placeholder indexes.
             */


            function replaceHolders(array, placeholder) {
              var index = -1,
                  length = array.length,
                  resIndex = 0,
                  result = [];

              while (++index < length) {
                var value = array[index];

                if (value === placeholder || value === PLACEHOLDER) {
                  array[index] = PLACEHOLDER;
                  result[resIndex++] = index;
                }
              }

              return result;
            }
            /**
             * Converts `set` to an array of its values.
             *
             * @private
             * @param {Object} set The set to convert.
             * @returns {Array} Returns the values.
             */


            function setToArray(set) {
              var index = -1,
                  result = Array(set.size);
              set.forEach(function (value) {
                result[++index] = value;
              });
              return result;
            }
            /**
             * Converts `set` to its value-value pairs.
             *
             * @private
             * @param {Object} set The set to convert.
             * @returns {Array} Returns the value-value pairs.
             */


            function setToPairs(set) {
              var index = -1,
                  result = Array(set.size);
              set.forEach(function (value) {
                result[++index] = [value, value];
              });
              return result;
            }
            /**
             * A specialized version of `_.indexOf` which performs strict equality
             * comparisons of values, i.e. `===`.
             *
             * @private
             * @param {Array} array The array to inspect.
             * @param {*} value The value to search for.
             * @param {number} fromIndex The index to search from.
             * @returns {number} Returns the index of the matched value, else `-1`.
             */


            function strictIndexOf(array, value, fromIndex) {
              var index = fromIndex - 1,
                  length = array.length;

              while (++index < length) {
                if (array[index] === value) {
                  return index;
                }
              }

              return -1;
            }
            /**
             * A specialized version of `_.lastIndexOf` which performs strict equality
             * comparisons of values, i.e. `===`.
             *
             * @private
             * @param {Array} array The array to inspect.
             * @param {*} value The value to search for.
             * @param {number} fromIndex The index to search from.
             * @returns {number} Returns the index of the matched value, else `-1`.
             */


            function strictLastIndexOf(array, value, fromIndex) {
              var index = fromIndex + 1;

              while (index--) {
                if (array[index] === value) {
                  return index;
                }
              }

              return index;
            }
            /**
             * Gets the number of symbols in `string`.
             *
             * @private
             * @param {string} string The string to inspect.
             * @returns {number} Returns the string size.
             */


            function stringSize(string) {
              return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
            }
            /**
             * Converts `string` to an array.
             *
             * @private
             * @param {string} string The string to convert.
             * @returns {Array} Returns the converted array.
             */


            function stringToArray(string) {
              return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
            }
            /**
             * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
             * character of `string`.
             *
             * @private
             * @param {string} string The string to inspect.
             * @returns {number} Returns the index of the last non-whitespace character.
             */


            function trimmedEndIndex(string) {
              var index = string.length;

              while (index-- && reWhitespace.test(string.charAt(index))) {}

              return index;
            }
            /**
             * Used by `_.unescape` to convert HTML entities to characters.
             *
             * @private
             * @param {string} chr The matched character to unescape.
             * @returns {string} Returns the unescaped character.
             */


            var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
            /**
             * Gets the size of a Unicode `string`.
             *
             * @private
             * @param {string} string The string inspect.
             * @returns {number} Returns the string size.
             */

            function unicodeSize(string) {
              var result = reUnicode.lastIndex = 0;

              while (reUnicode.test(string)) {
                ++result;
              }

              return result;
            }
            /**
             * Converts a Unicode `string` to an array.
             *
             * @private
             * @param {string} string The string to convert.
             * @returns {Array} Returns the converted array.
             */


            function unicodeToArray(string) {
              return string.match(reUnicode) || [];
            }
            /**
             * Splits a Unicode `string` into an array of its words.
             *
             * @private
             * @param {string} The string to inspect.
             * @returns {Array} Returns the words of `string`.
             */


            function unicodeWords(string) {
              return string.match(reUnicodeWord) || [];
            }
            /*--------------------------------------------------------------------------*/

            /**
             * Create a new pristine `lodash` function using the `context` object.
             *
             * @static
             * @memberOf _
             * @since 1.1.0
             * @category Util
             * @param {Object} [context=root] The context object.
             * @returns {Function} Returns a new `lodash` function.
             * @example
             *
             * _.mixin({ 'foo': _.constant('foo') });
             *
             * var lodash = _.runInContext();
             * lodash.mixin({ 'bar': lodash.constant('bar') });
             *
             * _.isFunction(_.foo);
             * // => true
             * _.isFunction(_.bar);
             * // => false
             *
             * lodash.isFunction(lodash.foo);
             * // => false
             * lodash.isFunction(lodash.bar);
             * // => true
             *
             * // Create a suped-up `defer` in Node.js.
             * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
             */


            var runInContext = function runInContext(context) {
              context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
              /** Built-in constructor references. */

              var Array = context.Array,
                  Date = context.Date,
                  Error = context.Error,
                  Function = context.Function,
                  Math = context.Math,
                  Object = context.Object,
                  RegExp = context.RegExp,
                  String = context.String,
                  TypeError = context.TypeError;
              /** Used for built-in method references. */

              var arrayProto = Array.prototype,
                  funcProto = Function.prototype,
                  objectProto = Object.prototype;
              /** Used to detect overreaching core-js shims. */

              var coreJsData = context['__core-js_shared__'];
              /** Used to resolve the decompiled source of functions. */

              var funcToString = funcProto.toString;
              /** Used to check objects for own properties. */

              var hasOwnProperty = objectProto.hasOwnProperty;
              /** Used to generate unique IDs. */

              var idCounter = 0;
              /** Used to detect methods masquerading as native. */

              var maskSrcKey = function () {
                var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
                return uid ? 'Symbol(src)_1.' + uid : '';
              }();
              /**
               * Used to resolve the
               * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
               * of values.
               */


              var nativeObjectToString = objectProto.toString;
              /** Used to infer the `Object` constructor. */

              var objectCtorString = funcToString.call(Object);
              /** Used to restore the original `_` reference in `_.noConflict`. */

              var oldDash = root._;
              /** Used to detect if a method is native. */

              var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
              /** Built-in value references. */

              var Buffer = moduleExports ? context.Buffer : undefined,
                  _Symbol = context.Symbol,
                  Uint8Array = context.Uint8Array,
                  allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
                  getPrototype = overArg(Object.getPrototypeOf, Object),
                  objectCreate = Object.create,
                  propertyIsEnumerable = objectProto.propertyIsEnumerable,
                  splice = arrayProto.splice,
                  spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined,
                  symIterator = _Symbol ? _Symbol.iterator : undefined,
                  symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

              var defineProperty = function () {
                try {
                  var func = getNative(Object, 'defineProperty');
                  func({}, '', {});
                  return func;
                } catch (e) {}
              }();
              /** Mocked built-ins. */


              var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
                  ctxNow = Date && Date.now !== root.Date.now && Date.now,
                  ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
              /* Built-in method references for those with the same name as other `lodash` methods. */

              var nativeCeil = Math.ceil,
                  nativeFloor = Math.floor,
                  nativeGetSymbols = Object.getOwnPropertySymbols,
                  nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
                  nativeIsFinite = context.isFinite,
                  nativeJoin = arrayProto.join,
                  nativeKeys = overArg(Object.keys, Object),
                  nativeMax = Math.max,
                  nativeMin = Math.min,
                  nativeNow = Date.now,
                  nativeParseInt = context.parseInt,
                  nativeRandom = Math.random,
                  nativeReverse = arrayProto.reverse;
              /* Built-in method references that are verified to be native. */

              var DataView = getNative(context, 'DataView'),
                  Map = getNative(context, 'Map'),
                  Promise = getNative(context, 'Promise'),
                  Set = getNative(context, 'Set'),
                  WeakMap = getNative(context, 'WeakMap'),
                  nativeCreate = getNative(Object, 'create');
              /** Used to store function metadata. */

              var metaMap = WeakMap && new WeakMap();
              /** Used to lookup unminified function names. */

              var realNames = {};
              /** Used to detect maps, sets, and weakmaps. */

              var dataViewCtorString = toSource(DataView),
                  mapCtorString = toSource(Map),
                  promiseCtorString = toSource(Promise),
                  setCtorString = toSource(Set),
                  weakMapCtorString = toSource(WeakMap);
              /** Used to convert symbols to primitives and strings. */

              var symbolProto = _Symbol ? _Symbol.prototype : undefined,
                  symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
                  symbolToString = symbolProto ? symbolProto.toString : undefined;
              /*------------------------------------------------------------------------*/

              /**
               * Creates a `lodash` object which wraps `value` to enable implicit method
               * chain sequences. Methods that operate on and return arrays, collections,
               * and functions can be chained together. Methods that retrieve a single value
               * or may return a primitive value will automatically end the chain sequence
               * and return the unwrapped value. Otherwise, the value must be unwrapped
               * with `_#value`.
               *
               * Explicit chain sequences, which must be unwrapped with `_#value`, may be
               * enabled using `_.chain`.
               *
               * The execution of chained methods is lazy, that is, it's deferred until
               * `_#value` is implicitly or explicitly called.
               *
               * Lazy evaluation allows several methods to support shortcut fusion.
               * Shortcut fusion is an optimization to merge iteratee calls; this avoids
               * the creation of intermediate arrays and can greatly reduce the number of
               * iteratee executions. Sections of a chain sequence qualify for shortcut
               * fusion if the section is applied to an array and iteratees accept only
               * one argument. The heuristic for whether a section qualifies for shortcut
               * fusion is subject to change.
               *
               * Chaining is supported in custom builds as long as the `_#value` method is
               * directly or indirectly included in the build.
               *
               * In addition to lodash methods, wrappers have `Array` and `String` methods.
               *
               * The wrapper `Array` methods are:
               * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
               *
               * The wrapper `String` methods are:
               * `replace` and `split`
               *
               * The wrapper methods that support shortcut fusion are:
               * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
               * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
               * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
               *
               * The chainable wrapper methods are:
               * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
               * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
               * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
               * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
               * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
               * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
               * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
               * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
               * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
               * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
               * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
               * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
               * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
               * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
               * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
               * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
               * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
               * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
               * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
               * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
               * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
               * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
               * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
               * `zipObject`, `zipObjectDeep`, and `zipWith`
               *
               * The wrapper methods that are **not** chainable by default are:
               * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
               * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
               * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
               * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
               * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
               * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
               * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
               * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
               * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
               * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
               * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
               * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
               * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
               * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
               * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
               * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
               * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
               * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
               * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
               * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
               * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
               * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
               * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
               * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
               * `upperFirst`, `value`, and `words`
               *
               * @name _
               * @constructor
               * @category Seq
               * @param {*} value The value to wrap in a `lodash` instance.
               * @returns {Object} Returns the new `lodash` wrapper instance.
               * @example
               *
               * function square(n) {
               *   return n * n;
               * }
               *
               * var wrapped = _([1, 2, 3]);
               *
               * // Returns an unwrapped value.
               * wrapped.reduce(_.add);
               * // => 6
               *
               * // Returns a wrapped value.
               * var squares = wrapped.map(square);
               *
               * _.isArray(squares);
               * // => false
               *
               * _.isArray(squares.value());
               * // => true
               */

              function lodash(value) {
                if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                  if (value instanceof LodashWrapper) {
                    return value;
                  }

                  if (hasOwnProperty.call(value, '__wrapped__')) {
                    return wrapperClone(value);
                  }
                }

                return new LodashWrapper(value);
              }
              /**
               * The base implementation of `_.create` without support for assigning
               * properties to the created object.
               *
               * @private
               * @param {Object} proto The object to inherit from.
               * @returns {Object} Returns the new object.
               */


              var baseCreate = function () {
                function object() {}

                return function (proto) {
                  if (!isObject(proto)) {
                    return {};
                  }

                  if (objectCreate) {
                    return objectCreate(proto);
                  }

                  object.prototype = proto;
                  var result = new object();
                  object.prototype = undefined;
                  return result;
                };
              }();
              /**
               * The function whose prototype chain sequence wrappers inherit from.
               *
               * @private
               */


              function baseLodash() {// No operation performed.
              }
              /**
               * The base constructor for creating `lodash` wrapper objects.
               *
               * @private
               * @param {*} value The value to wrap.
               * @param {boolean} [chainAll] Enable explicit method chain sequences.
               */


              function LodashWrapper(value, chainAll) {
                this.__wrapped__ = value;
                this.__actions__ = [];
                this.__chain__ = !!chainAll;
                this.__index__ = 0;
                this.__values__ = undefined;
              }
              /**
               * By default, the template delimiters used by lodash are like those in
               * embedded Ruby (ERB) as well as ES2015 template strings. Change the
               * following template settings to use alternative delimiters.
               *
               * @static
               * @memberOf _
               * @type {Object}
               */


              lodash.templateSettings = {
                /**
                 * Used to detect `data` property values to be HTML-escaped.
                 *
                 * @memberOf _.templateSettings
                 * @type {RegExp}
                 */
                'escape': reEscape,

                /**
                 * Used to detect code to be evaluated.
                 *
                 * @memberOf _.templateSettings
                 * @type {RegExp}
                 */
                'evaluate': reEvaluate,

                /**
                 * Used to detect `data` property values to inject.
                 *
                 * @memberOf _.templateSettings
                 * @type {RegExp}
                 */
                'interpolate': reInterpolate,

                /**
                 * Used to reference the data object in the template text.
                 *
                 * @memberOf _.templateSettings
                 * @type {string}
                 */
                'variable': '',

                /**
                 * Used to import variables into the compiled template.
                 *
                 * @memberOf _.templateSettings
                 * @type {Object}
                 */
                'imports': {
                  /**
                   * A reference to the `lodash` function.
                   *
                   * @memberOf _.templateSettings.imports
                   * @type {Function}
                   */
                  '_': lodash
                }
              }; // Ensure wrappers are instances of `baseLodash`.

              lodash.prototype = baseLodash.prototype;
              lodash.prototype.constructor = lodash;
              LodashWrapper.prototype = baseCreate(baseLodash.prototype);
              LodashWrapper.prototype.constructor = LodashWrapper;
              /*------------------------------------------------------------------------*/

              /**
               * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
               *
               * @private
               * @constructor
               * @param {*} value The value to wrap.
               */

              function LazyWrapper(value) {
                this.__wrapped__ = value;
                this.__actions__ = [];
                this.__dir__ = 1;
                this.__filtered__ = false;
                this.__iteratees__ = [];
                this.__takeCount__ = MAX_ARRAY_LENGTH;
                this.__views__ = [];
              }
              /**
               * Creates a clone of the lazy wrapper object.
               *
               * @private
               * @name clone
               * @memberOf LazyWrapper
               * @returns {Object} Returns the cloned `LazyWrapper` object.
               */


              function lazyClone() {
                var result = new LazyWrapper(this.__wrapped__);
                result.__actions__ = copyArray(this.__actions__);
                result.__dir__ = this.__dir__;
                result.__filtered__ = this.__filtered__;
                result.__iteratees__ = copyArray(this.__iteratees__);
                result.__takeCount__ = this.__takeCount__;
                result.__views__ = copyArray(this.__views__);
                return result;
              }
              /**
               * Reverses the direction of lazy iteration.
               *
               * @private
               * @name reverse
               * @memberOf LazyWrapper
               * @returns {Object} Returns the new reversed `LazyWrapper` object.
               */


              function lazyReverse() {
                if (this.__filtered__) {
                  var result = new LazyWrapper(this);
                  result.__dir__ = -1;
                  result.__filtered__ = true;
                } else {
                  result = this.clone();
                  result.__dir__ *= -1;
                }

                return result;
              }
              /**
               * Extracts the unwrapped value from its lazy wrapper.
               *
               * @private
               * @name value
               * @memberOf LazyWrapper
               * @returns {*} Returns the unwrapped value.
               */


              function lazyValue() {
                var array = this.__wrapped__.value(),
                    dir = this.__dir__,
                    isArr = isArray(array),
                    isRight = dir < 0,
                    arrLength = isArr ? array.length : 0,
                    view = getView(0, arrLength, this.__views__),
                    start = view.start,
                    end = view.end,
                    length = end - start,
                    index = isRight ? end : start - 1,
                    iteratees = this.__iteratees__,
                    iterLength = iteratees.length,
                    resIndex = 0,
                    takeCount = nativeMin(length, this.__takeCount__);

                if (!isArr || !isRight && arrLength == length && takeCount == length) {
                  return baseWrapperValue(array, this.__actions__);
                }

                var result = [];

                outer: while (length-- && resIndex < takeCount) {
                  index += dir;
                  var iterIndex = -1,
                      value = array[index];

                  while (++iterIndex < iterLength) {
                    var data = iteratees[iterIndex],
                        iteratee = data.iteratee,
                        type = data.type,
                        computed = iteratee(value);

                    if (type == LAZY_MAP_FLAG) {
                      value = computed;
                    } else if (!computed) {
                      if (type == LAZY_FILTER_FLAG) {
                        continue outer;
                      } else {
                        break outer;
                      }
                    }
                  }

                  result[resIndex++] = value;
                }

                return result;
              } // Ensure `LazyWrapper` is an instance of `baseLodash`.


              LazyWrapper.prototype = baseCreate(baseLodash.prototype);
              LazyWrapper.prototype.constructor = LazyWrapper;
              /*------------------------------------------------------------------------*/

              /**
               * Creates a hash object.
               *
               * @private
               * @constructor
               * @param {Array} [entries] The key-value pairs to cache.
               */

              function Hash(entries) {
                var index = -1,
                    length = entries == null ? 0 : entries.length;
                this.clear();

                while (++index < length) {
                  var entry = entries[index];
                  this.set(entry[0], entry[1]);
                }
              }
              /**
               * Removes all key-value entries from the hash.
               *
               * @private
               * @name clear
               * @memberOf Hash
               */


              function hashClear() {
                this.__data__ = nativeCreate ? nativeCreate(null) : {};
                this.size = 0;
              }
              /**
               * Removes `key` and its value from the hash.
               *
               * @private
               * @name delete
               * @memberOf Hash
               * @param {Object} hash The hash to modify.
               * @param {string} key The key of the value to remove.
               * @returns {boolean} Returns `true` if the entry was removed, else `false`.
               */


              function hashDelete(key) {
                var result = this.has(key) && delete this.__data__[key];
                this.size -= result ? 1 : 0;
                return result;
              }
              /**
               * Gets the hash value for `key`.
               *
               * @private
               * @name get
               * @memberOf Hash
               * @param {string} key The key of the value to get.
               * @returns {*} Returns the entry value.
               */


              function hashGet(key) {
                var data = this.__data__;

                if (nativeCreate) {
                  var result = data[key];
                  return result === HASH_UNDEFINED ? undefined : result;
                }

                return hasOwnProperty.call(data, key) ? data[key] : undefined;
              }
              /**
               * Checks if a hash value for `key` exists.
               *
               * @private
               * @name has
               * @memberOf Hash
               * @param {string} key The key of the entry to check.
               * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
               */


              function hashHas(key) {
                var data = this.__data__;
                return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
              }
              /**
               * Sets the hash `key` to `value`.
               *
               * @private
               * @name set
               * @memberOf Hash
               * @param {string} key The key of the value to set.
               * @param {*} value The value to set.
               * @returns {Object} Returns the hash instance.
               */


              function hashSet(key, value) {
                var data = this.__data__;
                this.size += this.has(key) ? 0 : 1;
                data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
                return this;
              } // Add methods to `Hash`.


              Hash.prototype.clear = hashClear;
              Hash.prototype['delete'] = hashDelete;
              Hash.prototype.get = hashGet;
              Hash.prototype.has = hashHas;
              Hash.prototype.set = hashSet;
              /*------------------------------------------------------------------------*/

              /**
               * Creates an list cache object.
               *
               * @private
               * @constructor
               * @param {Array} [entries] The key-value pairs to cache.
               */

              function ListCache(entries) {
                var index = -1,
                    length = entries == null ? 0 : entries.length;
                this.clear();

                while (++index < length) {
                  var entry = entries[index];
                  this.set(entry[0], entry[1]);
                }
              }
              /**
               * Removes all key-value entries from the list cache.
               *
               * @private
               * @name clear
               * @memberOf ListCache
               */


              function listCacheClear() {
                this.__data__ = [];
                this.size = 0;
              }
              /**
               * Removes `key` and its value from the list cache.
               *
               * @private
               * @name delete
               * @memberOf ListCache
               * @param {string} key The key of the value to remove.
               * @returns {boolean} Returns `true` if the entry was removed, else `false`.
               */


              function listCacheDelete(key) {
                var data = this.__data__,
                    index = assocIndexOf(data, key);

                if (index < 0) {
                  return false;
                }

                var lastIndex = data.length - 1;

                if (index == lastIndex) {
                  data.pop();
                } else {
                  splice.call(data, index, 1);
                }

                --this.size;
                return true;
              }
              /**
               * Gets the list cache value for `key`.
               *
               * @private
               * @name get
               * @memberOf ListCache
               * @param {string} key The key of the value to get.
               * @returns {*} Returns the entry value.
               */


              function listCacheGet(key) {
                var data = this.__data__,
                    index = assocIndexOf(data, key);
                return index < 0 ? undefined : data[index][1];
              }
              /**
               * Checks if a list cache value for `key` exists.
               *
               * @private
               * @name has
               * @memberOf ListCache
               * @param {string} key The key of the entry to check.
               * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
               */


              function listCacheHas(key) {
                return assocIndexOf(this.__data__, key) > -1;
              }
              /**
               * Sets the list cache `key` to `value`.
               *
               * @private
               * @name set
               * @memberOf ListCache
               * @param {string} key The key of the value to set.
               * @param {*} value The value to set.
               * @returns {Object} Returns the list cache instance.
               */


              function listCacheSet(key, value) {
                var data = this.__data__,
                    index = assocIndexOf(data, key);

                if (index < 0) {
                  ++this.size;
                  data.push([key, value]);
                } else {
                  data[index][1] = value;
                }

                return this;
              } // Add methods to `ListCache`.


              ListCache.prototype.clear = listCacheClear;
              ListCache.prototype['delete'] = listCacheDelete;
              ListCache.prototype.get = listCacheGet;
              ListCache.prototype.has = listCacheHas;
              ListCache.prototype.set = listCacheSet;
              /*------------------------------------------------------------------------*/

              /**
               * Creates a map cache object to store key-value pairs.
               *
               * @private
               * @constructor
               * @param {Array} [entries] The key-value pairs to cache.
               */

              function MapCache(entries) {
                var index = -1,
                    length = entries == null ? 0 : entries.length;
                this.clear();

                while (++index < length) {
                  var entry = entries[index];
                  this.set(entry[0], entry[1]);
                }
              }
              /**
               * Removes all key-value entries from the map.
               *
               * @private
               * @name clear
               * @memberOf MapCache
               */


              function mapCacheClear() {
                this.size = 0;
                this.__data__ = {
                  'hash': new Hash(),
                  'map': new (Map || ListCache)(),
                  'string': new Hash()
                };
              }
              /**
               * Removes `key` and its value from the map.
               *
               * @private
               * @name delete
               * @memberOf MapCache
               * @param {string} key The key of the value to remove.
               * @returns {boolean} Returns `true` if the entry was removed, else `false`.
               */


              function mapCacheDelete(key) {
                var result = getMapData(this, key)['delete'](key);
                this.size -= result ? 1 : 0;
                return result;
              }
              /**
               * Gets the map value for `key`.
               *
               * @private
               * @name get
               * @memberOf MapCache
               * @param {string} key The key of the value to get.
               * @returns {*} Returns the entry value.
               */


              function mapCacheGet(key) {
                return getMapData(this, key).get(key);
              }
              /**
               * Checks if a map value for `key` exists.
               *
               * @private
               * @name has
               * @memberOf MapCache
               * @param {string} key The key of the entry to check.
               * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
               */


              function mapCacheHas(key) {
                return getMapData(this, key).has(key);
              }
              /**
               * Sets the map `key` to `value`.
               *
               * @private
               * @name set
               * @memberOf MapCache
               * @param {string} key The key of the value to set.
               * @param {*} value The value to set.
               * @returns {Object} Returns the map cache instance.
               */


              function mapCacheSet(key, value) {
                var data = getMapData(this, key),
                    size = data.size;
                data.set(key, value);
                this.size += data.size == size ? 0 : 1;
                return this;
              } // Add methods to `MapCache`.


              MapCache.prototype.clear = mapCacheClear;
              MapCache.prototype['delete'] = mapCacheDelete;
              MapCache.prototype.get = mapCacheGet;
              MapCache.prototype.has = mapCacheHas;
              MapCache.prototype.set = mapCacheSet;
              /*------------------------------------------------------------------------*/

              /**
               *
               * Creates an array cache object to store unique values.
               *
               * @private
               * @constructor
               * @param {Array} [values] The values to cache.
               */

              function SetCache(values) {
                var index = -1,
                    length = values == null ? 0 : values.length;
                this.__data__ = new MapCache();

                while (++index < length) {
                  this.add(values[index]);
                }
              }
              /**
               * Adds `value` to the array cache.
               *
               * @private
               * @name add
               * @memberOf SetCache
               * @alias push
               * @param {*} value The value to cache.
               * @returns {Object} Returns the cache instance.
               */


              function setCacheAdd(value) {
                this.__data__.set(value, HASH_UNDEFINED);

                return this;
              }
              /**
               * Checks if `value` is in the array cache.
               *
               * @private
               * @name has
               * @memberOf SetCache
               * @param {*} value The value to search for.
               * @returns {number} Returns `true` if `value` is found, else `false`.
               */


              function setCacheHas(value) {
                return this.__data__.has(value);
              } // Add methods to `SetCache`.


              SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
              SetCache.prototype.has = setCacheHas;
              /*------------------------------------------------------------------------*/

              /**
               * Creates a stack cache object to store key-value pairs.
               *
               * @private
               * @constructor
               * @param {Array} [entries] The key-value pairs to cache.
               */

              function Stack(entries) {
                var data = this.__data__ = new ListCache(entries);
                this.size = data.size;
              }
              /**
               * Removes all key-value entries from the stack.
               *
               * @private
               * @name clear
               * @memberOf Stack
               */


              function stackClear() {
                this.__data__ = new ListCache();
                this.size = 0;
              }
              /**
               * Removes `key` and its value from the stack.
               *
               * @private
               * @name delete
               * @memberOf Stack
               * @param {string} key The key of the value to remove.
               * @returns {boolean} Returns `true` if the entry was removed, else `false`.
               */


              function stackDelete(key) {
                var data = this.__data__,
                    result = data['delete'](key);
                this.size = data.size;
                return result;
              }
              /**
               * Gets the stack value for `key`.
               *
               * @private
               * @name get
               * @memberOf Stack
               * @param {string} key The key of the value to get.
               * @returns {*} Returns the entry value.
               */


              function stackGet(key) {
                return this.__data__.get(key);
              }
              /**
               * Checks if a stack value for `key` exists.
               *
               * @private
               * @name has
               * @memberOf Stack
               * @param {string} key The key of the entry to check.
               * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
               */


              function stackHas(key) {
                return this.__data__.has(key);
              }
              /**
               * Sets the stack `key` to `value`.
               *
               * @private
               * @name set
               * @memberOf Stack
               * @param {string} key The key of the value to set.
               * @param {*} value The value to set.
               * @returns {Object} Returns the stack cache instance.
               */


              function stackSet(key, value) {
                var data = this.__data__;

                if (data instanceof ListCache) {
                  var pairs = data.__data__;

                  if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([key, value]);
                    this.size = ++data.size;
                    return this;
                  }

                  data = this.__data__ = new MapCache(pairs);
                }

                data.set(key, value);
                this.size = data.size;
                return this;
              } // Add methods to `Stack`.


              Stack.prototype.clear = stackClear;
              Stack.prototype['delete'] = stackDelete;
              Stack.prototype.get = stackGet;
              Stack.prototype.has = stackHas;
              Stack.prototype.set = stackSet;
              /*------------------------------------------------------------------------*/

              /**
               * Creates an array of the enumerable property names of the array-like `value`.
               *
               * @private
               * @param {*} value The value to query.
               * @param {boolean} inherited Specify returning inherited property names.
               * @returns {Array} Returns the array of property names.
               */

              function arrayLikeKeys(value, inherited) {
                var isArr = isArray(value),
                    isArg = !isArr && isArguments(value),
                    isBuff = !isArr && !isArg && isBuffer(value),
                    isType = !isArr && !isArg && !isBuff && isTypedArray(value),
                    skipIndexes = isArr || isArg || isBuff || isType,
                    result = skipIndexes ? baseTimes(value.length, String) : [],
                    length = result.length;

                for (var key in value) {
                  if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
                  key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
                  isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
                  isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
                  isIndex(key, length)))) {
                    result.push(key);
                  }
                }

                return result;
              }
              /**
               * A specialized version of `_.sample` for arrays.
               *
               * @private
               * @param {Array} array The array to sample.
               * @returns {*} Returns the random element.
               */


              function arraySample(array) {
                var length = array.length;
                return length ? array[baseRandom(0, length - 1)] : undefined;
              }
              /**
               * A specialized version of `_.sampleSize` for arrays.
               *
               * @private
               * @param {Array} array The array to sample.
               * @param {number} n The number of elements to sample.
               * @returns {Array} Returns the random elements.
               */


              function arraySampleSize(array, n) {
                return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
              }
              /**
               * A specialized version of `_.shuffle` for arrays.
               *
               * @private
               * @param {Array} array The array to shuffle.
               * @returns {Array} Returns the new shuffled array.
               */


              function arrayShuffle(array) {
                return shuffleSelf(copyArray(array));
              }
              /**
               * This function is like `assignValue` except that it doesn't assign
               * `undefined` values.
               *
               * @private
               * @param {Object} object The object to modify.
               * @param {string} key The key of the property to assign.
               * @param {*} value The value to assign.
               */


              function assignMergeValue(object, key, value) {
                if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
                  baseAssignValue(object, key, value);
                }
              }
              /**
               * Assigns `value` to `key` of `object` if the existing value is not equivalent
               * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
               * for equality comparisons.
               *
               * @private
               * @param {Object} object The object to modify.
               * @param {string} key The key of the property to assign.
               * @param {*} value The value to assign.
               */


              function assignValue(object, key, value) {
                var objValue = object[key];

                if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
                  baseAssignValue(object, key, value);
                }
              }
              /**
               * Gets the index at which the `key` is found in `array` of key-value pairs.
               *
               * @private
               * @param {Array} array The array to inspect.
               * @param {*} key The key to search for.
               * @returns {number} Returns the index of the matched value, else `-1`.
               */


              function assocIndexOf(array, key) {
                var length = array.length;

                while (length--) {
                  if (eq(array[length][0], key)) {
                    return length;
                  }
                }

                return -1;
              }
              /**
               * Aggregates elements of `collection` on `accumulator` with keys transformed
               * by `iteratee` and values set by `setter`.
               *
               * @private
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} setter The function to set `accumulator` values.
               * @param {Function} iteratee The iteratee to transform keys.
               * @param {Object} accumulator The initial aggregated object.
               * @returns {Function} Returns `accumulator`.
               */


              function baseAggregator(collection, setter, iteratee, accumulator) {
                baseEach(collection, function (value, key, collection) {
                  setter(accumulator, value, iteratee(value), collection);
                });
                return accumulator;
              }
              /**
               * The base implementation of `_.assign` without support for multiple sources
               * or `customizer` functions.
               *
               * @private
               * @param {Object} object The destination object.
               * @param {Object} source The source object.
               * @returns {Object} Returns `object`.
               */


              function baseAssign(object, source) {
                return object && copyObject(source, keys(source), object);
              }
              /**
               * The base implementation of `_.assignIn` without support for multiple sources
               * or `customizer` functions.
               *
               * @private
               * @param {Object} object The destination object.
               * @param {Object} source The source object.
               * @returns {Object} Returns `object`.
               */


              function baseAssignIn(object, source) {
                return object && copyObject(source, keysIn(source), object);
              }
              /**
               * The base implementation of `assignValue` and `assignMergeValue` without
               * value checks.
               *
               * @private
               * @param {Object} object The object to modify.
               * @param {string} key The key of the property to assign.
               * @param {*} value The value to assign.
               */


              function baseAssignValue(object, key, value) {
                if (key == '__proto__' && defineProperty) {
                  defineProperty(object, key, {
                    'configurable': true,
                    'enumerable': true,
                    'value': value,
                    'writable': true
                  });
                } else {
                  object[key] = value;
                }
              }
              /**
               * The base implementation of `_.at` without support for individual paths.
               *
               * @private
               * @param {Object} object The object to iterate over.
               * @param {string[]} paths The property paths to pick.
               * @returns {Array} Returns the picked elements.
               */


              function baseAt(object, paths) {
                var index = -1,
                    length = paths.length,
                    result = Array(length),
                    skip = object == null;

                while (++index < length) {
                  result[index] = skip ? undefined : get(object, paths[index]);
                }

                return result;
              }
              /**
               * The base implementation of `_.clamp` which doesn't coerce arguments.
               *
               * @private
               * @param {number} number The number to clamp.
               * @param {number} [lower] The lower bound.
               * @param {number} upper The upper bound.
               * @returns {number} Returns the clamped number.
               */


              function baseClamp(number, lower, upper) {
                if (number === number) {
                  if (upper !== undefined) {
                    number = number <= upper ? number : upper;
                  }

                  if (lower !== undefined) {
                    number = number >= lower ? number : lower;
                  }
                }

                return number;
              }
              /**
               * The base implementation of `_.clone` and `_.cloneDeep` which tracks
               * traversed objects.
               *
               * @private
               * @param {*} value The value to clone.
               * @param {boolean} bitmask The bitmask flags.
               *  1 - Deep clone
               *  2 - Flatten inherited properties
               *  4 - Clone symbols
               * @param {Function} [customizer] The function to customize cloning.
               * @param {string} [key] The key of `value`.
               * @param {Object} [object] The parent object of `value`.
               * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
               * @returns {*} Returns the cloned value.
               */


              function baseClone(value, bitmask, customizer, key, object, stack) {
                var result,
                    isDeep = bitmask & CLONE_DEEP_FLAG,
                    isFlat = bitmask & CLONE_FLAT_FLAG,
                    isFull = bitmask & CLONE_SYMBOLS_FLAG;

                if (customizer) {
                  result = object ? customizer(value, key, object, stack) : customizer(value);
                }

                if (result !== undefined) {
                  return result;
                }

                if (!isObject(value)) {
                  return value;
                }

                var isArr = isArray(value);

                if (isArr) {
                  result = initCloneArray(value);

                  if (!isDeep) {
                    return copyArray(value, result);
                  }
                } else {
                  var tag = getTag(value),
                      isFunc = tag == funcTag || tag == genTag;

                  if (isBuffer(value)) {
                    return cloneBuffer(value, isDeep);
                  }

                  if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);

                    if (!isDeep) {
                      return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                    }
                  } else {
                    if (!cloneableTags[tag]) {
                      return object ? value : {};
                    }

                    result = initCloneByTag(value, tag, isDeep);
                  }
                } // Check for circular references and return its corresponding clone.


                stack || (stack = new Stack());
                var stacked = stack.get(value);

                if (stacked) {
                  return stacked;
                }

                stack.set(value, result);

                if (isSet(value)) {
                  value.forEach(function (subValue) {
                    result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
                  });
                } else if (isMap(value)) {
                  value.forEach(function (subValue, key) {
                    result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
                  });
                }

                var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
                var props = isArr ? undefined : keysFunc(value);
                arrayEach(props || value, function (subValue, key) {
                  if (props) {
                    key = subValue;
                    subValue = value[key];
                  } // Recursively populate clone (susceptible to call stack limits).


                  assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
                });
                return result;
              }
              /**
               * The base implementation of `_.conforms` which doesn't clone `source`.
               *
               * @private
               * @param {Object} source The object of property predicates to conform to.
               * @returns {Function} Returns the new spec function.
               */


              function baseConforms(source) {
                var props = keys(source);
                return function (object) {
                  return baseConformsTo(object, source, props);
                };
              }
              /**
               * The base implementation of `_.conformsTo` which accepts `props` to check.
               *
               * @private
               * @param {Object} object The object to inspect.
               * @param {Object} source The object of property predicates to conform to.
               * @returns {boolean} Returns `true` if `object` conforms, else `false`.
               */


              function baseConformsTo(object, source, props) {
                var length = props.length;

                if (object == null) {
                  return !length;
                }

                object = Object(object);

                while (length--) {
                  var key = props[length],
                      predicate = source[key],
                      value = object[key];

                  if (value === undefined && !(key in object) || !predicate(value)) {
                    return false;
                  }
                }

                return true;
              }
              /**
               * The base implementation of `_.delay` and `_.defer` which accepts `args`
               * to provide to `func`.
               *
               * @private
               * @param {Function} func The function to delay.
               * @param {number} wait The number of milliseconds to delay invocation.
               * @param {Array} args The arguments to provide to `func`.
               * @returns {number|Object} Returns the timer id or timeout object.
               */


              function baseDelay(func, wait, args) {
                if (typeof func != 'function') {
                  throw new TypeError(FUNC_ERROR_TEXT);
                }

                return setTimeout(function () {
                  func.apply(undefined, args);
                }, wait);
              }
              /**
               * The base implementation of methods like `_.difference` without support
               * for excluding multiple arrays or iteratee shorthands.
               *
               * @private
               * @param {Array} array The array to inspect.
               * @param {Array} values The values to exclude.
               * @param {Function} [iteratee] The iteratee invoked per element.
               * @param {Function} [comparator] The comparator invoked per element.
               * @returns {Array} Returns the new array of filtered values.
               */


              function baseDifference(array, values, iteratee, comparator) {
                var index = -1,
                    includes = arrayIncludes,
                    isCommon = true,
                    length = array.length,
                    result = [],
                    valuesLength = values.length;

                if (!length) {
                  return result;
                }

                if (iteratee) {
                  values = arrayMap(values, baseUnary(iteratee));
                }

                if (comparator) {
                  includes = arrayIncludesWith;
                  isCommon = false;
                } else if (values.length >= LARGE_ARRAY_SIZE) {
                  includes = cacheHas;
                  isCommon = false;
                  values = new SetCache(values);
                }

                outer: while (++index < length) {
                  var value = array[index],
                      computed = iteratee == null ? value : iteratee(value);
                  value = comparator || value !== 0 ? value : 0;

                  if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;

                    while (valuesIndex--) {
                      if (values[valuesIndex] === computed) {
                        continue outer;
                      }
                    }

                    result.push(value);
                  } else if (!includes(values, computed, comparator)) {
                    result.push(value);
                  }
                }

                return result;
              }
              /**
               * The base implementation of `_.forEach` without support for iteratee shorthands.
               *
               * @private
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} iteratee The function invoked per iteration.
               * @returns {Array|Object} Returns `collection`.
               */


              var baseEach = createBaseEach(baseForOwn);
              /**
               * The base implementation of `_.forEachRight` without support for iteratee shorthands.
               *
               * @private
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} iteratee The function invoked per iteration.
               * @returns {Array|Object} Returns `collection`.
               */

              var baseEachRight = createBaseEach(baseForOwnRight, true);
              /**
               * The base implementation of `_.every` without support for iteratee shorthands.
               *
               * @private
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} predicate The function invoked per iteration.
               * @returns {boolean} Returns `true` if all elements pass the predicate check,
               *  else `false`
               */

              function baseEvery(collection, predicate) {
                var result = true;
                baseEach(collection, function (value, index, collection) {
                  result = !!predicate(value, index, collection);
                  return result;
                });
                return result;
              }
              /**
               * The base implementation of methods like `_.max` and `_.min` which accepts a
               * `comparator` to determine the extremum value.
               *
               * @private
               * @param {Array} array The array to iterate over.
               * @param {Function} iteratee The iteratee invoked per iteration.
               * @param {Function} comparator The comparator used to compare values.
               * @returns {*} Returns the extremum value.
               */


              function baseExtremum(array, iteratee, comparator) {
                var index = -1,
                    length = array.length;

                while (++index < length) {
                  var value = array[index],
                      current = iteratee(value);

                  if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) {
                    var computed = current,
                        result = value;
                  }
                }

                return result;
              }
              /**
               * The base implementation of `_.fill` without an iteratee call guard.
               *
               * @private
               * @param {Array} array The array to fill.
               * @param {*} value The value to fill `array` with.
               * @param {number} [start=0] The start position.
               * @param {number} [end=array.length] The end position.
               * @returns {Array} Returns `array`.
               */


              function baseFill(array, value, start, end) {
                var length = array.length;
                start = toInteger(start);

                if (start < 0) {
                  start = -start > length ? 0 : length + start;
                }

                end = end === undefined || end > length ? length : toInteger(end);

                if (end < 0) {
                  end += length;
                }

                end = start > end ? 0 : toLength(end);

                while (start < end) {
                  array[start++] = value;
                }

                return array;
              }
              /**
               * The base implementation of `_.filter` without support for iteratee shorthands.
               *
               * @private
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} predicate The function invoked per iteration.
               * @returns {Array} Returns the new filtered array.
               */


              function baseFilter(collection, predicate) {
                var result = [];
                baseEach(collection, function (value, index, collection) {
                  if (predicate(value, index, collection)) {
                    result.push(value);
                  }
                });
                return result;
              }
              /**
               * The base implementation of `_.flatten` with support for restricting flattening.
               *
               * @private
               * @param {Array} array The array to flatten.
               * @param {number} depth The maximum recursion depth.
               * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
               * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
               * @param {Array} [result=[]] The initial result value.
               * @returns {Array} Returns the new flattened array.
               */


              function baseFlatten(array, depth, predicate, isStrict, result) {
                var index = -1,
                    length = array.length;
                predicate || (predicate = isFlattenable);
                result || (result = []);

                while (++index < length) {
                  var value = array[index];

                  if (depth > 0 && predicate(value)) {
                    if (depth > 1) {
                      // Recursively flatten arrays (susceptible to call stack limits).
                      baseFlatten(value, depth - 1, predicate, isStrict, result);
                    } else {
                      arrayPush(result, value);
                    }
                  } else if (!isStrict) {
                    result[result.length] = value;
                  }
                }

                return result;
              }
              /**
               * The base implementation of `baseForOwn` which iterates over `object`
               * properties returned by `keysFunc` and invokes `iteratee` for each property.
               * Iteratee functions may exit iteration early by explicitly returning `false`.
               *
               * @private
               * @param {Object} object The object to iterate over.
               * @param {Function} iteratee The function invoked per iteration.
               * @param {Function} keysFunc The function to get the keys of `object`.
               * @returns {Object} Returns `object`.
               */


              var baseFor = createBaseFor();
              /**
               * This function is like `baseFor` except that it iterates over properties
               * in the opposite order.
               *
               * @private
               * @param {Object} object The object to iterate over.
               * @param {Function} iteratee The function invoked per iteration.
               * @param {Function} keysFunc The function to get the keys of `object`.
               * @returns {Object} Returns `object`.
               */

              var baseForRight = createBaseFor(true);
              /**
               * The base implementation of `_.forOwn` without support for iteratee shorthands.
               *
               * @private
               * @param {Object} object The object to iterate over.
               * @param {Function} iteratee The function invoked per iteration.
               * @returns {Object} Returns `object`.
               */

              function baseForOwn(object, iteratee) {
                return object && baseFor(object, iteratee, keys);
              }
              /**
               * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
               *
               * @private
               * @param {Object} object The object to iterate over.
               * @param {Function} iteratee The function invoked per iteration.
               * @returns {Object} Returns `object`.
               */


              function baseForOwnRight(object, iteratee) {
                return object && baseForRight(object, iteratee, keys);
              }
              /**
               * The base implementation of `_.functions` which creates an array of
               * `object` function property names filtered from `props`.
               *
               * @private
               * @param {Object} object The object to inspect.
               * @param {Array} props The property names to filter.
               * @returns {Array} Returns the function names.
               */


              function baseFunctions(object, props) {
                return arrayFilter(props, function (key) {
                  return isFunction(object[key]);
                });
              }
              /**
               * The base implementation of `_.get` without support for default values.
               *
               * @private
               * @param {Object} object The object to query.
               * @param {Array|string} path The path of the property to get.
               * @returns {*} Returns the resolved value.
               */


              function baseGet(object, path) {
                path = castPath(path, object);
                var index = 0,
                    length = path.length;

                while (object != null && index < length) {
                  object = object[toKey(path[index++])];
                }

                return index && index == length ? object : undefined;
              }
              /**
               * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
               * `keysFunc` and `symbolsFunc` to get the enumerable property names and
               * symbols of `object`.
               *
               * @private
               * @param {Object} object The object to query.
               * @param {Function} keysFunc The function to get the keys of `object`.
               * @param {Function} symbolsFunc The function to get the symbols of `object`.
               * @returns {Array} Returns the array of property names and symbols.
               */


              function baseGetAllKeys(object, keysFunc, symbolsFunc) {
                var result = keysFunc(object);
                return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
              }
              /**
               * The base implementation of `getTag` without fallbacks for buggy environments.
               *
               * @private
               * @param {*} value The value to query.
               * @returns {string} Returns the `toStringTag`.
               */


              function baseGetTag(value) {
                if (value == null) {
                  return value === undefined ? undefinedTag : nullTag;
                }

                return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
              }
              /**
               * The base implementation of `_.gt` which doesn't coerce arguments.
               *
               * @private
               * @param {*} value The value to compare.
               * @param {*} other The other value to compare.
               * @returns {boolean} Returns `true` if `value` is greater than `other`,
               *  else `false`.
               */


              function baseGt(value, other) {
                return value > other;
              }
              /**
               * The base implementation of `_.has` without support for deep paths.
               *
               * @private
               * @param {Object} [object] The object to query.
               * @param {Array|string} key The key to check.
               * @returns {boolean} Returns `true` if `key` exists, else `false`.
               */


              function baseHas(object, key) {
                return object != null && hasOwnProperty.call(object, key);
              }
              /**
               * The base implementation of `_.hasIn` without support for deep paths.
               *
               * @private
               * @param {Object} [object] The object to query.
               * @param {Array|string} key The key to check.
               * @returns {boolean} Returns `true` if `key` exists, else `false`.
               */


              function baseHasIn(object, key) {
                return object != null && key in Object(object);
              }
              /**
               * The base implementation of `_.inRange` which doesn't coerce arguments.
               *
               * @private
               * @param {number} number The number to check.
               * @param {number} start The start of the range.
               * @param {number} end The end of the range.
               * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
               */


              function baseInRange(number, start, end) {
                return number >= nativeMin(start, end) && number < nativeMax(start, end);
              }
              /**
               * The base implementation of methods like `_.intersection`, without support
               * for iteratee shorthands, that accepts an array of arrays to inspect.
               *
               * @private
               * @param {Array} arrays The arrays to inspect.
               * @param {Function} [iteratee] The iteratee invoked per element.
               * @param {Function} [comparator] The comparator invoked per element.
               * @returns {Array} Returns the new array of shared values.
               */


              function baseIntersection(arrays, iteratee, comparator) {
                var includes = comparator ? arrayIncludesWith : arrayIncludes,
                    length = arrays[0].length,
                    othLength = arrays.length,
                    othIndex = othLength,
                    caches = Array(othLength),
                    maxLength = Infinity,
                    result = [];

                while (othIndex--) {
                  var array = arrays[othIndex];

                  if (othIndex && iteratee) {
                    array = arrayMap(array, baseUnary(iteratee));
                  }

                  maxLength = nativeMin(array.length, maxLength);
                  caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
                }

                array = arrays[0];
                var index = -1,
                    seen = caches[0];

                outer: while (++index < length && result.length < maxLength) {
                  var value = array[index],
                      computed = iteratee ? iteratee(value) : value;
                  value = comparator || value !== 0 ? value : 0;

                  if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;

                    while (--othIndex) {
                      var cache = caches[othIndex];

                      if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
                        continue outer;
                      }
                    }

                    if (seen) {
                      seen.push(computed);
                    }

                    result.push(value);
                  }
                }

                return result;
              }
              /**
               * The base implementation of `_.invert` and `_.invertBy` which inverts
               * `object` with values transformed by `iteratee` and set by `setter`.
               *
               * @private
               * @param {Object} object The object to iterate over.
               * @param {Function} setter The function to set `accumulator` values.
               * @param {Function} iteratee The iteratee to transform values.
               * @param {Object} accumulator The initial inverted object.
               * @returns {Function} Returns `accumulator`.
               */


              function baseInverter(object, setter, iteratee, accumulator) {
                baseForOwn(object, function (value, key, object) {
                  setter(accumulator, iteratee(value), key, object);
                });
                return accumulator;
              }
              /**
               * The base implementation of `_.invoke` without support for individual
               * method arguments.
               *
               * @private
               * @param {Object} object The object to query.
               * @param {Array|string} path The path of the method to invoke.
               * @param {Array} args The arguments to invoke the method with.
               * @returns {*} Returns the result of the invoked method.
               */


              function baseInvoke(object, path, args) {
                path = castPath(path, object);
                object = parent(object, path);
                var func = object == null ? object : object[toKey(last(path))];
                return func == null ? undefined : apply(func, object, args);
              }
              /**
               * The base implementation of `_.isArguments`.
               *
               * @private
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is an `arguments` object,
               */


              function baseIsArguments(value) {
                return isObjectLike(value) && baseGetTag(value) == argsTag;
              }
              /**
               * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
               *
               * @private
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
               */


              function baseIsArrayBuffer(value) {
                return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
              }
              /**
               * The base implementation of `_.isDate` without Node.js optimizations.
               *
               * @private
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
               */


              function baseIsDate(value) {
                return isObjectLike(value) && baseGetTag(value) == dateTag;
              }
              /**
               * The base implementation of `_.isEqual` which supports partial comparisons
               * and tracks traversed objects.
               *
               * @private
               * @param {*} value The value to compare.
               * @param {*} other The other value to compare.
               * @param {boolean} bitmask The bitmask flags.
               *  1 - Unordered comparison
               *  2 - Partial comparison
               * @param {Function} [customizer] The function to customize comparisons.
               * @param {Object} [stack] Tracks traversed `value` and `other` objects.
               * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
               */


              function baseIsEqual(value, other, bitmask, customizer, stack) {
                if (value === other) {
                  return true;
                }

                if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
                  return value !== value && other !== other;
                }

                return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
              }
              /**
               * A specialized version of `baseIsEqual` for arrays and objects which performs
               * deep comparisons and tracks traversed objects enabling objects with circular
               * references to be compared.
               *
               * @private
               * @param {Object} object The object to compare.
               * @param {Object} other The other object to compare.
               * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
               * @param {Function} customizer The function to customize comparisons.
               * @param {Function} equalFunc The function to determine equivalents of values.
               * @param {Object} [stack] Tracks traversed `object` and `other` objects.
               * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
               */


              function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
                var objIsArr = isArray(object),
                    othIsArr = isArray(other),
                    objTag = objIsArr ? arrayTag : getTag(object),
                    othTag = othIsArr ? arrayTag : getTag(other);
                objTag = objTag == argsTag ? objectTag : objTag;
                othTag = othTag == argsTag ? objectTag : othTag;
                var objIsObj = objTag == objectTag,
                    othIsObj = othTag == objectTag,
                    isSameTag = objTag == othTag;

                if (isSameTag && isBuffer(object)) {
                  if (!isBuffer(other)) {
                    return false;
                  }

                  objIsArr = true;
                  objIsObj = false;
                }

                if (isSameTag && !objIsObj) {
                  stack || (stack = new Stack());
                  return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
                }

                if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                  var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
                      othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

                  if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object,
                        othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack());
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                  }
                }

                if (!isSameTag) {
                  return false;
                }

                stack || (stack = new Stack());
                return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
              }
              /**
               * The base implementation of `_.isMap` without Node.js optimizations.
               *
               * @private
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a map, else `false`.
               */


              function baseIsMap(value) {
                return isObjectLike(value) && getTag(value) == mapTag;
              }
              /**
               * The base implementation of `_.isMatch` without support for iteratee shorthands.
               *
               * @private
               * @param {Object} object The object to inspect.
               * @param {Object} source The object of property values to match.
               * @param {Array} matchData The property names, values, and compare flags to match.
               * @param {Function} [customizer] The function to customize comparisons.
               * @returns {boolean} Returns `true` if `object` is a match, else `false`.
               */


              function baseIsMatch(object, source, matchData, customizer) {
                var index = matchData.length,
                    length = index,
                    noCustomizer = !customizer;

                if (object == null) {
                  return !length;
                }

                object = Object(object);

                while (index--) {
                  var data = matchData[index];

                  if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
                    return false;
                  }
                }

                while (++index < length) {
                  data = matchData[index];
                  var key = data[0],
                      objValue = object[key],
                      srcValue = data[1];

                  if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) {
                      return false;
                    }
                  } else {
                    var stack = new Stack();

                    if (customizer) {
                      var result = customizer(objValue, srcValue, key, object, source, stack);
                    }

                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
                      return false;
                    }
                  }
                }

                return true;
              }
              /**
               * The base implementation of `_.isNative` without bad shim checks.
               *
               * @private
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a native function,
               *  else `false`.
               */


              function baseIsNative(value) {
                if (!isObject(value) || isMasked(value)) {
                  return false;
                }

                var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
                return pattern.test(toSource(value));
              }
              /**
               * The base implementation of `_.isRegExp` without Node.js optimizations.
               *
               * @private
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
               */


              function baseIsRegExp(value) {
                return isObjectLike(value) && baseGetTag(value) == regexpTag;
              }
              /**
               * The base implementation of `_.isSet` without Node.js optimizations.
               *
               * @private
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a set, else `false`.
               */


              function baseIsSet(value) {
                return isObjectLike(value) && getTag(value) == setTag;
              }
              /**
               * The base implementation of `_.isTypedArray` without Node.js optimizations.
               *
               * @private
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
               */


              function baseIsTypedArray(value) {
                return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
              }
              /**
               * The base implementation of `_.iteratee`.
               *
               * @private
               * @param {*} [value=_.identity] The value to convert to an iteratee.
               * @returns {Function} Returns the iteratee.
               */


              function baseIteratee(value) {
                // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
                // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
                if (typeof value == 'function') {
                  return value;
                }

                if (value == null) {
                  return identity;
                }

                if (_typeof2(value) == 'object') {
                  return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
                }

                return property(value);
              }
              /**
               * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
               *
               * @private
               * @param {Object} object The object to query.
               * @returns {Array} Returns the array of property names.
               */


              function baseKeys(object) {
                if (!isPrototype(object)) {
                  return nativeKeys(object);
                }

                var result = [];

                for (var key in Object(object)) {
                  if (hasOwnProperty.call(object, key) && key != 'constructor') {
                    result.push(key);
                  }
                }

                return result;
              }
              /**
               * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
               *
               * @private
               * @param {Object} object The object to query.
               * @returns {Array} Returns the array of property names.
               */


              function baseKeysIn(object) {
                if (!isObject(object)) {
                  return nativeKeysIn(object);
                }

                var isProto = isPrototype(object),
                    result = [];

                for (var key in object) {
                  if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
                    result.push(key);
                  }
                }

                return result;
              }
              /**
               * The base implementation of `_.lt` which doesn't coerce arguments.
               *
               * @private
               * @param {*} value The value to compare.
               * @param {*} other The other value to compare.
               * @returns {boolean} Returns `true` if `value` is less than `other`,
               *  else `false`.
               */


              function baseLt(value, other) {
                return value < other;
              }
              /**
               * The base implementation of `_.map` without support for iteratee shorthands.
               *
               * @private
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} iteratee The function invoked per iteration.
               * @returns {Array} Returns the new mapped array.
               */


              function baseMap(collection, iteratee) {
                var index = -1,
                    result = isArrayLike(collection) ? Array(collection.length) : [];
                baseEach(collection, function (value, key, collection) {
                  result[++index] = iteratee(value, key, collection);
                });
                return result;
              }
              /**
               * The base implementation of `_.matches` which doesn't clone `source`.
               *
               * @private
               * @param {Object} source The object of property values to match.
               * @returns {Function} Returns the new spec function.
               */


              function baseMatches(source) {
                var matchData = getMatchData(source);

                if (matchData.length == 1 && matchData[0][2]) {
                  return matchesStrictComparable(matchData[0][0], matchData[0][1]);
                }

                return function (object) {
                  return object === source || baseIsMatch(object, source, matchData);
                };
              }
              /**
               * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
               *
               * @private
               * @param {string} path The path of the property to get.
               * @param {*} srcValue The value to match.
               * @returns {Function} Returns the new spec function.
               */


              function baseMatchesProperty(path, srcValue) {
                if (isKey(path) && isStrictComparable(srcValue)) {
                  return matchesStrictComparable(toKey(path), srcValue);
                }

                return function (object) {
                  var objValue = get(object, path);
                  return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
                };
              }
              /**
               * The base implementation of `_.merge` without support for multiple sources.
               *
               * @private
               * @param {Object} object The destination object.
               * @param {Object} source The source object.
               * @param {number} srcIndex The index of `source`.
               * @param {Function} [customizer] The function to customize merged values.
               * @param {Object} [stack] Tracks traversed source values and their merged
               *  counterparts.
               */


              function baseMerge(object, source, srcIndex, customizer, stack) {
                if (object === source) {
                  return;
                }

                baseFor(source, function (srcValue, key) {
                  stack || (stack = new Stack());

                  if (isObject(srcValue)) {
                    baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                  } else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;

                    if (newValue === undefined) {
                      newValue = srcValue;
                    }

                    assignMergeValue(object, key, newValue);
                  }
                }, keysIn);
              }
              /**
               * A specialized version of `baseMerge` for arrays and objects which performs
               * deep merges and tracks traversed objects enabling objects with circular
               * references to be merged.
               *
               * @private
               * @param {Object} object The destination object.
               * @param {Object} source The source object.
               * @param {string} key The key of the value to merge.
               * @param {number} srcIndex The index of `source`.
               * @param {Function} mergeFunc The function to merge values.
               * @param {Function} [customizer] The function to customize assigned values.
               * @param {Object} [stack] Tracks traversed source values and their merged
               *  counterparts.
               */


              function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
                var objValue = safeGet(object, key),
                    srcValue = safeGet(source, key),
                    stacked = stack.get(srcValue);

                if (stacked) {
                  assignMergeValue(object, key, stacked);
                  return;
                }

                var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
                var isCommon = newValue === undefined;

                if (isCommon) {
                  var isArr = isArray(srcValue),
                      isBuff = !isArr && isBuffer(srcValue),
                      isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                  newValue = srcValue;

                  if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) {
                      newValue = objValue;
                    } else if (isArrayLikeObject(objValue)) {
                      newValue = copyArray(objValue);
                    } else if (isBuff) {
                      isCommon = false;
                      newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                      isCommon = false;
                      newValue = cloneTypedArray(srcValue, true);
                    } else {
                      newValue = [];
                    }
                  } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;

                    if (isArguments(objValue)) {
                      newValue = toPlainObject(objValue);
                    } else if (!isObject(objValue) || isFunction(objValue)) {
                      newValue = initCloneObject(srcValue);
                    }
                  } else {
                    isCommon = false;
                  }
                }

                if (isCommon) {
                  // Recursively merge objects and arrays (susceptible to call stack limits).
                  stack.set(srcValue, newValue);
                  mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                  stack['delete'](srcValue);
                }

                assignMergeValue(object, key, newValue);
              }
              /**
               * The base implementation of `_.nth` which doesn't coerce arguments.
               *
               * @private
               * @param {Array} array The array to query.
               * @param {number} n The index of the element to return.
               * @returns {*} Returns the nth element of `array`.
               */


              function baseNth(array, n) {
                var length = array.length;

                if (!length) {
                  return;
                }

                n += n < 0 ? length : 0;
                return isIndex(n, length) ? array[n] : undefined;
              }
              /**
               * The base implementation of `_.orderBy` without param guards.
               *
               * @private
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
               * @param {string[]} orders The sort orders of `iteratees`.
               * @returns {Array} Returns the new sorted array.
               */


              function baseOrderBy(collection, iteratees, orders) {
                if (iteratees.length) {
                  iteratees = arrayMap(iteratees, function (iteratee) {
                    if (isArray(iteratee)) {
                      return function (value) {
                        return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                      };
                    }

                    return iteratee;
                  });
                } else {
                  iteratees = [identity];
                }

                var index = -1;
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                var result = baseMap(collection, function (value, key, collection) {
                  var criteria = arrayMap(iteratees, function (iteratee) {
                    return iteratee(value);
                  });
                  return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                  };
                });
                return baseSortBy(result, function (object, other) {
                  return compareMultiple(object, other, orders);
                });
              }
              /**
               * The base implementation of `_.pick` without support for individual
               * property identifiers.
               *
               * @private
               * @param {Object} object The source object.
               * @param {string[]} paths The property paths to pick.
               * @returns {Object} Returns the new object.
               */


              function basePick(object, paths) {
                return basePickBy(object, paths, function (value, path) {
                  return hasIn(object, path);
                });
              }
              /**
               * The base implementation of  `_.pickBy` without support for iteratee shorthands.
               *
               * @private
               * @param {Object} object The source object.
               * @param {string[]} paths The property paths to pick.
               * @param {Function} predicate The function invoked per property.
               * @returns {Object} Returns the new object.
               */


              function basePickBy(object, paths, predicate) {
                var index = -1,
                    length = paths.length,
                    result = {};

                while (++index < length) {
                  var path = paths[index],
                      value = baseGet(object, path);

                  if (predicate(value, path)) {
                    baseSet(result, castPath(path, object), value);
                  }
                }

                return result;
              }
              /**
               * A specialized version of `baseProperty` which supports deep paths.
               *
               * @private
               * @param {Array|string} path The path of the property to get.
               * @returns {Function} Returns the new accessor function.
               */


              function basePropertyDeep(path) {
                return function (object) {
                  return baseGet(object, path);
                };
              }
              /**
               * The base implementation of `_.pullAllBy` without support for iteratee
               * shorthands.
               *
               * @private
               * @param {Array} array The array to modify.
               * @param {Array} values The values to remove.
               * @param {Function} [iteratee] The iteratee invoked per element.
               * @param {Function} [comparator] The comparator invoked per element.
               * @returns {Array} Returns `array`.
               */


              function basePullAll(array, values, iteratee, comparator) {
                var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
                    index = -1,
                    length = values.length,
                    seen = array;

                if (array === values) {
                  values = copyArray(values);
                }

                if (iteratee) {
                  seen = arrayMap(array, baseUnary(iteratee));
                }

                while (++index < length) {
                  var fromIndex = 0,
                      value = values[index],
                      computed = iteratee ? iteratee(value) : value;

                  while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
                    if (seen !== array) {
                      splice.call(seen, fromIndex, 1);
                    }

                    splice.call(array, fromIndex, 1);
                  }
                }

                return array;
              }
              /**
               * The base implementation of `_.pullAt` without support for individual
               * indexes or capturing the removed elements.
               *
               * @private
               * @param {Array} array The array to modify.
               * @param {number[]} indexes The indexes of elements to remove.
               * @returns {Array} Returns `array`.
               */


              function basePullAt(array, indexes) {
                var length = array ? indexes.length : 0,
                    lastIndex = length - 1;

                while (length--) {
                  var index = indexes[length];

                  if (length == lastIndex || index !== previous) {
                    var previous = index;

                    if (isIndex(index)) {
                      splice.call(array, index, 1);
                    } else {
                      baseUnset(array, index);
                    }
                  }
                }

                return array;
              }
              /**
               * The base implementation of `_.random` without support for returning
               * floating-point numbers.
               *
               * @private
               * @param {number} lower The lower bound.
               * @param {number} upper The upper bound.
               * @returns {number} Returns the random number.
               */


              function baseRandom(lower, upper) {
                return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
              }
              /**
               * The base implementation of `_.range` and `_.rangeRight` which doesn't
               * coerce arguments.
               *
               * @private
               * @param {number} start The start of the range.
               * @param {number} end The end of the range.
               * @param {number} step The value to increment or decrement by.
               * @param {boolean} [fromRight] Specify iterating from right to left.
               * @returns {Array} Returns the range of numbers.
               */


              function baseRange(start, end, step, fromRight) {
                var index = -1,
                    length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
                    result = Array(length);

                while (length--) {
                  result[fromRight ? length : ++index] = start;
                  start += step;
                }

                return result;
              }
              /**
               * The base implementation of `_.repeat` which doesn't coerce arguments.
               *
               * @private
               * @param {string} string The string to repeat.
               * @param {number} n The number of times to repeat the string.
               * @returns {string} Returns the repeated string.
               */


              function baseRepeat(string, n) {
                var result = '';

                if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
                  return result;
                } // Leverage the exponentiation by squaring algorithm for a faster repeat.
                // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.


                do {
                  if (n % 2) {
                    result += string;
                  }

                  n = nativeFloor(n / 2);

                  if (n) {
                    string += string;
                  }
                } while (n);

                return result;
              }
              /**
               * The base implementation of `_.rest` which doesn't validate or coerce arguments.
               *
               * @private
               * @param {Function} func The function to apply a rest parameter to.
               * @param {number} [start=func.length-1] The start position of the rest parameter.
               * @returns {Function} Returns the new function.
               */


              function baseRest(func, start) {
                return setToString(overRest(func, start, identity), func + '');
              }
              /**
               * The base implementation of `_.sample`.
               *
               * @private
               * @param {Array|Object} collection The collection to sample.
               * @returns {*} Returns the random element.
               */


              function baseSample(collection) {
                return arraySample(values(collection));
              }
              /**
               * The base implementation of `_.sampleSize` without param guards.
               *
               * @private
               * @param {Array|Object} collection The collection to sample.
               * @param {number} n The number of elements to sample.
               * @returns {Array} Returns the random elements.
               */


              function baseSampleSize(collection, n) {
                var array = values(collection);
                return shuffleSelf(array, baseClamp(n, 0, array.length));
              }
              /**
               * The base implementation of `_.set`.
               *
               * @private
               * @param {Object} object The object to modify.
               * @param {Array|string} path The path of the property to set.
               * @param {*} value The value to set.
               * @param {Function} [customizer] The function to customize path creation.
               * @returns {Object} Returns `object`.
               */


              function baseSet(object, path, value, customizer) {
                if (!isObject(object)) {
                  return object;
                }

                path = castPath(path, object);
                var index = -1,
                    length = path.length,
                    lastIndex = length - 1,
                    nested = object;

                while (nested != null && ++index < length) {
                  var key = toKey(path[index]),
                      newValue = value;

                  if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
                    return object;
                  }

                  if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;

                    if (newValue === undefined) {
                      newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                    }
                  }

                  assignValue(nested, key, newValue);
                  nested = nested[key];
                }

                return object;
              }
              /**
               * The base implementation of `setData` without support for hot loop shorting.
               *
               * @private
               * @param {Function} func The function to associate metadata with.
               * @param {*} data The metadata.
               * @returns {Function} Returns `func`.
               */


              var baseSetData = !metaMap ? identity : function (func, data) {
                metaMap.set(func, data);
                return func;
              };
              /**
               * The base implementation of `setToString` without support for hot loop shorting.
               *
               * @private
               * @param {Function} func The function to modify.
               * @param {Function} string The `toString` result.
               * @returns {Function} Returns `func`.
               */

              var baseSetToString = !defineProperty ? identity : function (func, string) {
                return defineProperty(func, 'toString', {
                  'configurable': true,
                  'enumerable': false,
                  'value': constant(string),
                  'writable': true
                });
              };
              /**
               * The base implementation of `_.shuffle`.
               *
               * @private
               * @param {Array|Object} collection The collection to shuffle.
               * @returns {Array} Returns the new shuffled array.
               */

              function baseShuffle(collection) {
                return shuffleSelf(values(collection));
              }
              /**
               * The base implementation of `_.slice` without an iteratee call guard.
               *
               * @private
               * @param {Array} array The array to slice.
               * @param {number} [start=0] The start position.
               * @param {number} [end=array.length] The end position.
               * @returns {Array} Returns the slice of `array`.
               */


              function baseSlice(array, start, end) {
                var index = -1,
                    length = array.length;

                if (start < 0) {
                  start = -start > length ? 0 : length + start;
                }

                end = end > length ? length : end;

                if (end < 0) {
                  end += length;
                }

                length = start > end ? 0 : end - start >>> 0;
                start >>>= 0;
                var result = Array(length);

                while (++index < length) {
                  result[index] = array[index + start];
                }

                return result;
              }
              /**
               * The base implementation of `_.some` without support for iteratee shorthands.
               *
               * @private
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} predicate The function invoked per iteration.
               * @returns {boolean} Returns `true` if any element passes the predicate check,
               *  else `false`.
               */


              function baseSome(collection, predicate) {
                var result;
                baseEach(collection, function (value, index, collection) {
                  result = predicate(value, index, collection);
                  return !result;
                });
                return !!result;
              }
              /**
               * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
               * performs a binary search of `array` to determine the index at which `value`
               * should be inserted into `array` in order to maintain its sort order.
               *
               * @private
               * @param {Array} array The sorted array to inspect.
               * @param {*} value The value to evaluate.
               * @param {boolean} [retHighest] Specify returning the highest qualified index.
               * @returns {number} Returns the index at which `value` should be inserted
               *  into `array`.
               */


              function baseSortedIndex(array, value, retHighest) {
                var low = 0,
                    high = array == null ? low : array.length;

                if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                  while (low < high) {
                    var mid = low + high >>> 1,
                        computed = array[mid];

                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
                      low = mid + 1;
                    } else {
                      high = mid;
                    }
                  }

                  return high;
                }

                return baseSortedIndexBy(array, value, identity, retHighest);
              }
              /**
               * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
               * which invokes `iteratee` for `value` and each element of `array` to compute
               * their sort ranking. The iteratee is invoked with one argument; (value).
               *
               * @private
               * @param {Array} array The sorted array to inspect.
               * @param {*} value The value to evaluate.
               * @param {Function} iteratee The iteratee invoked per element.
               * @param {boolean} [retHighest] Specify returning the highest qualified index.
               * @returns {number} Returns the index at which `value` should be inserted
               *  into `array`.
               */


              function baseSortedIndexBy(array, value, iteratee, retHighest) {
                var low = 0,
                    high = array == null ? 0 : array.length;

                if (high === 0) {
                  return 0;
                }

                value = iteratee(value);
                var valIsNaN = value !== value,
                    valIsNull = value === null,
                    valIsSymbol = isSymbol(value),
                    valIsUndefined = value === undefined;

                while (low < high) {
                  var mid = nativeFloor((low + high) / 2),
                      computed = iteratee(array[mid]),
                      othIsDefined = computed !== undefined,
                      othIsNull = computed === null,
                      othIsReflexive = computed === computed,
                      othIsSymbol = isSymbol(computed);

                  if (valIsNaN) {
                    var setLow = retHighest || othIsReflexive;
                  } else if (valIsUndefined) {
                    setLow = othIsReflexive && (retHighest || othIsDefined);
                  } else if (valIsNull) {
                    setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                  } else if (valIsSymbol) {
                    setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                  } else if (othIsNull || othIsSymbol) {
                    setLow = false;
                  } else {
                    setLow = retHighest ? computed <= value : computed < value;
                  }

                  if (setLow) {
                    low = mid + 1;
                  } else {
                    high = mid;
                  }
                }

                return nativeMin(high, MAX_ARRAY_INDEX);
              }
              /**
               * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
               * support for iteratee shorthands.
               *
               * @private
               * @param {Array} array The array to inspect.
               * @param {Function} [iteratee] The iteratee invoked per element.
               * @returns {Array} Returns the new duplicate free array.
               */


              function baseSortedUniq(array, iteratee) {
                var index = -1,
                    length = array.length,
                    resIndex = 0,
                    result = [];

                while (++index < length) {
                  var value = array[index],
                      computed = iteratee ? iteratee(value) : value;

                  if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                  }
                }

                return result;
              }
              /**
               * The base implementation of `_.toNumber` which doesn't ensure correct
               * conversions of binary, hexadecimal, or octal string values.
               *
               * @private
               * @param {*} value The value to process.
               * @returns {number} Returns the number.
               */


              function baseToNumber(value) {
                if (typeof value == 'number') {
                  return value;
                }

                if (isSymbol(value)) {
                  return NAN;
                }

                return +value;
              }
              /**
               * The base implementation of `_.toString` which doesn't convert nullish
               * values to empty strings.
               *
               * @private
               * @param {*} value The value to process.
               * @returns {string} Returns the string.
               */


              function baseToString(value) {
                // Exit early for strings to avoid a performance hit in some environments.
                if (typeof value == 'string') {
                  return value;
                }

                if (isArray(value)) {
                  // Recursively convert values (susceptible to call stack limits).
                  return arrayMap(value, baseToString) + '';
                }

                if (isSymbol(value)) {
                  return symbolToString ? symbolToString.call(value) : '';
                }

                var result = value + '';
                return result == '0' && 1 / value == -INFINITY ? '-0' : result;
              }
              /**
               * The base implementation of `_.uniqBy` without support for iteratee shorthands.
               *
               * @private
               * @param {Array} array The array to inspect.
               * @param {Function} [iteratee] The iteratee invoked per element.
               * @param {Function} [comparator] The comparator invoked per element.
               * @returns {Array} Returns the new duplicate free array.
               */


              function baseUniq(array, iteratee, comparator) {
                var index = -1,
                    includes = arrayIncludes,
                    length = array.length,
                    isCommon = true,
                    result = [],
                    seen = result;

                if (comparator) {
                  isCommon = false;
                  includes = arrayIncludesWith;
                } else if (length >= LARGE_ARRAY_SIZE) {
                  var set = iteratee ? null : createSet(array);

                  if (set) {
                    return setToArray(set);
                  }

                  isCommon = false;
                  includes = cacheHas;
                  seen = new SetCache();
                } else {
                  seen = iteratee ? [] : result;
                }

                outer: while (++index < length) {
                  var value = array[index],
                      computed = iteratee ? iteratee(value) : value;
                  value = comparator || value !== 0 ? value : 0;

                  if (isCommon && computed === computed) {
                    var seenIndex = seen.length;

                    while (seenIndex--) {
                      if (seen[seenIndex] === computed) {
                        continue outer;
                      }
                    }

                    if (iteratee) {
                      seen.push(computed);
                    }

                    result.push(value);
                  } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) {
                      seen.push(computed);
                    }

                    result.push(value);
                  }
                }

                return result;
              }
              /**
               * The base implementation of `_.unset`.
               *
               * @private
               * @param {Object} object The object to modify.
               * @param {Array|string} path The property path to unset.
               * @returns {boolean} Returns `true` if the property is deleted, else `false`.
               */


              function baseUnset(object, path) {
                path = castPath(path, object);
                object = parent(object, path);
                return object == null || delete object[toKey(last(path))];
              }
              /**
               * The base implementation of `_.update`.
               *
               * @private
               * @param {Object} object The object to modify.
               * @param {Array|string} path The path of the property to update.
               * @param {Function} updater The function to produce the updated value.
               * @param {Function} [customizer] The function to customize path creation.
               * @returns {Object} Returns `object`.
               */


              function baseUpdate(object, path, updater, customizer) {
                return baseSet(object, path, updater(baseGet(object, path)), customizer);
              }
              /**
               * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
               * without support for iteratee shorthands.
               *
               * @private
               * @param {Array} array The array to query.
               * @param {Function} predicate The function invoked per iteration.
               * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
               * @param {boolean} [fromRight] Specify iterating from right to left.
               * @returns {Array} Returns the slice of `array`.
               */


              function baseWhile(array, predicate, isDrop, fromRight) {
                var length = array.length,
                    index = fromRight ? length : -1;

                while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}

                return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
              }
              /**
               * The base implementation of `wrapperValue` which returns the result of
               * performing a sequence of actions on the unwrapped `value`, where each
               * successive action is supplied the return value of the previous.
               *
               * @private
               * @param {*} value The unwrapped value.
               * @param {Array} actions Actions to perform to resolve the unwrapped value.
               * @returns {*} Returns the resolved value.
               */


              function baseWrapperValue(value, actions) {
                var result = value;

                if (result instanceof LazyWrapper) {
                  result = result.value();
                }

                return arrayReduce(actions, function (result, action) {
                  return action.func.apply(action.thisArg, arrayPush([result], action.args));
                }, result);
              }
              /**
               * The base implementation of methods like `_.xor`, without support for
               * iteratee shorthands, that accepts an array of arrays to inspect.
               *
               * @private
               * @param {Array} arrays The arrays to inspect.
               * @param {Function} [iteratee] The iteratee invoked per element.
               * @param {Function} [comparator] The comparator invoked per element.
               * @returns {Array} Returns the new array of values.
               */


              function baseXor(arrays, iteratee, comparator) {
                var length = arrays.length;

                if (length < 2) {
                  return length ? baseUniq(arrays[0]) : [];
                }

                var index = -1,
                    result = Array(length);

                while (++index < length) {
                  var array = arrays[index],
                      othIndex = -1;

                  while (++othIndex < length) {
                    if (othIndex != index) {
                      result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
                    }
                  }
                }

                return baseUniq(baseFlatten(result, 1), iteratee, comparator);
              }
              /**
               * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
               *
               * @private
               * @param {Array} props The property identifiers.
               * @param {Array} values The property values.
               * @param {Function} assignFunc The function to assign values.
               * @returns {Object} Returns the new object.
               */


              function baseZipObject(props, values, assignFunc) {
                var index = -1,
                    length = props.length,
                    valsLength = values.length,
                    result = {};

                while (++index < length) {
                  var value = index < valsLength ? values[index] : undefined;
                  assignFunc(result, props[index], value);
                }

                return result;
              }
              /**
               * Casts `value` to an empty array if it's not an array like object.
               *
               * @private
               * @param {*} value The value to inspect.
               * @returns {Array|Object} Returns the cast array-like object.
               */


              function castArrayLikeObject(value) {
                return isArrayLikeObject(value) ? value : [];
              }
              /**
               * Casts `value` to `identity` if it's not a function.
               *
               * @private
               * @param {*} value The value to inspect.
               * @returns {Function} Returns cast function.
               */


              function castFunction(value) {
                return typeof value == 'function' ? value : identity;
              }
              /**
               * Casts `value` to a path array if it's not one.
               *
               * @private
               * @param {*} value The value to inspect.
               * @param {Object} [object] The object to query keys on.
               * @returns {Array} Returns the cast property path array.
               */


              function castPath(value, object) {
                if (isArray(value)) {
                  return value;
                }

                return isKey(value, object) ? [value] : stringToPath(toString(value));
              }
              /**
               * A `baseRest` alias which can be replaced with `identity` by module
               * replacement plugins.
               *
               * @private
               * @type {Function}
               * @param {Function} func The function to apply a rest parameter to.
               * @returns {Function} Returns the new function.
               */


              var castRest = baseRest;
              /**
               * Casts `array` to a slice if it's needed.
               *
               * @private
               * @param {Array} array The array to inspect.
               * @param {number} start The start position.
               * @param {number} [end=array.length] The end position.
               * @returns {Array} Returns the cast slice.
               */

              function castSlice(array, start, end) {
                var length = array.length;
                end = end === undefined ? length : end;
                return !start && end >= length ? array : baseSlice(array, start, end);
              }
              /**
               * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
               *
               * @private
               * @param {number|Object} id The timer id or timeout object of the timer to clear.
               */


              var clearTimeout = ctxClearTimeout || function (id) {
                return root.clearTimeout(id);
              };
              /**
               * Creates a clone of  `buffer`.
               *
               * @private
               * @param {Buffer} buffer The buffer to clone.
               * @param {boolean} [isDeep] Specify a deep clone.
               * @returns {Buffer} Returns the cloned buffer.
               */


              function cloneBuffer(buffer, isDeep) {
                if (isDeep) {
                  return buffer.slice();
                }

                var length = buffer.length,
                    result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
                buffer.copy(result);
                return result;
              }
              /**
               * Creates a clone of `arrayBuffer`.
               *
               * @private
               * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
               * @returns {ArrayBuffer} Returns the cloned array buffer.
               */


              function cloneArrayBuffer(arrayBuffer) {
                var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
                new Uint8Array(result).set(new Uint8Array(arrayBuffer));
                return result;
              }
              /**
               * Creates a clone of `dataView`.
               *
               * @private
               * @param {Object} dataView The data view to clone.
               * @param {boolean} [isDeep] Specify a deep clone.
               * @returns {Object} Returns the cloned data view.
               */


              function cloneDataView(dataView, isDeep) {
                var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
                return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
              }
              /**
               * Creates a clone of `regexp`.
               *
               * @private
               * @param {Object} regexp The regexp to clone.
               * @returns {Object} Returns the cloned regexp.
               */


              function cloneRegExp(regexp) {
                var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
                result.lastIndex = regexp.lastIndex;
                return result;
              }
              /**
               * Creates a clone of the `symbol` object.
               *
               * @private
               * @param {Object} symbol The symbol object to clone.
               * @returns {Object} Returns the cloned symbol object.
               */


              function cloneSymbol(symbol) {
                return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
              }
              /**
               * Creates a clone of `typedArray`.
               *
               * @private
               * @param {Object} typedArray The typed array to clone.
               * @param {boolean} [isDeep] Specify a deep clone.
               * @returns {Object} Returns the cloned typed array.
               */


              function cloneTypedArray(typedArray, isDeep) {
                var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
                return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
              }
              /**
               * Compares values to sort them in ascending order.
               *
               * @private
               * @param {*} value The value to compare.
               * @param {*} other The other value to compare.
               * @returns {number} Returns the sort order indicator for `value`.
               */


              function compareAscending(value, other) {
                if (value !== other) {
                  var valIsDefined = value !== undefined,
                      valIsNull = value === null,
                      valIsReflexive = value === value,
                      valIsSymbol = isSymbol(value);
                  var othIsDefined = other !== undefined,
                      othIsNull = other === null,
                      othIsReflexive = other === other,
                      othIsSymbol = isSymbol(other);

                  if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
                    return 1;
                  }

                  if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
                    return -1;
                  }
                }

                return 0;
              }
              /**
               * Used by `_.orderBy` to compare multiple properties of a value to another
               * and stable sort them.
               *
               * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
               * specify an order of "desc" for descending or "asc" for ascending sort order
               * of corresponding values.
               *
               * @private
               * @param {Object} object The object to compare.
               * @param {Object} other The other object to compare.
               * @param {boolean[]|string[]} orders The order to sort by for each property.
               * @returns {number} Returns the sort order indicator for `object`.
               */


              function compareMultiple(object, other, orders) {
                var index = -1,
                    objCriteria = object.criteria,
                    othCriteria = other.criteria,
                    length = objCriteria.length,
                    ordersLength = orders.length;

                while (++index < length) {
                  var result = compareAscending(objCriteria[index], othCriteria[index]);

                  if (result) {
                    if (index >= ordersLength) {
                      return result;
                    }

                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                  }
                } // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
                // that causes it, under certain circumstances, to provide the same value for
                // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
                // for more details.
                //
                // This also ensures a stable sort in V8 and other engines.
                // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.


                return object.index - other.index;
              }
              /**
               * Creates an array that is the composition of partially applied arguments,
               * placeholders, and provided arguments into a single array of arguments.
               *
               * @private
               * @param {Array} args The provided arguments.
               * @param {Array} partials The arguments to prepend to those provided.
               * @param {Array} holders The `partials` placeholder indexes.
               * @params {boolean} [isCurried] Specify composing for a curried function.
               * @returns {Array} Returns the new array of composed arguments.
               */


              function composeArgs(args, partials, holders, isCurried) {
                var argsIndex = -1,
                    argsLength = args.length,
                    holdersLength = holders.length,
                    leftIndex = -1,
                    leftLength = partials.length,
                    rangeLength = nativeMax(argsLength - holdersLength, 0),
                    result = Array(leftLength + rangeLength),
                    isUncurried = !isCurried;

                while (++leftIndex < leftLength) {
                  result[leftIndex] = partials[leftIndex];
                }

                while (++argsIndex < holdersLength) {
                  if (isUncurried || argsIndex < argsLength) {
                    result[holders[argsIndex]] = args[argsIndex];
                  }
                }

                while (rangeLength--) {
                  result[leftIndex++] = args[argsIndex++];
                }

                return result;
              }
              /**
               * This function is like `composeArgs` except that the arguments composition
               * is tailored for `_.partialRight`.
               *
               * @private
               * @param {Array} args The provided arguments.
               * @param {Array} partials The arguments to append to those provided.
               * @param {Array} holders The `partials` placeholder indexes.
               * @params {boolean} [isCurried] Specify composing for a curried function.
               * @returns {Array} Returns the new array of composed arguments.
               */


              function composeArgsRight(args, partials, holders, isCurried) {
                var argsIndex = -1,
                    argsLength = args.length,
                    holdersIndex = -1,
                    holdersLength = holders.length,
                    rightIndex = -1,
                    rightLength = partials.length,
                    rangeLength = nativeMax(argsLength - holdersLength, 0),
                    result = Array(rangeLength + rightLength),
                    isUncurried = !isCurried;

                while (++argsIndex < rangeLength) {
                  result[argsIndex] = args[argsIndex];
                }

                var offset = argsIndex;

                while (++rightIndex < rightLength) {
                  result[offset + rightIndex] = partials[rightIndex];
                }

                while (++holdersIndex < holdersLength) {
                  if (isUncurried || argsIndex < argsLength) {
                    result[offset + holders[holdersIndex]] = args[argsIndex++];
                  }
                }

                return result;
              }
              /**
               * Copies the values of `source` to `array`.
               *
               * @private
               * @param {Array} source The array to copy values from.
               * @param {Array} [array=[]] The array to copy values to.
               * @returns {Array} Returns `array`.
               */


              function copyArray(source, array) {
                var index = -1,
                    length = source.length;
                array || (array = Array(length));

                while (++index < length) {
                  array[index] = source[index];
                }

                return array;
              }
              /**
               * Copies properties of `source` to `object`.
               *
               * @private
               * @param {Object} source The object to copy properties from.
               * @param {Array} props The property identifiers to copy.
               * @param {Object} [object={}] The object to copy properties to.
               * @param {Function} [customizer] The function to customize copied values.
               * @returns {Object} Returns `object`.
               */


              function copyObject(source, props, object, customizer) {
                var isNew = !object;
                object || (object = {});
                var index = -1,
                    length = props.length;

                while (++index < length) {
                  var key = props[index];
                  var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

                  if (newValue === undefined) {
                    newValue = source[key];
                  }

                  if (isNew) {
                    baseAssignValue(object, key, newValue);
                  } else {
                    assignValue(object, key, newValue);
                  }
                }

                return object;
              }
              /**
               * Copies own symbols of `source` to `object`.
               *
               * @private
               * @param {Object} source The object to copy symbols from.
               * @param {Object} [object={}] The object to copy symbols to.
               * @returns {Object} Returns `object`.
               */


              function copySymbols(source, object) {
                return copyObject(source, getSymbols(source), object);
              }
              /**
               * Copies own and inherited symbols of `source` to `object`.
               *
               * @private
               * @param {Object} source The object to copy symbols from.
               * @param {Object} [object={}] The object to copy symbols to.
               * @returns {Object} Returns `object`.
               */


              function copySymbolsIn(source, object) {
                return copyObject(source, getSymbolsIn(source), object);
              }
              /**
               * Creates a function like `_.groupBy`.
               *
               * @private
               * @param {Function} setter The function to set accumulator values.
               * @param {Function} [initializer] The accumulator object initializer.
               * @returns {Function} Returns the new aggregator function.
               */


              function createAggregator(setter, initializer) {
                return function (collection, iteratee) {
                  var func = isArray(collection) ? arrayAggregator : baseAggregator,
                      accumulator = initializer ? initializer() : {};
                  return func(collection, setter, getIteratee(iteratee, 2), accumulator);
                };
              }
              /**
               * Creates a function like `_.assign`.
               *
               * @private
               * @param {Function} assigner The function to assign values.
               * @returns {Function} Returns the new assigner function.
               */


              function createAssigner(assigner) {
                return baseRest(function (object, sources) {
                  var index = -1,
                      length = sources.length,
                      customizer = length > 1 ? sources[length - 1] : undefined,
                      guard = length > 2 ? sources[2] : undefined;
                  customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

                  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                  }

                  object = Object(object);

                  while (++index < length) {
                    var source = sources[index];

                    if (source) {
                      assigner(object, source, index, customizer);
                    }
                  }

                  return object;
                });
              }
              /**
               * Creates a `baseEach` or `baseEachRight` function.
               *
               * @private
               * @param {Function} eachFunc The function to iterate over a collection.
               * @param {boolean} [fromRight] Specify iterating from right to left.
               * @returns {Function} Returns the new base function.
               */


              function createBaseEach(eachFunc, fromRight) {
                return function (collection, iteratee) {
                  if (collection == null) {
                    return collection;
                  }

                  if (!isArrayLike(collection)) {
                    return eachFunc(collection, iteratee);
                  }

                  var length = collection.length,
                      index = fromRight ? length : -1,
                      iterable = Object(collection);

                  while (fromRight ? index-- : ++index < length) {
                    if (iteratee(iterable[index], index, iterable) === false) {
                      break;
                    }
                  }

                  return collection;
                };
              }
              /**
               * Creates a base function for methods like `_.forIn` and `_.forOwn`.
               *
               * @private
               * @param {boolean} [fromRight] Specify iterating from right to left.
               * @returns {Function} Returns the new base function.
               */


              function createBaseFor(fromRight) {
                return function (object, iteratee, keysFunc) {
                  var index = -1,
                      iterable = Object(object),
                      props = keysFunc(object),
                      length = props.length;

                  while (length--) {
                    var key = props[fromRight ? length : ++index];

                    if (iteratee(iterable[key], key, iterable) === false) {
                      break;
                    }
                  }

                  return object;
                };
              }
              /**
               * Creates a function that wraps `func` to invoke it with the optional `this`
               * binding of `thisArg`.
               *
               * @private
               * @param {Function} func The function to wrap.
               * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
               * @param {*} [thisArg] The `this` binding of `func`.
               * @returns {Function} Returns the new wrapped function.
               */


              function createBind(func, bitmask, thisArg) {
                var isBind = bitmask & WRAP_BIND_FLAG,
                    Ctor = createCtor(func);

                function wrapper() {
                  var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                  return fn.apply(isBind ? thisArg : this, arguments);
                }

                return wrapper;
              }
              /**
               * Creates a function like `_.lowerFirst`.
               *
               * @private
               * @param {string} methodName The name of the `String` case method to use.
               * @returns {Function} Returns the new case function.
               */


              function createCaseFirst(methodName) {
                return function (string) {
                  string = toString(string);
                  var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                  var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                  var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                  return chr[methodName]() + trailing;
                };
              }
              /**
               * Creates a function like `_.camelCase`.
               *
               * @private
               * @param {Function} callback The function to combine each word.
               * @returns {Function} Returns the new compounder function.
               */


              function createCompounder(callback) {
                return function (string) {
                  return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
                };
              }
              /**
               * Creates a function that produces an instance of `Ctor` regardless of
               * whether it was invoked as part of a `new` expression or by `call` or `apply`.
               *
               * @private
               * @param {Function} Ctor The constructor to wrap.
               * @returns {Function} Returns the new wrapped function.
               */


              function createCtor(Ctor) {
                return function () {
                  // Use a `switch` statement to work with class constructors. See
                  // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                  // for more details.
                  var args = arguments;

                  switch (args.length) {
                    case 0:
                      return new Ctor();

                    case 1:
                      return new Ctor(args[0]);

                    case 2:
                      return new Ctor(args[0], args[1]);

                    case 3:
                      return new Ctor(args[0], args[1], args[2]);

                    case 4:
                      return new Ctor(args[0], args[1], args[2], args[3]);

                    case 5:
                      return new Ctor(args[0], args[1], args[2], args[3], args[4]);

                    case 6:
                      return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);

                    case 7:
                      return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                  }

                  var thisBinding = baseCreate(Ctor.prototype),
                      result = Ctor.apply(thisBinding, args); // Mimic the constructor's `return` behavior.
                  // See https://es5.github.io/#x13.2.2 for more details.

                  return isObject(result) ? result : thisBinding;
                };
              }
              /**
               * Creates a function that wraps `func` to enable currying.
               *
               * @private
               * @param {Function} func The function to wrap.
               * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
               * @param {number} arity The arity of `func`.
               * @returns {Function} Returns the new wrapped function.
               */


              function createCurry(func, bitmask, arity) {
                var Ctor = createCtor(func);

                function wrapper() {
                  var length = arguments.length,
                      args = Array(length),
                      index = length,
                      placeholder = getHolder(wrapper);

                  while (index--) {
                    args[index] = arguments[index];
                  }

                  var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                  length -= holders.length;

                  if (length < arity) {
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                  }

                  var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                  return apply(fn, this, args);
                }

                return wrapper;
              }
              /**
               * Creates a `_.find` or `_.findLast` function.
               *
               * @private
               * @param {Function} findIndexFunc The function to find the collection index.
               * @returns {Function} Returns the new find function.
               */


              function createFind(findIndexFunc) {
                return function (collection, predicate, fromIndex) {
                  var iterable = Object(collection);

                  if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);

                    predicate = function predicate(key) {
                      return iteratee(iterable[key], key, iterable);
                    };
                  }

                  var index = findIndexFunc(collection, predicate, fromIndex);
                  return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
                };
              }
              /**
               * Creates a `_.flow` or `_.flowRight` function.
               *
               * @private
               * @param {boolean} [fromRight] Specify iterating from right to left.
               * @returns {Function} Returns the new flow function.
               */


              function createFlow(fromRight) {
                return flatRest(function (funcs) {
                  var length = funcs.length,
                      index = length,
                      prereq = LodashWrapper.prototype.thru;

                  if (fromRight) {
                    funcs.reverse();
                  }

                  while (index--) {
                    var func = funcs[index];

                    if (typeof func != 'function') {
                      throw new TypeError(FUNC_ERROR_TEXT);
                    }

                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
                      var wrapper = new LodashWrapper([], true);
                    }
                  }

                  index = wrapper ? index : length;

                  while (++index < length) {
                    func = funcs[index];
                    var funcName = getFuncName(func),
                        data = funcName == 'wrapper' ? getData(func) : undefined;

                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                      wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    } else {
                      wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                    }
                  }

                  return function () {
                    var args = arguments,
                        value = args[0];

                    if (wrapper && args.length == 1 && isArray(value)) {
                      return wrapper.plant(value).value();
                    }

                    var index = 0,
                        result = length ? funcs[index].apply(this, args) : value;

                    while (++index < length) {
                      result = funcs[index].call(this, result);
                    }

                    return result;
                  };
                });
              }
              /**
               * Creates a function that wraps `func` to invoke it with optional `this`
               * binding of `thisArg`, partial application, and currying.
               *
               * @private
               * @param {Function|string} func The function or method name to wrap.
               * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
               * @param {*} [thisArg] The `this` binding of `func`.
               * @param {Array} [partials] The arguments to prepend to those provided to
               *  the new function.
               * @param {Array} [holders] The `partials` placeholder indexes.
               * @param {Array} [partialsRight] The arguments to append to those provided
               *  to the new function.
               * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
               * @param {Array} [argPos] The argument positions of the new function.
               * @param {number} [ary] The arity cap of `func`.
               * @param {number} [arity] The arity of `func`.
               * @returns {Function} Returns the new wrapped function.
               */


              function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
                var isAry = bitmask & WRAP_ARY_FLAG,
                    isBind = bitmask & WRAP_BIND_FLAG,
                    isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
                    isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
                    isFlip = bitmask & WRAP_FLIP_FLAG,
                    Ctor = isBindKey ? undefined : createCtor(func);

                function wrapper() {
                  var length = arguments.length,
                      args = Array(length),
                      index = length;

                  while (index--) {
                    args[index] = arguments[index];
                  }

                  if (isCurried) {
                    var placeholder = getHolder(wrapper),
                        holdersCount = countHolders(args, placeholder);
                  }

                  if (partials) {
                    args = composeArgs(args, partials, holders, isCurried);
                  }

                  if (partialsRight) {
                    args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                  }

                  length -= holdersCount;

                  if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                  }

                  var thisBinding = isBind ? thisArg : this,
                      fn = isBindKey ? thisBinding[func] : func;
                  length = args.length;

                  if (argPos) {
                    args = reorder(args, argPos);
                  } else if (isFlip && length > 1) {
                    args.reverse();
                  }

                  if (isAry && ary < length) {
                    args.length = ary;
                  }

                  if (this && this !== root && this instanceof wrapper) {
                    fn = Ctor || createCtor(fn);
                  }

                  return fn.apply(thisBinding, args);
                }

                return wrapper;
              }
              /**
               * Creates a function like `_.invertBy`.
               *
               * @private
               * @param {Function} setter The function to set accumulator values.
               * @param {Function} toIteratee The function to resolve iteratees.
               * @returns {Function} Returns the new inverter function.
               */


              function createInverter(setter, toIteratee) {
                return function (object, iteratee) {
                  return baseInverter(object, setter, toIteratee(iteratee), {});
                };
              }
              /**
               * Creates a function that performs a mathematical operation on two values.
               *
               * @private
               * @param {Function} operator The function to perform the operation.
               * @param {number} [defaultValue] The value used for `undefined` arguments.
               * @returns {Function} Returns the new mathematical operation function.
               */


              function createMathOperation(operator, defaultValue) {
                return function (value, other) {
                  var result;

                  if (value === undefined && other === undefined) {
                    return defaultValue;
                  }

                  if (value !== undefined) {
                    result = value;
                  }

                  if (other !== undefined) {
                    if (result === undefined) {
                      return other;
                    }

                    if (typeof value == 'string' || typeof other == 'string') {
                      value = baseToString(value);
                      other = baseToString(other);
                    } else {
                      value = baseToNumber(value);
                      other = baseToNumber(other);
                    }

                    result = operator(value, other);
                  }

                  return result;
                };
              }
              /**
               * Creates a function like `_.over`.
               *
               * @private
               * @param {Function} arrayFunc The function to iterate over iteratees.
               * @returns {Function} Returns the new over function.
               */


              function createOver(arrayFunc) {
                return flatRest(function (iteratees) {
                  iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                  return baseRest(function (args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function (iteratee) {
                      return apply(iteratee, thisArg, args);
                    });
                  });
                });
              }
              /**
               * Creates the padding for `string` based on `length`. The `chars` string
               * is truncated if the number of characters exceeds `length`.
               *
               * @private
               * @param {number} length The padding length.
               * @param {string} [chars=' '] The string used as padding.
               * @returns {string} Returns the padding for `string`.
               */


              function createPadding(length, chars) {
                chars = chars === undefined ? ' ' : baseToString(chars);
                var charsLength = chars.length;

                if (charsLength < 2) {
                  return charsLength ? baseRepeat(chars, length) : chars;
                }

                var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
                return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
              }
              /**
               * Creates a function that wraps `func` to invoke it with the `this` binding
               * of `thisArg` and `partials` prepended to the arguments it receives.
               *
               * @private
               * @param {Function} func The function to wrap.
               * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
               * @param {*} thisArg The `this` binding of `func`.
               * @param {Array} partials The arguments to prepend to those provided to
               *  the new function.
               * @returns {Function} Returns the new wrapped function.
               */


              function createPartial(func, bitmask, thisArg, partials) {
                var isBind = bitmask & WRAP_BIND_FLAG,
                    Ctor = createCtor(func);

                function wrapper() {
                  var argsIndex = -1,
                      argsLength = arguments.length,
                      leftIndex = -1,
                      leftLength = partials.length,
                      args = Array(leftLength + argsLength),
                      fn = this && this !== root && this instanceof wrapper ? Ctor : func;

                  while (++leftIndex < leftLength) {
                    args[leftIndex] = partials[leftIndex];
                  }

                  while (argsLength--) {
                    args[leftIndex++] = arguments[++argsIndex];
                  }

                  return apply(fn, isBind ? thisArg : this, args);
                }

                return wrapper;
              }
              /**
               * Creates a `_.range` or `_.rangeRight` function.
               *
               * @private
               * @param {boolean} [fromRight] Specify iterating from right to left.
               * @returns {Function} Returns the new range function.
               */


              function createRange(fromRight) {
                return function (start, end, step) {
                  if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
                    end = step = undefined;
                  } // Ensure the sign of `-0` is preserved.


                  start = toFinite(start);

                  if (end === undefined) {
                    end = start;
                    start = 0;
                  } else {
                    end = toFinite(end);
                  }

                  step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                  return baseRange(start, end, step, fromRight);
                };
              }
              /**
               * Creates a function that performs a relational operation on two values.
               *
               * @private
               * @param {Function} operator The function to perform the operation.
               * @returns {Function} Returns the new relational operation function.
               */


              function createRelationalOperation(operator) {
                return function (value, other) {
                  if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                  }

                  return operator(value, other);
                };
              }
              /**
               * Creates a function that wraps `func` to continue currying.
               *
               * @private
               * @param {Function} func The function to wrap.
               * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
               * @param {Function} wrapFunc The function to create the `func` wrapper.
               * @param {*} placeholder The placeholder value.
               * @param {*} [thisArg] The `this` binding of `func`.
               * @param {Array} [partials] The arguments to prepend to those provided to
               *  the new function.
               * @param {Array} [holders] The `partials` placeholder indexes.
               * @param {Array} [argPos] The argument positions of the new function.
               * @param {number} [ary] The arity cap of `func`.
               * @param {number} [arity] The arity of `func`.
               * @returns {Function} Returns the new wrapped function.
               */


              function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
                var isCurry = bitmask & WRAP_CURRY_FLAG,
                    newHolders = isCurry ? holders : undefined,
                    newHoldersRight = isCurry ? undefined : holders,
                    newPartials = isCurry ? partials : undefined,
                    newPartialsRight = isCurry ? undefined : partials;
                bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
                bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

                if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
                  bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
                }

                var newData = [func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity];
                var result = wrapFunc.apply(undefined, newData);

                if (isLaziable(func)) {
                  setData(result, newData);
                }

                result.placeholder = placeholder;
                return setWrapToString(result, func, bitmask);
              }
              /**
               * Creates a function like `_.round`.
               *
               * @private
               * @param {string} methodName The name of the `Math` method to use when rounding.
               * @returns {Function} Returns the new round function.
               */


              function createRound(methodName) {
                var func = Math[methodName];
                return function (number, precision) {
                  number = toNumber(number);
                  precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);

                  if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'),
                        value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                  }

                  return func(number);
                };
              }
              /**
               * Creates a set object of `values`.
               *
               * @private
               * @param {Array} values The values to add to the set.
               * @returns {Object} Returns the new set.
               */


              var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function (values) {
                return new Set(values);
              };
              /**
               * Creates a `_.toPairs` or `_.toPairsIn` function.
               *
               * @private
               * @param {Function} keysFunc The function to get the keys of a given object.
               * @returns {Function} Returns the new pairs function.
               */

              function createToPairs(keysFunc) {
                return function (object) {
                  var tag = getTag(object);

                  if (tag == mapTag) {
                    return mapToArray(object);
                  }

                  if (tag == setTag) {
                    return setToPairs(object);
                  }

                  return baseToPairs(object, keysFunc(object));
                };
              }
              /**
               * Creates a function that either curries or invokes `func` with optional
               * `this` binding and partially applied arguments.
               *
               * @private
               * @param {Function|string} func The function or method name to wrap.
               * @param {number} bitmask The bitmask flags.
               *    1 - `_.bind`
               *    2 - `_.bindKey`
               *    4 - `_.curry` or `_.curryRight` of a bound function
               *    8 - `_.curry`
               *   16 - `_.curryRight`
               *   32 - `_.partial`
               *   64 - `_.partialRight`
               *  128 - `_.rearg`
               *  256 - `_.ary`
               *  512 - `_.flip`
               * @param {*} [thisArg] The `this` binding of `func`.
               * @param {Array} [partials] The arguments to be partially applied.
               * @param {Array} [holders] The `partials` placeholder indexes.
               * @param {Array} [argPos] The argument positions of the new function.
               * @param {number} [ary] The arity cap of `func`.
               * @param {number} [arity] The arity of `func`.
               * @returns {Function} Returns the new wrapped function.
               */


              function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
                var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;

                if (!isBindKey && typeof func != 'function') {
                  throw new TypeError(FUNC_ERROR_TEXT);
                }

                var length = partials ? partials.length : 0;

                if (!length) {
                  bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                  partials = holders = undefined;
                }

                ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
                arity = arity === undefined ? arity : toInteger(arity);
                length -= holders ? holders.length : 0;

                if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                  var partialsRight = partials,
                      holdersRight = holders;
                  partials = holders = undefined;
                }

                var data = isBindKey ? undefined : getData(func);
                var newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

                if (data) {
                  mergeData(newData, data);
                }

                func = newData[0];
                bitmask = newData[1];
                thisArg = newData[2];
                partials = newData[3];
                holders = newData[4];
                arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);

                if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
                  bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
                }

                if (!bitmask || bitmask == WRAP_BIND_FLAG) {
                  var result = createBind(func, bitmask, thisArg);
                } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
                  result = createCurry(func, bitmask, arity);
                } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
                  result = createPartial(func, bitmask, thisArg, partials);
                } else {
                  result = createHybrid.apply(undefined, newData);
                }

                var setter = data ? baseSetData : setData;
                return setWrapToString(setter(result, newData), func, bitmask);
              }
              /**
               * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
               * of source objects to the destination object for all destination properties
               * that resolve to `undefined`.
               *
               * @private
               * @param {*} objValue The destination value.
               * @param {*} srcValue The source value.
               * @param {string} key The key of the property to assign.
               * @param {Object} object The parent object of `objValue`.
               * @returns {*} Returns the value to assign.
               */


              function customDefaultsAssignIn(objValue, srcValue, key, object) {
                if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
                  return srcValue;
                }

                return objValue;
              }
              /**
               * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
               * objects into destination objects that are passed thru.
               *
               * @private
               * @param {*} objValue The destination value.
               * @param {*} srcValue The source value.
               * @param {string} key The key of the property to merge.
               * @param {Object} object The parent object of `objValue`.
               * @param {Object} source The parent object of `srcValue`.
               * @param {Object} [stack] Tracks traversed source values and their merged
               *  counterparts.
               * @returns {*} Returns the value to assign.
               */


              function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
                if (isObject(objValue) && isObject(srcValue)) {
                  // Recursively merge objects and arrays (susceptible to call stack limits).
                  stack.set(srcValue, objValue);
                  baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                  stack['delete'](srcValue);
                }

                return objValue;
              }
              /**
               * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
               * objects.
               *
               * @private
               * @param {*} value The value to inspect.
               * @param {string} key The key of the property to inspect.
               * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
               */


              function customOmitClone(value) {
                return isPlainObject(value) ? undefined : value;
              }
              /**
               * A specialized version of `baseIsEqualDeep` for arrays with support for
               * partial deep comparisons.
               *
               * @private
               * @param {Array} array The array to compare.
               * @param {Array} other The other array to compare.
               * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
               * @param {Function} customizer The function to customize comparisons.
               * @param {Function} equalFunc The function to determine equivalents of values.
               * @param {Object} stack Tracks traversed `array` and `other` objects.
               * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
               */


              function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
                var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
                    arrLength = array.length,
                    othLength = other.length;

                if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
                  return false;
                } // Check that cyclic values are equal.


                var arrStacked = stack.get(array);
                var othStacked = stack.get(other);

                if (arrStacked && othStacked) {
                  return arrStacked == other && othStacked == array;
                }

                var index = -1,
                    result = true,
                    seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
                stack.set(array, other);
                stack.set(other, array); // Ignore non-index properties.

                while (++index < arrLength) {
                  var arrValue = array[index],
                      othValue = other[index];

                  if (customizer) {
                    var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                  }

                  if (compared !== undefined) {
                    if (compared) {
                      continue;
                    }

                    result = false;
                    break;
                  } // Recursively compare arrays (susceptible to call stack limits).


                  if (seen) {
                    if (!arraySome(other, function (othValue, othIndex) {
                      if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                        return seen.push(othIndex);
                      }
                    })) {
                      result = false;
                      break;
                    }
                  } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                  }
                }

                stack['delete'](array);
                stack['delete'](other);
                return result;
              }
              /**
               * A specialized version of `baseIsEqualDeep` for comparing objects of
               * the same `toStringTag`.
               *
               * **Note:** This function only supports comparing values with tags of
               * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
               *
               * @private
               * @param {Object} object The object to compare.
               * @param {Object} other The other object to compare.
               * @param {string} tag The `toStringTag` of the objects to compare.
               * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
               * @param {Function} customizer The function to customize comparisons.
               * @param {Function} equalFunc The function to determine equivalents of values.
               * @param {Object} stack Tracks traversed `object` and `other` objects.
               * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
               */


              function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
                switch (tag) {
                  case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                      return false;
                    }

                    object = object.buffer;
                    other = other.buffer;

                  case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
                      return false;
                    }

                    return true;

                  case boolTag:
                  case dateTag:
                  case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);

                  case errorTag:
                    return object.name == other.name && object.message == other.message;

                  case regexpTag:
                  case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';

                  case mapTag:
                    var convert = mapToArray;

                  case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);

                    if (object.size != other.size && !isPartial) {
                      return false;
                    } // Assume cyclic values are equal.


                    var stacked = stack.get(object);

                    if (stacked) {
                      return stacked == other;
                    }

                    bitmask |= COMPARE_UNORDERED_FLAG; // Recursively compare objects (susceptible to call stack limits).

                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;

                  case symbolTag:
                    if (symbolValueOf) {
                      return symbolValueOf.call(object) == symbolValueOf.call(other);
                    }

                }

                return false;
              }
              /**
               * A specialized version of `baseIsEqualDeep` for objects with support for
               * partial deep comparisons.
               *
               * @private
               * @param {Object} object The object to compare.
               * @param {Object} other The other object to compare.
               * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
               * @param {Function} customizer The function to customize comparisons.
               * @param {Function} equalFunc The function to determine equivalents of values.
               * @param {Object} stack Tracks traversed `object` and `other` objects.
               * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
               */


              function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
                var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
                    objProps = getAllKeys(object),
                    objLength = objProps.length,
                    othProps = getAllKeys(other),
                    othLength = othProps.length;

                if (objLength != othLength && !isPartial) {
                  return false;
                }

                var index = objLength;

                while (index--) {
                  var key = objProps[index];

                  if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
                    return false;
                  }
                } // Check that cyclic values are equal.


                var objStacked = stack.get(object);
                var othStacked = stack.get(other);

                if (objStacked && othStacked) {
                  return objStacked == other && othStacked == object;
                }

                var result = true;
                stack.set(object, other);
                stack.set(other, object);
                var skipCtor = isPartial;

                while (++index < objLength) {
                  key = objProps[index];
                  var objValue = object[key],
                      othValue = other[key];

                  if (customizer) {
                    var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                  } // Recursively compare objects (susceptible to call stack limits).


                  if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                  }

                  skipCtor || (skipCtor = key == 'constructor');
                }

                if (result && !skipCtor) {
                  var objCtor = object.constructor,
                      othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

                  if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
                    result = false;
                  }
                }

                stack['delete'](object);
                stack['delete'](other);
                return result;
              }
              /**
               * A specialized version of `baseRest` which flattens the rest array.
               *
               * @private
               * @param {Function} func The function to apply a rest parameter to.
               * @returns {Function} Returns the new function.
               */


              function flatRest(func) {
                return setToString(overRest(func, undefined, flatten), func + '');
              }
              /**
               * Creates an array of own enumerable property names and symbols of `object`.
               *
               * @private
               * @param {Object} object The object to query.
               * @returns {Array} Returns the array of property names and symbols.
               */


              function getAllKeys(object) {
                return baseGetAllKeys(object, keys, getSymbols);
              }
              /**
               * Creates an array of own and inherited enumerable property names and
               * symbols of `object`.
               *
               * @private
               * @param {Object} object The object to query.
               * @returns {Array} Returns the array of property names and symbols.
               */


              function getAllKeysIn(object) {
                return baseGetAllKeys(object, keysIn, getSymbolsIn);
              }
              /**
               * Gets metadata for `func`.
               *
               * @private
               * @param {Function} func The function to query.
               * @returns {*} Returns the metadata for `func`.
               */


              var getData = !metaMap ? noop : function (func) {
                return metaMap.get(func);
              };
              /**
               * Gets the name of `func`.
               *
               * @private
               * @param {Function} func The function to query.
               * @returns {string} Returns the function name.
               */

              function getFuncName(func) {
                var result = func.name + '',
                    array = realNames[result],
                    length = hasOwnProperty.call(realNames, result) ? array.length : 0;

                while (length--) {
                  var data = array[length],
                      otherFunc = data.func;

                  if (otherFunc == null || otherFunc == func) {
                    return data.name;
                  }
                }

                return result;
              }
              /**
               * Gets the argument placeholder value for `func`.
               *
               * @private
               * @param {Function} func The function to inspect.
               * @returns {*} Returns the placeholder value.
               */


              function getHolder(func) {
                var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
                return object.placeholder;
              }
              /**
               * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
               * this function returns the custom method, otherwise it returns `baseIteratee`.
               * If arguments are provided, the chosen function is invoked with them and
               * its result is returned.
               *
               * @private
               * @param {*} [value] The value to convert to an iteratee.
               * @param {number} [arity] The arity of the created iteratee.
               * @returns {Function} Returns the chosen function or its result.
               */


              function getIteratee() {
                var result = lodash.iteratee || iteratee;
                result = result === iteratee ? baseIteratee : result;
                return arguments.length ? result(arguments[0], arguments[1]) : result;
              }
              /**
               * Gets the data for `map`.
               *
               * @private
               * @param {Object} map The map to query.
               * @param {string} key The reference key.
               * @returns {*} Returns the map data.
               */


              function getMapData(map, key) {
                var data = map.__data__;
                return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
              }
              /**
               * Gets the property names, values, and compare flags of `object`.
               *
               * @private
               * @param {Object} object The object to query.
               * @returns {Array} Returns the match data of `object`.
               */


              function getMatchData(object) {
                var result = keys(object),
                    length = result.length;

                while (length--) {
                  var key = result[length],
                      value = object[key];
                  result[length] = [key, value, isStrictComparable(value)];
                }

                return result;
              }
              /**
               * Gets the native function at `key` of `object`.
               *
               * @private
               * @param {Object} object The object to query.
               * @param {string} key The key of the method to get.
               * @returns {*} Returns the function if it's native, else `undefined`.
               */


              function getNative(object, key) {
                var value = getValue(object, key);
                return baseIsNative(value) ? value : undefined;
              }
              /**
               * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
               *
               * @private
               * @param {*} value The value to query.
               * @returns {string} Returns the raw `toStringTag`.
               */


              function getRawTag(value) {
                var isOwn = hasOwnProperty.call(value, symToStringTag),
                    tag = value[symToStringTag];

                try {
                  value[symToStringTag] = undefined;
                  var unmasked = true;
                } catch (e) {}

                var result = nativeObjectToString.call(value);

                if (unmasked) {
                  if (isOwn) {
                    value[symToStringTag] = tag;
                  } else {
                    delete value[symToStringTag];
                  }
                }

                return result;
              }
              /**
               * Creates an array of the own enumerable symbols of `object`.
               *
               * @private
               * @param {Object} object The object to query.
               * @returns {Array} Returns the array of symbols.
               */


              var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
                if (object == null) {
                  return [];
                }

                object = Object(object);
                return arrayFilter(nativeGetSymbols(object), function (symbol) {
                  return propertyIsEnumerable.call(object, symbol);
                });
              };
              /**
               * Creates an array of the own and inherited enumerable symbols of `object`.
               *
               * @private
               * @param {Object} object The object to query.
               * @returns {Array} Returns the array of symbols.
               */

              var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
                var result = [];

                while (object) {
                  arrayPush(result, getSymbols(object));
                  object = getPrototype(object);
                }

                return result;
              };
              /**
               * Gets the `toStringTag` of `value`.
               *
               * @private
               * @param {*} value The value to query.
               * @returns {string} Returns the `toStringTag`.
               */

              var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

              if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
                getTag = function getTag(value) {
                  var result = baseGetTag(value),
                      Ctor = result == objectTag ? value.constructor : undefined,
                      ctorString = Ctor ? toSource(Ctor) : '';

                  if (ctorString) {
                    switch (ctorString) {
                      case dataViewCtorString:
                        return dataViewTag;

                      case mapCtorString:
                        return mapTag;

                      case promiseCtorString:
                        return promiseTag;

                      case setCtorString:
                        return setTag;

                      case weakMapCtorString:
                        return weakMapTag;
                    }
                  }

                  return result;
                };
              }
              /**
               * Gets the view, applying any `transforms` to the `start` and `end` positions.
               *
               * @private
               * @param {number} start The start of the view.
               * @param {number} end The end of the view.
               * @param {Array} transforms The transformations to apply to the view.
               * @returns {Object} Returns an object containing the `start` and `end`
               *  positions of the view.
               */


              function getView(start, end, transforms) {
                var index = -1,
                    length = transforms.length;

                while (++index < length) {
                  var data = transforms[index],
                      size = data.size;

                  switch (data.type) {
                    case 'drop':
                      start += size;
                      break;

                    case 'dropRight':
                      end -= size;
                      break;

                    case 'take':
                      end = nativeMin(end, start + size);
                      break;

                    case 'takeRight':
                      start = nativeMax(start, end - size);
                      break;
                  }
                }

                return {
                  'start': start,
                  'end': end
                };
              }
              /**
               * Extracts wrapper details from the `source` body comment.
               *
               * @private
               * @param {string} source The source to inspect.
               * @returns {Array} Returns the wrapper details.
               */


              function getWrapDetails(source) {
                var match = source.match(reWrapDetails);
                return match ? match[1].split(reSplitDetails) : [];
              }
              /**
               * Checks if `path` exists on `object`.
               *
               * @private
               * @param {Object} object The object to query.
               * @param {Array|string} path The path to check.
               * @param {Function} hasFunc The function to check properties.
               * @returns {boolean} Returns `true` if `path` exists, else `false`.
               */


              function hasPath(object, path, hasFunc) {
                path = castPath(path, object);
                var index = -1,
                    length = path.length,
                    result = false;

                while (++index < length) {
                  var key = toKey(path[index]);

                  if (!(result = object != null && hasFunc(object, key))) {
                    break;
                  }

                  object = object[key];
                }

                if (result || ++index != length) {
                  return result;
                }

                length = object == null ? 0 : object.length;
                return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
              }
              /**
               * Initializes an array clone.
               *
               * @private
               * @param {Array} array The array to clone.
               * @returns {Array} Returns the initialized clone.
               */


              function initCloneArray(array) {
                var length = array.length,
                    result = new array.constructor(length); // Add properties assigned by `RegExp#exec`.

                if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                  result.index = array.index;
                  result.input = array.input;
                }

                return result;
              }
              /**
               * Initializes an object clone.
               *
               * @private
               * @param {Object} object The object to clone.
               * @returns {Object} Returns the initialized clone.
               */


              function initCloneObject(object) {
                return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
              }
              /**
               * Initializes an object clone based on its `toStringTag`.
               *
               * **Note:** This function only supports cloning values with tags of
               * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
               *
               * @private
               * @param {Object} object The object to clone.
               * @param {string} tag The `toStringTag` of the object to clone.
               * @param {boolean} [isDeep] Specify a deep clone.
               * @returns {Object} Returns the initialized clone.
               */


              function initCloneByTag(object, tag, isDeep) {
                var Ctor = object.constructor;

                switch (tag) {
                  case arrayBufferTag:
                    return cloneArrayBuffer(object);

                  case boolTag:
                  case dateTag:
                    return new Ctor(+object);

                  case dataViewTag:
                    return cloneDataView(object, isDeep);

                  case float32Tag:
                  case float64Tag:
                  case int8Tag:
                  case int16Tag:
                  case int32Tag:
                  case uint8Tag:
                  case uint8ClampedTag:
                  case uint16Tag:
                  case uint32Tag:
                    return cloneTypedArray(object, isDeep);

                  case mapTag:
                    return new Ctor();

                  case numberTag:
                  case stringTag:
                    return new Ctor(object);

                  case regexpTag:
                    return cloneRegExp(object);

                  case setTag:
                    return new Ctor();

                  case symbolTag:
                    return cloneSymbol(object);
                }
              }
              /**
               * Inserts wrapper `details` in a comment at the top of the `source` body.
               *
               * @private
               * @param {string} source The source to modify.
               * @returns {Array} details The details to insert.
               * @returns {string} Returns the modified source.
               */


              function insertWrapDetails(source, details) {
                var length = details.length;

                if (!length) {
                  return source;
                }

                var lastIndex = length - 1;
                details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
                details = details.join(length > 2 ? ', ' : ' ');
                return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
              }
              /**
               * Checks if `value` is a flattenable `arguments` object or array.
               *
               * @private
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
               */


              function isFlattenable(value) {
                return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
              }
              /**
               * Checks if `value` is a valid array-like index.
               *
               * @private
               * @param {*} value The value to check.
               * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
               * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
               */


              function isIndex(value, length) {
                var type = _typeof2(value);

                length = length == null ? MAX_SAFE_INTEGER : length;
                return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
              }
              /**
               * Checks if the given arguments are from an iteratee call.
               *
               * @private
               * @param {*} value The potential iteratee value argument.
               * @param {*} index The potential iteratee index or key argument.
               * @param {*} object The potential iteratee object argument.
               * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
               *  else `false`.
               */


              function isIterateeCall(value, index, object) {
                if (!isObject(object)) {
                  return false;
                }

                var type = _typeof2(index);

                if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
                  return eq(object[index], value);
                }

                return false;
              }
              /**
               * Checks if `value` is a property name and not a property path.
               *
               * @private
               * @param {*} value The value to check.
               * @param {Object} [object] The object to query keys on.
               * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
               */


              function isKey(value, object) {
                if (isArray(value)) {
                  return false;
                }

                var type = _typeof2(value);

                if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
                  return true;
                }

                return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
              }
              /**
               * Checks if `value` is suitable for use as unique object key.
               *
               * @private
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
               */


              function isKeyable(value) {
                var type = _typeof2(value);

                return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
              }
              /**
               * Checks if `func` has a lazy counterpart.
               *
               * @private
               * @param {Function} func The function to check.
               * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
               *  else `false`.
               */


              function isLaziable(func) {
                var funcName = getFuncName(func),
                    other = lodash[funcName];

                if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
                  return false;
                }

                if (func === other) {
                  return true;
                }

                var data = getData(other);
                return !!data && func === data[0];
              }
              /**
               * Checks if `func` has its source masked.
               *
               * @private
               * @param {Function} func The function to check.
               * @returns {boolean} Returns `true` if `func` is masked, else `false`.
               */


              function isMasked(func) {
                return !!maskSrcKey && maskSrcKey in func;
              }
              /**
               * Checks if `func` is capable of being masked.
               *
               * @private
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
               */


              var isMaskable = coreJsData ? isFunction : stubFalse;
              /**
               * Checks if `value` is likely a prototype object.
               *
               * @private
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
               */

              function isPrototype(value) {
                var Ctor = value && value.constructor,
                    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
                return value === proto;
              }
              /**
               * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
               *
               * @private
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` if suitable for strict
               *  equality comparisons, else `false`.
               */


              function isStrictComparable(value) {
                return value === value && !isObject(value);
              }
              /**
               * A specialized version of `matchesProperty` for source values suitable
               * for strict equality comparisons, i.e. `===`.
               *
               * @private
               * @param {string} key The key of the property to get.
               * @param {*} srcValue The value to match.
               * @returns {Function} Returns the new spec function.
               */


              function matchesStrictComparable(key, srcValue) {
                return function (object) {
                  if (object == null) {
                    return false;
                  }

                  return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
                };
              }
              /**
               * A specialized version of `_.memoize` which clears the memoized function's
               * cache when it exceeds `MAX_MEMOIZE_SIZE`.
               *
               * @private
               * @param {Function} func The function to have its output memoized.
               * @returns {Function} Returns the new memoized function.
               */


              function memoizeCapped(func) {
                var result = memoize(func, function (key) {
                  if (cache.size === MAX_MEMOIZE_SIZE) {
                    cache.clear();
                  }

                  return key;
                });
                var cache = result.cache;
                return result;
              }
              /**
               * Merges the function metadata of `source` into `data`.
               *
               * Merging metadata reduces the number of wrappers used to invoke a function.
               * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
               * may be applied regardless of execution order. Methods like `_.ary` and
               * `_.rearg` modify function arguments, making the order in which they are
               * executed important, preventing the merging of metadata. However, we make
               * an exception for a safe combined case where curried functions have `_.ary`
               * and or `_.rearg` applied.
               *
               * @private
               * @param {Array} data The destination metadata.
               * @param {Array} source The source metadata.
               * @returns {Array} Returns `data`.
               */


              function mergeData(data, source) {
                var bitmask = data[1],
                    srcBitmask = source[1],
                    newBitmask = bitmask | srcBitmask,
                    isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
                var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG; // Exit early if metadata can't be merged.

                if (!(isCommon || isCombo)) {
                  return data;
                } // Use source `thisArg` if available.


                if (srcBitmask & WRAP_BIND_FLAG) {
                  data[2] = source[2]; // Set when currying a bound function.

                  newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
                } // Compose partial arguments.


                var value = source[3];

                if (value) {
                  var partials = data[3];
                  data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                  data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
                } // Compose partial right arguments.


                value = source[5];

                if (value) {
                  partials = data[5];
                  data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                  data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
                } // Use source `argPos` if available.


                value = source[7];

                if (value) {
                  data[7] = value;
                } // Use source `ary` if it's smaller.


                if (srcBitmask & WRAP_ARY_FLAG) {
                  data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
                } // Use source `arity` if one is not provided.


                if (data[9] == null) {
                  data[9] = source[9];
                } // Use source `func` and merge bitmasks.


                data[0] = source[0];
                data[1] = newBitmask;
                return data;
              }
              /**
               * This function is like
               * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
               * except that it includes inherited enumerable properties.
               *
               * @private
               * @param {Object} object The object to query.
               * @returns {Array} Returns the array of property names.
               */


              function nativeKeysIn(object) {
                var result = [];

                if (object != null) {
                  for (var key in Object(object)) {
                    result.push(key);
                  }
                }

                return result;
              }
              /**
               * Converts `value` to a string using `Object.prototype.toString`.
               *
               * @private
               * @param {*} value The value to convert.
               * @returns {string} Returns the converted string.
               */


              function objectToString(value) {
                return nativeObjectToString.call(value);
              }
              /**
               * A specialized version of `baseRest` which transforms the rest array.
               *
               * @private
               * @param {Function} func The function to apply a rest parameter to.
               * @param {number} [start=func.length-1] The start position of the rest parameter.
               * @param {Function} transform The rest array transform.
               * @returns {Function} Returns the new function.
               */


              function overRest(func, start, transform) {
                start = nativeMax(start === undefined ? func.length - 1 : start, 0);
                return function () {
                  var args = arguments,
                      index = -1,
                      length = nativeMax(args.length - start, 0),
                      array = Array(length);

                  while (++index < length) {
                    array[index] = args[start + index];
                  }

                  index = -1;
                  var otherArgs = Array(start + 1);

                  while (++index < start) {
                    otherArgs[index] = args[index];
                  }

                  otherArgs[start] = transform(array);
                  return apply(func, this, otherArgs);
                };
              }
              /**
               * Gets the parent value at `path` of `object`.
               *
               * @private
               * @param {Object} object The object to query.
               * @param {Array} path The path to get the parent value of.
               * @returns {*} Returns the parent value.
               */


              function parent(object, path) {
                return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
              }
              /**
               * Reorder `array` according to the specified indexes where the element at
               * the first index is assigned as the first element, the element at
               * the second index is assigned as the second element, and so on.
               *
               * @private
               * @param {Array} array The array to reorder.
               * @param {Array} indexes The arranged array indexes.
               * @returns {Array} Returns `array`.
               */


              function reorder(array, indexes) {
                var arrLength = array.length,
                    length = nativeMin(indexes.length, arrLength),
                    oldArray = copyArray(array);

                while (length--) {
                  var index = indexes[length];
                  array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
                }

                return array;
              }
              /**
               * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
               *
               * @private
               * @param {Object} object The object to query.
               * @param {string} key The key of the property to get.
               * @returns {*} Returns the property value.
               */


              function safeGet(object, key) {
                if (key === 'constructor' && typeof object[key] === 'function') {
                  return;
                }

                if (key == '__proto__') {
                  return;
                }

                return object[key];
              }
              /**
               * Sets metadata for `func`.
               *
               * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
               * period of time, it will trip its breaker and transition to an identity
               * function to avoid garbage collection pauses in V8. See
               * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
               * for more details.
               *
               * @private
               * @param {Function} func The function to associate metadata with.
               * @param {*} data The metadata.
               * @returns {Function} Returns `func`.
               */


              var setData = shortOut(baseSetData);
              /**
               * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
               *
               * @private
               * @param {Function} func The function to delay.
               * @param {number} wait The number of milliseconds to delay invocation.
               * @returns {number|Object} Returns the timer id or timeout object.
               */

              var setTimeout = ctxSetTimeout || function (func, wait) {
                return root.setTimeout(func, wait);
              };
              /**
               * Sets the `toString` method of `func` to return `string`.
               *
               * @private
               * @param {Function} func The function to modify.
               * @param {Function} string The `toString` result.
               * @returns {Function} Returns `func`.
               */


              var setToString = shortOut(baseSetToString);
              /**
               * Sets the `toString` method of `wrapper` to mimic the source of `reference`
               * with wrapper details in a comment at the top of the source body.
               *
               * @private
               * @param {Function} wrapper The function to modify.
               * @param {Function} reference The reference function.
               * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
               * @returns {Function} Returns `wrapper`.
               */

              function setWrapToString(wrapper, reference, bitmask) {
                var source = reference + '';
                return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
              }
              /**
               * Creates a function that'll short out and invoke `identity` instead
               * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
               * milliseconds.
               *
               * @private
               * @param {Function} func The function to restrict.
               * @returns {Function} Returns the new shortable function.
               */


              function shortOut(func) {
                var count = 0,
                    lastCalled = 0;
                return function () {
                  var stamp = nativeNow(),
                      remaining = HOT_SPAN - (stamp - lastCalled);
                  lastCalled = stamp;

                  if (remaining > 0) {
                    if (++count >= HOT_COUNT) {
                      return arguments[0];
                    }
                  } else {
                    count = 0;
                  }

                  return func.apply(undefined, arguments);
                };
              }
              /**
               * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
               *
               * @private
               * @param {Array} array The array to shuffle.
               * @param {number} [size=array.length] The size of `array`.
               * @returns {Array} Returns `array`.
               */


              function shuffleSelf(array, size) {
                var index = -1,
                    length = array.length,
                    lastIndex = length - 1;
                size = size === undefined ? length : size;

                while (++index < size) {
                  var rand = baseRandom(index, lastIndex),
                      value = array[rand];
                  array[rand] = array[index];
                  array[index] = value;
                }

                array.length = size;
                return array;
              }
              /**
               * Converts `string` to a property path array.
               *
               * @private
               * @param {string} string The string to convert.
               * @returns {Array} Returns the property path array.
               */


              var stringToPath = memoizeCapped(function (string) {
                var result = [];

                if (string.charCodeAt(0) === 46
                /* . */
                ) {
                  result.push('');
                }

                string.replace(rePropName, function (match, number, quote, subString) {
                  result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
                });
                return result;
              });
              /**
               * Converts `value` to a string key if it's not a string or symbol.
               *
               * @private
               * @param {*} value The value to inspect.
               * @returns {string|symbol} Returns the key.
               */

              function toKey(value) {
                if (typeof value == 'string' || isSymbol(value)) {
                  return value;
                }

                var result = value + '';
                return result == '0' && 1 / value == -INFINITY ? '-0' : result;
              }
              /**
               * Converts `func` to its source code.
               *
               * @private
               * @param {Function} func The function to convert.
               * @returns {string} Returns the source code.
               */


              function toSource(func) {
                if (func != null) {
                  try {
                    return funcToString.call(func);
                  } catch (e) {}

                  try {
                    return func + '';
                  } catch (e) {}
                }

                return '';
              }
              /**
               * Updates wrapper `details` based on `bitmask` flags.
               *
               * @private
               * @returns {Array} details The details to modify.
               * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
               * @returns {Array} Returns `details`.
               */


              function updateWrapDetails(details, bitmask) {
                arrayEach(wrapFlags, function (pair) {
                  var value = '_.' + pair[0];

                  if (bitmask & pair[1] && !arrayIncludes(details, value)) {
                    details.push(value);
                  }
                });
                return details.sort();
              }
              /**
               * Creates a clone of `wrapper`.
               *
               * @private
               * @param {Object} wrapper The wrapper to clone.
               * @returns {Object} Returns the cloned wrapper.
               */


              function wrapperClone(wrapper) {
                if (wrapper instanceof LazyWrapper) {
                  return wrapper.clone();
                }

                var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
                result.__actions__ = copyArray(wrapper.__actions__);
                result.__index__ = wrapper.__index__;
                result.__values__ = wrapper.__values__;
                return result;
              }
              /*------------------------------------------------------------------------*/

              /**
               * Creates an array of elements split into groups the length of `size`.
               * If `array` can't be split evenly, the final chunk will be the remaining
               * elements.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Array
               * @param {Array} array The array to process.
               * @param {number} [size=1] The length of each chunk
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
               * @returns {Array} Returns the new array of chunks.
               * @example
               *
               * _.chunk(['a', 'b', 'c', 'd'], 2);
               * // => [['a', 'b'], ['c', 'd']]
               *
               * _.chunk(['a', 'b', 'c', 'd'], 3);
               * // => [['a', 'b', 'c'], ['d']]
               */


              function chunk(array, size, guard) {
                if (guard ? isIterateeCall(array, size, guard) : size === undefined) {
                  size = 1;
                } else {
                  size = nativeMax(toInteger(size), 0);
                }

                var length = array == null ? 0 : array.length;

                if (!length || size < 1) {
                  return [];
                }

                var index = 0,
                    resIndex = 0,
                    result = Array(nativeCeil(length / size));

                while (index < length) {
                  result[resIndex++] = baseSlice(array, index, index += size);
                }

                return result;
              }
              /**
               * Creates an array with all falsey values removed. The values `false`, `null`,
               * `0`, `""`, `undefined`, and `NaN` are falsey.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Array
               * @param {Array} array The array to compact.
               * @returns {Array} Returns the new array of filtered values.
               * @example
               *
               * _.compact([0, 1, false, 2, '', 3]);
               * // => [1, 2, 3]
               */


              function compact(array) {
                var index = -1,
                    length = array == null ? 0 : array.length,
                    resIndex = 0,
                    result = [];

                while (++index < length) {
                  var value = array[index];

                  if (value) {
                    result[resIndex++] = value;
                  }
                }

                return result;
              }
              /**
               * Creates a new array concatenating `array` with any additional arrays
               * and/or values.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {Array} array The array to concatenate.
               * @param {...*} [values] The values to concatenate.
               * @returns {Array} Returns the new concatenated array.
               * @example
               *
               * var array = [1];
               * var other = _.concat(array, 2, [3], [[4]]);
               *
               * console.log(other);
               * // => [1, 2, 3, [4]]
               *
               * console.log(array);
               * // => [1]
               */


              function concat() {
                var length = arguments.length;

                if (!length) {
                  return [];
                }

                var args = Array(length - 1),
                    array = arguments[0],
                    index = length;

                while (index--) {
                  args[index - 1] = arguments[index];
                }

                return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
              }
              /**
               * Creates an array of `array` values not included in the other given arrays
               * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
               * for equality comparisons. The order and references of result values are
               * determined by the first array.
               *
               * **Note:** Unlike `_.pullAll`, this method returns a new array.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Array
               * @param {Array} array The array to inspect.
               * @param {...Array} [values] The values to exclude.
               * @returns {Array} Returns the new array of filtered values.
               * @see _.without, _.xor
               * @example
               *
               * _.difference([2, 1], [2, 3]);
               * // => [1]
               */


              var difference = baseRest(function (array, values) {
                return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
              });
              /**
               * This method is like `_.difference` except that it accepts `iteratee` which
               * is invoked for each element of `array` and `values` to generate the criterion
               * by which they're compared. The order and references of result values are
               * determined by the first array. The iteratee is invoked with one argument:
               * (value).
               *
               * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {Array} array The array to inspect.
               * @param {...Array} [values] The values to exclude.
               * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
               * @returns {Array} Returns the new array of filtered values.
               * @example
               *
               * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
               * // => [1.2]
               *
               * // The `_.property` iteratee shorthand.
               * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
               * // => [{ 'x': 2 }]
               */

              var differenceBy = baseRest(function (array, values) {
                var iteratee = last(values);

                if (isArrayLikeObject(iteratee)) {
                  iteratee = undefined;
                }

                return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
              });
              /**
               * This method is like `_.difference` except that it accepts `comparator`
               * which is invoked to compare elements of `array` to `values`. The order and
               * references of result values are determined by the first array. The comparator
               * is invoked with two arguments: (arrVal, othVal).
               *
               * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {Array} array The array to inspect.
               * @param {...Array} [values] The values to exclude.
               * @param {Function} [comparator] The comparator invoked per element.
               * @returns {Array} Returns the new array of filtered values.
               * @example
               *
               * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
               *
               * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
               * // => [{ 'x': 2, 'y': 1 }]
               */

              var differenceWith = baseRest(function (array, values) {
                var comparator = last(values);

                if (isArrayLikeObject(comparator)) {
                  comparator = undefined;
                }

                return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
              });
              /**
               * Creates a slice of `array` with `n` elements dropped from the beginning.
               *
               * @static
               * @memberOf _
               * @since 0.5.0
               * @category Array
               * @param {Array} array The array to query.
               * @param {number} [n=1] The number of elements to drop.
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
               * @returns {Array} Returns the slice of `array`.
               * @example
               *
               * _.drop([1, 2, 3]);
               * // => [2, 3]
               *
               * _.drop([1, 2, 3], 2);
               * // => [3]
               *
               * _.drop([1, 2, 3], 5);
               * // => []
               *
               * _.drop([1, 2, 3], 0);
               * // => [1, 2, 3]
               */

              function drop(array, n, guard) {
                var length = array == null ? 0 : array.length;

                if (!length) {
                  return [];
                }

                n = guard || n === undefined ? 1 : toInteger(n);
                return baseSlice(array, n < 0 ? 0 : n, length);
              }
              /**
               * Creates a slice of `array` with `n` elements dropped from the end.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Array
               * @param {Array} array The array to query.
               * @param {number} [n=1] The number of elements to drop.
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
               * @returns {Array} Returns the slice of `array`.
               * @example
               *
               * _.dropRight([1, 2, 3]);
               * // => [1, 2]
               *
               * _.dropRight([1, 2, 3], 2);
               * // => [1]
               *
               * _.dropRight([1, 2, 3], 5);
               * // => []
               *
               * _.dropRight([1, 2, 3], 0);
               * // => [1, 2, 3]
               */


              function dropRight(array, n, guard) {
                var length = array == null ? 0 : array.length;

                if (!length) {
                  return [];
                }

                n = guard || n === undefined ? 1 : toInteger(n);
                n = length - n;
                return baseSlice(array, 0, n < 0 ? 0 : n);
              }
              /**
               * Creates a slice of `array` excluding elements dropped from the end.
               * Elements are dropped until `predicate` returns falsey. The predicate is
               * invoked with three arguments: (value, index, array).
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Array
               * @param {Array} array The array to query.
               * @param {Function} [predicate=_.identity] The function invoked per iteration.
               * @returns {Array} Returns the slice of `array`.
               * @example
               *
               * var users = [
               *   { 'user': 'barney',  'active': true },
               *   { 'user': 'fred',    'active': false },
               *   { 'user': 'pebbles', 'active': false }
               * ];
               *
               * _.dropRightWhile(users, function(o) { return !o.active; });
               * // => objects for ['barney']
               *
               * // The `_.matches` iteratee shorthand.
               * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
               * // => objects for ['barney', 'fred']
               *
               * // The `_.matchesProperty` iteratee shorthand.
               * _.dropRightWhile(users, ['active', false]);
               * // => objects for ['barney']
               *
               * // The `_.property` iteratee shorthand.
               * _.dropRightWhile(users, 'active');
               * // => objects for ['barney', 'fred', 'pebbles']
               */


              function dropRightWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
              }
              /**
               * Creates a slice of `array` excluding elements dropped from the beginning.
               * Elements are dropped until `predicate` returns falsey. The predicate is
               * invoked with three arguments: (value, index, array).
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Array
               * @param {Array} array The array to query.
               * @param {Function} [predicate=_.identity] The function invoked per iteration.
               * @returns {Array} Returns the slice of `array`.
               * @example
               *
               * var users = [
               *   { 'user': 'barney',  'active': false },
               *   { 'user': 'fred',    'active': false },
               *   { 'user': 'pebbles', 'active': true }
               * ];
               *
               * _.dropWhile(users, function(o) { return !o.active; });
               * // => objects for ['pebbles']
               *
               * // The `_.matches` iteratee shorthand.
               * _.dropWhile(users, { 'user': 'barney', 'active': false });
               * // => objects for ['fred', 'pebbles']
               *
               * // The `_.matchesProperty` iteratee shorthand.
               * _.dropWhile(users, ['active', false]);
               * // => objects for ['pebbles']
               *
               * // The `_.property` iteratee shorthand.
               * _.dropWhile(users, 'active');
               * // => objects for ['barney', 'fred', 'pebbles']
               */


              function dropWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
              }
              /**
               * Fills elements of `array` with `value` from `start` up to, but not
               * including, `end`.
               *
               * **Note:** This method mutates `array`.
               *
               * @static
               * @memberOf _
               * @since 3.2.0
               * @category Array
               * @param {Array} array The array to fill.
               * @param {*} value The value to fill `array` with.
               * @param {number} [start=0] The start position.
               * @param {number} [end=array.length] The end position.
               * @returns {Array} Returns `array`.
               * @example
               *
               * var array = [1, 2, 3];
               *
               * _.fill(array, 'a');
               * console.log(array);
               * // => ['a', 'a', 'a']
               *
               * _.fill(Array(3), 2);
               * // => [2, 2, 2]
               *
               * _.fill([4, 6, 8, 10], '*', 1, 3);
               * // => [4, '*', '*', 10]
               */


              function fill(array, value, start, end) {
                var length = array == null ? 0 : array.length;

                if (!length) {
                  return [];
                }

                if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                  start = 0;
                  end = length;
                }

                return baseFill(array, value, start, end);
              }
              /**
               * This method is like `_.find` except that it returns the index of the first
               * element `predicate` returns truthy for instead of the element itself.
               *
               * @static
               * @memberOf _
               * @since 1.1.0
               * @category Array
               * @param {Array} array The array to inspect.
               * @param {Function} [predicate=_.identity] The function invoked per iteration.
               * @param {number} [fromIndex=0] The index to search from.
               * @returns {number} Returns the index of the found element, else `-1`.
               * @example
               *
               * var users = [
               *   { 'user': 'barney',  'active': false },
               *   { 'user': 'fred',    'active': false },
               *   { 'user': 'pebbles', 'active': true }
               * ];
               *
               * _.findIndex(users, function(o) { return o.user == 'barney'; });
               * // => 0
               *
               * // The `_.matches` iteratee shorthand.
               * _.findIndex(users, { 'user': 'fred', 'active': false });
               * // => 1
               *
               * // The `_.matchesProperty` iteratee shorthand.
               * _.findIndex(users, ['active', false]);
               * // => 0
               *
               * // The `_.property` iteratee shorthand.
               * _.findIndex(users, 'active');
               * // => 2
               */


              function findIndex(array, predicate, fromIndex) {
                var length = array == null ? 0 : array.length;

                if (!length) {
                  return -1;
                }

                var index = fromIndex == null ? 0 : toInteger(fromIndex);

                if (index < 0) {
                  index = nativeMax(length + index, 0);
                }

                return baseFindIndex(array, getIteratee(predicate, 3), index);
              }
              /**
               * This method is like `_.findIndex` except that it iterates over elements
               * of `collection` from right to left.
               *
               * @static
               * @memberOf _
               * @since 2.0.0
               * @category Array
               * @param {Array} array The array to inspect.
               * @param {Function} [predicate=_.identity] The function invoked per iteration.
               * @param {number} [fromIndex=array.length-1] The index to search from.
               * @returns {number} Returns the index of the found element, else `-1`.
               * @example
               *
               * var users = [
               *   { 'user': 'barney',  'active': true },
               *   { 'user': 'fred',    'active': false },
               *   { 'user': 'pebbles', 'active': false }
               * ];
               *
               * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
               * // => 2
               *
               * // The `_.matches` iteratee shorthand.
               * _.findLastIndex(users, { 'user': 'barney', 'active': true });
               * // => 0
               *
               * // The `_.matchesProperty` iteratee shorthand.
               * _.findLastIndex(users, ['active', false]);
               * // => 2
               *
               * // The `_.property` iteratee shorthand.
               * _.findLastIndex(users, 'active');
               * // => 0
               */


              function findLastIndex(array, predicate, fromIndex) {
                var length = array == null ? 0 : array.length;

                if (!length) {
                  return -1;
                }

                var index = length - 1;

                if (fromIndex !== undefined) {
                  index = toInteger(fromIndex);
                  index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
                }

                return baseFindIndex(array, getIteratee(predicate, 3), index, true);
              }
              /**
               * Flattens `array` a single level deep.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Array
               * @param {Array} array The array to flatten.
               * @returns {Array} Returns the new flattened array.
               * @example
               *
               * _.flatten([1, [2, [3, [4]], 5]]);
               * // => [1, 2, [3, [4]], 5]
               */


              function flatten(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseFlatten(array, 1) : [];
              }
              /**
               * Recursively flattens `array`.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Array
               * @param {Array} array The array to flatten.
               * @returns {Array} Returns the new flattened array.
               * @example
               *
               * _.flattenDeep([1, [2, [3, [4]], 5]]);
               * // => [1, 2, 3, 4, 5]
               */


              function flattenDeep(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseFlatten(array, INFINITY) : [];
              }
              /**
               * Recursively flatten `array` up to `depth` times.
               *
               * @static
               * @memberOf _
               * @since 4.4.0
               * @category Array
               * @param {Array} array The array to flatten.
               * @param {number} [depth=1] The maximum recursion depth.
               * @returns {Array} Returns the new flattened array.
               * @example
               *
               * var array = [1, [2, [3, [4]], 5]];
               *
               * _.flattenDepth(array, 1);
               * // => [1, 2, [3, [4]], 5]
               *
               * _.flattenDepth(array, 2);
               * // => [1, 2, 3, [4], 5]
               */


              function flattenDepth(array, depth) {
                var length = array == null ? 0 : array.length;

                if (!length) {
                  return [];
                }

                depth = depth === undefined ? 1 : toInteger(depth);
                return baseFlatten(array, depth);
              }
              /**
               * The inverse of `_.toPairs`; this method returns an object composed
               * from key-value `pairs`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {Array} pairs The key-value pairs.
               * @returns {Object} Returns the new object.
               * @example
               *
               * _.fromPairs([['a', 1], ['b', 2]]);
               * // => { 'a': 1, 'b': 2 }
               */


              function fromPairs(pairs) {
                var index = -1,
                    length = pairs == null ? 0 : pairs.length,
                    result = {};

                while (++index < length) {
                  var pair = pairs[index];
                  result[pair[0]] = pair[1];
                }

                return result;
              }
              /**
               * Gets the first element of `array`.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @alias first
               * @category Array
               * @param {Array} array The array to query.
               * @returns {*} Returns the first element of `array`.
               * @example
               *
               * _.head([1, 2, 3]);
               * // => 1
               *
               * _.head([]);
               * // => undefined
               */


              function head(array) {
                return array && array.length ? array[0] : undefined;
              }
              /**
               * Gets the index at which the first occurrence of `value` is found in `array`
               * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
               * for equality comparisons. If `fromIndex` is negative, it's used as the
               * offset from the end of `array`.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Array
               * @param {Array} array The array to inspect.
               * @param {*} value The value to search for.
               * @param {number} [fromIndex=0] The index to search from.
               * @returns {number} Returns the index of the matched value, else `-1`.
               * @example
               *
               * _.indexOf([1, 2, 1, 2], 2);
               * // => 1
               *
               * // Search from the `fromIndex`.
               * _.indexOf([1, 2, 1, 2], 2, 2);
               * // => 3
               */


              function indexOf(array, value, fromIndex) {
                var length = array == null ? 0 : array.length;

                if (!length) {
                  return -1;
                }

                var index = fromIndex == null ? 0 : toInteger(fromIndex);

                if (index < 0) {
                  index = nativeMax(length + index, 0);
                }

                return baseIndexOf(array, value, index);
              }
              /**
               * Gets all but the last element of `array`.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Array
               * @param {Array} array The array to query.
               * @returns {Array} Returns the slice of `array`.
               * @example
               *
               * _.initial([1, 2, 3]);
               * // => [1, 2]
               */


              function initial(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseSlice(array, 0, -1) : [];
              }
              /**
               * Creates an array of unique values that are included in all given arrays
               * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
               * for equality comparisons. The order and references of result values are
               * determined by the first array.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Array
               * @param {...Array} [arrays] The arrays to inspect.
               * @returns {Array} Returns the new array of intersecting values.
               * @example
               *
               * _.intersection([2, 1], [2, 3]);
               * // => [2]
               */


              var intersection = baseRest(function (arrays) {
                var mapped = arrayMap(arrays, castArrayLikeObject);
                return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
              });
              /**
               * This method is like `_.intersection` except that it accepts `iteratee`
               * which is invoked for each element of each `arrays` to generate the criterion
               * by which they're compared. The order and references of result values are
               * determined by the first array. The iteratee is invoked with one argument:
               * (value).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {...Array} [arrays] The arrays to inspect.
               * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
               * @returns {Array} Returns the new array of intersecting values.
               * @example
               *
               * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
               * // => [2.1]
               *
               * // The `_.property` iteratee shorthand.
               * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
               * // => [{ 'x': 1 }]
               */

              var intersectionBy = baseRest(function (arrays) {
                var iteratee = last(arrays),
                    mapped = arrayMap(arrays, castArrayLikeObject);

                if (iteratee === last(mapped)) {
                  iteratee = undefined;
                } else {
                  mapped.pop();
                }

                return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
              });
              /**
               * This method is like `_.intersection` except that it accepts `comparator`
               * which is invoked to compare elements of `arrays`. The order and references
               * of result values are determined by the first array. The comparator is
               * invoked with two arguments: (arrVal, othVal).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {...Array} [arrays] The arrays to inspect.
               * @param {Function} [comparator] The comparator invoked per element.
               * @returns {Array} Returns the new array of intersecting values.
               * @example
               *
               * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
               * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
               *
               * _.intersectionWith(objects, others, _.isEqual);
               * // => [{ 'x': 1, 'y': 2 }]
               */

              var intersectionWith = baseRest(function (arrays) {
                var comparator = last(arrays),
                    mapped = arrayMap(arrays, castArrayLikeObject);
                comparator = typeof comparator == 'function' ? comparator : undefined;

                if (comparator) {
                  mapped.pop();
                }

                return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
              });
              /**
               * Converts all elements in `array` into a string separated by `separator`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {Array} array The array to convert.
               * @param {string} [separator=','] The element separator.
               * @returns {string} Returns the joined string.
               * @example
               *
               * _.join(['a', 'b', 'c'], '~');
               * // => 'a~b~c'
               */

              function join(array, separator) {
                return array == null ? '' : nativeJoin.call(array, separator);
              }
              /**
               * Gets the last element of `array`.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Array
               * @param {Array} array The array to query.
               * @returns {*} Returns the last element of `array`.
               * @example
               *
               * _.last([1, 2, 3]);
               * // => 3
               */


              function last(array) {
                var length = array == null ? 0 : array.length;
                return length ? array[length - 1] : undefined;
              }
              /**
               * This method is like `_.indexOf` except that it iterates over elements of
               * `array` from right to left.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Array
               * @param {Array} array The array to inspect.
               * @param {*} value The value to search for.
               * @param {number} [fromIndex=array.length-1] The index to search from.
               * @returns {number} Returns the index of the matched value, else `-1`.
               * @example
               *
               * _.lastIndexOf([1, 2, 1, 2], 2);
               * // => 3
               *
               * // Search from the `fromIndex`.
               * _.lastIndexOf([1, 2, 1, 2], 2, 2);
               * // => 1
               */


              function lastIndexOf(array, value, fromIndex) {
                var length = array == null ? 0 : array.length;

                if (!length) {
                  return -1;
                }

                var index = length;

                if (fromIndex !== undefined) {
                  index = toInteger(fromIndex);
                  index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
                }

                return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
              }
              /**
               * Gets the element at index `n` of `array`. If `n` is negative, the nth
               * element from the end is returned.
               *
               * @static
               * @memberOf _
               * @since 4.11.0
               * @category Array
               * @param {Array} array The array to query.
               * @param {number} [n=0] The index of the element to return.
               * @returns {*} Returns the nth element of `array`.
               * @example
               *
               * var array = ['a', 'b', 'c', 'd'];
               *
               * _.nth(array, 1);
               * // => 'b'
               *
               * _.nth(array, -2);
               * // => 'c';
               */


              function nth(array, n) {
                return array && array.length ? baseNth(array, toInteger(n)) : undefined;
              }
              /**
               * Removes all given values from `array` using
               * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
               * for equality comparisons.
               *
               * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
               * to remove elements from an array by predicate.
               *
               * @static
               * @memberOf _
               * @since 2.0.0
               * @category Array
               * @param {Array} array The array to modify.
               * @param {...*} [values] The values to remove.
               * @returns {Array} Returns `array`.
               * @example
               *
               * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
               *
               * _.pull(array, 'a', 'c');
               * console.log(array);
               * // => ['b', 'b']
               */


              var pull = baseRest(pullAll);
              /**
               * This method is like `_.pull` except that it accepts an array of values to remove.
               *
               * **Note:** Unlike `_.difference`, this method mutates `array`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {Array} array The array to modify.
               * @param {Array} values The values to remove.
               * @returns {Array} Returns `array`.
               * @example
               *
               * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
               *
               * _.pullAll(array, ['a', 'c']);
               * console.log(array);
               * // => ['b', 'b']
               */

              function pullAll(array, values) {
                return array && array.length && values && values.length ? basePullAll(array, values) : array;
              }
              /**
               * This method is like `_.pullAll` except that it accepts `iteratee` which is
               * invoked for each element of `array` and `values` to generate the criterion
               * by which they're compared. The iteratee is invoked with one argument: (value).
               *
               * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {Array} array The array to modify.
               * @param {Array} values The values to remove.
               * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
               * @returns {Array} Returns `array`.
               * @example
               *
               * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
               *
               * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
               * console.log(array);
               * // => [{ 'x': 2 }]
               */


              function pullAllBy(array, values, iteratee) {
                return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
              }
              /**
               * This method is like `_.pullAll` except that it accepts `comparator` which
               * is invoked to compare elements of `array` to `values`. The comparator is
               * invoked with two arguments: (arrVal, othVal).
               *
               * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
               *
               * @static
               * @memberOf _
               * @since 4.6.0
               * @category Array
               * @param {Array} array The array to modify.
               * @param {Array} values The values to remove.
               * @param {Function} [comparator] The comparator invoked per element.
               * @returns {Array} Returns `array`.
               * @example
               *
               * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
               *
               * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
               * console.log(array);
               * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
               */


              function pullAllWith(array, values, comparator) {
                return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
              }
              /**
               * Removes elements from `array` corresponding to `indexes` and returns an
               * array of removed elements.
               *
               * **Note:** Unlike `_.at`, this method mutates `array`.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Array
               * @param {Array} array The array to modify.
               * @param {...(number|number[])} [indexes] The indexes of elements to remove.
               * @returns {Array} Returns the new array of removed elements.
               * @example
               *
               * var array = ['a', 'b', 'c', 'd'];
               * var pulled = _.pullAt(array, [1, 3]);
               *
               * console.log(array);
               * // => ['a', 'c']
               *
               * console.log(pulled);
               * // => ['b', 'd']
               */


              var pullAt = flatRest(function (array, indexes) {
                var length = array == null ? 0 : array.length,
                    result = baseAt(array, indexes);
                basePullAt(array, arrayMap(indexes, function (index) {
                  return isIndex(index, length) ? +index : index;
                }).sort(compareAscending));
                return result;
              });
              /**
               * Removes all elements from `array` that `predicate` returns truthy for
               * and returns an array of the removed elements. The predicate is invoked
               * with three arguments: (value, index, array).
               *
               * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
               * to pull elements from an array by value.
               *
               * @static
               * @memberOf _
               * @since 2.0.0
               * @category Array
               * @param {Array} array The array to modify.
               * @param {Function} [predicate=_.identity] The function invoked per iteration.
               * @returns {Array} Returns the new array of removed elements.
               * @example
               *
               * var array = [1, 2, 3, 4];
               * var evens = _.remove(array, function(n) {
               *   return n % 2 == 0;
               * });
               *
               * console.log(array);
               * // => [1, 3]
               *
               * console.log(evens);
               * // => [2, 4]
               */

              function remove(array, predicate) {
                var result = [];

                if (!(array && array.length)) {
                  return result;
                }

                var index = -1,
                    indexes = [],
                    length = array.length;
                predicate = getIteratee(predicate, 3);

                while (++index < length) {
                  var value = array[index];

                  if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                  }
                }

                basePullAt(array, indexes);
                return result;
              }
              /**
               * Reverses `array` so that the first element becomes the last, the second
               * element becomes the second to last, and so on.
               *
               * **Note:** This method mutates `array` and is based on
               * [`Array#reverse`](https://mdn.io/Array/reverse).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {Array} array The array to modify.
               * @returns {Array} Returns `array`.
               * @example
               *
               * var array = [1, 2, 3];
               *
               * _.reverse(array);
               * // => [3, 2, 1]
               *
               * console.log(array);
               * // => [3, 2, 1]
               */


              function reverse(array) {
                return array == null ? array : nativeReverse.call(array);
              }
              /**
               * Creates a slice of `array` from `start` up to, but not including, `end`.
               *
               * **Note:** This method is used instead of
               * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
               * returned.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Array
               * @param {Array} array The array to slice.
               * @param {number} [start=0] The start position.
               * @param {number} [end=array.length] The end position.
               * @returns {Array} Returns the slice of `array`.
               */


              function slice(array, start, end) {
                var length = array == null ? 0 : array.length;

                if (!length) {
                  return [];
                }

                if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                  start = 0;
                  end = length;
                } else {
                  start = start == null ? 0 : toInteger(start);
                  end = end === undefined ? length : toInteger(end);
                }

                return baseSlice(array, start, end);
              }
              /**
               * Uses a binary search to determine the lowest index at which `value`
               * should be inserted into `array` in order to maintain its sort order.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Array
               * @param {Array} array The sorted array to inspect.
               * @param {*} value The value to evaluate.
               * @returns {number} Returns the index at which `value` should be inserted
               *  into `array`.
               * @example
               *
               * _.sortedIndex([30, 50], 40);
               * // => 1
               */


              function sortedIndex(array, value) {
                return baseSortedIndex(array, value);
              }
              /**
               * This method is like `_.sortedIndex` except that it accepts `iteratee`
               * which is invoked for `value` and each element of `array` to compute their
               * sort ranking. The iteratee is invoked with one argument: (value).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {Array} array The sorted array to inspect.
               * @param {*} value The value to evaluate.
               * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
               * @returns {number} Returns the index at which `value` should be inserted
               *  into `array`.
               * @example
               *
               * var objects = [{ 'x': 4 }, { 'x': 5 }];
               *
               * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
               * // => 0
               *
               * // The `_.property` iteratee shorthand.
               * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
               * // => 0
               */


              function sortedIndexBy(array, value, iteratee) {
                return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
              }
              /**
               * This method is like `_.indexOf` except that it performs a binary
               * search on a sorted `array`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {Array} array The array to inspect.
               * @param {*} value The value to search for.
               * @returns {number} Returns the index of the matched value, else `-1`.
               * @example
               *
               * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
               * // => 1
               */


              function sortedIndexOf(array, value) {
                var length = array == null ? 0 : array.length;

                if (length) {
                  var index = baseSortedIndex(array, value);

                  if (index < length && eq(array[index], value)) {
                    return index;
                  }
                }

                return -1;
              }
              /**
               * This method is like `_.sortedIndex` except that it returns the highest
               * index at which `value` should be inserted into `array` in order to
               * maintain its sort order.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Array
               * @param {Array} array The sorted array to inspect.
               * @param {*} value The value to evaluate.
               * @returns {number} Returns the index at which `value` should be inserted
               *  into `array`.
               * @example
               *
               * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
               * // => 4
               */


              function sortedLastIndex(array, value) {
                return baseSortedIndex(array, value, true);
              }
              /**
               * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
               * which is invoked for `value` and each element of `array` to compute their
               * sort ranking. The iteratee is invoked with one argument: (value).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {Array} array The sorted array to inspect.
               * @param {*} value The value to evaluate.
               * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
               * @returns {number} Returns the index at which `value` should be inserted
               *  into `array`.
               * @example
               *
               * var objects = [{ 'x': 4 }, { 'x': 5 }];
               *
               * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
               * // => 1
               *
               * // The `_.property` iteratee shorthand.
               * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
               * // => 1
               */


              function sortedLastIndexBy(array, value, iteratee) {
                return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
              }
              /**
               * This method is like `_.lastIndexOf` except that it performs a binary
               * search on a sorted `array`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {Array} array The array to inspect.
               * @param {*} value The value to search for.
               * @returns {number} Returns the index of the matched value, else `-1`.
               * @example
               *
               * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
               * // => 3
               */


              function sortedLastIndexOf(array, value) {
                var length = array == null ? 0 : array.length;

                if (length) {
                  var index = baseSortedIndex(array, value, true) - 1;

                  if (eq(array[index], value)) {
                    return index;
                  }
                }

                return -1;
              }
              /**
               * This method is like `_.uniq` except that it's designed and optimized
               * for sorted arrays.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {Array} array The array to inspect.
               * @returns {Array} Returns the new duplicate free array.
               * @example
               *
               * _.sortedUniq([1, 1, 2]);
               * // => [1, 2]
               */


              function sortedUniq(array) {
                return array && array.length ? baseSortedUniq(array) : [];
              }
              /**
               * This method is like `_.uniqBy` except that it's designed and optimized
               * for sorted arrays.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {Array} array The array to inspect.
               * @param {Function} [iteratee] The iteratee invoked per element.
               * @returns {Array} Returns the new duplicate free array.
               * @example
               *
               * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
               * // => [1.1, 2.3]
               */


              function sortedUniqBy(array, iteratee) {
                return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
              }
              /**
               * Gets all but the first element of `array`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {Array} array The array to query.
               * @returns {Array} Returns the slice of `array`.
               * @example
               *
               * _.tail([1, 2, 3]);
               * // => [2, 3]
               */


              function tail(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseSlice(array, 1, length) : [];
              }
              /**
               * Creates a slice of `array` with `n` elements taken from the beginning.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Array
               * @param {Array} array The array to query.
               * @param {number} [n=1] The number of elements to take.
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
               * @returns {Array} Returns the slice of `array`.
               * @example
               *
               * _.take([1, 2, 3]);
               * // => [1]
               *
               * _.take([1, 2, 3], 2);
               * // => [1, 2]
               *
               * _.take([1, 2, 3], 5);
               * // => [1, 2, 3]
               *
               * _.take([1, 2, 3], 0);
               * // => []
               */


              function take(array, n, guard) {
                if (!(array && array.length)) {
                  return [];
                }

                n = guard || n === undefined ? 1 : toInteger(n);
                return baseSlice(array, 0, n < 0 ? 0 : n);
              }
              /**
               * Creates a slice of `array` with `n` elements taken from the end.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Array
               * @param {Array} array The array to query.
               * @param {number} [n=1] The number of elements to take.
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
               * @returns {Array} Returns the slice of `array`.
               * @example
               *
               * _.takeRight([1, 2, 3]);
               * // => [3]
               *
               * _.takeRight([1, 2, 3], 2);
               * // => [2, 3]
               *
               * _.takeRight([1, 2, 3], 5);
               * // => [1, 2, 3]
               *
               * _.takeRight([1, 2, 3], 0);
               * // => []
               */


              function takeRight(array, n, guard) {
                var length = array == null ? 0 : array.length;

                if (!length) {
                  return [];
                }

                n = guard || n === undefined ? 1 : toInteger(n);
                n = length - n;
                return baseSlice(array, n < 0 ? 0 : n, length);
              }
              /**
               * Creates a slice of `array` with elements taken from the end. Elements are
               * taken until `predicate` returns falsey. The predicate is invoked with
               * three arguments: (value, index, array).
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Array
               * @param {Array} array The array to query.
               * @param {Function} [predicate=_.identity] The function invoked per iteration.
               * @returns {Array} Returns the slice of `array`.
               * @example
               *
               * var users = [
               *   { 'user': 'barney',  'active': true },
               *   { 'user': 'fred',    'active': false },
               *   { 'user': 'pebbles', 'active': false }
               * ];
               *
               * _.takeRightWhile(users, function(o) { return !o.active; });
               * // => objects for ['fred', 'pebbles']
               *
               * // The `_.matches` iteratee shorthand.
               * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
               * // => objects for ['pebbles']
               *
               * // The `_.matchesProperty` iteratee shorthand.
               * _.takeRightWhile(users, ['active', false]);
               * // => objects for ['fred', 'pebbles']
               *
               * // The `_.property` iteratee shorthand.
               * _.takeRightWhile(users, 'active');
               * // => []
               */


              function takeRightWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
              }
              /**
               * Creates a slice of `array` with elements taken from the beginning. Elements
               * are taken until `predicate` returns falsey. The predicate is invoked with
               * three arguments: (value, index, array).
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Array
               * @param {Array} array The array to query.
               * @param {Function} [predicate=_.identity] The function invoked per iteration.
               * @returns {Array} Returns the slice of `array`.
               * @example
               *
               * var users = [
               *   { 'user': 'barney',  'active': false },
               *   { 'user': 'fred',    'active': false },
               *   { 'user': 'pebbles', 'active': true }
               * ];
               *
               * _.takeWhile(users, function(o) { return !o.active; });
               * // => objects for ['barney', 'fred']
               *
               * // The `_.matches` iteratee shorthand.
               * _.takeWhile(users, { 'user': 'barney', 'active': false });
               * // => objects for ['barney']
               *
               * // The `_.matchesProperty` iteratee shorthand.
               * _.takeWhile(users, ['active', false]);
               * // => objects for ['barney', 'fred']
               *
               * // The `_.property` iteratee shorthand.
               * _.takeWhile(users, 'active');
               * // => []
               */


              function takeWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
              }
              /**
               * Creates an array of unique values, in order, from all given arrays using
               * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
               * for equality comparisons.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Array
               * @param {...Array} [arrays] The arrays to inspect.
               * @returns {Array} Returns the new array of combined values.
               * @example
               *
               * _.union([2], [1, 2]);
               * // => [2, 1]
               */


              var union = baseRest(function (arrays) {
                return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
              });
              /**
               * This method is like `_.union` except that it accepts `iteratee` which is
               * invoked for each element of each `arrays` to generate the criterion by
               * which uniqueness is computed. Result values are chosen from the first
               * array in which the value occurs. The iteratee is invoked with one argument:
               * (value).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {...Array} [arrays] The arrays to inspect.
               * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
               * @returns {Array} Returns the new array of combined values.
               * @example
               *
               * _.unionBy([2.1], [1.2, 2.3], Math.floor);
               * // => [2.1, 1.2]
               *
               * // The `_.property` iteratee shorthand.
               * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
               * // => [{ 'x': 1 }, { 'x': 2 }]
               */

              var unionBy = baseRest(function (arrays) {
                var iteratee = last(arrays);

                if (isArrayLikeObject(iteratee)) {
                  iteratee = undefined;
                }

                return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
              });
              /**
               * This method is like `_.union` except that it accepts `comparator` which
               * is invoked to compare elements of `arrays`. Result values are chosen from
               * the first array in which the value occurs. The comparator is invoked
               * with two arguments: (arrVal, othVal).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {...Array} [arrays] The arrays to inspect.
               * @param {Function} [comparator] The comparator invoked per element.
               * @returns {Array} Returns the new array of combined values.
               * @example
               *
               * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
               * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
               *
               * _.unionWith(objects, others, _.isEqual);
               * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
               */

              var unionWith = baseRest(function (arrays) {
                var comparator = last(arrays);
                comparator = typeof comparator == 'function' ? comparator : undefined;
                return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
              });
              /**
               * Creates a duplicate-free version of an array, using
               * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
               * for equality comparisons, in which only the first occurrence of each element
               * is kept. The order of result values is determined by the order they occur
               * in the array.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Array
               * @param {Array} array The array to inspect.
               * @returns {Array} Returns the new duplicate free array.
               * @example
               *
               * _.uniq([2, 1, 2]);
               * // => [2, 1]
               */

              function uniq(array) {
                return array && array.length ? baseUniq(array) : [];
              }
              /**
               * This method is like `_.uniq` except that it accepts `iteratee` which is
               * invoked for each element in `array` to generate the criterion by which
               * uniqueness is computed. The order of result values is determined by the
               * order they occur in the array. The iteratee is invoked with one argument:
               * (value).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {Array} array The array to inspect.
               * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
               * @returns {Array} Returns the new duplicate free array.
               * @example
               *
               * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
               * // => [2.1, 1.2]
               *
               * // The `_.property` iteratee shorthand.
               * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
               * // => [{ 'x': 1 }, { 'x': 2 }]
               */


              function uniqBy(array, iteratee) {
                return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
              }
              /**
               * This method is like `_.uniq` except that it accepts `comparator` which
               * is invoked to compare elements of `array`. The order of result values is
               * determined by the order they occur in the array.The comparator is invoked
               * with two arguments: (arrVal, othVal).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {Array} array The array to inspect.
               * @param {Function} [comparator] The comparator invoked per element.
               * @returns {Array} Returns the new duplicate free array.
               * @example
               *
               * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
               *
               * _.uniqWith(objects, _.isEqual);
               * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
               */


              function uniqWith(array, comparator) {
                comparator = typeof comparator == 'function' ? comparator : undefined;
                return array && array.length ? baseUniq(array, undefined, comparator) : [];
              }
              /**
               * This method is like `_.zip` except that it accepts an array of grouped
               * elements and creates an array regrouping the elements to their pre-zip
               * configuration.
               *
               * @static
               * @memberOf _
               * @since 1.2.0
               * @category Array
               * @param {Array} array The array of grouped elements to process.
               * @returns {Array} Returns the new array of regrouped elements.
               * @example
               *
               * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
               * // => [['a', 1, true], ['b', 2, false]]
               *
               * _.unzip(zipped);
               * // => [['a', 'b'], [1, 2], [true, false]]
               */


              function unzip(array) {
                if (!(array && array.length)) {
                  return [];
                }

                var length = 0;
                array = arrayFilter(array, function (group) {
                  if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                  }
                });
                return baseTimes(length, function (index) {
                  return arrayMap(array, baseProperty(index));
                });
              }
              /**
               * This method is like `_.unzip` except that it accepts `iteratee` to specify
               * how regrouped values should be combined. The iteratee is invoked with the
               * elements of each group: (...group).
               *
               * @static
               * @memberOf _
               * @since 3.8.0
               * @category Array
               * @param {Array} array The array of grouped elements to process.
               * @param {Function} [iteratee=_.identity] The function to combine
               *  regrouped values.
               * @returns {Array} Returns the new array of regrouped elements.
               * @example
               *
               * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
               * // => [[1, 10, 100], [2, 20, 200]]
               *
               * _.unzipWith(zipped, _.add);
               * // => [3, 30, 300]
               */


              function unzipWith(array, iteratee) {
                if (!(array && array.length)) {
                  return [];
                }

                var result = unzip(array);

                if (iteratee == null) {
                  return result;
                }

                return arrayMap(result, function (group) {
                  return apply(iteratee, undefined, group);
                });
              }
              /**
               * Creates an array excluding all given values using
               * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
               * for equality comparisons.
               *
               * **Note:** Unlike `_.pull`, this method returns a new array.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Array
               * @param {Array} array The array to inspect.
               * @param {...*} [values] The values to exclude.
               * @returns {Array} Returns the new array of filtered values.
               * @see _.difference, _.xor
               * @example
               *
               * _.without([2, 1, 2, 3], 1, 2);
               * // => [3]
               */


              var without = baseRest(function (array, values) {
                return isArrayLikeObject(array) ? baseDifference(array, values) : [];
              });
              /**
               * Creates an array of unique values that is the
               * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
               * of the given arrays. The order of result values is determined by the order
               * they occur in the arrays.
               *
               * @static
               * @memberOf _
               * @since 2.4.0
               * @category Array
               * @param {...Array} [arrays] The arrays to inspect.
               * @returns {Array} Returns the new array of filtered values.
               * @see _.difference, _.without
               * @example
               *
               * _.xor([2, 1], [2, 3]);
               * // => [1, 3]
               */

              var xor = baseRest(function (arrays) {
                return baseXor(arrayFilter(arrays, isArrayLikeObject));
              });
              /**
               * This method is like `_.xor` except that it accepts `iteratee` which is
               * invoked for each element of each `arrays` to generate the criterion by
               * which by which they're compared. The order of result values is determined
               * by the order they occur in the arrays. The iteratee is invoked with one
               * argument: (value).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {...Array} [arrays] The arrays to inspect.
               * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
               * @returns {Array} Returns the new array of filtered values.
               * @example
               *
               * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
               * // => [1.2, 3.4]
               *
               * // The `_.property` iteratee shorthand.
               * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
               * // => [{ 'x': 2 }]
               */

              var xorBy = baseRest(function (arrays) {
                var iteratee = last(arrays);

                if (isArrayLikeObject(iteratee)) {
                  iteratee = undefined;
                }

                return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
              });
              /**
               * This method is like `_.xor` except that it accepts `comparator` which is
               * invoked to compare elements of `arrays`. The order of result values is
               * determined by the order they occur in the arrays. The comparator is invoked
               * with two arguments: (arrVal, othVal).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Array
               * @param {...Array} [arrays] The arrays to inspect.
               * @param {Function} [comparator] The comparator invoked per element.
               * @returns {Array} Returns the new array of filtered values.
               * @example
               *
               * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
               * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
               *
               * _.xorWith(objects, others, _.isEqual);
               * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
               */

              var xorWith = baseRest(function (arrays) {
                var comparator = last(arrays);
                comparator = typeof comparator == 'function' ? comparator : undefined;
                return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
              });
              /**
               * Creates an array of grouped elements, the first of which contains the
               * first elements of the given arrays, the second of which contains the
               * second elements of the given arrays, and so on.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Array
               * @param {...Array} [arrays] The arrays to process.
               * @returns {Array} Returns the new array of grouped elements.
               * @example
               *
               * _.zip(['a', 'b'], [1, 2], [true, false]);
               * // => [['a', 1, true], ['b', 2, false]]
               */

              var zip = baseRest(unzip);
              /**
               * This method is like `_.fromPairs` except that it accepts two arrays,
               * one of property identifiers and one of corresponding values.
               *
               * @static
               * @memberOf _
               * @since 0.4.0
               * @category Array
               * @param {Array} [props=[]] The property identifiers.
               * @param {Array} [values=[]] The property values.
               * @returns {Object} Returns the new object.
               * @example
               *
               * _.zipObject(['a', 'b'], [1, 2]);
               * // => { 'a': 1, 'b': 2 }
               */

              function zipObject(props, values) {
                return baseZipObject(props || [], values || [], assignValue);
              }
              /**
               * This method is like `_.zipObject` except that it supports property paths.
               *
               * @static
               * @memberOf _
               * @since 4.1.0
               * @category Array
               * @param {Array} [props=[]] The property identifiers.
               * @param {Array} [values=[]] The property values.
               * @returns {Object} Returns the new object.
               * @example
               *
               * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
               * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
               */


              function zipObjectDeep(props, values) {
                return baseZipObject(props || [], values || [], baseSet);
              }
              /**
               * This method is like `_.zip` except that it accepts `iteratee` to specify
               * how grouped values should be combined. The iteratee is invoked with the
               * elements of each group: (...group).
               *
               * @static
               * @memberOf _
               * @since 3.8.0
               * @category Array
               * @param {...Array} [arrays] The arrays to process.
               * @param {Function} [iteratee=_.identity] The function to combine
               *  grouped values.
               * @returns {Array} Returns the new array of grouped elements.
               * @example
               *
               * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
               *   return a + b + c;
               * });
               * // => [111, 222]
               */


              var zipWith = baseRest(function (arrays) {
                var length = arrays.length,
                    iteratee = length > 1 ? arrays[length - 1] : undefined;
                iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
                return unzipWith(arrays, iteratee);
              });
              /*------------------------------------------------------------------------*/

              /**
               * Creates a `lodash` wrapper instance that wraps `value` with explicit method
               * chain sequences enabled. The result of such sequences must be unwrapped
               * with `_#value`.
               *
               * @static
               * @memberOf _
               * @since 1.3.0
               * @category Seq
               * @param {*} value The value to wrap.
               * @returns {Object} Returns the new `lodash` wrapper instance.
               * @example
               *
               * var users = [
               *   { 'user': 'barney',  'age': 36 },
               *   { 'user': 'fred',    'age': 40 },
               *   { 'user': 'pebbles', 'age': 1 }
               * ];
               *
               * var youngest = _
               *   .chain(users)
               *   .sortBy('age')
               *   .map(function(o) {
               *     return o.user + ' is ' + o.age;
               *   })
               *   .head()
               *   .value();
               * // => 'pebbles is 1'
               */

              function chain(value) {
                var result = lodash(value);
                result.__chain__ = true;
                return result;
              }
              /**
               * This method invokes `interceptor` and returns `value`. The interceptor
               * is invoked with one argument; (value). The purpose of this method is to
               * "tap into" a method chain sequence in order to modify intermediate results.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Seq
               * @param {*} value The value to provide to `interceptor`.
               * @param {Function} interceptor The function to invoke.
               * @returns {*} Returns `value`.
               * @example
               *
               * _([1, 2, 3])
               *  .tap(function(array) {
               *    // Mutate input array.
               *    array.pop();
               *  })
               *  .reverse()
               *  .value();
               * // => [2, 1]
               */


              function tap(value, interceptor) {
                interceptor(value);
                return value;
              }
              /**
               * This method is like `_.tap` except that it returns the result of `interceptor`.
               * The purpose of this method is to "pass thru" values replacing intermediate
               * results in a method chain sequence.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Seq
               * @param {*} value The value to provide to `interceptor`.
               * @param {Function} interceptor The function to invoke.
               * @returns {*} Returns the result of `interceptor`.
               * @example
               *
               * _('  abc  ')
               *  .chain()
               *  .trim()
               *  .thru(function(value) {
               *    return [value];
               *  })
               *  .value();
               * // => ['abc']
               */


              function thru(value, interceptor) {
                return interceptor(value);
              }
              /**
               * This method is the wrapper version of `_.at`.
               *
               * @name at
               * @memberOf _
               * @since 1.0.0
               * @category Seq
               * @param {...(string|string[])} [paths] The property paths to pick.
               * @returns {Object} Returns the new `lodash` wrapper instance.
               * @example
               *
               * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
               *
               * _(object).at(['a[0].b.c', 'a[1]']).value();
               * // => [3, 4]
               */


              var wrapperAt = flatRest(function (paths) {
                var length = paths.length,
                    start = length ? paths[0] : 0,
                    value = this.__wrapped__,
                    interceptor = function interceptor(object) {
                  return baseAt(object, paths);
                };

                if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
                  return this.thru(interceptor);
                }

                value = value.slice(start, +start + (length ? 1 : 0));

                value.__actions__.push({
                  'func': thru,
                  'args': [interceptor],
                  'thisArg': undefined
                });

                return new LodashWrapper(value, this.__chain__).thru(function (array) {
                  if (length && !array.length) {
                    array.push(undefined);
                  }

                  return array;
                });
              });
              /**
               * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
               *
               * @name chain
               * @memberOf _
               * @since 0.1.0
               * @category Seq
               * @returns {Object} Returns the new `lodash` wrapper instance.
               * @example
               *
               * var users = [
               *   { 'user': 'barney', 'age': 36 },
               *   { 'user': 'fred',   'age': 40 }
               * ];
               *
               * // A sequence without explicit chaining.
               * _(users).head();
               * // => { 'user': 'barney', 'age': 36 }
               *
               * // A sequence with explicit chaining.
               * _(users)
               *   .chain()
               *   .head()
               *   .pick('user')
               *   .value();
               * // => { 'user': 'barney' }
               */

              function wrapperChain() {
                return chain(this);
              }
              /**
               * Executes the chain sequence and returns the wrapped result.
               *
               * @name commit
               * @memberOf _
               * @since 3.2.0
               * @category Seq
               * @returns {Object} Returns the new `lodash` wrapper instance.
               * @example
               *
               * var array = [1, 2];
               * var wrapped = _(array).push(3);
               *
               * console.log(array);
               * // => [1, 2]
               *
               * wrapped = wrapped.commit();
               * console.log(array);
               * // => [1, 2, 3]
               *
               * wrapped.last();
               * // => 3
               *
               * console.log(array);
               * // => [1, 2, 3]
               */


              function wrapperCommit() {
                return new LodashWrapper(this.value(), this.__chain__);
              }
              /**
               * Gets the next value on a wrapped object following the
               * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
               *
               * @name next
               * @memberOf _
               * @since 4.0.0
               * @category Seq
               * @returns {Object} Returns the next iterator value.
               * @example
               *
               * var wrapped = _([1, 2]);
               *
               * wrapped.next();
               * // => { 'done': false, 'value': 1 }
               *
               * wrapped.next();
               * // => { 'done': false, 'value': 2 }
               *
               * wrapped.next();
               * // => { 'done': true, 'value': undefined }
               */


              function wrapperNext() {
                if (this.__values__ === undefined) {
                  this.__values__ = toArray(this.value());
                }

                var done = this.__index__ >= this.__values__.length,
                    value = done ? undefined : this.__values__[this.__index__++];
                return {
                  'done': done,
                  'value': value
                };
              }
              /**
               * Enables the wrapper to be iterable.
               *
               * @name Symbol.iterator
               * @memberOf _
               * @since 4.0.0
               * @category Seq
               * @returns {Object} Returns the wrapper object.
               * @example
               *
               * var wrapped = _([1, 2]);
               *
               * wrapped[Symbol.iterator]() === wrapped;
               * // => true
               *
               * Array.from(wrapped);
               * // => [1, 2]
               */


              function wrapperToIterator() {
                return this;
              }
              /**
               * Creates a clone of the chain sequence planting `value` as the wrapped value.
               *
               * @name plant
               * @memberOf _
               * @since 3.2.0
               * @category Seq
               * @param {*} value The value to plant.
               * @returns {Object} Returns the new `lodash` wrapper instance.
               * @example
               *
               * function square(n) {
               *   return n * n;
               * }
               *
               * var wrapped = _([1, 2]).map(square);
               * var other = wrapped.plant([3, 4]);
               *
               * other.value();
               * // => [9, 16]
               *
               * wrapped.value();
               * // => [1, 4]
               */


              function wrapperPlant(value) {
                var result,
                    parent = this;

                while (parent instanceof baseLodash) {
                  var clone = wrapperClone(parent);
                  clone.__index__ = 0;
                  clone.__values__ = undefined;

                  if (result) {
                    previous.__wrapped__ = clone;
                  } else {
                    result = clone;
                  }

                  var previous = clone;
                  parent = parent.__wrapped__;
                }

                previous.__wrapped__ = value;
                return result;
              }
              /**
               * This method is the wrapper version of `_.reverse`.
               *
               * **Note:** This method mutates the wrapped array.
               *
               * @name reverse
               * @memberOf _
               * @since 0.1.0
               * @category Seq
               * @returns {Object} Returns the new `lodash` wrapper instance.
               * @example
               *
               * var array = [1, 2, 3];
               *
               * _(array).reverse().value()
               * // => [3, 2, 1]
               *
               * console.log(array);
               * // => [3, 2, 1]
               */


              function wrapperReverse() {
                var value = this.__wrapped__;

                if (value instanceof LazyWrapper) {
                  var wrapped = value;

                  if (this.__actions__.length) {
                    wrapped = new LazyWrapper(this);
                  }

                  wrapped = wrapped.reverse();

                  wrapped.__actions__.push({
                    'func': thru,
                    'args': [reverse],
                    'thisArg': undefined
                  });

                  return new LodashWrapper(wrapped, this.__chain__);
                }

                return this.thru(reverse);
              }
              /**
               * Executes the chain sequence to resolve the unwrapped value.
               *
               * @name value
               * @memberOf _
               * @since 0.1.0
               * @alias toJSON, valueOf
               * @category Seq
               * @returns {*} Returns the resolved unwrapped value.
               * @example
               *
               * _([1, 2, 3]).value();
               * // => [1, 2, 3]
               */


              function wrapperValue() {
                return baseWrapperValue(this.__wrapped__, this.__actions__);
              }
              /*------------------------------------------------------------------------*/

              /**
               * Creates an object composed of keys generated from the results of running
               * each element of `collection` thru `iteratee`. The corresponding value of
               * each key is the number of times the key was returned by `iteratee`. The
               * iteratee is invoked with one argument: (value).
               *
               * @static
               * @memberOf _
               * @since 0.5.0
               * @category Collection
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
               * @returns {Object} Returns the composed aggregate object.
               * @example
               *
               * _.countBy([6.1, 4.2, 6.3], Math.floor);
               * // => { '4': 1, '6': 2 }
               *
               * // The `_.property` iteratee shorthand.
               * _.countBy(['one', 'two', 'three'], 'length');
               * // => { '3': 2, '5': 1 }
               */


              var countBy = createAggregator(function (result, value, key) {
                if (hasOwnProperty.call(result, key)) {
                  ++result[key];
                } else {
                  baseAssignValue(result, key, 1);
                }
              });
              /**
               * Checks if `predicate` returns truthy for **all** elements of `collection`.
               * Iteration is stopped once `predicate` returns falsey. The predicate is
               * invoked with three arguments: (value, index|key, collection).
               *
               * **Note:** This method returns `true` for
               * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
               * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
               * elements of empty collections.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Collection
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} [predicate=_.identity] The function invoked per iteration.
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
               * @returns {boolean} Returns `true` if all elements pass the predicate check,
               *  else `false`.
               * @example
               *
               * _.every([true, 1, null, 'yes'], Boolean);
               * // => false
               *
               * var users = [
               *   { 'user': 'barney', 'age': 36, 'active': false },
               *   { 'user': 'fred',   'age': 40, 'active': false }
               * ];
               *
               * // The `_.matches` iteratee shorthand.
               * _.every(users, { 'user': 'barney', 'active': false });
               * // => false
               *
               * // The `_.matchesProperty` iteratee shorthand.
               * _.every(users, ['active', false]);
               * // => true
               *
               * // The `_.property` iteratee shorthand.
               * _.every(users, 'active');
               * // => false
               */

              function every(collection, predicate, guard) {
                var func = isArray(collection) ? arrayEvery : baseEvery;

                if (guard && isIterateeCall(collection, predicate, guard)) {
                  predicate = undefined;
                }

                return func(collection, getIteratee(predicate, 3));
              }
              /**
               * Iterates over elements of `collection`, returning an array of all elements
               * `predicate` returns truthy for. The predicate is invoked with three
               * arguments: (value, index|key, collection).
               *
               * **Note:** Unlike `_.remove`, this method returns a new array.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Collection
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} [predicate=_.identity] The function invoked per iteration.
               * @returns {Array} Returns the new filtered array.
               * @see _.reject
               * @example
               *
               * var users = [
               *   { 'user': 'barney', 'age': 36, 'active': true },
               *   { 'user': 'fred',   'age': 40, 'active': false }
               * ];
               *
               * _.filter(users, function(o) { return !o.active; });
               * // => objects for ['fred']
               *
               * // The `_.matches` iteratee shorthand.
               * _.filter(users, { 'age': 36, 'active': true });
               * // => objects for ['barney']
               *
               * // The `_.matchesProperty` iteratee shorthand.
               * _.filter(users, ['active', false]);
               * // => objects for ['fred']
               *
               * // The `_.property` iteratee shorthand.
               * _.filter(users, 'active');
               * // => objects for ['barney']
               *
               * // Combining several predicates using `_.overEvery` or `_.overSome`.
               * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
               * // => objects for ['fred', 'barney']
               */


              function filter(collection, predicate) {
                var func = isArray(collection) ? arrayFilter : baseFilter;
                return func(collection, getIteratee(predicate, 3));
              }
              /**
               * Iterates over elements of `collection`, returning the first element
               * `predicate` returns truthy for. The predicate is invoked with three
               * arguments: (value, index|key, collection).
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Collection
               * @param {Array|Object} collection The collection to inspect.
               * @param {Function} [predicate=_.identity] The function invoked per iteration.
               * @param {number} [fromIndex=0] The index to search from.
               * @returns {*} Returns the matched element, else `undefined`.
               * @example
               *
               * var users = [
               *   { 'user': 'barney',  'age': 36, 'active': true },
               *   { 'user': 'fred',    'age': 40, 'active': false },
               *   { 'user': 'pebbles', 'age': 1,  'active': true }
               * ];
               *
               * _.find(users, function(o) { return o.age < 40; });
               * // => object for 'barney'
               *
               * // The `_.matches` iteratee shorthand.
               * _.find(users, { 'age': 1, 'active': true });
               * // => object for 'pebbles'
               *
               * // The `_.matchesProperty` iteratee shorthand.
               * _.find(users, ['active', false]);
               * // => object for 'fred'
               *
               * // The `_.property` iteratee shorthand.
               * _.find(users, 'active');
               * // => object for 'barney'
               */


              var find = createFind(findIndex);
              /**
               * This method is like `_.find` except that it iterates over elements of
               * `collection` from right to left.
               *
               * @static
               * @memberOf _
               * @since 2.0.0
               * @category Collection
               * @param {Array|Object} collection The collection to inspect.
               * @param {Function} [predicate=_.identity] The function invoked per iteration.
               * @param {number} [fromIndex=collection.length-1] The index to search from.
               * @returns {*} Returns the matched element, else `undefined`.
               * @example
               *
               * _.findLast([1, 2, 3, 4], function(n) {
               *   return n % 2 == 1;
               * });
               * // => 3
               */

              var findLast = createFind(findLastIndex);
              /**
               * Creates a flattened array of values by running each element in `collection`
               * thru `iteratee` and flattening the mapped results. The iteratee is invoked
               * with three arguments: (value, index|key, collection).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Collection
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} [iteratee=_.identity] The function invoked per iteration.
               * @returns {Array} Returns the new flattened array.
               * @example
               *
               * function duplicate(n) {
               *   return [n, n];
               * }
               *
               * _.flatMap([1, 2], duplicate);
               * // => [1, 1, 2, 2]
               */

              function flatMap(collection, iteratee) {
                return baseFlatten(map(collection, iteratee), 1);
              }
              /**
               * This method is like `_.flatMap` except that it recursively flattens the
               * mapped results.
               *
               * @static
               * @memberOf _
               * @since 4.7.0
               * @category Collection
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} [iteratee=_.identity] The function invoked per iteration.
               * @returns {Array} Returns the new flattened array.
               * @example
               *
               * function duplicate(n) {
               *   return [[[n, n]]];
               * }
               *
               * _.flatMapDeep([1, 2], duplicate);
               * // => [1, 1, 2, 2]
               */


              function flatMapDeep(collection, iteratee) {
                return baseFlatten(map(collection, iteratee), INFINITY);
              }
              /**
               * This method is like `_.flatMap` except that it recursively flattens the
               * mapped results up to `depth` times.
               *
               * @static
               * @memberOf _
               * @since 4.7.0
               * @category Collection
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} [iteratee=_.identity] The function invoked per iteration.
               * @param {number} [depth=1] The maximum recursion depth.
               * @returns {Array} Returns the new flattened array.
               * @example
               *
               * function duplicate(n) {
               *   return [[[n, n]]];
               * }
               *
               * _.flatMapDepth([1, 2], duplicate, 2);
               * // => [[1, 1], [2, 2]]
               */


              function flatMapDepth(collection, iteratee, depth) {
                depth = depth === undefined ? 1 : toInteger(depth);
                return baseFlatten(map(collection, iteratee), depth);
              }
              /**
               * Iterates over elements of `collection` and invokes `iteratee` for each element.
               * The iteratee is invoked with three arguments: (value, index|key, collection).
               * Iteratee functions may exit iteration early by explicitly returning `false`.
               *
               * **Note:** As with other "Collections" methods, objects with a "length"
               * property are iterated like arrays. To avoid this behavior use `_.forIn`
               * or `_.forOwn` for object iteration.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @alias each
               * @category Collection
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} [iteratee=_.identity] The function invoked per iteration.
               * @returns {Array|Object} Returns `collection`.
               * @see _.forEachRight
               * @example
               *
               * _.forEach([1, 2], function(value) {
               *   console.log(value);
               * });
               * // => Logs `1` then `2`.
               *
               * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
               *   console.log(key);
               * });
               * // => Logs 'a' then 'b' (iteration order is not guaranteed).
               */


              function forEach(collection, iteratee) {
                var func = isArray(collection) ? arrayEach : baseEach;
                return func(collection, getIteratee(iteratee, 3));
              }
              /**
               * This method is like `_.forEach` except that it iterates over elements of
               * `collection` from right to left.
               *
               * @static
               * @memberOf _
               * @since 2.0.0
               * @alias eachRight
               * @category Collection
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} [iteratee=_.identity] The function invoked per iteration.
               * @returns {Array|Object} Returns `collection`.
               * @see _.forEach
               * @example
               *
               * _.forEachRight([1, 2], function(value) {
               *   console.log(value);
               * });
               * // => Logs `2` then `1`.
               */


              function forEachRight(collection, iteratee) {
                var func = isArray(collection) ? arrayEachRight : baseEachRight;
                return func(collection, getIteratee(iteratee, 3));
              }
              /**
               * Creates an object composed of keys generated from the results of running
               * each element of `collection` thru `iteratee`. The order of grouped values
               * is determined by the order they occur in `collection`. The corresponding
               * value of each key is an array of elements responsible for generating the
               * key. The iteratee is invoked with one argument: (value).
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Collection
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
               * @returns {Object} Returns the composed aggregate object.
               * @example
               *
               * _.groupBy([6.1, 4.2, 6.3], Math.floor);
               * // => { '4': [4.2], '6': [6.1, 6.3] }
               *
               * // The `_.property` iteratee shorthand.
               * _.groupBy(['one', 'two', 'three'], 'length');
               * // => { '3': ['one', 'two'], '5': ['three'] }
               */


              var groupBy = createAggregator(function (result, value, key) {
                if (hasOwnProperty.call(result, key)) {
                  result[key].push(value);
                } else {
                  baseAssignValue(result, key, [value]);
                }
              });
              /**
               * Checks if `value` is in `collection`. If `collection` is a string, it's
               * checked for a substring of `value`, otherwise
               * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
               * is used for equality comparisons. If `fromIndex` is negative, it's used as
               * the offset from the end of `collection`.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Collection
               * @param {Array|Object|string} collection The collection to inspect.
               * @param {*} value The value to search for.
               * @param {number} [fromIndex=0] The index to search from.
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
               * @returns {boolean} Returns `true` if `value` is found, else `false`.
               * @example
               *
               * _.includes([1, 2, 3], 1);
               * // => true
               *
               * _.includes([1, 2, 3], 1, 2);
               * // => false
               *
               * _.includes({ 'a': 1, 'b': 2 }, 1);
               * // => true
               *
               * _.includes('abcd', 'bc');
               * // => true
               */

              function includes(collection, value, fromIndex, guard) {
                collection = isArrayLike(collection) ? collection : values(collection);
                fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
                var length = collection.length;

                if (fromIndex < 0) {
                  fromIndex = nativeMax(length + fromIndex, 0);
                }

                return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
              }
              /**
               * Invokes the method at `path` of each element in `collection`, returning
               * an array of the results of each invoked method. Any additional arguments
               * are provided to each invoked method. If `path` is a function, it's invoked
               * for, and `this` bound to, each element in `collection`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Collection
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Array|Function|string} path The path of the method to invoke or
               *  the function invoked per iteration.
               * @param {...*} [args] The arguments to invoke each method with.
               * @returns {Array} Returns the array of results.
               * @example
               *
               * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
               * // => [[1, 5, 7], [1, 2, 3]]
               *
               * _.invokeMap([123, 456], String.prototype.split, '');
               * // => [['1', '2', '3'], ['4', '5', '6']]
               */


              var invokeMap = baseRest(function (collection, path, args) {
                var index = -1,
                    isFunc = typeof path == 'function',
                    result = isArrayLike(collection) ? Array(collection.length) : [];
                baseEach(collection, function (value) {
                  result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
                });
                return result;
              });
              /**
               * Creates an object composed of keys generated from the results of running
               * each element of `collection` thru `iteratee`. The corresponding value of
               * each key is the last element responsible for generating the key. The
               * iteratee is invoked with one argument: (value).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Collection
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
               * @returns {Object} Returns the composed aggregate object.
               * @example
               *
               * var array = [
               *   { 'dir': 'left', 'code': 97 },
               *   { 'dir': 'right', 'code': 100 }
               * ];
               *
               * _.keyBy(array, function(o) {
               *   return String.fromCharCode(o.code);
               * });
               * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
               *
               * _.keyBy(array, 'dir');
               * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
               */

              var keyBy = createAggregator(function (result, value, key) {
                baseAssignValue(result, key, value);
              });
              /**
               * Creates an array of values by running each element in `collection` thru
               * `iteratee`. The iteratee is invoked with three arguments:
               * (value, index|key, collection).
               *
               * Many lodash methods are guarded to work as iteratees for methods like
               * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
               *
               * The guarded methods are:
               * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
               * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
               * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
               * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Collection
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} [iteratee=_.identity] The function invoked per iteration.
               * @returns {Array} Returns the new mapped array.
               * @example
               *
               * function square(n) {
               *   return n * n;
               * }
               *
               * _.map([4, 8], square);
               * // => [16, 64]
               *
               * _.map({ 'a': 4, 'b': 8 }, square);
               * // => [16, 64] (iteration order is not guaranteed)
               *
               * var users = [
               *   { 'user': 'barney' },
               *   { 'user': 'fred' }
               * ];
               *
               * // The `_.property` iteratee shorthand.
               * _.map(users, 'user');
               * // => ['barney', 'fred']
               */

              function map(collection, iteratee) {
                var func = isArray(collection) ? arrayMap : baseMap;
                return func(collection, getIteratee(iteratee, 3));
              }
              /**
               * This method is like `_.sortBy` except that it allows specifying the sort
               * orders of the iteratees to sort by. If `orders` is unspecified, all values
               * are sorted in ascending order. Otherwise, specify an order of "desc" for
               * descending or "asc" for ascending sort order of corresponding values.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Collection
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
               *  The iteratees to sort by.
               * @param {string[]} [orders] The sort orders of `iteratees`.
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
               * @returns {Array} Returns the new sorted array.
               * @example
               *
               * var users = [
               *   { 'user': 'fred',   'age': 48 },
               *   { 'user': 'barney', 'age': 34 },
               *   { 'user': 'fred',   'age': 40 },
               *   { 'user': 'barney', 'age': 36 }
               * ];
               *
               * // Sort by `user` in ascending order and by `age` in descending order.
               * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
               * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
               */


              function orderBy(collection, iteratees, orders, guard) {
                if (collection == null) {
                  return [];
                }

                if (!isArray(iteratees)) {
                  iteratees = iteratees == null ? [] : [iteratees];
                }

                orders = guard ? undefined : orders;

                if (!isArray(orders)) {
                  orders = orders == null ? [] : [orders];
                }

                return baseOrderBy(collection, iteratees, orders);
              }
              /**
               * Creates an array of elements split into two groups, the first of which
               * contains elements `predicate` returns truthy for, the second of which
               * contains elements `predicate` returns falsey for. The predicate is
               * invoked with one argument: (value).
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Collection
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} [predicate=_.identity] The function invoked per iteration.
               * @returns {Array} Returns the array of grouped elements.
               * @example
               *
               * var users = [
               *   { 'user': 'barney',  'age': 36, 'active': false },
               *   { 'user': 'fred',    'age': 40, 'active': true },
               *   { 'user': 'pebbles', 'age': 1,  'active': false }
               * ];
               *
               * _.partition(users, function(o) { return o.active; });
               * // => objects for [['fred'], ['barney', 'pebbles']]
               *
               * // The `_.matches` iteratee shorthand.
               * _.partition(users, { 'age': 1, 'active': false });
               * // => objects for [['pebbles'], ['barney', 'fred']]
               *
               * // The `_.matchesProperty` iteratee shorthand.
               * _.partition(users, ['active', false]);
               * // => objects for [['barney', 'pebbles'], ['fred']]
               *
               * // The `_.property` iteratee shorthand.
               * _.partition(users, 'active');
               * // => objects for [['fred'], ['barney', 'pebbles']]
               */


              var partition = createAggregator(function (result, value, key) {
                result[key ? 0 : 1].push(value);
              }, function () {
                return [[], []];
              });
              /**
               * Reduces `collection` to a value which is the accumulated result of running
               * each element in `collection` thru `iteratee`, where each successive
               * invocation is supplied the return value of the previous. If `accumulator`
               * is not given, the first element of `collection` is used as the initial
               * value. The iteratee is invoked with four arguments:
               * (accumulator, value, index|key, collection).
               *
               * Many lodash methods are guarded to work as iteratees for methods like
               * `_.reduce`, `_.reduceRight`, and `_.transform`.
               *
               * The guarded methods are:
               * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
               * and `sortBy`
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Collection
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} [iteratee=_.identity] The function invoked per iteration.
               * @param {*} [accumulator] The initial value.
               * @returns {*} Returns the accumulated value.
               * @see _.reduceRight
               * @example
               *
               * _.reduce([1, 2], function(sum, n) {
               *   return sum + n;
               * }, 0);
               * // => 3
               *
               * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
               *   (result[value] || (result[value] = [])).push(key);
               *   return result;
               * }, {});
               * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
               */

              function reduce(collection, iteratee, accumulator) {
                var func = isArray(collection) ? arrayReduce : baseReduce,
                    initAccum = arguments.length < 3;
                return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
              }
              /**
               * This method is like `_.reduce` except that it iterates over elements of
               * `collection` from right to left.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Collection
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} [iteratee=_.identity] The function invoked per iteration.
               * @param {*} [accumulator] The initial value.
               * @returns {*} Returns the accumulated value.
               * @see _.reduce
               * @example
               *
               * var array = [[0, 1], [2, 3], [4, 5]];
               *
               * _.reduceRight(array, function(flattened, other) {
               *   return flattened.concat(other);
               * }, []);
               * // => [4, 5, 2, 3, 0, 1]
               */


              function reduceRight(collection, iteratee, accumulator) {
                var func = isArray(collection) ? arrayReduceRight : baseReduce,
                    initAccum = arguments.length < 3;
                return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
              }
              /**
               * The opposite of `_.filter`; this method returns the elements of `collection`
               * that `predicate` does **not** return truthy for.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Collection
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} [predicate=_.identity] The function invoked per iteration.
               * @returns {Array} Returns the new filtered array.
               * @see _.filter
               * @example
               *
               * var users = [
               *   { 'user': 'barney', 'age': 36, 'active': false },
               *   { 'user': 'fred',   'age': 40, 'active': true }
               * ];
               *
               * _.reject(users, function(o) { return !o.active; });
               * // => objects for ['fred']
               *
               * // The `_.matches` iteratee shorthand.
               * _.reject(users, { 'age': 40, 'active': true });
               * // => objects for ['barney']
               *
               * // The `_.matchesProperty` iteratee shorthand.
               * _.reject(users, ['active', false]);
               * // => objects for ['fred']
               *
               * // The `_.property` iteratee shorthand.
               * _.reject(users, 'active');
               * // => objects for ['barney']
               */


              function reject(collection, predicate) {
                var func = isArray(collection) ? arrayFilter : baseFilter;
                return func(collection, negate(getIteratee(predicate, 3)));
              }
              /**
               * Gets a random element from `collection`.
               *
               * @static
               * @memberOf _
               * @since 2.0.0
               * @category Collection
               * @param {Array|Object} collection The collection to sample.
               * @returns {*} Returns the random element.
               * @example
               *
               * _.sample([1, 2, 3, 4]);
               * // => 2
               */


              function sample(collection) {
                var func = isArray(collection) ? arraySample : baseSample;
                return func(collection);
              }
              /**
               * Gets `n` random elements at unique keys from `collection` up to the
               * size of `collection`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Collection
               * @param {Array|Object} collection The collection to sample.
               * @param {number} [n=1] The number of elements to sample.
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
               * @returns {Array} Returns the random elements.
               * @example
               *
               * _.sampleSize([1, 2, 3], 2);
               * // => [3, 1]
               *
               * _.sampleSize([1, 2, 3], 4);
               * // => [2, 3, 1]
               */


              function sampleSize(collection, n, guard) {
                if (guard ? isIterateeCall(collection, n, guard) : n === undefined) {
                  n = 1;
                } else {
                  n = toInteger(n);
                }

                var func = isArray(collection) ? arraySampleSize : baseSampleSize;
                return func(collection, n);
              }
              /**
               * Creates an array of shuffled values, using a version of the
               * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Collection
               * @param {Array|Object} collection The collection to shuffle.
               * @returns {Array} Returns the new shuffled array.
               * @example
               *
               * _.shuffle([1, 2, 3, 4]);
               * // => [4, 1, 3, 2]
               */


              function shuffle(collection) {
                var func = isArray(collection) ? arrayShuffle : baseShuffle;
                return func(collection);
              }
              /**
               * Gets the size of `collection` by returning its length for array-like
               * values or the number of own enumerable string keyed properties for objects.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Collection
               * @param {Array|Object|string} collection The collection to inspect.
               * @returns {number} Returns the collection size.
               * @example
               *
               * _.size([1, 2, 3]);
               * // => 3
               *
               * _.size({ 'a': 1, 'b': 2 });
               * // => 2
               *
               * _.size('pebbles');
               * // => 7
               */


              function size(collection) {
                if (collection == null) {
                  return 0;
                }

                if (isArrayLike(collection)) {
                  return isString(collection) ? stringSize(collection) : collection.length;
                }

                var tag = getTag(collection);

                if (tag == mapTag || tag == setTag) {
                  return collection.size;
                }

                return baseKeys(collection).length;
              }
              /**
               * Checks if `predicate` returns truthy for **any** element of `collection`.
               * Iteration is stopped once `predicate` returns truthy. The predicate is
               * invoked with three arguments: (value, index|key, collection).
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Collection
               * @param {Array|Object} collection The collection to iterate over.
               * @param {Function} [predicate=_.identity] The function invoked per iteration.
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
               * @returns {boolean} Returns `true` if any element passes the predicate check,
               *  else `false`.
               * @example
               *
               * _.some([null, 0, 'yes', false], Boolean);
               * // => true
               *
               * var users = [
               *   { 'user': 'barney', 'active': true },
               *   { 'user': 'fred',   'active': false }
               * ];
               *
               * // The `_.matches` iteratee shorthand.
               * _.some(users, { 'user': 'barney', 'active': false });
               * // => false
               *
               * // The `_.matchesProperty` iteratee shorthand.
               * _.some(users, ['active', false]);
               * // => true
               *
               * // The `_.property` iteratee shorthand.
               * _.some(users, 'active');
               * // => true
               */


              function some(collection, predicate, guard) {
                var func = isArray(collection) ? arraySome : baseSome;

                if (guard && isIterateeCall(collection, predicate, guard)) {
                  predicate = undefined;
                }

                return func(collection, getIteratee(predicate, 3));
              }
              /**
               * Creates an array of elements, sorted in ascending order by the results of
               * running each element in a collection thru each iteratee. This method
               * performs a stable sort, that is, it preserves the original sort order of
               * equal elements. The iteratees are invoked with one argument: (value).
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Collection
               * @param {Array|Object} collection The collection to iterate over.
               * @param {...(Function|Function[])} [iteratees=[_.identity]]
               *  The iteratees to sort by.
               * @returns {Array} Returns the new sorted array.
               * @example
               *
               * var users = [
               *   { 'user': 'fred',   'age': 48 },
               *   { 'user': 'barney', 'age': 36 },
               *   { 'user': 'fred',   'age': 30 },
               *   { 'user': 'barney', 'age': 34 }
               * ];
               *
               * _.sortBy(users, [function(o) { return o.user; }]);
               * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
               *
               * _.sortBy(users, ['user', 'age']);
               * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
               */


              var sortBy = baseRest(function (collection, iteratees) {
                if (collection == null) {
                  return [];
                }

                var length = iteratees.length;

                if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
                  iteratees = [];
                } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
                  iteratees = [iteratees[0]];
                }

                return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
              });
              /*------------------------------------------------------------------------*/

              /**
               * Gets the timestamp of the number of milliseconds that have elapsed since
               * the Unix epoch (1 January 1970 00:00:00 UTC).
               *
               * @static
               * @memberOf _
               * @since 2.4.0
               * @category Date
               * @returns {number} Returns the timestamp.
               * @example
               *
               * _.defer(function(stamp) {
               *   console.log(_.now() - stamp);
               * }, _.now());
               * // => Logs the number of milliseconds it took for the deferred invocation.
               */

              var now = ctxNow || function () {
                return root.Date.now();
              };
              /*------------------------------------------------------------------------*/

              /**
               * The opposite of `_.before`; this method creates a function that invokes
               * `func` once it's called `n` or more times.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Function
               * @param {number} n The number of calls before `func` is invoked.
               * @param {Function} func The function to restrict.
               * @returns {Function} Returns the new restricted function.
               * @example
               *
               * var saves = ['profile', 'settings'];
               *
               * var done = _.after(saves.length, function() {
               *   console.log('done saving!');
               * });
               *
               * _.forEach(saves, function(type) {
               *   asyncSave({ 'type': type, 'complete': done });
               * });
               * // => Logs 'done saving!' after the two async saves have completed.
               */


              function after(n, func) {
                if (typeof func != 'function') {
                  throw new TypeError(FUNC_ERROR_TEXT);
                }

                n = toInteger(n);
                return function () {
                  if (--n < 1) {
                    return func.apply(this, arguments);
                  }
                };
              }
              /**
               * Creates a function that invokes `func`, with up to `n` arguments,
               * ignoring any additional arguments.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Function
               * @param {Function} func The function to cap arguments for.
               * @param {number} [n=func.length] The arity cap.
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
               * @returns {Function} Returns the new capped function.
               * @example
               *
               * _.map(['6', '8', '10'], _.ary(parseInt, 1));
               * // => [6, 8, 10]
               */


              function ary(func, n, guard) {
                n = guard ? undefined : n;
                n = func && n == null ? func.length : n;
                return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
              }
              /**
               * Creates a function that invokes `func`, with the `this` binding and arguments
               * of the created function, while it's called less than `n` times. Subsequent
               * calls to the created function return the result of the last `func` invocation.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Function
               * @param {number} n The number of calls at which `func` is no longer invoked.
               * @param {Function} func The function to restrict.
               * @returns {Function} Returns the new restricted function.
               * @example
               *
               * jQuery(element).on('click', _.before(5, addContactToList));
               * // => Allows adding up to 4 contacts to the list.
               */


              function before(n, func) {
                var result;

                if (typeof func != 'function') {
                  throw new TypeError(FUNC_ERROR_TEXT);
                }

                n = toInteger(n);
                return function () {
                  if (--n > 0) {
                    result = func.apply(this, arguments);
                  }

                  if (n <= 1) {
                    func = undefined;
                  }

                  return result;
                };
              }
              /**
               * Creates a function that invokes `func` with the `this` binding of `thisArg`
               * and `partials` prepended to the arguments it receives.
               *
               * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
               * may be used as a placeholder for partially applied arguments.
               *
               * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
               * property of bound functions.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Function
               * @param {Function} func The function to bind.
               * @param {*} thisArg The `this` binding of `func`.
               * @param {...*} [partials] The arguments to be partially applied.
               * @returns {Function} Returns the new bound function.
               * @example
               *
               * function greet(greeting, punctuation) {
               *   return greeting + ' ' + this.user + punctuation;
               * }
               *
               * var object = { 'user': 'fred' };
               *
               * var bound = _.bind(greet, object, 'hi');
               * bound('!');
               * // => 'hi fred!'
               *
               * // Bound with placeholders.
               * var bound = _.bind(greet, object, _, '!');
               * bound('hi');
               * // => 'hi fred!'
               */


              var bind = baseRest(function (func, thisArg, partials) {
                var bitmask = WRAP_BIND_FLAG;

                if (partials.length) {
                  var holders = replaceHolders(partials, getHolder(bind));
                  bitmask |= WRAP_PARTIAL_FLAG;
                }

                return createWrap(func, bitmask, thisArg, partials, holders);
              });
              /**
               * Creates a function that invokes the method at `object[key]` with `partials`
               * prepended to the arguments it receives.
               *
               * This method differs from `_.bind` by allowing bound functions to reference
               * methods that may be redefined or don't yet exist. See
               * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
               * for more details.
               *
               * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
               * builds, may be used as a placeholder for partially applied arguments.
               *
               * @static
               * @memberOf _
               * @since 0.10.0
               * @category Function
               * @param {Object} object The object to invoke the method on.
               * @param {string} key The key of the method.
               * @param {...*} [partials] The arguments to be partially applied.
               * @returns {Function} Returns the new bound function.
               * @example
               *
               * var object = {
               *   'user': 'fred',
               *   'greet': function(greeting, punctuation) {
               *     return greeting + ' ' + this.user + punctuation;
               *   }
               * };
               *
               * var bound = _.bindKey(object, 'greet', 'hi');
               * bound('!');
               * // => 'hi fred!'
               *
               * object.greet = function(greeting, punctuation) {
               *   return greeting + 'ya ' + this.user + punctuation;
               * };
               *
               * bound('!');
               * // => 'hiya fred!'
               *
               * // Bound with placeholders.
               * var bound = _.bindKey(object, 'greet', _, '!');
               * bound('hi');
               * // => 'hiya fred!'
               */

              var bindKey = baseRest(function (object, key, partials) {
                var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;

                if (partials.length) {
                  var holders = replaceHolders(partials, getHolder(bindKey));
                  bitmask |= WRAP_PARTIAL_FLAG;
                }

                return createWrap(key, bitmask, object, partials, holders);
              });
              /**
               * Creates a function that accepts arguments of `func` and either invokes
               * `func` returning its result, if at least `arity` number of arguments have
               * been provided, or returns a function that accepts the remaining `func`
               * arguments, and so on. The arity of `func` may be specified if `func.length`
               * is not sufficient.
               *
               * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
               * may be used as a placeholder for provided arguments.
               *
               * **Note:** This method doesn't set the "length" property of curried functions.
               *
               * @static
               * @memberOf _
               * @since 2.0.0
               * @category Function
               * @param {Function} func The function to curry.
               * @param {number} [arity=func.length] The arity of `func`.
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
               * @returns {Function} Returns the new curried function.
               * @example
               *
               * var abc = function(a, b, c) {
               *   return [a, b, c];
               * };
               *
               * var curried = _.curry(abc);
               *
               * curried(1)(2)(3);
               * // => [1, 2, 3]
               *
               * curried(1, 2)(3);
               * // => [1, 2, 3]
               *
               * curried(1, 2, 3);
               * // => [1, 2, 3]
               *
               * // Curried with placeholders.
               * curried(1)(_, 3)(2);
               * // => [1, 2, 3]
               */

              function curry(func, arity, guard) {
                arity = guard ? undefined : arity;
                var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
                result.placeholder = curry.placeholder;
                return result;
              }
              /**
               * This method is like `_.curry` except that arguments are applied to `func`
               * in the manner of `_.partialRight` instead of `_.partial`.
               *
               * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
               * builds, may be used as a placeholder for provided arguments.
               *
               * **Note:** This method doesn't set the "length" property of curried functions.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Function
               * @param {Function} func The function to curry.
               * @param {number} [arity=func.length] The arity of `func`.
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
               * @returns {Function} Returns the new curried function.
               * @example
               *
               * var abc = function(a, b, c) {
               *   return [a, b, c];
               * };
               *
               * var curried = _.curryRight(abc);
               *
               * curried(3)(2)(1);
               * // => [1, 2, 3]
               *
               * curried(2, 3)(1);
               * // => [1, 2, 3]
               *
               * curried(1, 2, 3);
               * // => [1, 2, 3]
               *
               * // Curried with placeholders.
               * curried(3)(1, _)(2);
               * // => [1, 2, 3]
               */


              function curryRight(func, arity, guard) {
                arity = guard ? undefined : arity;
                var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
                result.placeholder = curryRight.placeholder;
                return result;
              }
              /**
               * Creates a debounced function that delays invoking `func` until after `wait`
               * milliseconds have elapsed since the last time the debounced function was
               * invoked. The debounced function comes with a `cancel` method to cancel
               * delayed `func` invocations and a `flush` method to immediately invoke them.
               * Provide `options` to indicate whether `func` should be invoked on the
               * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
               * with the last arguments provided to the debounced function. Subsequent
               * calls to the debounced function return the result of the last `func`
               * invocation.
               *
               * **Note:** If `leading` and `trailing` options are `true`, `func` is
               * invoked on the trailing edge of the timeout only if the debounced function
               * is invoked more than once during the `wait` timeout.
               *
               * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
               * until to the next tick, similar to `setTimeout` with a timeout of `0`.
               *
               * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
               * for details over the differences between `_.debounce` and `_.throttle`.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Function
               * @param {Function} func The function to debounce.
               * @param {number} [wait=0] The number of milliseconds to delay.
               * @param {Object} [options={}] The options object.
               * @param {boolean} [options.leading=false]
               *  Specify invoking on the leading edge of the timeout.
               * @param {number} [options.maxWait]
               *  The maximum time `func` is allowed to be delayed before it's invoked.
               * @param {boolean} [options.trailing=true]
               *  Specify invoking on the trailing edge of the timeout.
               * @returns {Function} Returns the new debounced function.
               * @example
               *
               * // Avoid costly calculations while the window size is in flux.
               * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
               *
               * // Invoke `sendMail` when clicked, debouncing subsequent calls.
               * jQuery(element).on('click', _.debounce(sendMail, 300, {
               *   'leading': true,
               *   'trailing': false
               * }));
               *
               * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
               * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
               * var source = new EventSource('/stream');
               * jQuery(source).on('message', debounced);
               *
               * // Cancel the trailing debounced invocation.
               * jQuery(window).on('popstate', debounced.cancel);
               */


              function debounce(func, wait, options) {
                var lastArgs,
                    lastThis,
                    maxWait,
                    result,
                    timerId,
                    lastCallTime,
                    lastInvokeTime = 0,
                    leading = false,
                    maxing = false,
                    trailing = true;

                if (typeof func != 'function') {
                  throw new TypeError(FUNC_ERROR_TEXT);
                }

                wait = toNumber(wait) || 0;

                if (isObject(options)) {
                  leading = !!options.leading;
                  maxing = 'maxWait' in options;
                  maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                  trailing = 'trailing' in options ? !!options.trailing : trailing;
                }

                function invokeFunc(time) {
                  var args = lastArgs,
                      thisArg = lastThis;
                  lastArgs = lastThis = undefined;
                  lastInvokeTime = time;
                  result = func.apply(thisArg, args);
                  return result;
                }

                function leadingEdge(time) {
                  // Reset any `maxWait` timer.
                  lastInvokeTime = time; // Start the timer for the trailing edge.

                  timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

                  return leading ? invokeFunc(time) : result;
                }

                function remainingWait(time) {
                  var timeSinceLastCall = time - lastCallTime,
                      timeSinceLastInvoke = time - lastInvokeTime,
                      timeWaiting = wait - timeSinceLastCall;
                  return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
                }

                function shouldInvoke(time) {
                  var timeSinceLastCall = time - lastCallTime,
                      timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
                  // trailing edge, the system time has gone backwards and we're treating
                  // it as the trailing edge, or we've hit the `maxWait` limit.

                  return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
                }

                function timerExpired() {
                  var time = now();

                  if (shouldInvoke(time)) {
                    return trailingEdge(time);
                  } // Restart the timer.


                  timerId = setTimeout(timerExpired, remainingWait(time));
                }

                function trailingEdge(time) {
                  timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
                  // debounced at least once.

                  if (trailing && lastArgs) {
                    return invokeFunc(time);
                  }

                  lastArgs = lastThis = undefined;
                  return result;
                }

                function cancel() {
                  if (timerId !== undefined) {
                    clearTimeout(timerId);
                  }

                  lastInvokeTime = 0;
                  lastArgs = lastCallTime = lastThis = timerId = undefined;
                }

                function flush() {
                  return timerId === undefined ? result : trailingEdge(now());
                }

                function debounced() {
                  var time = now(),
                      isInvoking = shouldInvoke(time);
                  lastArgs = arguments;
                  lastThis = this;
                  lastCallTime = time;

                  if (isInvoking) {
                    if (timerId === undefined) {
                      return leadingEdge(lastCallTime);
                    }

                    if (maxing) {
                      // Handle invocations in a tight loop.
                      clearTimeout(timerId);
                      timerId = setTimeout(timerExpired, wait);
                      return invokeFunc(lastCallTime);
                    }
                  }

                  if (timerId === undefined) {
                    timerId = setTimeout(timerExpired, wait);
                  }

                  return result;
                }

                debounced.cancel = cancel;
                debounced.flush = flush;
                return debounced;
              }
              /**
               * Defers invoking the `func` until the current call stack has cleared. Any
               * additional arguments are provided to `func` when it's invoked.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Function
               * @param {Function} func The function to defer.
               * @param {...*} [args] The arguments to invoke `func` with.
               * @returns {number} Returns the timer id.
               * @example
               *
               * _.defer(function(text) {
               *   console.log(text);
               * }, 'deferred');
               * // => Logs 'deferred' after one millisecond.
               */


              var defer = baseRest(function (func, args) {
                return baseDelay(func, 1, args);
              });
              /**
               * Invokes `func` after `wait` milliseconds. Any additional arguments are
               * provided to `func` when it's invoked.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Function
               * @param {Function} func The function to delay.
               * @param {number} wait The number of milliseconds to delay invocation.
               * @param {...*} [args] The arguments to invoke `func` with.
               * @returns {number} Returns the timer id.
               * @example
               *
               * _.delay(function(text) {
               *   console.log(text);
               * }, 1000, 'later');
               * // => Logs 'later' after one second.
               */

              var delay = baseRest(function (func, wait, args) {
                return baseDelay(func, toNumber(wait) || 0, args);
              });
              /**
               * Creates a function that invokes `func` with arguments reversed.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Function
               * @param {Function} func The function to flip arguments for.
               * @returns {Function} Returns the new flipped function.
               * @example
               *
               * var flipped = _.flip(function() {
               *   return _.toArray(arguments);
               * });
               *
               * flipped('a', 'b', 'c', 'd');
               * // => ['d', 'c', 'b', 'a']
               */

              function flip(func) {
                return createWrap(func, WRAP_FLIP_FLAG);
              }
              /**
               * Creates a function that memoizes the result of `func`. If `resolver` is
               * provided, it determines the cache key for storing the result based on the
               * arguments provided to the memoized function. By default, the first argument
               * provided to the memoized function is used as the map cache key. The `func`
               * is invoked with the `this` binding of the memoized function.
               *
               * **Note:** The cache is exposed as the `cache` property on the memoized
               * function. Its creation may be customized by replacing the `_.memoize.Cache`
               * constructor with one whose instances implement the
               * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
               * method interface of `clear`, `delete`, `get`, `has`, and `set`.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Function
               * @param {Function} func The function to have its output memoized.
               * @param {Function} [resolver] The function to resolve the cache key.
               * @returns {Function} Returns the new memoized function.
               * @example
               *
               * var object = { 'a': 1, 'b': 2 };
               * var other = { 'c': 3, 'd': 4 };
               *
               * var values = _.memoize(_.values);
               * values(object);
               * // => [1, 2]
               *
               * values(other);
               * // => [3, 4]
               *
               * object.a = 2;
               * values(object);
               * // => [1, 2]
               *
               * // Modify the result cache.
               * values.cache.set(object, ['a', 'b']);
               * values(object);
               * // => ['a', 'b']
               *
               * // Replace `_.memoize.Cache`.
               * _.memoize.Cache = WeakMap;
               */


              function memoize(func, resolver) {
                if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
                  throw new TypeError(FUNC_ERROR_TEXT);
                }

                var memoized = function memoized() {
                  var args = arguments,
                      key = resolver ? resolver.apply(this, args) : args[0],
                      cache = memoized.cache;

                  if (cache.has(key)) {
                    return cache.get(key);
                  }

                  var result = func.apply(this, args);
                  memoized.cache = cache.set(key, result) || cache;
                  return result;
                };

                memoized.cache = new (memoize.Cache || MapCache)();
                return memoized;
              } // Expose `MapCache`.


              memoize.Cache = MapCache;
              /**
               * Creates a function that negates the result of the predicate `func`. The
               * `func` predicate is invoked with the `this` binding and arguments of the
               * created function.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Function
               * @param {Function} predicate The predicate to negate.
               * @returns {Function} Returns the new negated function.
               * @example
               *
               * function isEven(n) {
               *   return n % 2 == 0;
               * }
               *
               * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
               * // => [1, 3, 5]
               */

              function negate(predicate) {
                if (typeof predicate != 'function') {
                  throw new TypeError(FUNC_ERROR_TEXT);
                }

                return function () {
                  var args = arguments;

                  switch (args.length) {
                    case 0:
                      return !predicate.call(this);

                    case 1:
                      return !predicate.call(this, args[0]);

                    case 2:
                      return !predicate.call(this, args[0], args[1]);

                    case 3:
                      return !predicate.call(this, args[0], args[1], args[2]);
                  }

                  return !predicate.apply(this, args);
                };
              }
              /**
               * Creates a function that is restricted to invoking `func` once. Repeat calls
               * to the function return the value of the first invocation. The `func` is
               * invoked with the `this` binding and arguments of the created function.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Function
               * @param {Function} func The function to restrict.
               * @returns {Function} Returns the new restricted function.
               * @example
               *
               * var initialize = _.once(createApplication);
               * initialize();
               * initialize();
               * // => `createApplication` is invoked once
               */


              function once(func) {
                return before(2, func);
              }
              /**
               * Creates a function that invokes `func` with its arguments transformed.
               *
               * @static
               * @since 4.0.0
               * @memberOf _
               * @category Function
               * @param {Function} func The function to wrap.
               * @param {...(Function|Function[])} [transforms=[_.identity]]
               *  The argument transforms.
               * @returns {Function} Returns the new function.
               * @example
               *
               * function doubled(n) {
               *   return n * 2;
               * }
               *
               * function square(n) {
               *   return n * n;
               * }
               *
               * var func = _.overArgs(function(x, y) {
               *   return [x, y];
               * }, [square, doubled]);
               *
               * func(9, 3);
               * // => [81, 6]
               *
               * func(10, 5);
               * // => [100, 10]
               */


              var overArgs = castRest(function (func, transforms) {
                transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
                var funcsLength = transforms.length;
                return baseRest(function (args) {
                  var index = -1,
                      length = nativeMin(args.length, funcsLength);

                  while (++index < length) {
                    args[index] = transforms[index].call(this, args[index]);
                  }

                  return apply(func, this, args);
                });
              });
              /**
               * Creates a function that invokes `func` with `partials` prepended to the
               * arguments it receives. This method is like `_.bind` except it does **not**
               * alter the `this` binding.
               *
               * The `_.partial.placeholder` value, which defaults to `_` in monolithic
               * builds, may be used as a placeholder for partially applied arguments.
               *
               * **Note:** This method doesn't set the "length" property of partially
               * applied functions.
               *
               * @static
               * @memberOf _
               * @since 0.2.0
               * @category Function
               * @param {Function} func The function to partially apply arguments to.
               * @param {...*} [partials] The arguments to be partially applied.
               * @returns {Function} Returns the new partially applied function.
               * @example
               *
               * function greet(greeting, name) {
               *   return greeting + ' ' + name;
               * }
               *
               * var sayHelloTo = _.partial(greet, 'hello');
               * sayHelloTo('fred');
               * // => 'hello fred'
               *
               * // Partially applied with placeholders.
               * var greetFred = _.partial(greet, _, 'fred');
               * greetFred('hi');
               * // => 'hi fred'
               */

              var partial = baseRest(function (func, partials) {
                var holders = replaceHolders(partials, getHolder(partial));
                return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
              });
              /**
               * This method is like `_.partial` except that partially applied arguments
               * are appended to the arguments it receives.
               *
               * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
               * builds, may be used as a placeholder for partially applied arguments.
               *
               * **Note:** This method doesn't set the "length" property of partially
               * applied functions.
               *
               * @static
               * @memberOf _
               * @since 1.0.0
               * @category Function
               * @param {Function} func The function to partially apply arguments to.
               * @param {...*} [partials] The arguments to be partially applied.
               * @returns {Function} Returns the new partially applied function.
               * @example
               *
               * function greet(greeting, name) {
               *   return greeting + ' ' + name;
               * }
               *
               * var greetFred = _.partialRight(greet, 'fred');
               * greetFred('hi');
               * // => 'hi fred'
               *
               * // Partially applied with placeholders.
               * var sayHelloTo = _.partialRight(greet, 'hello', _);
               * sayHelloTo('fred');
               * // => 'hello fred'
               */

              var partialRight = baseRest(function (func, partials) {
                var holders = replaceHolders(partials, getHolder(partialRight));
                return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
              });
              /**
               * Creates a function that invokes `func` with arguments arranged according
               * to the specified `indexes` where the argument value at the first index is
               * provided as the first argument, the argument value at the second index is
               * provided as the second argument, and so on.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Function
               * @param {Function} func The function to rearrange arguments for.
               * @param {...(number|number[])} indexes The arranged argument indexes.
               * @returns {Function} Returns the new function.
               * @example
               *
               * var rearged = _.rearg(function(a, b, c) {
               *   return [a, b, c];
               * }, [2, 0, 1]);
               *
               * rearged('b', 'c', 'a')
               * // => ['a', 'b', 'c']
               */

              var rearg = flatRest(function (func, indexes) {
                return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
              });
              /**
               * Creates a function that invokes `func` with the `this` binding of the
               * created function and arguments from `start` and beyond provided as
               * an array.
               *
               * **Note:** This method is based on the
               * [rest parameter](https://mdn.io/rest_parameters).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Function
               * @param {Function} func The function to apply a rest parameter to.
               * @param {number} [start=func.length-1] The start position of the rest parameter.
               * @returns {Function} Returns the new function.
               * @example
               *
               * var say = _.rest(function(what, names) {
               *   return what + ' ' + _.initial(names).join(', ') +
               *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
               * });
               *
               * say('hello', 'fred', 'barney', 'pebbles');
               * // => 'hello fred, barney, & pebbles'
               */

              function rest(func, start) {
                if (typeof func != 'function') {
                  throw new TypeError(FUNC_ERROR_TEXT);
                }

                start = start === undefined ? start : toInteger(start);
                return baseRest(func, start);
              }
              /**
               * Creates a function that invokes `func` with the `this` binding of the
               * create function and an array of arguments much like
               * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
               *
               * **Note:** This method is based on the
               * [spread operator](https://mdn.io/spread_operator).
               *
               * @static
               * @memberOf _
               * @since 3.2.0
               * @category Function
               * @param {Function} func The function to spread arguments over.
               * @param {number} [start=0] The start position of the spread.
               * @returns {Function} Returns the new function.
               * @example
               *
               * var say = _.spread(function(who, what) {
               *   return who + ' says ' + what;
               * });
               *
               * say(['fred', 'hello']);
               * // => 'fred says hello'
               *
               * var numbers = Promise.all([
               *   Promise.resolve(40),
               *   Promise.resolve(36)
               * ]);
               *
               * numbers.then(_.spread(function(x, y) {
               *   return x + y;
               * }));
               * // => a Promise of 76
               */


              function spread(func, start) {
                if (typeof func != 'function') {
                  throw new TypeError(FUNC_ERROR_TEXT);
                }

                start = start == null ? 0 : nativeMax(toInteger(start), 0);
                return baseRest(function (args) {
                  var array = args[start],
                      otherArgs = castSlice(args, 0, start);

                  if (array) {
                    arrayPush(otherArgs, array);
                  }

                  return apply(func, this, otherArgs);
                });
              }
              /**
               * Creates a throttled function that only invokes `func` at most once per
               * every `wait` milliseconds. The throttled function comes with a `cancel`
               * method to cancel delayed `func` invocations and a `flush` method to
               * immediately invoke them. Provide `options` to indicate whether `func`
               * should be invoked on the leading and/or trailing edge of the `wait`
               * timeout. The `func` is invoked with the last arguments provided to the
               * throttled function. Subsequent calls to the throttled function return the
               * result of the last `func` invocation.
               *
               * **Note:** If `leading` and `trailing` options are `true`, `func` is
               * invoked on the trailing edge of the timeout only if the throttled function
               * is invoked more than once during the `wait` timeout.
               *
               * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
               * until to the next tick, similar to `setTimeout` with a timeout of `0`.
               *
               * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
               * for details over the differences between `_.throttle` and `_.debounce`.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Function
               * @param {Function} func The function to throttle.
               * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
               * @param {Object} [options={}] The options object.
               * @param {boolean} [options.leading=true]
               *  Specify invoking on the leading edge of the timeout.
               * @param {boolean} [options.trailing=true]
               *  Specify invoking on the trailing edge of the timeout.
               * @returns {Function} Returns the new throttled function.
               * @example
               *
               * // Avoid excessively updating the position while scrolling.
               * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
               *
               * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
               * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
               * jQuery(element).on('click', throttled);
               *
               * // Cancel the trailing throttled invocation.
               * jQuery(window).on('popstate', throttled.cancel);
               */


              function throttle(func, wait, options) {
                var leading = true,
                    trailing = true;

                if (typeof func != 'function') {
                  throw new TypeError(FUNC_ERROR_TEXT);
                }

                if (isObject(options)) {
                  leading = 'leading' in options ? !!options.leading : leading;
                  trailing = 'trailing' in options ? !!options.trailing : trailing;
                }

                return debounce(func, wait, {
                  'leading': leading,
                  'maxWait': wait,
                  'trailing': trailing
                });
              }
              /**
               * Creates a function that accepts up to one argument, ignoring any
               * additional arguments.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Function
               * @param {Function} func The function to cap arguments for.
               * @returns {Function} Returns the new capped function.
               * @example
               *
               * _.map(['6', '8', '10'], _.unary(parseInt));
               * // => [6, 8, 10]
               */


              function unary(func) {
                return ary(func, 1);
              }
              /**
               * Creates a function that provides `value` to `wrapper` as its first
               * argument. Any additional arguments provided to the function are appended
               * to those provided to the `wrapper`. The wrapper is invoked with the `this`
               * binding of the created function.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Function
               * @param {*} value The value to wrap.
               * @param {Function} [wrapper=identity] The wrapper function.
               * @returns {Function} Returns the new function.
               * @example
               *
               * var p = _.wrap(_.escape, function(func, text) {
               *   return '<p>' + func(text) + '</p>';
               * });
               *
               * p('fred, barney, & pebbles');
               * // => '<p>fred, barney, &amp; pebbles</p>'
               */


              function wrap(value, wrapper) {
                return partial(castFunction(wrapper), value);
              }
              /*------------------------------------------------------------------------*/

              /**
               * Casts `value` as an array if it's not one.
               *
               * @static
               * @memberOf _
               * @since 4.4.0
               * @category Lang
               * @param {*} value The value to inspect.
               * @returns {Array} Returns the cast array.
               * @example
               *
               * _.castArray(1);
               * // => [1]
               *
               * _.castArray({ 'a': 1 });
               * // => [{ 'a': 1 }]
               *
               * _.castArray('abc');
               * // => ['abc']
               *
               * _.castArray(null);
               * // => [null]
               *
               * _.castArray(undefined);
               * // => [undefined]
               *
               * _.castArray();
               * // => []
               *
               * var array = [1, 2, 3];
               * console.log(_.castArray(array) === array);
               * // => true
               */


              function castArray() {
                if (!arguments.length) {
                  return [];
                }

                var value = arguments[0];
                return isArray(value) ? value : [value];
              }
              /**
               * Creates a shallow clone of `value`.
               *
               * **Note:** This method is loosely based on the
               * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
               * and supports cloning arrays, array buffers, booleans, date objects, maps,
               * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
               * arrays. The own enumerable properties of `arguments` objects are cloned
               * as plain objects. An empty object is returned for uncloneable values such
               * as error objects, functions, DOM nodes, and WeakMaps.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to clone.
               * @returns {*} Returns the cloned value.
               * @see _.cloneDeep
               * @example
               *
               * var objects = [{ 'a': 1 }, { 'b': 2 }];
               *
               * var shallow = _.clone(objects);
               * console.log(shallow[0] === objects[0]);
               * // => true
               */


              function clone(value) {
                return baseClone(value, CLONE_SYMBOLS_FLAG);
              }
              /**
               * This method is like `_.clone` except that it accepts `customizer` which
               * is invoked to produce the cloned value. If `customizer` returns `undefined`,
               * cloning is handled by the method instead. The `customizer` is invoked with
               * up to four arguments; (value [, index|key, object, stack]).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to clone.
               * @param {Function} [customizer] The function to customize cloning.
               * @returns {*} Returns the cloned value.
               * @see _.cloneDeepWith
               * @example
               *
               * function customizer(value) {
               *   if (_.isElement(value)) {
               *     return value.cloneNode(false);
               *   }
               * }
               *
               * var el = _.cloneWith(document.body, customizer);
               *
               * console.log(el === document.body);
               * // => false
               * console.log(el.nodeName);
               * // => 'BODY'
               * console.log(el.childNodes.length);
               * // => 0
               */


              function cloneWith(value, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
              }
              /**
               * This method is like `_.clone` except that it recursively clones `value`.
               *
               * @static
               * @memberOf _
               * @since 1.0.0
               * @category Lang
               * @param {*} value The value to recursively clone.
               * @returns {*} Returns the deep cloned value.
               * @see _.clone
               * @example
               *
               * var objects = [{ 'a': 1 }, { 'b': 2 }];
               *
               * var deep = _.cloneDeep(objects);
               * console.log(deep[0] === objects[0]);
               * // => false
               */


              function cloneDeep(value) {
                return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
              }
              /**
               * This method is like `_.cloneWith` except that it recursively clones `value`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to recursively clone.
               * @param {Function} [customizer] The function to customize cloning.
               * @returns {*} Returns the deep cloned value.
               * @see _.cloneWith
               * @example
               *
               * function customizer(value) {
               *   if (_.isElement(value)) {
               *     return value.cloneNode(true);
               *   }
               * }
               *
               * var el = _.cloneDeepWith(document.body, customizer);
               *
               * console.log(el === document.body);
               * // => false
               * console.log(el.nodeName);
               * // => 'BODY'
               * console.log(el.childNodes.length);
               * // => 20
               */


              function cloneDeepWith(value, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
              }
              /**
               * Checks if `object` conforms to `source` by invoking the predicate
               * properties of `source` with the corresponding property values of `object`.
               *
               * **Note:** This method is equivalent to `_.conforms` when `source` is
               * partially applied.
               *
               * @static
               * @memberOf _
               * @since 4.14.0
               * @category Lang
               * @param {Object} object The object to inspect.
               * @param {Object} source The object of property predicates to conform to.
               * @returns {boolean} Returns `true` if `object` conforms, else `false`.
               * @example
               *
               * var object = { 'a': 1, 'b': 2 };
               *
               * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
               * // => true
               *
               * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
               * // => false
               */


              function conformsTo(object, source) {
                return source == null || baseConformsTo(object, source, keys(source));
              }
              /**
               * Performs a
               * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
               * comparison between two values to determine if they are equivalent.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to compare.
               * @param {*} other The other value to compare.
               * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
               * @example
               *
               * var object = { 'a': 1 };
               * var other = { 'a': 1 };
               *
               * _.eq(object, object);
               * // => true
               *
               * _.eq(object, other);
               * // => false
               *
               * _.eq('a', 'a');
               * // => true
               *
               * _.eq('a', Object('a'));
               * // => false
               *
               * _.eq(NaN, NaN);
               * // => true
               */


              function eq(value, other) {
                return value === other || value !== value && other !== other;
              }
              /**
               * Checks if `value` is greater than `other`.
               *
               * @static
               * @memberOf _
               * @since 3.9.0
               * @category Lang
               * @param {*} value The value to compare.
               * @param {*} other The other value to compare.
               * @returns {boolean} Returns `true` if `value` is greater than `other`,
               *  else `false`.
               * @see _.lt
               * @example
               *
               * _.gt(3, 1);
               * // => true
               *
               * _.gt(3, 3);
               * // => false
               *
               * _.gt(1, 3);
               * // => false
               */


              var gt = createRelationalOperation(baseGt);
              /**
               * Checks if `value` is greater than or equal to `other`.
               *
               * @static
               * @memberOf _
               * @since 3.9.0
               * @category Lang
               * @param {*} value The value to compare.
               * @param {*} other The other value to compare.
               * @returns {boolean} Returns `true` if `value` is greater than or equal to
               *  `other`, else `false`.
               * @see _.lte
               * @example
               *
               * _.gte(3, 1);
               * // => true
               *
               * _.gte(3, 3);
               * // => true
               *
               * _.gte(1, 3);
               * // => false
               */

              var gte = createRelationalOperation(function (value, other) {
                return value >= other;
              });
              /**
               * Checks if `value` is likely an `arguments` object.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is an `arguments` object,
               *  else `false`.
               * @example
               *
               * _.isArguments(function() { return arguments; }());
               * // => true
               *
               * _.isArguments([1, 2, 3]);
               * // => false
               */

              var isArguments = baseIsArguments(function () {
                return arguments;
              }()) ? baseIsArguments : function (value) {
                return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
              };
              /**
               * Checks if `value` is classified as an `Array` object.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is an array, else `false`.
               * @example
               *
               * _.isArray([1, 2, 3]);
               * // => true
               *
               * _.isArray(document.body.children);
               * // => false
               *
               * _.isArray('abc');
               * // => false
               *
               * _.isArray(_.noop);
               * // => false
               */

              var isArray = Array.isArray;
              /**
               * Checks if `value` is classified as an `ArrayBuffer` object.
               *
               * @static
               * @memberOf _
               * @since 4.3.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
               * @example
               *
               * _.isArrayBuffer(new ArrayBuffer(2));
               * // => true
               *
               * _.isArrayBuffer(new Array(2));
               * // => false
               */

              var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
              /**
               * Checks if `value` is array-like. A value is considered array-like if it's
               * not a function and has a `value.length` that's an integer greater than or
               * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
               * @example
               *
               * _.isArrayLike([1, 2, 3]);
               * // => true
               *
               * _.isArrayLike(document.body.children);
               * // => true
               *
               * _.isArrayLike('abc');
               * // => true
               *
               * _.isArrayLike(_.noop);
               * // => false
               */

              function isArrayLike(value) {
                return value != null && isLength(value.length) && !isFunction(value);
              }
              /**
               * This method is like `_.isArrayLike` except that it also checks if `value`
               * is an object.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is an array-like object,
               *  else `false`.
               * @example
               *
               * _.isArrayLikeObject([1, 2, 3]);
               * // => true
               *
               * _.isArrayLikeObject(document.body.children);
               * // => true
               *
               * _.isArrayLikeObject('abc');
               * // => false
               *
               * _.isArrayLikeObject(_.noop);
               * // => false
               */


              function isArrayLikeObject(value) {
                return isObjectLike(value) && isArrayLike(value);
              }
              /**
               * Checks if `value` is classified as a boolean primitive or object.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
               * @example
               *
               * _.isBoolean(false);
               * // => true
               *
               * _.isBoolean(null);
               * // => false
               */


              function isBoolean(value) {
                return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
              }
              /**
               * Checks if `value` is a buffer.
               *
               * @static
               * @memberOf _
               * @since 4.3.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
               * @example
               *
               * _.isBuffer(new Buffer(2));
               * // => true
               *
               * _.isBuffer(new Uint8Array(2));
               * // => false
               */


              var isBuffer = nativeIsBuffer || stubFalse;
              /**
               * Checks if `value` is classified as a `Date` object.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
               * @example
               *
               * _.isDate(new Date);
               * // => true
               *
               * _.isDate('Mon April 23 2012');
               * // => false
               */

              var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
              /**
               * Checks if `value` is likely a DOM element.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
               * @example
               *
               * _.isElement(document.body);
               * // => true
               *
               * _.isElement('<body>');
               * // => false
               */

              function isElement(value) {
                return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
              }
              /**
               * Checks if `value` is an empty object, collection, map, or set.
               *
               * Objects are considered empty if they have no own enumerable string keyed
               * properties.
               *
               * Array-like values such as `arguments` objects, arrays, buffers, strings, or
               * jQuery-like collections are considered empty if they have a `length` of `0`.
               * Similarly, maps and sets are considered empty if they have a `size` of `0`.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is empty, else `false`.
               * @example
               *
               * _.isEmpty(null);
               * // => true
               *
               * _.isEmpty(true);
               * // => true
               *
               * _.isEmpty(1);
               * // => true
               *
               * _.isEmpty([1, 2, 3]);
               * // => false
               *
               * _.isEmpty({ 'a': 1 });
               * // => false
               */


              function isEmpty(value) {
                if (value == null) {
                  return true;
                }

                if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
                  return !value.length;
                }

                var tag = getTag(value);

                if (tag == mapTag || tag == setTag) {
                  return !value.size;
                }

                if (isPrototype(value)) {
                  return !baseKeys(value).length;
                }

                for (var key in value) {
                  if (hasOwnProperty.call(value, key)) {
                    return false;
                  }
                }

                return true;
              }
              /**
               * Performs a deep comparison between two values to determine if they are
               * equivalent.
               *
               * **Note:** This method supports comparing arrays, array buffers, booleans,
               * date objects, error objects, maps, numbers, `Object` objects, regexes,
               * sets, strings, symbols, and typed arrays. `Object` objects are compared
               * by their own, not inherited, enumerable properties. Functions and DOM
               * nodes are compared by strict equality, i.e. `===`.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to compare.
               * @param {*} other The other value to compare.
               * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
               * @example
               *
               * var object = { 'a': 1 };
               * var other = { 'a': 1 };
               *
               * _.isEqual(object, other);
               * // => true
               *
               * object === other;
               * // => false
               */


              function isEqual(value, other) {
                return baseIsEqual(value, other);
              }
              /**
               * This method is like `_.isEqual` except that it accepts `customizer` which
               * is invoked to compare values. If `customizer` returns `undefined`, comparisons
               * are handled by the method instead. The `customizer` is invoked with up to
               * six arguments: (objValue, othValue [, index|key, object, other, stack]).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to compare.
               * @param {*} other The other value to compare.
               * @param {Function} [customizer] The function to customize comparisons.
               * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
               * @example
               *
               * function isGreeting(value) {
               *   return /^h(?:i|ello)$/.test(value);
               * }
               *
               * function customizer(objValue, othValue) {
               *   if (isGreeting(objValue) && isGreeting(othValue)) {
               *     return true;
               *   }
               * }
               *
               * var array = ['hello', 'goodbye'];
               * var other = ['hi', 'goodbye'];
               *
               * _.isEqualWith(array, other, customizer);
               * // => true
               */


              function isEqualWith(value, other, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                var result = customizer ? customizer(value, other) : undefined;
                return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
              }
              /**
               * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
               * `SyntaxError`, `TypeError`, or `URIError` object.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
               * @example
               *
               * _.isError(new Error);
               * // => true
               *
               * _.isError(Error);
               * // => false
               */


              function isError(value) {
                if (!isObjectLike(value)) {
                  return false;
                }

                var tag = baseGetTag(value);
                return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
              }
              /**
               * Checks if `value` is a finite primitive number.
               *
               * **Note:** This method is based on
               * [`Number.isFinite`](https://mdn.io/Number/isFinite).
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
               * @example
               *
               * _.isFinite(3);
               * // => true
               *
               * _.isFinite(Number.MIN_VALUE);
               * // => true
               *
               * _.isFinite(Infinity);
               * // => false
               *
               * _.isFinite('3');
               * // => false
               */


              function isFinite(value) {
                return typeof value == 'number' && nativeIsFinite(value);
              }
              /**
               * Checks if `value` is classified as a `Function` object.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a function, else `false`.
               * @example
               *
               * _.isFunction(_);
               * // => true
               *
               * _.isFunction(/abc/);
               * // => false
               */


              function isFunction(value) {
                if (!isObject(value)) {
                  return false;
                } // The use of `Object#toString` avoids issues with the `typeof` operator
                // in Safari 9 which returns 'object' for typed arrays and other constructors.


                var tag = baseGetTag(value);
                return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
              }
              /**
               * Checks if `value` is an integer.
               *
               * **Note:** This method is based on
               * [`Number.isInteger`](https://mdn.io/Number/isInteger).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
               * @example
               *
               * _.isInteger(3);
               * // => true
               *
               * _.isInteger(Number.MIN_VALUE);
               * // => false
               *
               * _.isInteger(Infinity);
               * // => false
               *
               * _.isInteger('3');
               * // => false
               */


              function isInteger(value) {
                return typeof value == 'number' && value == toInteger(value);
              }
              /**
               * Checks if `value` is a valid array-like length.
               *
               * **Note:** This method is loosely based on
               * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
               * @example
               *
               * _.isLength(3);
               * // => true
               *
               * _.isLength(Number.MIN_VALUE);
               * // => false
               *
               * _.isLength(Infinity);
               * // => false
               *
               * _.isLength('3');
               * // => false
               */


              function isLength(value) {
                return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
              }
              /**
               * Checks if `value` is the
               * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
               * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is an object, else `false`.
               * @example
               *
               * _.isObject({});
               * // => true
               *
               * _.isObject([1, 2, 3]);
               * // => true
               *
               * _.isObject(_.noop);
               * // => true
               *
               * _.isObject(null);
               * // => false
               */


              function isObject(value) {
                var type = _typeof2(value);

                return value != null && (type == 'object' || type == 'function');
              }
              /**
               * Checks if `value` is object-like. A value is object-like if it's not `null`
               * and has a `typeof` result of "object".
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
               * @example
               *
               * _.isObjectLike({});
               * // => true
               *
               * _.isObjectLike([1, 2, 3]);
               * // => true
               *
               * _.isObjectLike(_.noop);
               * // => false
               *
               * _.isObjectLike(null);
               * // => false
               */


              function isObjectLike(value) {
                return value != null && _typeof2(value) == 'object';
              }
              /**
               * Checks if `value` is classified as a `Map` object.
               *
               * @static
               * @memberOf _
               * @since 4.3.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a map, else `false`.
               * @example
               *
               * _.isMap(new Map);
               * // => true
               *
               * _.isMap(new WeakMap);
               * // => false
               */


              var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
              /**
               * Performs a partial deep comparison between `object` and `source` to
               * determine if `object` contains equivalent property values.
               *
               * **Note:** This method is equivalent to `_.matches` when `source` is
               * partially applied.
               *
               * Partial comparisons will match empty array and empty object `source`
               * values against any array or object value, respectively. See `_.isEqual`
               * for a list of supported value comparisons.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Lang
               * @param {Object} object The object to inspect.
               * @param {Object} source The object of property values to match.
               * @returns {boolean} Returns `true` if `object` is a match, else `false`.
               * @example
               *
               * var object = { 'a': 1, 'b': 2 };
               *
               * _.isMatch(object, { 'b': 2 });
               * // => true
               *
               * _.isMatch(object, { 'b': 1 });
               * // => false
               */

              function isMatch(object, source) {
                return object === source || baseIsMatch(object, source, getMatchData(source));
              }
              /**
               * This method is like `_.isMatch` except that it accepts `customizer` which
               * is invoked to compare values. If `customizer` returns `undefined`, comparisons
               * are handled by the method instead. The `customizer` is invoked with five
               * arguments: (objValue, srcValue, index|key, object, source).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {Object} object The object to inspect.
               * @param {Object} source The object of property values to match.
               * @param {Function} [customizer] The function to customize comparisons.
               * @returns {boolean} Returns `true` if `object` is a match, else `false`.
               * @example
               *
               * function isGreeting(value) {
               *   return /^h(?:i|ello)$/.test(value);
               * }
               *
               * function customizer(objValue, srcValue) {
               *   if (isGreeting(objValue) && isGreeting(srcValue)) {
               *     return true;
               *   }
               * }
               *
               * var object = { 'greeting': 'hello' };
               * var source = { 'greeting': 'hi' };
               *
               * _.isMatchWith(object, source, customizer);
               * // => true
               */


              function isMatchWith(object, source, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return baseIsMatch(object, source, getMatchData(source), customizer);
              }
              /**
               * Checks if `value` is `NaN`.
               *
               * **Note:** This method is based on
               * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
               * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
               * `undefined` and other non-number values.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
               * @example
               *
               * _.isNaN(NaN);
               * // => true
               *
               * _.isNaN(new Number(NaN));
               * // => true
               *
               * isNaN(undefined);
               * // => true
               *
               * _.isNaN(undefined);
               * // => false
               */


              function isNaN(value) {
                // An `NaN` primitive is the only value that is not equal to itself.
                // Perform the `toStringTag` check first to avoid errors with some
                // ActiveX objects in IE.
                return isNumber(value) && value != +value;
              }
              /**
               * Checks if `value` is a pristine native function.
               *
               * **Note:** This method can't reliably detect native functions in the presence
               * of the core-js package because core-js circumvents this kind of detection.
               * Despite multiple requests, the core-js maintainer has made it clear: any
               * attempt to fix the detection will be obstructed. As a result, we're left
               * with little choice but to throw an error. Unfortunately, this also affects
               * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
               * which rely on core-js.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a native function,
               *  else `false`.
               * @example
               *
               * _.isNative(Array.prototype.push);
               * // => true
               *
               * _.isNative(_);
               * // => false
               */


              function isNative(value) {
                if (isMaskable(value)) {
                  throw new Error(CORE_ERROR_TEXT);
                }

                return baseIsNative(value);
              }
              /**
               * Checks if `value` is `null`.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
               * @example
               *
               * _.isNull(null);
               * // => true
               *
               * _.isNull(void 0);
               * // => false
               */


              function isNull(value) {
                return value === null;
              }
              /**
               * Checks if `value` is `null` or `undefined`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
               * @example
               *
               * _.isNil(null);
               * // => true
               *
               * _.isNil(void 0);
               * // => true
               *
               * _.isNil(NaN);
               * // => false
               */


              function isNil(value) {
                return value == null;
              }
              /**
               * Checks if `value` is classified as a `Number` primitive or object.
               *
               * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
               * classified as numbers, use the `_.isFinite` method.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a number, else `false`.
               * @example
               *
               * _.isNumber(3);
               * // => true
               *
               * _.isNumber(Number.MIN_VALUE);
               * // => true
               *
               * _.isNumber(Infinity);
               * // => true
               *
               * _.isNumber('3');
               * // => false
               */


              function isNumber(value) {
                return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
              }
              /**
               * Checks if `value` is a plain object, that is, an object created by the
               * `Object` constructor or one with a `[[Prototype]]` of `null`.
               *
               * @static
               * @memberOf _
               * @since 0.8.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
               * @example
               *
               * function Foo() {
               *   this.a = 1;
               * }
               *
               * _.isPlainObject(new Foo);
               * // => false
               *
               * _.isPlainObject([1, 2, 3]);
               * // => false
               *
               * _.isPlainObject({ 'x': 0, 'y': 0 });
               * // => true
               *
               * _.isPlainObject(Object.create(null));
               * // => true
               */


              function isPlainObject(value) {
                if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
                  return false;
                }

                var proto = getPrototype(value);

                if (proto === null) {
                  return true;
                }

                var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
                return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
              }
              /**
               * Checks if `value` is classified as a `RegExp` object.
               *
               * @static
               * @memberOf _
               * @since 0.1.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
               * @example
               *
               * _.isRegExp(/abc/);
               * // => true
               *
               * _.isRegExp('/abc/');
               * // => false
               */


              var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
              /**
               * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
               * double precision number which isn't the result of a rounded unsafe integer.
               *
               * **Note:** This method is based on
               * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
               * @example
               *
               * _.isSafeInteger(3);
               * // => true
               *
               * _.isSafeInteger(Number.MIN_VALUE);
               * // => false
               *
               * _.isSafeInteger(Infinity);
               * // => false
               *
               * _.isSafeInteger('3');
               * // => false
               */

              function isSafeInteger(value) {
                return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
              }
              /**
               * Checks if `value` is classified as a `Set` object.
               *
               * @static
               * @memberOf _
               * @since 4.3.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a set, else `false`.
               * @example
               *
               * _.isSet(new Set);
               * // => true
               *
               * _.isSet(new WeakSet);
               * // => false
               */


              var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
              /**
               * Checks if `value` is classified as a `String` primitive or object.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a string, else `false`.
               * @example
               *
               * _.isString('abc');
               * // => true
               *
               * _.isString(1);
               * // => false
               */

              function isString(value) {
                return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
              }
              /**
               * Checks if `value` is classified as a `Symbol` primitive or object.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
               * @example
               *
               * _.isSymbol(Symbol.iterator);
               * // => true
               *
               * _.isSymbol('abc');
               * // => false
               */


              function isSymbol(value) {
                return _typeof2(value) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
              }
              /**
               * Checks if `value` is classified as a typed array.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
               * @example
               *
               * _.isTypedArray(new Uint8Array);
               * // => true
               *
               * _.isTypedArray([]);
               * // => false
               */


              var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
              /**
               * Checks if `value` is `undefined`.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
               * @example
               *
               * _.isUndefined(void 0);
               * // => true
               *
               * _.isUndefined(null);
               * // => false
               */

              function isUndefined(value) {
                return value === undefined;
              }
              /**
               * Checks if `value` is classified as a `WeakMap` object.
               *
               * @static
               * @memberOf _
               * @since 4.3.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
               * @example
               *
               * _.isWeakMap(new WeakMap);
               * // => true
               *
               * _.isWeakMap(new Map);
               * // => false
               */


              function isWeakMap(value) {
                return isObjectLike(value) && getTag(value) == weakMapTag;
              }
              /**
               * Checks if `value` is classified as a `WeakSet` object.
               *
               * @static
               * @memberOf _
               * @since 4.3.0
               * @category Lang
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
               * @example
               *
               * _.isWeakSet(new WeakSet);
               * // => true
               *
               * _.isWeakSet(new Set);
               * // => false
               */


              function isWeakSet(value) {
                return isObjectLike(value) && baseGetTag(value) == weakSetTag;
              }
              /**
               * Checks if `value` is less than `other`.
               *
               * @static
               * @memberOf _
               * @since 3.9.0
               * @category Lang
               * @param {*} value The value to compare.
               * @param {*} other The other value to compare.
               * @returns {boolean} Returns `true` if `value` is less than `other`,
               *  else `false`.
               * @see _.gt
               * @example
               *
               * _.lt(1, 3);
               * // => true
               *
               * _.lt(3, 3);
               * // => false
               *
               * _.lt(3, 1);
               * // => false
               */


              var lt = createRelationalOperation(baseLt);
              /**
               * Checks if `value` is less than or equal to `other`.
               *
               * @static
               * @memberOf _
               * @since 3.9.0
               * @category Lang
               * @param {*} value The value to compare.
               * @param {*} other The other value to compare.
               * @returns {boolean} Returns `true` if `value` is less than or equal to
               *  `other`, else `false`.
               * @see _.gte
               * @example
               *
               * _.lte(1, 3);
               * // => true
               *
               * _.lte(3, 3);
               * // => true
               *
               * _.lte(3, 1);
               * // => false
               */

              var lte = createRelationalOperation(function (value, other) {
                return value <= other;
              });
              /**
               * Converts `value` to an array.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Lang
               * @param {*} value The value to convert.
               * @returns {Array} Returns the converted array.
               * @example
               *
               * _.toArray({ 'a': 1, 'b': 2 });
               * // => [1, 2]
               *
               * _.toArray('abc');
               * // => ['a', 'b', 'c']
               *
               * _.toArray(1);
               * // => []
               *
               * _.toArray(null);
               * // => []
               */

              function toArray(value) {
                if (!value) {
                  return [];
                }

                if (isArrayLike(value)) {
                  return isString(value) ? stringToArray(value) : copyArray(value);
                }

                if (symIterator && value[symIterator]) {
                  return iteratorToArray(value[symIterator]());
                }

                var tag = getTag(value),
                    func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
                return func(value);
              }
              /**
               * Converts `value` to a finite number.
               *
               * @static
               * @memberOf _
               * @since 4.12.0
               * @category Lang
               * @param {*} value The value to convert.
               * @returns {number} Returns the converted number.
               * @example
               *
               * _.toFinite(3.2);
               * // => 3.2
               *
               * _.toFinite(Number.MIN_VALUE);
               * // => 5e-324
               *
               * _.toFinite(Infinity);
               * // => 1.7976931348623157e+308
               *
               * _.toFinite('3.2');
               * // => 3.2
               */


              function toFinite(value) {
                if (!value) {
                  return value === 0 ? value : 0;
                }

                value = toNumber(value);

                if (value === INFINITY || value === -INFINITY) {
                  var sign = value < 0 ? -1 : 1;
                  return sign * MAX_INTEGER;
                }

                return value === value ? value : 0;
              }
              /**
               * Converts `value` to an integer.
               *
               * **Note:** This method is loosely based on
               * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to convert.
               * @returns {number} Returns the converted integer.
               * @example
               *
               * _.toInteger(3.2);
               * // => 3
               *
               * _.toInteger(Number.MIN_VALUE);
               * // => 0
               *
               * _.toInteger(Infinity);
               * // => 1.7976931348623157e+308
               *
               * _.toInteger('3.2');
               * // => 3
               */


              function toInteger(value) {
                var result = toFinite(value),
                    remainder = result % 1;
                return result === result ? remainder ? result - remainder : result : 0;
              }
              /**
               * Converts `value` to an integer suitable for use as the length of an
               * array-like object.
               *
               * **Note:** This method is based on
               * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to convert.
               * @returns {number} Returns the converted integer.
               * @example
               *
               * _.toLength(3.2);
               * // => 3
               *
               * _.toLength(Number.MIN_VALUE);
               * // => 0
               *
               * _.toLength(Infinity);
               * // => 4294967295
               *
               * _.toLength('3.2');
               * // => 3
               */


              function toLength(value) {
                return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
              }
              /**
               * Converts `value` to a number.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to process.
               * @returns {number} Returns the number.
               * @example
               *
               * _.toNumber(3.2);
               * // => 3.2
               *
               * _.toNumber(Number.MIN_VALUE);
               * // => 5e-324
               *
               * _.toNumber(Infinity);
               * // => Infinity
               *
               * _.toNumber('3.2');
               * // => 3.2
               */


              function toNumber(value) {
                if (typeof value == 'number') {
                  return value;
                }

                if (isSymbol(value)) {
                  return NAN;
                }

                if (isObject(value)) {
                  var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                  value = isObject(other) ? other + '' : other;
                }

                if (typeof value != 'string') {
                  return value === 0 ? value : +value;
                }

                value = baseTrim(value);
                var isBinary = reIsBinary.test(value);
                return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
              }
              /**
               * Converts `value` to a plain object flattening inherited enumerable string
               * keyed properties of `value` to own properties of the plain object.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Lang
               * @param {*} value The value to convert.
               * @returns {Object} Returns the converted plain object.
               * @example
               *
               * function Foo() {
               *   this.b = 2;
               * }
               *
               * Foo.prototype.c = 3;
               *
               * _.assign({ 'a': 1 }, new Foo);
               * // => { 'a': 1, 'b': 2 }
               *
               * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
               * // => { 'a': 1, 'b': 2, 'c': 3 }
               */


              function toPlainObject(value) {
                return copyObject(value, keysIn(value));
              }
              /**
               * Converts `value` to a safe integer. A safe integer can be compared and
               * represented correctly.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to convert.
               * @returns {number} Returns the converted integer.
               * @example
               *
               * _.toSafeInteger(3.2);
               * // => 3
               *
               * _.toSafeInteger(Number.MIN_VALUE);
               * // => 0
               *
               * _.toSafeInteger(Infinity);
               * // => 9007199254740991
               *
               * _.toSafeInteger('3.2');
               * // => 3
               */


              function toSafeInteger(value) {
                return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
              }
              /**
               * Converts `value` to a string. An empty string is returned for `null`
               * and `undefined` values. The sign of `-0` is preserved.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Lang
               * @param {*} value The value to convert.
               * @returns {string} Returns the converted string.
               * @example
               *
               * _.toString(null);
               * // => ''
               *
               * _.toString(-0);
               * // => '-0'
               *
               * _.toString([1, 2, 3]);
               * // => '1,2,3'
               */


              function toString(value) {
                return value == null ? '' : baseToString(value);
              }
              /*------------------------------------------------------------------------*/

              /**
               * Assigns own enumerable string keyed properties of source objects to the
               * destination object. Source objects are applied from left to right.
               * Subsequent sources overwrite property assignments of previous sources.
               *
               * **Note:** This method mutates `object` and is loosely based on
               * [`Object.assign`](https://mdn.io/Object/assign).
               *
               * @static
               * @memberOf _
               * @since 0.10.0
               * @category Object
               * @param {Object} object The destination object.
               * @param {...Object} [sources] The source objects.
               * @returns {Object} Returns `object`.
               * @see _.assignIn
               * @example
               *
               * function Foo() {
               *   this.a = 1;
               * }
               *
               * function Bar() {
               *   this.c = 3;
               * }
               *
               * Foo.prototype.b = 2;
               * Bar.prototype.d = 4;
               *
               * _.assign({ 'a': 0 }, new Foo, new Bar);
               * // => { 'a': 1, 'c': 3 }
               */


              var assign = createAssigner(function (object, source) {
                if (isPrototype(source) || isArrayLike(source)) {
                  copyObject(source, keys(source), object);
                  return;
                }

                for (var key in source) {
                  if (hasOwnProperty.call(source, key)) {
                    assignValue(object, key, source[key]);
                  }
                }
              });
              /**
               * This method is like `_.assign` except that it iterates over own and
               * inherited source properties.
               *
               * **Note:** This method mutates `object`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @alias extend
               * @category Object
               * @param {Object} object The destination object.
               * @param {...Object} [sources] The source objects.
               * @returns {Object} Returns `object`.
               * @see _.assign
               * @example
               *
               * function Foo() {
               *   this.a = 1;
               * }
               *
               * function Bar() {
               *   this.c = 3;
               * }
               *
               * Foo.prototype.b = 2;
               * Bar.prototype.d = 4;
               *
               * _.assignIn({ 'a': 0 }, new Foo, new Bar);
               * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
               */

              var assignIn = createAssigner(function (object, source) {
                copyObject(source, keysIn(source), object);
              });
              /**
               * This method is like `_.assignIn` except that it accepts `customizer`
               * which is invoked to produce the assigned values. If `customizer` returns
               * `undefined`, assignment is handled by the method instead. The `customizer`
               * is invoked with five arguments: (objValue, srcValue, key, object, source).
               *
               * **Note:** This method mutates `object`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @alias extendWith
               * @category Object
               * @param {Object} object The destination object.
               * @param {...Object} sources The source objects.
               * @param {Function} [customizer] The function to customize assigned values.
               * @returns {Object} Returns `object`.
               * @see _.assignWith
               * @example
               *
               * function customizer(objValue, srcValue) {
               *   return _.isUndefined(objValue) ? srcValue : objValue;
               * }
               *
               * var defaults = _.partialRight(_.assignInWith, customizer);
               *
               * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
               * // => { 'a': 1, 'b': 2 }
               */

              var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
                copyObject(source, keysIn(source), object, customizer);
              });
              /**
               * This method is like `_.assign` except that it accepts `customizer`
               * which is invoked to produce the assigned values. If `customizer` returns
               * `undefined`, assignment is handled by the method instead. The `customizer`
               * is invoked with five arguments: (objValue, srcValue, key, object, source).
               *
               * **Note:** This method mutates `object`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Object
               * @param {Object} object The destination object.
               * @param {...Object} sources The source objects.
               * @param {Function} [customizer] The function to customize assigned values.
               * @returns {Object} Returns `object`.
               * @see _.assignInWith
               * @example
               *
               * function customizer(objValue, srcValue) {
               *   return _.isUndefined(objValue) ? srcValue : objValue;
               * }
               *
               * var defaults = _.partialRight(_.assignWith, customizer);
               *
               * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
               * // => { 'a': 1, 'b': 2 }
               */

              var assignWith = createAssigner(function (object, source, srcIndex, customizer) {
                copyObject(source, keys(source), object, customizer);
              });
              /**
               * Creates an array of values corresponding to `paths` of `object`.
               *
               * @static
               * @memberOf _
               * @since 1.0.0
               * @category Object
               * @param {Object} object The object to iterate over.
               * @param {...(string|string[])} [paths] The property paths to pick.
               * @returns {Array} Returns the picked values.
               * @example
               *
               * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
               *
               * _.at(object, ['a[0].b.c', 'a[1]']);
               * // => [3, 4]
               */

              var at = flatRest(baseAt);
              /**
               * Creates an object that inherits from the `prototype` object. If a
               * `properties` object is given, its own enumerable string keyed properties
               * are assigned to the created object.
               *
               * @static
               * @memberOf _
               * @since 2.3.0
               * @category Object
               * @param {Object} prototype The object to inherit from.
               * @param {Object} [properties] The properties to assign to the object.
               * @returns {Object} Returns the new object.
               * @example
               *
               * function Shape() {
               *   this.x = 0;
               *   this.y = 0;
               * }
               *
               * function Circle() {
               *   Shape.call(this);
               * }
               *
               * Circle.prototype = _.create(Shape.prototype, {
               *   'constructor': Circle
               * });
               *
               * var circle = new Circle;
               * circle instanceof Circle;
               * // => true
               *
               * circle instanceof Shape;
               * // => true
               */

              function create(prototype, properties) {
                var result = baseCreate(prototype);
                return properties == null ? result : baseAssign(result, properties);
              }
              /**
               * Assigns own and inherited enumerable string keyed properties of source
               * objects to the destination object for all destination properties that
               * resolve to `undefined`. Source objects are applied from left to right.
               * Once a property is set, additional values of the same property are ignored.
               *
               * **Note:** This method mutates `object`.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Object
               * @param {Object} object The destination object.
               * @param {...Object} [sources] The source objects.
               * @returns {Object} Returns `object`.
               * @see _.defaultsDeep
               * @example
               *
               * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
               * // => { 'a': 1, 'b': 2 }
               */


              var defaults = baseRest(function (object, sources) {
                object = Object(object);
                var index = -1;
                var length = sources.length;
                var guard = length > 2 ? sources[2] : undefined;

                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                  length = 1;
                }

                while (++index < length) {
                  var source = sources[index];
                  var props = keysIn(source);
                  var propsIndex = -1;
                  var propsLength = props.length;

                  while (++propsIndex < propsLength) {
                    var key = props[propsIndex];
                    var value = object[key];

                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
                      object[key] = source[key];
                    }
                  }
                }

                return object;
              });
              /**
               * This method is like `_.defaults` except that it recursively assigns
               * default properties.
               *
               * **Note:** This method mutates `object`.
               *
               * @static
               * @memberOf _
               * @since 3.10.0
               * @category Object
               * @param {Object} object The destination object.
               * @param {...Object} [sources] The source objects.
               * @returns {Object} Returns `object`.
               * @see _.defaults
               * @example
               *
               * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
               * // => { 'a': { 'b': 2, 'c': 3 } }
               */

              var defaultsDeep = baseRest(function (args) {
                args.push(undefined, customDefaultsMerge);
                return apply(mergeWith, undefined, args);
              });
              /**
               * This method is like `_.find` except that it returns the key of the first
               * element `predicate` returns truthy for instead of the element itself.
               *
               * @static
               * @memberOf _
               * @since 1.1.0
               * @category Object
               * @param {Object} object The object to inspect.
               * @param {Function} [predicate=_.identity] The function invoked per iteration.
               * @returns {string|undefined} Returns the key of the matched element,
               *  else `undefined`.
               * @example
               *
               * var users = {
               *   'barney':  { 'age': 36, 'active': true },
               *   'fred':    { 'age': 40, 'active': false },
               *   'pebbles': { 'age': 1,  'active': true }
               * };
               *
               * _.findKey(users, function(o) { return o.age < 40; });
               * // => 'barney' (iteration order is not guaranteed)
               *
               * // The `_.matches` iteratee shorthand.
               * _.findKey(users, { 'age': 1, 'active': true });
               * // => 'pebbles'
               *
               * // The `_.matchesProperty` iteratee shorthand.
               * _.findKey(users, ['active', false]);
               * // => 'fred'
               *
               * // The `_.property` iteratee shorthand.
               * _.findKey(users, 'active');
               * // => 'barney'
               */

              function findKey(object, predicate) {
                return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
              }
              /**
               * This method is like `_.findKey` except that it iterates over elements of
               * a collection in the opposite order.
               *
               * @static
               * @memberOf _
               * @since 2.0.0
               * @category Object
               * @param {Object} object The object to inspect.
               * @param {Function} [predicate=_.identity] The function invoked per iteration.
               * @returns {string|undefined} Returns the key of the matched element,
               *  else `undefined`.
               * @example
               *
               * var users = {
               *   'barney':  { 'age': 36, 'active': true },
               *   'fred':    { 'age': 40, 'active': false },
               *   'pebbles': { 'age': 1,  'active': true }
               * };
               *
               * _.findLastKey(users, function(o) { return o.age < 40; });
               * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
               *
               * // The `_.matches` iteratee shorthand.
               * _.findLastKey(users, { 'age': 36, 'active': true });
               * // => 'barney'
               *
               * // The `_.matchesProperty` iteratee shorthand.
               * _.findLastKey(users, ['active', false]);
               * // => 'fred'
               *
               * // The `_.property` iteratee shorthand.
               * _.findLastKey(users, 'active');
               * // => 'pebbles'
               */


              function findLastKey(object, predicate) {
                return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
              }
              /**
               * Iterates over own and inherited enumerable string keyed properties of an
               * object and invokes `iteratee` for each property. The iteratee is invoked
               * with three arguments: (value, key, object). Iteratee functions may exit
               * iteration early by explicitly returning `false`.
               *
               * @static
               * @memberOf _
               * @since 0.3.0
               * @category Object
               * @param {Object} object The object to iterate over.
               * @param {Function} [iteratee=_.identity] The function invoked per iteration.
               * @returns {Object} Returns `object`.
               * @see _.forInRight
               * @example
               *
               * function Foo() {
               *   this.a = 1;
               *   this.b = 2;
               * }
               *
               * Foo.prototype.c = 3;
               *
               * _.forIn(new Foo, function(value, key) {
               *   console.log(key);
               * });
               * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
               */


              function forIn(object, iteratee) {
                return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
              }
              /**
               * This method is like `_.forIn` except that it iterates over properties of
               * `object` in the opposite order.
               *
               * @static
               * @memberOf _
               * @since 2.0.0
               * @category Object
               * @param {Object} object The object to iterate over.
               * @param {Function} [iteratee=_.identity] The function invoked per iteration.
               * @returns {Object} Returns `object`.
               * @see _.forIn
               * @example
               *
               * function Foo() {
               *   this.a = 1;
               *   this.b = 2;
               * }
               *
               * Foo.prototype.c = 3;
               *
               * _.forInRight(new Foo, function(value, key) {
               *   console.log(key);
               * });
               * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
               */


              function forInRight(object, iteratee) {
                return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
              }
              /**
               * Iterates over own enumerable string keyed properties of an object and
               * invokes `iteratee` for each property. The iteratee is invoked with three
               * arguments: (value, key, object). Iteratee functions may exit iteration
               * early by explicitly returning `false`.
               *
               * @static
               * @memberOf _
               * @since 0.3.0
               * @category Object
               * @param {Object} object The object to iterate over.
               * @param {Function} [iteratee=_.identity] The function invoked per iteration.
               * @returns {Object} Returns `object`.
               * @see _.forOwnRight
               * @example
               *
               * function Foo() {
               *   this.a = 1;
               *   this.b = 2;
               * }
               *
               * Foo.prototype.c = 3;
               *
               * _.forOwn(new Foo, function(value, key) {
               *   console.log(key);
               * });
               * // => Logs 'a' then 'b' (iteration order is not guaranteed).
               */


              function forOwn(object, iteratee) {
                return object && baseForOwn(object, getIteratee(iteratee, 3));
              }
              /**
               * This method is like `_.forOwn` except that it iterates over properties of
               * `object` in the opposite order.
               *
               * @static
               * @memberOf _
               * @since 2.0.0
               * @category Object
               * @param {Object} object The object to iterate over.
               * @param {Function} [iteratee=_.identity] The function invoked per iteration.
               * @returns {Object} Returns `object`.
               * @see _.forOwn
               * @example
               *
               * function Foo() {
               *   this.a = 1;
               *   this.b = 2;
               * }
               *
               * Foo.prototype.c = 3;
               *
               * _.forOwnRight(new Foo, function(value, key) {
               *   console.log(key);
               * });
               * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
               */


              function forOwnRight(object, iteratee) {
                return object && baseForOwnRight(object, getIteratee(iteratee, 3));
              }
              /**
               * Creates an array of function property names from own enumerable properties
               * of `object`.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Object
               * @param {Object} object The object to inspect.
               * @returns {Array} Returns the function names.
               * @see _.functionsIn
               * @example
               *
               * function Foo() {
               *   this.a = _.constant('a');
               *   this.b = _.constant('b');
               * }
               *
               * Foo.prototype.c = _.constant('c');
               *
               * _.functions(new Foo);
               * // => ['a', 'b']
               */


              function functions(object) {
                return object == null ? [] : baseFunctions(object, keys(object));
              }
              /**
               * Creates an array of function property names from own and inherited
               * enumerable properties of `object`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Object
               * @param {Object} object The object to inspect.
               * @returns {Array} Returns the function names.
               * @see _.functions
               * @example
               *
               * function Foo() {
               *   this.a = _.constant('a');
               *   this.b = _.constant('b');
               * }
               *
               * Foo.prototype.c = _.constant('c');
               *
               * _.functionsIn(new Foo);
               * // => ['a', 'b', 'c']
               */


              function functionsIn(object) {
                return object == null ? [] : baseFunctions(object, keysIn(object));
              }
              /**
               * Gets the value at `path` of `object`. If the resolved value is
               * `undefined`, the `defaultValue` is returned in its place.
               *
               * @static
               * @memberOf _
               * @since 3.7.0
               * @category Object
               * @param {Object} object The object to query.
               * @param {Array|string} path The path of the property to get.
               * @param {*} [defaultValue] The value returned for `undefined` resolved values.
               * @returns {*} Returns the resolved value.
               * @example
               *
               * var object = { 'a': [{ 'b': { 'c': 3 } }] };
               *
               * _.get(object, 'a[0].b.c');
               * // => 3
               *
               * _.get(object, ['a', '0', 'b', 'c']);
               * // => 3
               *
               * _.get(object, 'a.b.c', 'default');
               * // => 'default'
               */


              function get(object, path, defaultValue) {
                var result = object == null ? undefined : baseGet(object, path);
                return result === undefined ? defaultValue : result;
              }
              /**
               * Checks if `path` is a direct property of `object`.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Object
               * @param {Object} object The object to query.
               * @param {Array|string} path The path to check.
               * @returns {boolean} Returns `true` if `path` exists, else `false`.
               * @example
               *
               * var object = { 'a': { 'b': 2 } };
               * var other = _.create({ 'a': _.create({ 'b': 2 }) });
               *
               * _.has(object, 'a');
               * // => true
               *
               * _.has(object, 'a.b');
               * // => true
               *
               * _.has(object, ['a', 'b']);
               * // => true
               *
               * _.has(other, 'a');
               * // => false
               */


              function has(object, path) {
                return object != null && hasPath(object, path, baseHas);
              }
              /**
               * Checks if `path` is a direct or inherited property of `object`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Object
               * @param {Object} object The object to query.
               * @param {Array|string} path The path to check.
               * @returns {boolean} Returns `true` if `path` exists, else `false`.
               * @example
               *
               * var object = _.create({ 'a': _.create({ 'b': 2 }) });
               *
               * _.hasIn(object, 'a');
               * // => true
               *
               * _.hasIn(object, 'a.b');
               * // => true
               *
               * _.hasIn(object, ['a', 'b']);
               * // => true
               *
               * _.hasIn(object, 'b');
               * // => false
               */


              function hasIn(object, path) {
                return object != null && hasPath(object, path, baseHasIn);
              }
              /**
               * Creates an object composed of the inverted keys and values of `object`.
               * If `object` contains duplicate values, subsequent values overwrite
               * property assignments of previous values.
               *
               * @static
               * @memberOf _
               * @since 0.7.0
               * @category Object
               * @param {Object} object The object to invert.
               * @returns {Object} Returns the new inverted object.
               * @example
               *
               * var object = { 'a': 1, 'b': 2, 'c': 1 };
               *
               * _.invert(object);
               * // => { '1': 'c', '2': 'b' }
               */


              var invert = createInverter(function (result, value, key) {
                if (value != null && typeof value.toString != 'function') {
                  value = nativeObjectToString.call(value);
                }

                result[value] = key;
              }, constant(identity));
              /**
               * This method is like `_.invert` except that the inverted object is generated
               * from the results of running each element of `object` thru `iteratee`. The
               * corresponding inverted value of each inverted key is an array of keys
               * responsible for generating the inverted value. The iteratee is invoked
               * with one argument: (value).
               *
               * @static
               * @memberOf _
               * @since 4.1.0
               * @category Object
               * @param {Object} object The object to invert.
               * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
               * @returns {Object} Returns the new inverted object.
               * @example
               *
               * var object = { 'a': 1, 'b': 2, 'c': 1 };
               *
               * _.invertBy(object);
               * // => { '1': ['a', 'c'], '2': ['b'] }
               *
               * _.invertBy(object, function(value) {
               *   return 'group' + value;
               * });
               * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
               */

              var invertBy = createInverter(function (result, value, key) {
                if (value != null && typeof value.toString != 'function') {
                  value = nativeObjectToString.call(value);
                }

                if (hasOwnProperty.call(result, value)) {
                  result[value].push(key);
                } else {
                  result[value] = [key];
                }
              }, getIteratee);
              /**
               * Invokes the method at `path` of `object`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Object
               * @param {Object} object The object to query.
               * @param {Array|string} path The path of the method to invoke.
               * @param {...*} [args] The arguments to invoke the method with.
               * @returns {*} Returns the result of the invoked method.
               * @example
               *
               * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
               *
               * _.invoke(object, 'a[0].b.c.slice', 1, 3);
               * // => [2, 3]
               */

              var invoke = baseRest(baseInvoke);
              /**
               * Creates an array of the own enumerable property names of `object`.
               *
               * **Note:** Non-object values are coerced to objects. See the
               * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
               * for more details.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Object
               * @param {Object} object The object to query.
               * @returns {Array} Returns the array of property names.
               * @example
               *
               * function Foo() {
               *   this.a = 1;
               *   this.b = 2;
               * }
               *
               * Foo.prototype.c = 3;
               *
               * _.keys(new Foo);
               * // => ['a', 'b'] (iteration order is not guaranteed)
               *
               * _.keys('hi');
               * // => ['0', '1']
               */

              function keys(object) {
                return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
              }
              /**
               * Creates an array of the own and inherited enumerable property names of `object`.
               *
               * **Note:** Non-object values are coerced to objects.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Object
               * @param {Object} object The object to query.
               * @returns {Array} Returns the array of property names.
               * @example
               *
               * function Foo() {
               *   this.a = 1;
               *   this.b = 2;
               * }
               *
               * Foo.prototype.c = 3;
               *
               * _.keysIn(new Foo);
               * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
               */


              function keysIn(object) {
                return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
              }
              /**
               * The opposite of `_.mapValues`; this method creates an object with the
               * same values as `object` and keys generated by running each own enumerable
               * string keyed property of `object` thru `iteratee`. The iteratee is invoked
               * with three arguments: (value, key, object).
               *
               * @static
               * @memberOf _
               * @since 3.8.0
               * @category Object
               * @param {Object} object The object to iterate over.
               * @param {Function} [iteratee=_.identity] The function invoked per iteration.
               * @returns {Object} Returns the new mapped object.
               * @see _.mapValues
               * @example
               *
               * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
               *   return key + value;
               * });
               * // => { 'a1': 1, 'b2': 2 }
               */


              function mapKeys(object, iteratee) {
                var result = {};
                iteratee = getIteratee(iteratee, 3);
                baseForOwn(object, function (value, key, object) {
                  baseAssignValue(result, iteratee(value, key, object), value);
                });
                return result;
              }
              /**
               * Creates an object with the same keys as `object` and values generated
               * by running each own enumerable string keyed property of `object` thru
               * `iteratee`. The iteratee is invoked with three arguments:
               * (value, key, object).
               *
               * @static
               * @memberOf _
               * @since 2.4.0
               * @category Object
               * @param {Object} object The object to iterate over.
               * @param {Function} [iteratee=_.identity] The function invoked per iteration.
               * @returns {Object} Returns the new mapped object.
               * @see _.mapKeys
               * @example
               *
               * var users = {
               *   'fred':    { 'user': 'fred',    'age': 40 },
               *   'pebbles': { 'user': 'pebbles', 'age': 1 }
               * };
               *
               * _.mapValues(users, function(o) { return o.age; });
               * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
               *
               * // The `_.property` iteratee shorthand.
               * _.mapValues(users, 'age');
               * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
               */


              function mapValues(object, iteratee) {
                var result = {};
                iteratee = getIteratee(iteratee, 3);
                baseForOwn(object, function (value, key, object) {
                  baseAssignValue(result, key, iteratee(value, key, object));
                });
                return result;
              }
              /**
               * This method is like `_.assign` except that it recursively merges own and
               * inherited enumerable string keyed properties of source objects into the
               * destination object. Source properties that resolve to `undefined` are
               * skipped if a destination value exists. Array and plain object properties
               * are merged recursively. Other objects and value types are overridden by
               * assignment. Source objects are applied from left to right. Subsequent
               * sources overwrite property assignments of previous sources.
               *
               * **Note:** This method mutates `object`.
               *
               * @static
               * @memberOf _
               * @since 0.5.0
               * @category Object
               * @param {Object} object The destination object.
               * @param {...Object} [sources] The source objects.
               * @returns {Object} Returns `object`.
               * @example
               *
               * var object = {
               *   'a': [{ 'b': 2 }, { 'd': 4 }]
               * };
               *
               * var other = {
               *   'a': [{ 'c': 3 }, { 'e': 5 }]
               * };
               *
               * _.merge(object, other);
               * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
               */


              var merge = createAssigner(function (object, source, srcIndex) {
                baseMerge(object, source, srcIndex);
              });
              /**
               * This method is like `_.merge` except that it accepts `customizer` which
               * is invoked to produce the merged values of the destination and source
               * properties. If `customizer` returns `undefined`, merging is handled by the
               * method instead. The `customizer` is invoked with six arguments:
               * (objValue, srcValue, key, object, source, stack).
               *
               * **Note:** This method mutates `object`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Object
               * @param {Object} object The destination object.
               * @param {...Object} sources The source objects.
               * @param {Function} customizer The function to customize assigned values.
               * @returns {Object} Returns `object`.
               * @example
               *
               * function customizer(objValue, srcValue) {
               *   if (_.isArray(objValue)) {
               *     return objValue.concat(srcValue);
               *   }
               * }
               *
               * var object = { 'a': [1], 'b': [2] };
               * var other = { 'a': [3], 'b': [4] };
               *
               * _.mergeWith(object, other, customizer);
               * // => { 'a': [1, 3], 'b': [2, 4] }
               */

              var mergeWith = createAssigner(function (object, source, srcIndex, customizer) {
                baseMerge(object, source, srcIndex, customizer);
              });
              /**
               * The opposite of `_.pick`; this method creates an object composed of the
               * own and inherited enumerable property paths of `object` that are not omitted.
               *
               * **Note:** This method is considerably slower than `_.pick`.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Object
               * @param {Object} object The source object.
               * @param {...(string|string[])} [paths] The property paths to omit.
               * @returns {Object} Returns the new object.
               * @example
               *
               * var object = { 'a': 1, 'b': '2', 'c': 3 };
               *
               * _.omit(object, ['a', 'c']);
               * // => { 'b': '2' }
               */

              var omit = flatRest(function (object, paths) {
                var result = {};

                if (object == null) {
                  return result;
                }

                var isDeep = false;
                paths = arrayMap(paths, function (path) {
                  path = castPath(path, object);
                  isDeep || (isDeep = path.length > 1);
                  return path;
                });
                copyObject(object, getAllKeysIn(object), result);

                if (isDeep) {
                  result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
                }

                var length = paths.length;

                while (length--) {
                  baseUnset(result, paths[length]);
                }

                return result;
              });
              /**
               * The opposite of `_.pickBy`; this method creates an object composed of
               * the own and inherited enumerable string keyed properties of `object` that
               * `predicate` doesn't return truthy for. The predicate is invoked with two
               * arguments: (value, key).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Object
               * @param {Object} object The source object.
               * @param {Function} [predicate=_.identity] The function invoked per property.
               * @returns {Object} Returns the new object.
               * @example
               *
               * var object = { 'a': 1, 'b': '2', 'c': 3 };
               *
               * _.omitBy(object, _.isNumber);
               * // => { 'b': '2' }
               */

              function omitBy(object, predicate) {
                return pickBy(object, negate(getIteratee(predicate)));
              }
              /**
               * Creates an object composed of the picked `object` properties.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Object
               * @param {Object} object The source object.
               * @param {...(string|string[])} [paths] The property paths to pick.
               * @returns {Object} Returns the new object.
               * @example
               *
               * var object = { 'a': 1, 'b': '2', 'c': 3 };
               *
               * _.pick(object, ['a', 'c']);
               * // => { 'a': 1, 'c': 3 }
               */


              var pick = flatRest(function (object, paths) {
                return object == null ? {} : basePick(object, paths);
              });
              /**
               * Creates an object composed of the `object` properties `predicate` returns
               * truthy for. The predicate is invoked with two arguments: (value, key).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Object
               * @param {Object} object The source object.
               * @param {Function} [predicate=_.identity] The function invoked per property.
               * @returns {Object} Returns the new object.
               * @example
               *
               * var object = { 'a': 1, 'b': '2', 'c': 3 };
               *
               * _.pickBy(object, _.isNumber);
               * // => { 'a': 1, 'c': 3 }
               */

              function pickBy(object, predicate) {
                if (object == null) {
                  return {};
                }

                var props = arrayMap(getAllKeysIn(object), function (prop) {
                  return [prop];
                });
                predicate = getIteratee(predicate);
                return basePickBy(object, props, function (value, path) {
                  return predicate(value, path[0]);
                });
              }
              /**
               * This method is like `_.get` except that if the resolved value is a
               * function it's invoked with the `this` binding of its parent object and
               * its result is returned.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Object
               * @param {Object} object The object to query.
               * @param {Array|string} path The path of the property to resolve.
               * @param {*} [defaultValue] The value returned for `undefined` resolved values.
               * @returns {*} Returns the resolved value.
               * @example
               *
               * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
               *
               * _.result(object, 'a[0].b.c1');
               * // => 3
               *
               * _.result(object, 'a[0].b.c2');
               * // => 4
               *
               * _.result(object, 'a[0].b.c3', 'default');
               * // => 'default'
               *
               * _.result(object, 'a[0].b.c3', _.constant('default'));
               * // => 'default'
               */


              function result(object, path, defaultValue) {
                path = castPath(path, object);
                var index = -1,
                    length = path.length; // Ensure the loop is entered when path is empty.

                if (!length) {
                  length = 1;
                  object = undefined;
                }

                while (++index < length) {
                  var value = object == null ? undefined : object[toKey(path[index])];

                  if (value === undefined) {
                    index = length;
                    value = defaultValue;
                  }

                  object = isFunction(value) ? value.call(object) : value;
                }

                return object;
              }
              /**
               * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
               * it's created. Arrays are created for missing index properties while objects
               * are created for all other missing properties. Use `_.setWith` to customize
               * `path` creation.
               *
               * **Note:** This method mutates `object`.
               *
               * @static
               * @memberOf _
               * @since 3.7.0
               * @category Object
               * @param {Object} object The object to modify.
               * @param {Array|string} path The path of the property to set.
               * @param {*} value The value to set.
               * @returns {Object} Returns `object`.
               * @example
               *
               * var object = { 'a': [{ 'b': { 'c': 3 } }] };
               *
               * _.set(object, 'a[0].b.c', 4);
               * console.log(object.a[0].b.c);
               * // => 4
               *
               * _.set(object, ['x', '0', 'y', 'z'], 5);
               * console.log(object.x[0].y.z);
               * // => 5
               */


              function set(object, path, value) {
                return object == null ? object : baseSet(object, path, value);
              }
              /**
               * This method is like `_.set` except that it accepts `customizer` which is
               * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
               * path creation is handled by the method instead. The `customizer` is invoked
               * with three arguments: (nsValue, key, nsObject).
               *
               * **Note:** This method mutates `object`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Object
               * @param {Object} object The object to modify.
               * @param {Array|string} path The path of the property to set.
               * @param {*} value The value to set.
               * @param {Function} [customizer] The function to customize assigned values.
               * @returns {Object} Returns `object`.
               * @example
               *
               * var object = {};
               *
               * _.setWith(object, '[0][1]', 'a', Object);
               * // => { '0': { '1': 'a' } }
               */


              function setWith(object, path, value, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return object == null ? object : baseSet(object, path, value, customizer);
              }
              /**
               * Creates an array of own enumerable string keyed-value pairs for `object`
               * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
               * entries are returned.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @alias entries
               * @category Object
               * @param {Object} object The object to query.
               * @returns {Array} Returns the key-value pairs.
               * @example
               *
               * function Foo() {
               *   this.a = 1;
               *   this.b = 2;
               * }
               *
               * Foo.prototype.c = 3;
               *
               * _.toPairs(new Foo);
               * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
               */


              var toPairs = createToPairs(keys);
              /**
               * Creates an array of own and inherited enumerable string keyed-value pairs
               * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
               * or set, its entries are returned.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @alias entriesIn
               * @category Object
               * @param {Object} object The object to query.
               * @returns {Array} Returns the key-value pairs.
               * @example
               *
               * function Foo() {
               *   this.a = 1;
               *   this.b = 2;
               * }
               *
               * Foo.prototype.c = 3;
               *
               * _.toPairsIn(new Foo);
               * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
               */

              var toPairsIn = createToPairs(keysIn);
              /**
               * An alternative to `_.reduce`; this method transforms `object` to a new
               * `accumulator` object which is the result of running each of its own
               * enumerable string keyed properties thru `iteratee`, with each invocation
               * potentially mutating the `accumulator` object. If `accumulator` is not
               * provided, a new object with the same `[[Prototype]]` will be used. The
               * iteratee is invoked with four arguments: (accumulator, value, key, object).
               * Iteratee functions may exit iteration early by explicitly returning `false`.
               *
               * @static
               * @memberOf _
               * @since 1.3.0
               * @category Object
               * @param {Object} object The object to iterate over.
               * @param {Function} [iteratee=_.identity] The function invoked per iteration.
               * @param {*} [accumulator] The custom accumulator value.
               * @returns {*} Returns the accumulated value.
               * @example
               *
               * _.transform([2, 3, 4], function(result, n) {
               *   result.push(n *= n);
               *   return n % 2 == 0;
               * }, []);
               * // => [4, 9]
               *
               * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
               *   (result[value] || (result[value] = [])).push(key);
               * }, {});
               * // => { '1': ['a', 'c'], '2': ['b'] }
               */

              function transform(object, iteratee, accumulator) {
                var isArr = isArray(object),
                    isArrLike = isArr || isBuffer(object) || isTypedArray(object);
                iteratee = getIteratee(iteratee, 4);

                if (accumulator == null) {
                  var Ctor = object && object.constructor;

                  if (isArrLike) {
                    accumulator = isArr ? new Ctor() : [];
                  } else if (isObject(object)) {
                    accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                  } else {
                    accumulator = {};
                  }
                }

                (isArrLike ? arrayEach : baseForOwn)(object, function (value, index, object) {
                  return iteratee(accumulator, value, index, object);
                });
                return accumulator;
              }
              /**
               * Removes the property at `path` of `object`.
               *
               * **Note:** This method mutates `object`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Object
               * @param {Object} object The object to modify.
               * @param {Array|string} path The path of the property to unset.
               * @returns {boolean} Returns `true` if the property is deleted, else `false`.
               * @example
               *
               * var object = { 'a': [{ 'b': { 'c': 7 } }] };
               * _.unset(object, 'a[0].b.c');
               * // => true
               *
               * console.log(object);
               * // => { 'a': [{ 'b': {} }] };
               *
               * _.unset(object, ['a', '0', 'b', 'c']);
               * // => true
               *
               * console.log(object);
               * // => { 'a': [{ 'b': {} }] };
               */


              function unset(object, path) {
                return object == null ? true : baseUnset(object, path);
              }
              /**
               * This method is like `_.set` except that accepts `updater` to produce the
               * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
               * is invoked with one argument: (value).
               *
               * **Note:** This method mutates `object`.
               *
               * @static
               * @memberOf _
               * @since 4.6.0
               * @category Object
               * @param {Object} object The object to modify.
               * @param {Array|string} path The path of the property to set.
               * @param {Function} updater The function to produce the updated value.
               * @returns {Object} Returns `object`.
               * @example
               *
               * var object = { 'a': [{ 'b': { 'c': 3 } }] };
               *
               * _.update(object, 'a[0].b.c', function(n) { return n * n; });
               * console.log(object.a[0].b.c);
               * // => 9
               *
               * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
               * console.log(object.x[0].y.z);
               * // => 0
               */


              function update(object, path, updater) {
                return object == null ? object : baseUpdate(object, path, castFunction(updater));
              }
              /**
               * This method is like `_.update` except that it accepts `customizer` which is
               * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
               * path creation is handled by the method instead. The `customizer` is invoked
               * with three arguments: (nsValue, key, nsObject).
               *
               * **Note:** This method mutates `object`.
               *
               * @static
               * @memberOf _
               * @since 4.6.0
               * @category Object
               * @param {Object} object The object to modify.
               * @param {Array|string} path The path of the property to set.
               * @param {Function} updater The function to produce the updated value.
               * @param {Function} [customizer] The function to customize assigned values.
               * @returns {Object} Returns `object`.
               * @example
               *
               * var object = {};
               *
               * _.updateWith(object, '[0][1]', _.constant('a'), Object);
               * // => { '0': { '1': 'a' } }
               */


              function updateWith(object, path, updater, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
              }
              /**
               * Creates an array of the own enumerable string keyed property values of `object`.
               *
               * **Note:** Non-object values are coerced to objects.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Object
               * @param {Object} object The object to query.
               * @returns {Array} Returns the array of property values.
               * @example
               *
               * function Foo() {
               *   this.a = 1;
               *   this.b = 2;
               * }
               *
               * Foo.prototype.c = 3;
               *
               * _.values(new Foo);
               * // => [1, 2] (iteration order is not guaranteed)
               *
               * _.values('hi');
               * // => ['h', 'i']
               */


              function values(object) {
                return object == null ? [] : baseValues(object, keys(object));
              }
              /**
               * Creates an array of the own and inherited enumerable string keyed property
               * values of `object`.
               *
               * **Note:** Non-object values are coerced to objects.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Object
               * @param {Object} object The object to query.
               * @returns {Array} Returns the array of property values.
               * @example
               *
               * function Foo() {
               *   this.a = 1;
               *   this.b = 2;
               * }
               *
               * Foo.prototype.c = 3;
               *
               * _.valuesIn(new Foo);
               * // => [1, 2, 3] (iteration order is not guaranteed)
               */


              function valuesIn(object) {
                return object == null ? [] : baseValues(object, keysIn(object));
              }
              /*------------------------------------------------------------------------*/

              /**
               * Clamps `number` within the inclusive `lower` and `upper` bounds.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Number
               * @param {number} number The number to clamp.
               * @param {number} [lower] The lower bound.
               * @param {number} upper The upper bound.
               * @returns {number} Returns the clamped number.
               * @example
               *
               * _.clamp(-10, -5, 5);
               * // => -5
               *
               * _.clamp(10, -5, 5);
               * // => 5
               */


              function clamp(number, lower, upper) {
                if (upper === undefined) {
                  upper = lower;
                  lower = undefined;
                }

                if (upper !== undefined) {
                  upper = toNumber(upper);
                  upper = upper === upper ? upper : 0;
                }

                if (lower !== undefined) {
                  lower = toNumber(lower);
                  lower = lower === lower ? lower : 0;
                }

                return baseClamp(toNumber(number), lower, upper);
              }
              /**
               * Checks if `n` is between `start` and up to, but not including, `end`. If
               * `end` is not specified, it's set to `start` with `start` then set to `0`.
               * If `start` is greater than `end` the params are swapped to support
               * negative ranges.
               *
               * @static
               * @memberOf _
               * @since 3.3.0
               * @category Number
               * @param {number} number The number to check.
               * @param {number} [start=0] The start of the range.
               * @param {number} end The end of the range.
               * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
               * @see _.range, _.rangeRight
               * @example
               *
               * _.inRange(3, 2, 4);
               * // => true
               *
               * _.inRange(4, 8);
               * // => true
               *
               * _.inRange(4, 2);
               * // => false
               *
               * _.inRange(2, 2);
               * // => false
               *
               * _.inRange(1.2, 2);
               * // => true
               *
               * _.inRange(5.2, 4);
               * // => false
               *
               * _.inRange(-3, -2, -6);
               * // => true
               */


              function inRange(number, start, end) {
                start = toFinite(start);

                if (end === undefined) {
                  end = start;
                  start = 0;
                } else {
                  end = toFinite(end);
                }

                number = toNumber(number);
                return baseInRange(number, start, end);
              }
              /**
               * Produces a random number between the inclusive `lower` and `upper` bounds.
               * If only one argument is provided a number between `0` and the given number
               * is returned. If `floating` is `true`, or either `lower` or `upper` are
               * floats, a floating-point number is returned instead of an integer.
               *
               * **Note:** JavaScript follows the IEEE-754 standard for resolving
               * floating-point values which can produce unexpected results.
               *
               * @static
               * @memberOf _
               * @since 0.7.0
               * @category Number
               * @param {number} [lower=0] The lower bound.
               * @param {number} [upper=1] The upper bound.
               * @param {boolean} [floating] Specify returning a floating-point number.
               * @returns {number} Returns the random number.
               * @example
               *
               * _.random(0, 5);
               * // => an integer between 0 and 5
               *
               * _.random(5);
               * // => also an integer between 0 and 5
               *
               * _.random(5, true);
               * // => a floating-point number between 0 and 5
               *
               * _.random(1.2, 5.2);
               * // => a floating-point number between 1.2 and 5.2
               */


              function random(lower, upper, floating) {
                if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
                  upper = floating = undefined;
                }

                if (floating === undefined) {
                  if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                  } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                  }
                }

                if (lower === undefined && upper === undefined) {
                  lower = 0;
                  upper = 1;
                } else {
                  lower = toFinite(lower);

                  if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                  } else {
                    upper = toFinite(upper);
                  }
                }

                if (lower > upper) {
                  var temp = lower;
                  lower = upper;
                  upper = temp;
                }

                if (floating || lower % 1 || upper % 1) {
                  var rand = nativeRandom();
                  return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
                }

                return baseRandom(lower, upper);
              }
              /*------------------------------------------------------------------------*/

              /**
               * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category String
               * @param {string} [string=''] The string to convert.
               * @returns {string} Returns the camel cased string.
               * @example
               *
               * _.camelCase('Foo Bar');
               * // => 'fooBar'
               *
               * _.camelCase('--foo-bar--');
               * // => 'fooBar'
               *
               * _.camelCase('__FOO_BAR__');
               * // => 'fooBar'
               */


              var camelCase = createCompounder(function (result, word, index) {
                word = word.toLowerCase();
                return result + (index ? capitalize(word) : word);
              });
              /**
               * Converts the first character of `string` to upper case and the remaining
               * to lower case.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category String
               * @param {string} [string=''] The string to capitalize.
               * @returns {string} Returns the capitalized string.
               * @example
               *
               * _.capitalize('FRED');
               * // => 'Fred'
               */

              function capitalize(string) {
                return upperFirst(toString(string).toLowerCase());
              }
              /**
               * Deburrs `string` by converting
               * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
               * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
               * letters to basic Latin letters and removing
               * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category String
               * @param {string} [string=''] The string to deburr.
               * @returns {string} Returns the deburred string.
               * @example
               *
               * _.deburr('déjà vu');
               * // => 'deja vu'
               */


              function deburr(string) {
                string = toString(string);
                return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
              }
              /**
               * Checks if `string` ends with the given target string.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category String
               * @param {string} [string=''] The string to inspect.
               * @param {string} [target] The string to search for.
               * @param {number} [position=string.length] The position to search up to.
               * @returns {boolean} Returns `true` if `string` ends with `target`,
               *  else `false`.
               * @example
               *
               * _.endsWith('abc', 'c');
               * // => true
               *
               * _.endsWith('abc', 'b');
               * // => false
               *
               * _.endsWith('abc', 'b', 2);
               * // => true
               */


              function endsWith(string, target, position) {
                string = toString(string);
                target = baseToString(target);
                var length = string.length;
                position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
                var end = position;
                position -= target.length;
                return position >= 0 && string.slice(position, end) == target;
              }
              /**
               * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
               * corresponding HTML entities.
               *
               * **Note:** No other characters are escaped. To escape additional
               * characters use a third-party library like [_he_](https://mths.be/he).
               *
               * Though the ">" character is escaped for symmetry, characters like
               * ">" and "/" don't need escaping in HTML and have no special meaning
               * unless they're part of a tag or unquoted attribute value. See
               * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
               * (under "semi-related fun fact") for more details.
               *
               * When working with HTML you should always
               * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
               * XSS vectors.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category String
               * @param {string} [string=''] The string to escape.
               * @returns {string} Returns the escaped string.
               * @example
               *
               * _.escape('fred, barney, & pebbles');
               * // => 'fred, barney, &amp; pebbles'
               */


              function escape(string) {
                string = toString(string);
                return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
              }
              /**
               * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
               * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category String
               * @param {string} [string=''] The string to escape.
               * @returns {string} Returns the escaped string.
               * @example
               *
               * _.escapeRegExp('[lodash](https://lodash.com/)');
               * // => '\[lodash\]\(https://lodash\.com/\)'
               */


              function escapeRegExp(string) {
                string = toString(string);
                return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
              }
              /**
               * Converts `string` to
               * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category String
               * @param {string} [string=''] The string to convert.
               * @returns {string} Returns the kebab cased string.
               * @example
               *
               * _.kebabCase('Foo Bar');
               * // => 'foo-bar'
               *
               * _.kebabCase('fooBar');
               * // => 'foo-bar'
               *
               * _.kebabCase('__FOO_BAR__');
               * // => 'foo-bar'
               */


              var kebabCase = createCompounder(function (result, word, index) {
                return result + (index ? '-' : '') + word.toLowerCase();
              });
              /**
               * Converts `string`, as space separated words, to lower case.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category String
               * @param {string} [string=''] The string to convert.
               * @returns {string} Returns the lower cased string.
               * @example
               *
               * _.lowerCase('--Foo-Bar--');
               * // => 'foo bar'
               *
               * _.lowerCase('fooBar');
               * // => 'foo bar'
               *
               * _.lowerCase('__FOO_BAR__');
               * // => 'foo bar'
               */

              var lowerCase = createCompounder(function (result, word, index) {
                return result + (index ? ' ' : '') + word.toLowerCase();
              });
              /**
               * Converts the first character of `string` to lower case.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category String
               * @param {string} [string=''] The string to convert.
               * @returns {string} Returns the converted string.
               * @example
               *
               * _.lowerFirst('Fred');
               * // => 'fred'
               *
               * _.lowerFirst('FRED');
               * // => 'fRED'
               */

              var lowerFirst = createCaseFirst('toLowerCase');
              /**
               * Pads `string` on the left and right sides if it's shorter than `length`.
               * Padding characters are truncated if they can't be evenly divided by `length`.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category String
               * @param {string} [string=''] The string to pad.
               * @param {number} [length=0] The padding length.
               * @param {string} [chars=' '] The string used as padding.
               * @returns {string} Returns the padded string.
               * @example
               *
               * _.pad('abc', 8);
               * // => '  abc   '
               *
               * _.pad('abc', 8, '_-');
               * // => '_-abc_-_'
               *
               * _.pad('abc', 3);
               * // => 'abc'
               */

              function pad(string, length, chars) {
                string = toString(string);
                length = toInteger(length);
                var strLength = length ? stringSize(string) : 0;

                if (!length || strLength >= length) {
                  return string;
                }

                var mid = (length - strLength) / 2;
                return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
              }
              /**
               * Pads `string` on the right side if it's shorter than `length`. Padding
               * characters are truncated if they exceed `length`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category String
               * @param {string} [string=''] The string to pad.
               * @param {number} [length=0] The padding length.
               * @param {string} [chars=' '] The string used as padding.
               * @returns {string} Returns the padded string.
               * @example
               *
               * _.padEnd('abc', 6);
               * // => 'abc   '
               *
               * _.padEnd('abc', 6, '_-');
               * // => 'abc_-_'
               *
               * _.padEnd('abc', 3);
               * // => 'abc'
               */


              function padEnd(string, length, chars) {
                string = toString(string);
                length = toInteger(length);
                var strLength = length ? stringSize(string) : 0;
                return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
              }
              /**
               * Pads `string` on the left side if it's shorter than `length`. Padding
               * characters are truncated if they exceed `length`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category String
               * @param {string} [string=''] The string to pad.
               * @param {number} [length=0] The padding length.
               * @param {string} [chars=' '] The string used as padding.
               * @returns {string} Returns the padded string.
               * @example
               *
               * _.padStart('abc', 6);
               * // => '   abc'
               *
               * _.padStart('abc', 6, '_-');
               * // => '_-_abc'
               *
               * _.padStart('abc', 3);
               * // => 'abc'
               */


              function padStart(string, length, chars) {
                string = toString(string);
                length = toInteger(length);
                var strLength = length ? stringSize(string) : 0;
                return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
              }
              /**
               * Converts `string` to an integer of the specified radix. If `radix` is
               * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
               * hexadecimal, in which case a `radix` of `16` is used.
               *
               * **Note:** This method aligns with the
               * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
               *
               * @static
               * @memberOf _
               * @since 1.1.0
               * @category String
               * @param {string} string The string to convert.
               * @param {number} [radix=10] The radix to interpret `value` by.
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
               * @returns {number} Returns the converted integer.
               * @example
               *
               * _.parseInt('08');
               * // => 8
               *
               * _.map(['6', '08', '10'], _.parseInt);
               * // => [6, 8, 10]
               */


              function parseInt(string, radix, guard) {
                if (guard || radix == null) {
                  radix = 0;
                } else if (radix) {
                  radix = +radix;
                }

                return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
              }
              /**
               * Repeats the given string `n` times.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category String
               * @param {string} [string=''] The string to repeat.
               * @param {number} [n=1] The number of times to repeat the string.
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
               * @returns {string} Returns the repeated string.
               * @example
               *
               * _.repeat('*', 3);
               * // => '***'
               *
               * _.repeat('abc', 2);
               * // => 'abcabc'
               *
               * _.repeat('abc', 0);
               * // => ''
               */


              function repeat(string, n, guard) {
                if (guard ? isIterateeCall(string, n, guard) : n === undefined) {
                  n = 1;
                } else {
                  n = toInteger(n);
                }

                return baseRepeat(toString(string), n);
              }
              /**
               * Replaces matches for `pattern` in `string` with `replacement`.
               *
               * **Note:** This method is based on
               * [`String#replace`](https://mdn.io/String/replace).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category String
               * @param {string} [string=''] The string to modify.
               * @param {RegExp|string} pattern The pattern to replace.
               * @param {Function|string} replacement The match replacement.
               * @returns {string} Returns the modified string.
               * @example
               *
               * _.replace('Hi Fred', 'Fred', 'Barney');
               * // => 'Hi Barney'
               */


              function replace() {
                var args = arguments,
                    string = toString(args[0]);
                return args.length < 3 ? string : string.replace(args[1], args[2]);
              }
              /**
               * Converts `string` to
               * [snake case](https://en.wikipedia.org/wiki/Snake_case).
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category String
               * @param {string} [string=''] The string to convert.
               * @returns {string} Returns the snake cased string.
               * @example
               *
               * _.snakeCase('Foo Bar');
               * // => 'foo_bar'
               *
               * _.snakeCase('fooBar');
               * // => 'foo_bar'
               *
               * _.snakeCase('--FOO-BAR--');
               * // => 'foo_bar'
               */


              var snakeCase = createCompounder(function (result, word, index) {
                return result + (index ? '_' : '') + word.toLowerCase();
              });
              /**
               * Splits `string` by `separator`.
               *
               * **Note:** This method is based on
               * [`String#split`](https://mdn.io/String/split).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category String
               * @param {string} [string=''] The string to split.
               * @param {RegExp|string} separator The separator pattern to split by.
               * @param {number} [limit] The length to truncate results to.
               * @returns {Array} Returns the string segments.
               * @example
               *
               * _.split('a-b-c', '-', 2);
               * // => ['a', 'b']
               */

              function split(string, separator, limit) {
                if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
                  separator = limit = undefined;
                }

                limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;

                if (!limit) {
                  return [];
                }

                string = toString(string);

                if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                  separator = baseToString(separator);

                  if (!separator && hasUnicode(string)) {
                    return castSlice(stringToArray(string), 0, limit);
                  }
                }

                return string.split(separator, limit);
              }
              /**
               * Converts `string` to
               * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
               *
               * @static
               * @memberOf _
               * @since 3.1.0
               * @category String
               * @param {string} [string=''] The string to convert.
               * @returns {string} Returns the start cased string.
               * @example
               *
               * _.startCase('--foo-bar--');
               * // => 'Foo Bar'
               *
               * _.startCase('fooBar');
               * // => 'Foo Bar'
               *
               * _.startCase('__FOO_BAR__');
               * // => 'FOO BAR'
               */


              var startCase = createCompounder(function (result, word, index) {
                return result + (index ? ' ' : '') + upperFirst(word);
              });
              /**
               * Checks if `string` starts with the given target string.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category String
               * @param {string} [string=''] The string to inspect.
               * @param {string} [target] The string to search for.
               * @param {number} [position=0] The position to search from.
               * @returns {boolean} Returns `true` if `string` starts with `target`,
               *  else `false`.
               * @example
               *
               * _.startsWith('abc', 'a');
               * // => true
               *
               * _.startsWith('abc', 'b');
               * // => false
               *
               * _.startsWith('abc', 'b', 1);
               * // => true
               */

              function startsWith(string, target, position) {
                string = toString(string);
                position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
                target = baseToString(target);
                return string.slice(position, position + target.length) == target;
              }
              /**
               * Creates a compiled template function that can interpolate data properties
               * in "interpolate" delimiters, HTML-escape interpolated data properties in
               * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
               * properties may be accessed as free variables in the template. If a setting
               * object is given, it takes precedence over `_.templateSettings` values.
               *
               * **Note:** In the development build `_.template` utilizes
               * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
               * for easier debugging.
               *
               * For more information on precompiling templates see
               * [lodash's custom builds documentation](https://lodash.com/custom-builds).
               *
               * For more information on Chrome extension sandboxes see
               * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category String
               * @param {string} [string=''] The template string.
               * @param {Object} [options={}] The options object.
               * @param {RegExp} [options.escape=_.templateSettings.escape]
               *  The HTML "escape" delimiter.
               * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
               *  The "evaluate" delimiter.
               * @param {Object} [options.imports=_.templateSettings.imports]
               *  An object to import into the template as free variables.
               * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
               *  The "interpolate" delimiter.
               * @param {string} [options.sourceURL='lodash.templateSources[n]']
               *  The sourceURL of the compiled template.
               * @param {string} [options.variable='obj']
               *  The data object variable name.
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
               * @returns {Function} Returns the compiled template function.
               * @example
               *
               * // Use the "interpolate" delimiter to create a compiled template.
               * var compiled = _.template('hello <%= user %>!');
               * compiled({ 'user': 'fred' });
               * // => 'hello fred!'
               *
               * // Use the HTML "escape" delimiter to escape data property values.
               * var compiled = _.template('<b><%- value %></b>');
               * compiled({ 'value': '<script>' });
               * // => '<b>&lt;script&gt;</b>'
               *
               * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
               * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
               * compiled({ 'users': ['fred', 'barney'] });
               * // => '<li>fred</li><li>barney</li>'
               *
               * // Use the internal `print` function in "evaluate" delimiters.
               * var compiled = _.template('<% print("hello " + user); %>!');
               * compiled({ 'user': 'barney' });
               * // => 'hello barney!'
               *
               * // Use the ES template literal delimiter as an "interpolate" delimiter.
               * // Disable support by replacing the "interpolate" delimiter.
               * var compiled = _.template('hello ${ user }!');
               * compiled({ 'user': 'pebbles' });
               * // => 'hello pebbles!'
               *
               * // Use backslashes to treat delimiters as plain text.
               * var compiled = _.template('<%= "\\<%- value %\\>" %>');
               * compiled({ 'value': 'ignored' });
               * // => '<%- value %>'
               *
               * // Use the `imports` option to import `jQuery` as `jq`.
               * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
               * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
               * compiled({ 'users': ['fred', 'barney'] });
               * // => '<li>fred</li><li>barney</li>'
               *
               * // Use the `sourceURL` option to specify a custom sourceURL for the template.
               * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
               * compiled(data);
               * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
               *
               * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
               * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
               * compiled.source;
               * // => function(data) {
               * //   var __t, __p = '';
               * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
               * //   return __p;
               * // }
               *
               * // Use custom template delimiters.
               * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
               * var compiled = _.template('hello {{ user }}!');
               * compiled({ 'user': 'mustache' });
               * // => 'hello mustache!'
               *
               * // Use the `source` property to inline compiled templates for meaningful
               * // line numbers in error messages and stack traces.
               * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
               *   var JST = {\
               *     "main": ' + _.template(mainText).source + '\
               *   };\
               * ');
               */


              function template(string, options, guard) {
                // Based on John Resig's `tmpl` implementation
                // (http://ejohn.org/blog/javascript-micro-templating/)
                // and Laura Doktorova's doT.js (https://github.com/olado/doT).
                var settings = lodash.templateSettings;

                if (guard && isIterateeCall(string, options, guard)) {
                  options = undefined;
                }

                string = toString(string);
                options = assignInWith({}, options, settings, customDefaultsAssignIn);
                var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
                    importsKeys = keys(imports),
                    importsValues = baseValues(imports, importsKeys);
                var isEscaping,
                    isEvaluating,
                    index = 0,
                    interpolate = options.interpolate || reNoMatch,
                    source = "__p += '"; // Compile the regexp to match each delimiter.

                var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g'); // Use a sourceURL for easier debugging.
                // The sourceURL gets injected into the source that's eval-ed, so be careful
                // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
                // and escape the comment, thus injecting code that gets evaled.

                var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
                string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                  interpolateValue || (interpolateValue = esTemplateValue); // Escape characters that can't be included in string literals.

                  source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar); // Replace delimiters with snippets.

                  if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                  }

                  if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                  }

                  if (interpolateValue) {
                    source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                  }

                  index = offset + match.length; // The JS engine embedded in Adobe products needs `match` returned in
                  // order to produce the correct `offset` value.

                  return match;
                });
                source += "';\n"; // If `variable` is not specified wrap a with-statement around the generated
                // code to add the data object to the top of the scope chain.

                var variable = hasOwnProperty.call(options, 'variable') && options.variable;

                if (!variable) {
                  source = 'with (obj) {\n' + source + '\n}\n';
                } // Throw an error if a forbidden character was found in `variable`, to prevent
                // potential command injection attacks.
                else if (reForbiddenIdentifierChars.test(variable)) {
                  throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
                } // Cleanup code by stripping empty strings.


                source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;'); // Frame code as the function body.

                source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
                var result = attempt(function () {
                  return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
                }); // Provide the compiled function's source by its `toString` method or
                // the `source` property as a convenience for inlining compiled templates.

                result.source = source;

                if (isError(result)) {
                  throw result;
                }

                return result;
              }
              /**
               * Converts `string`, as a whole, to lower case just like
               * [String#toLowerCase](https://mdn.io/toLowerCase).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category String
               * @param {string} [string=''] The string to convert.
               * @returns {string} Returns the lower cased string.
               * @example
               *
               * _.toLower('--Foo-Bar--');
               * // => '--foo-bar--'
               *
               * _.toLower('fooBar');
               * // => 'foobar'
               *
               * _.toLower('__FOO_BAR__');
               * // => '__foo_bar__'
               */


              function toLower(value) {
                return toString(value).toLowerCase();
              }
              /**
               * Converts `string`, as a whole, to upper case just like
               * [String#toUpperCase](https://mdn.io/toUpperCase).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category String
               * @param {string} [string=''] The string to convert.
               * @returns {string} Returns the upper cased string.
               * @example
               *
               * _.toUpper('--foo-bar--');
               * // => '--FOO-BAR--'
               *
               * _.toUpper('fooBar');
               * // => 'FOOBAR'
               *
               * _.toUpper('__foo_bar__');
               * // => '__FOO_BAR__'
               */


              function toUpper(value) {
                return toString(value).toUpperCase();
              }
              /**
               * Removes leading and trailing whitespace or specified characters from `string`.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category String
               * @param {string} [string=''] The string to trim.
               * @param {string} [chars=whitespace] The characters to trim.
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
               * @returns {string} Returns the trimmed string.
               * @example
               *
               * _.trim('  abc  ');
               * // => 'abc'
               *
               * _.trim('-_-abc-_-', '_-');
               * // => 'abc'
               *
               * _.map(['  foo  ', '  bar  '], _.trim);
               * // => ['foo', 'bar']
               */


              function trim(string, chars, guard) {
                string = toString(string);

                if (string && (guard || chars === undefined)) {
                  return baseTrim(string);
                }

                if (!string || !(chars = baseToString(chars))) {
                  return string;
                }

                var strSymbols = stringToArray(string),
                    chrSymbols = stringToArray(chars),
                    start = charsStartIndex(strSymbols, chrSymbols),
                    end = charsEndIndex(strSymbols, chrSymbols) + 1;
                return castSlice(strSymbols, start, end).join('');
              }
              /**
               * Removes trailing whitespace or specified characters from `string`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category String
               * @param {string} [string=''] The string to trim.
               * @param {string} [chars=whitespace] The characters to trim.
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
               * @returns {string} Returns the trimmed string.
               * @example
               *
               * _.trimEnd('  abc  ');
               * // => '  abc'
               *
               * _.trimEnd('-_-abc-_-', '_-');
               * // => '-_-abc'
               */


              function trimEnd(string, chars, guard) {
                string = toString(string);

                if (string && (guard || chars === undefined)) {
                  return string.slice(0, trimmedEndIndex(string) + 1);
                }

                if (!string || !(chars = baseToString(chars))) {
                  return string;
                }

                var strSymbols = stringToArray(string),
                    end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
                return castSlice(strSymbols, 0, end).join('');
              }
              /**
               * Removes leading whitespace or specified characters from `string`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category String
               * @param {string} [string=''] The string to trim.
               * @param {string} [chars=whitespace] The characters to trim.
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
               * @returns {string} Returns the trimmed string.
               * @example
               *
               * _.trimStart('  abc  ');
               * // => 'abc  '
               *
               * _.trimStart('-_-abc-_-', '_-');
               * // => 'abc-_-'
               */


              function trimStart(string, chars, guard) {
                string = toString(string);

                if (string && (guard || chars === undefined)) {
                  return string.replace(reTrimStart, '');
                }

                if (!string || !(chars = baseToString(chars))) {
                  return string;
                }

                var strSymbols = stringToArray(string),
                    start = charsStartIndex(strSymbols, stringToArray(chars));
                return castSlice(strSymbols, start).join('');
              }
              /**
               * Truncates `string` if it's longer than the given maximum string length.
               * The last characters of the truncated string are replaced with the omission
               * string which defaults to "...".
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category String
               * @param {string} [string=''] The string to truncate.
               * @param {Object} [options={}] The options object.
               * @param {number} [options.length=30] The maximum string length.
               * @param {string} [options.omission='...'] The string to indicate text is omitted.
               * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
               * @returns {string} Returns the truncated string.
               * @example
               *
               * _.truncate('hi-diddly-ho there, neighborino');
               * // => 'hi-diddly-ho there, neighbo...'
               *
               * _.truncate('hi-diddly-ho there, neighborino', {
               *   'length': 24,
               *   'separator': ' '
               * });
               * // => 'hi-diddly-ho there,...'
               *
               * _.truncate('hi-diddly-ho there, neighborino', {
               *   'length': 24,
               *   'separator': /,? +/
               * });
               * // => 'hi-diddly-ho there...'
               *
               * _.truncate('hi-diddly-ho there, neighborino', {
               *   'omission': ' [...]'
               * });
               * // => 'hi-diddly-ho there, neig [...]'
               */


              function truncate(string, options) {
                var length = DEFAULT_TRUNC_LENGTH,
                    omission = DEFAULT_TRUNC_OMISSION;

                if (isObject(options)) {
                  var separator = 'separator' in options ? options.separator : separator;
                  length = 'length' in options ? toInteger(options.length) : length;
                  omission = 'omission' in options ? baseToString(options.omission) : omission;
                }

                string = toString(string);
                var strLength = string.length;

                if (hasUnicode(string)) {
                  var strSymbols = stringToArray(string);
                  strLength = strSymbols.length;
                }

                if (length >= strLength) {
                  return string;
                }

                var end = length - stringSize(omission);

                if (end < 1) {
                  return omission;
                }

                var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);

                if (separator === undefined) {
                  return result + omission;
                }

                if (strSymbols) {
                  end += result.length - end;
                }

                if (isRegExp(separator)) {
                  if (string.slice(end).search(separator)) {
                    var match,
                        substring = result;

                    if (!separator.global) {
                      separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
                    }

                    separator.lastIndex = 0;

                    while (match = separator.exec(substring)) {
                      var newEnd = match.index;
                    }

                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                  }
                } else if (string.indexOf(baseToString(separator), end) != end) {
                  var index = result.lastIndexOf(separator);

                  if (index > -1) {
                    result = result.slice(0, index);
                  }
                }

                return result + omission;
              }
              /**
               * The inverse of `_.escape`; this method converts the HTML entities
               * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
               * their corresponding characters.
               *
               * **Note:** No other HTML entities are unescaped. To unescape additional
               * HTML entities use a third-party library like [_he_](https://mths.be/he).
               *
               * @static
               * @memberOf _
               * @since 0.6.0
               * @category String
               * @param {string} [string=''] The string to unescape.
               * @returns {string} Returns the unescaped string.
               * @example
               *
               * _.unescape('fred, barney, &amp; pebbles');
               * // => 'fred, barney, & pebbles'
               */


              function unescape(string) {
                string = toString(string);
                return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
              }
              /**
               * Converts `string`, as space separated words, to upper case.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category String
               * @param {string} [string=''] The string to convert.
               * @returns {string} Returns the upper cased string.
               * @example
               *
               * _.upperCase('--foo-bar');
               * // => 'FOO BAR'
               *
               * _.upperCase('fooBar');
               * // => 'FOO BAR'
               *
               * _.upperCase('__foo_bar__');
               * // => 'FOO BAR'
               */


              var upperCase = createCompounder(function (result, word, index) {
                return result + (index ? ' ' : '') + word.toUpperCase();
              });
              /**
               * Converts the first character of `string` to upper case.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category String
               * @param {string} [string=''] The string to convert.
               * @returns {string} Returns the converted string.
               * @example
               *
               * _.upperFirst('fred');
               * // => 'Fred'
               *
               * _.upperFirst('FRED');
               * // => 'FRED'
               */

              var upperFirst = createCaseFirst('toUpperCase');
              /**
               * Splits `string` into an array of its words.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category String
               * @param {string} [string=''] The string to inspect.
               * @param {RegExp|string} [pattern] The pattern to match words.
               * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
               * @returns {Array} Returns the words of `string`.
               * @example
               *
               * _.words('fred, barney, & pebbles');
               * // => ['fred', 'barney', 'pebbles']
               *
               * _.words('fred, barney, & pebbles', /[^, ]+/g);
               * // => ['fred', 'barney', '&', 'pebbles']
               */

              function words(string, pattern, guard) {
                string = toString(string);
                pattern = guard ? undefined : pattern;

                if (pattern === undefined) {
                  return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
                }

                return string.match(pattern) || [];
              }
              /*------------------------------------------------------------------------*/

              /**
               * Attempts to invoke `func`, returning either the result or the caught error
               * object. Any additional arguments are provided to `func` when it's invoked.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Util
               * @param {Function} func The function to attempt.
               * @param {...*} [args] The arguments to invoke `func` with.
               * @returns {*} Returns the `func` result or error object.
               * @example
               *
               * // Avoid throwing errors for invalid selectors.
               * var elements = _.attempt(function(selector) {
               *   return document.querySelectorAll(selector);
               * }, '>_>');
               *
               * if (_.isError(elements)) {
               *   elements = [];
               * }
               */


              var attempt = baseRest(function (func, args) {
                try {
                  return apply(func, undefined, args);
                } catch (e) {
                  return isError(e) ? e : new Error(e);
                }
              });
              /**
               * Binds methods of an object to the object itself, overwriting the existing
               * method.
               *
               * **Note:** This method doesn't set the "length" property of bound functions.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Util
               * @param {Object} object The object to bind and assign the bound methods to.
               * @param {...(string|string[])} methodNames The object method names to bind.
               * @returns {Object} Returns `object`.
               * @example
               *
               * var view = {
               *   'label': 'docs',
               *   'click': function() {
               *     console.log('clicked ' + this.label);
               *   }
               * };
               *
               * _.bindAll(view, ['click']);
               * jQuery(element).on('click', view.click);
               * // => Logs 'clicked docs' when clicked.
               */

              var bindAll = flatRest(function (object, methodNames) {
                arrayEach(methodNames, function (key) {
                  key = toKey(key);
                  baseAssignValue(object, key, bind(object[key], object));
                });
                return object;
              });
              /**
               * Creates a function that iterates over `pairs` and invokes the corresponding
               * function of the first predicate to return truthy. The predicate-function
               * pairs are invoked with the `this` binding and arguments of the created
               * function.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Util
               * @param {Array} pairs The predicate-function pairs.
               * @returns {Function} Returns the new composite function.
               * @example
               *
               * var func = _.cond([
               *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
               *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
               *   [_.stubTrue,                      _.constant('no match')]
               * ]);
               *
               * func({ 'a': 1, 'b': 2 });
               * // => 'matches A'
               *
               * func({ 'a': 0, 'b': 1 });
               * // => 'matches B'
               *
               * func({ 'a': '1', 'b': '2' });
               * // => 'no match'
               */

              function cond(pairs) {
                var length = pairs == null ? 0 : pairs.length,
                    toIteratee = getIteratee();
                pairs = !length ? [] : arrayMap(pairs, function (pair) {
                  if (typeof pair[1] != 'function') {
                    throw new TypeError(FUNC_ERROR_TEXT);
                  }

                  return [toIteratee(pair[0]), pair[1]];
                });
                return baseRest(function (args) {
                  var index = -1;

                  while (++index < length) {
                    var pair = pairs[index];

                    if (apply(pair[0], this, args)) {
                      return apply(pair[1], this, args);
                    }
                  }
                });
              }
              /**
               * Creates a function that invokes the predicate properties of `source` with
               * the corresponding property values of a given object, returning `true` if
               * all predicates return truthy, else `false`.
               *
               * **Note:** The created function is equivalent to `_.conformsTo` with
               * `source` partially applied.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Util
               * @param {Object} source The object of property predicates to conform to.
               * @returns {Function} Returns the new spec function.
               * @example
               *
               * var objects = [
               *   { 'a': 2, 'b': 1 },
               *   { 'a': 1, 'b': 2 }
               * ];
               *
               * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
               * // => [{ 'a': 1, 'b': 2 }]
               */


              function conforms(source) {
                return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
              }
              /**
               * Creates a function that returns `value`.
               *
               * @static
               * @memberOf _
               * @since 2.4.0
               * @category Util
               * @param {*} value The value to return from the new function.
               * @returns {Function} Returns the new constant function.
               * @example
               *
               * var objects = _.times(2, _.constant({ 'a': 1 }));
               *
               * console.log(objects);
               * // => [{ 'a': 1 }, { 'a': 1 }]
               *
               * console.log(objects[0] === objects[1]);
               * // => true
               */


              function constant(value) {
                return function () {
                  return value;
                };
              }
              /**
               * Checks `value` to determine whether a default value should be returned in
               * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
               * or `undefined`.
               *
               * @static
               * @memberOf _
               * @since 4.14.0
               * @category Util
               * @param {*} value The value to check.
               * @param {*} defaultValue The default value.
               * @returns {*} Returns the resolved value.
               * @example
               *
               * _.defaultTo(1, 10);
               * // => 1
               *
               * _.defaultTo(undefined, 10);
               * // => 10
               */


              function defaultTo(value, defaultValue) {
                return value == null || value !== value ? defaultValue : value;
              }
              /**
               * Creates a function that returns the result of invoking the given functions
               * with the `this` binding of the created function, where each successive
               * invocation is supplied the return value of the previous.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Util
               * @param {...(Function|Function[])} [funcs] The functions to invoke.
               * @returns {Function} Returns the new composite function.
               * @see _.flowRight
               * @example
               *
               * function square(n) {
               *   return n * n;
               * }
               *
               * var addSquare = _.flow([_.add, square]);
               * addSquare(1, 2);
               * // => 9
               */


              var flow = createFlow();
              /**
               * This method is like `_.flow` except that it creates a function that
               * invokes the given functions from right to left.
               *
               * @static
               * @since 3.0.0
               * @memberOf _
               * @category Util
               * @param {...(Function|Function[])} [funcs] The functions to invoke.
               * @returns {Function} Returns the new composite function.
               * @see _.flow
               * @example
               *
               * function square(n) {
               *   return n * n;
               * }
               *
               * var addSquare = _.flowRight([square, _.add]);
               * addSquare(1, 2);
               * // => 9
               */

              var flowRight = createFlow(true);
              /**
               * This method returns the first argument it receives.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Util
               * @param {*} value Any value.
               * @returns {*} Returns `value`.
               * @example
               *
               * var object = { 'a': 1 };
               *
               * console.log(_.identity(object) === object);
               * // => true
               */

              function identity(value) {
                return value;
              }
              /**
               * Creates a function that invokes `func` with the arguments of the created
               * function. If `func` is a property name, the created function returns the
               * property value for a given element. If `func` is an array or object, the
               * created function returns `true` for elements that contain the equivalent
               * source properties, otherwise it returns `false`.
               *
               * @static
               * @since 4.0.0
               * @memberOf _
               * @category Util
               * @param {*} [func=_.identity] The value to convert to a callback.
               * @returns {Function} Returns the callback.
               * @example
               *
               * var users = [
               *   { 'user': 'barney', 'age': 36, 'active': true },
               *   { 'user': 'fred',   'age': 40, 'active': false }
               * ];
               *
               * // The `_.matches` iteratee shorthand.
               * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
               * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
               *
               * // The `_.matchesProperty` iteratee shorthand.
               * _.filter(users, _.iteratee(['user', 'fred']));
               * // => [{ 'user': 'fred', 'age': 40 }]
               *
               * // The `_.property` iteratee shorthand.
               * _.map(users, _.iteratee('user'));
               * // => ['barney', 'fred']
               *
               * // Create custom iteratee shorthands.
               * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
               *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
               *     return func.test(string);
               *   };
               * });
               *
               * _.filter(['abc', 'def'], /ef/);
               * // => ['def']
               */


              function iteratee(func) {
                return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
              }
              /**
               * Creates a function that performs a partial deep comparison between a given
               * object and `source`, returning `true` if the given object has equivalent
               * property values, else `false`.
               *
               * **Note:** The created function is equivalent to `_.isMatch` with `source`
               * partially applied.
               *
               * Partial comparisons will match empty array and empty object `source`
               * values against any array or object value, respectively. See `_.isEqual`
               * for a list of supported value comparisons.
               *
               * **Note:** Multiple values can be checked by combining several matchers
               * using `_.overSome`
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Util
               * @param {Object} source The object of property values to match.
               * @returns {Function} Returns the new spec function.
               * @example
               *
               * var objects = [
               *   { 'a': 1, 'b': 2, 'c': 3 },
               *   { 'a': 4, 'b': 5, 'c': 6 }
               * ];
               *
               * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
               * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
               *
               * // Checking for several possible values
               * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
               * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
               */


              function matches(source) {
                return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
              }
              /**
               * Creates a function that performs a partial deep comparison between the
               * value at `path` of a given object to `srcValue`, returning `true` if the
               * object value is equivalent, else `false`.
               *
               * **Note:** Partial comparisons will match empty array and empty object
               * `srcValue` values against any array or object value, respectively. See
               * `_.isEqual` for a list of supported value comparisons.
               *
               * **Note:** Multiple values can be checked by combining several matchers
               * using `_.overSome`
               *
               * @static
               * @memberOf _
               * @since 3.2.0
               * @category Util
               * @param {Array|string} path The path of the property to get.
               * @param {*} srcValue The value to match.
               * @returns {Function} Returns the new spec function.
               * @example
               *
               * var objects = [
               *   { 'a': 1, 'b': 2, 'c': 3 },
               *   { 'a': 4, 'b': 5, 'c': 6 }
               * ];
               *
               * _.find(objects, _.matchesProperty('a', 4));
               * // => { 'a': 4, 'b': 5, 'c': 6 }
               *
               * // Checking for several possible values
               * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
               * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
               */


              function matchesProperty(path, srcValue) {
                return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
              }
              /**
               * Creates a function that invokes the method at `path` of a given object.
               * Any additional arguments are provided to the invoked method.
               *
               * @static
               * @memberOf _
               * @since 3.7.0
               * @category Util
               * @param {Array|string} path The path of the method to invoke.
               * @param {...*} [args] The arguments to invoke the method with.
               * @returns {Function} Returns the new invoker function.
               * @example
               *
               * var objects = [
               *   { 'a': { 'b': _.constant(2) } },
               *   { 'a': { 'b': _.constant(1) } }
               * ];
               *
               * _.map(objects, _.method('a.b'));
               * // => [2, 1]
               *
               * _.map(objects, _.method(['a', 'b']));
               * // => [2, 1]
               */


              var method = baseRest(function (path, args) {
                return function (object) {
                  return baseInvoke(object, path, args);
                };
              });
              /**
               * The opposite of `_.method`; this method creates a function that invokes
               * the method at a given path of `object`. Any additional arguments are
               * provided to the invoked method.
               *
               * @static
               * @memberOf _
               * @since 3.7.0
               * @category Util
               * @param {Object} object The object to query.
               * @param {...*} [args] The arguments to invoke the method with.
               * @returns {Function} Returns the new invoker function.
               * @example
               *
               * var array = _.times(3, _.constant),
               *     object = { 'a': array, 'b': array, 'c': array };
               *
               * _.map(['a[2]', 'c[0]'], _.methodOf(object));
               * // => [2, 0]
               *
               * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
               * // => [2, 0]
               */

              var methodOf = baseRest(function (object, args) {
                return function (path) {
                  return baseInvoke(object, path, args);
                };
              });
              /**
               * Adds all own enumerable string keyed function properties of a source
               * object to the destination object. If `object` is a function, then methods
               * are added to its prototype as well.
               *
               * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
               * avoid conflicts caused by modifying the original.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Util
               * @param {Function|Object} [object=lodash] The destination object.
               * @param {Object} source The object of functions to add.
               * @param {Object} [options={}] The options object.
               * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
               * @returns {Function|Object} Returns `object`.
               * @example
               *
               * function vowels(string) {
               *   return _.filter(string, function(v) {
               *     return /[aeiou]/i.test(v);
               *   });
               * }
               *
               * _.mixin({ 'vowels': vowels });
               * _.vowels('fred');
               * // => ['e']
               *
               * _('fred').vowels().value();
               * // => ['e']
               *
               * _.mixin({ 'vowels': vowels }, { 'chain': false });
               * _('fred').vowels();
               * // => ['e']
               */

              function mixin(object, source, options) {
                var props = keys(source),
                    methodNames = baseFunctions(source, props);

                if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                  options = source;
                  source = object;
                  object = this;
                  methodNames = baseFunctions(source, keys(source));
                }

                var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
                    isFunc = isFunction(object);
                arrayEach(methodNames, function (methodName) {
                  var func = source[methodName];
                  object[methodName] = func;

                  if (isFunc) {
                    object.prototype[methodName] = function () {
                      var chainAll = this.__chain__;

                      if (chain || chainAll) {
                        var result = object(this.__wrapped__),
                            actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                          'func': func,
                          'args': arguments,
                          'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                      }

                      return func.apply(object, arrayPush([this.value()], arguments));
                    };
                  }
                });
                return object;
              }
              /**
               * Reverts the `_` variable to its previous value and returns a reference to
               * the `lodash` function.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Util
               * @returns {Function} Returns the `lodash` function.
               * @example
               *
               * var lodash = _.noConflict();
               */


              function noConflict() {
                if (root._ === this) {
                  root._ = oldDash;
                }

                return this;
              }
              /**
               * This method returns `undefined`.
               *
               * @static
               * @memberOf _
               * @since 2.3.0
               * @category Util
               * @example
               *
               * _.times(2, _.noop);
               * // => [undefined, undefined]
               */


              function noop() {// No operation performed.
              }
              /**
               * Creates a function that gets the argument at index `n`. If `n` is negative,
               * the nth argument from the end is returned.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Util
               * @param {number} [n=0] The index of the argument to return.
               * @returns {Function} Returns the new pass-thru function.
               * @example
               *
               * var func = _.nthArg(1);
               * func('a', 'b', 'c', 'd');
               * // => 'b'
               *
               * var func = _.nthArg(-2);
               * func('a', 'b', 'c', 'd');
               * // => 'c'
               */


              function nthArg(n) {
                n = toInteger(n);
                return baseRest(function (args) {
                  return baseNth(args, n);
                });
              }
              /**
               * Creates a function that invokes `iteratees` with the arguments it receives
               * and returns their results.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Util
               * @param {...(Function|Function[])} [iteratees=[_.identity]]
               *  The iteratees to invoke.
               * @returns {Function} Returns the new function.
               * @example
               *
               * var func = _.over([Math.max, Math.min]);
               *
               * func(1, 2, 3, 4);
               * // => [4, 1]
               */


              var over = createOver(arrayMap);
              /**
               * Creates a function that checks if **all** of the `predicates` return
               * truthy when invoked with the arguments it receives.
               *
               * Following shorthands are possible for providing predicates.
               * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
               * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Util
               * @param {...(Function|Function[])} [predicates=[_.identity]]
               *  The predicates to check.
               * @returns {Function} Returns the new function.
               * @example
               *
               * var func = _.overEvery([Boolean, isFinite]);
               *
               * func('1');
               * // => true
               *
               * func(null);
               * // => false
               *
               * func(NaN);
               * // => false
               */

              var overEvery = createOver(arrayEvery);
              /**
               * Creates a function that checks if **any** of the `predicates` return
               * truthy when invoked with the arguments it receives.
               *
               * Following shorthands are possible for providing predicates.
               * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
               * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Util
               * @param {...(Function|Function[])} [predicates=[_.identity]]
               *  The predicates to check.
               * @returns {Function} Returns the new function.
               * @example
               *
               * var func = _.overSome([Boolean, isFinite]);
               *
               * func('1');
               * // => true
               *
               * func(null);
               * // => true
               *
               * func(NaN);
               * // => false
               *
               * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
               * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
               */

              var overSome = createOver(arraySome);
              /**
               * Creates a function that returns the value at `path` of a given object.
               *
               * @static
               * @memberOf _
               * @since 2.4.0
               * @category Util
               * @param {Array|string} path The path of the property to get.
               * @returns {Function} Returns the new accessor function.
               * @example
               *
               * var objects = [
               *   { 'a': { 'b': 2 } },
               *   { 'a': { 'b': 1 } }
               * ];
               *
               * _.map(objects, _.property('a.b'));
               * // => [2, 1]
               *
               * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
               * // => [1, 2]
               */

              function property(path) {
                return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
              }
              /**
               * The opposite of `_.property`; this method creates a function that returns
               * the value at a given path of `object`.
               *
               * @static
               * @memberOf _
               * @since 3.0.0
               * @category Util
               * @param {Object} object The object to query.
               * @returns {Function} Returns the new accessor function.
               * @example
               *
               * var array = [0, 1, 2],
               *     object = { 'a': array, 'b': array, 'c': array };
               *
               * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
               * // => [2, 0]
               *
               * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
               * // => [2, 0]
               */


              function propertyOf(object) {
                return function (path) {
                  return object == null ? undefined : baseGet(object, path);
                };
              }
              /**
               * Creates an array of numbers (positive and/or negative) progressing from
               * `start` up to, but not including, `end`. A step of `-1` is used if a negative
               * `start` is specified without an `end` or `step`. If `end` is not specified,
               * it's set to `start` with `start` then set to `0`.
               *
               * **Note:** JavaScript follows the IEEE-754 standard for resolving
               * floating-point values which can produce unexpected results.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Util
               * @param {number} [start=0] The start of the range.
               * @param {number} end The end of the range.
               * @param {number} [step=1] The value to increment or decrement by.
               * @returns {Array} Returns the range of numbers.
               * @see _.inRange, _.rangeRight
               * @example
               *
               * _.range(4);
               * // => [0, 1, 2, 3]
               *
               * _.range(-4);
               * // => [0, -1, -2, -3]
               *
               * _.range(1, 5);
               * // => [1, 2, 3, 4]
               *
               * _.range(0, 20, 5);
               * // => [0, 5, 10, 15]
               *
               * _.range(0, -4, -1);
               * // => [0, -1, -2, -3]
               *
               * _.range(1, 4, 0);
               * // => [1, 1, 1]
               *
               * _.range(0);
               * // => []
               */


              var range = createRange();
              /**
               * This method is like `_.range` except that it populates values in
               * descending order.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Util
               * @param {number} [start=0] The start of the range.
               * @param {number} end The end of the range.
               * @param {number} [step=1] The value to increment or decrement by.
               * @returns {Array} Returns the range of numbers.
               * @see _.inRange, _.range
               * @example
               *
               * _.rangeRight(4);
               * // => [3, 2, 1, 0]
               *
               * _.rangeRight(-4);
               * // => [-3, -2, -1, 0]
               *
               * _.rangeRight(1, 5);
               * // => [4, 3, 2, 1]
               *
               * _.rangeRight(0, 20, 5);
               * // => [15, 10, 5, 0]
               *
               * _.rangeRight(0, -4, -1);
               * // => [-3, -2, -1, 0]
               *
               * _.rangeRight(1, 4, 0);
               * // => [1, 1, 1]
               *
               * _.rangeRight(0);
               * // => []
               */

              var rangeRight = createRange(true);
              /**
               * This method returns a new empty array.
               *
               * @static
               * @memberOf _
               * @since 4.13.0
               * @category Util
               * @returns {Array} Returns the new empty array.
               * @example
               *
               * var arrays = _.times(2, _.stubArray);
               *
               * console.log(arrays);
               * // => [[], []]
               *
               * console.log(arrays[0] === arrays[1]);
               * // => false
               */

              function stubArray() {
                return [];
              }
              /**
               * This method returns `false`.
               *
               * @static
               * @memberOf _
               * @since 4.13.0
               * @category Util
               * @returns {boolean} Returns `false`.
               * @example
               *
               * _.times(2, _.stubFalse);
               * // => [false, false]
               */


              function stubFalse() {
                return false;
              }
              /**
               * This method returns a new empty object.
               *
               * @static
               * @memberOf _
               * @since 4.13.0
               * @category Util
               * @returns {Object} Returns the new empty object.
               * @example
               *
               * var objects = _.times(2, _.stubObject);
               *
               * console.log(objects);
               * // => [{}, {}]
               *
               * console.log(objects[0] === objects[1]);
               * // => false
               */


              function stubObject() {
                return {};
              }
              /**
               * This method returns an empty string.
               *
               * @static
               * @memberOf _
               * @since 4.13.0
               * @category Util
               * @returns {string} Returns the empty string.
               * @example
               *
               * _.times(2, _.stubString);
               * // => ['', '']
               */


              function stubString() {
                return '';
              }
              /**
               * This method returns `true`.
               *
               * @static
               * @memberOf _
               * @since 4.13.0
               * @category Util
               * @returns {boolean} Returns `true`.
               * @example
               *
               * _.times(2, _.stubTrue);
               * // => [true, true]
               */


              function stubTrue() {
                return true;
              }
              /**
               * Invokes the iteratee `n` times, returning an array of the results of
               * each invocation. The iteratee is invoked with one argument; (index).
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Util
               * @param {number} n The number of times to invoke `iteratee`.
               * @param {Function} [iteratee=_.identity] The function invoked per iteration.
               * @returns {Array} Returns the array of results.
               * @example
               *
               * _.times(3, String);
               * // => ['0', '1', '2']
               *
               *  _.times(4, _.constant(0));
               * // => [0, 0, 0, 0]
               */


              function times(n, iteratee) {
                n = toInteger(n);

                if (n < 1 || n > MAX_SAFE_INTEGER) {
                  return [];
                }

                var index = MAX_ARRAY_LENGTH,
                    length = nativeMin(n, MAX_ARRAY_LENGTH);
                iteratee = getIteratee(iteratee);
                n -= MAX_ARRAY_LENGTH;
                var result = baseTimes(length, iteratee);

                while (++index < n) {
                  iteratee(index);
                }

                return result;
              }
              /**
               * Converts `value` to a property path array.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Util
               * @param {*} value The value to convert.
               * @returns {Array} Returns the new property path array.
               * @example
               *
               * _.toPath('a.b.c');
               * // => ['a', 'b', 'c']
               *
               * _.toPath('a[0].b.c');
               * // => ['a', '0', 'b', 'c']
               */


              function toPath(value) {
                if (isArray(value)) {
                  return arrayMap(value, toKey);
                }

                return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
              }
              /**
               * Generates a unique ID. If `prefix` is given, the ID is appended to it.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Util
               * @param {string} [prefix=''] The value to prefix the ID with.
               * @returns {string} Returns the unique ID.
               * @example
               *
               * _.uniqueId('contact_');
               * // => 'contact_104'
               *
               * _.uniqueId();
               * // => '105'
               */


              function uniqueId(prefix) {
                var id = ++idCounter;
                return toString(prefix) + id;
              }
              /*------------------------------------------------------------------------*/

              /**
               * Adds two numbers.
               *
               * @static
               * @memberOf _
               * @since 3.4.0
               * @category Math
               * @param {number} augend The first number in an addition.
               * @param {number} addend The second number in an addition.
               * @returns {number} Returns the total.
               * @example
               *
               * _.add(6, 4);
               * // => 10
               */


              var add = createMathOperation(function (augend, addend) {
                return augend + addend;
              }, 0);
              /**
               * Computes `number` rounded up to `precision`.
               *
               * @static
               * @memberOf _
               * @since 3.10.0
               * @category Math
               * @param {number} number The number to round up.
               * @param {number} [precision=0] The precision to round up to.
               * @returns {number} Returns the rounded up number.
               * @example
               *
               * _.ceil(4.006);
               * // => 5
               *
               * _.ceil(6.004, 2);
               * // => 6.01
               *
               * _.ceil(6040, -2);
               * // => 6100
               */

              var ceil = createRound('ceil');
              /**
               * Divide two numbers.
               *
               * @static
               * @memberOf _
               * @since 4.7.0
               * @category Math
               * @param {number} dividend The first number in a division.
               * @param {number} divisor The second number in a division.
               * @returns {number} Returns the quotient.
               * @example
               *
               * _.divide(6, 4);
               * // => 1.5
               */

              var divide = createMathOperation(function (dividend, divisor) {
                return dividend / divisor;
              }, 1);
              /**
               * Computes `number` rounded down to `precision`.
               *
               * @static
               * @memberOf _
               * @since 3.10.0
               * @category Math
               * @param {number} number The number to round down.
               * @param {number} [precision=0] The precision to round down to.
               * @returns {number} Returns the rounded down number.
               * @example
               *
               * _.floor(4.006);
               * // => 4
               *
               * _.floor(0.046, 2);
               * // => 0.04
               *
               * _.floor(4060, -2);
               * // => 4000
               */

              var floor = createRound('floor');
              /**
               * Computes the maximum value of `array`. If `array` is empty or falsey,
               * `undefined` is returned.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Math
               * @param {Array} array The array to iterate over.
               * @returns {*} Returns the maximum value.
               * @example
               *
               * _.max([4, 2, 8, 6]);
               * // => 8
               *
               * _.max([]);
               * // => undefined
               */

              function max(array) {
                return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
              }
              /**
               * This method is like `_.max` except that it accepts `iteratee` which is
               * invoked for each element in `array` to generate the criterion by which
               * the value is ranked. The iteratee is invoked with one argument: (value).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Math
               * @param {Array} array The array to iterate over.
               * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
               * @returns {*} Returns the maximum value.
               * @example
               *
               * var objects = [{ 'n': 1 }, { 'n': 2 }];
               *
               * _.maxBy(objects, function(o) { return o.n; });
               * // => { 'n': 2 }
               *
               * // The `_.property` iteratee shorthand.
               * _.maxBy(objects, 'n');
               * // => { 'n': 2 }
               */


              function maxBy(array, iteratee) {
                return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
              }
              /**
               * Computes the mean of the values in `array`.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Math
               * @param {Array} array The array to iterate over.
               * @returns {number} Returns the mean.
               * @example
               *
               * _.mean([4, 2, 8, 6]);
               * // => 5
               */


              function mean(array) {
                return baseMean(array, identity);
              }
              /**
               * This method is like `_.mean` except that it accepts `iteratee` which is
               * invoked for each element in `array` to generate the value to be averaged.
               * The iteratee is invoked with one argument: (value).
               *
               * @static
               * @memberOf _
               * @since 4.7.0
               * @category Math
               * @param {Array} array The array to iterate over.
               * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
               * @returns {number} Returns the mean.
               * @example
               *
               * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
               *
               * _.meanBy(objects, function(o) { return o.n; });
               * // => 5
               *
               * // The `_.property` iteratee shorthand.
               * _.meanBy(objects, 'n');
               * // => 5
               */


              function meanBy(array, iteratee) {
                return baseMean(array, getIteratee(iteratee, 2));
              }
              /**
               * Computes the minimum value of `array`. If `array` is empty or falsey,
               * `undefined` is returned.
               *
               * @static
               * @since 0.1.0
               * @memberOf _
               * @category Math
               * @param {Array} array The array to iterate over.
               * @returns {*} Returns the minimum value.
               * @example
               *
               * _.min([4, 2, 8, 6]);
               * // => 2
               *
               * _.min([]);
               * // => undefined
               */


              function min(array) {
                return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
              }
              /**
               * This method is like `_.min` except that it accepts `iteratee` which is
               * invoked for each element in `array` to generate the criterion by which
               * the value is ranked. The iteratee is invoked with one argument: (value).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Math
               * @param {Array} array The array to iterate over.
               * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
               * @returns {*} Returns the minimum value.
               * @example
               *
               * var objects = [{ 'n': 1 }, { 'n': 2 }];
               *
               * _.minBy(objects, function(o) { return o.n; });
               * // => { 'n': 1 }
               *
               * // The `_.property` iteratee shorthand.
               * _.minBy(objects, 'n');
               * // => { 'n': 1 }
               */


              function minBy(array, iteratee) {
                return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
              }
              /**
               * Multiply two numbers.
               *
               * @static
               * @memberOf _
               * @since 4.7.0
               * @category Math
               * @param {number} multiplier The first number in a multiplication.
               * @param {number} multiplicand The second number in a multiplication.
               * @returns {number} Returns the product.
               * @example
               *
               * _.multiply(6, 4);
               * // => 24
               */


              var multiply = createMathOperation(function (multiplier, multiplicand) {
                return multiplier * multiplicand;
              }, 1);
              /**
               * Computes `number` rounded to `precision`.
               *
               * @static
               * @memberOf _
               * @since 3.10.0
               * @category Math
               * @param {number} number The number to round.
               * @param {number} [precision=0] The precision to round to.
               * @returns {number} Returns the rounded number.
               * @example
               *
               * _.round(4.006);
               * // => 4
               *
               * _.round(4.006, 2);
               * // => 4.01
               *
               * _.round(4060, -2);
               * // => 4100
               */

              var round = createRound('round');
              /**
               * Subtract two numbers.
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Math
               * @param {number} minuend The first number in a subtraction.
               * @param {number} subtrahend The second number in a subtraction.
               * @returns {number} Returns the difference.
               * @example
               *
               * _.subtract(6, 4);
               * // => 2
               */

              var subtract = createMathOperation(function (minuend, subtrahend) {
                return minuend - subtrahend;
              }, 0);
              /**
               * Computes the sum of the values in `array`.
               *
               * @static
               * @memberOf _
               * @since 3.4.0
               * @category Math
               * @param {Array} array The array to iterate over.
               * @returns {number} Returns the sum.
               * @example
               *
               * _.sum([4, 2, 8, 6]);
               * // => 20
               */

              function sum(array) {
                return array && array.length ? baseSum(array, identity) : 0;
              }
              /**
               * This method is like `_.sum` except that it accepts `iteratee` which is
               * invoked for each element in `array` to generate the value to be summed.
               * The iteratee is invoked with one argument: (value).
               *
               * @static
               * @memberOf _
               * @since 4.0.0
               * @category Math
               * @param {Array} array The array to iterate over.
               * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
               * @returns {number} Returns the sum.
               * @example
               *
               * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
               *
               * _.sumBy(objects, function(o) { return o.n; });
               * // => 20
               *
               * // The `_.property` iteratee shorthand.
               * _.sumBy(objects, 'n');
               * // => 20
               */


              function sumBy(array, iteratee) {
                return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
              }
              /*------------------------------------------------------------------------*/
              // Add methods that return wrapped values in chain sequences.


              lodash.after = after;
              lodash.ary = ary;
              lodash.assign = assign;
              lodash.assignIn = assignIn;
              lodash.assignInWith = assignInWith;
              lodash.assignWith = assignWith;
              lodash.at = at;
              lodash.before = before;
              lodash.bind = bind;
              lodash.bindAll = bindAll;
              lodash.bindKey = bindKey;
              lodash.castArray = castArray;
              lodash.chain = chain;
              lodash.chunk = chunk;
              lodash.compact = compact;
              lodash.concat = concat;
              lodash.cond = cond;
              lodash.conforms = conforms;
              lodash.constant = constant;
              lodash.countBy = countBy;
              lodash.create = create;
              lodash.curry = curry;
              lodash.curryRight = curryRight;
              lodash.debounce = debounce;
              lodash.defaults = defaults;
              lodash.defaultsDeep = defaultsDeep;
              lodash.defer = defer;
              lodash.delay = delay;
              lodash.difference = difference;
              lodash.differenceBy = differenceBy;
              lodash.differenceWith = differenceWith;
              lodash.drop = drop;
              lodash.dropRight = dropRight;
              lodash.dropRightWhile = dropRightWhile;
              lodash.dropWhile = dropWhile;
              lodash.fill = fill;
              lodash.filter = filter;
              lodash.flatMap = flatMap;
              lodash.flatMapDeep = flatMapDeep;
              lodash.flatMapDepth = flatMapDepth;
              lodash.flatten = flatten;
              lodash.flattenDeep = flattenDeep;
              lodash.flattenDepth = flattenDepth;
              lodash.flip = flip;
              lodash.flow = flow;
              lodash.flowRight = flowRight;
              lodash.fromPairs = fromPairs;
              lodash.functions = functions;
              lodash.functionsIn = functionsIn;
              lodash.groupBy = groupBy;
              lodash.initial = initial;
              lodash.intersection = intersection;
              lodash.intersectionBy = intersectionBy;
              lodash.intersectionWith = intersectionWith;
              lodash.invert = invert;
              lodash.invertBy = invertBy;
              lodash.invokeMap = invokeMap;
              lodash.iteratee = iteratee;
              lodash.keyBy = keyBy;
              lodash.keys = keys;
              lodash.keysIn = keysIn;
              lodash.map = map;
              lodash.mapKeys = mapKeys;
              lodash.mapValues = mapValues;
              lodash.matches = matches;
              lodash.matchesProperty = matchesProperty;
              lodash.memoize = memoize;
              lodash.merge = merge;
              lodash.mergeWith = mergeWith;
              lodash.method = method;
              lodash.methodOf = methodOf;
              lodash.mixin = mixin;
              lodash.negate = negate;
              lodash.nthArg = nthArg;
              lodash.omit = omit;
              lodash.omitBy = omitBy;
              lodash.once = once;
              lodash.orderBy = orderBy;
              lodash.over = over;
              lodash.overArgs = overArgs;
              lodash.overEvery = overEvery;
              lodash.overSome = overSome;
              lodash.partial = partial;
              lodash.partialRight = partialRight;
              lodash.partition = partition;
              lodash.pick = pick;
              lodash.pickBy = pickBy;
              lodash.property = property;
              lodash.propertyOf = propertyOf;
              lodash.pull = pull;
              lodash.pullAll = pullAll;
              lodash.pullAllBy = pullAllBy;
              lodash.pullAllWith = pullAllWith;
              lodash.pullAt = pullAt;
              lodash.range = range;
              lodash.rangeRight = rangeRight;
              lodash.rearg = rearg;
              lodash.reject = reject;
              lodash.remove = remove;
              lodash.rest = rest;
              lodash.reverse = reverse;
              lodash.sampleSize = sampleSize;
              lodash.set = set;
              lodash.setWith = setWith;
              lodash.shuffle = shuffle;
              lodash.slice = slice;
              lodash.sortBy = sortBy;
              lodash.sortedUniq = sortedUniq;
              lodash.sortedUniqBy = sortedUniqBy;
              lodash.split = split;
              lodash.spread = spread;
              lodash.tail = tail;
              lodash.take = take;
              lodash.takeRight = takeRight;
              lodash.takeRightWhile = takeRightWhile;
              lodash.takeWhile = takeWhile;
              lodash.tap = tap;
              lodash.throttle = throttle;
              lodash.thru = thru;
              lodash.toArray = toArray;
              lodash.toPairs = toPairs;
              lodash.toPairsIn = toPairsIn;
              lodash.toPath = toPath;
              lodash.toPlainObject = toPlainObject;
              lodash.transform = transform;
              lodash.unary = unary;
              lodash.union = union;
              lodash.unionBy = unionBy;
              lodash.unionWith = unionWith;
              lodash.uniq = uniq;
              lodash.uniqBy = uniqBy;
              lodash.uniqWith = uniqWith;
              lodash.unset = unset;
              lodash.unzip = unzip;
              lodash.unzipWith = unzipWith;
              lodash.update = update;
              lodash.updateWith = updateWith;
              lodash.values = values;
              lodash.valuesIn = valuesIn;
              lodash.without = without;
              lodash.words = words;
              lodash.wrap = wrap;
              lodash.xor = xor;
              lodash.xorBy = xorBy;
              lodash.xorWith = xorWith;
              lodash.zip = zip;
              lodash.zipObject = zipObject;
              lodash.zipObjectDeep = zipObjectDeep;
              lodash.zipWith = zipWith; // Add aliases.

              lodash.entries = toPairs;
              lodash.entriesIn = toPairsIn;
              lodash.extend = assignIn;
              lodash.extendWith = assignInWith; // Add methods to `lodash.prototype`.

              mixin(lodash, lodash);
              /*------------------------------------------------------------------------*/
              // Add methods that return unwrapped values in chain sequences.

              lodash.add = add;
              lodash.attempt = attempt;
              lodash.camelCase = camelCase;
              lodash.capitalize = capitalize;
              lodash.ceil = ceil;
              lodash.clamp = clamp;
              lodash.clone = clone;
              lodash.cloneDeep = cloneDeep;
              lodash.cloneDeepWith = cloneDeepWith;
              lodash.cloneWith = cloneWith;
              lodash.conformsTo = conformsTo;
              lodash.deburr = deburr;
              lodash.defaultTo = defaultTo;
              lodash.divide = divide;
              lodash.endsWith = endsWith;
              lodash.eq = eq;
              lodash.escape = escape;
              lodash.escapeRegExp = escapeRegExp;
              lodash.every = every;
              lodash.find = find;
              lodash.findIndex = findIndex;
              lodash.findKey = findKey;
              lodash.findLast = findLast;
              lodash.findLastIndex = findLastIndex;
              lodash.findLastKey = findLastKey;
              lodash.floor = floor;
              lodash.forEach = forEach;
              lodash.forEachRight = forEachRight;
              lodash.forIn = forIn;
              lodash.forInRight = forInRight;
              lodash.forOwn = forOwn;
              lodash.forOwnRight = forOwnRight;
              lodash.get = get;
              lodash.gt = gt;
              lodash.gte = gte;
              lodash.has = has;
              lodash.hasIn = hasIn;
              lodash.head = head;
              lodash.identity = identity;
              lodash.includes = includes;
              lodash.indexOf = indexOf;
              lodash.inRange = inRange;
              lodash.invoke = invoke;
              lodash.isArguments = isArguments;
              lodash.isArray = isArray;
              lodash.isArrayBuffer = isArrayBuffer;
              lodash.isArrayLike = isArrayLike;
              lodash.isArrayLikeObject = isArrayLikeObject;
              lodash.isBoolean = isBoolean;
              lodash.isBuffer = isBuffer;
              lodash.isDate = isDate;
              lodash.isElement = isElement;
              lodash.isEmpty = isEmpty;
              lodash.isEqual = isEqual;
              lodash.isEqualWith = isEqualWith;
              lodash.isError = isError;
              lodash.isFinite = isFinite;
              lodash.isFunction = isFunction;
              lodash.isInteger = isInteger;
              lodash.isLength = isLength;
              lodash.isMap = isMap;
              lodash.isMatch = isMatch;
              lodash.isMatchWith = isMatchWith;
              lodash.isNaN = isNaN;
              lodash.isNative = isNative;
              lodash.isNil = isNil;
              lodash.isNull = isNull;
              lodash.isNumber = isNumber;
              lodash.isObject = isObject;
              lodash.isObjectLike = isObjectLike;
              lodash.isPlainObject = isPlainObject;
              lodash.isRegExp = isRegExp;
              lodash.isSafeInteger = isSafeInteger;
              lodash.isSet = isSet;
              lodash.isString = isString;
              lodash.isSymbol = isSymbol;
              lodash.isTypedArray = isTypedArray;
              lodash.isUndefined = isUndefined;
              lodash.isWeakMap = isWeakMap;
              lodash.isWeakSet = isWeakSet;
              lodash.join = join;
              lodash.kebabCase = kebabCase;
              lodash.last = last;
              lodash.lastIndexOf = lastIndexOf;
              lodash.lowerCase = lowerCase;
              lodash.lowerFirst = lowerFirst;
              lodash.lt = lt;
              lodash.lte = lte;
              lodash.max = max;
              lodash.maxBy = maxBy;
              lodash.mean = mean;
              lodash.meanBy = meanBy;
              lodash.min = min;
              lodash.minBy = minBy;
              lodash.stubArray = stubArray;
              lodash.stubFalse = stubFalse;
              lodash.stubObject = stubObject;
              lodash.stubString = stubString;
              lodash.stubTrue = stubTrue;
              lodash.multiply = multiply;
              lodash.nth = nth;
              lodash.noConflict = noConflict;
              lodash.noop = noop;
              lodash.now = now;
              lodash.pad = pad;
              lodash.padEnd = padEnd;
              lodash.padStart = padStart;
              lodash.parseInt = parseInt;
              lodash.random = random;
              lodash.reduce = reduce;
              lodash.reduceRight = reduceRight;
              lodash.repeat = repeat;
              lodash.replace = replace;
              lodash.result = result;
              lodash.round = round;
              lodash.runInContext = runInContext;
              lodash.sample = sample;
              lodash.size = size;
              lodash.snakeCase = snakeCase;
              lodash.some = some;
              lodash.sortedIndex = sortedIndex;
              lodash.sortedIndexBy = sortedIndexBy;
              lodash.sortedIndexOf = sortedIndexOf;
              lodash.sortedLastIndex = sortedLastIndex;
              lodash.sortedLastIndexBy = sortedLastIndexBy;
              lodash.sortedLastIndexOf = sortedLastIndexOf;
              lodash.startCase = startCase;
              lodash.startsWith = startsWith;
              lodash.subtract = subtract;
              lodash.sum = sum;
              lodash.sumBy = sumBy;
              lodash.template = template;
              lodash.times = times;
              lodash.toFinite = toFinite;
              lodash.toInteger = toInteger;
              lodash.toLength = toLength;
              lodash.toLower = toLower;
              lodash.toNumber = toNumber;
              lodash.toSafeInteger = toSafeInteger;
              lodash.toString = toString;
              lodash.toUpper = toUpper;
              lodash.trim = trim;
              lodash.trimEnd = trimEnd;
              lodash.trimStart = trimStart;
              lodash.truncate = truncate;
              lodash.unescape = unescape;
              lodash.uniqueId = uniqueId;
              lodash.upperCase = upperCase;
              lodash.upperFirst = upperFirst; // Add aliases.

              lodash.each = forEach;
              lodash.eachRight = forEachRight;
              lodash.first = head;
              mixin(lodash, function () {
                var source = {};
                baseForOwn(lodash, function (func, methodName) {
                  if (!hasOwnProperty.call(lodash.prototype, methodName)) {
                    source[methodName] = func;
                  }
                });
                return source;
              }(), {
                'chain': false
              });
              /*------------------------------------------------------------------------*/

              /**
               * The semantic version number.
               *
               * @static
               * @memberOf _
               * @type {string}
               */

              lodash.VERSION = VERSION; // Assign default placeholders.

              arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function (methodName) {
                lodash[methodName].placeholder = lodash;
              }); // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.

              arrayEach(['drop', 'take'], function (methodName, index) {
                LazyWrapper.prototype[methodName] = function (n) {
                  n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                  var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();

                  if (result.__filtered__) {
                    result.__takeCount__ = nativeMin(n, result.__takeCount__);
                  } else {
                    result.__views__.push({
                      'size': nativeMin(n, MAX_ARRAY_LENGTH),
                      'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                    });
                  }

                  return result;
                };

                LazyWrapper.prototype[methodName + 'Right'] = function (n) {
                  return this.reverse()[methodName](n).reverse();
                };
              }); // Add `LazyWrapper` methods that accept an `iteratee` value.

              arrayEach(['filter', 'map', 'takeWhile'], function (methodName, index) {
                var type = index + 1,
                    isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

                LazyWrapper.prototype[methodName] = function (iteratee) {
                  var result = this.clone();

                  result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                  });

                  result.__filtered__ = result.__filtered__ || isFilter;
                  return result;
                };
              }); // Add `LazyWrapper` methods for `_.head` and `_.last`.

              arrayEach(['head', 'last'], function (methodName, index) {
                var takeName = 'take' + (index ? 'Right' : '');

                LazyWrapper.prototype[methodName] = function () {
                  return this[takeName](1).value()[0];
                };
              }); // Add `LazyWrapper` methods for `_.initial` and `_.tail`.

              arrayEach(['initial', 'tail'], function (methodName, index) {
                var dropName = 'drop' + (index ? '' : 'Right');

                LazyWrapper.prototype[methodName] = function () {
                  return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
                };
              });

              LazyWrapper.prototype.compact = function () {
                return this.filter(identity);
              };

              LazyWrapper.prototype.find = function (predicate) {
                return this.filter(predicate).head();
              };

              LazyWrapper.prototype.findLast = function (predicate) {
                return this.reverse().find(predicate);
              };

              LazyWrapper.prototype.invokeMap = baseRest(function (path, args) {
                if (typeof path == 'function') {
                  return new LazyWrapper(this);
                }

                return this.map(function (value) {
                  return baseInvoke(value, path, args);
                });
              });

              LazyWrapper.prototype.reject = function (predicate) {
                return this.filter(negate(getIteratee(predicate)));
              };

              LazyWrapper.prototype.slice = function (start, end) {
                start = toInteger(start);
                var result = this;

                if (result.__filtered__ && (start > 0 || end < 0)) {
                  return new LazyWrapper(result);
                }

                if (start < 0) {
                  result = result.takeRight(-start);
                } else if (start) {
                  result = result.drop(start);
                }

                if (end !== undefined) {
                  end = toInteger(end);
                  result = end < 0 ? result.dropRight(-end) : result.take(end - start);
                }

                return result;
              };

              LazyWrapper.prototype.takeRightWhile = function (predicate) {
                return this.reverse().takeWhile(predicate).reverse();
              };

              LazyWrapper.prototype.toArray = function () {
                return this.take(MAX_ARRAY_LENGTH);
              }; // Add `LazyWrapper` methods to `lodash.prototype`.


              baseForOwn(LazyWrapper.prototype, function (func, methodName) {
                var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
                    isTaker = /^(?:head|last)$/.test(methodName),
                    lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName],
                    retUnwrapped = isTaker || /^find/.test(methodName);

                if (!lodashFunc) {
                  return;
                }

                lodash.prototype[methodName] = function () {
                  var value = this.__wrapped__,
                      args = isTaker ? [1] : arguments,
                      isLazy = value instanceof LazyWrapper,
                      iteratee = args[0],
                      useLazy = isLazy || isArray(value);

                  var interceptor = function interceptor(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([value], args));
                    return isTaker && chainAll ? result[0] : result;
                  };

                  if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
                    // Avoid lazy use if the iteratee has a "length" value other than `1`.
                    isLazy = useLazy = false;
                  }

                  var chainAll = this.__chain__,
                      isHybrid = !!this.__actions__.length,
                      isUnwrapped = retUnwrapped && !chainAll,
                      onlyLazy = isLazy && !isHybrid;

                  if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);

                    result.__actions__.push({
                      'func': thru,
                      'args': [interceptor],
                      'thisArg': undefined
                    });

                    return new LodashWrapper(result, chainAll);
                  }

                  if (isUnwrapped && onlyLazy) {
                    return func.apply(this, args);
                  }

                  result = this.thru(interceptor);
                  return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
                };
              }); // Add `Array` methods to `lodash.prototype`.

              arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function (methodName) {
                var func = arrayProto[methodName],
                    chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
                    retUnwrapped = /^(?:pop|shift)$/.test(methodName);

                lodash.prototype[methodName] = function () {
                  var args = arguments;

                  if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                  }

                  return this[chainName](function (value) {
                    return func.apply(isArray(value) ? value : [], args);
                  });
                };
              }); // Map minified method names to their real names.

              baseForOwn(LazyWrapper.prototype, function (func, methodName) {
                var lodashFunc = lodash[methodName];

                if (lodashFunc) {
                  var key = lodashFunc.name + '';

                  if (!hasOwnProperty.call(realNames, key)) {
                    realNames[key] = [];
                  }

                  realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                  });
                }
              });
              realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
                'name': 'wrapper',
                'func': undefined
              }]; // Add methods to `LazyWrapper`.

              LazyWrapper.prototype.clone = lazyClone;
              LazyWrapper.prototype.reverse = lazyReverse;
              LazyWrapper.prototype.value = lazyValue; // Add chain sequence methods to the `lodash` wrapper.

              lodash.prototype.at = wrapperAt;
              lodash.prototype.chain = wrapperChain;
              lodash.prototype.commit = wrapperCommit;
              lodash.prototype.next = wrapperNext;
              lodash.prototype.plant = wrapperPlant;
              lodash.prototype.reverse = wrapperReverse;
              lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue; // Add lazy aliases.

              lodash.prototype.first = lodash.prototype.head;

              if (symIterator) {
                lodash.prototype[symIterator] = wrapperToIterator;
              }

              return lodash;
            };
            /*--------------------------------------------------------------------------*/
            // Export lodash.


            var _ = runInContext(); // Some AMD build optimizers, like r.js, check for condition patterns like:


            if (true) {
              // Expose Lodash on the global object to prevent errors when Lodash is
              // loaded by a script tag in the presence of an AMD loader.
              // See http://requirejs.org/docs/errors.html#mismatch for more details.
              // Use `_.noConflict` to remove Lodash from the global object.
              root._ = _; // Define as an anonymous module so, through path mapping, it can be
              // referenced as the "underscore" module.

              !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
                return _;
              }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } // Check for `exports` after `define` in case a build optimizer adds it.
            else {}
          }).call(this);
          /***/
        },

        /***/
        2786:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Afrikaans [af]
          //! author : Werner Mollentze : https://github.com/wernerm
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var af = moment.defineLocale('af', {
              months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
              monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
              weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
              weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
              weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
              meridiemParse: /vm|nm/i,
              isPM: function isPM(input) {
                return /^nm$/i.test(input);
              },
              meridiem: function meridiem(hours, minutes, isLower) {
                if (hours < 12) {
                  return isLower ? 'vm' : 'VM';
                } else {
                  return isLower ? 'nm' : 'NM';
                }
              },
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Vandag om] LT',
                nextDay: '[Môre om] LT',
                nextWeek: 'dddd [om] LT',
                lastDay: '[Gister om] LT',
                lastWeek: '[Laas] dddd [om] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'oor %s',
                past: '%s gelede',
                s: "'n paar sekondes",
                ss: '%d sekondes',
                m: "'n minuut",
                mm: '%d minute',
                h: "'n uur",
                hh: '%d ure',
                d: "'n dag",
                dd: '%d dae',
                M: "'n maand",
                MM: '%d maande',
                y: "'n jaar",
                yy: '%d jaar'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
              ordinal: function ordinal(number) {
                return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
              },
              week: {
                dow: 1,
                // Maandag is die eerste dag van die week.
                doy: 4 // Die week wat die 4de Januarie bevat is die eerste week van die jaar.

              }
            });
            return af;
          });
          /***/

        },

        /***/
        4130:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Arabic (Algeria) [ar-dz]
          //! author : Amine Roukh: https://github.com/Amine27
          //! author : Abdel Said: https://github.com/abdelsaid
          //! author : Ahmed Elkhatib
          //! author : forabi https://github.com/forabi
          //! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var pluralForm = function pluralForm(n) {
              return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
            },
                plurals = {
              s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
              m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
              h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
              d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
              M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
              y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
            },
                pluralize = function pluralize(u) {
              return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];

                if (f === 2) {
                  str = str[withoutSuffix ? 0 : 1];
                }

                return str.replace(/%d/i, number);
              };
            },
                months = ['جانفي', 'فيفري', 'مارس', 'أفريل', 'ماي', 'جوان', 'جويلية', 'أوت', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];

            var arDz = moment.defineLocale('ar-dz', {
              months: months,
              monthsShort: months,
              weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
              weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
              weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: "D/\u200FM/\u200FYYYY",
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              meridiemParse: /ص|م/,
              isPM: function isPM(input) {
                return 'م' === input;
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 12) {
                  return 'ص';
                } else {
                  return 'م';
                }
              },
              calendar: {
                sameDay: '[اليوم عند الساعة] LT',
                nextDay: '[غدًا عند الساعة] LT',
                nextWeek: 'dddd [عند الساعة] LT',
                lastDay: '[أمس عند الساعة] LT',
                lastWeek: 'dddd [عند الساعة] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'بعد %s',
                past: 'منذ %s',
                s: pluralize('s'),
                ss: pluralize('s'),
                m: pluralize('m'),
                mm: pluralize('m'),
                h: pluralize('h'),
                hh: pluralize('h'),
                d: pluralize('d'),
                dd: pluralize('d'),
                M: pluralize('M'),
                MM: pluralize('M'),
                y: pluralize('y'),
                yy: pluralize('y')
              },
              postformat: function postformat(string) {
                return string.replace(/,/g, '،');
              },
              week: {
                dow: 0,
                // Sunday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return arDz;
          });
          /***/

        },

        /***/
        6135:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Arabic (Kuwait) [ar-kw]
          //! author : Nusret Parlak: https://github.com/nusretparlak
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var arKw = moment.defineLocale('ar-kw', {
              months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
              monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
              weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
              weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
              weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[اليوم على الساعة] LT',
                nextDay: '[غدا على الساعة] LT',
                nextWeek: 'dddd [على الساعة] LT',
                lastDay: '[أمس على الساعة] LT',
                lastWeek: 'dddd [على الساعة] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'في %s',
                past: 'منذ %s',
                s: 'ثوان',
                ss: '%d ثانية',
                m: 'دقيقة',
                mm: '%d دقائق',
                h: 'ساعة',
                hh: '%d ساعات',
                d: 'يوم',
                dd: '%d أيام',
                M: 'شهر',
                MM: '%d أشهر',
                y: 'سنة',
                yy: '%d سنوات'
              },
              week: {
                dow: 0,
                // Sunday is the first day of the week.
                doy: 12 // The week that contains Jan 12th is the first week of the year.

              }
            });
            return arKw;
          });
          /***/

        },

        /***/
        6440:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Arabic (Lybia) [ar-ly]
          //! author : Ali Hmer: https://github.com/kikoanis
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var symbolMap = {
              1: '1',
              2: '2',
              3: '3',
              4: '4',
              5: '5',
              6: '6',
              7: '7',
              8: '8',
              9: '9',
              0: '0'
            },
                pluralForm = function pluralForm(n) {
              return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
            },
                plurals = {
              s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
              m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
              h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
              d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
              M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
              y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
            },
                pluralize = function pluralize(u) {
              return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];

                if (f === 2) {
                  str = str[withoutSuffix ? 0 : 1];
                }

                return str.replace(/%d/i, number);
              };
            },
                months = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];

            var arLy = moment.defineLocale('ar-ly', {
              months: months,
              monthsShort: months,
              weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
              weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
              weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: "D/\u200FM/\u200FYYYY",
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              meridiemParse: /ص|م/,
              isPM: function isPM(input) {
                return 'م' === input;
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 12) {
                  return 'ص';
                } else {
                  return 'م';
                }
              },
              calendar: {
                sameDay: '[اليوم عند الساعة] LT',
                nextDay: '[غدًا عند الساعة] LT',
                nextWeek: 'dddd [عند الساعة] LT',
                lastDay: '[أمس عند الساعة] LT',
                lastWeek: 'dddd [عند الساعة] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'بعد %s',
                past: 'منذ %s',
                s: pluralize('s'),
                ss: pluralize('s'),
                m: pluralize('m'),
                mm: pluralize('m'),
                h: pluralize('h'),
                hh: pluralize('h'),
                d: pluralize('d'),
                dd: pluralize('d'),
                M: pluralize('M'),
                MM: pluralize('M'),
                y: pluralize('y'),
                yy: pluralize('y')
              },
              preparse: function preparse(string) {
                return string.replace(/،/g, ',');
              },
              postformat: function postformat(string) {
                return string.replace(/\d/g, function (match) {
                  return symbolMap[match];
                }).replace(/,/g, '،');
              },
              week: {
                dow: 6,
                // Saturday is the first day of the week.
                doy: 12 // The week that contains Jan 12th is the first week of the year.

              }
            });
            return arLy;
          });
          /***/

        },

        /***/
        7702:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Arabic (Morocco) [ar-ma]
          //! author : ElFadili Yassine : https://github.com/ElFadiliY
          //! author : Abdel Said : https://github.com/abdelsaid
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var arMa = moment.defineLocale('ar-ma', {
              months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
              monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
              weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
              weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
              weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[اليوم على الساعة] LT',
                nextDay: '[غدا على الساعة] LT',
                nextWeek: 'dddd [على الساعة] LT',
                lastDay: '[أمس على الساعة] LT',
                lastWeek: 'dddd [على الساعة] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'في %s',
                past: 'منذ %s',
                s: 'ثوان',
                ss: '%d ثانية',
                m: 'دقيقة',
                mm: '%d دقائق',
                h: 'ساعة',
                hh: '%d ساعات',
                d: 'يوم',
                dd: '%d أيام',
                M: 'شهر',
                MM: '%d أشهر',
                y: 'سنة',
                yy: '%d سنوات'
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return arMa;
          });
          /***/

        },

        /***/
        6040:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Arabic (Saudi Arabia) [ar-sa]
          //! author : Suhail Alkowaileet : https://github.com/xsoh
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var symbolMap = {
              1: '١',
              2: '٢',
              3: '٣',
              4: '٤',
              5: '٥',
              6: '٦',
              7: '٧',
              8: '٨',
              9: '٩',
              0: '٠'
            },
                numberMap = {
              '١': '1',
              '٢': '2',
              '٣': '3',
              '٤': '4',
              '٥': '5',
              '٦': '6',
              '٧': '7',
              '٨': '8',
              '٩': '9',
              '٠': '0'
            };
            var arSa = moment.defineLocale('ar-sa', {
              months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
              monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
              weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
              weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
              weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              meridiemParse: /ص|م/,
              isPM: function isPM(input) {
                return 'م' === input;
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 12) {
                  return 'ص';
                } else {
                  return 'م';
                }
              },
              calendar: {
                sameDay: '[اليوم على الساعة] LT',
                nextDay: '[غدا على الساعة] LT',
                nextWeek: 'dddd [على الساعة] LT',
                lastDay: '[أمس على الساعة] LT',
                lastWeek: 'dddd [على الساعة] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'في %s',
                past: 'منذ %s',
                s: 'ثوان',
                ss: '%d ثانية',
                m: 'دقيقة',
                mm: '%d دقائق',
                h: 'ساعة',
                hh: '%d ساعات',
                d: 'يوم',
                dd: '%d أيام',
                M: 'شهر',
                MM: '%d أشهر',
                y: 'سنة',
                yy: '%d سنوات'
              },
              preparse: function preparse(string) {
                return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                  return numberMap[match];
                }).replace(/،/g, ',');
              },
              postformat: function postformat(string) {
                return string.replace(/\d/g, function (match) {
                  return symbolMap[match];
                }).replace(/,/g, '،');
              },
              week: {
                dow: 0,
                // Sunday is the first day of the week.
                doy: 6 // The week that contains Jan 6th is the first week of the year.

              }
            });
            return arSa;
          });
          /***/

        },

        /***/
        7100:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale  :  Arabic (Tunisia) [ar-tn]
          //! author : Nader Toukabri : https://github.com/naderio
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var arTn = moment.defineLocale('ar-tn', {
              months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
              monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
              weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
              weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
              weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[اليوم على الساعة] LT',
                nextDay: '[غدا على الساعة] LT',
                nextWeek: 'dddd [على الساعة] LT',
                lastDay: '[أمس على الساعة] LT',
                lastWeek: 'dddd [على الساعة] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'في %s',
                past: 'منذ %s',
                s: 'ثوان',
                ss: '%d ثانية',
                m: 'دقيقة',
                mm: '%d دقائق',
                h: 'ساعة',
                hh: '%d ساعات',
                d: 'يوم',
                dd: '%d أيام',
                M: 'شهر',
                MM: '%d أشهر',
                y: 'سنة',
                yy: '%d سنوات'
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return arTn;
          });
          /***/

        },

        /***/
        867:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Arabic [ar]
          //! author : Abdel Said: https://github.com/abdelsaid
          //! author : Ahmed Elkhatib
          //! author : forabi https://github.com/forabi
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var symbolMap = {
              1: '١',
              2: '٢',
              3: '٣',
              4: '٤',
              5: '٥',
              6: '٦',
              7: '٧',
              8: '٨',
              9: '٩',
              0: '٠'
            },
                numberMap = {
              '١': '1',
              '٢': '2',
              '٣': '3',
              '٤': '4',
              '٥': '5',
              '٦': '6',
              '٧': '7',
              '٨': '8',
              '٩': '9',
              '٠': '0'
            },
                pluralForm = function pluralForm(n) {
              return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
            },
                plurals = {
              s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
              m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
              h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
              d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
              M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
              y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
            },
                pluralize = function pluralize(u) {
              return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];

                if (f === 2) {
                  str = str[withoutSuffix ? 0 : 1];
                }

                return str.replace(/%d/i, number);
              };
            },
                months = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];

            var ar = moment.defineLocale('ar', {
              months: months,
              monthsShort: months,
              weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
              weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
              weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: "D/\u200FM/\u200FYYYY",
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              meridiemParse: /ص|م/,
              isPM: function isPM(input) {
                return 'م' === input;
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 12) {
                  return 'ص';
                } else {
                  return 'م';
                }
              },
              calendar: {
                sameDay: '[اليوم عند الساعة] LT',
                nextDay: '[غدًا عند الساعة] LT',
                nextWeek: 'dddd [عند الساعة] LT',
                lastDay: '[أمس عند الساعة] LT',
                lastWeek: 'dddd [عند الساعة] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'بعد %s',
                past: 'منذ %s',
                s: pluralize('s'),
                ss: pluralize('s'),
                m: pluralize('m'),
                mm: pluralize('m'),
                h: pluralize('h'),
                hh: pluralize('h'),
                d: pluralize('d'),
                dd: pluralize('d'),
                M: pluralize('M'),
                MM: pluralize('M'),
                y: pluralize('y'),
                yy: pluralize('y')
              },
              preparse: function preparse(string) {
                return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                  return numberMap[match];
                }).replace(/،/g, ',');
              },
              postformat: function postformat(string) {
                return string.replace(/\d/g, function (match) {
                  return symbolMap[match];
                }).replace(/,/g, '،');
              },
              week: {
                dow: 6,
                // Saturday is the first day of the week.
                doy: 12 // The week that contains Jan 12th is the first week of the year.

              }
            });
            return ar;
          });
          /***/

        },

        /***/
        1083:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Azerbaijani [az]
          //! author : topchiyev : https://github.com/topchiyev
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var suffixes = {
              1: '-inci',
              5: '-inci',
              8: '-inci',
              70: '-inci',
              80: '-inci',
              2: '-nci',
              7: '-nci',
              20: '-nci',
              50: '-nci',
              3: '-üncü',
              4: '-üncü',
              100: '-üncü',
              6: '-ncı',
              9: '-uncu',
              10: '-uncu',
              30: '-uncu',
              60: '-ıncı',
              90: '-ıncı'
            };
            var az = moment.defineLocale('az', {
              months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
              monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
              weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
              weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
              weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[bugün saat] LT',
                nextDay: '[sabah saat] LT',
                nextWeek: '[gələn həftə] dddd [saat] LT',
                lastDay: '[dünən] LT',
                lastWeek: '[keçən həftə] dddd [saat] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s sonra',
                past: '%s əvvəl',
                s: 'bir neçə saniyə',
                ss: '%d saniyə',
                m: 'bir dəqiqə',
                mm: '%d dəqiqə',
                h: 'bir saat',
                hh: '%d saat',
                d: 'bir gün',
                dd: '%d gün',
                M: 'bir ay',
                MM: '%d ay',
                y: 'bir il',
                yy: '%d il'
              },
              meridiemParse: /gecə|səhər|gündüz|axşam/,
              isPM: function isPM(input) {
                return /^(gündüz|axşam)$/.test(input);
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 4) {
                  return 'gecə';
                } else if (hour < 12) {
                  return 'səhər';
                } else if (hour < 17) {
                  return 'gündüz';
                } else {
                  return 'axşam';
                }
              },
              dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
              ordinal: function ordinal(number) {
                if (number === 0) {
                  // special case for zero
                  return number + '-ıncı';
                }

                var a = number % 10,
                    b = number % 100 - a,
                    c = number >= 100 ? 100 : null;
                return number + (suffixes[a] || suffixes[b] || suffixes[c]);
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return az;
          });
          /***/

        },

        /***/
        9808:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Belarusian [be]
          //! author : Dmitry Demidov : https://github.com/demidov91
          //! author: Praleska: http://praleska.pro/
          //! Author : Menelion Elensúle : https://github.com/Oire
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            function plural(word, num) {
              var forms = word.split('_');
              return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
            }

            function relativeTimeWithPlural(number, withoutSuffix, key) {
              var format = {
                ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
                mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
                hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
                dd: 'дзень_дні_дзён',
                MM: 'месяц_месяцы_месяцаў',
                yy: 'год_гады_гадоў'
              };

              if (key === 'm') {
                return withoutSuffix ? 'хвіліна' : 'хвіліну';
              } else if (key === 'h') {
                return withoutSuffix ? 'гадзіна' : 'гадзіну';
              } else {
                return number + ' ' + plural(format[key], +number);
              }
            }

            var be = moment.defineLocale('be', {
              months: {
                format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
                standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
              },
              monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
              weekdays: {
                format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
                standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
                isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
              },
              weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
              weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D MMMM YYYY г.',
                LLL: 'D MMMM YYYY г., HH:mm',
                LLLL: 'dddd, D MMMM YYYY г., HH:mm'
              },
              calendar: {
                sameDay: '[Сёння ў] LT',
                nextDay: '[Заўтра ў] LT',
                lastDay: '[Учора ў] LT',
                nextWeek: function nextWeek() {
                  return '[У] dddd [ў] LT';
                },
                lastWeek: function lastWeek() {
                  switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                      return '[У мінулую] dddd [ў] LT';

                    case 1:
                    case 2:
                    case 4:
                      return '[У мінулы] dddd [ў] LT';
                  }
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'праз %s',
                past: '%s таму',
                s: 'некалькі секунд',
                m: relativeTimeWithPlural,
                mm: relativeTimeWithPlural,
                h: relativeTimeWithPlural,
                hh: relativeTimeWithPlural,
                d: 'дзень',
                dd: relativeTimeWithPlural,
                M: 'месяц',
                MM: relativeTimeWithPlural,
                y: 'год',
                yy: relativeTimeWithPlural
              },
              meridiemParse: /ночы|раніцы|дня|вечара/,
              isPM: function isPM(input) {
                return /^(дня|вечара)$/.test(input);
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 4) {
                  return 'ночы';
                } else if (hour < 12) {
                  return 'раніцы';
                } else if (hour < 17) {
                  return 'дня';
                } else {
                  return 'вечара';
                }
              },
              dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
              ordinal: function ordinal(number, period) {
                switch (period) {
                  case 'M':
                  case 'd':
                  case 'DDD':
                  case 'w':
                  case 'W':
                    return (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? number + '-і' : number + '-ы';

                  case 'D':
                    return number + '-га';

                  default:
                    return number;
                }
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return be;
          });
          /***/

        },

        /***/
        8338:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Bulgarian [bg]
          //! author : Krasen Borisov : https://github.com/kraz
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var bg = moment.defineLocale('bg', {
              months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
              monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
              weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
              weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
              weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'D.MM.YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY H:mm',
                LLLL: 'dddd, D MMMM YYYY H:mm'
              },
              calendar: {
                sameDay: '[Днес в] LT',
                nextDay: '[Утре в] LT',
                nextWeek: 'dddd [в] LT',
                lastDay: '[Вчера в] LT',
                lastWeek: function lastWeek() {
                  switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                      return '[Миналата] dddd [в] LT';

                    case 1:
                    case 2:
                    case 4:
                    case 5:
                      return '[Миналия] dddd [в] LT';
                  }
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'след %s',
                past: 'преди %s',
                s: 'няколко секунди',
                ss: '%d секунди',
                m: 'минута',
                mm: '%d минути',
                h: 'час',
                hh: '%d часа',
                d: 'ден',
                dd: '%d дена',
                w: 'седмица',
                ww: '%d седмици',
                M: 'месец',
                MM: '%d месеца',
                y: 'година',
                yy: '%d години'
              },
              dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
              ordinal: function ordinal(number) {
                var lastDigit = number % 10,
                    last2Digits = number % 100;

                if (number === 0) {
                  return number + '-ев';
                } else if (last2Digits === 0) {
                  return number + '-ен';
                } else if (last2Digits > 10 && last2Digits < 20) {
                  return number + '-ти';
                } else if (lastDigit === 1) {
                  return number + '-ви';
                } else if (lastDigit === 2) {
                  return number + '-ри';
                } else if (lastDigit === 7 || lastDigit === 8) {
                  return number + '-ми';
                } else {
                  return number + '-ти';
                }
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return bg;
          });
          /***/

        },

        /***/
        7438:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Bambara [bm]
          //! author : Estelle Comment : https://github.com/estellecomment
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var bm = moment.defineLocale('bm', {
              months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
              monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
              weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
              weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
              weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'MMMM [tile] D [san] YYYY',
                LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
                LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
              },
              calendar: {
                sameDay: '[Bi lɛrɛ] LT',
                nextDay: '[Sini lɛrɛ] LT',
                nextWeek: 'dddd [don lɛrɛ] LT',
                lastDay: '[Kunu lɛrɛ] LT',
                lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s kɔnɔ',
                past: 'a bɛ %s bɔ',
                s: 'sanga dama dama',
                ss: 'sekondi %d',
                m: 'miniti kelen',
                mm: 'miniti %d',
                h: 'lɛrɛ kelen',
                hh: 'lɛrɛ %d',
                d: 'tile kelen',
                dd: 'tile %d',
                M: 'kalo kelen',
                MM: 'kalo %d',
                y: 'san kelen',
                yy: 'san %d'
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return bm;
          });
          /***/

        },

        /***/
        6225:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Bengali (Bangladesh) [bn-bd]
          //! author : Asraf Hossain Patoary : https://github.com/ashwoolford
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var symbolMap = {
              1: '১',
              2: '২',
              3: '৩',
              4: '৪',
              5: '৫',
              6: '৬',
              7: '৭',
              8: '৮',
              9: '৯',
              0: '০'
            },
                numberMap = {
              '১': '1',
              '২': '2',
              '৩': '3',
              '৪': '4',
              '৫': '5',
              '৬': '6',
              '৭': '7',
              '৮': '8',
              '৯': '9',
              '০': '0'
            };
            var bnBd = moment.defineLocale('bn-bd', {
              months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
              monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
              weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
              weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
              weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
              longDateFormat: {
                LT: 'A h:mm সময়',
                LTS: 'A h:mm:ss সময়',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY, A h:mm সময়',
                LLLL: 'dddd, D MMMM YYYY, A h:mm সময়'
              },
              calendar: {
                sameDay: '[আজ] LT',
                nextDay: '[আগামীকাল] LT',
                nextWeek: 'dddd, LT',
                lastDay: '[গতকাল] LT',
                lastWeek: '[গত] dddd, LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s পরে',
                past: '%s আগে',
                s: 'কয়েক সেকেন্ড',
                ss: '%d সেকেন্ড',
                m: 'এক মিনিট',
                mm: '%d মিনিট',
                h: 'এক ঘন্টা',
                hh: '%d ঘন্টা',
                d: 'এক দিন',
                dd: '%d দিন',
                M: 'এক মাস',
                MM: '%d মাস',
                y: 'এক বছর',
                yy: '%d বছর'
              },
              preparse: function preparse(string) {
                return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                  return numberMap[match];
                });
              },
              postformat: function postformat(string) {
                return string.replace(/\d/g, function (match) {
                  return symbolMap[match];
                });
              },
              meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'রাত') {
                  return hour < 4 ? hour : hour + 12;
                } else if (meridiem === 'ভোর') {
                  return hour;
                } else if (meridiem === 'সকাল') {
                  return hour;
                } else if (meridiem === 'দুপুর') {
                  return hour >= 3 ? hour : hour + 12;
                } else if (meridiem === 'বিকাল') {
                  return hour + 12;
                } else if (meridiem === 'সন্ধ্যা') {
                  return hour + 12;
                }
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 4) {
                  return 'রাত';
                } else if (hour < 6) {
                  return 'ভোর';
                } else if (hour < 12) {
                  return 'সকাল';
                } else if (hour < 15) {
                  return 'দুপুর';
                } else if (hour < 18) {
                  return 'বিকাল';
                } else if (hour < 20) {
                  return 'সন্ধ্যা';
                } else {
                  return 'রাত';
                }
              },
              week: {
                dow: 0,
                // Sunday is the first day of the week.
                doy: 6 // The week that contains Jan 6th is the first week of the year.

              }
            });
            return bnBd;
          });
          /***/

        },

        /***/
        8905:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Bengali [bn]
          //! author : Kaushik Gandhi : https://github.com/kaushikgandhi
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var symbolMap = {
              1: '১',
              2: '২',
              3: '৩',
              4: '৪',
              5: '৫',
              6: '৬',
              7: '৭',
              8: '৮',
              9: '৯',
              0: '০'
            },
                numberMap = {
              '১': '1',
              '২': '2',
              '৩': '3',
              '৪': '4',
              '৫': '5',
              '৬': '6',
              '৭': '7',
              '৮': '8',
              '৯': '9',
              '০': '0'
            };
            var bn = moment.defineLocale('bn', {
              months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
              monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
              weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
              weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
              weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
              longDateFormat: {
                LT: 'A h:mm সময়',
                LTS: 'A h:mm:ss সময়',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY, A h:mm সময়',
                LLLL: 'dddd, D MMMM YYYY, A h:mm সময়'
              },
              calendar: {
                sameDay: '[আজ] LT',
                nextDay: '[আগামীকাল] LT',
                nextWeek: 'dddd, LT',
                lastDay: '[গতকাল] LT',
                lastWeek: '[গত] dddd, LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s পরে',
                past: '%s আগে',
                s: 'কয়েক সেকেন্ড',
                ss: '%d সেকেন্ড',
                m: 'এক মিনিট',
                mm: '%d মিনিট',
                h: 'এক ঘন্টা',
                hh: '%d ঘন্টা',
                d: 'এক দিন',
                dd: '%d দিন',
                M: 'এক মাস',
                MM: '%d মাস',
                y: 'এক বছর',
                yy: '%d বছর'
              },
              preparse: function preparse(string) {
                return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                  return numberMap[match];
                });
              },
              postformat: function postformat(string) {
                return string.replace(/\d/g, function (match) {
                  return symbolMap[match];
                });
              },
              meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'রাত' && hour >= 4 || meridiem === 'দুপুর' && hour < 5 || meridiem === 'বিকাল') {
                  return hour + 12;
                } else {
                  return hour;
                }
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 4) {
                  return 'রাত';
                } else if (hour < 10) {
                  return 'সকাল';
                } else if (hour < 17) {
                  return 'দুপুর';
                } else if (hour < 20) {
                  return 'বিকাল';
                } else {
                  return 'রাত';
                }
              },
              week: {
                dow: 0,
                // Sunday is the first day of the week.
                doy: 6 // The week that contains Jan 6th is the first week of the year.

              }
            });
            return bn;
          });
          /***/

        },

        /***/
        1560:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Tibetan [bo]
          //! author : Thupten N. Chakrishar : https://github.com/vajradog
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var symbolMap = {
              1: '༡',
              2: '༢',
              3: '༣',
              4: '༤',
              5: '༥',
              6: '༦',
              7: '༧',
              8: '༨',
              9: '༩',
              0: '༠'
            },
                numberMap = {
              '༡': '1',
              '༢': '2',
              '༣': '3',
              '༤': '4',
              '༥': '5',
              '༦': '6',
              '༧': '7',
              '༨': '8',
              '༩': '9',
              '༠': '0'
            };
            var bo = moment.defineLocale('bo', {
              months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
              monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split('_'),
              monthsShortRegex: /^(ཟླ་\d{1,2})/,
              monthsParseExact: true,
              weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
              weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
              weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
              longDateFormat: {
                LT: 'A h:mm',
                LTS: 'A h:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY, A h:mm',
                LLLL: 'dddd, D MMMM YYYY, A h:mm'
              },
              calendar: {
                sameDay: '[དི་རིང] LT',
                nextDay: '[སང་ཉིན] LT',
                nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
                lastDay: '[ཁ་སང] LT',
                lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s ལ་',
                past: '%s སྔན་ལ',
                s: 'ལམ་སང',
                ss: '%d སྐར་ཆ།',
                m: 'སྐར་མ་གཅིག',
                mm: '%d སྐར་མ',
                h: 'ཆུ་ཚོད་གཅིག',
                hh: '%d ཆུ་ཚོད',
                d: 'ཉིན་གཅིག',
                dd: '%d ཉིན་',
                M: 'ཟླ་བ་གཅིག',
                MM: '%d ཟླ་བ',
                y: 'ལོ་གཅིག',
                yy: '%d ལོ'
              },
              preparse: function preparse(string) {
                return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                  return numberMap[match];
                });
              },
              postformat: function postformat(string) {
                return string.replace(/\d/g, function (match) {
                  return symbolMap[match];
                });
              },
              meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'མཚན་མོ' && hour >= 4 || meridiem === 'ཉིན་གུང' && hour < 5 || meridiem === 'དགོང་དག') {
                  return hour + 12;
                } else {
                  return hour;
                }
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 4) {
                  return 'མཚན་མོ';
                } else if (hour < 10) {
                  return 'ཞོགས་ཀས';
                } else if (hour < 17) {
                  return 'ཉིན་གུང';
                } else if (hour < 20) {
                  return 'དགོང་དག';
                } else {
                  return 'མཚན་མོ';
                }
              },
              week: {
                dow: 0,
                // Sunday is the first day of the week.
                doy: 6 // The week that contains Jan 6th is the first week of the year.

              }
            });
            return bo;
          });
          /***/

        },

        /***/
        1278:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Breton [br]
          //! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            function relativeTimeWithMutation(number, withoutSuffix, key) {
              var format = {
                mm: 'munutenn',
                MM: 'miz',
                dd: 'devezh'
              };
              return number + ' ' + mutation(format[key], number);
            }

            function specialMutationForYears(number) {
              switch (lastNumber(number)) {
                case 1:
                case 3:
                case 4:
                case 5:
                case 9:
                  return number + ' bloaz';

                default:
                  return number + ' vloaz';
              }
            }

            function lastNumber(number) {
              if (number > 9) {
                return lastNumber(number % 10);
              }

              return number;
            }

            function mutation(text, number) {
              if (number === 2) {
                return softMutation(text);
              }

              return text;
            }

            function softMutation(text) {
              var mutationTable = {
                m: 'v',
                b: 'v',
                d: 'z'
              };

              if (mutationTable[text.charAt(0)] === undefined) {
                return text;
              }

              return mutationTable[text.charAt(0)] + text.substring(1);
            }

            var monthsParse = [/^gen/i, /^c[ʼ\']hwe/i, /^meu/i, /^ebr/i, /^mae/i, /^(mez|eve)/i, /^gou/i, /^eos/i, /^gwe/i, /^her/i, /^du/i, /^ker/i],
                monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
                monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
                monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
                fullWeekdaysParse = [/^sul/i, /^lun/i, /^meurzh/i, /^merc[ʼ\']her/i, /^yaou/i, /^gwener/i, /^sadorn/i],
                shortWeekdaysParse = [/^Sul/i, /^Lun/i, /^Meu/i, /^Mer/i, /^Yao/i, /^Gwe/i, /^Sad/i],
                minWeekdaysParse = [/^Su/i, /^Lu/i, /^Me([^r]|$)/i, /^Mer/i, /^Ya/i, /^Gw/i, /^Sa/i];
            var br = moment.defineLocale('br', {
              months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
              monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
              weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
              weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
              weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
              weekdaysParse: minWeekdaysParse,
              fullWeekdaysParse: fullWeekdaysParse,
              shortWeekdaysParse: shortWeekdaysParse,
              minWeekdaysParse: minWeekdaysParse,
              monthsRegex: monthsRegex,
              monthsShortRegex: monthsRegex,
              monthsStrictRegex: monthsStrictRegex,
              monthsShortStrictRegex: monthsShortStrictRegex,
              monthsParse: monthsParse,
              longMonthsParse: monthsParse,
              shortMonthsParse: monthsParse,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D [a viz] MMMM YYYY',
                LLL: 'D [a viz] MMMM YYYY HH:mm',
                LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Hiziv da] LT',
                nextDay: '[Warcʼhoazh da] LT',
                nextWeek: 'dddd [da] LT',
                lastDay: '[Decʼh da] LT',
                lastWeek: 'dddd [paset da] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'a-benn %s',
                past: '%s ʼzo',
                s: 'un nebeud segondennoù',
                ss: '%d eilenn',
                m: 'ur vunutenn',
                mm: relativeTimeWithMutation,
                h: 'un eur',
                hh: '%d eur',
                d: 'un devezh',
                dd: relativeTimeWithMutation,
                M: 'ur miz',
                MM: relativeTimeWithMutation,
                y: 'ur bloaz',
                yy: specialMutationForYears
              },
              dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
              ordinal: function ordinal(number) {
                var output = number === 1 ? 'añ' : 'vet';
                return number + output;
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              },
              meridiemParse: /a.m.|g.m./,
              // goude merenn | a-raok merenn
              isPM: function isPM(token) {
                return token === 'g.m.';
              },
              meridiem: function meridiem(hour, minute, isLower) {
                return hour < 12 ? 'a.m.' : 'g.m.';
              }
            });
            return br;
          });
          /***/

        },

        /***/
        622:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Bosnian [bs]
          //! author : Nedim Cholich : https://github.com/frontyard
          //! based on (hr) translation by Bojan Marković
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            function translate(number, withoutSuffix, key) {
              var result = number + ' ';

              switch (key) {
                case 'ss':
                  if (number === 1) {
                    result += 'sekunda';
                  } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                  } else {
                    result += 'sekundi';
                  }

                  return result;

                case 'm':
                  return withoutSuffix ? 'jedna minuta' : 'jedne minute';

                case 'mm':
                  if (number === 1) {
                    result += 'minuta';
                  } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                  } else {
                    result += 'minuta';
                  }

                  return result;

                case 'h':
                  return withoutSuffix ? 'jedan sat' : 'jednog sata';

                case 'hh':
                  if (number === 1) {
                    result += 'sat';
                  } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                  } else {
                    result += 'sati';
                  }

                  return result;

                case 'dd':
                  if (number === 1) {
                    result += 'dan';
                  } else {
                    result += 'dana';
                  }

                  return result;

                case 'MM':
                  if (number === 1) {
                    result += 'mjesec';
                  } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                  } else {
                    result += 'mjeseci';
                  }

                  return result;

                case 'yy':
                  if (number === 1) {
                    result += 'godina';
                  } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                  } else {
                    result += 'godina';
                  }

                  return result;
              }
            }

            var bs = moment.defineLocale('bs', {
              months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
              monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
              monthsParseExact: true,
              weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
              weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
              weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D. MMMM YYYY',
                LLL: 'D. MMMM YYYY H:mm',
                LLLL: 'dddd, D. MMMM YYYY H:mm'
              },
              calendar: {
                sameDay: '[danas u] LT',
                nextDay: '[sutra u] LT',
                nextWeek: function nextWeek() {
                  switch (this.day()) {
                    case 0:
                      return '[u] [nedjelju] [u] LT';

                    case 3:
                      return '[u] [srijedu] [u] LT';

                    case 6:
                      return '[u] [subotu] [u] LT';

                    case 1:
                    case 2:
                    case 4:
                    case 5:
                      return '[u] dddd [u] LT';
                  }
                },
                lastDay: '[jučer u] LT',
                lastWeek: function lastWeek() {
                  switch (this.day()) {
                    case 0:
                    case 3:
                      return '[prošlu] dddd [u] LT';

                    case 6:
                      return '[prošle] [subote] [u] LT';

                    case 1:
                    case 2:
                    case 4:
                    case 5:
                      return '[prošli] dddd [u] LT';
                  }
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'za %s',
                past: 'prije %s',
                s: 'par sekundi',
                ss: translate,
                m: translate,
                mm: translate,
                h: translate,
                hh: translate,
                d: 'dan',
                dd: translate,
                M: 'mjesec',
                MM: translate,
                y: 'godinu',
                yy: translate
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return bs;
          });
          /***/

        },

        /***/
        2468:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Catalan [ca]
          //! author : Juan G. Hurtado : https://github.com/juanghurtado
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var ca = moment.defineLocale('ca', {
              months: {
                standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
                format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split('_'),
                isFormat: /D[oD]?(\s)+MMMM/
              },
              monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
              monthsParseExact: true,
              weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
              weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
              weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM [de] YYYY',
                ll: 'D MMM YYYY',
                LLL: 'D MMMM [de] YYYY [a les] H:mm',
                lll: 'D MMM YYYY, H:mm',
                LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
                llll: 'ddd D MMM YYYY, H:mm'
              },
              calendar: {
                sameDay: function sameDay() {
                  return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
                },
                nextDay: function nextDay() {
                  return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
                },
                nextWeek: function nextWeek() {
                  return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
                },
                lastDay: function lastDay() {
                  return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
                },
                lastWeek: function lastWeek() {
                  return '[el] dddd [passat a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: "d'aquí %s",
                past: 'fa %s',
                s: 'uns segons',
                ss: '%d segons',
                m: 'un minut',
                mm: '%d minuts',
                h: 'una hora',
                hh: '%d hores',
                d: 'un dia',
                dd: '%d dies',
                M: 'un mes',
                MM: '%d mesos',
                y: 'un any',
                yy: '%d anys'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
              ordinal: function ordinal(number, period) {
                var output = number === 1 ? 'r' : number === 2 ? 'n' : number === 3 ? 'r' : number === 4 ? 't' : 'è';

                if (period === 'w' || period === 'W') {
                  output = 'a';
                }

                return number + output;
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return ca;
          });
          /***/

        },

        /***/
        5822:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Czech [cs]
          //! author : petrbela : https://github.com/petrbela
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
                monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
                monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i],
                // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
            // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
            monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

            function plural(n) {
              return n > 1 && n < 5 && ~~(n / 10) !== 1;
            }

            function translate(number, withoutSuffix, key, isFuture) {
              var result = number + ' ';

              switch (key) {
                case 's':
                  // a few seconds / in a few seconds / a few seconds ago
                  return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';

                case 'ss':
                  // 9 seconds / in 9 seconds / 9 seconds ago
                  if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                  } else {
                    return result + 'sekundami';
                  }

                case 'm':
                  // a minute / in a minute / a minute ago
                  return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';

                case 'mm':
                  // 9 minutes / in 9 minutes / 9 minutes ago
                  if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                  } else {
                    return result + 'minutami';
                  }

                case 'h':
                  // an hour / in an hour / an hour ago
                  return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';

                case 'hh':
                  // 9 hours / in 9 hours / 9 hours ago
                  if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                  } else {
                    return result + 'hodinami';
                  }

                case 'd':
                  // a day / in a day / a day ago
                  return withoutSuffix || isFuture ? 'den' : 'dnem';

                case 'dd':
                  // 9 days / in 9 days / 9 days ago
                  if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                  } else {
                    return result + 'dny';
                  }

                case 'M':
                  // a month / in a month / a month ago
                  return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';

                case 'MM':
                  // 9 months / in 9 months / 9 months ago
                  if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                  } else {
                    return result + 'měsíci';
                  }

                case 'y':
                  // a year / in a year / a year ago
                  return withoutSuffix || isFuture ? 'rok' : 'rokem';

                case 'yy':
                  // 9 years / in 9 years / 9 years ago
                  if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                  } else {
                    return result + 'lety';
                  }

              }
            }

            var cs = moment.defineLocale('cs', {
              months: months,
              monthsShort: monthsShort,
              monthsRegex: monthsRegex,
              monthsShortRegex: monthsRegex,
              // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
              // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
              monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
              monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
              monthsParse: monthsParse,
              longMonthsParse: monthsParse,
              shortMonthsParse: monthsParse,
              weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
              weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
              weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D. MMMM YYYY',
                LLL: 'D. MMMM YYYY H:mm',
                LLLL: 'dddd D. MMMM YYYY H:mm',
                l: 'D. M. YYYY'
              },
              calendar: {
                sameDay: '[dnes v] LT',
                nextDay: '[zítra v] LT',
                nextWeek: function nextWeek() {
                  switch (this.day()) {
                    case 0:
                      return '[v neděli v] LT';

                    case 1:
                    case 2:
                      return '[v] dddd [v] LT';

                    case 3:
                      return '[ve středu v] LT';

                    case 4:
                      return '[ve čtvrtek v] LT';

                    case 5:
                      return '[v pátek v] LT';

                    case 6:
                      return '[v sobotu v] LT';
                  }
                },
                lastDay: '[včera v] LT',
                lastWeek: function lastWeek() {
                  switch (this.day()) {
                    case 0:
                      return '[minulou neděli v] LT';

                    case 1:
                    case 2:
                      return '[minulé] dddd [v] LT';

                    case 3:
                      return '[minulou středu v] LT';

                    case 4:
                    case 5:
                      return '[minulý] dddd [v] LT';

                    case 6:
                      return '[minulou sobotu v] LT';
                  }
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'za %s',
                past: 'před %s',
                s: translate,
                ss: translate,
                m: translate,
                mm: translate,
                h: translate,
                hh: translate,
                d: translate,
                dd: translate,
                M: translate,
                MM: translate,
                y: translate,
                yy: translate
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return cs;
          });
          /***/

        },

        /***/
        877:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Chuvash [cv]
          //! author : Anatoly Mironov : https://github.com/mirontoli
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var cv = moment.defineLocale('cv', {
              months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
              monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
              weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
              weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
              weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD-MM-YYYY',
                LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
                LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
                LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
              },
              calendar: {
                sameDay: '[Паян] LT [сехетре]',
                nextDay: '[Ыран] LT [сехетре]',
                lastDay: '[Ӗнер] LT [сехетре]',
                nextWeek: '[Ҫитес] dddd LT [сехетре]',
                lastWeek: '[Иртнӗ] dddd LT [сехетре]',
                sameElse: 'L'
              },
              relativeTime: {
                future: function future(output) {
                  var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
                  return output + affix;
                },
                past: '%s каялла',
                s: 'пӗр-ик ҫеккунт',
                ss: '%d ҫеккунт',
                m: 'пӗр минут',
                mm: '%d минут',
                h: 'пӗр сехет',
                hh: '%d сехет',
                d: 'пӗр кун',
                dd: '%d кун',
                M: 'пӗр уйӑх',
                MM: '%d уйӑх',
                y: 'пӗр ҫул',
                yy: '%d ҫул'
              },
              dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
              ordinal: '%d-мӗш',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return cv;
          });
          /***/

        },

        /***/
        7373:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Welsh [cy]
          //! author : Robert Allen : https://github.com/robgallen
          //! author : https://github.com/ryangreaves
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var cy = moment.defineLocale('cy', {
              months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
              monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
              weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
              weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
              weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
              weekdaysParseExact: true,
              // time formats are the same as en-gb
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Heddiw am] LT',
                nextDay: '[Yfory am] LT',
                nextWeek: 'dddd [am] LT',
                lastDay: '[Ddoe am] LT',
                lastWeek: 'dddd [diwethaf am] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'mewn %s',
                past: '%s yn ôl',
                s: 'ychydig eiliadau',
                ss: '%d eiliad',
                m: 'munud',
                mm: '%d munud',
                h: 'awr',
                hh: '%d awr',
                d: 'diwrnod',
                dd: '%d diwrnod',
                M: 'mis',
                MM: '%d mis',
                y: 'blwyddyn',
                yy: '%d flynedd'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
              // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
              ordinal: function ordinal(number) {
                var b = number,
                    output = '',
                    lookup = ['', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
                ];

                if (b > 20) {
                  if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                  } else {
                    output = 'ain';
                  }
                } else if (b > 0) {
                  output = lookup[b];
                }

                return number + output;
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return cy;
          });
          /***/

        },

        /***/
        4780:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Danish [da]
          //! author : Ulrik Nielsen : https://github.com/mrbase
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var da = moment.defineLocale('da', {
              months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
              monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
              weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
              weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
              weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D. MMMM YYYY',
                LLL: 'D. MMMM YYYY HH:mm',
                LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
              },
              calendar: {
                sameDay: '[i dag kl.] LT',
                nextDay: '[i morgen kl.] LT',
                nextWeek: 'på dddd [kl.] LT',
                lastDay: '[i går kl.] LT',
                lastWeek: '[i] dddd[s kl.] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'om %s',
                past: '%s siden',
                s: 'få sekunder',
                ss: '%d sekunder',
                m: 'et minut',
                mm: '%d minutter',
                h: 'en time',
                hh: '%d timer',
                d: 'en dag',
                dd: '%d dage',
                M: 'en måned',
                MM: '%d måneder',
                y: 'et år',
                yy: '%d år'
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return da;
          });
          /***/

        },

        /***/
        217:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : German (Austria) [de-at]
          //! author : lluchs : https://github.com/lluchs
          //! author: Menelion Elensúle: https://github.com/Oire
          //! author : Martin Groller : https://github.com/MadMG
          //! author : Mikolaj Dadela : https://github.com/mik01aj
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            function processRelativeTime(number, withoutSuffix, key, isFuture) {
              var format = {
                m: ['eine Minute', 'einer Minute'],
                h: ['eine Stunde', 'einer Stunde'],
                d: ['ein Tag', 'einem Tag'],
                dd: [number + ' Tage', number + ' Tagen'],
                w: ['eine Woche', 'einer Woche'],
                M: ['ein Monat', 'einem Monat'],
                MM: [number + ' Monate', number + ' Monaten'],
                y: ['ein Jahr', 'einem Jahr'],
                yy: [number + ' Jahre', number + ' Jahren']
              };
              return withoutSuffix ? format[key][0] : format[key][1];
            }

            var deAt = moment.defineLocale('de-at', {
              months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
              monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
              monthsParseExact: true,
              weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
              weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
              weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D. MMMM YYYY',
                LLL: 'D. MMMM YYYY HH:mm',
                LLLL: 'dddd, D. MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[heute um] LT [Uhr]',
                sameElse: 'L',
                nextDay: '[morgen um] LT [Uhr]',
                nextWeek: 'dddd [um] LT [Uhr]',
                lastDay: '[gestern um] LT [Uhr]',
                lastWeek: '[letzten] dddd [um] LT [Uhr]'
              },
              relativeTime: {
                future: 'in %s',
                past: 'vor %s',
                s: 'ein paar Sekunden',
                ss: '%d Sekunden',
                m: processRelativeTime,
                mm: '%d Minuten',
                h: processRelativeTime,
                hh: '%d Stunden',
                d: processRelativeTime,
                dd: processRelativeTime,
                w: processRelativeTime,
                ww: '%d Wochen',
                M: processRelativeTime,
                MM: processRelativeTime,
                y: processRelativeTime,
                yy: processRelativeTime
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return deAt;
          });
          /***/

        },

        /***/
        894:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : German (Switzerland) [de-ch]
          //! author : sschueller : https://github.com/sschueller
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            function processRelativeTime(number, withoutSuffix, key, isFuture) {
              var format = {
                m: ['eine Minute', 'einer Minute'],
                h: ['eine Stunde', 'einer Stunde'],
                d: ['ein Tag', 'einem Tag'],
                dd: [number + ' Tage', number + ' Tagen'],
                w: ['eine Woche', 'einer Woche'],
                M: ['ein Monat', 'einem Monat'],
                MM: [number + ' Monate', number + ' Monaten'],
                y: ['ein Jahr', 'einem Jahr'],
                yy: [number + ' Jahre', number + ' Jahren']
              };
              return withoutSuffix ? format[key][0] : format[key][1];
            }

            var deCh = moment.defineLocale('de-ch', {
              months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
              monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
              monthsParseExact: true,
              weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
              weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
              weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D. MMMM YYYY',
                LLL: 'D. MMMM YYYY HH:mm',
                LLLL: 'dddd, D. MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[heute um] LT [Uhr]',
                sameElse: 'L',
                nextDay: '[morgen um] LT [Uhr]',
                nextWeek: 'dddd [um] LT [Uhr]',
                lastDay: '[gestern um] LT [Uhr]',
                lastWeek: '[letzten] dddd [um] LT [Uhr]'
              },
              relativeTime: {
                future: 'in %s',
                past: 'vor %s',
                s: 'ein paar Sekunden',
                ss: '%d Sekunden',
                m: processRelativeTime,
                mm: '%d Minuten',
                h: processRelativeTime,
                hh: '%d Stunden',
                d: processRelativeTime,
                dd: processRelativeTime,
                w: processRelativeTime,
                ww: '%d Wochen',
                M: processRelativeTime,
                MM: processRelativeTime,
                y: processRelativeTime,
                yy: processRelativeTime
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return deCh;
          });
          /***/

        },

        /***/
        9740:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : German [de]
          //! author : lluchs : https://github.com/lluchs
          //! author: Menelion Elensúle: https://github.com/Oire
          //! author : Mikolaj Dadela : https://github.com/mik01aj
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            function processRelativeTime(number, withoutSuffix, key, isFuture) {
              var format = {
                m: ['eine Minute', 'einer Minute'],
                h: ['eine Stunde', 'einer Stunde'],
                d: ['ein Tag', 'einem Tag'],
                dd: [number + ' Tage', number + ' Tagen'],
                w: ['eine Woche', 'einer Woche'],
                M: ['ein Monat', 'einem Monat'],
                MM: [number + ' Monate', number + ' Monaten'],
                y: ['ein Jahr', 'einem Jahr'],
                yy: [number + ' Jahre', number + ' Jahren']
              };
              return withoutSuffix ? format[key][0] : format[key][1];
            }

            var de = moment.defineLocale('de', {
              months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
              monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
              monthsParseExact: true,
              weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
              weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
              weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D. MMMM YYYY',
                LLL: 'D. MMMM YYYY HH:mm',
                LLLL: 'dddd, D. MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[heute um] LT [Uhr]',
                sameElse: 'L',
                nextDay: '[morgen um] LT [Uhr]',
                nextWeek: 'dddd [um] LT [Uhr]',
                lastDay: '[gestern um] LT [Uhr]',
                lastWeek: '[letzten] dddd [um] LT [Uhr]'
              },
              relativeTime: {
                future: 'in %s',
                past: 'vor %s',
                s: 'ein paar Sekunden',
                ss: '%d Sekunden',
                m: processRelativeTime,
                mm: '%d Minuten',
                h: processRelativeTime,
                hh: '%d Stunden',
                d: processRelativeTime,
                dd: processRelativeTime,
                w: processRelativeTime,
                ww: '%d Wochen',
                M: processRelativeTime,
                MM: processRelativeTime,
                y: processRelativeTime,
                yy: processRelativeTime
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return de;
          });
          /***/

        },

        /***/
        5300:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Maldivian [dv]
          //! author : Jawish Hameed : https://github.com/jawish
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var months = ['ޖެނުއަރީ', 'ފެބްރުއަރީ', 'މާރިޗު', 'އޭޕްރީލު', 'މޭ', 'ޖޫން', 'ޖުލައި', 'އޯގަސްޓު', 'ސެޕްޓެމްބަރު', 'އޮކްޓޯބަރު', 'ނޮވެމްބަރު', 'ޑިސެމްބަރު'],
                weekdays = ['އާދިއްތަ', 'ހޯމަ', 'އަންގާރަ', 'ބުދަ', 'ބުރާސްފަތި', 'ހުކުރު', 'ހޮނިހިރު'];
            var dv = moment.defineLocale('dv', {
              months: months,
              monthsShort: months,
              weekdays: weekdays,
              weekdaysShort: weekdays,
              weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'D/M/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              meridiemParse: /މކ|މފ/,
              isPM: function isPM(input) {
                return 'މފ' === input;
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 12) {
                  return 'މކ';
                } else {
                  return 'މފ';
                }
              },
              calendar: {
                sameDay: '[މިއަދު] LT',
                nextDay: '[މާދަމާ] LT',
                nextWeek: 'dddd LT',
                lastDay: '[އިއްޔެ] LT',
                lastWeek: '[ފާއިތުވި] dddd LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'ތެރޭގައި %s',
                past: 'ކުރިން %s',
                s: 'ސިކުންތުކޮޅެއް',
                ss: 'd% ސިކުންތު',
                m: 'މިނިޓެއް',
                mm: 'މިނިޓު %d',
                h: 'ގަޑިއިރެއް',
                hh: 'ގަޑިއިރު %d',
                d: 'ދުވަހެއް',
                dd: 'ދުވަސް %d',
                M: 'މަހެއް',
                MM: 'މަސް %d',
                y: 'އަހަރެއް',
                yy: 'އަހަރު %d'
              },
              preparse: function preparse(string) {
                return string.replace(/،/g, ',');
              },
              postformat: function postformat(string) {
                return string.replace(/,/g, '،');
              },
              week: {
                dow: 7,
                // Sunday is the first day of the week.
                doy: 12 // The week that contains Jan 12th is the first week of the year.

              }
            });
            return dv;
          });
          /***/

        },

        /***/
        837:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Greek [el]
          //! author : Aggelos Karalias : https://github.com/mehiel
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            function isFunction(input) {
              return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
            }

            var el = moment.defineLocale('el', {
              monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
              monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
              months: function months(momentToFormat, format) {
                if (!momentToFormat) {
                  return this._monthsNominativeEl;
                } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) {
                  // if there is a day number before 'MMMM'
                  return this._monthsGenitiveEl[momentToFormat.month()];
                } else {
                  return this._monthsNominativeEl[momentToFormat.month()];
                }
              },
              monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
              weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
              weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
              weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
              meridiem: function meridiem(hours, minutes, isLower) {
                if (hours > 11) {
                  return isLower ? 'μμ' : 'ΜΜ';
                } else {
                  return isLower ? 'πμ' : 'ΠΜ';
                }
              },
              isPM: function isPM(input) {
                return (input + '').toLowerCase()[0] === 'μ';
              },
              meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
              longDateFormat: {
                LT: 'h:mm A',
                LTS: 'h:mm:ss A',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY h:mm A',
                LLLL: 'dddd, D MMMM YYYY h:mm A'
              },
              calendarEl: {
                sameDay: '[Σήμερα {}] LT',
                nextDay: '[Αύριο {}] LT',
                nextWeek: 'dddd [{}] LT',
                lastDay: '[Χθες {}] LT',
                lastWeek: function lastWeek() {
                  switch (this.day()) {
                    case 6:
                      return '[το προηγούμενο] dddd [{}] LT';

                    default:
                      return '[την προηγούμενη] dddd [{}] LT';
                  }
                },
                sameElse: 'L'
              },
              calendar: function calendar(key, mom) {
                var output = this._calendarEl[key],
                    hours = mom && mom.hours();

                if (isFunction(output)) {
                  output = output.apply(mom);
                }

                return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
              },
              relativeTime: {
                future: 'σε %s',
                past: '%s πριν',
                s: 'λίγα δευτερόλεπτα',
                ss: '%d δευτερόλεπτα',
                m: 'ένα λεπτό',
                mm: '%d λεπτά',
                h: 'μία ώρα',
                hh: '%d ώρες',
                d: 'μία μέρα',
                dd: '%d μέρες',
                M: 'ένας μήνας',
                MM: '%d μήνες',
                y: 'ένας χρόνος',
                yy: '%d χρόνια'
              },
              dayOfMonthOrdinalParse: /\d{1,2}η/,
              ordinal: '%dη',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4st is the first week of the year.

              }
            });
            return el;
          });
          /***/

        },

        /***/
        8348:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : English (Australia) [en-au]
          //! author : Jared Morse : https://github.com/jarcoal
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var enAu = moment.defineLocale('en-au', {
              months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
              monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
              weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
              weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
              weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
              longDateFormat: {
                LT: 'h:mm A',
                LTS: 'h:mm:ss A',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY h:mm A',
                LLLL: 'dddd, D MMMM YYYY h:mm A'
              },
              calendar: {
                sameDay: '[Today at] LT',
                nextDay: '[Tomorrow at] LT',
                nextWeek: 'dddd [at] LT',
                lastDay: '[Yesterday at] LT',
                lastWeek: '[Last] dddd [at] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'in %s',
                past: '%s ago',
                s: 'a few seconds',
                ss: '%d seconds',
                m: 'a minute',
                mm: '%d minutes',
                h: 'an hour',
                hh: '%d hours',
                d: 'a day',
                dd: '%d days',
                M: 'a month',
                MM: '%d months',
                y: 'a year',
                yy: '%d years'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
              ordinal: function ordinal(number) {
                var b = number % 10,
                    output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
                return number + output;
              },
              week: {
                dow: 0,
                // Sunday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return enAu;
          });
          /***/

        },

        /***/
        7925:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : English (Canada) [en-ca]
          //! author : Jonathan Abourbih : https://github.com/jonbca
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var enCa = moment.defineLocale('en-ca', {
              months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
              monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
              weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
              weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
              weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
              longDateFormat: {
                LT: 'h:mm A',
                LTS: 'h:mm:ss A',
                L: 'YYYY-MM-DD',
                LL: 'MMMM D, YYYY',
                LLL: 'MMMM D, YYYY h:mm A',
                LLLL: 'dddd, MMMM D, YYYY h:mm A'
              },
              calendar: {
                sameDay: '[Today at] LT',
                nextDay: '[Tomorrow at] LT',
                nextWeek: 'dddd [at] LT',
                lastDay: '[Yesterday at] LT',
                lastWeek: '[Last] dddd [at] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'in %s',
                past: '%s ago',
                s: 'a few seconds',
                ss: '%d seconds',
                m: 'a minute',
                mm: '%d minutes',
                h: 'an hour',
                hh: '%d hours',
                d: 'a day',
                dd: '%d days',
                M: 'a month',
                MM: '%d months',
                y: 'a year',
                yy: '%d years'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
              ordinal: function ordinal(number) {
                var b = number % 10,
                    output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
                return number + output;
              }
            });
            return enCa;
          });
          /***/

        },

        /***/
        2243:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : English (United Kingdom) [en-gb]
          //! author : Chris Gedrim : https://github.com/chrisgedrim
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var enGb = moment.defineLocale('en-gb', {
              months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
              monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
              weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
              weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
              weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Today at] LT',
                nextDay: '[Tomorrow at] LT',
                nextWeek: 'dddd [at] LT',
                lastDay: '[Yesterday at] LT',
                lastWeek: '[Last] dddd [at] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'in %s',
                past: '%s ago',
                s: 'a few seconds',
                ss: '%d seconds',
                m: 'a minute',
                mm: '%d minutes',
                h: 'an hour',
                hh: '%d hours',
                d: 'a day',
                dd: '%d days',
                M: 'a month',
                MM: '%d months',
                y: 'a year',
                yy: '%d years'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
              ordinal: function ordinal(number) {
                var b = number % 10,
                    output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
                return number + output;
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return enGb;
          });
          /***/

        },

        /***/
        6436:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : English (Ireland) [en-ie]
          //! author : Chris Cartlidge : https://github.com/chriscartlidge
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var enIe = moment.defineLocale('en-ie', {
              months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
              monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
              weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
              weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
              weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Today at] LT',
                nextDay: '[Tomorrow at] LT',
                nextWeek: 'dddd [at] LT',
                lastDay: '[Yesterday at] LT',
                lastWeek: '[Last] dddd [at] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'in %s',
                past: '%s ago',
                s: 'a few seconds',
                ss: '%d seconds',
                m: 'a minute',
                mm: '%d minutes',
                h: 'an hour',
                hh: '%d hours',
                d: 'a day',
                dd: '%d days',
                M: 'a month',
                MM: '%d months',
                y: 'a year',
                yy: '%d years'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
              ordinal: function ordinal(number) {
                var b = number % 10,
                    output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
                return number + output;
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return enIe;
          });
          /***/

        },

        /***/
        7207:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : English (Israel) [en-il]
          //! author : Chris Gedrim : https://github.com/chrisgedrim
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var enIl = moment.defineLocale('en-il', {
              months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
              monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
              weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
              weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
              weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Today at] LT',
                nextDay: '[Tomorrow at] LT',
                nextWeek: 'dddd [at] LT',
                lastDay: '[Yesterday at] LT',
                lastWeek: '[Last] dddd [at] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'in %s',
                past: '%s ago',
                s: 'a few seconds',
                ss: '%d seconds',
                m: 'a minute',
                mm: '%d minutes',
                h: 'an hour',
                hh: '%d hours',
                d: 'a day',
                dd: '%d days',
                M: 'a month',
                MM: '%d months',
                y: 'a year',
                yy: '%d years'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
              ordinal: function ordinal(number) {
                var b = number % 10,
                    output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
                return number + output;
              }
            });
            return enIl;
          });
          /***/

        },

        /***/
        4175:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : English (India) [en-in]
          //! author : Jatin Agrawal : https://github.com/jatinag22
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var enIn = moment.defineLocale('en-in', {
              months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
              monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
              weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
              weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
              weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
              longDateFormat: {
                LT: 'h:mm A',
                LTS: 'h:mm:ss A',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY h:mm A',
                LLLL: 'dddd, D MMMM YYYY h:mm A'
              },
              calendar: {
                sameDay: '[Today at] LT',
                nextDay: '[Tomorrow at] LT',
                nextWeek: 'dddd [at] LT',
                lastDay: '[Yesterday at] LT',
                lastWeek: '[Last] dddd [at] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'in %s',
                past: '%s ago',
                s: 'a few seconds',
                ss: '%d seconds',
                m: 'a minute',
                mm: '%d minutes',
                h: 'an hour',
                hh: '%d hours',
                d: 'a day',
                dd: '%d days',
                M: 'a month',
                MM: '%d months',
                y: 'a year',
                yy: '%d years'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
              ordinal: function ordinal(number) {
                var b = number % 10,
                    output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
                return number + output;
              },
              week: {
                dow: 0,
                // Sunday is the first day of the week.
                doy: 6 // The week that contains Jan 1st is the first week of the year.

              }
            });
            return enIn;
          });
          /***/

        },

        /***/
        6319:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : English (New Zealand) [en-nz]
          //! author : Luke McGregor : https://github.com/lukemcgregor
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var enNz = moment.defineLocale('en-nz', {
              months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
              monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
              weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
              weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
              weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
              longDateFormat: {
                LT: 'h:mm A',
                LTS: 'h:mm:ss A',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY h:mm A',
                LLLL: 'dddd, D MMMM YYYY h:mm A'
              },
              calendar: {
                sameDay: '[Today at] LT',
                nextDay: '[Tomorrow at] LT',
                nextWeek: 'dddd [at] LT',
                lastDay: '[Yesterday at] LT',
                lastWeek: '[Last] dddd [at] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'in %s',
                past: '%s ago',
                s: 'a few seconds',
                ss: '%d seconds',
                m: 'a minute',
                mm: '%d minutes',
                h: 'an hour',
                hh: '%d hours',
                d: 'a day',
                dd: '%d days',
                M: 'a month',
                MM: '%d months',
                y: 'a year',
                yy: '%d years'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
              ordinal: function ordinal(number) {
                var b = number % 10,
                    output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
                return number + output;
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return enNz;
          });
          /***/

        },

        /***/
        1662:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : English (Singapore) [en-sg]
          //! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var enSg = moment.defineLocale('en-sg', {
              months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
              monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
              weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
              weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
              weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Today at] LT',
                nextDay: '[Tomorrow at] LT',
                nextWeek: 'dddd [at] LT',
                lastDay: '[Yesterday at] LT',
                lastWeek: '[Last] dddd [at] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'in %s',
                past: '%s ago',
                s: 'a few seconds',
                ss: '%d seconds',
                m: 'a minute',
                mm: '%d minutes',
                h: 'an hour',
                hh: '%d hours',
                d: 'a day',
                dd: '%d days',
                M: 'a month',
                MM: '%d months',
                y: 'a year',
                yy: '%d years'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
              ordinal: function ordinal(number) {
                var b = number % 10,
                    output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
                return number + output;
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return enSg;
          });
          /***/

        },

        /***/
        2915:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Esperanto [eo]
          //! author : Colin Dean : https://github.com/colindean
          //! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
          //! comment : miestasmia corrected the translation by colindean
          //! comment : Vivakvo corrected the translation by colindean and miestasmia
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var eo = moment.defineLocale('eo', {
              months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
              monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
              weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
              weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
              weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'YYYY-MM-DD',
                LL: '[la] D[-an de] MMMM, YYYY',
                LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
                LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
                llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm'
              },
              meridiemParse: /[ap]\.t\.m/i,
              isPM: function isPM(input) {
                return input.charAt(0).toLowerCase() === 'p';
              },
              meridiem: function meridiem(hours, minutes, isLower) {
                if (hours > 11) {
                  return isLower ? 'p.t.m.' : 'P.T.M.';
                } else {
                  return isLower ? 'a.t.m.' : 'A.T.M.';
                }
              },
              calendar: {
                sameDay: '[Hodiaŭ je] LT',
                nextDay: '[Morgaŭ je] LT',
                nextWeek: 'dddd[n je] LT',
                lastDay: '[Hieraŭ je] LT',
                lastWeek: '[pasintan] dddd[n je] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'post %s',
                past: 'antaŭ %s',
                s: 'kelkaj sekundoj',
                ss: '%d sekundoj',
                m: 'unu minuto',
                mm: '%d minutoj',
                h: 'unu horo',
                hh: '%d horoj',
                d: 'unu tago',
                //ne 'diurno', ĉar estas uzita por proksimumo
                dd: '%d tagoj',
                M: 'unu monato',
                MM: '%d monatoj',
                y: 'unu jaro',
                yy: '%d jaroj'
              },
              dayOfMonthOrdinalParse: /\d{1,2}a/,
              ordinal: '%da',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return eo;
          });
          /***/

        },

        /***/
        5251:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Spanish (Dominican Republic) [es-do]
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
                _monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
                monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
                monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

            var esDo = moment.defineLocale('es-do', {
              months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
              monthsShort: function monthsShort(m, format) {
                if (!m) {
                  return monthsShortDot;
                } else if (/-MMM-/.test(format)) {
                  return _monthsShort[m.month()];
                } else {
                  return monthsShortDot[m.month()];
                }
              },
              monthsRegex: monthsRegex,
              monthsShortRegex: monthsRegex,
              monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
              monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
              monthsParse: monthsParse,
              longMonthsParse: monthsParse,
              shortMonthsParse: monthsParse,
              weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
              weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
              weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'h:mm A',
                LTS: 'h:mm:ss A',
                L: 'DD/MM/YYYY',
                LL: 'D [de] MMMM [de] YYYY',
                LLL: 'D [de] MMMM [de] YYYY h:mm A',
                LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A'
              },
              calendar: {
                sameDay: function sameDay() {
                  return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                nextDay: function nextDay() {
                  return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                nextWeek: function nextWeek() {
                  return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                lastDay: function lastDay() {
                  return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                lastWeek: function lastWeek() {
                  return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'en %s',
                past: 'hace %s',
                s: 'unos segundos',
                ss: '%d segundos',
                m: 'un minuto',
                mm: '%d minutos',
                h: 'una hora',
                hh: '%d horas',
                d: 'un día',
                dd: '%d días',
                w: 'una semana',
                ww: '%d semanas',
                M: 'un mes',
                MM: '%d meses',
                y: 'un año',
                yy: '%d años'
              },
              dayOfMonthOrdinalParse: /\d{1,2}º/,
              ordinal: '%dº',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return esDo;
          });
          /***/

        },

        /***/
        6112:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Spanish (Mexico) [es-mx]
          //! author : JC Franco : https://github.com/jcfranco
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
                _monthsShort2 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
                monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
                monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

            var esMx = moment.defineLocale('es-mx', {
              months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
              monthsShort: function monthsShort(m, format) {
                if (!m) {
                  return monthsShortDot;
                } else if (/-MMM-/.test(format)) {
                  return _monthsShort2[m.month()];
                } else {
                  return monthsShortDot[m.month()];
                }
              },
              monthsRegex: monthsRegex,
              monthsShortRegex: monthsRegex,
              monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
              monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
              monthsParse: monthsParse,
              longMonthsParse: monthsParse,
              shortMonthsParse: monthsParse,
              weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
              weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
              weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D [de] MMMM [de] YYYY',
                LLL: 'D [de] MMMM [de] YYYY H:mm',
                LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
              },
              calendar: {
                sameDay: function sameDay() {
                  return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                nextDay: function nextDay() {
                  return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                nextWeek: function nextWeek() {
                  return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                lastDay: function lastDay() {
                  return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                lastWeek: function lastWeek() {
                  return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'en %s',
                past: 'hace %s',
                s: 'unos segundos',
                ss: '%d segundos',
                m: 'un minuto',
                mm: '%d minutos',
                h: 'una hora',
                hh: '%d horas',
                d: 'un día',
                dd: '%d días',
                w: 'una semana',
                ww: '%d semanas',
                M: 'un mes',
                MM: '%d meses',
                y: 'un año',
                yy: '%d años'
              },
              dayOfMonthOrdinalParse: /\d{1,2}º/,
              ordinal: '%dº',
              week: {
                dow: 0,
                // Sunday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              },
              invalidDate: 'Fecha inválida'
            });
            return esMx;
          });
          /***/

        },

        /***/
        1146:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Spanish (United States) [es-us]
          //! author : bustta : https://github.com/bustta
          //! author : chrisrodz : https://github.com/chrisrodz
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
                _monthsShort3 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
                monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
                monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

            var esUs = moment.defineLocale('es-us', {
              months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
              monthsShort: function monthsShort(m, format) {
                if (!m) {
                  return monthsShortDot;
                } else if (/-MMM-/.test(format)) {
                  return _monthsShort3[m.month()];
                } else {
                  return monthsShortDot[m.month()];
                }
              },
              monthsRegex: monthsRegex,
              monthsShortRegex: monthsRegex,
              monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
              monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
              monthsParse: monthsParse,
              longMonthsParse: monthsParse,
              shortMonthsParse: monthsParse,
              weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
              weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
              weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'h:mm A',
                LTS: 'h:mm:ss A',
                L: 'MM/DD/YYYY',
                LL: 'D [de] MMMM [de] YYYY',
                LLL: 'D [de] MMMM [de] YYYY h:mm A',
                LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A'
              },
              calendar: {
                sameDay: function sameDay() {
                  return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                nextDay: function nextDay() {
                  return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                nextWeek: function nextWeek() {
                  return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                lastDay: function lastDay() {
                  return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                lastWeek: function lastWeek() {
                  return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'en %s',
                past: 'hace %s',
                s: 'unos segundos',
                ss: '%d segundos',
                m: 'un minuto',
                mm: '%d minutos',
                h: 'una hora',
                hh: '%d horas',
                d: 'un día',
                dd: '%d días',
                w: 'una semana',
                ww: '%d semanas',
                M: 'un mes',
                MM: '%d meses',
                y: 'un año',
                yy: '%d años'
              },
              dayOfMonthOrdinalParse: /\d{1,2}º/,
              ordinal: '%dº',
              week: {
                dow: 0,
                // Sunday is the first day of the week.
                doy: 6 // The week that contains Jan 6th is the first week of the year.

              }
            });
            return esUs;
          });
          /***/

        },

        /***/
        5655:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Spanish [es]
          //! author : Julio Napurí : https://github.com/julionc
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
                _monthsShort4 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
                monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
                monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

            var es = moment.defineLocale('es', {
              months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
              monthsShort: function monthsShort(m, format) {
                if (!m) {
                  return monthsShortDot;
                } else if (/-MMM-/.test(format)) {
                  return _monthsShort4[m.month()];
                } else {
                  return monthsShortDot[m.month()];
                }
              },
              monthsRegex: monthsRegex,
              monthsShortRegex: monthsRegex,
              monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
              monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
              monthsParse: monthsParse,
              longMonthsParse: monthsParse,
              shortMonthsParse: monthsParse,
              weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
              weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
              weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D [de] MMMM [de] YYYY',
                LLL: 'D [de] MMMM [de] YYYY H:mm',
                LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
              },
              calendar: {
                sameDay: function sameDay() {
                  return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                nextDay: function nextDay() {
                  return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                nextWeek: function nextWeek() {
                  return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                lastDay: function lastDay() {
                  return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                lastWeek: function lastWeek() {
                  return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'en %s',
                past: 'hace %s',
                s: 'unos segundos',
                ss: '%d segundos',
                m: 'un minuto',
                mm: '%d minutos',
                h: 'una hora',
                hh: '%d horas',
                d: 'un día',
                dd: '%d días',
                w: 'una semana',
                ww: '%d semanas',
                M: 'un mes',
                MM: '%d meses',
                y: 'un año',
                yy: '%d años'
              },
              dayOfMonthOrdinalParse: /\d{1,2}º/,
              ordinal: '%dº',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              },
              invalidDate: 'Fecha inválida'
            });
            return es;
          });
          /***/

        },

        /***/
        5603:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Estonian [et]
          //! author : Henry Kehlmann : https://github.com/madhenry
          //! improvements : Illimar Tambek : https://github.com/ragulka
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            function processRelativeTime(number, withoutSuffix, key, isFuture) {
              var format = {
                s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
                ss: [number + 'sekundi', number + 'sekundit'],
                m: ['ühe minuti', 'üks minut'],
                mm: [number + ' minuti', number + ' minutit'],
                h: ['ühe tunni', 'tund aega', 'üks tund'],
                hh: [number + ' tunni', number + ' tundi'],
                d: ['ühe päeva', 'üks päev'],
                M: ['kuu aja', 'kuu aega', 'üks kuu'],
                MM: [number + ' kuu', number + ' kuud'],
                y: ['ühe aasta', 'aasta', 'üks aasta'],
                yy: [number + ' aasta', number + ' aastat']
              };

              if (withoutSuffix) {
                return format[key][2] ? format[key][2] : format[key][1];
              }

              return isFuture ? format[key][0] : format[key][1];
            }

            var et = moment.defineLocale('et', {
              months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
              monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
              weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
              weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
              weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D. MMMM YYYY',
                LLL: 'D. MMMM YYYY H:mm',
                LLLL: 'dddd, D. MMMM YYYY H:mm'
              },
              calendar: {
                sameDay: '[Täna,] LT',
                nextDay: '[Homme,] LT',
                nextWeek: '[Järgmine] dddd LT',
                lastDay: '[Eile,] LT',
                lastWeek: '[Eelmine] dddd LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s pärast',
                past: '%s tagasi',
                s: processRelativeTime,
                ss: processRelativeTime,
                m: processRelativeTime,
                mm: processRelativeTime,
                h: processRelativeTime,
                hh: processRelativeTime,
                d: processRelativeTime,
                dd: '%d päeva',
                M: processRelativeTime,
                MM: processRelativeTime,
                y: processRelativeTime,
                yy: processRelativeTime
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return et;
          });
          /***/

        },

        /***/
        7763:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Basque [eu]
          //! author : Eneko Illarramendi : https://github.com/eillarra
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var eu = moment.defineLocale('eu', {
              months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
              monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
              monthsParseExact: true,
              weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
              weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
              weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'YYYY-MM-DD',
                LL: 'YYYY[ko] MMMM[ren] D[a]',
                LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
                LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
                l: 'YYYY-M-D',
                ll: 'YYYY[ko] MMM D[a]',
                lll: 'YYYY[ko] MMM D[a] HH:mm',
                llll: 'ddd, YYYY[ko] MMM D[a] HH:mm'
              },
              calendar: {
                sameDay: '[gaur] LT[etan]',
                nextDay: '[bihar] LT[etan]',
                nextWeek: 'dddd LT[etan]',
                lastDay: '[atzo] LT[etan]',
                lastWeek: '[aurreko] dddd LT[etan]',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s barru',
                past: 'duela %s',
                s: 'segundo batzuk',
                ss: '%d segundo',
                m: 'minutu bat',
                mm: '%d minutu',
                h: 'ordu bat',
                hh: '%d ordu',
                d: 'egun bat',
                dd: '%d egun',
                M: 'hilabete bat',
                MM: '%d hilabete',
                y: 'urte bat',
                yy: '%d urte'
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return eu;
          });
          /***/

        },

        /***/
        6959:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Persian [fa]
          //! author : Ebrahim Byagowi : https://github.com/ebraminio
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var symbolMap = {
              1: '۱',
              2: '۲',
              3: '۳',
              4: '۴',
              5: '۵',
              6: '۶',
              7: '۷',
              8: '۸',
              9: '۹',
              0: '۰'
            },
                numberMap = {
              '۱': '1',
              '۲': '2',
              '۳': '3',
              '۴': '4',
              '۵': '5',
              '۶': '6',
              '۷': '7',
              '۸': '8',
              '۹': '9',
              '۰': '0'
            };
            var fa = moment.defineLocale('fa', {
              months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
              monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
              weekdays: "\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split('_'),
              weekdaysShort: "\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split('_'),
              weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              meridiemParse: /قبل از ظهر|بعد از ظهر/,
              isPM: function isPM(input) {
                return /بعد از ظهر/.test(input);
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 12) {
                  return 'قبل از ظهر';
                } else {
                  return 'بعد از ظهر';
                }
              },
              calendar: {
                sameDay: '[امروز ساعت] LT',
                nextDay: '[فردا ساعت] LT',
                nextWeek: 'dddd [ساعت] LT',
                lastDay: '[دیروز ساعت] LT',
                lastWeek: 'dddd [پیش] [ساعت] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'در %s',
                past: '%s پیش',
                s: 'چند ثانیه',
                ss: '%d ثانیه',
                m: 'یک دقیقه',
                mm: '%d دقیقه',
                h: 'یک ساعت',
                hh: '%d ساعت',
                d: 'یک روز',
                dd: '%d روز',
                M: 'یک ماه',
                MM: '%d ماه',
                y: 'یک سال',
                yy: '%d سال'
              },
              preparse: function preparse(string) {
                return string.replace(/[۰-۹]/g, function (match) {
                  return numberMap[match];
                }).replace(/،/g, ',');
              },
              postformat: function postformat(string) {
                return string.replace(/\d/g, function (match) {
                  return symbolMap[match];
                }).replace(/,/g, '،');
              },
              dayOfMonthOrdinalParse: /\d{1,2}م/,
              ordinal: '%dم',
              week: {
                dow: 6,
                // Saturday is the first day of the week.
                doy: 12 // The week that contains Jan 12th is the first week of the year.

              }
            });
            return fa;
          });
          /***/

        },

        /***/
        1897:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Finnish [fi]
          //! author : Tarmo Aidantausta : https://github.com/bleadof
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
                numbersFuture = ['nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden', numbersPast[7], numbersPast[8], numbersPast[9]];

            function translate(number, withoutSuffix, key, isFuture) {
              var result = '';

              switch (key) {
                case 's':
                  return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';

                case 'ss':
                  result = isFuture ? 'sekunnin' : 'sekuntia';
                  break;

                case 'm':
                  return isFuture ? 'minuutin' : 'minuutti';

                case 'mm':
                  result = isFuture ? 'minuutin' : 'minuuttia';
                  break;

                case 'h':
                  return isFuture ? 'tunnin' : 'tunti';

                case 'hh':
                  result = isFuture ? 'tunnin' : 'tuntia';
                  break;

                case 'd':
                  return isFuture ? 'päivän' : 'päivä';

                case 'dd':
                  result = isFuture ? 'päivän' : 'päivää';
                  break;

                case 'M':
                  return isFuture ? 'kuukauden' : 'kuukausi';

                case 'MM':
                  result = isFuture ? 'kuukauden' : 'kuukautta';
                  break;

                case 'y':
                  return isFuture ? 'vuoden' : 'vuosi';

                case 'yy':
                  result = isFuture ? 'vuoden' : 'vuotta';
                  break;
              }

              result = verbalNumber(number, isFuture) + ' ' + result;
              return result;
            }

            function verbalNumber(number, isFuture) {
              return number < 10 ? isFuture ? numbersFuture[number] : numbersPast[number] : number;
            }

            var fi = moment.defineLocale('fi', {
              months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
              monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
              weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
              weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
              weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
              longDateFormat: {
                LT: 'HH.mm',
                LTS: 'HH.mm.ss',
                L: 'DD.MM.YYYY',
                LL: 'Do MMMM[ta] YYYY',
                LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
                LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
                l: 'D.M.YYYY',
                ll: 'Do MMM YYYY',
                lll: 'Do MMM YYYY, [klo] HH.mm',
                llll: 'ddd, Do MMM YYYY, [klo] HH.mm'
              },
              calendar: {
                sameDay: '[tänään] [klo] LT',
                nextDay: '[huomenna] [klo] LT',
                nextWeek: 'dddd [klo] LT',
                lastDay: '[eilen] [klo] LT',
                lastWeek: '[viime] dddd[na] [klo] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s päästä',
                past: '%s sitten',
                s: translate,
                ss: translate,
                m: translate,
                mm: translate,
                h: translate,
                hh: translate,
                d: translate,
                dd: translate,
                M: translate,
                MM: translate,
                y: translate,
                yy: translate
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return fi;
          });
          /***/

        },

        /***/
        2549:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Filipino [fil]
          //! author : Dan Hagman : https://github.com/hagmandan
          //! author : Matthew Co : https://github.com/matthewdeeco
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var fil = moment.defineLocale('fil', {
              months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
              monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
              weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
              weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
              weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'MM/D/YYYY',
                LL: 'MMMM D, YYYY',
                LLL: 'MMMM D, YYYY HH:mm',
                LLLL: 'dddd, MMMM DD, YYYY HH:mm'
              },
              calendar: {
                sameDay: 'LT [ngayong araw]',
                nextDay: '[Bukas ng] LT',
                nextWeek: 'LT [sa susunod na] dddd',
                lastDay: 'LT [kahapon]',
                lastWeek: 'LT [noong nakaraang] dddd',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'sa loob ng %s',
                past: '%s ang nakalipas',
                s: 'ilang segundo',
                ss: '%d segundo',
                m: 'isang minuto',
                mm: '%d minuto',
                h: 'isang oras',
                hh: '%d oras',
                d: 'isang araw',
                dd: '%d araw',
                M: 'isang buwan',
                MM: '%d buwan',
                y: 'isang taon',
                yy: '%d taon'
              },
              dayOfMonthOrdinalParse: /\d{1,2}/,
              ordinal: function ordinal(number) {
                return number;
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return fil;
          });
          /***/

        },

        /***/
        4694:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Faroese [fo]
          //! author : Ragnar Johannesen : https://github.com/ragnar123
          //! author : Kristian Sakarisson : https://github.com/sakarisson
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var fo = moment.defineLocale('fo', {
              months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
              monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
              weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
              weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
              weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D. MMMM, YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Í dag kl.] LT',
                nextDay: '[Í morgin kl.] LT',
                nextWeek: 'dddd [kl.] LT',
                lastDay: '[Í gjár kl.] LT',
                lastWeek: '[síðstu] dddd [kl] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'um %s',
                past: '%s síðani',
                s: 'fá sekund',
                ss: '%d sekundir',
                m: 'ein minuttur',
                mm: '%d minuttir',
                h: 'ein tími',
                hh: '%d tímar',
                d: 'ein dagur',
                dd: '%d dagar',
                M: 'ein mánaður',
                MM: '%d mánaðir',
                y: 'eitt ár',
                yy: '%d ár'
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return fo;
          });
          /***/

        },

        /***/
        3049:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : French (Canada) [fr-ca]
          //! author : Jonathan Abourbih : https://github.com/jonbca
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var frCa = moment.defineLocale('fr-ca', {
              months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
              monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
              monthsParseExact: true,
              weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
              weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
              weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'YYYY-MM-DD',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Aujourd’hui à] LT',
                nextDay: '[Demain à] LT',
                nextWeek: 'dddd [à] LT',
                lastDay: '[Hier à] LT',
                lastWeek: 'dddd [dernier à] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'dans %s',
                past: 'il y a %s',
                s: 'quelques secondes',
                ss: '%d secondes',
                m: 'une minute',
                mm: '%d minutes',
                h: 'une heure',
                hh: '%d heures',
                d: 'un jour',
                dd: '%d jours',
                M: 'un mois',
                MM: '%d mois',
                y: 'un an',
                yy: '%d ans'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
              ordinal: function ordinal(number, period) {
                switch (period) {
                  // Words with masculine grammatical gender: mois, trimestre, jour
                  default:
                  case 'M':
                  case 'Q':
                  case 'D':
                  case 'DDD':
                  case 'd':
                    return number + (number === 1 ? 'er' : 'e');
                  // Words with feminine grammatical gender: semaine

                  case 'w':
                  case 'W':
                    return number + (number === 1 ? 're' : 'e');
                }
              }
            });
            return frCa;
          });
          /***/

        },

        /***/
        2330:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : French (Switzerland) [fr-ch]
          //! author : Gaspard Bucher : https://github.com/gaspard
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var frCh = moment.defineLocale('fr-ch', {
              months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
              monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
              monthsParseExact: true,
              weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
              weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
              weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Aujourd’hui à] LT',
                nextDay: '[Demain à] LT',
                nextWeek: 'dddd [à] LT',
                lastDay: '[Hier à] LT',
                lastWeek: 'dddd [dernier à] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'dans %s',
                past: 'il y a %s',
                s: 'quelques secondes',
                ss: '%d secondes',
                m: 'une minute',
                mm: '%d minutes',
                h: 'une heure',
                hh: '%d heures',
                d: 'un jour',
                dd: '%d jours',
                M: 'un mois',
                MM: '%d mois',
                y: 'un an',
                yy: '%d ans'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
              ordinal: function ordinal(number, period) {
                switch (period) {
                  // Words with masculine grammatical gender: mois, trimestre, jour
                  default:
                  case 'M':
                  case 'Q':
                  case 'D':
                  case 'DDD':
                  case 'd':
                    return number + (number === 1 ? 'er' : 'e');
                  // Words with feminine grammatical gender: semaine

                  case 'w':
                  case 'W':
                    return number + (number === 1 ? 're' : 'e');
                }
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return frCh;
          });
          /***/

        },

        /***/
        4470:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : French [fr]
          //! author : John Fischer : https://github.com/jfroffice
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
                monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
                monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
                monthsParse = [/^janv/i, /^févr/i, /^mars/i, /^avr/i, /^mai/i, /^juin/i, /^juil/i, /^août/i, /^sept/i, /^oct/i, /^nov/i, /^déc/i];
            var fr = moment.defineLocale('fr', {
              months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
              monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
              monthsRegex: monthsRegex,
              monthsShortRegex: monthsRegex,
              monthsStrictRegex: monthsStrictRegex,
              monthsShortStrictRegex: monthsShortStrictRegex,
              monthsParse: monthsParse,
              longMonthsParse: monthsParse,
              shortMonthsParse: monthsParse,
              weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
              weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
              weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Aujourd’hui à] LT',
                nextDay: '[Demain à] LT',
                nextWeek: 'dddd [à] LT',
                lastDay: '[Hier à] LT',
                lastWeek: 'dddd [dernier à] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'dans %s',
                past: 'il y a %s',
                s: 'quelques secondes',
                ss: '%d secondes',
                m: 'une minute',
                mm: '%d minutes',
                h: 'une heure',
                hh: '%d heures',
                d: 'un jour',
                dd: '%d jours',
                w: 'une semaine',
                ww: '%d semaines',
                M: 'un mois',
                MM: '%d mois',
                y: 'un an',
                yy: '%d ans'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
              ordinal: function ordinal(number, period) {
                switch (period) {
                  // TODO: Return 'e' when day of month > 1. Move this case inside
                  // block for masculine words below.
                  // See https://github.com/moment/moment/issues/3375
                  case 'D':
                    return number + (number === 1 ? 'er' : '');
                  // Words with masculine grammatical gender: mois, trimestre, jour

                  default:
                  case 'M':
                  case 'Q':
                  case 'DDD':
                  case 'd':
                    return number + (number === 1 ? 'er' : 'e');
                  // Words with feminine grammatical gender: semaine

                  case 'w':
                  case 'W':
                    return number + (number === 1 ? 're' : 'e');
                }
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return fr;
          });
          /***/

        },

        /***/
        5044:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Frisian [fy]
          //! author : Robin van der Vliet : https://github.com/robin0van0der0v
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
                monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
            var fy = moment.defineLocale('fy', {
              months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
              monthsShort: function monthsShort(m, format) {
                if (!m) {
                  return monthsShortWithDots;
                } else if (/-MMM-/.test(format)) {
                  return monthsShortWithoutDots[m.month()];
                } else {
                  return monthsShortWithDots[m.month()];
                }
              },
              monthsParseExact: true,
              weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
              weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
              weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD-MM-YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[hjoed om] LT',
                nextDay: '[moarn om] LT',
                nextWeek: 'dddd [om] LT',
                lastDay: '[juster om] LT',
                lastWeek: '[ôfrûne] dddd [om] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'oer %s',
                past: '%s lyn',
                s: 'in pear sekonden',
                ss: '%d sekonden',
                m: 'ien minút',
                mm: '%d minuten',
                h: 'ien oere',
                hh: '%d oeren',
                d: 'ien dei',
                dd: '%d dagen',
                M: 'ien moanne',
                MM: '%d moannen',
                y: 'ien jier',
                yy: '%d jierren'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
              ordinal: function ordinal(number) {
                return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return fy;
          });
          /***/

        },

        /***/
        9295:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Irish or Irish Gaelic [ga]
          //! author : André Silva : https://github.com/askpt
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var months = ['Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Meitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deireadh Fómhair', 'Samhain', 'Nollaig'],
                monthsShort = ['Ean', 'Feabh', 'Márt', 'Aib', 'Beal', 'Meith', 'Iúil', 'Lún', 'M.F.', 'D.F.', 'Samh', 'Noll'],
                weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Sathairn'],
                weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
                weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
            var ga = moment.defineLocale('ga', {
              months: months,
              monthsShort: monthsShort,
              monthsParseExact: true,
              weekdays: weekdays,
              weekdaysShort: weekdaysShort,
              weekdaysMin: weekdaysMin,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Inniu ag] LT',
                nextDay: '[Amárach ag] LT',
                nextWeek: 'dddd [ag] LT',
                lastDay: '[Inné ag] LT',
                lastWeek: 'dddd [seo caite] [ag] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'i %s',
                past: '%s ó shin',
                s: 'cúpla soicind',
                ss: '%d soicind',
                m: 'nóiméad',
                mm: '%d nóiméad',
                h: 'uair an chloig',
                hh: '%d uair an chloig',
                d: 'lá',
                dd: '%d lá',
                M: 'mí',
                MM: '%d míonna',
                y: 'bliain',
                yy: '%d bliain'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
              ordinal: function ordinal(number) {
                var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
                return number + output;
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return ga;
          });
          /***/

        },

        /***/
        2101:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Scottish Gaelic [gd]
          //! author : Jon Ashdown : https://github.com/jonashdown
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var months = ['Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'],
                monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'],
                weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'],
                weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
                weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
            var gd = moment.defineLocale('gd', {
              months: months,
              monthsShort: monthsShort,
              monthsParseExact: true,
              weekdays: weekdays,
              weekdaysShort: weekdaysShort,
              weekdaysMin: weekdaysMin,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[An-diugh aig] LT',
                nextDay: '[A-màireach aig] LT',
                nextWeek: 'dddd [aig] LT',
                lastDay: '[An-dè aig] LT',
                lastWeek: 'dddd [seo chaidh] [aig] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'ann an %s',
                past: 'bho chionn %s',
                s: 'beagan diogan',
                ss: '%d diogan',
                m: 'mionaid',
                mm: '%d mionaidean',
                h: 'uair',
                hh: '%d uairean',
                d: 'latha',
                dd: '%d latha',
                M: 'mìos',
                MM: '%d mìosan',
                y: 'bliadhna',
                yy: '%d bliadhna'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
              ordinal: function ordinal(number) {
                var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
                return number + output;
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return gd;
          });
          /***/

        },

        /***/
        8794:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Galician [gl]
          //! author : Juan G. Hurtado : https://github.com/juanghurtado
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var gl = moment.defineLocale('gl', {
              months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
              monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
              monthsParseExact: true,
              weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
              weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
              weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D [de] MMMM [de] YYYY',
                LLL: 'D [de] MMMM [de] YYYY H:mm',
                LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
              },
              calendar: {
                sameDay: function sameDay() {
                  return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
                },
                nextDay: function nextDay() {
                  return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
                },
                nextWeek: function nextWeek() {
                  return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
                },
                lastDay: function lastDay() {
                  return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
                },
                lastWeek: function lastWeek() {
                  return '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: function future(str) {
                  if (str.indexOf('un') === 0) {
                    return 'n' + str;
                  }

                  return 'en ' + str;
                },
                past: 'hai %s',
                s: 'uns segundos',
                ss: '%d segundos',
                m: 'un minuto',
                mm: '%d minutos',
                h: 'unha hora',
                hh: '%d horas',
                d: 'un día',
                dd: '%d días',
                M: 'un mes',
                MM: '%d meses',
                y: 'un ano',
                yy: '%d anos'
              },
              dayOfMonthOrdinalParse: /\d{1,2}º/,
              ordinal: '%dº',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return gl;
          });
          /***/

        },

        /***/
        7884:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Konkani Devanagari script [gom-deva]
          //! author : The Discoverer : https://github.com/WikiDiscoverer
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            function processRelativeTime(number, withoutSuffix, key, isFuture) {
              var format = {
                s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
                ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
                m: ['एका मिणटान', 'एक मिनूट'],
                mm: [number + ' मिणटांनी', number + ' मिणटां'],
                h: ['एका वरान', 'एक वर'],
                hh: [number + ' वरांनी', number + ' वरां'],
                d: ['एका दिसान', 'एक दीस'],
                dd: [number + ' दिसांनी', number + ' दीस'],
                M: ['एका म्हयन्यान', 'एक म्हयनो'],
                MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
                y: ['एका वर्सान', 'एक वर्स'],
                yy: [number + ' वर्सांनी', number + ' वर्सां']
              };
              return isFuture ? format[key][0] : format[key][1];
            }

            var gomDeva = moment.defineLocale('gom-deva', {
              months: {
                standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
                format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split('_'),
                isFormat: /MMMM(\s)+D[oD]?/
              },
              monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
              monthsParseExact: true,
              weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
              weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
              weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'A h:mm [वाजतां]',
                LTS: 'A h:mm:ss [वाजतां]',
                L: 'DD-MM-YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY A h:mm [वाजतां]',
                LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
                llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]'
              },
              calendar: {
                sameDay: '[आयज] LT',
                nextDay: '[फाल्यां] LT',
                nextWeek: '[फुडलो] dddd[,] LT',
                lastDay: '[काल] LT',
                lastWeek: '[फाटलो] dddd[,] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s',
                past: '%s आदीं',
                s: processRelativeTime,
                ss: processRelativeTime,
                m: processRelativeTime,
                mm: processRelativeTime,
                h: processRelativeTime,
                hh: processRelativeTime,
                d: processRelativeTime,
                dd: processRelativeTime,
                M: processRelativeTime,
                MM: processRelativeTime,
                y: processRelativeTime,
                yy: processRelativeTime
              },
              dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
              ordinal: function ordinal(number, period) {
                switch (period) {
                  // the ordinal 'वेर' only applies to day of the month
                  case 'D':
                    return number + 'वेर';

                  default:
                  case 'M':
                  case 'Q':
                  case 'DDD':
                  case 'd':
                  case 'w':
                  case 'W':
                    return number;
                }
              },
              week: {
                dow: 0,
                // Sunday is the first day of the week
                doy: 3 // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)

              },
              meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'राती') {
                  return hour < 4 ? hour : hour + 12;
                } else if (meridiem === 'सकाळीं') {
                  return hour;
                } else if (meridiem === 'दनपारां') {
                  return hour > 12 ? hour : hour + 12;
                } else if (meridiem === 'सांजे') {
                  return hour + 12;
                }
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 4) {
                  return 'राती';
                } else if (hour < 12) {
                  return 'सकाळीं';
                } else if (hour < 16) {
                  return 'दनपारां';
                } else if (hour < 20) {
                  return 'सांजे';
                } else {
                  return 'राती';
                }
              }
            });
            return gomDeva;
          });
          /***/

        },

        /***/
        3168:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Konkani Latin script [gom-latn]
          //! author : The Discoverer : https://github.com/WikiDiscoverer
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            function processRelativeTime(number, withoutSuffix, key, isFuture) {
              var format = {
                s: ['thoddea sekondamni', 'thodde sekond'],
                ss: [number + ' sekondamni', number + ' sekond'],
                m: ['eka mintan', 'ek minut'],
                mm: [number + ' mintamni', number + ' mintam'],
                h: ['eka voran', 'ek vor'],
                hh: [number + ' voramni', number + ' voram'],
                d: ['eka disan', 'ek dis'],
                dd: [number + ' disamni', number + ' dis'],
                M: ['eka mhoinean', 'ek mhoino'],
                MM: [number + ' mhoineamni', number + ' mhoine'],
                y: ['eka vorsan', 'ek voros'],
                yy: [number + ' vorsamni', number + ' vorsam']
              };
              return isFuture ? format[key][0] : format[key][1];
            }

            var gomLatn = moment.defineLocale('gom-latn', {
              months: {
                standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
                format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split('_'),
                isFormat: /MMMM(\s)+D[oD]?/
              },
              monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
              monthsParseExact: true,
              weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
              weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
              weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'A h:mm [vazta]',
                LTS: 'A h:mm:ss [vazta]',
                L: 'DD-MM-YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY A h:mm [vazta]',
                LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
                llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
              },
              calendar: {
                sameDay: '[Aiz] LT',
                nextDay: '[Faleam] LT',
                nextWeek: '[Fuddlo] dddd[,] LT',
                lastDay: '[Kal] LT',
                lastWeek: '[Fattlo] dddd[,] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s',
                past: '%s adim',
                s: processRelativeTime,
                ss: processRelativeTime,
                m: processRelativeTime,
                mm: processRelativeTime,
                h: processRelativeTime,
                hh: processRelativeTime,
                d: processRelativeTime,
                dd: processRelativeTime,
                M: processRelativeTime,
                MM: processRelativeTime,
                y: processRelativeTime,
                yy: processRelativeTime
              },
              dayOfMonthOrdinalParse: /\d{1,2}(er)/,
              ordinal: function ordinal(number, period) {
                switch (period) {
                  // the ordinal 'er' only applies to day of the month
                  case 'D':
                    return number + 'er';

                  default:
                  case 'M':
                  case 'Q':
                  case 'DDD':
                  case 'd':
                  case 'w':
                  case 'W':
                    return number;
                }
              },
              week: {
                dow: 0,
                // Sunday is the first day of the week
                doy: 3 // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)

              },
              meridiemParse: /rati|sokallim|donparam|sanje/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'rati') {
                  return hour < 4 ? hour : hour + 12;
                } else if (meridiem === 'sokallim') {
                  return hour;
                } else if (meridiem === 'donparam') {
                  return hour > 12 ? hour : hour + 12;
                } else if (meridiem === 'sanje') {
                  return hour + 12;
                }
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 4) {
                  return 'rati';
                } else if (hour < 12) {
                  return 'sokallim';
                } else if (hour < 16) {
                  return 'donparam';
                } else if (hour < 20) {
                  return 'sanje';
                } else {
                  return 'rati';
                }
              }
            });
            return gomLatn;
          });
          /***/

        },

        /***/
        5349:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Gujarati [gu]
          //! author : Kaushik Thanki : https://github.com/Kaushik1987
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var symbolMap = {
              1: '૧',
              2: '૨',
              3: '૩',
              4: '૪',
              5: '૫',
              6: '૬',
              7: '૭',
              8: '૮',
              9: '૯',
              0: '૦'
            },
                numberMap = {
              '૧': '1',
              '૨': '2',
              '૩': '3',
              '૪': '4',
              '૫': '5',
              '૬': '6',
              '૭': '7',
              '૮': '8',
              '૯': '9',
              '૦': '0'
            };
            var gu = moment.defineLocale('gu', {
              months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
              monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
              monthsParseExact: true,
              weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
              weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
              weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
              longDateFormat: {
                LT: 'A h:mm વાગ્યે',
                LTS: 'A h:mm:ss વાગ્યે',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
                LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
              },
              calendar: {
                sameDay: '[આજ] LT',
                nextDay: '[કાલે] LT',
                nextWeek: 'dddd, LT',
                lastDay: '[ગઇકાલે] LT',
                lastWeek: '[પાછલા] dddd, LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s મા',
                past: '%s પહેલા',
                s: 'અમુક પળો',
                ss: '%d સેકંડ',
                m: 'એક મિનિટ',
                mm: '%d મિનિટ',
                h: 'એક કલાક',
                hh: '%d કલાક',
                d: 'એક દિવસ',
                dd: '%d દિવસ',
                M: 'એક મહિનો',
                MM: '%d મહિનો',
                y: 'એક વર્ષ',
                yy: '%d વર્ષ'
              },
              preparse: function preparse(string) {
                return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                  return numberMap[match];
                });
              },
              postformat: function postformat(string) {
                return string.replace(/\d/g, function (match) {
                  return symbolMap[match];
                });
              },
              // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
              // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
              meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'રાત') {
                  return hour < 4 ? hour : hour + 12;
                } else if (meridiem === 'સવાર') {
                  return hour;
                } else if (meridiem === 'બપોર') {
                  return hour >= 10 ? hour : hour + 12;
                } else if (meridiem === 'સાંજ') {
                  return hour + 12;
                }
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 4) {
                  return 'રાત';
                } else if (hour < 10) {
                  return 'સવાર';
                } else if (hour < 17) {
                  return 'બપોર';
                } else if (hour < 20) {
                  return 'સાંજ';
                } else {
                  return 'રાત';
                }
              },
              week: {
                dow: 0,
                // Sunday is the first day of the week.
                doy: 6 // The week that contains Jan 6th is the first week of the year.

              }
            });
            return gu;
          });
          /***/

        },

        /***/
        4206:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Hebrew [he]
          //! author : Tomer Cohen : https://github.com/tomer
          //! author : Moshe Simantov : https://github.com/DevelopmentIL
          //! author : Tal Ater : https://github.com/TalAter
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var he = moment.defineLocale('he', {
              months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
              monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
              weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
              weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
              weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D [ב]MMMM YYYY',
                LLL: 'D [ב]MMMM YYYY HH:mm',
                LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
                l: 'D/M/YYYY',
                ll: 'D MMM YYYY',
                lll: 'D MMM YYYY HH:mm',
                llll: 'ddd, D MMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[היום ב־]LT',
                nextDay: '[מחר ב־]LT',
                nextWeek: 'dddd [בשעה] LT',
                lastDay: '[אתמול ב־]LT',
                lastWeek: '[ביום] dddd [האחרון בשעה] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'בעוד %s',
                past: 'לפני %s',
                s: 'מספר שניות',
                ss: '%d שניות',
                m: 'דקה',
                mm: '%d דקות',
                h: 'שעה',
                hh: function hh(number) {
                  if (number === 2) {
                    return 'שעתיים';
                  }

                  return number + ' שעות';
                },
                d: 'יום',
                dd: function dd(number) {
                  if (number === 2) {
                    return 'יומיים';
                  }

                  return number + ' ימים';
                },
                M: 'חודש',
                MM: function MM(number) {
                  if (number === 2) {
                    return 'חודשיים';
                  }

                  return number + ' חודשים';
                },
                y: 'שנה',
                yy: function yy(number) {
                  if (number === 2) {
                    return 'שנתיים';
                  } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                  }

                  return number + ' שנים';
                }
              },
              meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
              isPM: function isPM(input) {
                return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 5) {
                  return 'לפנות בוקר';
                } else if (hour < 10) {
                  return 'בבוקר';
                } else if (hour < 12) {
                  return isLower ? 'לפנה"צ' : 'לפני הצהריים';
                } else if (hour < 18) {
                  return isLower ? 'אחה"צ' : 'אחרי הצהריים';
                } else {
                  return 'בערב';
                }
              }
            });
            return he;
          });
          /***/

        },

        /***/
        94:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Hindi [hi]
          //! author : Mayank Singhal : https://github.com/mayanksinghal
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var symbolMap = {
              1: '१',
              2: '२',
              3: '३',
              4: '४',
              5: '५',
              6: '६',
              7: '७',
              8: '८',
              9: '९',
              0: '०'
            },
                numberMap = {
              '१': '1',
              '२': '2',
              '३': '3',
              '४': '4',
              '५': '5',
              '६': '6',
              '७': '7',
              '८': '8',
              '९': '9',
              '०': '0'
            },
                monthsParse = [/^जन/i, /^फ़र|फर/i, /^मार्च/i, /^अप्रै/i, /^मई/i, /^जून/i, /^जुल/i, /^अग/i, /^सितं|सित/i, /^अक्टू/i, /^नव|नवं/i, /^दिसं|दिस/i],
                shortMonthsParse = [/^जन/i, /^फ़र/i, /^मार्च/i, /^अप्रै/i, /^मई/i, /^जून/i, /^जुल/i, /^अग/i, /^सित/i, /^अक्टू/i, /^नव/i, /^दिस/i];
            var hi = moment.defineLocale('hi', {
              months: {
                format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
                standalone: 'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split('_')
              },
              monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
              weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
              weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
              weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
              longDateFormat: {
                LT: 'A h:mm बजे',
                LTS: 'A h:mm:ss बजे',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY, A h:mm बजे',
                LLLL: 'dddd, D MMMM YYYY, A h:mm बजे'
              },
              monthsParse: monthsParse,
              longMonthsParse: monthsParse,
              shortMonthsParse: shortMonthsParse,
              monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
              monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
              monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
              monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
              calendar: {
                sameDay: '[आज] LT',
                nextDay: '[कल] LT',
                nextWeek: 'dddd, LT',
                lastDay: '[कल] LT',
                lastWeek: '[पिछले] dddd, LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s में',
                past: '%s पहले',
                s: 'कुछ ही क्षण',
                ss: '%d सेकंड',
                m: 'एक मिनट',
                mm: '%d मिनट',
                h: 'एक घंटा',
                hh: '%d घंटे',
                d: 'एक दिन',
                dd: '%d दिन',
                M: 'एक महीने',
                MM: '%d महीने',
                y: 'एक वर्ष',
                yy: '%d वर्ष'
              },
              preparse: function preparse(string) {
                return string.replace(/[१२३४५६७८९०]/g, function (match) {
                  return numberMap[match];
                });
              },
              postformat: function postformat(string) {
                return string.replace(/\d/g, function (match) {
                  return symbolMap[match];
                });
              },
              // Hindi notation for meridiems are quite fuzzy in practice. While there exists
              // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
              meridiemParse: /रात|सुबह|दोपहर|शाम/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'रात') {
                  return hour < 4 ? hour : hour + 12;
                } else if (meridiem === 'सुबह') {
                  return hour;
                } else if (meridiem === 'दोपहर') {
                  return hour >= 10 ? hour : hour + 12;
                } else if (meridiem === 'शाम') {
                  return hour + 12;
                }
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 4) {
                  return 'रात';
                } else if (hour < 10) {
                  return 'सुबह';
                } else if (hour < 17) {
                  return 'दोपहर';
                } else if (hour < 20) {
                  return 'शाम';
                } else {
                  return 'रात';
                }
              },
              week: {
                dow: 0,
                // Sunday is the first day of the week.
                doy: 6 // The week that contains Jan 6th is the first week of the year.

              }
            });
            return hi;
          });
          /***/

        },

        /***/
        316:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Croatian [hr]
          //! author : Bojan Marković : https://github.com/bmarkovic
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            function translate(number, withoutSuffix, key) {
              var result = number + ' ';

              switch (key) {
                case 'ss':
                  if (number === 1) {
                    result += 'sekunda';
                  } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                  } else {
                    result += 'sekundi';
                  }

                  return result;

                case 'm':
                  return withoutSuffix ? 'jedna minuta' : 'jedne minute';

                case 'mm':
                  if (number === 1) {
                    result += 'minuta';
                  } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                  } else {
                    result += 'minuta';
                  }

                  return result;

                case 'h':
                  return withoutSuffix ? 'jedan sat' : 'jednog sata';

                case 'hh':
                  if (number === 1) {
                    result += 'sat';
                  } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                  } else {
                    result += 'sati';
                  }

                  return result;

                case 'dd':
                  if (number === 1) {
                    result += 'dan';
                  } else {
                    result += 'dana';
                  }

                  return result;

                case 'MM':
                  if (number === 1) {
                    result += 'mjesec';
                  } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                  } else {
                    result += 'mjeseci';
                  }

                  return result;

                case 'yy':
                  if (number === 1) {
                    result += 'godina';
                  } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                  } else {
                    result += 'godina';
                  }

                  return result;
              }
            }

            var hr = moment.defineLocale('hr', {
              months: {
                format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
                standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
              },
              monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
              monthsParseExact: true,
              weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
              weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
              weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'Do MMMM YYYY',
                LLL: 'Do MMMM YYYY H:mm',
                LLLL: 'dddd, Do MMMM YYYY H:mm'
              },
              calendar: {
                sameDay: '[danas u] LT',
                nextDay: '[sutra u] LT',
                nextWeek: function nextWeek() {
                  switch (this.day()) {
                    case 0:
                      return '[u] [nedjelju] [u] LT';

                    case 3:
                      return '[u] [srijedu] [u] LT';

                    case 6:
                      return '[u] [subotu] [u] LT';

                    case 1:
                    case 2:
                    case 4:
                    case 5:
                      return '[u] dddd [u] LT';
                  }
                },
                lastDay: '[jučer u] LT',
                lastWeek: function lastWeek() {
                  switch (this.day()) {
                    case 0:
                      return '[prošlu] [nedjelju] [u] LT';

                    case 3:
                      return '[prošlu] [srijedu] [u] LT';

                    case 6:
                      return '[prošle] [subote] [u] LT';

                    case 1:
                    case 2:
                    case 4:
                    case 5:
                      return '[prošli] dddd [u] LT';
                  }
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'za %s',
                past: 'prije %s',
                s: 'par sekundi',
                ss: translate,
                m: translate,
                mm: translate,
                h: translate,
                hh: translate,
                d: 'dan',
                dd: translate,
                M: 'mjesec',
                MM: translate,
                y: 'godinu',
                yy: translate
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return hr;
          });
          /***/

        },

        /***/
        2138:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Hungarian [hu]
          //! author : Adam Brunner : https://github.com/adambrunner
          //! author : Peter Viszt  : https://github.com/passatgt
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');

            function translate(number, withoutSuffix, key, isFuture) {
              var num = number;

              switch (key) {
                case 's':
                  return isFuture || withoutSuffix ? 'néhány másodperc' : 'néhány másodperce';

                case 'ss':
                  return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';

                case 'm':
                  return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');

                case 'mm':
                  return num + (isFuture || withoutSuffix ? ' perc' : ' perce');

                case 'h':
                  return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');

                case 'hh':
                  return num + (isFuture || withoutSuffix ? ' óra' : ' órája');

                case 'd':
                  return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');

                case 'dd':
                  return num + (isFuture || withoutSuffix ? ' nap' : ' napja');

                case 'M':
                  return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');

                case 'MM':
                  return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');

                case 'y':
                  return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');

                case 'yy':
                  return num + (isFuture || withoutSuffix ? ' év' : ' éve');
              }

              return '';
            }

            function week(isFuture) {
              return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
            }

            var hu = moment.defineLocale('hu', {
              months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
              monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split('_'),
              monthsParseExact: true,
              weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
              weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
              weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'YYYY.MM.DD.',
                LL: 'YYYY. MMMM D.',
                LLL: 'YYYY. MMMM D. H:mm',
                LLLL: 'YYYY. MMMM D., dddd H:mm'
              },
              meridiemParse: /de|du/i,
              isPM: function isPM(input) {
                return input.charAt(1).toLowerCase() === 'u';
              },
              meridiem: function meridiem(hours, minutes, isLower) {
                if (hours < 12) {
                  return isLower === true ? 'de' : 'DE';
                } else {
                  return isLower === true ? 'du' : 'DU';
                }
              },
              calendar: {
                sameDay: '[ma] LT[-kor]',
                nextDay: '[holnap] LT[-kor]',
                nextWeek: function nextWeek() {
                  return week.call(this, true);
                },
                lastDay: '[tegnap] LT[-kor]',
                lastWeek: function lastWeek() {
                  return week.call(this, false);
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s múlva',
                past: '%s',
                s: translate,
                ss: translate,
                m: translate,
                mm: translate,
                h: translate,
                hh: translate,
                d: translate,
                dd: translate,
                M: translate,
                MM: translate,
                y: translate,
                yy: translate
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return hu;
          });
          /***/

        },

        /***/
        1423:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Armenian [hy-am]
          //! author : Armendarabyan : https://github.com/armendarabyan
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var hyAm = moment.defineLocale('hy-am', {
              months: {
                format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
                standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
              },
              monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
              weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
              weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
              weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D MMMM YYYY թ.',
                LLL: 'D MMMM YYYY թ., HH:mm',
                LLLL: 'dddd, D MMMM YYYY թ., HH:mm'
              },
              calendar: {
                sameDay: '[այսօր] LT',
                nextDay: '[վաղը] LT',
                lastDay: '[երեկ] LT',
                nextWeek: function nextWeek() {
                  return 'dddd [օրը ժամը] LT';
                },
                lastWeek: function lastWeek() {
                  return '[անցած] dddd [օրը ժամը] LT';
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s հետո',
                past: '%s առաջ',
                s: 'մի քանի վայրկյան',
                ss: '%d վայրկյան',
                m: 'րոպե',
                mm: '%d րոպե',
                h: 'ժամ',
                hh: '%d ժամ',
                d: 'օր',
                dd: '%d օր',
                M: 'ամիս',
                MM: '%d ամիս',
                y: 'տարի',
                yy: '%d տարի'
              },
              meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
              isPM: function isPM(input) {
                return /^(ցերեկվա|երեկոյան)$/.test(input);
              },
              meridiem: function meridiem(hour) {
                if (hour < 4) {
                  return 'գիշերվա';
                } else if (hour < 12) {
                  return 'առավոտվա';
                } else if (hour < 17) {
                  return 'ցերեկվա';
                } else {
                  return 'երեկոյան';
                }
              },
              dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
              ordinal: function ordinal(number, period) {
                switch (period) {
                  case 'DDD':
                  case 'w':
                  case 'W':
                  case 'DDDo':
                    if (number === 1) {
                      return number + '-ին';
                    }

                    return number + '-րդ';

                  default:
                    return number;
                }
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return hyAm;
          });
          /***/

        },

        /***/
        9218:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Indonesian [id]
          //! author : Mohammad Satrio Utomo : https://github.com/tyok
          //! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var id = moment.defineLocale('id', {
              months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
              monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
              weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
              weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
              weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
              longDateFormat: {
                LT: 'HH.mm',
                LTS: 'HH.mm.ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY [pukul] HH.mm',
                LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
              },
              meridiemParse: /pagi|siang|sore|malam/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'pagi') {
                  return hour;
                } else if (meridiem === 'siang') {
                  return hour >= 11 ? hour : hour + 12;
                } else if (meridiem === 'sore' || meridiem === 'malam') {
                  return hour + 12;
                }
              },
              meridiem: function meridiem(hours, minutes, isLower) {
                if (hours < 11) {
                  return 'pagi';
                } else if (hours < 15) {
                  return 'siang';
                } else if (hours < 19) {
                  return 'sore';
                } else {
                  return 'malam';
                }
              },
              calendar: {
                sameDay: '[Hari ini pukul] LT',
                nextDay: '[Besok pukul] LT',
                nextWeek: 'dddd [pukul] LT',
                lastDay: '[Kemarin pukul] LT',
                lastWeek: 'dddd [lalu pukul] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'dalam %s',
                past: '%s yang lalu',
                s: 'beberapa detik',
                ss: '%d detik',
                m: 'semenit',
                mm: '%d menit',
                h: 'sejam',
                hh: '%d jam',
                d: 'sehari',
                dd: '%d hari',
                M: 'sebulan',
                MM: '%d bulan',
                y: 'setahun',
                yy: '%d tahun'
              },
              week: {
                dow: 0,
                // Sunday is the first day of the week.
                doy: 6 // The week that contains Jan 6th is the first week of the year.

              }
            });
            return id;
          });
          /***/

        },

        /***/
        135:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Icelandic [is]
          //! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            function plural(n) {
              if (n % 100 === 11) {
                return true;
              } else if (n % 10 === 1) {
                return false;
              }

              return true;
            }

            function translate(number, withoutSuffix, key, isFuture) {
              var result = number + ' ';

              switch (key) {
                case 's':
                  return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';

                case 'ss':
                  if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
                  }

                  return result + 'sekúnda';

                case 'm':
                  return withoutSuffix ? 'mínúta' : 'mínútu';

                case 'mm':
                  if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
                  } else if (withoutSuffix) {
                    return result + 'mínúta';
                  }

                  return result + 'mínútu';

                case 'hh':
                  if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
                  }

                  return result + 'klukkustund';

                case 'd':
                  if (withoutSuffix) {
                    return 'dagur';
                  }

                  return isFuture ? 'dag' : 'degi';

                case 'dd':
                  if (plural(number)) {
                    if (withoutSuffix) {
                      return result + 'dagar';
                    }

                    return result + (isFuture ? 'daga' : 'dögum');
                  } else if (withoutSuffix) {
                    return result + 'dagur';
                  }

                  return result + (isFuture ? 'dag' : 'degi');

                case 'M':
                  if (withoutSuffix) {
                    return 'mánuður';
                  }

                  return isFuture ? 'mánuð' : 'mánuði';

                case 'MM':
                  if (plural(number)) {
                    if (withoutSuffix) {
                      return result + 'mánuðir';
                    }

                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                  } else if (withoutSuffix) {
                    return result + 'mánuður';
                  }

                  return result + (isFuture ? 'mánuð' : 'mánuði');

                case 'y':
                  return withoutSuffix || isFuture ? 'ár' : 'ári';

                case 'yy':
                  if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                  }

                  return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
              }
            }

            var is = moment.defineLocale('is', {
              months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
              monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
              weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
              weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
              weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D. MMMM YYYY',
                LLL: 'D. MMMM YYYY [kl.] H:mm',
                LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm'
              },
              calendar: {
                sameDay: '[í dag kl.] LT',
                nextDay: '[á morgun kl.] LT',
                nextWeek: 'dddd [kl.] LT',
                lastDay: '[í gær kl.] LT',
                lastWeek: '[síðasta] dddd [kl.] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'eftir %s',
                past: 'fyrir %s síðan',
                s: translate,
                ss: translate,
                m: translate,
                mm: translate,
                h: 'klukkustund',
                hh: translate,
                d: translate,
                dd: translate,
                M: translate,
                MM: translate,
                y: translate,
                yy: translate
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return is;
          });
          /***/

        },

        /***/
        150:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Italian (Switzerland) [it-ch]
          //! author : xfh : https://github.com/xfh
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var itCh = moment.defineLocale('it-ch', {
              months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
              monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
              weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
              weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
              weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Oggi alle] LT',
                nextDay: '[Domani alle] LT',
                nextWeek: 'dddd [alle] LT',
                lastDay: '[Ieri alle] LT',
                lastWeek: function lastWeek() {
                  switch (this.day()) {
                    case 0:
                      return '[la scorsa] dddd [alle] LT';

                    default:
                      return '[lo scorso] dddd [alle] LT';
                  }
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: function future(s) {
                  return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
                },
                past: '%s fa',
                s: 'alcuni secondi',
                ss: '%d secondi',
                m: 'un minuto',
                mm: '%d minuti',
                h: "un'ora",
                hh: '%d ore',
                d: 'un giorno',
                dd: '%d giorni',
                M: 'un mese',
                MM: '%d mesi',
                y: 'un anno',
                yy: '%d anni'
              },
              dayOfMonthOrdinalParse: /\d{1,2}º/,
              ordinal: '%dº',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return itCh;
          });
          /***/

        },

        /***/
        626:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Italian [it]
          //! author : Lorenzo : https://github.com/aliem
          //! author: Mattia Larentis: https://github.com/nostalgiaz
          //! author: Marco : https://github.com/Manfre98
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var it = moment.defineLocale('it', {
              months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
              monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
              weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
              weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
              weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: function sameDay() {
                  return '[Oggi a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
                },
                nextDay: function nextDay() {
                  return '[Domani a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
                },
                nextWeek: function nextWeek() {
                  return 'dddd [a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
                },
                lastDay: function lastDay() {
                  return '[Ieri a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
                },
                lastWeek: function lastWeek() {
                  switch (this.day()) {
                    case 0:
                      return '[La scorsa] dddd [a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';

                    default:
                      return '[Lo scorso] dddd [a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
                  }
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'tra %s',
                past: '%s fa',
                s: 'alcuni secondi',
                ss: '%d secondi',
                m: 'un minuto',
                mm: '%d minuti',
                h: "un'ora",
                hh: '%d ore',
                d: 'un giorno',
                dd: '%d giorni',
                w: 'una settimana',
                ww: '%d settimane',
                M: 'un mese',
                MM: '%d mesi',
                y: 'un anno',
                yy: '%d anni'
              },
              dayOfMonthOrdinalParse: /\d{1,2}º/,
              ordinal: '%dº',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return it;
          });
          /***/

        },

        /***/
        9183:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Japanese [ja]
          //! author : LI Long : https://github.com/baryon
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var ja = moment.defineLocale('ja', {
              eras: [{
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R'
              }, {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H'
              }, {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S'
              }, {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T'
              }, {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M'
              }, {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD'
              }, {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC'
              }],
              eraYearOrdinalRegex: /(元|\d+)年/,
              eraYearOrdinalParse: function eraYearOrdinalParse(input, match) {
                return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
              },
              months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
              monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
              weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
              weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
              weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'YYYY/MM/DD',
                LL: 'YYYY年M月D日',
                LLL: 'YYYY年M月D日 HH:mm',
                LLLL: 'YYYY年M月D日 dddd HH:mm',
                l: 'YYYY/MM/DD',
                ll: 'YYYY年M月D日',
                lll: 'YYYY年M月D日 HH:mm',
                llll: 'YYYY年M月D日(ddd) HH:mm'
              },
              meridiemParse: /午前|午後/i,
              isPM: function isPM(input) {
                return input === '午後';
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 12) {
                  return '午前';
                } else {
                  return '午後';
                }
              },
              calendar: {
                sameDay: '[今日] LT',
                nextDay: '[明日] LT',
                nextWeek: function nextWeek(now) {
                  if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                  } else {
                    return 'dddd LT';
                  }
                },
                lastDay: '[昨日] LT',
                lastWeek: function lastWeek(now) {
                  if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                  } else {
                    return 'dddd LT';
                  }
                },
                sameElse: 'L'
              },
              dayOfMonthOrdinalParse: /\d{1,2}日/,
              ordinal: function ordinal(number, period) {
                switch (period) {
                  case 'y':
                    return number === 1 ? '元年' : number + '年';

                  case 'd':
                  case 'D':
                  case 'DDD':
                    return number + '日';

                  default:
                    return number;
                }
              },
              relativeTime: {
                future: '%s後',
                past: '%s前',
                s: '数秒',
                ss: '%d秒',
                m: '1分',
                mm: '%d分',
                h: '1時間',
                hh: '%d時間',
                d: '1日',
                dd: '%d日',
                M: '1ヶ月',
                MM: '%dヶ月',
                y: '1年',
                yy: '%d年'
              }
            });
            return ja;
          });
          /***/

        },

        /***/
        4286:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Javanese [jv]
          //! author : Rony Lantip : https://github.com/lantip
          //! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var jv = moment.defineLocale('jv', {
              months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
              monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
              weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
              weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
              weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
              longDateFormat: {
                LT: 'HH.mm',
                LTS: 'HH.mm.ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY [pukul] HH.mm',
                LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
              },
              meridiemParse: /enjing|siyang|sonten|ndalu/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'enjing') {
                  return hour;
                } else if (meridiem === 'siyang') {
                  return hour >= 11 ? hour : hour + 12;
                } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                  return hour + 12;
                }
              },
              meridiem: function meridiem(hours, minutes, isLower) {
                if (hours < 11) {
                  return 'enjing';
                } else if (hours < 15) {
                  return 'siyang';
                } else if (hours < 19) {
                  return 'sonten';
                } else {
                  return 'ndalu';
                }
              },
              calendar: {
                sameDay: '[Dinten puniko pukul] LT',
                nextDay: '[Mbenjang pukul] LT',
                nextWeek: 'dddd [pukul] LT',
                lastDay: '[Kala wingi pukul] LT',
                lastWeek: 'dddd [kepengker pukul] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'wonten ing %s',
                past: '%s ingkang kepengker',
                s: 'sawetawis detik',
                ss: '%d detik',
                m: 'setunggal menit',
                mm: '%d menit',
                h: 'setunggal jam',
                hh: '%d jam',
                d: 'sedinten',
                dd: '%d dinten',
                M: 'sewulan',
                MM: '%d wulan',
                y: 'setaun',
                yy: '%d taun'
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return jv;
          });
          /***/

        },

        /***/
        2105:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Georgian [ka]
          //! author : Irakli Janiashvili : https://github.com/IrakliJani
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var ka = moment.defineLocale('ka', {
              months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
              monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
              weekdays: {
                standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
                format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
                isFormat: /(წინა|შემდეგ)/
              },
              weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
              weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[დღეს] LT[-ზე]',
                nextDay: '[ხვალ] LT[-ზე]',
                lastDay: '[გუშინ] LT[-ზე]',
                nextWeek: '[შემდეგ] dddd LT[-ზე]',
                lastWeek: '[წინა] dddd LT-ზე',
                sameElse: 'L'
              },
              relativeTime: {
                future: function future(s) {
                  return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function ($0, $1, $2) {
                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                  });
                },
                past: function past(s) {
                  if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                  }

                  if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                  }

                  return s;
                },
                s: 'რამდენიმე წამი',
                ss: '%d წამი',
                m: 'წუთი',
                mm: '%d წუთი',
                h: 'საათი',
                hh: '%d საათი',
                d: 'დღე',
                dd: '%d დღე',
                M: 'თვე',
                MM: '%d თვე',
                y: 'წელი',
                yy: '%d წელი'
              },
              dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
              ordinal: function ordinal(number) {
                if (number === 0) {
                  return number;
                }

                if (number === 1) {
                  return number + '-ლი';
                }

                if (number < 20 || number <= 100 && number % 20 === 0 || number % 100 === 0) {
                  return 'მე-' + number;
                }

                return number + '-ე';
              },
              week: {
                dow: 1,
                doy: 7
              }
            });
            return ka;
          });
          /***/

        },

        /***/
        7772:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Kazakh [kk]
          //! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var suffixes = {
              0: '-ші',
              1: '-ші',
              2: '-ші',
              3: '-ші',
              4: '-ші',
              5: '-ші',
              6: '-шы',
              7: '-ші',
              8: '-ші',
              9: '-шы',
              10: '-шы',
              20: '-шы',
              30: '-шы',
              40: '-шы',
              50: '-ші',
              60: '-шы',
              70: '-ші',
              80: '-ші',
              90: '-шы',
              100: '-ші'
            };
            var kk = moment.defineLocale('kk', {
              months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
              monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
              weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
              weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
              weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Бүгін сағат] LT',
                nextDay: '[Ертең сағат] LT',
                nextWeek: 'dddd [сағат] LT',
                lastDay: '[Кеше сағат] LT',
                lastWeek: '[Өткен аптаның] dddd [сағат] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s ішінде',
                past: '%s бұрын',
                s: 'бірнеше секунд',
                ss: '%d секунд',
                m: 'бір минут',
                mm: '%d минут',
                h: 'бір сағат',
                hh: '%d сағат',
                d: 'бір күн',
                dd: '%d күн',
                M: 'бір ай',
                MM: '%d ай',
                y: 'бір жыл',
                yy: '%d жыл'
              },
              dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
              ordinal: function ordinal(number) {
                var a = number % 10,
                    b = number >= 100 ? 100 : null;
                return number + (suffixes[number] || suffixes[a] || suffixes[b]);
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return kk;
          });
          /***/

        },

        /***/
        8758:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Cambodian [km]
          //! author : Kruy Vanna : https://github.com/kruyvanna
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var symbolMap = {
              1: '១',
              2: '២',
              3: '៣',
              4: '៤',
              5: '៥',
              6: '៦',
              7: '៧',
              8: '៨',
              9: '៩',
              0: '០'
            },
                numberMap = {
              '១': '1',
              '២': '2',
              '៣': '3',
              '៤': '4',
              '៥': '5',
              '៦': '6',
              '៧': '7',
              '៨': '8',
              '៩': '9',
              '០': '0'
            };
            var km = moment.defineLocale('km', {
              months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
              monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
              weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
              weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
              weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              meridiemParse: /ព្រឹក|ល្ងាច/,
              isPM: function isPM(input) {
                return input === 'ល្ងាច';
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 12) {
                  return 'ព្រឹក';
                } else {
                  return 'ល្ងាច';
                }
              },
              calendar: {
                sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
                nextDay: '[ស្អែក ម៉ោង] LT',
                nextWeek: 'dddd [ម៉ោង] LT',
                lastDay: '[ម្សិលមិញ ម៉ោង] LT',
                lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%sទៀត',
                past: '%sមុន',
                s: 'ប៉ុន្មានវិនាទី',
                ss: '%d វិនាទី',
                m: 'មួយនាទី',
                mm: '%d នាទី',
                h: 'មួយម៉ោង',
                hh: '%d ម៉ោង',
                d: 'មួយថ្ងៃ',
                dd: '%d ថ្ងៃ',
                M: 'មួយខែ',
                MM: '%d ខែ',
                y: 'មួយឆ្នាំ',
                yy: '%d ឆ្នាំ'
              },
              dayOfMonthOrdinalParse: /ទី\d{1,2}/,
              ordinal: 'ទី%d',
              preparse: function preparse(string) {
                return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                  return numberMap[match];
                });
              },
              postformat: function postformat(string) {
                return string.replace(/\d/g, function (match) {
                  return symbolMap[match];
                });
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return km;
          });
          /***/

        },

        /***/
        9282:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Kannada [kn]
          //! author : Rajeev Naik : https://github.com/rajeevnaikte
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var symbolMap = {
              1: '೧',
              2: '೨',
              3: '೩',
              4: '೪',
              5: '೫',
              6: '೬',
              7: '೭',
              8: '೮',
              9: '೯',
              0: '೦'
            },
                numberMap = {
              '೧': '1',
              '೨': '2',
              '೩': '3',
              '೪': '4',
              '೫': '5',
              '೬': '6',
              '೭': '7',
              '೮': '8',
              '೯': '9',
              '೦': '0'
            };
            var kn = moment.defineLocale('kn', {
              months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
              monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
              monthsParseExact: true,
              weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
              weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
              weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
              longDateFormat: {
                LT: 'A h:mm',
                LTS: 'A h:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY, A h:mm',
                LLLL: 'dddd, D MMMM YYYY, A h:mm'
              },
              calendar: {
                sameDay: '[ಇಂದು] LT',
                nextDay: '[ನಾಳೆ] LT',
                nextWeek: 'dddd, LT',
                lastDay: '[ನಿನ್ನೆ] LT',
                lastWeek: '[ಕೊನೆಯ] dddd, LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s ನಂತರ',
                past: '%s ಹಿಂದೆ',
                s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
                ss: '%d ಸೆಕೆಂಡುಗಳು',
                m: 'ಒಂದು ನಿಮಿಷ',
                mm: '%d ನಿಮಿಷ',
                h: 'ಒಂದು ಗಂಟೆ',
                hh: '%d ಗಂಟೆ',
                d: 'ಒಂದು ದಿನ',
                dd: '%d ದಿನ',
                M: 'ಒಂದು ತಿಂಗಳು',
                MM: '%d ತಿಂಗಳು',
                y: 'ಒಂದು ವರ್ಷ',
                yy: '%d ವರ್ಷ'
              },
              preparse: function preparse(string) {
                return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                  return numberMap[match];
                });
              },
              postformat: function postformat(string) {
                return string.replace(/\d/g, function (match) {
                  return symbolMap[match];
                });
              },
              meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'ರಾತ್ರಿ') {
                  return hour < 4 ? hour : hour + 12;
                } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                  return hour;
                } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                  return hour >= 10 ? hour : hour + 12;
                } else if (meridiem === 'ಸಂಜೆ') {
                  return hour + 12;
                }
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 4) {
                  return 'ರಾತ್ರಿ';
                } else if (hour < 10) {
                  return 'ಬೆಳಿಗ್ಗೆ';
                } else if (hour < 17) {
                  return 'ಮಧ್ಯಾಹ್ನ';
                } else if (hour < 20) {
                  return 'ಸಂಜೆ';
                } else {
                  return 'ರಾತ್ರಿ';
                }
              },
              dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
              ordinal: function ordinal(number) {
                return number + 'ನೇ';
              },
              week: {
                dow: 0,
                // Sunday is the first day of the week.
                doy: 6 // The week that contains Jan 6th is the first week of the year.

              }
            });
            return kn;
          });
          /***/

        },

        /***/
        3730:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Korean [ko]
          //! author : Kyungwook, Park : https://github.com/kyungw00k
          //! author : Jeeeyul Lee <jeeeyul@gmail.com>
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var ko = moment.defineLocale('ko', {
              months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
              monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
              weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
              weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
              weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
              longDateFormat: {
                LT: 'A h:mm',
                LTS: 'A h:mm:ss',
                L: 'YYYY.MM.DD.',
                LL: 'YYYY년 MMMM D일',
                LLL: 'YYYY년 MMMM D일 A h:mm',
                LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
                l: 'YYYY.MM.DD.',
                ll: 'YYYY년 MMMM D일',
                lll: 'YYYY년 MMMM D일 A h:mm',
                llll: 'YYYY년 MMMM D일 dddd A h:mm'
              },
              calendar: {
                sameDay: '오늘 LT',
                nextDay: '내일 LT',
                nextWeek: 'dddd LT',
                lastDay: '어제 LT',
                lastWeek: '지난주 dddd LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s 후',
                past: '%s 전',
                s: '몇 초',
                ss: '%d초',
                m: '1분',
                mm: '%d분',
                h: '한 시간',
                hh: '%d시간',
                d: '하루',
                dd: '%d일',
                M: '한 달',
                MM: '%d달',
                y: '일 년',
                yy: '%d년'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
              ordinal: function ordinal(number, period) {
                switch (period) {
                  case 'd':
                  case 'D':
                  case 'DDD':
                    return number + '일';

                  case 'M':
                    return number + '월';

                  case 'w':
                  case 'W':
                    return number + '주';

                  default:
                    return number;
                }
              },
              meridiemParse: /오전|오후/,
              isPM: function isPM(token) {
                return token === '오후';
              },
              meridiem: function meridiem(hour, minute, isUpper) {
                return hour < 12 ? '오전' : '오후';
              }
            });
            return ko;
          });
          /***/

        },

        /***/
        1408:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Kurdish [ku]
          //! author : Shahram Mebashar : https://github.com/ShahramMebashar
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var symbolMap = {
              1: '١',
              2: '٢',
              3: '٣',
              4: '٤',
              5: '٥',
              6: '٦',
              7: '٧',
              8: '٨',
              9: '٩',
              0: '٠'
            },
                numberMap = {
              '١': '1',
              '٢': '2',
              '٣': '3',
              '٤': '4',
              '٥': '5',
              '٦': '6',
              '٧': '7',
              '٨': '8',
              '٩': '9',
              '٠': '0'
            },
                months = ['کانونی دووەم', 'شوبات', 'ئازار', 'نیسان', 'ئایار', 'حوزەیران', 'تەمموز', 'ئاب', 'ئەیلوول', 'تشرینی یەكەم', 'تشرینی دووەم', 'كانونی یەکەم'];
            var ku = moment.defineLocale('ku', {
              months: months,
              monthsShort: months,
              weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
              weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
              weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              meridiemParse: /ئێواره‌|به‌یانی/,
              isPM: function isPM(input) {
                return /ئێواره‌/.test(input);
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 12) {
                  return 'به‌یانی';
                } else {
                  return 'ئێواره‌';
                }
              },
              calendar: {
                sameDay: '[ئه‌مرۆ كاتژمێر] LT',
                nextDay: '[به‌یانی كاتژمێر] LT',
                nextWeek: 'dddd [كاتژمێر] LT',
                lastDay: '[دوێنێ كاتژمێر] LT',
                lastWeek: 'dddd [كاتژمێر] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'له‌ %s',
                past: '%s',
                s: 'چه‌ند چركه‌یه‌ك',
                ss: 'چركه‌ %d',
                m: 'یه‌ك خوله‌ك',
                mm: '%d خوله‌ك',
                h: 'یه‌ك كاتژمێر',
                hh: '%d كاتژمێر',
                d: 'یه‌ك ڕۆژ',
                dd: '%d ڕۆژ',
                M: 'یه‌ك مانگ',
                MM: '%d مانگ',
                y: 'یه‌ك ساڵ',
                yy: '%d ساڵ'
              },
              preparse: function preparse(string) {
                return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                  return numberMap[match];
                }).replace(/،/g, ',');
              },
              postformat: function postformat(string) {
                return string.replace(/\d/g, function (match) {
                  return symbolMap[match];
                }).replace(/,/g, '،');
              },
              week: {
                dow: 6,
                // Saturday is the first day of the week.
                doy: 12 // The week that contains Jan 12th is the first week of the year.

              }
            });
            return ku;
          });
          /***/

        },

        /***/
        3291:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Kyrgyz [ky]
          //! author : Chyngyz Arystan uulu : https://github.com/chyngyz
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var suffixes = {
              0: '-чү',
              1: '-чи',
              2: '-чи',
              3: '-чү',
              4: '-чү',
              5: '-чи',
              6: '-чы',
              7: '-чи',
              8: '-чи',
              9: '-чу',
              10: '-чу',
              20: '-чы',
              30: '-чу',
              40: '-чы',
              50: '-чү',
              60: '-чы',
              70: '-чи',
              80: '-чи',
              90: '-чу',
              100: '-чү'
            };
            var ky = moment.defineLocale('ky', {
              months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
              monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
              weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
              weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
              weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Бүгүн саат] LT',
                nextDay: '[Эртең саат] LT',
                nextWeek: 'dddd [саат] LT',
                lastDay: '[Кечээ саат] LT',
                lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s ичинде',
                past: '%s мурун',
                s: 'бирнече секунд',
                ss: '%d секунд',
                m: 'бир мүнөт',
                mm: '%d мүнөт',
                h: 'бир саат',
                hh: '%d саат',
                d: 'бир күн',
                dd: '%d күн',
                M: 'бир ай',
                MM: '%d ай',
                y: 'бир жыл',
                yy: '%d жыл'
              },
              dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
              ordinal: function ordinal(number) {
                var a = number % 10,
                    b = number >= 100 ? 100 : null;
                return number + (suffixes[number] || suffixes[a] || suffixes[b]);
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return ky;
          });
          /***/

        },

        /***/
        6841:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Luxembourgish [lb]
          //! author : mweimerskirch : https://github.com/mweimerskirch
          //! author : David Raison : https://github.com/kwisatz
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            function processRelativeTime(number, withoutSuffix, key, isFuture) {
              var format = {
                m: ['eng Minutt', 'enger Minutt'],
                h: ['eng Stonn', 'enger Stonn'],
                d: ['een Dag', 'engem Dag'],
                M: ['ee Mount', 'engem Mount'],
                y: ['ee Joer', 'engem Joer']
              };
              return withoutSuffix ? format[key][0] : format[key][1];
            }

            function processFutureTime(string) {
              var number = string.substr(0, string.indexOf(' '));

              if (eifelerRegelAppliesToNumber(number)) {
                return 'a ' + string;
              }

              return 'an ' + string;
            }

            function processPastTime(string) {
              var number = string.substr(0, string.indexOf(' '));

              if (eifelerRegelAppliesToNumber(number)) {
                return 'viru ' + string;
              }

              return 'virun ' + string;
            }
            /**
             * Returns true if the word before the given number loses the '-n' ending.
             * e.g. 'an 10 Deeg' but 'a 5 Deeg'
             *
             * @param number {integer}
             * @returns {boolean}
             */


            function eifelerRegelAppliesToNumber(number) {
              number = parseInt(number, 10);

              if (isNaN(number)) {
                return false;
              }

              if (number < 0) {
                // Negative Number --> always true
                return true;
              } else if (number < 10) {
                // Only 1 digit
                if (4 <= number && number <= 7) {
                  return true;
                }

                return false;
              } else if (number < 100) {
                // 2 digits
                var lastDigit = number % 10,
                    firstDigit = number / 10;

                if (lastDigit === 0) {
                  return eifelerRegelAppliesToNumber(firstDigit);
                }

                return eifelerRegelAppliesToNumber(lastDigit);
              } else if (number < 10000) {
                // 3 or 4 digits --> recursively check first digit
                while (number >= 10) {
                  number = number / 10;
                }

                return eifelerRegelAppliesToNumber(number);
              } else {
                // Anything larger than 4 digits: recursively check first n-3 digits
                number = number / 1000;
                return eifelerRegelAppliesToNumber(number);
              }
            }

            var lb = moment.defineLocale('lb', {
              months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
              monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
              monthsParseExact: true,
              weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
              weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
              weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'H:mm [Auer]',
                LTS: 'H:mm:ss [Auer]',
                L: 'DD.MM.YYYY',
                LL: 'D. MMMM YYYY',
                LLL: 'D. MMMM YYYY H:mm [Auer]',
                LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
              },
              calendar: {
                sameDay: '[Haut um] LT',
                sameElse: 'L',
                nextDay: '[Muer um] LT',
                nextWeek: 'dddd [um] LT',
                lastDay: '[Gëschter um] LT',
                lastWeek: function lastWeek() {
                  // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                  switch (this.day()) {
                    case 2:
                    case 4:
                      return '[Leschten] dddd [um] LT';

                    default:
                      return '[Leschte] dddd [um] LT';
                  }
                }
              },
              relativeTime: {
                future: processFutureTime,
                past: processPastTime,
                s: 'e puer Sekonnen',
                ss: '%d Sekonnen',
                m: processRelativeTime,
                mm: '%d Minutten',
                h: processRelativeTime,
                hh: '%d Stonnen',
                d: processRelativeTime,
                dd: '%d Deeg',
                M: processRelativeTime,
                MM: '%d Méint',
                y: processRelativeTime,
                yy: '%d Joer'
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return lb;
          });
          /***/

        },

        /***/
        5466:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Lao [lo]
          //! author : Ryan Hart : https://github.com/ryanhart2
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var lo = moment.defineLocale('lo', {
              months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
              monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
              weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
              weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
              weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'ວັນdddd D MMMM YYYY HH:mm'
              },
              meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
              isPM: function isPM(input) {
                return input === 'ຕອນແລງ';
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 12) {
                  return 'ຕອນເຊົ້າ';
                } else {
                  return 'ຕອນແລງ';
                }
              },
              calendar: {
                sameDay: '[ມື້ນີ້ເວລາ] LT',
                nextDay: '[ມື້ອື່ນເວລາ] LT',
                nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
                lastDay: '[ມື້ວານນີ້ເວລາ] LT',
                lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'ອີກ %s',
                past: '%sຜ່ານມາ',
                s: 'ບໍ່ເທົ່າໃດວິນາທີ',
                ss: '%d ວິນາທີ',
                m: '1 ນາທີ',
                mm: '%d ນາທີ',
                h: '1 ຊົ່ວໂມງ',
                hh: '%d ຊົ່ວໂມງ',
                d: '1 ມື້',
                dd: '%d ມື້',
                M: '1 ເດືອນ',
                MM: '%d ເດືອນ',
                y: '1 ປີ',
                yy: '%d ປີ'
              },
              dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
              ordinal: function ordinal(number) {
                return 'ທີ່' + number;
              }
            });
            return lo;
          });
          /***/

        },

        /***/
        7010:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Lithuanian [lt]
          //! author : Mindaugas Mozūras : https://github.com/mmozuras
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var units = {
              ss: 'sekundė_sekundžių_sekundes',
              m: 'minutė_minutės_minutę',
              mm: 'minutės_minučių_minutes',
              h: 'valanda_valandos_valandą',
              hh: 'valandos_valandų_valandas',
              d: 'diena_dienos_dieną',
              dd: 'dienos_dienų_dienas',
              M: 'mėnuo_mėnesio_mėnesį',
              MM: 'mėnesiai_mėnesių_mėnesius',
              y: 'metai_metų_metus',
              yy: 'metai_metų_metus'
            };

            function translateSeconds(number, withoutSuffix, key, isFuture) {
              if (withoutSuffix) {
                return 'kelios sekundės';
              } else {
                return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
              }
            }

            function translateSingular(number, withoutSuffix, key, isFuture) {
              return withoutSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
            }

            function special(number) {
              return number % 10 === 0 || number > 10 && number < 20;
            }

            function forms(key) {
              return units[key].split('_');
            }

            function translate(number, withoutSuffix, key, isFuture) {
              var result = number + ' ';

              if (number === 1) {
                return result + translateSingular(number, withoutSuffix, key[0], isFuture);
              } else if (withoutSuffix) {
                return result + (special(number) ? forms(key)[1] : forms(key)[0]);
              } else {
                if (isFuture) {
                  return result + forms(key)[1];
                } else {
                  return result + (special(number) ? forms(key)[1] : forms(key)[2]);
                }
              }
            }

            var lt = moment.defineLocale('lt', {
              months: {
                format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
                standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
                isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
              },
              monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
              weekdays: {
                format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
                standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
                isFormat: /dddd HH:mm/
              },
              weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
              weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'YYYY-MM-DD',
                LL: 'YYYY [m.] MMMM D [d.]',
                LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
                LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
                l: 'YYYY-MM-DD',
                ll: 'YYYY [m.] MMMM D [d.]',
                lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
                llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
              },
              calendar: {
                sameDay: '[Šiandien] LT',
                nextDay: '[Rytoj] LT',
                nextWeek: 'dddd LT',
                lastDay: '[Vakar] LT',
                lastWeek: '[Praėjusį] dddd LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'po %s',
                past: 'prieš %s',
                s: translateSeconds,
                ss: translate,
                m: translateSingular,
                mm: translate,
                h: translateSingular,
                hh: translate,
                d: translateSingular,
                dd: translate,
                M: translateSingular,
                MM: translate,
                y: translateSingular,
                yy: translate
              },
              dayOfMonthOrdinalParse: /\d{1,2}-oji/,
              ordinal: function ordinal(number) {
                return number + '-oji';
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return lt;
          });
          /***/

        },

        /***/
        7595:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Latvian [lv]
          //! author : Kristaps Karlsons : https://github.com/skakri
          //! author : Jānis Elmeris : https://github.com/JanisE
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var units = {
              ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
              m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
              mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
              h: 'stundas_stundām_stunda_stundas'.split('_'),
              hh: 'stundas_stundām_stunda_stundas'.split('_'),
              d: 'dienas_dienām_diena_dienas'.split('_'),
              dd: 'dienas_dienām_diena_dienas'.split('_'),
              M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
              MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
              y: 'gada_gadiem_gads_gadi'.split('_'),
              yy: 'gada_gadiem_gads_gadi'.split('_')
            };
            /**
             * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
             */

            function format(forms, number, withoutSuffix) {
              if (withoutSuffix) {
                // E.g. "21 minūte", "3 minūtes".
                return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
              } else {
                // E.g. "21 minūtes" as in "pēc 21 minūtes".
                // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
                return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
              }
            }

            function relativeTimeWithPlural(number, withoutSuffix, key) {
              return number + ' ' + format(units[key], number, withoutSuffix);
            }

            function relativeTimeWithSingular(number, withoutSuffix, key) {
              return format(units[key], number, withoutSuffix);
            }

            function relativeSeconds(number, withoutSuffix) {
              return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
            }

            var lv = moment.defineLocale('lv', {
              months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
              monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
              weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
              weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
              weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY.',
                LL: 'YYYY. [gada] D. MMMM',
                LLL: 'YYYY. [gada] D. MMMM, HH:mm',
                LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm'
              },
              calendar: {
                sameDay: '[Šodien pulksten] LT',
                nextDay: '[Rīt pulksten] LT',
                nextWeek: 'dddd [pulksten] LT',
                lastDay: '[Vakar pulksten] LT',
                lastWeek: '[Pagājušā] dddd [pulksten] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'pēc %s',
                past: 'pirms %s',
                s: relativeSeconds,
                ss: relativeTimeWithPlural,
                m: relativeTimeWithSingular,
                mm: relativeTimeWithPlural,
                h: relativeTimeWithSingular,
                hh: relativeTimeWithPlural,
                d: relativeTimeWithSingular,
                dd: relativeTimeWithPlural,
                M: relativeTimeWithSingular,
                MM: relativeTimeWithPlural,
                y: relativeTimeWithSingular,
                yy: relativeTimeWithPlural
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return lv;
          });
          /***/

        },

        /***/
        9861:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Montenegrin [me]
          //! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var translator = {
              words: {
                //Different grammatical cases
                ss: ['sekund', 'sekunda', 'sekundi'],
                m: ['jedan minut', 'jednog minuta'],
                mm: ['minut', 'minuta', 'minuta'],
                h: ['jedan sat', 'jednog sata'],
                hh: ['sat', 'sata', 'sati'],
                dd: ['dan', 'dana', 'dana'],
                MM: ['mjesec', 'mjeseca', 'mjeseci'],
                yy: ['godina', 'godine', 'godina']
              },
              correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
                return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
              },
              translate: function translate(number, withoutSuffix, key) {
                var wordKey = translator.words[key];

                if (key.length === 1) {
                  return withoutSuffix ? wordKey[0] : wordKey[1];
                } else {
                  return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
                }
              }
            };
            var me = moment.defineLocale('me', {
              months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
              monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
              monthsParseExact: true,
              weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
              weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
              weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D. MMMM YYYY',
                LLL: 'D. MMMM YYYY H:mm',
                LLLL: 'dddd, D. MMMM YYYY H:mm'
              },
              calendar: {
                sameDay: '[danas u] LT',
                nextDay: '[sjutra u] LT',
                nextWeek: function nextWeek() {
                  switch (this.day()) {
                    case 0:
                      return '[u] [nedjelju] [u] LT';

                    case 3:
                      return '[u] [srijedu] [u] LT';

                    case 6:
                      return '[u] [subotu] [u] LT';

                    case 1:
                    case 2:
                    case 4:
                    case 5:
                      return '[u] dddd [u] LT';
                  }
                },
                lastDay: '[juče u] LT',
                lastWeek: function lastWeek() {
                  var lastWeekDays = ['[prošle] [nedjelje] [u] LT', '[prošlog] [ponedjeljka] [u] LT', '[prošlog] [utorka] [u] LT', '[prošle] [srijede] [u] LT', '[prošlog] [četvrtka] [u] LT', '[prošlog] [petka] [u] LT', '[prošle] [subote] [u] LT'];
                  return lastWeekDays[this.day()];
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'za %s',
                past: 'prije %s',
                s: 'nekoliko sekundi',
                ss: translator.translate,
                m: translator.translate,
                mm: translator.translate,
                h: translator.translate,
                hh: translator.translate,
                d: 'dan',
                dd: translator.translate,
                M: 'mjesec',
                MM: translator.translate,
                y: 'godinu',
                yy: translator.translate
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return me;
          });
          /***/

        },

        /***/
        5493:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Maori [mi]
          //! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var mi = moment.defineLocale('mi', {
              months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
              monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
              monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
              monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
              monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
              monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
              weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
              weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
              weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY [i] HH:mm',
                LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
              },
              calendar: {
                sameDay: '[i teie mahana, i] LT',
                nextDay: '[apopo i] LT',
                nextWeek: 'dddd [i] LT',
                lastDay: '[inanahi i] LT',
                lastWeek: 'dddd [whakamutunga i] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'i roto i %s',
                past: '%s i mua',
                s: 'te hēkona ruarua',
                ss: '%d hēkona',
                m: 'he meneti',
                mm: '%d meneti',
                h: 'te haora',
                hh: '%d haora',
                d: 'he ra',
                dd: '%d ra',
                M: 'he marama',
                MM: '%d marama',
                y: 'he tau',
                yy: '%d tau'
              },
              dayOfMonthOrdinalParse: /\d{1,2}º/,
              ordinal: '%dº',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return mi;
          });
          /***/

        },

        /***/
        5966:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Macedonian [mk]
          //! author : Borislav Mickov : https://github.com/B0k0
          //! author : Sashko Todorov : https://github.com/bkyceh
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var mk = moment.defineLocale('mk', {
              months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
              monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
              weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
              weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
              weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'D.MM.YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY H:mm',
                LLLL: 'dddd, D MMMM YYYY H:mm'
              },
              calendar: {
                sameDay: '[Денес во] LT',
                nextDay: '[Утре во] LT',
                nextWeek: '[Во] dddd [во] LT',
                lastDay: '[Вчера во] LT',
                lastWeek: function lastWeek() {
                  switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                      return '[Изминатата] dddd [во] LT';

                    case 1:
                    case 2:
                    case 4:
                    case 5:
                      return '[Изминатиот] dddd [во] LT';
                  }
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'за %s',
                past: 'пред %s',
                s: 'неколку секунди',
                ss: '%d секунди',
                m: 'една минута',
                mm: '%d минути',
                h: 'еден час',
                hh: '%d часа',
                d: 'еден ден',
                dd: '%d дена',
                M: 'еден месец',
                MM: '%d месеци',
                y: 'една година',
                yy: '%d години'
              },
              dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
              ordinal: function ordinal(number) {
                var lastDigit = number % 10,
                    last2Digits = number % 100;

                if (number === 0) {
                  return number + '-ев';
                } else if (last2Digits === 0) {
                  return number + '-ен';
                } else if (last2Digits > 10 && last2Digits < 20) {
                  return number + '-ти';
                } else if (lastDigit === 1) {
                  return number + '-ви';
                } else if (lastDigit === 2) {
                  return number + '-ри';
                } else if (lastDigit === 7 || lastDigit === 8) {
                  return number + '-ми';
                } else {
                  return number + '-ти';
                }
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return mk;
          });
          /***/

        },

        /***/
        7341:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Malayalam [ml]
          //! author : Floyd Pink : https://github.com/floydpink
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var ml = moment.defineLocale('ml', {
              months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
              monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
              monthsParseExact: true,
              weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
              weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
              weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
              longDateFormat: {
                LT: 'A h:mm -നു',
                LTS: 'A h:mm:ss -നു',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY, A h:mm -നു',
                LLLL: 'dddd, D MMMM YYYY, A h:mm -നു'
              },
              calendar: {
                sameDay: '[ഇന്ന്] LT',
                nextDay: '[നാളെ] LT',
                nextWeek: 'dddd, LT',
                lastDay: '[ഇന്നലെ] LT',
                lastWeek: '[കഴിഞ്ഞ] dddd, LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s കഴിഞ്ഞ്',
                past: '%s മുൻപ്',
                s: 'അൽപ നിമിഷങ്ങൾ',
                ss: '%d സെക്കൻഡ്',
                m: 'ഒരു മിനിറ്റ്',
                mm: '%d മിനിറ്റ്',
                h: 'ഒരു മണിക്കൂർ',
                hh: '%d മണിക്കൂർ',
                d: 'ഒരു ദിവസം',
                dd: '%d ദിവസം',
                M: 'ഒരു മാസം',
                MM: '%d മാസം',
                y: 'ഒരു വർഷം',
                yy: '%d വർഷം'
              },
              meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'രാത്രി' && hour >= 4 || meridiem === 'ഉച്ച കഴിഞ്ഞ്' || meridiem === 'വൈകുന്നേരം') {
                  return hour + 12;
                } else {
                  return hour;
                }
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 4) {
                  return 'രാത്രി';
                } else if (hour < 12) {
                  return 'രാവിലെ';
                } else if (hour < 17) {
                  return 'ഉച്ച കഴിഞ്ഞ്';
                } else if (hour < 20) {
                  return 'വൈകുന്നേരം';
                } else {
                  return 'രാത്രി';
                }
              }
            });
            return ml;
          });
          /***/

        },

        /***/
        5115:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Mongolian [mn]
          //! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            function translate(number, withoutSuffix, key, isFuture) {
              switch (key) {
                case 's':
                  return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';

                case 'ss':
                  return number + (withoutSuffix ? ' секунд' : ' секундын');

                case 'm':
                case 'mm':
                  return number + (withoutSuffix ? ' минут' : ' минутын');

                case 'h':
                case 'hh':
                  return number + (withoutSuffix ? ' цаг' : ' цагийн');

                case 'd':
                case 'dd':
                  return number + (withoutSuffix ? ' өдөр' : ' өдрийн');

                case 'M':
                case 'MM':
                  return number + (withoutSuffix ? ' сар' : ' сарын');

                case 'y':
                case 'yy':
                  return number + (withoutSuffix ? ' жил' : ' жилийн');

                default:
                  return number;
              }
            }

            var mn = moment.defineLocale('mn', {
              months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
              monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
              monthsParseExact: true,
              weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
              weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
              weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'YYYY-MM-DD',
                LL: 'YYYY оны MMMMын D',
                LLL: 'YYYY оны MMMMын D HH:mm',
                LLLL: 'dddd, YYYY оны MMMMын D HH:mm'
              },
              meridiemParse: /ҮӨ|ҮХ/i,
              isPM: function isPM(input) {
                return input === 'ҮХ';
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 12) {
                  return 'ҮӨ';
                } else {
                  return 'ҮХ';
                }
              },
              calendar: {
                sameDay: '[Өнөөдөр] LT',
                nextDay: '[Маргааш] LT',
                nextWeek: '[Ирэх] dddd LT',
                lastDay: '[Өчигдөр] LT',
                lastWeek: '[Өнгөрсөн] dddd LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s дараа',
                past: '%s өмнө',
                s: translate,
                ss: translate,
                m: translate,
                mm: translate,
                h: translate,
                hh: translate,
                d: translate,
                dd: translate,
                M: translate,
                MM: translate,
                y: translate,
                yy: translate
              },
              dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
              ordinal: function ordinal(number, period) {
                switch (period) {
                  case 'd':
                  case 'D':
                  case 'DDD':
                    return number + ' өдөр';

                  default:
                    return number;
                }
              }
            });
            return mn;
          });
          /***/

        },

        /***/
        370:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Marathi [mr]
          //! author : Harshad Kale : https://github.com/kalehv
          //! author : Vivek Athalye : https://github.com/vnathalye
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var symbolMap = {
              1: '१',
              2: '२',
              3: '३',
              4: '४',
              5: '५',
              6: '६',
              7: '७',
              8: '८',
              9: '९',
              0: '०'
            },
                numberMap = {
              '१': '1',
              '२': '2',
              '३': '3',
              '४': '4',
              '५': '5',
              '६': '6',
              '७': '7',
              '८': '8',
              '९': '9',
              '०': '0'
            };

            function relativeTimeMr(number, withoutSuffix, string, isFuture) {
              var output = '';

              if (withoutSuffix) {
                switch (string) {
                  case 's':
                    output = 'काही सेकंद';
                    break;

                  case 'ss':
                    output = '%d सेकंद';
                    break;

                  case 'm':
                    output = 'एक मिनिट';
                    break;

                  case 'mm':
                    output = '%d मिनिटे';
                    break;

                  case 'h':
                    output = 'एक तास';
                    break;

                  case 'hh':
                    output = '%d तास';
                    break;

                  case 'd':
                    output = 'एक दिवस';
                    break;

                  case 'dd':
                    output = '%d दिवस';
                    break;

                  case 'M':
                    output = 'एक महिना';
                    break;

                  case 'MM':
                    output = '%d महिने';
                    break;

                  case 'y':
                    output = 'एक वर्ष';
                    break;

                  case 'yy':
                    output = '%d वर्षे';
                    break;
                }
              } else {
                switch (string) {
                  case 's':
                    output = 'काही सेकंदां';
                    break;

                  case 'ss':
                    output = '%d सेकंदां';
                    break;

                  case 'm':
                    output = 'एका मिनिटा';
                    break;

                  case 'mm':
                    output = '%d मिनिटां';
                    break;

                  case 'h':
                    output = 'एका तासा';
                    break;

                  case 'hh':
                    output = '%d तासां';
                    break;

                  case 'd':
                    output = 'एका दिवसा';
                    break;

                  case 'dd':
                    output = '%d दिवसां';
                    break;

                  case 'M':
                    output = 'एका महिन्या';
                    break;

                  case 'MM':
                    output = '%d महिन्यां';
                    break;

                  case 'y':
                    output = 'एका वर्षा';
                    break;

                  case 'yy':
                    output = '%d वर्षां';
                    break;
                }
              }

              return output.replace(/%d/i, number);
            }

            var mr = moment.defineLocale('mr', {
              months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
              monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
              monthsParseExact: true,
              weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
              weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
              weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
              longDateFormat: {
                LT: 'A h:mm वाजता',
                LTS: 'A h:mm:ss वाजता',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY, A h:mm वाजता',
                LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता'
              },
              calendar: {
                sameDay: '[आज] LT',
                nextDay: '[उद्या] LT',
                nextWeek: 'dddd, LT',
                lastDay: '[काल] LT',
                lastWeek: '[मागील] dddd, LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%sमध्ये',
                past: '%sपूर्वी',
                s: relativeTimeMr,
                ss: relativeTimeMr,
                m: relativeTimeMr,
                mm: relativeTimeMr,
                h: relativeTimeMr,
                hh: relativeTimeMr,
                d: relativeTimeMr,
                dd: relativeTimeMr,
                M: relativeTimeMr,
                MM: relativeTimeMr,
                y: relativeTimeMr,
                yy: relativeTimeMr
              },
              preparse: function preparse(string) {
                return string.replace(/[१२३४५६७८९०]/g, function (match) {
                  return numberMap[match];
                });
              },
              postformat: function postformat(string) {
                return string.replace(/\d/g, function (match) {
                  return symbolMap[match];
                });
              },
              meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                  return hour;
                } else if (meridiem === 'दुपारी' || meridiem === 'सायंकाळी' || meridiem === 'रात्री') {
                  return hour >= 12 ? hour : hour + 12;
                }
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour >= 0 && hour < 6) {
                  return 'पहाटे';
                } else if (hour < 12) {
                  return 'सकाळी';
                } else if (hour < 17) {
                  return 'दुपारी';
                } else if (hour < 20) {
                  return 'सायंकाळी';
                } else {
                  return 'रात्री';
                }
              },
              week: {
                dow: 0,
                // Sunday is the first day of the week.
                doy: 6 // The week that contains Jan 6th is the first week of the year.

              }
            });
            return mr;
          });
          /***/

        },

        /***/
        1237:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Malay [ms-my]
          //! note : DEPRECATED, the correct one is [ms]
          //! author : Weldan Jamili : https://github.com/weldan
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var msMy = moment.defineLocale('ms-my', {
              months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
              monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
              weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
              weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
              weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
              longDateFormat: {
                LT: 'HH.mm',
                LTS: 'HH.mm.ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY [pukul] HH.mm',
                LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
              },
              meridiemParse: /pagi|tengahari|petang|malam/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'pagi') {
                  return hour;
                } else if (meridiem === 'tengahari') {
                  return hour >= 11 ? hour : hour + 12;
                } else if (meridiem === 'petang' || meridiem === 'malam') {
                  return hour + 12;
                }
              },
              meridiem: function meridiem(hours, minutes, isLower) {
                if (hours < 11) {
                  return 'pagi';
                } else if (hours < 15) {
                  return 'tengahari';
                } else if (hours < 19) {
                  return 'petang';
                } else {
                  return 'malam';
                }
              },
              calendar: {
                sameDay: '[Hari ini pukul] LT',
                nextDay: '[Esok pukul] LT',
                nextWeek: 'dddd [pukul] LT',
                lastDay: '[Kelmarin pukul] LT',
                lastWeek: 'dddd [lepas pukul] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'dalam %s',
                past: '%s yang lepas',
                s: 'beberapa saat',
                ss: '%d saat',
                m: 'seminit',
                mm: '%d minit',
                h: 'sejam',
                hh: '%d jam',
                d: 'sehari',
                dd: '%d hari',
                M: 'sebulan',
                MM: '%d bulan',
                y: 'setahun',
                yy: '%d tahun'
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return msMy;
          });
          /***/

        },

        /***/
        9847:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Malay [ms]
          //! author : Weldan Jamili : https://github.com/weldan
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var ms = moment.defineLocale('ms', {
              months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
              monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
              weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
              weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
              weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
              longDateFormat: {
                LT: 'HH.mm',
                LTS: 'HH.mm.ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY [pukul] HH.mm',
                LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
              },
              meridiemParse: /pagi|tengahari|petang|malam/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'pagi') {
                  return hour;
                } else if (meridiem === 'tengahari') {
                  return hour >= 11 ? hour : hour + 12;
                } else if (meridiem === 'petang' || meridiem === 'malam') {
                  return hour + 12;
                }
              },
              meridiem: function meridiem(hours, minutes, isLower) {
                if (hours < 11) {
                  return 'pagi';
                } else if (hours < 15) {
                  return 'tengahari';
                } else if (hours < 19) {
                  return 'petang';
                } else {
                  return 'malam';
                }
              },
              calendar: {
                sameDay: '[Hari ini pukul] LT',
                nextDay: '[Esok pukul] LT',
                nextWeek: 'dddd [pukul] LT',
                lastDay: '[Kelmarin pukul] LT',
                lastWeek: 'dddd [lepas pukul] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'dalam %s',
                past: '%s yang lepas',
                s: 'beberapa saat',
                ss: '%d saat',
                m: 'seminit',
                mm: '%d minit',
                h: 'sejam',
                hh: '%d jam',
                d: 'sehari',
                dd: '%d hari',
                M: 'sebulan',
                MM: '%d bulan',
                y: 'setahun',
                yy: '%d tahun'
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return ms;
          });
          /***/

        },

        /***/
        2126:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Maltese (Malta) [mt]
          //! author : Alessandro Maruccia : https://github.com/alesma
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var mt = moment.defineLocale('mt', {
              months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
              monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
              weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
              weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
              weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Illum fil-]LT',
                nextDay: '[Għada fil-]LT',
                nextWeek: 'dddd [fil-]LT',
                lastDay: '[Il-bieraħ fil-]LT',
                lastWeek: 'dddd [li għadda] [fil-]LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'f’ %s',
                past: '%s ilu',
                s: 'ftit sekondi',
                ss: '%d sekondi',
                m: 'minuta',
                mm: '%d minuti',
                h: 'siegħa',
                hh: '%d siegħat',
                d: 'ġurnata',
                dd: '%d ġranet',
                M: 'xahar',
                MM: '%d xhur',
                y: 'sena',
                yy: '%d sni'
              },
              dayOfMonthOrdinalParse: /\d{1,2}º/,
              ordinal: '%dº',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return mt;
          });
          /***/

        },

        /***/
        6165:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Burmese [my]
          //! author : Squar team, mysquar.com
          //! author : David Rossellat : https://github.com/gholadr
          //! author : Tin Aung Lin : https://github.com/thanyawzinmin
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var symbolMap = {
              1: '၁',
              2: '၂',
              3: '၃',
              4: '၄',
              5: '၅',
              6: '၆',
              7: '၇',
              8: '၈',
              9: '၉',
              0: '၀'
            },
                numberMap = {
              '၁': '1',
              '၂': '2',
              '၃': '3',
              '၄': '4',
              '၅': '5',
              '၆': '6',
              '၇': '7',
              '၈': '8',
              '၉': '9',
              '၀': '0'
            };
            var my = moment.defineLocale('my', {
              months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
              monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
              weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
              weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
              weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[ယနေ.] LT [မှာ]',
                nextDay: '[မနက်ဖြန်] LT [မှာ]',
                nextWeek: 'dddd LT [မှာ]',
                lastDay: '[မနေ.က] LT [မှာ]',
                lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'လာမည့် %s မှာ',
                past: 'လွန်ခဲ့သော %s က',
                s: 'စက္ကန်.အနည်းငယ်',
                ss: '%d စက္ကန့်',
                m: 'တစ်မိနစ်',
                mm: '%d မိနစ်',
                h: 'တစ်နာရီ',
                hh: '%d နာရီ',
                d: 'တစ်ရက်',
                dd: '%d ရက်',
                M: 'တစ်လ',
                MM: '%d လ',
                y: 'တစ်နှစ်',
                yy: '%d နှစ်'
              },
              preparse: function preparse(string) {
                return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                  return numberMap[match];
                });
              },
              postformat: function postformat(string) {
                return string.replace(/\d/g, function (match) {
                  return symbolMap[match];
                });
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return my;
          });
          /***/

        },

        /***/
        4924:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Norwegian Bokmål [nb]
          //! authors : Espen Hovlandsdal : https://github.com/rexxars
          //!           Sigurd Gartmann : https://github.com/sigurdga
          //!           Stephen Ramthun : https://github.com/stephenramthun
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var nb = moment.defineLocale('nb', {
              months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
              monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
              monthsParseExact: true,
              weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
              weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
              weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D. MMMM YYYY',
                LLL: 'D. MMMM YYYY [kl.] HH:mm',
                LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm'
              },
              calendar: {
                sameDay: '[i dag kl.] LT',
                nextDay: '[i morgen kl.] LT',
                nextWeek: 'dddd [kl.] LT',
                lastDay: '[i går kl.] LT',
                lastWeek: '[forrige] dddd [kl.] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'om %s',
                past: '%s siden',
                s: 'noen sekunder',
                ss: '%d sekunder',
                m: 'ett minutt',
                mm: '%d minutter',
                h: 'en time',
                hh: '%d timer',
                d: 'en dag',
                dd: '%d dager',
                w: 'en uke',
                ww: '%d uker',
                M: 'en måned',
                MM: '%d måneder',
                y: 'ett år',
                yy: '%d år'
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return nb;
          });
          /***/

        },

        /***/
        6744:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Nepalese [ne]
          //! author : suvash : https://github.com/suvash
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var symbolMap = {
              1: '१',
              2: '२',
              3: '३',
              4: '४',
              5: '५',
              6: '६',
              7: '७',
              8: '८',
              9: '९',
              0: '०'
            },
                numberMap = {
              '१': '1',
              '२': '2',
              '३': '3',
              '४': '4',
              '५': '5',
              '६': '6',
              '७': '7',
              '८': '8',
              '९': '9',
              '०': '0'
            };
            var ne = moment.defineLocale('ne', {
              months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
              monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
              monthsParseExact: true,
              weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
              weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
              weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'Aको h:mm बजे',
                LTS: 'Aको h:mm:ss बजे',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY, Aको h:mm बजे',
                LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे'
              },
              preparse: function preparse(string) {
                return string.replace(/[१२३४५६७८९०]/g, function (match) {
                  return numberMap[match];
                });
              },
              postformat: function postformat(string) {
                return string.replace(/\d/g, function (match) {
                  return symbolMap[match];
                });
              },
              meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'राति') {
                  return hour < 4 ? hour : hour + 12;
                } else if (meridiem === 'बिहान') {
                  return hour;
                } else if (meridiem === 'दिउँसो') {
                  return hour >= 10 ? hour : hour + 12;
                } else if (meridiem === 'साँझ') {
                  return hour + 12;
                }
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 3) {
                  return 'राति';
                } else if (hour < 12) {
                  return 'बिहान';
                } else if (hour < 16) {
                  return 'दिउँसो';
                } else if (hour < 20) {
                  return 'साँझ';
                } else {
                  return 'राति';
                }
              },
              calendar: {
                sameDay: '[आज] LT',
                nextDay: '[भोलि] LT',
                nextWeek: '[आउँदो] dddd[,] LT',
                lastDay: '[हिजो] LT',
                lastWeek: '[गएको] dddd[,] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%sमा',
                past: '%s अगाडि',
                s: 'केही क्षण',
                ss: '%d सेकेण्ड',
                m: 'एक मिनेट',
                mm: '%d मिनेट',
                h: 'एक घण्टा',
                hh: '%d घण्टा',
                d: 'एक दिन',
                dd: '%d दिन',
                M: 'एक महिना',
                MM: '%d महिना',
                y: 'एक बर्ष',
                yy: '%d बर्ष'
              },
              week: {
                dow: 0,
                // Sunday is the first day of the week.
                doy: 6 // The week that contains Jan 6th is the first week of the year.

              }
            });
            return ne;
          });
          /***/

        },

        /***/
        9814:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Dutch (Belgium) [nl-be]
          //! author : Joris Röling : https://github.com/jorisroling
          //! author : Jacob Middag : https://github.com/middagj
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
                monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
                monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i],
                monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
            var nlBe = moment.defineLocale('nl-be', {
              months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
              monthsShort: function monthsShort(m, format) {
                if (!m) {
                  return monthsShortWithDots;
                } else if (/-MMM-/.test(format)) {
                  return monthsShortWithoutDots[m.month()];
                } else {
                  return monthsShortWithDots[m.month()];
                }
              },
              monthsRegex: monthsRegex,
              monthsShortRegex: monthsRegex,
              monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
              monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
              monthsParse: monthsParse,
              longMonthsParse: monthsParse,
              shortMonthsParse: monthsParse,
              weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
              weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
              weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[vandaag om] LT',
                nextDay: '[morgen om] LT',
                nextWeek: 'dddd [om] LT',
                lastDay: '[gisteren om] LT',
                lastWeek: '[afgelopen] dddd [om] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'over %s',
                past: '%s geleden',
                s: 'een paar seconden',
                ss: '%d seconden',
                m: 'één minuut',
                mm: '%d minuten',
                h: 'één uur',
                hh: '%d uur',
                d: 'één dag',
                dd: '%d dagen',
                M: 'één maand',
                MM: '%d maanden',
                y: 'één jaar',
                yy: '%d jaar'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
              ordinal: function ordinal(number) {
                return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return nlBe;
          });
          /***/

        },

        /***/
        3901:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Dutch [nl]
          //! author : Joris Röling : https://github.com/jorisroling
          //! author : Jacob Middag : https://github.com/middagj
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
                monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
                monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i],
                monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
            var nl = moment.defineLocale('nl', {
              months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
              monthsShort: function monthsShort(m, format) {
                if (!m) {
                  return monthsShortWithDots;
                } else if (/-MMM-/.test(format)) {
                  return monthsShortWithoutDots[m.month()];
                } else {
                  return monthsShortWithDots[m.month()];
                }
              },
              monthsRegex: monthsRegex,
              monthsShortRegex: monthsRegex,
              monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
              monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
              monthsParse: monthsParse,
              longMonthsParse: monthsParse,
              shortMonthsParse: monthsParse,
              weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
              weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
              weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD-MM-YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[vandaag om] LT',
                nextDay: '[morgen om] LT',
                nextWeek: 'dddd [om] LT',
                lastDay: '[gisteren om] LT',
                lastWeek: '[afgelopen] dddd [om] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'over %s',
                past: '%s geleden',
                s: 'een paar seconden',
                ss: '%d seconden',
                m: 'één minuut',
                mm: '%d minuten',
                h: 'één uur',
                hh: '%d uur',
                d: 'één dag',
                dd: '%d dagen',
                w: 'één week',
                ww: '%d weken',
                M: 'één maand',
                MM: '%d maanden',
                y: 'één jaar',
                yy: '%d jaar'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
              ordinal: function ordinal(number) {
                return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return nl;
          });
          /***/

        },

        /***/
        3877:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Nynorsk [nn]
          //! authors : https://github.com/mechuwind
          //!           Stephen Ramthun : https://github.com/stephenramthun
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var nn = moment.defineLocale('nn', {
              months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
              monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
              monthsParseExact: true,
              weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
              weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
              weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D. MMMM YYYY',
                LLL: 'D. MMMM YYYY [kl.] H:mm',
                LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm'
              },
              calendar: {
                sameDay: '[I dag klokka] LT',
                nextDay: '[I morgon klokka] LT',
                nextWeek: 'dddd [klokka] LT',
                lastDay: '[I går klokka] LT',
                lastWeek: '[Føregåande] dddd [klokka] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'om %s',
                past: '%s sidan',
                s: 'nokre sekund',
                ss: '%d sekund',
                m: 'eit minutt',
                mm: '%d minutt',
                h: 'ein time',
                hh: '%d timar',
                d: 'ein dag',
                dd: '%d dagar',
                w: 'ei veke',
                ww: '%d veker',
                M: 'ein månad',
                MM: '%d månader',
                y: 'eit år',
                yy: '%d år'
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return nn;
          });
          /***/

        },

        /***/
        2135:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Occitan, lengadocian dialecte [oc-lnc]
          //! author : Quentin PAGÈS : https://github.com/Quenty31
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var ocLnc = moment.defineLocale('oc-lnc', {
              months: {
                standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split('_'),
                format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split('_'),
                isFormat: /D[oD]?(\s)+MMMM/
              },
              monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split('_'),
              monthsParseExact: true,
              weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split('_'),
              weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
              weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM [de] YYYY',
                ll: 'D MMM YYYY',
                LLL: 'D MMMM [de] YYYY [a] H:mm',
                lll: 'D MMM YYYY, H:mm',
                LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
                llll: 'ddd D MMM YYYY, H:mm'
              },
              calendar: {
                sameDay: '[uèi a] LT',
                nextDay: '[deman a] LT',
                nextWeek: 'dddd [a] LT',
                lastDay: '[ièr a] LT',
                lastWeek: 'dddd [passat a] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: "d'aquí %s",
                past: 'fa %s',
                s: 'unas segondas',
                ss: '%d segondas',
                m: 'una minuta',
                mm: '%d minutas',
                h: 'una ora',
                hh: '%d oras',
                d: 'un jorn',
                dd: '%d jorns',
                M: 'un mes',
                MM: '%d meses',
                y: 'un an',
                yy: '%d ans'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
              ordinal: function ordinal(number, period) {
                var output = number === 1 ? 'r' : number === 2 ? 'n' : number === 3 ? 'r' : number === 4 ? 't' : 'è';

                if (period === 'w' || period === 'W') {
                  output = 'a';
                }

                return number + output;
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4
              }
            });
            return ocLnc;
          });
          /***/

        },

        /***/
        5858:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Punjabi (India) [pa-in]
          //! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var symbolMap = {
              1: '੧',
              2: '੨',
              3: '੩',
              4: '੪',
              5: '੫',
              6: '੬',
              7: '੭',
              8: '੮',
              9: '੯',
              0: '੦'
            },
                numberMap = {
              '੧': '1',
              '੨': '2',
              '੩': '3',
              '੪': '4',
              '੫': '5',
              '੬': '6',
              '੭': '7',
              '੮': '8',
              '੯': '9',
              '੦': '0'
            };
            var paIn = moment.defineLocale('pa-in', {
              // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
              months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
              monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
              weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
              weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
              weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
              longDateFormat: {
                LT: 'A h:mm ਵਜੇ',
                LTS: 'A h:mm:ss ਵਜੇ',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
                LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
              },
              calendar: {
                sameDay: '[ਅਜ] LT',
                nextDay: '[ਕਲ] LT',
                nextWeek: '[ਅਗਲਾ] dddd, LT',
                lastDay: '[ਕਲ] LT',
                lastWeek: '[ਪਿਛਲੇ] dddd, LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s ਵਿੱਚ',
                past: '%s ਪਿਛਲੇ',
                s: 'ਕੁਝ ਸਕਿੰਟ',
                ss: '%d ਸਕਿੰਟ',
                m: 'ਇਕ ਮਿੰਟ',
                mm: '%d ਮਿੰਟ',
                h: 'ਇੱਕ ਘੰਟਾ',
                hh: '%d ਘੰਟੇ',
                d: 'ਇੱਕ ਦਿਨ',
                dd: '%d ਦਿਨ',
                M: 'ਇੱਕ ਮਹੀਨਾ',
                MM: '%d ਮਹੀਨੇ',
                y: 'ਇੱਕ ਸਾਲ',
                yy: '%d ਸਾਲ'
              },
              preparse: function preparse(string) {
                return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                  return numberMap[match];
                });
              },
              postformat: function postformat(string) {
                return string.replace(/\d/g, function (match) {
                  return symbolMap[match];
                });
              },
              // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
              // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
              meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'ਰਾਤ') {
                  return hour < 4 ? hour : hour + 12;
                } else if (meridiem === 'ਸਵੇਰ') {
                  return hour;
                } else if (meridiem === 'ਦੁਪਹਿਰ') {
                  return hour >= 10 ? hour : hour + 12;
                } else if (meridiem === 'ਸ਼ਾਮ') {
                  return hour + 12;
                }
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 4) {
                  return 'ਰਾਤ';
                } else if (hour < 10) {
                  return 'ਸਵੇਰ';
                } else if (hour < 17) {
                  return 'ਦੁਪਹਿਰ';
                } else if (hour < 20) {
                  return 'ਸ਼ਾਮ';
                } else {
                  return 'ਰਾਤ';
                }
              },
              week: {
                dow: 0,
                // Sunday is the first day of the week.
                doy: 6 // The week that contains Jan 6th is the first week of the year.

              }
            });
            return paIn;
          });
          /***/

        },

        /***/
        4495:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Polish [pl]
          //! author : Rafal Hirsz : https://github.com/evoL
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
                monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_'),
                monthsParse = [/^sty/i, /^lut/i, /^mar/i, /^kwi/i, /^maj/i, /^cze/i, /^lip/i, /^sie/i, /^wrz/i, /^paź/i, /^lis/i, /^gru/i];

            function plural(n) {
              return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
            }

            function translate(number, withoutSuffix, key) {
              var result = number + ' ';

              switch (key) {
                case 'ss':
                  return result + (plural(number) ? 'sekundy' : 'sekund');

                case 'm':
                  return withoutSuffix ? 'minuta' : 'minutę';

                case 'mm':
                  return result + (plural(number) ? 'minuty' : 'minut');

                case 'h':
                  return withoutSuffix ? 'godzina' : 'godzinę';

                case 'hh':
                  return result + (plural(number) ? 'godziny' : 'godzin');

                case 'ww':
                  return result + (plural(number) ? 'tygodnie' : 'tygodni');

                case 'MM':
                  return result + (plural(number) ? 'miesiące' : 'miesięcy');

                case 'yy':
                  return result + (plural(number) ? 'lata' : 'lat');
              }
            }

            var pl = moment.defineLocale('pl', {
              months: function months(momentToFormat, format) {
                if (!momentToFormat) {
                  return monthsNominative;
                } else if (/D MMMM/.test(format)) {
                  return monthsSubjective[momentToFormat.month()];
                } else {
                  return monthsNominative[momentToFormat.month()];
                }
              },
              monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
              monthsParse: monthsParse,
              longMonthsParse: monthsParse,
              shortMonthsParse: monthsParse,
              weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
              weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
              weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Dziś o] LT',
                nextDay: '[Jutro o] LT',
                nextWeek: function nextWeek() {
                  switch (this.day()) {
                    case 0:
                      return '[W niedzielę o] LT';

                    case 2:
                      return '[We wtorek o] LT';

                    case 3:
                      return '[W środę o] LT';

                    case 6:
                      return '[W sobotę o] LT';

                    default:
                      return '[W] dddd [o] LT';
                  }
                },
                lastDay: '[Wczoraj o] LT',
                lastWeek: function lastWeek() {
                  switch (this.day()) {
                    case 0:
                      return '[W zeszłą niedzielę o] LT';

                    case 3:
                      return '[W zeszłą środę o] LT';

                    case 6:
                      return '[W zeszłą sobotę o] LT';

                    default:
                      return '[W zeszły] dddd [o] LT';
                  }
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'za %s',
                past: '%s temu',
                s: 'kilka sekund',
                ss: translate,
                m: translate,
                mm: translate,
                h: translate,
                hh: translate,
                d: '1 dzień',
                dd: '%d dni',
                w: 'tydzień',
                ww: translate,
                M: 'miesiąc',
                MM: translate,
                y: 'rok',
                yy: translate
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return pl;
          });
          /***/

        },

        /***/
        7971:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Portuguese (Brazil) [pt-br]
          //! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var ptBr = moment.defineLocale('pt-br', {
              months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
              monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
              weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split('_'),
              weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
              weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D [de] MMMM [de] YYYY',
                LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
                LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
              },
              calendar: {
                sameDay: '[Hoje às] LT',
                nextDay: '[Amanhã às] LT',
                nextWeek: 'dddd [às] LT',
                lastDay: '[Ontem às] LT',
                lastWeek: function lastWeek() {
                  return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' // Saturday + Sunday
                  : '[Última] dddd [às] LT'; // Monday - Friday
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'em %s',
                past: 'há %s',
                s: 'poucos segundos',
                ss: '%d segundos',
                m: 'um minuto',
                mm: '%d minutos',
                h: 'uma hora',
                hh: '%d horas',
                d: 'um dia',
                dd: '%d dias',
                M: 'um mês',
                MM: '%d meses',
                y: 'um ano',
                yy: '%d anos'
              },
              dayOfMonthOrdinalParse: /\d{1,2}º/,
              ordinal: '%dº',
              invalidDate: 'Data inválida'
            });
            return ptBr;
          });
          /***/

        },

        /***/
        9520:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Portuguese [pt]
          //! author : Jefferson : https://github.com/jalex79
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var pt = moment.defineLocale('pt', {
              months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
              monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
              weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
              weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
              weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D [de] MMMM [de] YYYY',
                LLL: 'D [de] MMMM [de] YYYY HH:mm',
                LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Hoje às] LT',
                nextDay: '[Amanhã às] LT',
                nextWeek: 'dddd [às] LT',
                lastDay: '[Ontem às] LT',
                lastWeek: function lastWeek() {
                  return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' // Saturday + Sunday
                  : '[Última] dddd [às] LT'; // Monday - Friday
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'em %s',
                past: 'há %s',
                s: 'segundos',
                ss: '%d segundos',
                m: 'um minuto',
                mm: '%d minutos',
                h: 'uma hora',
                hh: '%d horas',
                d: 'um dia',
                dd: '%d dias',
                w: 'uma semana',
                ww: '%d semanas',
                M: 'um mês',
                MM: '%d meses',
                y: 'um ano',
                yy: '%d anos'
              },
              dayOfMonthOrdinalParse: /\d{1,2}º/,
              ordinal: '%dº',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return pt;
          });
          /***/

        },

        /***/
        6459:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Romanian [ro]
          //! author : Vlad Gurdiga : https://github.com/gurdiga
          //! author : Valentin Agachi : https://github.com/avaly
          //! author : Emanuel Cepoi : https://github.com/cepem
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            function relativeTimeWithPlural(number, withoutSuffix, key) {
              var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani'
              },
                  separator = ' ';

              if (number % 100 >= 20 || number >= 100 && number % 100 === 0) {
                separator = ' de ';
              }

              return number + separator + format[key];
            }

            var ro = moment.defineLocale('ro', {
              months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
              monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
              monthsParseExact: true,
              weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
              weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
              weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY H:mm',
                LLLL: 'dddd, D MMMM YYYY H:mm'
              },
              calendar: {
                sameDay: '[azi la] LT',
                nextDay: '[mâine la] LT',
                nextWeek: 'dddd [la] LT',
                lastDay: '[ieri la] LT',
                lastWeek: '[fosta] dddd [la] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'peste %s',
                past: '%s în urmă',
                s: 'câteva secunde',
                ss: relativeTimeWithPlural,
                m: 'un minut',
                mm: relativeTimeWithPlural,
                h: 'o oră',
                hh: relativeTimeWithPlural,
                d: 'o zi',
                dd: relativeTimeWithPlural,
                w: 'o săptămână',
                ww: relativeTimeWithPlural,
                M: 'o lună',
                MM: relativeTimeWithPlural,
                y: 'un an',
                yy: relativeTimeWithPlural
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return ro;
          });
          /***/

        },

        /***/
        1793:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Russian [ru]
          //! author : Viktorminator : https://github.com/Viktorminator
          //! author : Menelion Elensúle : https://github.com/Oire
          //! author : Коренберг Марк : https://github.com/socketpair
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            function plural(word, num) {
              var forms = word.split('_');
              return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
            }

            function relativeTimeWithPlural(number, withoutSuffix, key) {
              var format = {
                ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
                mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
                hh: 'час_часа_часов',
                dd: 'день_дня_дней',
                ww: 'неделя_недели_недель',
                MM: 'месяц_месяца_месяцев',
                yy: 'год_года_лет'
              };

              if (key === 'm') {
                return withoutSuffix ? 'минута' : 'минуту';
              } else {
                return number + ' ' + plural(format[key], +number);
              }
            }

            var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i]; // http://new.gramota.ru/spravka/rules/139-prop : § 103
            // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
            // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753

            var ru = moment.defineLocale('ru', {
              months: {
                format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
                standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
              },
              monthsShort: {
                // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
                format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
                standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
              },
              weekdays: {
                standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
                format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
                isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/
              },
              weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
              weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
              monthsParse: monthsParse,
              longMonthsParse: monthsParse,
              shortMonthsParse: monthsParse,
              // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
              monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
              // копия предыдущего
              monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
              // полные названия с падежами
              monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
              // Выражение, которое соответствует только сокращённым формам
              monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D MMMM YYYY г.',
                LLL: 'D MMMM YYYY г., H:mm',
                LLLL: 'dddd, D MMMM YYYY г., H:mm'
              },
              calendar: {
                sameDay: '[Сегодня, в] LT',
                nextDay: '[Завтра, в] LT',
                lastDay: '[Вчера, в] LT',
                nextWeek: function nextWeek(now) {
                  if (now.week() !== this.week()) {
                    switch (this.day()) {
                      case 0:
                        return '[В следующее] dddd, [в] LT';

                      case 1:
                      case 2:
                      case 4:
                        return '[В следующий] dddd, [в] LT';

                      case 3:
                      case 5:
                      case 6:
                        return '[В следующую] dddd, [в] LT';
                    }
                  } else {
                    if (this.day() === 2) {
                      return '[Во] dddd, [в] LT';
                    } else {
                      return '[В] dddd, [в] LT';
                    }
                  }
                },
                lastWeek: function lastWeek(now) {
                  if (now.week() !== this.week()) {
                    switch (this.day()) {
                      case 0:
                        return '[В прошлое] dddd, [в] LT';

                      case 1:
                      case 2:
                      case 4:
                        return '[В прошлый] dddd, [в] LT';

                      case 3:
                      case 5:
                      case 6:
                        return '[В прошлую] dddd, [в] LT';
                    }
                  } else {
                    if (this.day() === 2) {
                      return '[Во] dddd, [в] LT';
                    } else {
                      return '[В] dddd, [в] LT';
                    }
                  }
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'через %s',
                past: '%s назад',
                s: 'несколько секунд',
                ss: relativeTimeWithPlural,
                m: relativeTimeWithPlural,
                mm: relativeTimeWithPlural,
                h: 'час',
                hh: relativeTimeWithPlural,
                d: 'день',
                dd: relativeTimeWithPlural,
                w: 'неделя',
                ww: relativeTimeWithPlural,
                M: 'месяц',
                MM: relativeTimeWithPlural,
                y: 'год',
                yy: relativeTimeWithPlural
              },
              meridiemParse: /ночи|утра|дня|вечера/i,
              isPM: function isPM(input) {
                return /^(дня|вечера)$/.test(input);
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 4) {
                  return 'ночи';
                } else if (hour < 12) {
                  return 'утра';
                } else if (hour < 17) {
                  return 'дня';
                } else {
                  return 'вечера';
                }
              },
              dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
              ordinal: function ordinal(number, period) {
                switch (period) {
                  case 'M':
                  case 'd':
                  case 'DDD':
                    return number + '-й';

                  case 'D':
                    return number + '-го';

                  case 'w':
                  case 'W':
                    return number + '-я';

                  default:
                    return number;
                }
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return ru;
          });
          /***/

        },

        /***/
        950:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Sindhi [sd]
          //! author : Narain Sagar : https://github.com/narainsagar
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var months = ['جنوري', 'فيبروري', 'مارچ', 'اپريل', 'مئي', 'جون', 'جولاءِ', 'آگسٽ', 'سيپٽمبر', 'آڪٽوبر', 'نومبر', 'ڊسمبر'],
                days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
            var sd = moment.defineLocale('sd', {
              months: months,
              monthsShort: months,
              weekdays: days,
              weekdaysShort: days,
              weekdaysMin: days,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd، D MMMM YYYY HH:mm'
              },
              meridiemParse: /صبح|شام/,
              isPM: function isPM(input) {
                return 'شام' === input;
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 12) {
                  return 'صبح';
                }

                return 'شام';
              },
              calendar: {
                sameDay: '[اڄ] LT',
                nextDay: '[سڀاڻي] LT',
                nextWeek: 'dddd [اڳين هفتي تي] LT',
                lastDay: '[ڪالهه] LT',
                lastWeek: '[گزريل هفتي] dddd [تي] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s پوء',
                past: '%s اڳ',
                s: 'چند سيڪنڊ',
                ss: '%d سيڪنڊ',
                m: 'هڪ منٽ',
                mm: '%d منٽ',
                h: 'هڪ ڪلاڪ',
                hh: '%d ڪلاڪ',
                d: 'هڪ ڏينهن',
                dd: '%d ڏينهن',
                M: 'هڪ مهينو',
                MM: '%d مهينا',
                y: 'هڪ سال',
                yy: '%d سال'
              },
              preparse: function preparse(string) {
                return string.replace(/،/g, ',');
              },
              postformat: function postformat(string) {
                return string.replace(/,/g, '،');
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return sd;
          });
          /***/

        },

        /***/
        490:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Northern Sami [se]
          //! authors : Bård Rolstad Henriksen : https://github.com/karamell
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var se = moment.defineLocale('se', {
              months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
              monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
              weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
              weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
              weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'MMMM D. [b.] YYYY',
                LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
                LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
              },
              calendar: {
                sameDay: '[otne ti] LT',
                nextDay: '[ihttin ti] LT',
                nextWeek: 'dddd [ti] LT',
                lastDay: '[ikte ti] LT',
                lastWeek: '[ovddit] dddd [ti] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s geažes',
                past: 'maŋit %s',
                s: 'moadde sekunddat',
                ss: '%d sekunddat',
                m: 'okta minuhta',
                mm: '%d minuhtat',
                h: 'okta diimmu',
                hh: '%d diimmut',
                d: 'okta beaivi',
                dd: '%d beaivvit',
                M: 'okta mánnu',
                MM: '%d mánut',
                y: 'okta jahki',
                yy: '%d jagit'
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return se;
          });
          /***/

        },

        /***/
        124:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Sinhalese [si]
          //! author : Sampath Sitinamaluwa : https://github.com/sampathsris
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            /*jshint -W100*/

            var si = moment.defineLocale('si', {
              months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
              monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
              weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
              weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
              weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'a h:mm',
                LTS: 'a h:mm:ss',
                L: 'YYYY/MM/DD',
                LL: 'YYYY MMMM D',
                LLL: 'YYYY MMMM D, a h:mm',
                LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
              },
              calendar: {
                sameDay: '[අද] LT[ට]',
                nextDay: '[හෙට] LT[ට]',
                nextWeek: 'dddd LT[ට]',
                lastDay: '[ඊයේ] LT[ට]',
                lastWeek: '[පසුගිය] dddd LT[ට]',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%sකින්',
                past: '%sකට පෙර',
                s: 'තත්පර කිහිපය',
                ss: 'තත්පර %d',
                m: 'මිනිත්තුව',
                mm: 'මිනිත්තු %d',
                h: 'පැය',
                hh: 'පැය %d',
                d: 'දිනය',
                dd: 'දින %d',
                M: 'මාසය',
                MM: 'මාස %d',
                y: 'වසර',
                yy: 'වසර %d'
              },
              dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
              ordinal: function ordinal(number) {
                return number + ' වැනි';
              },
              meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
              isPM: function isPM(input) {
                return input === 'ප.ව.' || input === 'පස් වරු';
              },
              meridiem: function meridiem(hours, minutes, isLower) {
                if (hours > 11) {
                  return isLower ? 'ප.ව.' : 'පස් වරු';
                } else {
                  return isLower ? 'පෙ.ව.' : 'පෙර වරු';
                }
              }
            });
            return si;
          });
          /***/

        },

        /***/
        4249:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Slovak [sk]
          //! author : Martin Minka : https://github.com/k2s
          //! based on work of petrbela : https://github.com/petrbela
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
                monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');

            function plural(n) {
              return n > 1 && n < 5;
            }

            function translate(number, withoutSuffix, key, isFuture) {
              var result = number + ' ';

              switch (key) {
                case 's':
                  // a few seconds / in a few seconds / a few seconds ago
                  return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';

                case 'ss':
                  // 9 seconds / in 9 seconds / 9 seconds ago
                  if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                  } else {
                    return result + 'sekundami';
                  }

                case 'm':
                  // a minute / in a minute / a minute ago
                  return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';

                case 'mm':
                  // 9 minutes / in 9 minutes / 9 minutes ago
                  if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                  } else {
                    return result + 'minútami';
                  }

                case 'h':
                  // an hour / in an hour / an hour ago
                  return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';

                case 'hh':
                  // 9 hours / in 9 hours / 9 hours ago
                  if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                  } else {
                    return result + 'hodinami';
                  }

                case 'd':
                  // a day / in a day / a day ago
                  return withoutSuffix || isFuture ? 'deň' : 'dňom';

                case 'dd':
                  // 9 days / in 9 days / 9 days ago
                  if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                  } else {
                    return result + 'dňami';
                  }

                case 'M':
                  // a month / in a month / a month ago
                  return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';

                case 'MM':
                  // 9 months / in 9 months / 9 months ago
                  if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                  } else {
                    return result + 'mesiacmi';
                  }

                case 'y':
                  // a year / in a year / a year ago
                  return withoutSuffix || isFuture ? 'rok' : 'rokom';

                case 'yy':
                  // 9 years / in 9 years / 9 years ago
                  if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                  } else {
                    return result + 'rokmi';
                  }

              }
            }

            var sk = moment.defineLocale('sk', {
              months: months,
              monthsShort: monthsShort,
              weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
              weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
              weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D. MMMM YYYY',
                LLL: 'D. MMMM YYYY H:mm',
                LLLL: 'dddd D. MMMM YYYY H:mm'
              },
              calendar: {
                sameDay: '[dnes o] LT',
                nextDay: '[zajtra o] LT',
                nextWeek: function nextWeek() {
                  switch (this.day()) {
                    case 0:
                      return '[v nedeľu o] LT';

                    case 1:
                    case 2:
                      return '[v] dddd [o] LT';

                    case 3:
                      return '[v stredu o] LT';

                    case 4:
                      return '[vo štvrtok o] LT';

                    case 5:
                      return '[v piatok o] LT';

                    case 6:
                      return '[v sobotu o] LT';
                  }
                },
                lastDay: '[včera o] LT',
                lastWeek: function lastWeek() {
                  switch (this.day()) {
                    case 0:
                      return '[minulú nedeľu o] LT';

                    case 1:
                    case 2:
                      return '[minulý] dddd [o] LT';

                    case 3:
                      return '[minulú stredu o] LT';

                    case 4:
                    case 5:
                      return '[minulý] dddd [o] LT';

                    case 6:
                      return '[minulú sobotu o] LT';
                  }
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'za %s',
                past: 'pred %s',
                s: translate,
                ss: translate,
                m: translate,
                mm: translate,
                h: translate,
                hh: translate,
                d: translate,
                dd: translate,
                M: translate,
                MM: translate,
                y: translate,
                yy: translate
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return sk;
          });
          /***/

        },

        /***/
        4985:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Slovenian [sl]
          //! author : Robert Sedovšek : https://github.com/sedovsek
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            function processRelativeTime(number, withoutSuffix, key, isFuture) {
              var result = number + ' ';

              switch (key) {
                case 's':
                  return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';

                case 'ss':
                  if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                  } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                  } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                  } else {
                    result += 'sekund';
                  }

                  return result;

                case 'm':
                  return withoutSuffix ? 'ena minuta' : 'eno minuto';

                case 'mm':
                  if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                  } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                  } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                  } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                  }

                  return result;

                case 'h':
                  return withoutSuffix ? 'ena ura' : 'eno uro';

                case 'hh':
                  if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                  } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                  } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                  } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                  }

                  return result;

                case 'd':
                  return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';

                case 'dd':
                  if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                  } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                  } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                  }

                  return result;

                case 'M':
                  return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';

                case 'MM':
                  if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                  } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                  } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                  } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                  }

                  return result;

                case 'y':
                  return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';

                case 'yy':
                  if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                  } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                  } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                  } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                  }

                  return result;
              }
            }

            var sl = moment.defineLocale('sl', {
              months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
              monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
              monthsParseExact: true,
              weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
              weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
              weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'DD. MM. YYYY',
                LL: 'D. MMMM YYYY',
                LLL: 'D. MMMM YYYY H:mm',
                LLLL: 'dddd, D. MMMM YYYY H:mm'
              },
              calendar: {
                sameDay: '[danes ob] LT',
                nextDay: '[jutri ob] LT',
                nextWeek: function nextWeek() {
                  switch (this.day()) {
                    case 0:
                      return '[v] [nedeljo] [ob] LT';

                    case 3:
                      return '[v] [sredo] [ob] LT';

                    case 6:
                      return '[v] [soboto] [ob] LT';

                    case 1:
                    case 2:
                    case 4:
                    case 5:
                      return '[v] dddd [ob] LT';
                  }
                },
                lastDay: '[včeraj ob] LT',
                lastWeek: function lastWeek() {
                  switch (this.day()) {
                    case 0:
                      return '[prejšnjo] [nedeljo] [ob] LT';

                    case 3:
                      return '[prejšnjo] [sredo] [ob] LT';

                    case 6:
                      return '[prejšnjo] [soboto] [ob] LT';

                    case 1:
                    case 2:
                    case 4:
                    case 5:
                      return '[prejšnji] dddd [ob] LT';
                  }
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'čez %s',
                past: 'pred %s',
                s: processRelativeTime,
                ss: processRelativeTime,
                m: processRelativeTime,
                mm: processRelativeTime,
                h: processRelativeTime,
                hh: processRelativeTime,
                d: processRelativeTime,
                dd: processRelativeTime,
                M: processRelativeTime,
                MM: processRelativeTime,
                y: processRelativeTime,
                yy: processRelativeTime
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return sl;
          });
          /***/

        },

        /***/
        1104:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Albanian [sq]
          //! author : Flakërim Ismani : https://github.com/flakerimi
          //! author : Menelion Elensúle : https://github.com/Oire
          //! author : Oerd Cukalla : https://github.com/oerd
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var sq = moment.defineLocale('sq', {
              months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
              monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
              weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
              weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
              weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
              weekdaysParseExact: true,
              meridiemParse: /PD|MD/,
              isPM: function isPM(input) {
                return input.charAt(0) === 'M';
              },
              meridiem: function meridiem(hours, minutes, isLower) {
                return hours < 12 ? 'PD' : 'MD';
              },
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Sot në] LT',
                nextDay: '[Nesër në] LT',
                nextWeek: 'dddd [në] LT',
                lastDay: '[Dje në] LT',
                lastWeek: 'dddd [e kaluar në] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'në %s',
                past: '%s më parë',
                s: 'disa sekonda',
                ss: '%d sekonda',
                m: 'një minutë',
                mm: '%d minuta',
                h: 'një orë',
                hh: '%d orë',
                d: 'një ditë',
                dd: '%d ditë',
                M: 'një muaj',
                MM: '%d muaj',
                y: 'një vit',
                yy: '%d vite'
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return sq;
          });
          /***/

        },

        /***/
        9915:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Serbian Cyrillic [sr-cyrl]
          //! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
          //! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var translator = {
              words: {
                //Different grammatical cases
                ss: ['секунда', 'секунде', 'секунди'],
                m: ['један минут', 'једне минуте'],
                mm: ['минут', 'минуте', 'минута'],
                h: ['један сат', 'једног сата'],
                hh: ['сат', 'сата', 'сати'],
                dd: ['дан', 'дана', 'дана'],
                MM: ['месец', 'месеца', 'месеци'],
                yy: ['година', 'године', 'година']
              },
              correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
                return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
              },
              translate: function translate(number, withoutSuffix, key) {
                var wordKey = translator.words[key];

                if (key.length === 1) {
                  return withoutSuffix ? wordKey[0] : wordKey[1];
                } else {
                  return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
                }
              }
            };
            var srCyrl = moment.defineLocale('sr-cyrl', {
              months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
              monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
              monthsParseExact: true,
              weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
              weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
              weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'D. M. YYYY.',
                LL: 'D. MMMM YYYY.',
                LLL: 'D. MMMM YYYY. H:mm',
                LLLL: 'dddd, D. MMMM YYYY. H:mm'
              },
              calendar: {
                sameDay: '[данас у] LT',
                nextDay: '[сутра у] LT',
                nextWeek: function nextWeek() {
                  switch (this.day()) {
                    case 0:
                      return '[у] [недељу] [у] LT';

                    case 3:
                      return '[у] [среду] [у] LT';

                    case 6:
                      return '[у] [суботу] [у] LT';

                    case 1:
                    case 2:
                    case 4:
                    case 5:
                      return '[у] dddd [у] LT';
                  }
                },
                lastDay: '[јуче у] LT',
                lastWeek: function lastWeek() {
                  var lastWeekDays = ['[прошле] [недеље] [у] LT', '[прошлог] [понедељка] [у] LT', '[прошлог] [уторка] [у] LT', '[прошле] [среде] [у] LT', '[прошлог] [четвртка] [у] LT', '[прошлог] [петка] [у] LT', '[прошле] [суботе] [у] LT'];
                  return lastWeekDays[this.day()];
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'за %s',
                past: 'пре %s',
                s: 'неколико секунди',
                ss: translator.translate,
                m: translator.translate,
                mm: translator.translate,
                h: translator.translate,
                hh: translator.translate,
                d: 'дан',
                dd: translator.translate,
                M: 'месец',
                MM: translator.translate,
                y: 'годину',
                yy: translator.translate
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 1st is the first week of the year.

              }
            });
            return srCyrl;
          });
          /***/

        },

        /***/
        9131:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Serbian [sr]
          //! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
          //! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var translator = {
              words: {
                //Different grammatical cases
                ss: ['sekunda', 'sekunde', 'sekundi'],
                m: ['jedan minut', 'jedne minute'],
                mm: ['minut', 'minute', 'minuta'],
                h: ['jedan sat', 'jednog sata'],
                hh: ['sat', 'sata', 'sati'],
                dd: ['dan', 'dana', 'dana'],
                MM: ['mesec', 'meseca', 'meseci'],
                yy: ['godina', 'godine', 'godina']
              },
              correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
                return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
              },
              translate: function translate(number, withoutSuffix, key) {
                var wordKey = translator.words[key];

                if (key.length === 1) {
                  return withoutSuffix ? wordKey[0] : wordKey[1];
                } else {
                  return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
                }
              }
            };
            var sr = moment.defineLocale('sr', {
              months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
              monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
              monthsParseExact: true,
              weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
              weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
              weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'D. M. YYYY.',
                LL: 'D. MMMM YYYY.',
                LLL: 'D. MMMM YYYY. H:mm',
                LLLL: 'dddd, D. MMMM YYYY. H:mm'
              },
              calendar: {
                sameDay: '[danas u] LT',
                nextDay: '[sutra u] LT',
                nextWeek: function nextWeek() {
                  switch (this.day()) {
                    case 0:
                      return '[u] [nedelju] [u] LT';

                    case 3:
                      return '[u] [sredu] [u] LT';

                    case 6:
                      return '[u] [subotu] [u] LT';

                    case 1:
                    case 2:
                    case 4:
                    case 5:
                      return '[u] dddd [u] LT';
                  }
                },
                lastDay: '[juče u] LT',
                lastWeek: function lastWeek() {
                  var lastWeekDays = ['[prošle] [nedelje] [u] LT', '[prošlog] [ponedeljka] [u] LT', '[prošlog] [utorka] [u] LT', '[prošle] [srede] [u] LT', '[prošlog] [četvrtka] [u] LT', '[prošlog] [petka] [u] LT', '[prošle] [subote] [u] LT'];
                  return lastWeekDays[this.day()];
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'za %s',
                past: 'pre %s',
                s: 'nekoliko sekundi',
                ss: translator.translate,
                m: translator.translate,
                mm: translator.translate,
                h: translator.translate,
                hh: translator.translate,
                d: 'dan',
                dd: translator.translate,
                M: 'mesec',
                MM: translator.translate,
                y: 'godinu',
                yy: translator.translate
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return sr;
          });
          /***/

        },

        /***/
        5893:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : siSwati [ss]
          //! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var ss = moment.defineLocale('ss', {
              months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
              monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
              weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
              weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
              weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'h:mm A',
                LTS: 'h:mm:ss A',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY h:mm A',
                LLLL: 'dddd, D MMMM YYYY h:mm A'
              },
              calendar: {
                sameDay: '[Namuhla nga] LT',
                nextDay: '[Kusasa nga] LT',
                nextWeek: 'dddd [nga] LT',
                lastDay: '[Itolo nga] LT',
                lastWeek: 'dddd [leliphelile] [nga] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'nga %s',
                past: 'wenteka nga %s',
                s: 'emizuzwana lomcane',
                ss: '%d mzuzwana',
                m: 'umzuzu',
                mm: '%d emizuzu',
                h: 'lihora',
                hh: '%d emahora',
                d: 'lilanga',
                dd: '%d emalanga',
                M: 'inyanga',
                MM: '%d tinyanga',
                y: 'umnyaka',
                yy: '%d iminyaka'
              },
              meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
              meridiem: function meridiem(hours, minutes, isLower) {
                if (hours < 11) {
                  return 'ekuseni';
                } else if (hours < 15) {
                  return 'emini';
                } else if (hours < 19) {
                  return 'entsambama';
                } else {
                  return 'ebusuku';
                }
              },
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'ekuseni') {
                  return hour;
                } else if (meridiem === 'emini') {
                  return hour >= 11 ? hour : hour + 12;
                } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                  if (hour === 0) {
                    return 0;
                  }

                  return hour + 12;
                }
              },
              dayOfMonthOrdinalParse: /\d{1,2}/,
              ordinal: '%d',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return ss;
          });
          /***/

        },

        /***/
        8760:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Swedish [sv]
          //! author : Jens Alm : https://github.com/ulmus
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var sv = moment.defineLocale('sv', {
              months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
              monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
              weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
              weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
              weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'YYYY-MM-DD',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY [kl.] HH:mm',
                LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
                lll: 'D MMM YYYY HH:mm',
                llll: 'ddd D MMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Idag] LT',
                nextDay: '[Imorgon] LT',
                lastDay: '[Igår] LT',
                nextWeek: '[På] dddd LT',
                lastWeek: '[I] dddd[s] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'om %s',
                past: 'för %s sedan',
                s: 'några sekunder',
                ss: '%d sekunder',
                m: 'en minut',
                mm: '%d minuter',
                h: 'en timme',
                hh: '%d timmar',
                d: 'en dag',
                dd: '%d dagar',
                M: 'en månad',
                MM: '%d månader',
                y: 'ett år',
                yy: '%d år'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
              ordinal: function ordinal(number) {
                var b = number % 10,
                    output = ~~(number % 100 / 10) === 1 ? ':e' : b === 1 ? ':a' : b === 2 ? ':a' : b === 3 ? ':e' : ':e';
                return number + output;
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return sv;
          });
          /***/

        },

        /***/
        1172:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Swahili [sw]
          //! author : Fahad Kassim : https://github.com/fadsel
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var sw = moment.defineLocale('sw', {
              months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
              monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
              weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
              weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
              weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'hh:mm A',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[leo saa] LT',
                nextDay: '[kesho saa] LT',
                nextWeek: '[wiki ijayo] dddd [saat] LT',
                lastDay: '[jana] LT',
                lastWeek: '[wiki iliyopita] dddd [saat] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s baadaye',
                past: 'tokea %s',
                s: 'hivi punde',
                ss: 'sekunde %d',
                m: 'dakika moja',
                mm: 'dakika %d',
                h: 'saa limoja',
                hh: 'masaa %d',
                d: 'siku moja',
                dd: 'siku %d',
                M: 'mwezi mmoja',
                MM: 'miezi %d',
                y: 'mwaka mmoja',
                yy: 'miaka %d'
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return sw;
          });
          /***/

        },

        /***/
        7333:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Tamil [ta]
          //! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var symbolMap = {
              1: '௧',
              2: '௨',
              3: '௩',
              4: '௪',
              5: '௫',
              6: '௬',
              7: '௭',
              8: '௮',
              9: '௯',
              0: '௦'
            },
                numberMap = {
              '௧': '1',
              '௨': '2',
              '௩': '3',
              '௪': '4',
              '௫': '5',
              '௬': '6',
              '௭': '7',
              '௮': '8',
              '௯': '9',
              '௦': '0'
            };
            var ta = moment.defineLocale('ta', {
              months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
              monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
              weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
              weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
              weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY, HH:mm',
                LLLL: 'dddd, D MMMM YYYY, HH:mm'
              },
              calendar: {
                sameDay: '[இன்று] LT',
                nextDay: '[நாளை] LT',
                nextWeek: 'dddd, LT',
                lastDay: '[நேற்று] LT',
                lastWeek: '[கடந்த வாரம்] dddd, LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s இல்',
                past: '%s முன்',
                s: 'ஒரு சில விநாடிகள்',
                ss: '%d விநாடிகள்',
                m: 'ஒரு நிமிடம்',
                mm: '%d நிமிடங்கள்',
                h: 'ஒரு மணி நேரம்',
                hh: '%d மணி நேரம்',
                d: 'ஒரு நாள்',
                dd: '%d நாட்கள்',
                M: 'ஒரு மாதம்',
                MM: '%d மாதங்கள்',
                y: 'ஒரு வருடம்',
                yy: '%d ஆண்டுகள்'
              },
              dayOfMonthOrdinalParse: /\d{1,2}வது/,
              ordinal: function ordinal(number) {
                return number + 'வது';
              },
              preparse: function preparse(string) {
                return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                  return numberMap[match];
                });
              },
              postformat: function postformat(string) {
                return string.replace(/\d/g, function (match) {
                  return symbolMap[match];
                });
              },
              // refer http://ta.wikipedia.org/s/1er1
              meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 2) {
                  return ' யாமம்';
                } else if (hour < 6) {
                  return ' வைகறை'; // வைகறை
                } else if (hour < 10) {
                  return ' காலை'; // காலை
                } else if (hour < 14) {
                  return ' நண்பகல்'; // நண்பகல்
                } else if (hour < 18) {
                  return ' எற்பாடு'; // எற்பாடு
                } else if (hour < 22) {
                  return ' மாலை'; // மாலை
                } else {
                  return ' யாமம்';
                }
              },
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'யாமம்') {
                  return hour < 2 ? hour : hour + 12;
                } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                  return hour;
                } else if (meridiem === 'நண்பகல்') {
                  return hour >= 10 ? hour : hour + 12;
                } else {
                  return hour + 12;
                }
              },
              week: {
                dow: 0,
                // Sunday is the first day of the week.
                doy: 6 // The week that contains Jan 6th is the first week of the year.

              }
            });
            return ta;
          });
          /***/

        },

        /***/
        3110:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Telugu [te]
          //! author : Krishna Chaitanya Thota : https://github.com/kcthota
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var te = moment.defineLocale('te', {
              months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
              monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
              monthsParseExact: true,
              weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
              weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
              weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
              longDateFormat: {
                LT: 'A h:mm',
                LTS: 'A h:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY, A h:mm',
                LLLL: 'dddd, D MMMM YYYY, A h:mm'
              },
              calendar: {
                sameDay: '[నేడు] LT',
                nextDay: '[రేపు] LT',
                nextWeek: 'dddd, LT',
                lastDay: '[నిన్న] LT',
                lastWeek: '[గత] dddd, LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s లో',
                past: '%s క్రితం',
                s: 'కొన్ని క్షణాలు',
                ss: '%d సెకన్లు',
                m: 'ఒక నిమిషం',
                mm: '%d నిమిషాలు',
                h: 'ఒక గంట',
                hh: '%d గంటలు',
                d: 'ఒక రోజు',
                dd: '%d రోజులు',
                M: 'ఒక నెల',
                MM: '%d నెలలు',
                y: 'ఒక సంవత్సరం',
                yy: '%d సంవత్సరాలు'
              },
              dayOfMonthOrdinalParse: /\d{1,2}వ/,
              ordinal: '%dవ',
              meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'రాత్రి') {
                  return hour < 4 ? hour : hour + 12;
                } else if (meridiem === 'ఉదయం') {
                  return hour;
                } else if (meridiem === 'మధ్యాహ్నం') {
                  return hour >= 10 ? hour : hour + 12;
                } else if (meridiem === 'సాయంత్రం') {
                  return hour + 12;
                }
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 4) {
                  return 'రాత్రి';
                } else if (hour < 10) {
                  return 'ఉదయం';
                } else if (hour < 17) {
                  return 'మధ్యాహ్నం';
                } else if (hour < 20) {
                  return 'సాయంత్రం';
                } else {
                  return 'రాత్రి';
                }
              },
              week: {
                dow: 0,
                // Sunday is the first day of the week.
                doy: 6 // The week that contains Jan 6th is the first week of the year.

              }
            });
            return te;
          });
          /***/

        },

        /***/
        2095:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Tetun Dili (East Timor) [tet]
          //! author : Joshua Brooks : https://github.com/joshbrooks
          //! author : Onorio De J. Afonso : https://github.com/marobo
          //! author : Sonia Simoes : https://github.com/soniasimoes
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var tet = moment.defineLocale('tet', {
              months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
              monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
              weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
              weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
              weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Ohin iha] LT',
                nextDay: '[Aban iha] LT',
                nextWeek: 'dddd [iha] LT',
                lastDay: '[Horiseik iha] LT',
                lastWeek: 'dddd [semana kotuk] [iha] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'iha %s',
                past: '%s liuba',
                s: 'segundu balun',
                ss: 'segundu %d',
                m: 'minutu ida',
                mm: 'minutu %d',
                h: 'oras ida',
                hh: 'oras %d',
                d: 'loron ida',
                dd: 'loron %d',
                M: 'fulan ida',
                MM: 'fulan %d',
                y: 'tinan ida',
                yy: 'tinan %d'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
              ordinal: function ordinal(number) {
                var b = number % 10,
                    output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
                return number + output;
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return tet;
          });
          /***/

        },

        /***/
        7321:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Tajik [tg]
          //! author : Orif N. Jr. : https://github.com/orif-jr
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var suffixes = {
              0: '-ум',
              1: '-ум',
              2: '-юм',
              3: '-юм',
              4: '-ум',
              5: '-ум',
              6: '-ум',
              7: '-ум',
              8: '-ум',
              9: '-ум',
              10: '-ум',
              12: '-ум',
              13: '-ум',
              20: '-ум',
              30: '-юм',
              40: '-ум',
              50: '-ум',
              60: '-ум',
              70: '-ум',
              80: '-ум',
              90: '-ум',
              100: '-ум'
            };
            var tg = moment.defineLocale('tg', {
              months: {
                format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split('_'),
                standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_')
              },
              monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
              weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
              weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
              weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Имрӯз соати] LT',
                nextDay: '[Фардо соати] LT',
                lastDay: '[Дирӯз соати] LT',
                nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
                lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'баъди %s',
                past: '%s пеш',
                s: 'якчанд сония',
                m: 'як дақиқа',
                mm: '%d дақиқа',
                h: 'як соат',
                hh: '%d соат',
                d: 'як рӯз',
                dd: '%d рӯз',
                M: 'як моҳ',
                MM: '%d моҳ',
                y: 'як сол',
                yy: '%d сол'
              },
              meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'шаб') {
                  return hour < 4 ? hour : hour + 12;
                } else if (meridiem === 'субҳ') {
                  return hour;
                } else if (meridiem === 'рӯз') {
                  return hour >= 11 ? hour : hour + 12;
                } else if (meridiem === 'бегоҳ') {
                  return hour + 12;
                }
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 4) {
                  return 'шаб';
                } else if (hour < 11) {
                  return 'субҳ';
                } else if (hour < 16) {
                  return 'рӯз';
                } else if (hour < 19) {
                  return 'бегоҳ';
                } else {
                  return 'шаб';
                }
              },
              dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
              ordinal: function ordinal(number) {
                var a = number % 10,
                    b = number >= 100 ? 100 : null;
                return number + (suffixes[number] || suffixes[a] || suffixes[b]);
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 1th is the first week of the year.

              }
            });
            return tg;
          });
          /***/

        },

        /***/
        9041:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Thai [th]
          //! author : Kridsada Thanabulpong : https://github.com/sirn
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var th = moment.defineLocale('th', {
              months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
              monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
              monthsParseExact: true,
              weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
              weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'),
              // yes, three characters difference
              weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY เวลา H:mm',
                LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm'
              },
              meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
              isPM: function isPM(input) {
                return input === 'หลังเที่ยง';
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 12) {
                  return 'ก่อนเที่ยง';
                } else {
                  return 'หลังเที่ยง';
                }
              },
              calendar: {
                sameDay: '[วันนี้ เวลา] LT',
                nextDay: '[พรุ่งนี้ เวลา] LT',
                nextWeek: 'dddd[หน้า เวลา] LT',
                lastDay: '[เมื่อวานนี้ เวลา] LT',
                lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'อีก %s',
                past: '%sที่แล้ว',
                s: 'ไม่กี่วินาที',
                ss: '%d วินาที',
                m: '1 นาที',
                mm: '%d นาที',
                h: '1 ชั่วโมง',
                hh: '%d ชั่วโมง',
                d: '1 วัน',
                dd: '%d วัน',
                w: '1 สัปดาห์',
                ww: '%d สัปดาห์',
                M: '1 เดือน',
                MM: '%d เดือน',
                y: '1 ปี',
                yy: '%d ปี'
              }
            });
            return th;
          });
          /***/

        },

        /***/
        9005:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Turkmen [tk]
          //! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var suffixes = {
              1: "'inji",
              5: "'inji",
              8: "'inji",
              70: "'inji",
              80: "'inji",
              2: "'nji",
              7: "'nji",
              20: "'nji",
              50: "'nji",
              3: "'ünji",
              4: "'ünji",
              100: "'ünji",
              6: "'njy",
              9: "'unjy",
              10: "'unjy",
              30: "'unjy",
              60: "'ynjy",
              90: "'ynjy"
            };
            var tk = moment.defineLocale('tk', {
              months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split('_'),
              monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
              weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split('_'),
              weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
              weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[bugün sagat] LT',
                nextDay: '[ertir sagat] LT',
                nextWeek: '[indiki] dddd [sagat] LT',
                lastDay: '[düýn] LT',
                lastWeek: '[geçen] dddd [sagat] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s soň',
                past: '%s öň',
                s: 'birnäçe sekunt',
                m: 'bir minut',
                mm: '%d minut',
                h: 'bir sagat',
                hh: '%d sagat',
                d: 'bir gün',
                dd: '%d gün',
                M: 'bir aý',
                MM: '%d aý',
                y: 'bir ýyl',
                yy: '%d ýyl'
              },
              ordinal: function ordinal(number, period) {
                switch (period) {
                  case 'd':
                  case 'D':
                  case 'Do':
                  case 'DD':
                    return number;

                  default:
                    if (number === 0) {
                      // special case for zero
                      return number + "'unjy";
                    }

                    var a = number % 10,
                        b = number % 100 - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
                }
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return tk;
          });
          /***/

        },

        /***/
        5768:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Tagalog (Philippines) [tl-ph]
          //! author : Dan Hagman : https://github.com/hagmandan
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var tlPh = moment.defineLocale('tl-ph', {
              months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
              monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
              weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
              weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
              weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'MM/D/YYYY',
                LL: 'MMMM D, YYYY',
                LLL: 'MMMM D, YYYY HH:mm',
                LLLL: 'dddd, MMMM DD, YYYY HH:mm'
              },
              calendar: {
                sameDay: 'LT [ngayong araw]',
                nextDay: '[Bukas ng] LT',
                nextWeek: 'LT [sa susunod na] dddd',
                lastDay: 'LT [kahapon]',
                lastWeek: 'LT [noong nakaraang] dddd',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'sa loob ng %s',
                past: '%s ang nakalipas',
                s: 'ilang segundo',
                ss: '%d segundo',
                m: 'isang minuto',
                mm: '%d minuto',
                h: 'isang oras',
                hh: '%d oras',
                d: 'isang araw',
                dd: '%d araw',
                M: 'isang buwan',
                MM: '%d buwan',
                y: 'isang taon',
                yy: '%d taon'
              },
              dayOfMonthOrdinalParse: /\d{1,2}/,
              ordinal: function ordinal(number) {
                return number;
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return tlPh;
          });
          /***/

        },

        /***/
        9444:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Klingon [tlh]
          //! author : Dominika Kruk : https://github.com/amaranthrose
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

            function translateFuture(output) {
              var time = output;
              time = output.indexOf('jaj') !== -1 ? time.slice(0, -3) + 'leS' : output.indexOf('jar') !== -1 ? time.slice(0, -3) + 'waQ' : output.indexOf('DIS') !== -1 ? time.slice(0, -3) + 'nem' : time + ' pIq';
              return time;
            }

            function translatePast(output) {
              var time = output;
              time = output.indexOf('jaj') !== -1 ? time.slice(0, -3) + 'Hu’' : output.indexOf('jar') !== -1 ? time.slice(0, -3) + 'wen' : output.indexOf('DIS') !== -1 ? time.slice(0, -3) + 'ben' : time + ' ret';
              return time;
            }

            function translate(number, withoutSuffix, string, isFuture) {
              var numberNoun = numberAsNoun(number);

              switch (string) {
                case 'ss':
                  return numberNoun + ' lup';

                case 'mm':
                  return numberNoun + ' tup';

                case 'hh':
                  return numberNoun + ' rep';

                case 'dd':
                  return numberNoun + ' jaj';

                case 'MM':
                  return numberNoun + ' jar';

                case 'yy':
                  return numberNoun + ' DIS';
              }
            }

            function numberAsNoun(number) {
              var hundred = Math.floor(number % 1000 / 100),
                  ten = Math.floor(number % 100 / 10),
                  one = number % 10,
                  word = '';

              if (hundred > 0) {
                word += numbersNouns[hundred] + 'vatlh';
              }

              if (ten > 0) {
                word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
              }

              if (one > 0) {
                word += (word !== '' ? ' ' : '') + numbersNouns[one];
              }

              return word === '' ? 'pagh' : word;
            }

            var tlh = moment.defineLocale('tlh', {
              months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
              monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
              monthsParseExact: true,
              weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
              weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
              weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[DaHjaj] LT',
                nextDay: '[wa’leS] LT',
                nextWeek: 'LLL',
                lastDay: '[wa’Hu’] LT',
                lastWeek: 'LLL',
                sameElse: 'L'
              },
              relativeTime: {
                future: translateFuture,
                past: translatePast,
                s: 'puS lup',
                ss: translate,
                m: 'wa’ tup',
                mm: translate,
                h: 'wa’ rep',
                hh: translate,
                d: 'wa’ jaj',
                dd: translate,
                M: 'wa’ jar',
                MM: translate,
                y: 'wa’ DIS',
                yy: translate
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return tlh;
          });
          /***/

        },

        /***/
        2397:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Turkish [tr]
          //! authors : Erhan Gundogan : https://github.com/erhangundogan,
          //!           Burak Yiğit Kaya: https://github.com/BYK
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var suffixes = {
              1: "'inci",
              5: "'inci",
              8: "'inci",
              70: "'inci",
              80: "'inci",
              2: "'nci",
              7: "'nci",
              20: "'nci",
              50: "'nci",
              3: "'üncü",
              4: "'üncü",
              100: "'üncü",
              6: "'ncı",
              9: "'uncu",
              10: "'uncu",
              30: "'uncu",
              60: "'ıncı",
              90: "'ıncı"
            };
            var tr = moment.defineLocale('tr', {
              months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
              monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
              weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
              weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
              weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
              meridiem: function meridiem(hours, minutes, isLower) {
                if (hours < 12) {
                  return isLower ? 'öö' : 'ÖÖ';
                } else {
                  return isLower ? 'ös' : 'ÖS';
                }
              },
              meridiemParse: /öö|ÖÖ|ös|ÖS/,
              isPM: function isPM(input) {
                return input === 'ös' || input === 'ÖS';
              },
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[bugün saat] LT',
                nextDay: '[yarın saat] LT',
                nextWeek: '[gelecek] dddd [saat] LT',
                lastDay: '[dün] LT',
                lastWeek: '[geçen] dddd [saat] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s sonra',
                past: '%s önce',
                s: 'birkaç saniye',
                ss: '%d saniye',
                m: 'bir dakika',
                mm: '%d dakika',
                h: 'bir saat',
                hh: '%d saat',
                d: 'bir gün',
                dd: '%d gün',
                w: 'bir hafta',
                ww: '%d hafta',
                M: 'bir ay',
                MM: '%d ay',
                y: 'bir yıl',
                yy: '%d yıl'
              },
              ordinal: function ordinal(number, period) {
                switch (period) {
                  case 'd':
                  case 'D':
                  case 'Do':
                  case 'DD':
                    return number;

                  default:
                    if (number === 0) {
                      // special case for zero
                      return number + "'ıncı";
                    }

                    var a = number % 10,
                        b = number % 100 - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
                }
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return tr;
          });
          /***/

        },

        /***/
        8254:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Talossan [tzl]
          //! author : Robin van der Vliet : https://github.com/robin0van0der0v
          //! author : Iustì Canun
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration
            // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
            // This is currently too difficult (maybe even impossible) to add.

            var tzl = moment.defineLocale('tzl', {
              months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
              monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
              weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
              weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
              weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
              longDateFormat: {
                LT: 'HH.mm',
                LTS: 'HH.mm.ss',
                L: 'DD.MM.YYYY',
                LL: 'D. MMMM [dallas] YYYY',
                LLL: 'D. MMMM [dallas] YYYY HH.mm',
                LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
              },
              meridiemParse: /d\'o|d\'a/i,
              isPM: function isPM(input) {
                return "d'o" === input.toLowerCase();
              },
              meridiem: function meridiem(hours, minutes, isLower) {
                if (hours > 11) {
                  return isLower ? "d'o" : "D'O";
                } else {
                  return isLower ? "d'a" : "D'A";
                }
              },
              calendar: {
                sameDay: '[oxhi à] LT',
                nextDay: '[demà à] LT',
                nextWeek: 'dddd [à] LT',
                lastDay: '[ieiri à] LT',
                lastWeek: '[sür el] dddd [lasteu à] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'osprei %s',
                past: 'ja%s',
                s: processRelativeTime,
                ss: processRelativeTime,
                m: processRelativeTime,
                mm: processRelativeTime,
                h: processRelativeTime,
                hh: processRelativeTime,
                d: processRelativeTime,
                dd: processRelativeTime,
                M: processRelativeTime,
                MM: processRelativeTime,
                y: processRelativeTime,
                yy: processRelativeTime
              },
              dayOfMonthOrdinalParse: /\d{1,2}\./,
              ordinal: '%d.',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });

            function processRelativeTime(number, withoutSuffix, key, isFuture) {
              var format = {
                s: ['viensas secunds', "'iensas secunds"],
                ss: [number + ' secunds', '' + number + ' secunds'],
                m: ["'n míut", "'iens míut"],
                mm: [number + ' míuts', '' + number + ' míuts'],
                h: ["'n þora", "'iensa þora"],
                hh: [number + ' þoras', '' + number + ' þoras'],
                d: ["'n ziua", "'iensa ziua"],
                dd: [number + ' ziuas', '' + number + ' ziuas'],
                M: ["'n mes", "'iens mes"],
                MM: [number + ' mesen', '' + number + ' mesen'],
                y: ["'n ar", "'iens ar"],
                yy: [number + ' ars', '' + number + ' ars']
              };
              return isFuture ? format[key][0] : withoutSuffix ? format[key][0] : format[key][1];
            }

            return tzl;
          });
          /***/

        },

        /***/
        699:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Central Atlas Tamazight Latin [tzm-latn]
          //! author : Abdel Said : https://github.com/abdelsaid
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var tzmLatn = moment.defineLocale('tzm-latn', {
              months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
              monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
              weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
              weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
              weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[asdkh g] LT',
                nextDay: '[aska g] LT',
                nextWeek: 'dddd [g] LT',
                lastDay: '[assant g] LT',
                lastWeek: 'dddd [g] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'dadkh s yan %s',
                past: 'yan %s',
                s: 'imik',
                ss: '%d imik',
                m: 'minuḍ',
                mm: '%d minuḍ',
                h: 'saɛa',
                hh: '%d tassaɛin',
                d: 'ass',
                dd: '%d ossan',
                M: 'ayowr',
                MM: '%d iyyirn',
                y: 'asgas',
                yy: '%d isgasn'
              },
              week: {
                dow: 6,
                // Saturday is the first day of the week.
                doy: 12 // The week that contains Jan 12th is the first week of the year.

              }
            });
            return tzmLatn;
          });
          /***/

        },

        /***/
        1106:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Central Atlas Tamazight [tzm]
          //! author : Abdel Said : https://github.com/abdelsaid
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var tzm = moment.defineLocale('tzm', {
              months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
              monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
              weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
              weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
              weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
                nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
                nextWeek: 'dddd [ⴴ] LT',
                lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
                lastWeek: 'dddd [ⴴ] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
                past: 'ⵢⴰⵏ %s',
                s: 'ⵉⵎⵉⴽ',
                ss: '%d ⵉⵎⵉⴽ',
                m: 'ⵎⵉⵏⵓⴺ',
                mm: '%d ⵎⵉⵏⵓⴺ',
                h: 'ⵙⴰⵄⴰ',
                hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
                d: 'ⴰⵙⵙ',
                dd: '%d oⵙⵙⴰⵏ',
                M: 'ⴰⵢoⵓⵔ',
                MM: '%d ⵉⵢⵢⵉⵔⵏ',
                y: 'ⴰⵙⴳⴰⵙ',
                yy: '%d ⵉⵙⴳⴰⵙⵏ'
              },
              week: {
                dow: 6,
                // Saturday is the first day of the week.
                doy: 12 // The week that contains Jan 12th is the first week of the year.

              }
            });
            return tzm;
          });
          /***/

        },

        /***/
        9288:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Uyghur (China) [ug-cn]
          //! author: boyaq : https://github.com/boyaq
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var ugCn = moment.defineLocale('ug-cn', {
              months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split('_'),
              monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split('_'),
              weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split('_'),
              weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
              weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'YYYY-MM-DD',
                LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
                LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
                LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
              },
              meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === 'يېرىم كېچە' || meridiem === 'سەھەر' || meridiem === 'چۈشتىن بۇرۇن') {
                  return hour;
                } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                  return hour + 12;
                } else {
                  return hour >= 11 ? hour : hour + 12;
                }
              },
              meridiem: function meridiem(hour, minute, isLower) {
                var hm = hour * 100 + minute;

                if (hm < 600) {
                  return 'يېرىم كېچە';
                } else if (hm < 900) {
                  return 'سەھەر';
                } else if (hm < 1130) {
                  return 'چۈشتىن بۇرۇن';
                } else if (hm < 1230) {
                  return 'چۈش';
                } else if (hm < 1800) {
                  return 'چۈشتىن كېيىن';
                } else {
                  return 'كەچ';
                }
              },
              calendar: {
                sameDay: '[بۈگۈن سائەت] LT',
                nextDay: '[ئەتە سائەت] LT',
                nextWeek: '[كېلەركى] dddd [سائەت] LT',
                lastDay: '[تۆنۈگۈن] LT',
                lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s كېيىن',
                past: '%s بۇرۇن',
                s: 'نەچچە سېكونت',
                ss: '%d سېكونت',
                m: 'بىر مىنۇت',
                mm: '%d مىنۇت',
                h: 'بىر سائەت',
                hh: '%d سائەت',
                d: 'بىر كۈن',
                dd: '%d كۈن',
                M: 'بىر ئاي',
                MM: '%d ئاي',
                y: 'بىر يىل',
                yy: '%d يىل'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
              ordinal: function ordinal(number, period) {
                switch (period) {
                  case 'd':
                  case 'D':
                  case 'DDD':
                    return number + '-كۈنى';

                  case 'w':
                  case 'W':
                    return number + '-ھەپتە';

                  default:
                    return number;
                }
              },
              preparse: function preparse(string) {
                return string.replace(/،/g, ',');
              },
              postformat: function postformat(string) {
                return string.replace(/,/g, '،');
              },
              week: {
                // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 1st is the first week of the year.

              }
            });
            return ugCn;
          });
          /***/

        },

        /***/
        7691:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Ukrainian [uk]
          //! author : zemlanin : https://github.com/zemlanin
          //! Author : Menelion Elensúle : https://github.com/Oire
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            function plural(word, num) {
              var forms = word.split('_');
              return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
            }

            function relativeTimeWithPlural(number, withoutSuffix, key) {
              var format = {
                ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
                mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
                hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
                dd: 'день_дні_днів',
                MM: 'місяць_місяці_місяців',
                yy: 'рік_роки_років'
              };

              if (key === 'm') {
                return withoutSuffix ? 'хвилина' : 'хвилину';
              } else if (key === 'h') {
                return withoutSuffix ? 'година' : 'годину';
              } else {
                return number + ' ' + plural(format[key], +number);
              }
            }

            function weekdaysCaseReplace(m, format) {
              var weekdays = {
                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
              },
                  nounCase;

              if (m === true) {
                return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
              }

              if (!m) {
                return weekdays['nominative'];
              }

              nounCase = /(\[[ВвУу]\]) ?dddd/.test(format) ? 'accusative' : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format) ? 'genitive' : 'nominative';
              return weekdays[nounCase][m.day()];
            }

            function processHoursFunction(str) {
              return function () {
                return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
              };
            }

            var uk = moment.defineLocale('uk', {
              months: {
                format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
                standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
              },
              monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
              weekdays: weekdaysCaseReplace,
              weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
              weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D MMMM YYYY р.',
                LLL: 'D MMMM YYYY р., HH:mm',
                LLLL: 'dddd, D MMMM YYYY р., HH:mm'
              },
              calendar: {
                sameDay: processHoursFunction('[Сьогодні '),
                nextDay: processHoursFunction('[Завтра '),
                lastDay: processHoursFunction('[Вчора '),
                nextWeek: processHoursFunction('[У] dddd ['),
                lastWeek: function lastWeek() {
                  switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                      return processHoursFunction('[Минулої] dddd [').call(this);

                    case 1:
                    case 2:
                    case 4:
                      return processHoursFunction('[Минулого] dddd [').call(this);
                  }
                },
                sameElse: 'L'
              },
              relativeTime: {
                future: 'за %s',
                past: '%s тому',
                s: 'декілька секунд',
                ss: relativeTimeWithPlural,
                m: relativeTimeWithPlural,
                mm: relativeTimeWithPlural,
                h: 'годину',
                hh: relativeTimeWithPlural,
                d: 'день',
                dd: relativeTimeWithPlural,
                M: 'місяць',
                MM: relativeTimeWithPlural,
                y: 'рік',
                yy: relativeTimeWithPlural
              },
              // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
              meridiemParse: /ночі|ранку|дня|вечора/,
              isPM: function isPM(input) {
                return /^(дня|вечора)$/.test(input);
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 4) {
                  return 'ночі';
                } else if (hour < 12) {
                  return 'ранку';
                } else if (hour < 17) {
                  return 'дня';
                } else {
                  return 'вечора';
                }
              },
              dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
              ordinal: function ordinal(number, period) {
                switch (period) {
                  case 'M':
                  case 'd':
                  case 'DDD':
                  case 'w':
                  case 'W':
                    return number + '-й';

                  case 'D':
                    return number + '-го';

                  default:
                    return number;
                }
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return uk;
          });
          /***/

        },

        /***/
        3795:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Urdu [ur]
          //! author : Sawood Alam : https://github.com/ibnesayeed
          //! author : Zack : https://github.com/ZackVision
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var months = ['جنوری', 'فروری', 'مارچ', 'اپریل', 'مئی', 'جون', 'جولائی', 'اگست', 'ستمبر', 'اکتوبر', 'نومبر', 'دسمبر'],
                days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
            var ur = moment.defineLocale('ur', {
              months: months,
              monthsShort: months,
              weekdays: days,
              weekdaysShort: days,
              weekdaysMin: days,
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd، D MMMM YYYY HH:mm'
              },
              meridiemParse: /صبح|شام/,
              isPM: function isPM(input) {
                return 'شام' === input;
              },
              meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 12) {
                  return 'صبح';
                }

                return 'شام';
              },
              calendar: {
                sameDay: '[آج بوقت] LT',
                nextDay: '[کل بوقت] LT',
                nextWeek: 'dddd [بوقت] LT',
                lastDay: '[گذشتہ روز بوقت] LT',
                lastWeek: '[گذشتہ] dddd [بوقت] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s بعد',
                past: '%s قبل',
                s: 'چند سیکنڈ',
                ss: '%d سیکنڈ',
                m: 'ایک منٹ',
                mm: '%d منٹ',
                h: 'ایک گھنٹہ',
                hh: '%d گھنٹے',
                d: 'ایک دن',
                dd: '%d دن',
                M: 'ایک ماہ',
                MM: '%d ماہ',
                y: 'ایک سال',
                yy: '%d سال'
              },
              preparse: function preparse(string) {
                return string.replace(/،/g, ',');
              },
              postformat: function postformat(string) {
                return string.replace(/,/g, '،');
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return ur;
          });
          /***/

        },

        /***/
        588:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Uzbek Latin [uz-latn]
          //! author : Rasulbek Mirzayev : github.com/Rasulbeeek
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var uzLatn = moment.defineLocale('uz-latn', {
              months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
              monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
              weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
              weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
              weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'D MMMM YYYY, dddd HH:mm'
              },
              calendar: {
                sameDay: '[Bugun soat] LT [da]',
                nextDay: '[Ertaga] LT [da]',
                nextWeek: 'dddd [kuni soat] LT [da]',
                lastDay: '[Kecha soat] LT [da]',
                lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
                sameElse: 'L'
              },
              relativeTime: {
                future: 'Yaqin %s ichida',
                past: 'Bir necha %s oldin',
                s: 'soniya',
                ss: '%d soniya',
                m: 'bir daqiqa',
                mm: '%d daqiqa',
                h: 'bir soat',
                hh: '%d soat',
                d: 'bir kun',
                dd: '%d kun',
                M: 'bir oy',
                MM: '%d oy',
                y: 'bir yil',
                yy: '%d yil'
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 7th is the first week of the year.

              }
            });
            return uzLatn;
          });
          /***/

        },

        /***/
        6791:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Uzbek [uz]
          //! author : Sardor Muminov : https://github.com/muminoff
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var uz = moment.defineLocale('uz', {
              months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
              monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
              weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
              weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
              weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'D MMMM YYYY, dddd HH:mm'
              },
              calendar: {
                sameDay: '[Бугун соат] LT [да]',
                nextDay: '[Эртага] LT [да]',
                nextWeek: 'dddd [куни соат] LT [да]',
                lastDay: '[Кеча соат] LT [да]',
                lastWeek: '[Утган] dddd [куни соат] LT [да]',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'Якин %s ичида',
                past: 'Бир неча %s олдин',
                s: 'фурсат',
                ss: '%d фурсат',
                m: 'бир дакика',
                mm: '%d дакика',
                h: 'бир соат',
                hh: '%d соат',
                d: 'бир кун',
                dd: '%d кун',
                M: 'бир ой',
                MM: '%d ой',
                y: 'бир йил',
                yy: '%d йил'
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 7 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return uz;
          });
          /***/

        },

        /***/
        5666:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Vietnamese [vi]
          //! author : Bang Nguyen : https://github.com/bangnk
          //! author : Chien Kira : https://github.com/chienkira
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var vi = moment.defineLocale('vi', {
              months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
              monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split('_'),
              monthsParseExact: true,
              weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
              weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
              weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
              weekdaysParseExact: true,
              meridiemParse: /sa|ch/i,
              isPM: function isPM(input) {
                return /^ch$/i.test(input);
              },
              meridiem: function meridiem(hours, minutes, isLower) {
                if (hours < 12) {
                  return isLower ? 'sa' : 'SA';
                } else {
                  return isLower ? 'ch' : 'CH';
                }
              },
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM [năm] YYYY',
                LLL: 'D MMMM [năm] YYYY HH:mm',
                LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
                l: 'DD/M/YYYY',
                ll: 'D MMM YYYY',
                lll: 'D MMM YYYY HH:mm',
                llll: 'ddd, D MMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[Hôm nay lúc] LT',
                nextDay: '[Ngày mai lúc] LT',
                nextWeek: 'dddd [tuần tới lúc] LT',
                lastDay: '[Hôm qua lúc] LT',
                lastWeek: 'dddd [tuần trước lúc] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: '%s tới',
                past: '%s trước',
                s: 'vài giây',
                ss: '%d giây',
                m: 'một phút',
                mm: '%d phút',
                h: 'một giờ',
                hh: '%d giờ',
                d: 'một ngày',
                dd: '%d ngày',
                w: 'một tuần',
                ww: '%d tuần',
                M: 'một tháng',
                MM: '%d tháng',
                y: 'một năm',
                yy: '%d năm'
              },
              dayOfMonthOrdinalParse: /\d{1,2}/,
              ordinal: function ordinal(number) {
                return number;
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return vi;
          });
          /***/

        },

        /***/
        4378:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Pseudo [x-pseudo]
          //! author : Andrew Hood : https://github.com/andrewhood125
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var xPseudo = moment.defineLocale('x-pseudo', {
              months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
              monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
              monthsParseExact: true,
              weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
              weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
              weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
              weekdaysParseExact: true,
              longDateFormat: {
                LT: 'HH:mm',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
              },
              calendar: {
                sameDay: '[T~ódá~ý át] LT',
                nextDay: '[T~ómó~rró~w át] LT',
                nextWeek: 'dddd [át] LT',
                lastDay: '[Ý~ést~érdá~ý át] LT',
                lastWeek: '[L~ást] dddd [át] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'í~ñ %s',
                past: '%s á~gó',
                s: 'á ~féw ~sécó~ñds',
                ss: '%d s~écóñ~ds',
                m: 'á ~míñ~úté',
                mm: '%d m~íñú~tés',
                h: 'á~ñ hó~úr',
                hh: '%d h~óúrs',
                d: 'á ~dáý',
                dd: '%d d~áýs',
                M: 'á ~móñ~th',
                MM: '%d m~óñt~hs',
                y: 'á ~ýéár',
                yy: '%d ý~éárs'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
              ordinal: function ordinal(number) {
                var b = number % 10,
                    output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
                return number + output;
              },
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return xPseudo;
          });
          /***/

        },

        /***/
        5805:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Yoruba Nigeria [yo]
          //! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var yo = moment.defineLocale('yo', {
              months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
              monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
              weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
              weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
              weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
              longDateFormat: {
                LT: 'h:mm A',
                LTS: 'h:mm:ss A',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY h:mm A',
                LLLL: 'dddd, D MMMM YYYY h:mm A'
              },
              calendar: {
                sameDay: '[Ònì ni] LT',
                nextDay: '[Ọ̀la ni] LT',
                nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
                lastDay: '[Àna ni] LT',
                lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
                sameElse: 'L'
              },
              relativeTime: {
                future: 'ní %s',
                past: '%s kọjá',
                s: 'ìsẹjú aayá die',
                ss: 'aayá %d',
                m: 'ìsẹjú kan',
                mm: 'ìsẹjú %d',
                h: 'wákati kan',
                hh: 'wákati %d',
                d: 'ọjọ́ kan',
                dd: 'ọjọ́ %d',
                M: 'osù kan',
                MM: 'osù %d',
                y: 'ọdún kan',
                yy: 'ọdún %d'
              },
              dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
              ordinal: 'ọjọ́ %d',
              week: {
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return yo;
          });
          /***/

        },

        /***/
        3839:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Chinese (China) [zh-cn]
          //! author : suupic : https://github.com/suupic
          //! author : Zeno Zeng : https://github.com/zenozeng
          //! author : uu109 : https://github.com/uu109
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var zhCn = moment.defineLocale('zh-cn', {
              months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
              monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
              weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
              weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
              weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'YYYY/MM/DD',
                LL: 'YYYY年M月D日',
                LLL: 'YYYY年M月D日Ah点mm分',
                LLLL: 'YYYY年M月D日ddddAh点mm分',
                l: 'YYYY/M/D',
                ll: 'YYYY年M月D日',
                lll: 'YYYY年M月D日 HH:mm',
                llll: 'YYYY年M月D日dddd HH:mm'
              },
              meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                  return hour;
                } else if (meridiem === '下午' || meridiem === '晚上') {
                  return hour + 12;
                } else {
                  // '中午'
                  return hour >= 11 ? hour : hour + 12;
                }
              },
              meridiem: function meridiem(hour, minute, isLower) {
                var hm = hour * 100 + minute;

                if (hm < 600) {
                  return '凌晨';
                } else if (hm < 900) {
                  return '早上';
                } else if (hm < 1130) {
                  return '上午';
                } else if (hm < 1230) {
                  return '中午';
                } else if (hm < 1800) {
                  return '下午';
                } else {
                  return '晚上';
                }
              },
              calendar: {
                sameDay: '[今天]LT',
                nextDay: '[明天]LT',
                nextWeek: function nextWeek(now) {
                  if (now.week() !== this.week()) {
                    return '[下]dddLT';
                  } else {
                    return '[本]dddLT';
                  }
                },
                lastDay: '[昨天]LT',
                lastWeek: function lastWeek(now) {
                  if (this.week() !== now.week()) {
                    return '[上]dddLT';
                  } else {
                    return '[本]dddLT';
                  }
                },
                sameElse: 'L'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
              ordinal: function ordinal(number, period) {
                switch (period) {
                  case 'd':
                  case 'D':
                  case 'DDD':
                    return number + '日';

                  case 'M':
                    return number + '月';

                  case 'w':
                  case 'W':
                    return number + '周';

                  default:
                    return number;
                }
              },
              relativeTime: {
                future: '%s后',
                past: '%s前',
                s: '几秒',
                ss: '%d 秒',
                m: '1 分钟',
                mm: '%d 分钟',
                h: '1 小时',
                hh: '%d 小时',
                d: '1 天',
                dd: '%d 天',
                w: '1 周',
                ww: '%d 周',
                M: '1 个月',
                MM: '%d 个月',
                y: '1 年',
                yy: '%d 年'
              },
              week: {
                // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
                dow: 1,
                // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.

              }
            });
            return zhCn;
          });
          /***/

        },

        /***/
        5726:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Chinese (Hong Kong) [zh-hk]
          //! author : Ben : https://github.com/ben-lin
          //! author : Chris Lam : https://github.com/hehachris
          //! author : Konstantin : https://github.com/skfd
          //! author : Anthony : https://github.com/anthonylau
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var zhHk = moment.defineLocale('zh-hk', {
              months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
              monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
              weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
              weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
              weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'YYYY/MM/DD',
                LL: 'YYYY年M月D日',
                LLL: 'YYYY年M月D日 HH:mm',
                LLLL: 'YYYY年M月D日dddd HH:mm',
                l: 'YYYY/M/D',
                ll: 'YYYY年M月D日',
                lll: 'YYYY年M月D日 HH:mm',
                llll: 'YYYY年M月D日dddd HH:mm'
              },
              meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                  return hour;
                } else if (meridiem === '中午') {
                  return hour >= 11 ? hour : hour + 12;
                } else if (meridiem === '下午' || meridiem === '晚上') {
                  return hour + 12;
                }
              },
              meridiem: function meridiem(hour, minute, isLower) {
                var hm = hour * 100 + minute;

                if (hm < 600) {
                  return '凌晨';
                } else if (hm < 900) {
                  return '早上';
                } else if (hm < 1200) {
                  return '上午';
                } else if (hm === 1200) {
                  return '中午';
                } else if (hm < 1800) {
                  return '下午';
                } else {
                  return '晚上';
                }
              },
              calendar: {
                sameDay: '[今天]LT',
                nextDay: '[明天]LT',
                nextWeek: '[下]ddddLT',
                lastDay: '[昨天]LT',
                lastWeek: '[上]ddddLT',
                sameElse: 'L'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
              ordinal: function ordinal(number, period) {
                switch (period) {
                  case 'd':
                  case 'D':
                  case 'DDD':
                    return number + '日';

                  case 'M':
                    return number + '月';

                  case 'w':
                  case 'W':
                    return number + '週';

                  default:
                    return number;
                }
              },
              relativeTime: {
                future: '%s後',
                past: '%s前',
                s: '幾秒',
                ss: '%d 秒',
                m: '1 分鐘',
                mm: '%d 分鐘',
                h: '1 小時',
                hh: '%d 小時',
                d: '1 天',
                dd: '%d 天',
                M: '1 個月',
                MM: '%d 個月',
                y: '1 年',
                yy: '%d 年'
              }
            });
            return zhHk;
          });
          /***/

        },

        /***/
        9807:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Chinese (Macau) [zh-mo]
          //! author : Ben : https://github.com/ben-lin
          //! author : Chris Lam : https://github.com/hehachris
          //! author : Tan Yuanhong : https://github.com/le0tan
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var zhMo = moment.defineLocale('zh-mo', {
              months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
              monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
              weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
              weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
              weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'YYYY年M月D日',
                LLL: 'YYYY年M月D日 HH:mm',
                LLLL: 'YYYY年M月D日dddd HH:mm',
                l: 'D/M/YYYY',
                ll: 'YYYY年M月D日',
                lll: 'YYYY年M月D日 HH:mm',
                llll: 'YYYY年M月D日dddd HH:mm'
              },
              meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                  return hour;
                } else if (meridiem === '中午') {
                  return hour >= 11 ? hour : hour + 12;
                } else if (meridiem === '下午' || meridiem === '晚上') {
                  return hour + 12;
                }
              },
              meridiem: function meridiem(hour, minute, isLower) {
                var hm = hour * 100 + minute;

                if (hm < 600) {
                  return '凌晨';
                } else if (hm < 900) {
                  return '早上';
                } else if (hm < 1130) {
                  return '上午';
                } else if (hm < 1230) {
                  return '中午';
                } else if (hm < 1800) {
                  return '下午';
                } else {
                  return '晚上';
                }
              },
              calendar: {
                sameDay: '[今天] LT',
                nextDay: '[明天] LT',
                nextWeek: '[下]dddd LT',
                lastDay: '[昨天] LT',
                lastWeek: '[上]dddd LT',
                sameElse: 'L'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
              ordinal: function ordinal(number, period) {
                switch (period) {
                  case 'd':
                  case 'D':
                  case 'DDD':
                    return number + '日';

                  case 'M':
                    return number + '月';

                  case 'w':
                  case 'W':
                    return number + '週';

                  default:
                    return number;
                }
              },
              relativeTime: {
                future: '%s內',
                past: '%s前',
                s: '幾秒',
                ss: '%d 秒',
                m: '1 分鐘',
                mm: '%d 分鐘',
                h: '1 小時',
                hh: '%d 小時',
                d: '1 天',
                dd: '%d 天',
                M: '1 個月',
                MM: '%d 個月',
                y: '1 年',
                yy: '%d 年'
              }
            });
            return zhMo;
          });
          /***/

        },

        /***/
        4152:
        /***/
        function _(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          //! moment.js locale configuration
          //! locale : Chinese (Taiwan) [zh-tw]
          //! author : Ben : https://github.com/ben-lin
          //! author : Chris Lam : https://github.com/hehachris
          ;

          (function (global, factory) {
            true ? factory(__webpack_require__(381)) : 0;
          })(this, function (moment) {
            'use strict'; //! moment.js locale configuration

            var zhTw = moment.defineLocale('zh-tw', {
              months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
              monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
              weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
              weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
              weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
              longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'YYYY/MM/DD',
                LL: 'YYYY年M月D日',
                LLL: 'YYYY年M月D日 HH:mm',
                LLLL: 'YYYY年M月D日dddd HH:mm',
                l: 'YYYY/M/D',
                ll: 'YYYY年M月D日',
                lll: 'YYYY年M月D日 HH:mm',
                llll: 'YYYY年M月D日dddd HH:mm'
              },
              meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
              meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                  hour = 0;
                }

                if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                  return hour;
                } else if (meridiem === '中午') {
                  return hour >= 11 ? hour : hour + 12;
                } else if (meridiem === '下午' || meridiem === '晚上') {
                  return hour + 12;
                }
              },
              meridiem: function meridiem(hour, minute, isLower) {
                var hm = hour * 100 + minute;

                if (hm < 600) {
                  return '凌晨';
                } else if (hm < 900) {
                  return '早上';
                } else if (hm < 1130) {
                  return '上午';
                } else if (hm < 1230) {
                  return '中午';
                } else if (hm < 1800) {
                  return '下午';
                } else {
                  return '晚上';
                }
              },
              calendar: {
                sameDay: '[今天] LT',
                nextDay: '[明天] LT',
                nextWeek: '[下]dddd LT',
                lastDay: '[昨天] LT',
                lastWeek: '[上]dddd LT',
                sameElse: 'L'
              },
              dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
              ordinal: function ordinal(number, period) {
                switch (period) {
                  case 'd':
                  case 'D':
                  case 'DDD':
                    return number + '日';

                  case 'M':
                    return number + '月';

                  case 'w':
                  case 'W':
                    return number + '週';

                  default:
                    return number;
                }
              },
              relativeTime: {
                future: '%s後',
                past: '%s前',
                s: '幾秒',
                ss: '%d 秒',
                m: '1 分鐘',
                mm: '%d 分鐘',
                h: '1 小時',
                hh: '%d 小時',
                d: '1 天',
                dd: '%d 天',
                M: '1 個月',
                MM: '%d 個月',
                y: '1 年',
                yy: '%d 年'
              }
            });
            return zhTw;
          });
          /***/

        },

        /***/
        6700:
        /***/
        function _(module, __unused_webpack_exports, __webpack_require__) {
          var map = {
            "./af": 2786,
            "./af.js": 2786,
            "./ar": 867,
            "./ar-dz": 4130,
            "./ar-dz.js": 4130,
            "./ar-kw": 6135,
            "./ar-kw.js": 6135,
            "./ar-ly": 6440,
            "./ar-ly.js": 6440,
            "./ar-ma": 7702,
            "./ar-ma.js": 7702,
            "./ar-sa": 6040,
            "./ar-sa.js": 6040,
            "./ar-tn": 7100,
            "./ar-tn.js": 7100,
            "./ar.js": 867,
            "./az": 1083,
            "./az.js": 1083,
            "./be": 9808,
            "./be.js": 9808,
            "./bg": 8338,
            "./bg.js": 8338,
            "./bm": 7438,
            "./bm.js": 7438,
            "./bn": 8905,
            "./bn-bd": 6225,
            "./bn-bd.js": 6225,
            "./bn.js": 8905,
            "./bo": 1560,
            "./bo.js": 1560,
            "./br": 1278,
            "./br.js": 1278,
            "./bs": 622,
            "./bs.js": 622,
            "./ca": 2468,
            "./ca.js": 2468,
            "./cs": 5822,
            "./cs.js": 5822,
            "./cv": 877,
            "./cv.js": 877,
            "./cy": 7373,
            "./cy.js": 7373,
            "./da": 4780,
            "./da.js": 4780,
            "./de": 9740,
            "./de-at": 217,
            "./de-at.js": 217,
            "./de-ch": 894,
            "./de-ch.js": 894,
            "./de.js": 9740,
            "./dv": 5300,
            "./dv.js": 5300,
            "./el": 837,
            "./el.js": 837,
            "./en-au": 8348,
            "./en-au.js": 8348,
            "./en-ca": 7925,
            "./en-ca.js": 7925,
            "./en-gb": 2243,
            "./en-gb.js": 2243,
            "./en-ie": 6436,
            "./en-ie.js": 6436,
            "./en-il": 7207,
            "./en-il.js": 7207,
            "./en-in": 4175,
            "./en-in.js": 4175,
            "./en-nz": 6319,
            "./en-nz.js": 6319,
            "./en-sg": 1662,
            "./en-sg.js": 1662,
            "./eo": 2915,
            "./eo.js": 2915,
            "./es": 5655,
            "./es-do": 5251,
            "./es-do.js": 5251,
            "./es-mx": 6112,
            "./es-mx.js": 6112,
            "./es-us": 1146,
            "./es-us.js": 1146,
            "./es.js": 5655,
            "./et": 5603,
            "./et.js": 5603,
            "./eu": 7763,
            "./eu.js": 7763,
            "./fa": 6959,
            "./fa.js": 6959,
            "./fi": 1897,
            "./fi.js": 1897,
            "./fil": 2549,
            "./fil.js": 2549,
            "./fo": 4694,
            "./fo.js": 4694,
            "./fr": 4470,
            "./fr-ca": 3049,
            "./fr-ca.js": 3049,
            "./fr-ch": 2330,
            "./fr-ch.js": 2330,
            "./fr.js": 4470,
            "./fy": 5044,
            "./fy.js": 5044,
            "./ga": 9295,
            "./ga.js": 9295,
            "./gd": 2101,
            "./gd.js": 2101,
            "./gl": 8794,
            "./gl.js": 8794,
            "./gom-deva": 7884,
            "./gom-deva.js": 7884,
            "./gom-latn": 3168,
            "./gom-latn.js": 3168,
            "./gu": 5349,
            "./gu.js": 5349,
            "./he": 4206,
            "./he.js": 4206,
            "./hi": 94,
            "./hi.js": 94,
            "./hr": 316,
            "./hr.js": 316,
            "./hu": 2138,
            "./hu.js": 2138,
            "./hy-am": 1423,
            "./hy-am.js": 1423,
            "./id": 9218,
            "./id.js": 9218,
            "./is": 135,
            "./is.js": 135,
            "./it": 626,
            "./it-ch": 150,
            "./it-ch.js": 150,
            "./it.js": 626,
            "./ja": 9183,
            "./ja.js": 9183,
            "./jv": 4286,
            "./jv.js": 4286,
            "./ka": 2105,
            "./ka.js": 2105,
            "./kk": 7772,
            "./kk.js": 7772,
            "./km": 8758,
            "./km.js": 8758,
            "./kn": 9282,
            "./kn.js": 9282,
            "./ko": 3730,
            "./ko.js": 3730,
            "./ku": 1408,
            "./ku.js": 1408,
            "./ky": 3291,
            "./ky.js": 3291,
            "./lb": 6841,
            "./lb.js": 6841,
            "./lo": 5466,
            "./lo.js": 5466,
            "./lt": 7010,
            "./lt.js": 7010,
            "./lv": 7595,
            "./lv.js": 7595,
            "./me": 9861,
            "./me.js": 9861,
            "./mi": 5493,
            "./mi.js": 5493,
            "./mk": 5966,
            "./mk.js": 5966,
            "./ml": 7341,
            "./ml.js": 7341,
            "./mn": 5115,
            "./mn.js": 5115,
            "./mr": 370,
            "./mr.js": 370,
            "./ms": 9847,
            "./ms-my": 1237,
            "./ms-my.js": 1237,
            "./ms.js": 9847,
            "./mt": 2126,
            "./mt.js": 2126,
            "./my": 6165,
            "./my.js": 6165,
            "./nb": 4924,
            "./nb.js": 4924,
            "./ne": 6744,
            "./ne.js": 6744,
            "./nl": 3901,
            "./nl-be": 9814,
            "./nl-be.js": 9814,
            "./nl.js": 3901,
            "./nn": 3877,
            "./nn.js": 3877,
            "./oc-lnc": 2135,
            "./oc-lnc.js": 2135,
            "./pa-in": 5858,
            "./pa-in.js": 5858,
            "./pl": 4495,
            "./pl.js": 4495,
            "./pt": 9520,
            "./pt-br": 7971,
            "./pt-br.js": 7971,
            "./pt.js": 9520,
            "./ro": 6459,
            "./ro.js": 6459,
            "./ru": 1793,
            "./ru.js": 1793,
            "./sd": 950,
            "./sd.js": 950,
            "./se": 490,
            "./se.js": 490,
            "./si": 124,
            "./si.js": 124,
            "./sk": 4249,
            "./sk.js": 4249,
            "./sl": 4985,
            "./sl.js": 4985,
            "./sq": 1104,
            "./sq.js": 1104,
            "./sr": 9131,
            "./sr-cyrl": 9915,
            "./sr-cyrl.js": 9915,
            "./sr.js": 9131,
            "./ss": 5893,
            "./ss.js": 5893,
            "./sv": 8760,
            "./sv.js": 8760,
            "./sw": 1172,
            "./sw.js": 1172,
            "./ta": 7333,
            "./ta.js": 7333,
            "./te": 3110,
            "./te.js": 3110,
            "./tet": 2095,
            "./tet.js": 2095,
            "./tg": 7321,
            "./tg.js": 7321,
            "./th": 9041,
            "./th.js": 9041,
            "./tk": 9005,
            "./tk.js": 9005,
            "./tl-ph": 5768,
            "./tl-ph.js": 5768,
            "./tlh": 9444,
            "./tlh.js": 9444,
            "./tr": 2397,
            "./tr.js": 2397,
            "./tzl": 8254,
            "./tzl.js": 8254,
            "./tzm": 1106,
            "./tzm-latn": 699,
            "./tzm-latn.js": 699,
            "./tzm.js": 1106,
            "./ug-cn": 9288,
            "./ug-cn.js": 9288,
            "./uk": 7691,
            "./uk.js": 7691,
            "./ur": 3795,
            "./ur.js": 3795,
            "./uz": 6791,
            "./uz-latn": 588,
            "./uz-latn.js": 588,
            "./uz.js": 6791,
            "./vi": 5666,
            "./vi.js": 5666,
            "./x-pseudo": 4378,
            "./x-pseudo.js": 4378,
            "./yo": 5805,
            "./yo.js": 5805,
            "./zh-cn": 3839,
            "./zh-cn.js": 3839,
            "./zh-hk": 5726,
            "./zh-hk.js": 5726,
            "./zh-mo": 9807,
            "./zh-mo.js": 9807,
            "./zh-tw": 4152,
            "./zh-tw.js": 4152
          };

          function webpackContext(req) {
            var id = webpackContextResolve(req);
            return __webpack_require__(id);
          }

          function webpackContextResolve(req) {
            if (!__webpack_require__.o(map, req)) {
              var e = new Error("Cannot find module '" + req + "'");
              e.code = 'MODULE_NOT_FOUND';
              throw e;
            }

            return map[req];
          }

          webpackContext.keys = function webpackContextKeys() {
            return Object.keys(map);
          };

          webpackContext.resolve = webpackContextResolve;
          module.exports = webpackContext;
          webpackContext.id = 6700;
          /***/
        },

        /***/
        381:
        /***/
        function _(module, __unused_webpack_exports, __webpack_require__) {
          /* module decorator */
          module = __webpack_require__.nmd(module); //! moment.js
          //! version : 2.29.1
          //! authors : Tim Wood, Iskren Chernev, Moment.js contributors
          //! license : MIT
          //! momentjs.com

          ;

          (function (global, factory) {
            true ? module.exports = factory() : 0;
          })(this, function () {
            'use strict';

            var hookCallback;

            function hooks() {
              return hookCallback.apply(null, arguments);
            } // This is done to register the method called with moment()
            // without creating circular dependencies.


            function setHookCallback(callback) {
              hookCallback = callback;
            }

            function isArray(input) {
              return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
            }

            function isObject(input) {
              // IE8 will treat undefined and null as object if it wasn't for
              // input != null
              return input != null && Object.prototype.toString.call(input) === '[object Object]';
            }

            function hasOwnProp(a, b) {
              return Object.prototype.hasOwnProperty.call(a, b);
            }

            function isObjectEmpty(obj) {
              if (Object.getOwnPropertyNames) {
                return Object.getOwnPropertyNames(obj).length === 0;
              } else {
                var k;

                for (k in obj) {
                  if (hasOwnProp(obj, k)) {
                    return false;
                  }
                }

                return true;
              }
            }

            function isUndefined(input) {
              return input === void 0;
            }

            function isNumber(input) {
              return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
            }

            function isDate(input) {
              return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
            }

            function map(arr, fn) {
              var res = [],
                  i;

              for (i = 0; i < arr.length; ++i) {
                res.push(fn(arr[i], i));
              }

              return res;
            }

            function extend(a, b) {
              for (var i in b) {
                if (hasOwnProp(b, i)) {
                  a[i] = b[i];
                }
              }

              if (hasOwnProp(b, 'toString')) {
                a.toString = b.toString;
              }

              if (hasOwnProp(b, 'valueOf')) {
                a.valueOf = b.valueOf;
              }

              return a;
            }

            function createUTC(input, format, locale, strict) {
              return createLocalOrUTC(input, format, locale, strict, true).utc();
            }

            function defaultParsingFlags() {
              // We need to deep clone this object.
              return {
                empty: false,
                unusedTokens: [],
                unusedInput: [],
                overflow: -2,
                charsLeftOver: 0,
                nullInput: false,
                invalidEra: null,
                invalidMonth: null,
                invalidFormat: false,
                userInvalidated: false,
                iso: false,
                parsedDateParts: [],
                era: null,
                meridiem: null,
                rfc2822: false,
                weekdayMismatch: false
              };
            }

            function getParsingFlags(m) {
              if (m._pf == null) {
                m._pf = defaultParsingFlags();
              }

              return m._pf;
            }

            var some;

            if (Array.prototype.some) {
              some = Array.prototype.some;
            } else {
              some = function some(fun) {
                var t = Object(this),
                    len = t.length >>> 0,
                    i;

                for (i = 0; i < len; i++) {
                  if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                  }
                }

                return false;
              };
            }

            function isValid(m) {
              if (m._isValid == null) {
                var flags = getParsingFlags(m),
                    parsedParts = some.call(flags.parsedDateParts, function (i) {
                  return i != null;
                }),
                    isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);

                if (m._strict) {
                  isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
                }

                if (Object.isFrozen == null || !Object.isFrozen(m)) {
                  m._isValid = isNowValid;
                } else {
                  return isNowValid;
                }
              }

              return m._isValid;
            }

            function createInvalid(flags) {
              var m = createUTC(NaN);

              if (flags != null) {
                extend(getParsingFlags(m), flags);
              } else {
                getParsingFlags(m).userInvalidated = true;
              }

              return m;
            } // Plugins that add properties should also add the key here (null value),
            // so we can properly clone ourselves.


            var momentProperties = hooks.momentProperties = [],
                updateInProgress = false;

            function copyConfig(to, from) {
              var i, prop, val;

              if (!isUndefined(from._isAMomentObject)) {
                to._isAMomentObject = from._isAMomentObject;
              }

              if (!isUndefined(from._i)) {
                to._i = from._i;
              }

              if (!isUndefined(from._f)) {
                to._f = from._f;
              }

              if (!isUndefined(from._l)) {
                to._l = from._l;
              }

              if (!isUndefined(from._strict)) {
                to._strict = from._strict;
              }

              if (!isUndefined(from._tzm)) {
                to._tzm = from._tzm;
              }

              if (!isUndefined(from._isUTC)) {
                to._isUTC = from._isUTC;
              }

              if (!isUndefined(from._offset)) {
                to._offset = from._offset;
              }

              if (!isUndefined(from._pf)) {
                to._pf = getParsingFlags(from);
              }

              if (!isUndefined(from._locale)) {
                to._locale = from._locale;
              }

              if (momentProperties.length > 0) {
                for (i = 0; i < momentProperties.length; i++) {
                  prop = momentProperties[i];
                  val = from[prop];

                  if (!isUndefined(val)) {
                    to[prop] = val;
                  }
                }
              }

              return to;
            } // Moment prototype object


            function Moment(config) {
              copyConfig(this, config);
              this._d = new Date(config._d != null ? config._d.getTime() : NaN);

              if (!this.isValid()) {
                this._d = new Date(NaN);
              } // Prevent infinite loop in case updateOffset creates new moment
              // objects.


              if (updateInProgress === false) {
                updateInProgress = true;
                hooks.updateOffset(this);
                updateInProgress = false;
              }
            }

            function isMoment(obj) {
              return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
            }

            function warn(msg) {
              if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
                console.warn('Deprecation warning: ' + msg);
              }
            }

            function deprecate(msg, fn) {
              var firstTime = true;
              return extend(function () {
                if (hooks.deprecationHandler != null) {
                  hooks.deprecationHandler(null, msg);
                }

                if (firstTime) {
                  var args = [],
                      arg,
                      i,
                      key;

                  for (i = 0; i < arguments.length; i++) {
                    arg = '';

                    if (_typeof2(arguments[i]) === 'object') {
                      arg += '\n[' + i + '] ';

                      for (key in arguments[0]) {
                        if (hasOwnProp(arguments[0], key)) {
                          arg += key + ': ' + arguments[0][key] + ', ';
                        }
                      }

                      arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                      arg = arguments[i];
                    }

                    args.push(arg);
                  }

                  warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                  firstTime = false;
                }

                return fn.apply(this, arguments);
              }, fn);
            }

            var deprecations = {};

            function deprecateSimple(name, msg) {
              if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(name, msg);
              }

              if (!deprecations[name]) {
                warn(msg);
                deprecations[name] = true;
              }
            }

            hooks.suppressDeprecationWarnings = false;
            hooks.deprecationHandler = null;

            function isFunction(input) {
              return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
            }

            function set(config) {
              var prop, i;

              for (i in config) {
                if (hasOwnProp(config, i)) {
                  prop = config[i];

                  if (isFunction(prop)) {
                    this[i] = prop;
                  } else {
                    this['_' + i] = prop;
                  }
                }
              }

              this._config = config; // Lenient ordinal parsing accepts just a number in addition to
              // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
              // TODO: Remove "ordinalParse" fallback in next major release.

              this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
            }

            function mergeConfigs(parentConfig, childConfig) {
              var res = extend({}, parentConfig),
                  prop;

              for (prop in childConfig) {
                if (hasOwnProp(childConfig, prop)) {
                  if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                  } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                  } else {
                    delete res[prop];
                  }
                }
              }

              for (prop in parentConfig) {
                if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
                  // make sure changes to properties don't modify parent config
                  res[prop] = extend({}, res[prop]);
                }
              }

              return res;
            }

            function Locale(config) {
              if (config != null) {
                this.set(config);
              }
            }

            var keys;

            if (Object.keys) {
              keys = Object.keys;
            } else {
              keys = function keys(obj) {
                var i,
                    res = [];

                for (i in obj) {
                  if (hasOwnProp(obj, i)) {
                    res.push(i);
                  }
                }

                return res;
              };
            }

            var defaultCalendar = {
              sameDay: '[Today at] LT',
              nextDay: '[Tomorrow at] LT',
              nextWeek: 'dddd [at] LT',
              lastDay: '[Yesterday at] LT',
              lastWeek: '[Last] dddd [at] LT',
              sameElse: 'L'
            };

            function calendar(key, mom, now) {
              var output = this._calendar[key] || this._calendar['sameElse'];
              return isFunction(output) ? output.call(mom, now) : output;
            }

            function zeroFill(number, targetLength, forceSign) {
              var absNumber = '' + Math.abs(number),
                  zerosToFill = targetLength - absNumber.length,
                  sign = number >= 0;
              return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
            }

            var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
                localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
                formatFunctions = {},
                formatTokenFunctions = {}; // token:    'M'
            // padded:   ['MM', 2]
            // ordinal:  'Mo'
            // callback: function () { this.month() + 1 }

            function addFormatToken(token, padded, ordinal, callback) {
              var func = callback;

              if (typeof callback === 'string') {
                func = function func() {
                  return this[callback]();
                };
              }

              if (token) {
                formatTokenFunctions[token] = func;
              }

              if (padded) {
                formatTokenFunctions[padded[0]] = function () {
                  return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
                };
              }

              if (ordinal) {
                formatTokenFunctions[ordinal] = function () {
                  return this.localeData().ordinal(func.apply(this, arguments), token);
                };
              }
            }

            function removeFormattingTokens(input) {
              if (input.match(/\[[\s\S]/)) {
                return input.replace(/^\[|\]$/g, '');
              }

              return input.replace(/\\/g, '');
            }

            function makeFormatFunction(format) {
              var array = format.match(formattingTokens),
                  i,
                  length;

              for (i = 0, length = array.length; i < length; i++) {
                if (formatTokenFunctions[array[i]]) {
                  array[i] = formatTokenFunctions[array[i]];
                } else {
                  array[i] = removeFormattingTokens(array[i]);
                }
              }

              return function (mom) {
                var output = '',
                    i;

                for (i = 0; i < length; i++) {
                  output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
                }

                return output;
              };
            } // format date using native date object


            function formatMoment(m, format) {
              if (!m.isValid()) {
                return m.localeData().invalidDate();
              }

              format = expandFormat(format, m.localeData());
              formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
              return formatFunctions[format](m);
            }

            function expandFormat(format, locale) {
              var i = 5;

              function replaceLongDateFormatTokens(input) {
                return locale.longDateFormat(input) || input;
              }

              localFormattingTokens.lastIndex = 0;

              while (i >= 0 && localFormattingTokens.test(format)) {
                format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
                localFormattingTokens.lastIndex = 0;
                i -= 1;
              }

              return format;
            }

            var defaultLongDateFormat = {
              LTS: 'h:mm:ss A',
              LT: 'h:mm A',
              L: 'MM/DD/YYYY',
              LL: 'MMMM D, YYYY',
              LLL: 'MMMM D, YYYY h:mm A',
              LLLL: 'dddd, MMMM D, YYYY h:mm A'
            };

            function longDateFormat(key) {
              var format = this._longDateFormat[key],
                  formatUpper = this._longDateFormat[key.toUpperCase()];

              if (format || !formatUpper) {
                return format;
              }

              this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function (tok) {
                if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') {
                  return tok.slice(1);
                }

                return tok;
              }).join('');
              return this._longDateFormat[key];
            }

            var defaultInvalidDate = 'Invalid date';

            function invalidDate() {
              return this._invalidDate;
            }

            var defaultOrdinal = '%d',
                defaultDayOfMonthOrdinalParse = /\d{1,2}/;

            function ordinal(number) {
              return this._ordinal.replace('%d', number);
            }

            var defaultRelativeTime = {
              future: 'in %s',
              past: '%s ago',
              s: 'a few seconds',
              ss: '%d seconds',
              m: 'a minute',
              mm: '%d minutes',
              h: 'an hour',
              hh: '%d hours',
              d: 'a day',
              dd: '%d days',
              w: 'a week',
              ww: '%d weeks',
              M: 'a month',
              MM: '%d months',
              y: 'a year',
              yy: '%d years'
            };

            function relativeTime(number, withoutSuffix, string, isFuture) {
              var output = this._relativeTime[string];
              return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
            }

            function pastFuture(diff, output) {
              var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
              return isFunction(format) ? format(output) : format.replace(/%s/i, output);
            }

            var aliases = {};

            function addUnitAlias(unit, shorthand) {
              var lowerCase = unit.toLowerCase();
              aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
            }

            function normalizeUnits(units) {
              return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
            }

            function normalizeObjectUnits(inputObject) {
              var normalizedInput = {},
                  normalizedProp,
                  prop;

              for (prop in inputObject) {
                if (hasOwnProp(inputObject, prop)) {
                  normalizedProp = normalizeUnits(prop);

                  if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                  }
                }
              }

              return normalizedInput;
            }

            var priorities = {};

            function addUnitPriority(unit, priority) {
              priorities[unit] = priority;
            }

            function getPrioritizedUnits(unitsObj) {
              var units = [],
                  u;

              for (u in unitsObj) {
                if (hasOwnProp(unitsObj, u)) {
                  units.push({
                    unit: u,
                    priority: priorities[u]
                  });
                }
              }

              units.sort(function (a, b) {
                return a.priority - b.priority;
              });
              return units;
            }

            function isLeapYear(year) {
              return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
            }

            function absFloor(number) {
              if (number < 0) {
                // -0 -> 0
                return Math.ceil(number) || 0;
              } else {
                return Math.floor(number);
              }
            }

            function toInt(argumentForCoercion) {
              var coercedNumber = +argumentForCoercion,
                  value = 0;

              if (coercedNumber !== 0 && isFinite(coercedNumber)) {
                value = absFloor(coercedNumber);
              }

              return value;
            }

            function makeGetSet(unit, keepTime) {
              return function (value) {
                if (value != null) {
                  set$1(this, unit, value);
                  hooks.updateOffset(this, keepTime);
                  return this;
                } else {
                  return get(this, unit);
                }
              };
            }

            function get(mom, unit) {
              return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
            }

            function set$1(mom, unit, value) {
              if (mom.isValid() && !isNaN(value)) {
                if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                  value = toInt(value);

                  mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
                } else {
                  mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
                }
              }
            } // MOMENTS


            function stringGet(units) {
              units = normalizeUnits(units);

              if (isFunction(this[units])) {
                return this[units]();
              }

              return this;
            }

            function stringSet(units, value) {
              if (_typeof2(units) === 'object') {
                units = normalizeObjectUnits(units);
                var prioritized = getPrioritizedUnits(units),
                    i;

                for (i = 0; i < prioritized.length; i++) {
                  this[prioritized[i].unit](units[prioritized[i].unit]);
                }
              } else {
                units = normalizeUnits(units);

                if (isFunction(this[units])) {
                  return this[units](value);
                }
              }

              return this;
            }

            var match1 = /\d/,
                //       0 - 9
            match2 = /\d\d/,
                //      00 - 99
            match3 = /\d{3}/,
                //     000 - 999
            match4 = /\d{4}/,
                //    0000 - 9999
            match6 = /[+-]?\d{6}/,
                // -999999 - 999999
            match1to2 = /\d\d?/,
                //       0 - 99
            match3to4 = /\d\d\d\d?/,
                //     999 - 9999
            match5to6 = /\d\d\d\d\d\d?/,
                //   99999 - 999999
            match1to3 = /\d{1,3}/,
                //       0 - 999
            match1to4 = /\d{1,4}/,
                //       0 - 9999
            match1to6 = /[+-]?\d{1,6}/,
                // -999999 - 999999
            matchUnsigned = /\d+/,
                //       0 - inf
            matchSigned = /[+-]?\d+/,
                //    -inf - inf
            matchOffset = /Z|[+-]\d\d:?\d\d/gi,
                // +00:00 -00:00 +0000 -0000 or Z
            matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi,
                // +00 -00 +00:00 -00:00 +0000 -0000 or Z
            matchTimestamp = /[+-]?\d+(\.\d{1,3})?/,
                // 123456789 123456789.123
            // any word (or two) characters or numbers including two/three word month in arabic.
            // includes scottish gaelic two word and hyphenated months
            matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
                regexes;
            regexes = {};

            function addRegexToken(token, regex, strictRegex) {
              regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
                return isStrict && strictRegex ? strictRegex : regex;
              };
            }

            function getParseRegexForToken(token, config) {
              if (!hasOwnProp(regexes, token)) {
                return new RegExp(unescapeFormat(token));
              }

              return regexes[token](config._strict, config._locale);
            } // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript


            function unescapeFormat(s) {
              return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
                return p1 || p2 || p3 || p4;
              }));
            }

            function regexEscape(s) {
              return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            }

            var tokens = {};

            function addParseToken(token, callback) {
              var i,
                  func = callback;

              if (typeof token === 'string') {
                token = [token];
              }

              if (isNumber(callback)) {
                func = function func(input, array) {
                  array[callback] = toInt(input);
                };
              }

              for (i = 0; i < token.length; i++) {
                tokens[token[i]] = func;
              }
            }

            function addWeekParseToken(token, callback) {
              addParseToken(token, function (input, array, config, token) {
                config._w = config._w || {};
                callback(input, config._w, config, token);
              });
            }

            function addTimeToArrayFromToken(token, input, config) {
              if (input != null && hasOwnProp(tokens, token)) {
                tokens[token](input, config._a, config, token);
              }
            }

            var YEAR = 0,
                MONTH = 1,
                DATE = 2,
                HOUR = 3,
                MINUTE = 4,
                SECOND = 5,
                MILLISECOND = 6,
                WEEK = 7,
                WEEKDAY = 8;

            function mod(n, x) {
              return (n % x + x) % x;
            }

            var indexOf;

            if (Array.prototype.indexOf) {
              indexOf = Array.prototype.indexOf;
            } else {
              indexOf = function indexOf(o) {
                // I know
                var i;

                for (i = 0; i < this.length; ++i) {
                  if (this[i] === o) {
                    return i;
                  }
                }

                return -1;
              };
            }

            function daysInMonth(year, month) {
              if (isNaN(year) || isNaN(month)) {
                return NaN;
              }

              var modMonth = mod(month, 12);
              year += (month - modMonth) / 12;
              return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
            } // FORMATTING


            addFormatToken('M', ['MM', 2], 'Mo', function () {
              return this.month() + 1;
            });
            addFormatToken('MMM', 0, 0, function (format) {
              return this.localeData().monthsShort(this, format);
            });
            addFormatToken('MMMM', 0, 0, function (format) {
              return this.localeData().months(this, format);
            }); // ALIASES

            addUnitAlias('month', 'M'); // PRIORITY

            addUnitPriority('month', 8); // PARSING

            addRegexToken('M', match1to2);
            addRegexToken('MM', match1to2, match2);
            addRegexToken('MMM', function (isStrict, locale) {
              return locale.monthsShortRegex(isStrict);
            });
            addRegexToken('MMMM', function (isStrict, locale) {
              return locale.monthsRegex(isStrict);
            });
            addParseToken(['M', 'MM'], function (input, array) {
              array[MONTH] = toInt(input) - 1;
            });
            addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
              var month = config._locale.monthsParse(input, token, config._strict); // if we didn't find a month name, mark the date as invalid.


              if (month != null) {
                array[MONTH] = month;
              } else {
                getParsingFlags(config).invalidMonth = input;
              }
            }); // LOCALES

            var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
                defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
                defaultMonthsShortRegex = matchWord,
                defaultMonthsRegex = matchWord;

            function localeMonths(m, format) {
              if (!m) {
                return isArray(this._months) ? this._months : this._months['standalone'];
              }

              return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
            }

            function localeMonthsShort(m, format) {
              if (!m) {
                return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
              }

              return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
            }

            function handleStrictParse(monthName, format, strict) {
              var i,
                  ii,
                  mom,
                  llc = monthName.toLocaleLowerCase();

              if (!this._monthsParse) {
                // this is not used
                this._monthsParse = [];
                this._longMonthsParse = [];
                this._shortMonthsParse = [];

                for (i = 0; i < 12; ++i) {
                  mom = createUTC([2000, i]);
                  this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                  this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
                }
              }

              if (strict) {
                if (format === 'MMM') {
                  ii = indexOf.call(this._shortMonthsParse, llc);
                  return ii !== -1 ? ii : null;
                } else {
                  ii = indexOf.call(this._longMonthsParse, llc);
                  return ii !== -1 ? ii : null;
                }
              } else {
                if (format === 'MMM') {
                  ii = indexOf.call(this._shortMonthsParse, llc);

                  if (ii !== -1) {
                    return ii;
                  }

                  ii = indexOf.call(this._longMonthsParse, llc);
                  return ii !== -1 ? ii : null;
                } else {
                  ii = indexOf.call(this._longMonthsParse, llc);

                  if (ii !== -1) {
                    return ii;
                  }

                  ii = indexOf.call(this._shortMonthsParse, llc);
                  return ii !== -1 ? ii : null;
                }
              }
            }

            function localeMonthsParse(monthName, format, strict) {
              var i, mom, regex;

              if (this._monthsParseExact) {
                return handleStrictParse.call(this, monthName, format, strict);
              }

              if (!this._monthsParse) {
                this._monthsParse = [];
                this._longMonthsParse = [];
                this._shortMonthsParse = [];
              } // TODO: add sorting
              // Sorting makes sure if one month (or abbr) is a prefix of another
              // see sorting in computeMonthsParse


              for (i = 0; i < 12; i++) {
                // make the regex if we don't have it already
                mom = createUTC([2000, i]);

                if (strict && !this._longMonthsParse[i]) {
                  this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                  this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
                }

                if (!strict && !this._monthsParse[i]) {
                  regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                  this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
                } // test the regex


                if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                  return i;
                } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                  return i;
                } else if (!strict && this._monthsParse[i].test(monthName)) {
                  return i;
                }
              }
            } // MOMENTS


            function setMonth(mom, value) {
              var dayOfMonth;

              if (!mom.isValid()) {
                // No op
                return mom;
              }

              if (typeof value === 'string') {
                if (/^\d+$/.test(value)) {
                  value = toInt(value);
                } else {
                  value = mom.localeData().monthsParse(value); // TODO: Another silent failure?

                  if (!isNumber(value)) {
                    return mom;
                  }
                }
              }

              dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));

              mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);

              return mom;
            }

            function getSetMonth(value) {
              if (value != null) {
                setMonth(this, value);
                hooks.updateOffset(this, true);
                return this;
              } else {
                return get(this, 'Month');
              }
            }

            function getDaysInMonth() {
              return daysInMonth(this.year(), this.month());
            }

            function monthsShortRegex(isStrict) {
              if (this._monthsParseExact) {
                if (!hasOwnProp(this, '_monthsRegex')) {
                  computeMonthsParse.call(this);
                }

                if (isStrict) {
                  return this._monthsShortStrictRegex;
                } else {
                  return this._monthsShortRegex;
                }
              } else {
                if (!hasOwnProp(this, '_monthsShortRegex')) {
                  this._monthsShortRegex = defaultMonthsShortRegex;
                }

                return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
              }
            }

            function monthsRegex(isStrict) {
              if (this._monthsParseExact) {
                if (!hasOwnProp(this, '_monthsRegex')) {
                  computeMonthsParse.call(this);
                }

                if (isStrict) {
                  return this._monthsStrictRegex;
                } else {
                  return this._monthsRegex;
                }
              } else {
                if (!hasOwnProp(this, '_monthsRegex')) {
                  this._monthsRegex = defaultMonthsRegex;
                }

                return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
              }
            }

            function computeMonthsParse() {
              function cmpLenRev(a, b) {
                return b.length - a.length;
              }

              var shortPieces = [],
                  longPieces = [],
                  mixedPieces = [],
                  i,
                  mom;

              for (i = 0; i < 12; i++) {
                // make the regex if we don't have it already
                mom = createUTC([2000, i]);
                shortPieces.push(this.monthsShort(mom, ''));
                longPieces.push(this.months(mom, ''));
                mixedPieces.push(this.months(mom, ''));
                mixedPieces.push(this.monthsShort(mom, ''));
              } // Sorting makes sure if one month (or abbr) is a prefix of another it
              // will match the longer piece.


              shortPieces.sort(cmpLenRev);
              longPieces.sort(cmpLenRev);
              mixedPieces.sort(cmpLenRev);

              for (i = 0; i < 12; i++) {
                shortPieces[i] = regexEscape(shortPieces[i]);
                longPieces[i] = regexEscape(longPieces[i]);
              }

              for (i = 0; i < 24; i++) {
                mixedPieces[i] = regexEscape(mixedPieces[i]);
              }

              this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
              this._monthsShortRegex = this._monthsRegex;
              this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
              this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
            } // FORMATTING


            addFormatToken('Y', 0, 0, function () {
              var y = this.year();
              return y <= 9999 ? zeroFill(y, 4) : '+' + y;
            });
            addFormatToken(0, ['YY', 2], 0, function () {
              return this.year() % 100;
            });
            addFormatToken(0, ['YYYY', 4], 0, 'year');
            addFormatToken(0, ['YYYYY', 5], 0, 'year');
            addFormatToken(0, ['YYYYYY', 6, true], 0, 'year'); // ALIASES

            addUnitAlias('year', 'y'); // PRIORITIES

            addUnitPriority('year', 1); // PARSING

            addRegexToken('Y', matchSigned);
            addRegexToken('YY', match1to2, match2);
            addRegexToken('YYYY', match1to4, match4);
            addRegexToken('YYYYY', match1to6, match6);
            addRegexToken('YYYYYY', match1to6, match6);
            addParseToken(['YYYYY', 'YYYYYY'], YEAR);
            addParseToken('YYYY', function (input, array) {
              array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
            });
            addParseToken('YY', function (input, array) {
              array[YEAR] = hooks.parseTwoDigitYear(input);
            });
            addParseToken('Y', function (input, array) {
              array[YEAR] = parseInt(input, 10);
            }); // HELPERS

            function daysInYear(year) {
              return isLeapYear(year) ? 366 : 365;
            } // HOOKS


            hooks.parseTwoDigitYear = function (input) {
              return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
            }; // MOMENTS


            var getSetYear = makeGetSet('FullYear', true);

            function getIsLeapYear() {
              return isLeapYear(this.year());
            }

            function createDate(y, m, d, h, M, s, ms) {
              // can't just apply() to create a date:
              // https://stackoverflow.com/q/181348
              var date; // the date constructor remaps years 0-99 to 1900-1999

              if (y < 100 && y >= 0) {
                // preserve leap years using a full 400 year cycle, then reset
                date = new Date(y + 400, m, d, h, M, s, ms);

                if (isFinite(date.getFullYear())) {
                  date.setFullYear(y);
                }
              } else {
                date = new Date(y, m, d, h, M, s, ms);
              }

              return date;
            }

            function createUTCDate(y) {
              var date, args; // the Date.UTC function remaps years 0-99 to 1900-1999

              if (y < 100 && y >= 0) {
                args = Array.prototype.slice.call(arguments); // preserve leap years using a full 400 year cycle, then reset

                args[0] = y + 400;
                date = new Date(Date.UTC.apply(null, args));

                if (isFinite(date.getUTCFullYear())) {
                  date.setUTCFullYear(y);
                }
              } else {
                date = new Date(Date.UTC.apply(null, arguments));
              }

              return date;
            } // start-of-first-week - start-of-year


            function firstWeekOffset(year, dow, doy) {
              var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
              fwd = 7 + dow - doy,
                  // first-week day local weekday -- which local weekday is fwd
              fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
              return -fwdlw + fwd - 1;
            } // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday


            function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
              var localWeekday = (7 + weekday - dow) % 7,
                  weekOffset = firstWeekOffset(year, dow, doy),
                  dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
                  resYear,
                  resDayOfYear;

              if (dayOfYear <= 0) {
                resYear = year - 1;
                resDayOfYear = daysInYear(resYear) + dayOfYear;
              } else if (dayOfYear > daysInYear(year)) {
                resYear = year + 1;
                resDayOfYear = dayOfYear - daysInYear(year);
              } else {
                resYear = year;
                resDayOfYear = dayOfYear;
              }

              return {
                year: resYear,
                dayOfYear: resDayOfYear
              };
            }

            function weekOfYear(mom, dow, doy) {
              var weekOffset = firstWeekOffset(mom.year(), dow, doy),
                  week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
                  resWeek,
                  resYear;

              if (week < 1) {
                resYear = mom.year() - 1;
                resWeek = week + weeksInYear(resYear, dow, doy);
              } else if (week > weeksInYear(mom.year(), dow, doy)) {
                resWeek = week - weeksInYear(mom.year(), dow, doy);
                resYear = mom.year() + 1;
              } else {
                resYear = mom.year();
                resWeek = week;
              }

              return {
                week: resWeek,
                year: resYear
              };
            }

            function weeksInYear(year, dow, doy) {
              var weekOffset = firstWeekOffset(year, dow, doy),
                  weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
              return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
            } // FORMATTING


            addFormatToken('w', ['ww', 2], 'wo', 'week');
            addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek'); // ALIASES

            addUnitAlias('week', 'w');
            addUnitAlias('isoWeek', 'W'); // PRIORITIES

            addUnitPriority('week', 5);
            addUnitPriority('isoWeek', 5); // PARSING

            addRegexToken('w', match1to2);
            addRegexToken('ww', match1to2, match2);
            addRegexToken('W', match1to2);
            addRegexToken('WW', match1to2, match2);
            addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
              week[token.substr(0, 1)] = toInt(input);
            }); // HELPERS
            // LOCALES

            function localeWeek(mom) {
              return weekOfYear(mom, this._week.dow, this._week.doy).week;
            }

            var defaultLocaleWeek = {
              dow: 0,
              // Sunday is the first day of the week.
              doy: 6 // The week that contains Jan 6th is the first week of the year.

            };

            function localeFirstDayOfWeek() {
              return this._week.dow;
            }

            function localeFirstDayOfYear() {
              return this._week.doy;
            } // MOMENTS


            function getSetWeek(input) {
              var week = this.localeData().week(this);
              return input == null ? week : this.add((input - week) * 7, 'd');
            }

            function getSetISOWeek(input) {
              var week = weekOfYear(this, 1, 4).week;
              return input == null ? week : this.add((input - week) * 7, 'd');
            } // FORMATTING


            addFormatToken('d', 0, 'do', 'day');
            addFormatToken('dd', 0, 0, function (format) {
              return this.localeData().weekdaysMin(this, format);
            });
            addFormatToken('ddd', 0, 0, function (format) {
              return this.localeData().weekdaysShort(this, format);
            });
            addFormatToken('dddd', 0, 0, function (format) {
              return this.localeData().weekdays(this, format);
            });
            addFormatToken('e', 0, 0, 'weekday');
            addFormatToken('E', 0, 0, 'isoWeekday'); // ALIASES

            addUnitAlias('day', 'd');
            addUnitAlias('weekday', 'e');
            addUnitAlias('isoWeekday', 'E'); // PRIORITY

            addUnitPriority('day', 11);
            addUnitPriority('weekday', 11);
            addUnitPriority('isoWeekday', 11); // PARSING

            addRegexToken('d', match1to2);
            addRegexToken('e', match1to2);
            addRegexToken('E', match1to2);
            addRegexToken('dd', function (isStrict, locale) {
              return locale.weekdaysMinRegex(isStrict);
            });
            addRegexToken('ddd', function (isStrict, locale) {
              return locale.weekdaysShortRegex(isStrict);
            });
            addRegexToken('dddd', function (isStrict, locale) {
              return locale.weekdaysRegex(isStrict);
            });
            addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
              var weekday = config._locale.weekdaysParse(input, token, config._strict); // if we didn't get a weekday name, mark the date as invalid


              if (weekday != null) {
                week.d = weekday;
              } else {
                getParsingFlags(config).invalidWeekday = input;
              }
            });
            addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
              week[token] = toInt(input);
            }); // HELPERS

            function parseWeekday(input, locale) {
              if (typeof input !== 'string') {
                return input;
              }

              if (!isNaN(input)) {
                return parseInt(input, 10);
              }

              input = locale.weekdaysParse(input);

              if (typeof input === 'number') {
                return input;
              }

              return null;
            }

            function parseIsoWeekday(input, locale) {
              if (typeof input === 'string') {
                return locale.weekdaysParse(input) % 7 || 7;
              }

              return isNaN(input) ? null : input;
            } // LOCALES


            function shiftWeekdays(ws, n) {
              return ws.slice(n, 7).concat(ws.slice(0, n));
            }

            var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
                defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
                defaultWeekdaysRegex = matchWord,
                defaultWeekdaysShortRegex = matchWord,
                defaultWeekdaysMinRegex = matchWord;

            function localeWeekdays(m, format) {
              var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
              return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
            }

            function localeWeekdaysShort(m) {
              return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
            }

            function localeWeekdaysMin(m) {
              return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
            }

            function handleStrictParse$1(weekdayName, format, strict) {
              var i,
                  ii,
                  mom,
                  llc = weekdayName.toLocaleLowerCase();

              if (!this._weekdaysParse) {
                this._weekdaysParse = [];
                this._shortWeekdaysParse = [];
                this._minWeekdaysParse = [];

                for (i = 0; i < 7; ++i) {
                  mom = createUTC([2000, 1]).day(i);
                  this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                  this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                  this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
                }
              }

              if (strict) {
                if (format === 'dddd') {
                  ii = indexOf.call(this._weekdaysParse, llc);
                  return ii !== -1 ? ii : null;
                } else if (format === 'ddd') {
                  ii = indexOf.call(this._shortWeekdaysParse, llc);
                  return ii !== -1 ? ii : null;
                } else {
                  ii = indexOf.call(this._minWeekdaysParse, llc);
                  return ii !== -1 ? ii : null;
                }
              } else {
                if (format === 'dddd') {
                  ii = indexOf.call(this._weekdaysParse, llc);

                  if (ii !== -1) {
                    return ii;
                  }

                  ii = indexOf.call(this._shortWeekdaysParse, llc);

                  if (ii !== -1) {
                    return ii;
                  }

                  ii = indexOf.call(this._minWeekdaysParse, llc);
                  return ii !== -1 ? ii : null;
                } else if (format === 'ddd') {
                  ii = indexOf.call(this._shortWeekdaysParse, llc);

                  if (ii !== -1) {
                    return ii;
                  }

                  ii = indexOf.call(this._weekdaysParse, llc);

                  if (ii !== -1) {
                    return ii;
                  }

                  ii = indexOf.call(this._minWeekdaysParse, llc);
                  return ii !== -1 ? ii : null;
                } else {
                  ii = indexOf.call(this._minWeekdaysParse, llc);

                  if (ii !== -1) {
                    return ii;
                  }

                  ii = indexOf.call(this._weekdaysParse, llc);

                  if (ii !== -1) {
                    return ii;
                  }

                  ii = indexOf.call(this._shortWeekdaysParse, llc);
                  return ii !== -1 ? ii : null;
                }
              }
            }

            function localeWeekdaysParse(weekdayName, format, strict) {
              var i, mom, regex;

              if (this._weekdaysParseExact) {
                return handleStrictParse$1.call(this, weekdayName, format, strict);
              }

              if (!this._weekdaysParse) {
                this._weekdaysParse = [];
                this._minWeekdaysParse = [];
                this._shortWeekdaysParse = [];
                this._fullWeekdaysParse = [];
              }

              for (i = 0; i < 7; i++) {
                // make the regex if we don't have it already
                mom = createUTC([2000, 1]).day(i);

                if (strict && !this._fullWeekdaysParse[i]) {
                  this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                  this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                  this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
                }

                if (!this._weekdaysParse[i]) {
                  regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                  this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
                } // test the regex


                if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                  return i;
                } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                  return i;
                } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                  return i;
                } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                  return i;
                }
              }
            } // MOMENTS


            function getSetDayOfWeek(input) {
              if (!this.isValid()) {
                return input != null ? this : NaN;
              }

              var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();

              if (input != null) {
                input = parseWeekday(input, this.localeData());
                return this.add(input - day, 'd');
              } else {
                return day;
              }
            }

            function getSetLocaleDayOfWeek(input) {
              if (!this.isValid()) {
                return input != null ? this : NaN;
              }

              var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
              return input == null ? weekday : this.add(input - weekday, 'd');
            }

            function getSetISODayOfWeek(input) {
              if (!this.isValid()) {
                return input != null ? this : NaN;
              } // behaves the same as moment#day except
              // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
              // as a setter, sunday should belong to the previous week.


              if (input != null) {
                var weekday = parseIsoWeekday(input, this.localeData());
                return this.day(this.day() % 7 ? weekday : weekday - 7);
              } else {
                return this.day() || 7;
              }
            }

            function weekdaysRegex(isStrict) {
              if (this._weekdaysParseExact) {
                if (!hasOwnProp(this, '_weekdaysRegex')) {
                  computeWeekdaysParse.call(this);
                }

                if (isStrict) {
                  return this._weekdaysStrictRegex;
                } else {
                  return this._weekdaysRegex;
                }
              } else {
                if (!hasOwnProp(this, '_weekdaysRegex')) {
                  this._weekdaysRegex = defaultWeekdaysRegex;
                }

                return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
              }
            }

            function weekdaysShortRegex(isStrict) {
              if (this._weekdaysParseExact) {
                if (!hasOwnProp(this, '_weekdaysRegex')) {
                  computeWeekdaysParse.call(this);
                }

                if (isStrict) {
                  return this._weekdaysShortStrictRegex;
                } else {
                  return this._weekdaysShortRegex;
                }
              } else {
                if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                  this._weekdaysShortRegex = defaultWeekdaysShortRegex;
                }

                return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
              }
            }

            function weekdaysMinRegex(isStrict) {
              if (this._weekdaysParseExact) {
                if (!hasOwnProp(this, '_weekdaysRegex')) {
                  computeWeekdaysParse.call(this);
                }

                if (isStrict) {
                  return this._weekdaysMinStrictRegex;
                } else {
                  return this._weekdaysMinRegex;
                }
              } else {
                if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                  this._weekdaysMinRegex = defaultWeekdaysMinRegex;
                }

                return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
              }
            }

            function computeWeekdaysParse() {
              function cmpLenRev(a, b) {
                return b.length - a.length;
              }

              var minPieces = [],
                  shortPieces = [],
                  longPieces = [],
                  mixedPieces = [],
                  i,
                  mom,
                  minp,
                  shortp,
                  longp;

              for (i = 0; i < 7; i++) {
                // make the regex if we don't have it already
                mom = createUTC([2000, 1]).day(i);
                minp = regexEscape(this.weekdaysMin(mom, ''));
                shortp = regexEscape(this.weekdaysShort(mom, ''));
                longp = regexEscape(this.weekdays(mom, ''));
                minPieces.push(minp);
                shortPieces.push(shortp);
                longPieces.push(longp);
                mixedPieces.push(minp);
                mixedPieces.push(shortp);
                mixedPieces.push(longp);
              } // Sorting makes sure if one weekday (or abbr) is a prefix of another it
              // will match the longer piece.


              minPieces.sort(cmpLenRev);
              shortPieces.sort(cmpLenRev);
              longPieces.sort(cmpLenRev);
              mixedPieces.sort(cmpLenRev);
              this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
              this._weekdaysShortRegex = this._weekdaysRegex;
              this._weekdaysMinRegex = this._weekdaysRegex;
              this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
              this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
              this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
            } // FORMATTING


            function hFormat() {
              return this.hours() % 12 || 12;
            }

            function kFormat() {
              return this.hours() || 24;
            }

            addFormatToken('H', ['HH', 2], 0, 'hour');
            addFormatToken('h', ['hh', 2], 0, hFormat);
            addFormatToken('k', ['kk', 2], 0, kFormat);
            addFormatToken('hmm', 0, 0, function () {
              return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
            });
            addFormatToken('hmmss', 0, 0, function () {
              return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
            });
            addFormatToken('Hmm', 0, 0, function () {
              return '' + this.hours() + zeroFill(this.minutes(), 2);
            });
            addFormatToken('Hmmss', 0, 0, function () {
              return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
            });

            function meridiem(token, lowercase) {
              addFormatToken(token, 0, 0, function () {
                return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
              });
            }

            meridiem('a', true);
            meridiem('A', false); // ALIASES

            addUnitAlias('hour', 'h'); // PRIORITY

            addUnitPriority('hour', 13); // PARSING

            function matchMeridiem(isStrict, locale) {
              return locale._meridiemParse;
            }

            addRegexToken('a', matchMeridiem);
            addRegexToken('A', matchMeridiem);
            addRegexToken('H', match1to2);
            addRegexToken('h', match1to2);
            addRegexToken('k', match1to2);
            addRegexToken('HH', match1to2, match2);
            addRegexToken('hh', match1to2, match2);
            addRegexToken('kk', match1to2, match2);
            addRegexToken('hmm', match3to4);
            addRegexToken('hmmss', match5to6);
            addRegexToken('Hmm', match3to4);
            addRegexToken('Hmmss', match5to6);
            addParseToken(['H', 'HH'], HOUR);
            addParseToken(['k', 'kk'], function (input, array, config) {
              var kInput = toInt(input);
              array[HOUR] = kInput === 24 ? 0 : kInput;
            });
            addParseToken(['a', 'A'], function (input, array, config) {
              config._isPm = config._locale.isPM(input);
              config._meridiem = input;
            });
            addParseToken(['h', 'hh'], function (input, array, config) {
              array[HOUR] = toInt(input);
              getParsingFlags(config).bigHour = true;
            });
            addParseToken('hmm', function (input, array, config) {
              var pos = input.length - 2;
              array[HOUR] = toInt(input.substr(0, pos));
              array[MINUTE] = toInt(input.substr(pos));
              getParsingFlags(config).bigHour = true;
            });
            addParseToken('hmmss', function (input, array, config) {
              var pos1 = input.length - 4,
                  pos2 = input.length - 2;
              array[HOUR] = toInt(input.substr(0, pos1));
              array[MINUTE] = toInt(input.substr(pos1, 2));
              array[SECOND] = toInt(input.substr(pos2));
              getParsingFlags(config).bigHour = true;
            });
            addParseToken('Hmm', function (input, array, config) {
              var pos = input.length - 2;
              array[HOUR] = toInt(input.substr(0, pos));
              array[MINUTE] = toInt(input.substr(pos));
            });
            addParseToken('Hmmss', function (input, array, config) {
              var pos1 = input.length - 4,
                  pos2 = input.length - 2;
              array[HOUR] = toInt(input.substr(0, pos1));
              array[MINUTE] = toInt(input.substr(pos1, 2));
              array[SECOND] = toInt(input.substr(pos2));
            }); // LOCALES

            function localeIsPM(input) {
              // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
              // Using charAt should be more compatible.
              return (input + '').toLowerCase().charAt(0) === 'p';
            }

            var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
                // Setting the hour should keep the time, because the user explicitly
            // specified which hour they want. So trying to maintain the same hour (in
            // a new timezone) makes sense. Adding/subtracting hours does not follow
            // this rule.
            getSetHour = makeGetSet('Hours', true);

            function localeMeridiem(hours, minutes, isLower) {
              if (hours > 11) {
                return isLower ? 'pm' : 'PM';
              } else {
                return isLower ? 'am' : 'AM';
              }
            }

            var baseConfig = {
              calendar: defaultCalendar,
              longDateFormat: defaultLongDateFormat,
              invalidDate: defaultInvalidDate,
              ordinal: defaultOrdinal,
              dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
              relativeTime: defaultRelativeTime,
              months: defaultLocaleMonths,
              monthsShort: defaultLocaleMonthsShort,
              week: defaultLocaleWeek,
              weekdays: defaultLocaleWeekdays,
              weekdaysMin: defaultLocaleWeekdaysMin,
              weekdaysShort: defaultLocaleWeekdaysShort,
              meridiemParse: defaultLocaleMeridiemParse
            }; // internal storage for locale config files

            var locales = {},
                localeFamilies = {},
                globalLocale;

            function commonPrefix(arr1, arr2) {
              var i,
                  minl = Math.min(arr1.length, arr2.length);

              for (i = 0; i < minl; i += 1) {
                if (arr1[i] !== arr2[i]) {
                  return i;
                }
              }

              return minl;
            }

            function normalizeLocale(key) {
              return key ? key.toLowerCase().replace('_', '-') : key;
            } // pick the locale from the array
            // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
            // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root


            function chooseLocale(names) {
              var i = 0,
                  j,
                  next,
                  locale,
                  split;

              while (i < names.length) {
                split = normalizeLocale(names[i]).split('-');
                j = split.length;
                next = normalizeLocale(names[i + 1]);
                next = next ? next.split('-') : null;

                while (j > 0) {
                  locale = loadLocale(split.slice(0, j).join('-'));

                  if (locale) {
                    return locale;
                  }

                  if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                  }

                  j--;
                }

                i++;
              }

              return globalLocale;
            }

            function loadLocale(name) {
              var oldLocale = null,
                  aliasedRequire; // TODO: Find a better way to register and load all the locales in Node

              if (locales[name] === undefined && "object" !== 'undefined' && module && module.exports) {
                try {
                  oldLocale = globalLocale._abbr;
                  aliasedRequire = undefined;

                  __webpack_require__(6700)("./" + name);

                  getSetGlobalLocale(oldLocale);
                } catch (e) {
                  // mark as not found to avoid repeating expensive file require call causing high CPU
                  // when trying to find en-US, en_US, en-us for every format call
                  locales[name] = null; // null means not found
                }
              }

              return locales[name];
            } // This function will load locale and then set the global locale.  If
            // no arguments are passed in, it will simply return the current global
            // locale key.


            function getSetGlobalLocale(key, values) {
              var data;

              if (key) {
                if (isUndefined(values)) {
                  data = getLocale(key);
                } else {
                  data = defineLocale(key, values);
                }

                if (data) {
                  // moment.duration._locale = moment._locale = data;
                  globalLocale = data;
                } else {
                  if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key + ' not found. Did you forget to load it?');
                  }
                }
              }

              return globalLocale._abbr;
            }

            function defineLocale(name, config) {
              if (config !== null) {
                var locale,
                    parentConfig = baseConfig;
                config.abbr = name;

                if (locales[name] != null) {
                  deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                  parentConfig = locales[name]._config;
                } else if (config.parentLocale != null) {
                  if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                  } else {
                    locale = loadLocale(config.parentLocale);

                    if (locale != null) {
                      parentConfig = locale._config;
                    } else {
                      if (!localeFamilies[config.parentLocale]) {
                        localeFamilies[config.parentLocale] = [];
                      }

                      localeFamilies[config.parentLocale].push({
                        name: name,
                        config: config
                      });
                      return null;
                    }
                  }
                }

                locales[name] = new Locale(mergeConfigs(parentConfig, config));

                if (localeFamilies[name]) {
                  localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                  });
                } // backwards compat for now: also set the locale
                // make sure we set the locale AFTER all child locales have been
                // created, so we won't end up with the child locale set.


                getSetGlobalLocale(name);
                return locales[name];
              } else {
                // useful for testing
                delete locales[name];
                return null;
              }
            }

            function updateLocale(name, config) {
              if (config != null) {
                var locale,
                    tmpLocale,
                    parentConfig = baseConfig;

                if (locales[name] != null && locales[name].parentLocale != null) {
                  // Update existing child locale in-place to avoid memory-leaks
                  locales[name].set(mergeConfigs(locales[name]._config, config));
                } else {
                  // MERGE
                  tmpLocale = loadLocale(name);

                  if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                  }

                  config = mergeConfigs(parentConfig, config);

                  if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                  }

                  locale = new Locale(config);
                  locale.parentLocale = locales[name];
                  locales[name] = locale;
                } // backwards compat for now: also set the locale


                getSetGlobalLocale(name);
              } else {
                // pass null for config to unupdate, useful for tests
                if (locales[name] != null) {
                  if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;

                    if (name === getSetGlobalLocale()) {
                      getSetGlobalLocale(name);
                    }
                  } else if (locales[name] != null) {
                    delete locales[name];
                  }
                }
              }

              return locales[name];
            } // returns locale data


            function getLocale(key) {
              var locale;

              if (key && key._locale && key._locale._abbr) {
                key = key._locale._abbr;
              }

              if (!key) {
                return globalLocale;
              }

              if (!isArray(key)) {
                //short-circuit everything else
                locale = loadLocale(key);

                if (locale) {
                  return locale;
                }

                key = [key];
              }

              return chooseLocale(key);
            }

            function listLocales() {
              return keys(locales);
            }

            function checkOverflow(m) {
              var overflow,
                  a = m._a;

              if (a && getParsingFlags(m).overflow === -2) {
                overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;

                if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                  overflow = DATE;
                }

                if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                  overflow = WEEK;
                }

                if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                  overflow = WEEKDAY;
                }

                getParsingFlags(m).overflow = overflow;
              }

              return m;
            } // iso 8601 regex
            // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)


            var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
                basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
                tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
                isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/], ['YYYYMM', /\d{6}/, false], ['YYYY', /\d{4}/, false]],
                // iso time formats and regexes
            isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]],
                aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
                // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
            rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
                obsOffsets = {
              UT: 0,
              GMT: 0,
              EDT: -4 * 60,
              EST: -5 * 60,
              CDT: -5 * 60,
              CST: -6 * 60,
              MDT: -6 * 60,
              MST: -7 * 60,
              PDT: -7 * 60,
              PST: -8 * 60
            }; // date from iso format

            function configFromISO(config) {
              var i,
                  l,
                  string = config._i,
                  match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
                  allowTime,
                  dateFormat,
                  timeFormat,
                  tzFormat;

              if (match) {
                getParsingFlags(config).iso = true;

                for (i = 0, l = isoDates.length; i < l; i++) {
                  if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                  }
                }

                if (dateFormat == null) {
                  config._isValid = false;
                  return;
                }

                if (match[3]) {
                  for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                      // match[2] should be 'T' or space
                      timeFormat = (match[2] || ' ') + isoTimes[i][0];
                      break;
                    }
                  }

                  if (timeFormat == null) {
                    config._isValid = false;
                    return;
                  }
                }

                if (!allowTime && timeFormat != null) {
                  config._isValid = false;
                  return;
                }

                if (match[4]) {
                  if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                  } else {
                    config._isValid = false;
                    return;
                  }
                }

                config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
                configFromStringAndFormat(config);
              } else {
                config._isValid = false;
              }
            }

            function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
              var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];

              if (secondStr) {
                result.push(parseInt(secondStr, 10));
              }

              return result;
            }

            function untruncateYear(yearStr) {
              var year = parseInt(yearStr, 10);

              if (year <= 49) {
                return 2000 + year;
              } else if (year <= 999) {
                return 1900 + year;
              }

              return year;
            }

            function preprocessRFC2822(s) {
              // Remove comments and folding whitespace and replace multiple-spaces with a single space
              return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
            }

            function checkWeekday(weekdayStr, parsedInput, config) {
              if (weekdayStr) {
                // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
                var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                    weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();

                if (weekdayProvided !== weekdayActual) {
                  getParsingFlags(config).weekdayMismatch = true;
                  config._isValid = false;
                  return false;
                }
              }

              return true;
            }

            function calculateOffset(obsOffset, militaryOffset, numOffset) {
              if (obsOffset) {
                return obsOffsets[obsOffset];
              } else if (militaryOffset) {
                // the only allowed military tz is Z
                return 0;
              } else {
                var hm = parseInt(numOffset, 10),
                    m = hm % 100,
                    h = (hm - m) / 100;
                return h * 60 + m;
              }
            } // date and time from ref 2822 format


            function configFromRFC2822(config) {
              var match = rfc2822.exec(preprocessRFC2822(config._i)),
                  parsedArray;

              if (match) {
                parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);

                if (!checkWeekday(match[1], parsedArray, config)) {
                  return;
                }

                config._a = parsedArray;
                config._tzm = calculateOffset(match[8], match[9], match[10]);
                config._d = createUTCDate.apply(null, config._a);

                config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

                getParsingFlags(config).rfc2822 = true;
              } else {
                config._isValid = false;
              }
            } // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict


            function configFromString(config) {
              var matched = aspNetJsonRegex.exec(config._i);

              if (matched !== null) {
                config._d = new Date(+matched[1]);
                return;
              }

              configFromISO(config);

              if (config._isValid === false) {
                delete config._isValid;
              } else {
                return;
              }

              configFromRFC2822(config);

              if (config._isValid === false) {
                delete config._isValid;
              } else {
                return;
              }

              if (config._strict) {
                config._isValid = false;
              } else {
                // Final attempt, use Input Fallback
                hooks.createFromInputFallback(config);
              }
            }

            hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
              config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
            }); // Pick the first defined of two or three arguments.

            function defaults(a, b, c) {
              if (a != null) {
                return a;
              }

              if (b != null) {
                return b;
              }

              return c;
            }

            function currentDateArray(config) {
              // hooks is actually the exported moment object
              var nowValue = new Date(hooks.now());

              if (config._useUTC) {
                return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
              }

              return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
            } // convert an array to a date.
            // the array should mirror the parameters below
            // note: all values past the year are optional and will default to the lowest possible value.
            // [year, month, day , hour, minute, second, millisecond]


            function configFromArray(config) {
              var i,
                  date,
                  input = [],
                  currentDate,
                  expectedWeekday,
                  yearToUse;

              if (config._d) {
                return;
              }

              currentDate = currentDateArray(config); //compute day of the year from weeks and weekdays

              if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
                dayOfYearFromWeekInfo(config);
              } //if the day of the year is set, figure out what it is


              if (config._dayOfYear != null) {
                yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

                if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                  getParsingFlags(config)._overflowDayOfYear = true;
                }

                date = createUTCDate(yearToUse, 0, config._dayOfYear);
                config._a[MONTH] = date.getUTCMonth();
                config._a[DATE] = date.getUTCDate();
              } // Default to current date.
              // * if no year, month, day of month are given, default to today
              // * if day of month is given, default month and year
              // * if month is given, default only year
              // * if year is given, don't default anything


              for (i = 0; i < 3 && config._a[i] == null; ++i) {
                config._a[i] = input[i] = currentDate[i];
              } // Zero out whatever was not defaulted, including time


              for (; i < 7; i++) {
                config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
              } // Check for 24:00:00.000


              if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
                config._nextDay = true;
                config._a[HOUR] = 0;
              }

              config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
              expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay(); // Apply timezone offset from input. The actual utcOffset can be changed
              // with parseZone.

              if (config._tzm != null) {
                config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
              }

              if (config._nextDay) {
                config._a[HOUR] = 24;
              } // check for mismatching day of week


              if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
                getParsingFlags(config).weekdayMismatch = true;
              }
            }

            function dayOfYearFromWeekInfo(config) {
              var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
              w = config._w;

              if (w.GG != null || w.W != null || w.E != null) {
                dow = 1;
                doy = 4; // TODO: We need to take the current isoWeekYear, but that depends on
                // how we interpret now (local, utc, fixed offset). So create
                // a now version of current config (take local/utc/offset flags, and
                // create now).

                weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
                week = defaults(w.W, 1);
                weekday = defaults(w.E, 1);

                if (weekday < 1 || weekday > 7) {
                  weekdayOverflow = true;
                }
              } else {
                dow = config._locale._week.dow;
                doy = config._locale._week.doy;
                curWeek = weekOfYear(createLocal(), dow, doy);
                weekYear = defaults(w.gg, config._a[YEAR], curWeek.year); // Default to current week.

                week = defaults(w.w, curWeek.week);

                if (w.d != null) {
                  // weekday -- low day numbers are considered next week
                  weekday = w.d;

                  if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                  }
                } else if (w.e != null) {
                  // local weekday -- counting starts from beginning of week
                  weekday = w.e + dow;

                  if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                  }
                } else {
                  // default to beginning of week
                  weekday = dow;
                }
              }

              if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
                getParsingFlags(config)._overflowWeeks = true;
              } else if (weekdayOverflow != null) {
                getParsingFlags(config)._overflowWeekday = true;
              } else {
                temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
                config._a[YEAR] = temp.year;
                config._dayOfYear = temp.dayOfYear;
              }
            } // constant that refers to the ISO standard


            hooks.ISO_8601 = function () {}; // constant that refers to the RFC 2822 form


            hooks.RFC_2822 = function () {}; // date from string and format string


            function configFromStringAndFormat(config) {
              // TODO: Move this to another part of the creation flow to prevent circular deps
              if (config._f === hooks.ISO_8601) {
                configFromISO(config);
                return;
              }

              if (config._f === hooks.RFC_2822) {
                configFromRFC2822(config);
                return;
              }

              config._a = [];
              getParsingFlags(config).empty = true; // This array is used to make a Date, either with `new Date` or `Date.UTC`

              var string = '' + config._i,
                  i,
                  parsedInput,
                  tokens,
                  token,
                  skipped,
                  stringLength = string.length,
                  totalParsedInputLength = 0,
                  era;
              tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

              for (i = 0; i < tokens.length; i++) {
                token = tokens[i];
                parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];

                if (parsedInput) {
                  skipped = string.substr(0, string.indexOf(parsedInput));

                  if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                  }

                  string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                  totalParsedInputLength += parsedInput.length;
                } // don't parse if it's not a known token


                if (formatTokenFunctions[token]) {
                  if (parsedInput) {
                    getParsingFlags(config).empty = false;
                  } else {
                    getParsingFlags(config).unusedTokens.push(token);
                  }

                  addTimeToArrayFromToken(token, parsedInput, config);
                } else if (config._strict && !parsedInput) {
                  getParsingFlags(config).unusedTokens.push(token);
                }
              } // add remaining unparsed input length to the string


              getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;

              if (string.length > 0) {
                getParsingFlags(config).unusedInput.push(string);
              } // clear _12h flag if hour is <= 12


              if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
                getParsingFlags(config).bigHour = undefined;
              }

              getParsingFlags(config).parsedDateParts = config._a.slice(0);
              getParsingFlags(config).meridiem = config._meridiem; // handle meridiem

              config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem); // handle era

              era = getParsingFlags(config).era;

              if (era !== null) {
                config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
              }

              configFromArray(config);
              checkOverflow(config);
            }

            function meridiemFixWrap(locale, hour, meridiem) {
              var isPm;

              if (meridiem == null) {
                // nothing to do
                return hour;
              }

              if (locale.meridiemHour != null) {
                return locale.meridiemHour(hour, meridiem);
              } else if (locale.isPM != null) {
                // Fallback
                isPm = locale.isPM(meridiem);

                if (isPm && hour < 12) {
                  hour += 12;
                }

                if (!isPm && hour === 12) {
                  hour = 0;
                }

                return hour;
              } else {
                // this is not supposed to happen
                return hour;
              }
            } // date from string and array of format strings


            function configFromStringAndArray(config) {
              var tempConfig,
                  bestMoment,
                  scoreToBeat,
                  i,
                  currentScore,
                  validFormatFound,
                  bestFormatIsValid = false;

              if (config._f.length === 0) {
                getParsingFlags(config).invalidFormat = true;
                config._d = new Date(NaN);
                return;
              }

              for (i = 0; i < config._f.length; i++) {
                currentScore = 0;
                validFormatFound = false;
                tempConfig = copyConfig({}, config);

                if (config._useUTC != null) {
                  tempConfig._useUTC = config._useUTC;
                }

                tempConfig._f = config._f[i];
                configFromStringAndFormat(tempConfig);

                if (isValid(tempConfig)) {
                  validFormatFound = true;
                } // if there is any input that was not parsed add a penalty for that format


                currentScore += getParsingFlags(tempConfig).charsLeftOver; //or tokens

                currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
                getParsingFlags(tempConfig).score = currentScore;

                if (!bestFormatIsValid) {
                  if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;

                    if (validFormatFound) {
                      bestFormatIsValid = true;
                    }
                  }
                } else {
                  if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                  }
                }
              }

              extend(config, bestMoment || tempConfig);
            }

            function configFromObject(config) {
              if (config._d) {
                return;
              }

              var i = normalizeObjectUnits(config._i),
                  dayOrDate = i.day === undefined ? i.date : i.day;
              config._a = map([i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond], function (obj) {
                return obj && parseInt(obj, 10);
              });
              configFromArray(config);
            }

            function createFromConfig(config) {
              var res = new Moment(checkOverflow(prepareConfig(config)));

              if (res._nextDay) {
                // Adding is smart enough around DST
                res.add(1, 'd');
                res._nextDay = undefined;
              }

              return res;
            }

            function prepareConfig(config) {
              var input = config._i,
                  format = config._f;
              config._locale = config._locale || getLocale(config._l);

              if (input === null || format === undefined && input === '') {
                return createInvalid({
                  nullInput: true
                });
              }

              if (typeof input === 'string') {
                config._i = input = config._locale.preparse(input);
              }

              if (isMoment(input)) {
                return new Moment(checkOverflow(input));
              } else if (isDate(input)) {
                config._d = input;
              } else if (isArray(format)) {
                configFromStringAndArray(config);
              } else if (format) {
                configFromStringAndFormat(config);
              } else {
                configFromInput(config);
              }

              if (!isValid(config)) {
                config._d = null;
              }

              return config;
            }

            function configFromInput(config) {
              var input = config._i;

              if (isUndefined(input)) {
                config._d = new Date(hooks.now());
              } else if (isDate(input)) {
                config._d = new Date(input.valueOf());
              } else if (typeof input === 'string') {
                configFromString(config);
              } else if (isArray(input)) {
                config._a = map(input.slice(0), function (obj) {
                  return parseInt(obj, 10);
                });
                configFromArray(config);
              } else if (isObject(input)) {
                configFromObject(config);
              } else if (isNumber(input)) {
                // from milliseconds
                config._d = new Date(input);
              } else {
                hooks.createFromInputFallback(config);
              }
            }

            function createLocalOrUTC(input, format, locale, strict, isUTC) {
              var c = {};

              if (format === true || format === false) {
                strict = format;
                format = undefined;
              }

              if (locale === true || locale === false) {
                strict = locale;
                locale = undefined;
              }

              if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
                input = undefined;
              } // object construction must be done this way.
              // https://github.com/moment/moment/issues/1423


              c._isAMomentObject = true;
              c._useUTC = c._isUTC = isUTC;
              c._l = locale;
              c._i = input;
              c._f = format;
              c._strict = strict;
              return createFromConfig(c);
            }

            function createLocal(input, format, locale, strict) {
              return createLocalOrUTC(input, format, locale, strict, false);
            }

            var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
              var other = createLocal.apply(null, arguments);

              if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
              } else {
                return createInvalid();
              }
            }),
                prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
              var other = createLocal.apply(null, arguments);

              if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
              } else {
                return createInvalid();
              }
            }); // Pick a moment m from moments so that m[fn](other) is true for all
            // other. This relies on the function fn to be transitive.
            //
            // moments should either be an array of moment objects or an array, whose
            // first element is an array of moment objects.

            function pickBy(fn, moments) {
              var res, i;

              if (moments.length === 1 && isArray(moments[0])) {
                moments = moments[0];
              }

              if (!moments.length) {
                return createLocal();
              }

              res = moments[0];

              for (i = 1; i < moments.length; ++i) {
                if (!moments[i].isValid() || moments[i][fn](res)) {
                  res = moments[i];
                }
              }

              return res;
            } // TODO: Use [].sort instead?


            function min() {
              var args = [].slice.call(arguments, 0);
              return pickBy('isBefore', args);
            }

            function max() {
              var args = [].slice.call(arguments, 0);
              return pickBy('isAfter', args);
            }

            var now = function now() {
              return Date.now ? Date.now() : +new Date();
            };

            var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

            function isDurationValid(m) {
              var key,
                  unitHasDecimal = false,
                  i;

              for (key in m) {
                if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                  return false;
                }
              }

              for (i = 0; i < ordering.length; ++i) {
                if (m[ordering[i]]) {
                  if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                  }

                  if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                  }
                }
              }

              return true;
            }

            function isValid$1() {
              return this._isValid;
            }

            function createInvalid$1() {
              return createDuration(NaN);
            }

            function Duration(duration) {
              var normalizedInput = normalizeObjectUnits(duration),
                  years = normalizedInput.year || 0,
                  quarters = normalizedInput.quarter || 0,
                  months = normalizedInput.month || 0,
                  weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
                  days = normalizedInput.day || 0,
                  hours = normalizedInput.hour || 0,
                  minutes = normalizedInput.minute || 0,
                  seconds = normalizedInput.second || 0,
                  milliseconds = normalizedInput.millisecond || 0;
              this._isValid = isDurationValid(normalizedInput); // representation for dateAddRemove

              this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
              minutes * 6e4 + // 1000 * 60
              hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
              // Because of dateAddRemove treats 24 hours as different from a
              // day when working around DST, we need to store them separately

              this._days = +days + weeks * 7; // It is impossible to translate months into days without knowing
              // which months you are are talking about, so we have to store
              // it separately.

              this._months = +months + quarters * 3 + years * 12;
              this._data = {};
              this._locale = getLocale();

              this._bubble();
            }

            function isDuration(obj) {
              return obj instanceof Duration;
            }

            function absRound(number) {
              if (number < 0) {
                return Math.round(-1 * number) * -1;
              } else {
                return Math.round(number);
              }
            } // compare two arrays, return the number of differences


            function compareArrays(array1, array2, dontConvert) {
              var len = Math.min(array1.length, array2.length),
                  lengthDiff = Math.abs(array1.length - array2.length),
                  diffs = 0,
                  i;

              for (i = 0; i < len; i++) {
                if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
                  diffs++;
                }
              }

              return diffs + lengthDiff;
            } // FORMATTING


            function offset(token, separator) {
              addFormatToken(token, 0, 0, function () {
                var offset = this.utcOffset(),
                    sign = '+';

                if (offset < 0) {
                  offset = -offset;
                  sign = '-';
                }

                return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
              });
            }

            offset('Z', ':');
            offset('ZZ', ''); // PARSING

            addRegexToken('Z', matchShortOffset);
            addRegexToken('ZZ', matchShortOffset);
            addParseToken(['Z', 'ZZ'], function (input, array, config) {
              config._useUTC = true;
              config._tzm = offsetFromString(matchShortOffset, input);
            }); // HELPERS
            // timezone chunker
            // '+10:00' > ['10',  '00']
            // '-1530'  > ['-15', '30']

            var chunkOffset = /([\+\-]|\d\d)/gi;

            function offsetFromString(matcher, string) {
              var matches = (string || '').match(matcher),
                  chunk,
                  parts,
                  minutes;

              if (matches === null) {
                return null;
              }

              chunk = matches[matches.length - 1] || [];
              parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
              minutes = +(parts[1] * 60) + toInt(parts[2]);
              return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
            } // Return a moment from input, that is local/utc/zone equivalent to model.


            function cloneWithOffset(input, model) {
              var res, diff;

              if (model._isUTC) {
                res = model.clone();
                diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf(); // Use low-level api, because this fn is low-level api.

                res._d.setTime(res._d.valueOf() + diff);

                hooks.updateOffset(res, false);
                return res;
              } else {
                return createLocal(input).local();
              }
            }

            function getDateOffset(m) {
              // On Firefox.24 Date#getTimezoneOffset returns a floating point.
              // https://github.com/moment/moment/pull/1871
              return -Math.round(m._d.getTimezoneOffset());
            } // HOOKS
            // This function will be called whenever a moment is mutated.
            // It is intended to keep the offset in sync with the timezone.


            hooks.updateOffset = function () {}; // MOMENTS
            // keepLocalTime = true means only change the timezone, without
            // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
            // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
            // +0200, so we adjust the time as needed, to be valid.
            //
            // Keeping the time actually adds/subtracts (one hour)
            // from the actual represented time. That is why we call updateOffset
            // a second time. In case it wants us to change the offset again
            // _changeInProgress == true case, then we have to adjust, because
            // there is no such time in the given timezone.


            function getSetOffset(input, keepLocalTime, keepMinutes) {
              var offset = this._offset || 0,
                  localAdjust;

              if (!this.isValid()) {
                return input != null ? this : NaN;
              }

              if (input != null) {
                if (typeof input === 'string') {
                  input = offsetFromString(matchShortOffset, input);

                  if (input === null) {
                    return this;
                  }
                } else if (Math.abs(input) < 16 && !keepMinutes) {
                  input = input * 60;
                }

                if (!this._isUTC && keepLocalTime) {
                  localAdjust = getDateOffset(this);
                }

                this._offset = input;
                this._isUTC = true;

                if (localAdjust != null) {
                  this.add(localAdjust, 'm');
                }

                if (offset !== input) {
                  if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                  } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                  }
                }

                return this;
              } else {
                return this._isUTC ? offset : getDateOffset(this);
              }
            }

            function getSetZone(input, keepLocalTime) {
              if (input != null) {
                if (typeof input !== 'string') {
                  input = -input;
                }

                this.utcOffset(input, keepLocalTime);
                return this;
              } else {
                return -this.utcOffset();
              }
            }

            function setOffsetToUTC(keepLocalTime) {
              return this.utcOffset(0, keepLocalTime);
            }

            function setOffsetToLocal(keepLocalTime) {
              if (this._isUTC) {
                this.utcOffset(0, keepLocalTime);
                this._isUTC = false;

                if (keepLocalTime) {
                  this.subtract(getDateOffset(this), 'm');
                }
              }

              return this;
            }

            function setOffsetToParsedOffset() {
              if (this._tzm != null) {
                this.utcOffset(this._tzm, false, true);
              } else if (typeof this._i === 'string') {
                var tZone = offsetFromString(matchOffset, this._i);

                if (tZone != null) {
                  this.utcOffset(tZone);
                } else {
                  this.utcOffset(0, true);
                }
              }

              return this;
            }

            function hasAlignedHourOffset(input) {
              if (!this.isValid()) {
                return false;
              }

              input = input ? createLocal(input).utcOffset() : 0;
              return (this.utcOffset() - input) % 60 === 0;
            }

            function isDaylightSavingTime() {
              return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
            }

            function isDaylightSavingTimeShifted() {
              if (!isUndefined(this._isDSTShifted)) {
                return this._isDSTShifted;
              }

              var c = {},
                  other;
              copyConfig(c, this);
              c = prepareConfig(c);

              if (c._a) {
                other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
                this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
              } else {
                this._isDSTShifted = false;
              }

              return this._isDSTShifted;
            }

            function isLocal() {
              return this.isValid() ? !this._isUTC : false;
            }

            function isUtcOffset() {
              return this.isValid() ? this._isUTC : false;
            }

            function isUtc() {
              return this.isValid() ? this._isUTC && this._offset === 0 : false;
            } // ASP.NET json date format regex


            var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
                // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
            // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
            // and further modified to allow for strings containing both week and day
            isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

            function createDuration(input, key) {
              var duration = input,
                  // matching against regexp is expensive, do it on demand
              match = null,
                  sign,
                  ret,
                  diffRes;

              if (isDuration(input)) {
                duration = {
                  ms: input._milliseconds,
                  d: input._days,
                  M: input._months
                };
              } else if (isNumber(input) || !isNaN(+input)) {
                duration = {};

                if (key) {
                  duration[key] = +input;
                } else {
                  duration.milliseconds = +input;
                }
              } else if (match = aspNetRegex.exec(input)) {
                sign = match[1] === '-' ? -1 : 1;
                duration = {
                  y: 0,
                  d: toInt(match[DATE]) * sign,
                  h: toInt(match[HOUR]) * sign,
                  m: toInt(match[MINUTE]) * sign,
                  s: toInt(match[SECOND]) * sign,
                  ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match

                };
              } else if (match = isoRegex.exec(input)) {
                sign = match[1] === '-' ? -1 : 1;
                duration = {
                  y: parseIso(match[2], sign),
                  M: parseIso(match[3], sign),
                  w: parseIso(match[4], sign),
                  d: parseIso(match[5], sign),
                  h: parseIso(match[6], sign),
                  m: parseIso(match[7], sign),
                  s: parseIso(match[8], sign)
                };
              } else if (duration == null) {
                // checks for null or undefined
                duration = {};
              } else if (_typeof2(duration) === 'object' && ('from' in duration || 'to' in duration)) {
                diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
                duration = {};
                duration.ms = diffRes.milliseconds;
                duration.M = diffRes.months;
              }

              ret = new Duration(duration);

              if (isDuration(input) && hasOwnProp(input, '_locale')) {
                ret._locale = input._locale;
              }

              if (isDuration(input) && hasOwnProp(input, '_isValid')) {
                ret._isValid = input._isValid;
              }

              return ret;
            }

            createDuration.fn = Duration.prototype;
            createDuration.invalid = createInvalid$1;

            function parseIso(inp, sign) {
              // We'd normally use ~~inp for this, but unfortunately it also
              // converts floats to ints.
              // inp may be undefined, so careful calling replace on it.
              var res = inp && parseFloat(inp.replace(',', '.')); // apply sign while we're at it

              return (isNaN(res) ? 0 : res) * sign;
            }

            function positiveMomentsDifference(base, other) {
              var res = {};
              res.months = other.month() - base.month() + (other.year() - base.year()) * 12;

              if (base.clone().add(res.months, 'M').isAfter(other)) {
                --res.months;
              }

              res.milliseconds = +other - +base.clone().add(res.months, 'M');
              return res;
            }

            function momentsDifference(base, other) {
              var res;

              if (!(base.isValid() && other.isValid())) {
                return {
                  milliseconds: 0,
                  months: 0
                };
              }

              other = cloneWithOffset(other, base);

              if (base.isBefore(other)) {
                res = positiveMomentsDifference(base, other);
              } else {
                res = positiveMomentsDifference(other, base);
                res.milliseconds = -res.milliseconds;
                res.months = -res.months;
              }

              return res;
            } // TODO: remove 'name' arg after deprecation is removed


            function createAdder(direction, name) {
              return function (val, period) {
                var dur, tmp; //invert the arguments, but complain about it

                if (period !== null && !isNaN(+period)) {
                  deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                  tmp = val;
                  val = period;
                  period = tmp;
                }

                dur = createDuration(val, period);
                addSubtract(this, dur, direction);
                return this;
              };
            }

            function addSubtract(mom, duration, isAdding, updateOffset) {
              var milliseconds = duration._milliseconds,
                  days = absRound(duration._days),
                  months = absRound(duration._months);

              if (!mom.isValid()) {
                // No op
                return;
              }

              updateOffset = updateOffset == null ? true : updateOffset;

              if (months) {
                setMonth(mom, get(mom, 'Month') + months * isAdding);
              }

              if (days) {
                set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
              }

              if (milliseconds) {
                mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
              }

              if (updateOffset) {
                hooks.updateOffset(mom, days || months);
              }
            }

            var add = createAdder(1, 'add'),
                subtract = createAdder(-1, 'subtract');

            function isString(input) {
              return typeof input === 'string' || input instanceof String;
            } // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined


            function isMomentInput(input) {
              return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
            }

            function isMomentInputObject(input) {
              var objectTest = isObject(input) && !isObjectEmpty(input),
                  propertyTest = false,
                  properties = ['years', 'year', 'y', 'months', 'month', 'M', 'days', 'day', 'd', 'dates', 'date', 'D', 'hours', 'hour', 'h', 'minutes', 'minute', 'm', 'seconds', 'second', 's', 'milliseconds', 'millisecond', 'ms'],
                  i,
                  property;

              for (i = 0; i < properties.length; i += 1) {
                property = properties[i];
                propertyTest = propertyTest || hasOwnProp(input, property);
              }

              return objectTest && propertyTest;
            }

            function isNumberOrStringArray(input) {
              var arrayTest = isArray(input),
                  dataTypeTest = false;

              if (arrayTest) {
                dataTypeTest = input.filter(function (item) {
                  return !isNumber(item) && isString(input);
                }).length === 0;
              }

              return arrayTest && dataTypeTest;
            }

            function isCalendarSpec(input) {
              var objectTest = isObject(input) && !isObjectEmpty(input),
                  propertyTest = false,
                  properties = ['sameDay', 'nextDay', 'lastDay', 'nextWeek', 'lastWeek', 'sameElse'],
                  i,
                  property;

              for (i = 0; i < properties.length; i += 1) {
                property = properties[i];
                propertyTest = propertyTest || hasOwnProp(input, property);
              }

              return objectTest && propertyTest;
            }

            function getCalendarFormat(myMoment, now) {
              var diff = myMoment.diff(now, 'days', true);
              return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
            }

            function calendar$1(time, formats) {
              // Support for single parameter, formats only overload to the calendar function
              if (arguments.length === 1) {
                if (!arguments[0]) {
                  time = undefined;
                  formats = undefined;
                } else if (isMomentInput(arguments[0])) {
                  time = arguments[0];
                  formats = undefined;
                } else if (isCalendarSpec(arguments[0])) {
                  formats = arguments[0];
                  time = undefined;
                }
              } // We want to compare the start of today, vs this.
              // Getting start-of-today depends on whether we're local/utc/offset or not.


              var now = time || createLocal(),
                  sod = cloneWithOffset(now, this).startOf('day'),
                  format = hooks.calendarFormat(this, sod) || 'sameElse',
                  output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
              return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
            }

            function clone() {
              return new Moment(this);
            }

            function isAfter(input, units) {
              var localInput = isMoment(input) ? input : createLocal(input);

              if (!(this.isValid() && localInput.isValid())) {
                return false;
              }

              units = normalizeUnits(units) || 'millisecond';

              if (units === 'millisecond') {
                return this.valueOf() > localInput.valueOf();
              } else {
                return localInput.valueOf() < this.clone().startOf(units).valueOf();
              }
            }

            function isBefore(input, units) {
              var localInput = isMoment(input) ? input : createLocal(input);

              if (!(this.isValid() && localInput.isValid())) {
                return false;
              }

              units = normalizeUnits(units) || 'millisecond';

              if (units === 'millisecond') {
                return this.valueOf() < localInput.valueOf();
              } else {
                return this.clone().endOf(units).valueOf() < localInput.valueOf();
              }
            }

            function isBetween(from, to, units, inclusivity) {
              var localFrom = isMoment(from) ? from : createLocal(from),
                  localTo = isMoment(to) ? to : createLocal(to);

              if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
                return false;
              }

              inclusivity = inclusivity || '()';
              return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
            }

            function isSame(input, units) {
              var localInput = isMoment(input) ? input : createLocal(input),
                  inputMs;

              if (!(this.isValid() && localInput.isValid())) {
                return false;
              }

              units = normalizeUnits(units) || 'millisecond';

              if (units === 'millisecond') {
                return this.valueOf() === localInput.valueOf();
              } else {
                inputMs = localInput.valueOf();
                return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
              }
            }

            function isSameOrAfter(input, units) {
              return this.isSame(input, units) || this.isAfter(input, units);
            }

            function isSameOrBefore(input, units) {
              return this.isSame(input, units) || this.isBefore(input, units);
            }

            function diff(input, units, asFloat) {
              var that, zoneDelta, output;

              if (!this.isValid()) {
                return NaN;
              }

              that = cloneWithOffset(input, this);

              if (!that.isValid()) {
                return NaN;
              }

              zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
              units = normalizeUnits(units);

              switch (units) {
                case 'year':
                  output = monthDiff(this, that) / 12;
                  break;

                case 'month':
                  output = monthDiff(this, that);
                  break;

                case 'quarter':
                  output = monthDiff(this, that) / 3;
                  break;

                case 'second':
                  output = (this - that) / 1e3;
                  break;
                // 1000

                case 'minute':
                  output = (this - that) / 6e4;
                  break;
                // 1000 * 60

                case 'hour':
                  output = (this - that) / 36e5;
                  break;
                // 1000 * 60 * 60

                case 'day':
                  output = (this - that - zoneDelta) / 864e5;
                  break;
                // 1000 * 60 * 60 * 24, negate dst

                case 'week':
                  output = (this - that - zoneDelta) / 6048e5;
                  break;
                // 1000 * 60 * 60 * 24 * 7, negate dst

                default:
                  output = this - that;
              }

              return asFloat ? output : absFloor(output);
            }

            function monthDiff(a, b) {
              if (a.date() < b.date()) {
                // end-of-month calculations work correct when the start month has more
                // days than the end month.
                return -monthDiff(b, a);
              } // difference in months


              var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
                  // b is in (anchor - 1 month, anchor + 1 month)
              anchor = a.clone().add(wholeMonthDiff, 'months'),
                  anchor2,
                  adjust;

              if (b - anchor < 0) {
                anchor2 = a.clone().add(wholeMonthDiff - 1, 'months'); // linear across the month

                adjust = (b - anchor) / (anchor - anchor2);
              } else {
                anchor2 = a.clone().add(wholeMonthDiff + 1, 'months'); // linear across the month

                adjust = (b - anchor) / (anchor2 - anchor);
              } //check for negative zero, return zero if negative zero


              return -(wholeMonthDiff + adjust) || 0;
            }

            hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
            hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

            function toString() {
              return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
            }

            function toISOString(keepOffset) {
              if (!this.isValid()) {
                return null;
              }

              var utc = keepOffset !== true,
                  m = utc ? this.clone().utc() : this;

              if (m.year() < 0 || m.year() > 9999) {
                return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
              }

              if (isFunction(Date.prototype.toISOString)) {
                // native implementation is ~50x faster, use it when we can
                if (utc) {
                  return this.toDate().toISOString();
                } else {
                  return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
                }
              }

              return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
            }
            /**
             * Return a human readable representation of a moment that can
             * also be evaluated to get a new moment which is the same
             *
             * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
             */


            function inspect() {
              if (!this.isValid()) {
                return 'moment.invalid(/* ' + this._i + ' */)';
              }

              var func = 'moment',
                  zone = '',
                  prefix,
                  year,
                  datetime,
                  suffix;

              if (!this.isLocal()) {
                func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
                zone = 'Z';
              }

              prefix = '[' + func + '("]';
              year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
              datetime = '-MM-DD[T]HH:mm:ss.SSS';
              suffix = zone + '[")]';
              return this.format(prefix + year + datetime + suffix);
            }

            function format(inputString) {
              if (!inputString) {
                inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
              }

              var output = formatMoment(this, inputString);
              return this.localeData().postformat(output);
            }

            function from(time, withoutSuffix) {
              if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
                return createDuration({
                  to: this,
                  from: time
                }).locale(this.locale()).humanize(!withoutSuffix);
              } else {
                return this.localeData().invalidDate();
              }
            }

            function fromNow(withoutSuffix) {
              return this.from(createLocal(), withoutSuffix);
            }

            function to(time, withoutSuffix) {
              if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
                return createDuration({
                  from: this,
                  to: time
                }).locale(this.locale()).humanize(!withoutSuffix);
              } else {
                return this.localeData().invalidDate();
              }
            }

            function toNow(withoutSuffix) {
              return this.to(createLocal(), withoutSuffix);
            } // If passed a locale key, it will set the locale for this
            // instance.  Otherwise, it will return the locale configuration
            // variables for this instance.


            function locale(key) {
              var newLocaleData;

              if (key === undefined) {
                return this._locale._abbr;
              } else {
                newLocaleData = getLocale(key);

                if (newLocaleData != null) {
                  this._locale = newLocaleData;
                }

                return this;
              }
            }

            var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
              if (key === undefined) {
                return this.localeData();
              } else {
                return this.locale(key);
              }
            });

            function localeData() {
              return this._locale;
            }

            var MS_PER_SECOND = 1000,
                MS_PER_MINUTE = 60 * MS_PER_SECOND,
                MS_PER_HOUR = 60 * MS_PER_MINUTE,
                MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR; // actual modulo - handles negative numbers (for dates before 1970):

            function mod$1(dividend, divisor) {
              return (dividend % divisor + divisor) % divisor;
            }

            function localStartOfDate(y, m, d) {
              // the date constructor remaps years 0-99 to 1900-1999
              if (y < 100 && y >= 0) {
                // preserve leap years using a full 400 year cycle, then reset
                return new Date(y + 400, m, d) - MS_PER_400_YEARS;
              } else {
                return new Date(y, m, d).valueOf();
              }
            }

            function utcStartOfDate(y, m, d) {
              // Date.UTC remaps years 0-99 to 1900-1999
              if (y < 100 && y >= 0) {
                // preserve leap years using a full 400 year cycle, then reset
                return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
              } else {
                return Date.UTC(y, m, d);
              }
            }

            function startOf(units) {
              var time, startOfDate;
              units = normalizeUnits(units);

              if (units === undefined || units === 'millisecond' || !this.isValid()) {
                return this;
              }

              startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

              switch (units) {
                case 'year':
                  time = startOfDate(this.year(), 0, 1);
                  break;

                case 'quarter':
                  time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                  break;

                case 'month':
                  time = startOfDate(this.year(), this.month(), 1);
                  break;

                case 'week':
                  time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                  break;

                case 'isoWeek':
                  time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                  break;

                case 'day':
                case 'date':
                  time = startOfDate(this.year(), this.month(), this.date());
                  break;

                case 'hour':
                  time = this._d.valueOf();
                  time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                  break;

                case 'minute':
                  time = this._d.valueOf();
                  time -= mod$1(time, MS_PER_MINUTE);
                  break;

                case 'second':
                  time = this._d.valueOf();
                  time -= mod$1(time, MS_PER_SECOND);
                  break;
              }

              this._d.setTime(time);

              hooks.updateOffset(this, true);
              return this;
            }

            function endOf(units) {
              var time, startOfDate;
              units = normalizeUnits(units);

              if (units === undefined || units === 'millisecond' || !this.isValid()) {
                return this;
              }

              startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

              switch (units) {
                case 'year':
                  time = startOfDate(this.year() + 1, 0, 1) - 1;
                  break;

                case 'quarter':
                  time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                  break;

                case 'month':
                  time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                  break;

                case 'week':
                  time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                  break;

                case 'isoWeek':
                  time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                  break;

                case 'day':
                case 'date':
                  time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                  break;

                case 'hour':
                  time = this._d.valueOf();
                  time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                  break;

                case 'minute':
                  time = this._d.valueOf();
                  time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                  break;

                case 'second':
                  time = this._d.valueOf();
                  time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                  break;
              }

              this._d.setTime(time);

              hooks.updateOffset(this, true);
              return this;
            }

            function valueOf() {
              return this._d.valueOf() - (this._offset || 0) * 60000;
            }

            function unix() {
              return Math.floor(this.valueOf() / 1000);
            }

            function toDate() {
              return new Date(this.valueOf());
            }

            function toArray() {
              var m = this;
              return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
            }

            function toObject() {
              var m = this;
              return {
                years: m.year(),
                months: m.month(),
                date: m.date(),
                hours: m.hours(),
                minutes: m.minutes(),
                seconds: m.seconds(),
                milliseconds: m.milliseconds()
              };
            }

            function toJSON() {
              // new Date(NaN).toJSON() === null
              return this.isValid() ? this.toISOString() : null;
            }

            function isValid$2() {
              return isValid(this);
            }

            function parsingFlags() {
              return extend({}, getParsingFlags(this));
            }

            function invalidAt() {
              return getParsingFlags(this).overflow;
            }

            function creationData() {
              return {
                input: this._i,
                format: this._f,
                locale: this._locale,
                isUTC: this._isUTC,
                strict: this._strict
              };
            }

            addFormatToken('N', 0, 0, 'eraAbbr');
            addFormatToken('NN', 0, 0, 'eraAbbr');
            addFormatToken('NNN', 0, 0, 'eraAbbr');
            addFormatToken('NNNN', 0, 0, 'eraName');
            addFormatToken('NNNNN', 0, 0, 'eraNarrow');
            addFormatToken('y', ['y', 1], 'yo', 'eraYear');
            addFormatToken('y', ['yy', 2], 0, 'eraYear');
            addFormatToken('y', ['yyy', 3], 0, 'eraYear');
            addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
            addRegexToken('N', matchEraAbbr);
            addRegexToken('NN', matchEraAbbr);
            addRegexToken('NNN', matchEraAbbr);
            addRegexToken('NNNN', matchEraName);
            addRegexToken('NNNNN', matchEraNarrow);
            addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (input, array, config, token) {
              var era = config._locale.erasParse(input, token, config._strict);

              if (era) {
                getParsingFlags(config).era = era;
              } else {
                getParsingFlags(config).invalidEra = input;
              }
            });
            addRegexToken('y', matchUnsigned);
            addRegexToken('yy', matchUnsigned);
            addRegexToken('yyy', matchUnsigned);
            addRegexToken('yyyy', matchUnsigned);
            addRegexToken('yo', matchEraYearOrdinal);
            addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
            addParseToken(['yo'], function (input, array, config, token) {
              var match;

              if (config._locale._eraYearOrdinalRegex) {
                match = input.match(config._locale._eraYearOrdinalRegex);
              }

              if (config._locale.eraYearOrdinalParse) {
                array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
              } else {
                array[YEAR] = parseInt(input, 10);
              }
            });

            function localeEras(m, format) {
              var i,
                  l,
                  date,
                  eras = this._eras || getLocale('en')._eras;

              for (i = 0, l = eras.length; i < l; ++i) {
                switch (_typeof2(eras[i].since)) {
                  case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
                }

                switch (_typeof2(eras[i].until)) {
                  case 'undefined':
                    eras[i].until = +Infinity;
                    break;

                  case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
                }
              }

              return eras;
            }

            function localeErasParse(eraName, format, strict) {
              var i,
                  l,
                  eras = this.eras(),
                  name,
                  abbr,
                  narrow;
              eraName = eraName.toUpperCase();

              for (i = 0, l = eras.length; i < l; ++i) {
                name = eras[i].name.toUpperCase();
                abbr = eras[i].abbr.toUpperCase();
                narrow = eras[i].narrow.toUpperCase();

                if (strict) {
                  switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                      if (abbr === eraName) {
                        return eras[i];
                      }

                      break;

                    case 'NNNN':
                      if (name === eraName) {
                        return eras[i];
                      }

                      break;

                    case 'NNNNN':
                      if (narrow === eraName) {
                        return eras[i];
                      }

                      break;
                  }
                } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                  return eras[i];
                }
              }
            }

            function localeErasConvertYear(era, year) {
              var dir = era.since <= era.until ? +1 : -1;

              if (year === undefined) {
                return hooks(era.since).year();
              } else {
                return hooks(era.since).year() + (year - era.offset) * dir;
              }
            }

            function getEraName() {
              var i,
                  l,
                  val,
                  eras = this.localeData().eras();

              for (i = 0, l = eras.length; i < l; ++i) {
                // truncate time
                val = this.clone().startOf('day').valueOf();

                if (eras[i].since <= val && val <= eras[i].until) {
                  return eras[i].name;
                }

                if (eras[i].until <= val && val <= eras[i].since) {
                  return eras[i].name;
                }
              }

              return '';
            }

            function getEraNarrow() {
              var i,
                  l,
                  val,
                  eras = this.localeData().eras();

              for (i = 0, l = eras.length; i < l; ++i) {
                // truncate time
                val = this.clone().startOf('day').valueOf();

                if (eras[i].since <= val && val <= eras[i].until) {
                  return eras[i].narrow;
                }

                if (eras[i].until <= val && val <= eras[i].since) {
                  return eras[i].narrow;
                }
              }

              return '';
            }

            function getEraAbbr() {
              var i,
                  l,
                  val,
                  eras = this.localeData().eras();

              for (i = 0, l = eras.length; i < l; ++i) {
                // truncate time
                val = this.clone().startOf('day').valueOf();

                if (eras[i].since <= val && val <= eras[i].until) {
                  return eras[i].abbr;
                }

                if (eras[i].until <= val && val <= eras[i].since) {
                  return eras[i].abbr;
                }
              }

              return '';
            }

            function getEraYear() {
              var i,
                  l,
                  dir,
                  val,
                  eras = this.localeData().eras();

              for (i = 0, l = eras.length; i < l; ++i) {
                dir = eras[i].since <= eras[i].until ? +1 : -1; // truncate time

                val = this.clone().startOf('day').valueOf();

                if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
                  return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
                }
              }

              return this.year();
            }

            function erasNameRegex(isStrict) {
              if (!hasOwnProp(this, '_erasNameRegex')) {
                computeErasParse.call(this);
              }

              return isStrict ? this._erasNameRegex : this._erasRegex;
            }

            function erasAbbrRegex(isStrict) {
              if (!hasOwnProp(this, '_erasAbbrRegex')) {
                computeErasParse.call(this);
              }

              return isStrict ? this._erasAbbrRegex : this._erasRegex;
            }

            function erasNarrowRegex(isStrict) {
              if (!hasOwnProp(this, '_erasNarrowRegex')) {
                computeErasParse.call(this);
              }

              return isStrict ? this._erasNarrowRegex : this._erasRegex;
            }

            function matchEraAbbr(isStrict, locale) {
              return locale.erasAbbrRegex(isStrict);
            }

            function matchEraName(isStrict, locale) {
              return locale.erasNameRegex(isStrict);
            }

            function matchEraNarrow(isStrict, locale) {
              return locale.erasNarrowRegex(isStrict);
            }

            function matchEraYearOrdinal(isStrict, locale) {
              return locale._eraYearOrdinalRegex || matchUnsigned;
            }

            function computeErasParse() {
              var abbrPieces = [],
                  namePieces = [],
                  narrowPieces = [],
                  mixedPieces = [],
                  i,
                  l,
                  eras = this.eras();

              for (i = 0, l = eras.length; i < l; ++i) {
                namePieces.push(regexEscape(eras[i].name));
                abbrPieces.push(regexEscape(eras[i].abbr));
                narrowPieces.push(regexEscape(eras[i].narrow));
                mixedPieces.push(regexEscape(eras[i].name));
                mixedPieces.push(regexEscape(eras[i].abbr));
                mixedPieces.push(regexEscape(eras[i].narrow));
              }

              this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
              this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
              this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
              this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
            } // FORMATTING


            addFormatToken(0, ['gg', 2], 0, function () {
              return this.weekYear() % 100;
            });
            addFormatToken(0, ['GG', 2], 0, function () {
              return this.isoWeekYear() % 100;
            });

            function addWeekYearFormatToken(token, getter) {
              addFormatToken(0, [token, token.length], 0, getter);
            }

            addWeekYearFormatToken('gggg', 'weekYear');
            addWeekYearFormatToken('ggggg', 'weekYear');
            addWeekYearFormatToken('GGGG', 'isoWeekYear');
            addWeekYearFormatToken('GGGGG', 'isoWeekYear'); // ALIASES

            addUnitAlias('weekYear', 'gg');
            addUnitAlias('isoWeekYear', 'GG'); // PRIORITY

            addUnitPriority('weekYear', 1);
            addUnitPriority('isoWeekYear', 1); // PARSING

            addRegexToken('G', matchSigned);
            addRegexToken('g', matchSigned);
            addRegexToken('GG', match1to2, match2);
            addRegexToken('gg', match1to2, match2);
            addRegexToken('GGGG', match1to4, match4);
            addRegexToken('gggg', match1to4, match4);
            addRegexToken('GGGGG', match1to6, match6);
            addRegexToken('ggggg', match1to6, match6);
            addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
              week[token.substr(0, 2)] = toInt(input);
            });
            addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
              week[token] = hooks.parseTwoDigitYear(input);
            }); // MOMENTS

            function getSetWeekYear(input) {
              return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
            }

            function getSetISOWeekYear(input) {
              return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
            }

            function getISOWeeksInYear() {
              return weeksInYear(this.year(), 1, 4);
            }

            function getISOWeeksInISOWeekYear() {
              return weeksInYear(this.isoWeekYear(), 1, 4);
            }

            function getWeeksInYear() {
              var weekInfo = this.localeData()._week;

              return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
            }

            function getWeeksInWeekYear() {
              var weekInfo = this.localeData()._week;

              return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
            }

            function getSetWeekYearHelper(input, week, weekday, dow, doy) {
              var weeksTarget;

              if (input == null) {
                return weekOfYear(this, dow, doy).year;
              } else {
                weeksTarget = weeksInYear(input, dow, doy);

                if (week > weeksTarget) {
                  week = weeksTarget;
                }

                return setWeekAll.call(this, input, week, weekday, dow, doy);
              }
            }

            function setWeekAll(weekYear, week, weekday, dow, doy) {
              var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
                  date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
              this.year(date.getUTCFullYear());
              this.month(date.getUTCMonth());
              this.date(date.getUTCDate());
              return this;
            } // FORMATTING


            addFormatToken('Q', 0, 'Qo', 'quarter'); // ALIASES

            addUnitAlias('quarter', 'Q'); // PRIORITY

            addUnitPriority('quarter', 7); // PARSING

            addRegexToken('Q', match1);
            addParseToken('Q', function (input, array) {
              array[MONTH] = (toInt(input) - 1) * 3;
            }); // MOMENTS

            function getSetQuarter(input) {
              return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
            } // FORMATTING


            addFormatToken('D', ['DD', 2], 'Do', 'date'); // ALIASES

            addUnitAlias('date', 'D'); // PRIORITY

            addUnitPriority('date', 9); // PARSING

            addRegexToken('D', match1to2);
            addRegexToken('DD', match1to2, match2);
            addRegexToken('Do', function (isStrict, locale) {
              // TODO: Remove "ordinalParse" fallback in next major release.
              return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
            });
            addParseToken(['D', 'DD'], DATE);
            addParseToken('Do', function (input, array) {
              array[DATE] = toInt(input.match(match1to2)[0]);
            }); // MOMENTS

            var getSetDayOfMonth = makeGetSet('Date', true); // FORMATTING

            addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear'); // ALIASES

            addUnitAlias('dayOfYear', 'DDD'); // PRIORITY

            addUnitPriority('dayOfYear', 4); // PARSING

            addRegexToken('DDD', match1to3);
            addRegexToken('DDDD', match3);
            addParseToken(['DDD', 'DDDD'], function (input, array, config) {
              config._dayOfYear = toInt(input);
            }); // HELPERS
            // MOMENTS

            function getSetDayOfYear(input) {
              var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
              return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
            } // FORMATTING


            addFormatToken('m', ['mm', 2], 0, 'minute'); // ALIASES

            addUnitAlias('minute', 'm'); // PRIORITY

            addUnitPriority('minute', 14); // PARSING

            addRegexToken('m', match1to2);
            addRegexToken('mm', match1to2, match2);
            addParseToken(['m', 'mm'], MINUTE); // MOMENTS

            var getSetMinute = makeGetSet('Minutes', false); // FORMATTING

            addFormatToken('s', ['ss', 2], 0, 'second'); // ALIASES

            addUnitAlias('second', 's'); // PRIORITY

            addUnitPriority('second', 15); // PARSING

            addRegexToken('s', match1to2);
            addRegexToken('ss', match1to2, match2);
            addParseToken(['s', 'ss'], SECOND); // MOMENTS

            var getSetSecond = makeGetSet('Seconds', false); // FORMATTING

            addFormatToken('S', 0, 0, function () {
              return ~~(this.millisecond() / 100);
            });
            addFormatToken(0, ['SS', 2], 0, function () {
              return ~~(this.millisecond() / 10);
            });
            addFormatToken(0, ['SSS', 3], 0, 'millisecond');
            addFormatToken(0, ['SSSS', 4], 0, function () {
              return this.millisecond() * 10;
            });
            addFormatToken(0, ['SSSSS', 5], 0, function () {
              return this.millisecond() * 100;
            });
            addFormatToken(0, ['SSSSSS', 6], 0, function () {
              return this.millisecond() * 1000;
            });
            addFormatToken(0, ['SSSSSSS', 7], 0, function () {
              return this.millisecond() * 10000;
            });
            addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
              return this.millisecond() * 100000;
            });
            addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
              return this.millisecond() * 1000000;
            }); // ALIASES

            addUnitAlias('millisecond', 'ms'); // PRIORITY

            addUnitPriority('millisecond', 16); // PARSING

            addRegexToken('S', match1to3, match1);
            addRegexToken('SS', match1to3, match2);
            addRegexToken('SSS', match1to3, match3);
            var token, getSetMillisecond;

            for (token = 'SSSS'; token.length <= 9; token += 'S') {
              addRegexToken(token, matchUnsigned);
            }

            function parseMs(input, array) {
              array[MILLISECOND] = toInt(('0.' + input) * 1000);
            }

            for (token = 'S'; token.length <= 9; token += 'S') {
              addParseToken(token, parseMs);
            }

            getSetMillisecond = makeGetSet('Milliseconds', false); // FORMATTING

            addFormatToken('z', 0, 0, 'zoneAbbr');
            addFormatToken('zz', 0, 0, 'zoneName'); // MOMENTS

            function getZoneAbbr() {
              return this._isUTC ? 'UTC' : '';
            }

            function getZoneName() {
              return this._isUTC ? 'Coordinated Universal Time' : '';
            }

            var proto = Moment.prototype;
            proto.add = add;
            proto.calendar = calendar$1;
            proto.clone = clone;
            proto.diff = diff;
            proto.endOf = endOf;
            proto.format = format;
            proto.from = from;
            proto.fromNow = fromNow;
            proto.to = to;
            proto.toNow = toNow;
            proto.get = stringGet;
            proto.invalidAt = invalidAt;
            proto.isAfter = isAfter;
            proto.isBefore = isBefore;
            proto.isBetween = isBetween;
            proto.isSame = isSame;
            proto.isSameOrAfter = isSameOrAfter;
            proto.isSameOrBefore = isSameOrBefore;
            proto.isValid = isValid$2;
            proto.lang = lang;
            proto.locale = locale;
            proto.localeData = localeData;
            proto.max = prototypeMax;
            proto.min = prototypeMin;
            proto.parsingFlags = parsingFlags;
            proto.set = stringSet;
            proto.startOf = startOf;
            proto.subtract = subtract;
            proto.toArray = toArray;
            proto.toObject = toObject;
            proto.toDate = toDate;
            proto.toISOString = toISOString;
            proto.inspect = inspect;

            if (typeof Symbol !== 'undefined' && Symbol.for != null) {
              proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
                return 'Moment<' + this.format() + '>';
              };
            }

            proto.toJSON = toJSON;
            proto.toString = toString;
            proto.unix = unix;
            proto.valueOf = valueOf;
            proto.creationData = creationData;
            proto.eraName = getEraName;
            proto.eraNarrow = getEraNarrow;
            proto.eraAbbr = getEraAbbr;
            proto.eraYear = getEraYear;
            proto.year = getSetYear;
            proto.isLeapYear = getIsLeapYear;
            proto.weekYear = getSetWeekYear;
            proto.isoWeekYear = getSetISOWeekYear;
            proto.quarter = proto.quarters = getSetQuarter;
            proto.month = getSetMonth;
            proto.daysInMonth = getDaysInMonth;
            proto.week = proto.weeks = getSetWeek;
            proto.isoWeek = proto.isoWeeks = getSetISOWeek;
            proto.weeksInYear = getWeeksInYear;
            proto.weeksInWeekYear = getWeeksInWeekYear;
            proto.isoWeeksInYear = getISOWeeksInYear;
            proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
            proto.date = getSetDayOfMonth;
            proto.day = proto.days = getSetDayOfWeek;
            proto.weekday = getSetLocaleDayOfWeek;
            proto.isoWeekday = getSetISODayOfWeek;
            proto.dayOfYear = getSetDayOfYear;
            proto.hour = proto.hours = getSetHour;
            proto.minute = proto.minutes = getSetMinute;
            proto.second = proto.seconds = getSetSecond;
            proto.millisecond = proto.milliseconds = getSetMillisecond;
            proto.utcOffset = getSetOffset;
            proto.utc = setOffsetToUTC;
            proto.local = setOffsetToLocal;
            proto.parseZone = setOffsetToParsedOffset;
            proto.hasAlignedHourOffset = hasAlignedHourOffset;
            proto.isDST = isDaylightSavingTime;
            proto.isLocal = isLocal;
            proto.isUtcOffset = isUtcOffset;
            proto.isUtc = isUtc;
            proto.isUTC = isUtc;
            proto.zoneAbbr = getZoneAbbr;
            proto.zoneName = getZoneName;
            proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
            proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
            proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
            proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
            proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

            function createUnix(input) {
              return createLocal(input * 1000);
            }

            function createInZone() {
              return createLocal.apply(null, arguments).parseZone();
            }

            function preParsePostFormat(string) {
              return string;
            }

            var proto$1 = Locale.prototype;
            proto$1.calendar = calendar;
            proto$1.longDateFormat = longDateFormat;
            proto$1.invalidDate = invalidDate;
            proto$1.ordinal = ordinal;
            proto$1.preparse = preParsePostFormat;
            proto$1.postformat = preParsePostFormat;
            proto$1.relativeTime = relativeTime;
            proto$1.pastFuture = pastFuture;
            proto$1.set = set;
            proto$1.eras = localeEras;
            proto$1.erasParse = localeErasParse;
            proto$1.erasConvertYear = localeErasConvertYear;
            proto$1.erasAbbrRegex = erasAbbrRegex;
            proto$1.erasNameRegex = erasNameRegex;
            proto$1.erasNarrowRegex = erasNarrowRegex;
            proto$1.months = localeMonths;
            proto$1.monthsShort = localeMonthsShort;
            proto$1.monthsParse = localeMonthsParse;
            proto$1.monthsRegex = monthsRegex;
            proto$1.monthsShortRegex = monthsShortRegex;
            proto$1.week = localeWeek;
            proto$1.firstDayOfYear = localeFirstDayOfYear;
            proto$1.firstDayOfWeek = localeFirstDayOfWeek;
            proto$1.weekdays = localeWeekdays;
            proto$1.weekdaysMin = localeWeekdaysMin;
            proto$1.weekdaysShort = localeWeekdaysShort;
            proto$1.weekdaysParse = localeWeekdaysParse;
            proto$1.weekdaysRegex = weekdaysRegex;
            proto$1.weekdaysShortRegex = weekdaysShortRegex;
            proto$1.weekdaysMinRegex = weekdaysMinRegex;
            proto$1.isPM = localeIsPM;
            proto$1.meridiem = localeMeridiem;

            function get$1(format, index, field, setter) {
              var locale = getLocale(),
                  utc = createUTC().set(setter, index);
              return locale[field](utc, format);
            }

            function listMonthsImpl(format, index, field) {
              if (isNumber(format)) {
                index = format;
                format = undefined;
              }

              format = format || '';

              if (index != null) {
                return get$1(format, index, field, 'month');
              }

              var i,
                  out = [];

              for (i = 0; i < 12; i++) {
                out[i] = get$1(format, i, field, 'month');
              }

              return out;
            } // ()
            // (5)
            // (fmt, 5)
            // (fmt)
            // (true)
            // (true, 5)
            // (true, fmt, 5)
            // (true, fmt)


            function listWeekdaysImpl(localeSorted, format, index, field) {
              if (typeof localeSorted === 'boolean') {
                if (isNumber(format)) {
                  index = format;
                  format = undefined;
                }

                format = format || '';
              } else {
                format = localeSorted;
                index = format;
                localeSorted = false;

                if (isNumber(format)) {
                  index = format;
                  format = undefined;
                }

                format = format || '';
              }

              var locale = getLocale(),
                  shift = localeSorted ? locale._week.dow : 0,
                  i,
                  out = [];

              if (index != null) {
                return get$1(format, (index + shift) % 7, field, 'day');
              }

              for (i = 0; i < 7; i++) {
                out[i] = get$1(format, (i + shift) % 7, field, 'day');
              }

              return out;
            }

            function listMonths(format, index) {
              return listMonthsImpl(format, index, 'months');
            }

            function listMonthsShort(format, index) {
              return listMonthsImpl(format, index, 'monthsShort');
            }

            function listWeekdays(localeSorted, format, index) {
              return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
            }

            function listWeekdaysShort(localeSorted, format, index) {
              return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
            }

            function listWeekdaysMin(localeSorted, format, index) {
              return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
            }

            getSetGlobalLocale('en', {
              eras: [{
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
              }, {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
              }],
              dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
              ordinal: function ordinal(number) {
                var b = number % 10,
                    output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
                return number + output;
              }
            }); // Side effect imports

            hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
            hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
            var mathAbs = Math.abs;

            function abs() {
              var data = this._data;
              this._milliseconds = mathAbs(this._milliseconds);
              this._days = mathAbs(this._days);
              this._months = mathAbs(this._months);
              data.milliseconds = mathAbs(data.milliseconds);
              data.seconds = mathAbs(data.seconds);
              data.minutes = mathAbs(data.minutes);
              data.hours = mathAbs(data.hours);
              data.months = mathAbs(data.months);
              data.years = mathAbs(data.years);
              return this;
            }

            function addSubtract$1(duration, input, value, direction) {
              var other = createDuration(input, value);
              duration._milliseconds += direction * other._milliseconds;
              duration._days += direction * other._days;
              duration._months += direction * other._months;
              return duration._bubble();
            } // supports only 2.0-style add(1, 's') or add(duration)


            function add$1(input, value) {
              return addSubtract$1(this, input, value, 1);
            } // supports only 2.0-style subtract(1, 's') or subtract(duration)


            function subtract$1(input, value) {
              return addSubtract$1(this, input, value, -1);
            }

            function absCeil(number) {
              if (number < 0) {
                return Math.floor(number);
              } else {
                return Math.ceil(number);
              }
            }

            function bubble() {
              var milliseconds = this._milliseconds,
                  days = this._days,
                  months = this._months,
                  data = this._data,
                  seconds,
                  minutes,
                  hours,
                  years,
                  monthsFromDays; // if we have a mix of positive and negative values, bubble down first
              // check: https://github.com/moment/moment/issues/2166

              if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
                milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
                days = 0;
                months = 0;
              } // The following code bubbles up values, see the tests for
              // examples of what that means.


              data.milliseconds = milliseconds % 1000;
              seconds = absFloor(milliseconds / 1000);
              data.seconds = seconds % 60;
              minutes = absFloor(seconds / 60);
              data.minutes = minutes % 60;
              hours = absFloor(minutes / 60);
              data.hours = hours % 24;
              days += absFloor(hours / 24); // convert days to months

              monthsFromDays = absFloor(daysToMonths(days));
              months += monthsFromDays;
              days -= absCeil(monthsToDays(monthsFromDays)); // 12 months -> 1 year

              years = absFloor(months / 12);
              months %= 12;
              data.days = days;
              data.months = months;
              data.years = years;
              return this;
            }

            function daysToMonths(days) {
              // 400 years have 146097 days (taking into account leap year rules)
              // 400 years have 12 months === 4800
              return days * 4800 / 146097;
            }

            function monthsToDays(months) {
              // the reverse of daysToMonths
              return months * 146097 / 4800;
            }

            function as(units) {
              if (!this.isValid()) {
                return NaN;
              }

              var days,
                  months,
                  milliseconds = this._milliseconds;
              units = normalizeUnits(units);

              if (units === 'month' || units === 'quarter' || units === 'year') {
                days = this._days + milliseconds / 864e5;
                months = this._months + daysToMonths(days);

                switch (units) {
                  case 'month':
                    return months;

                  case 'quarter':
                    return months / 3;

                  case 'year':
                    return months / 12;
                }
              } else {
                // handle milliseconds separately because of floating point math errors (issue #1867)
                days = this._days + Math.round(monthsToDays(this._months));

                switch (units) {
                  case 'week':
                    return days / 7 + milliseconds / 6048e5;

                  case 'day':
                    return days + milliseconds / 864e5;

                  case 'hour':
                    return days * 24 + milliseconds / 36e5;

                  case 'minute':
                    return days * 1440 + milliseconds / 6e4;

                  case 'second':
                    return days * 86400 + milliseconds / 1000;
                  // Math.floor prevents floating point math errors here

                  case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;

                  default:
                    throw new Error('Unknown unit ' + units);
                }
              }
            } // TODO: Use this.as('ms')?


            function valueOf$1() {
              if (!this.isValid()) {
                return NaN;
              }

              return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
            }

            function makeAs(alias) {
              return function () {
                return this.as(alias);
              };
            }

            var asMilliseconds = makeAs('ms'),
                asSeconds = makeAs('s'),
                asMinutes = makeAs('m'),
                asHours = makeAs('h'),
                asDays = makeAs('d'),
                asWeeks = makeAs('w'),
                asMonths = makeAs('M'),
                asQuarters = makeAs('Q'),
                asYears = makeAs('y');

            function clone$1() {
              return createDuration(this);
            }

            function get$2(units) {
              units = normalizeUnits(units);
              return this.isValid() ? this[units + 's']() : NaN;
            }

            function makeGetter(name) {
              return function () {
                return this.isValid() ? this._data[name] : NaN;
              };
            }

            var milliseconds = makeGetter('milliseconds'),
                seconds = makeGetter('seconds'),
                minutes = makeGetter('minutes'),
                hours = makeGetter('hours'),
                days = makeGetter('days'),
                months = makeGetter('months'),
                years = makeGetter('years');

            function weeks() {
              return absFloor(this.days() / 7);
            }

            var round = Math.round,
                thresholds = {
              ss: 44,
              // a few seconds to seconds
              s: 45,
              // seconds to minute
              m: 45,
              // minutes to hour
              h: 22,
              // hours to day
              d: 26,
              // days to month/week
              w: null,
              // weeks to month
              M: 11 // months to year

            }; // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize

            function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
              return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
            }

            function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
              var duration = createDuration(posNegDuration).abs(),
                  seconds = round(duration.as('s')),
                  minutes = round(duration.as('m')),
                  hours = round(duration.as('h')),
                  days = round(duration.as('d')),
                  months = round(duration.as('M')),
                  weeks = round(duration.as('w')),
                  years = round(duration.as('y')),
                  a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days];

              if (thresholds.w != null) {
                a = a || weeks <= 1 && ['w'] || weeks < thresholds.w && ['ww', weeks];
              }

              a = a || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
              a[2] = withoutSuffix;
              a[3] = +posNegDuration > 0;
              a[4] = locale;
              return substituteTimeAgo.apply(null, a);
            } // This function allows you to set the rounding function for relative time strings


            function getSetRelativeTimeRounding(roundingFunction) {
              if (roundingFunction === undefined) {
                return round;
              }

              if (typeof roundingFunction === 'function') {
                round = roundingFunction;
                return true;
              }

              return false;
            } // This function allows you to set a threshold for relative time strings


            function getSetRelativeTimeThreshold(threshold, limit) {
              if (thresholds[threshold] === undefined) {
                return false;
              }

              if (limit === undefined) {
                return thresholds[threshold];
              }

              thresholds[threshold] = limit;

              if (threshold === 's') {
                thresholds.ss = limit - 1;
              }

              return true;
            }

            function humanize(argWithSuffix, argThresholds) {
              if (!this.isValid()) {
                return this.localeData().invalidDate();
              }

              var withSuffix = false,
                  th = thresholds,
                  locale,
                  output;

              if (_typeof2(argWithSuffix) === 'object') {
                argThresholds = argWithSuffix;
                argWithSuffix = false;
              }

              if (typeof argWithSuffix === 'boolean') {
                withSuffix = argWithSuffix;
              }

              if (_typeof2(argThresholds) === 'object') {
                th = Object.assign({}, thresholds, argThresholds);

                if (argThresholds.s != null && argThresholds.ss == null) {
                  th.ss = argThresholds.s - 1;
                }
              }

              locale = this.localeData();
              output = relativeTime$1(this, !withSuffix, th, locale);

              if (withSuffix) {
                output = locale.pastFuture(+this, output);
              }

              return locale.postformat(output);
            }

            var abs$1 = Math.abs;

            function sign(x) {
              return (x > 0) - (x < 0) || +x;
            }

            function toISOString$1() {
              // for ISO strings we do not use the normal bubbling rules:
              //  * milliseconds bubble up until they become hours
              //  * days do not bubble at all
              //  * months bubble up until they become years
              // This is because there is no context-free conversion between hours and days
              // (think of clock changes)
              // and also not between days and months (28-31 days per month)
              if (!this.isValid()) {
                return this.localeData().invalidDate();
              }

              var seconds = abs$1(this._milliseconds) / 1000,
                  days = abs$1(this._days),
                  months = abs$1(this._months),
                  minutes,
                  hours,
                  years,
                  s,
                  total = this.asSeconds(),
                  totalSign,
                  ymSign,
                  daysSign,
                  hmsSign;

              if (!total) {
                // this is the same as C#'s (Noda) and python (isodate)...
                // but not other JS (goog.date)
                return 'P0D';
              } // 3600 seconds -> 60 minutes -> 1 hour


              minutes = absFloor(seconds / 60);
              hours = absFloor(minutes / 60);
              seconds %= 60;
              minutes %= 60; // 12 months -> 1 year

              years = absFloor(months / 12);
              months %= 12; // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js

              s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
              totalSign = total < 0 ? '-' : '';
              ymSign = sign(this._months) !== sign(total) ? '-' : '';
              daysSign = sign(this._days) !== sign(total) ? '-' : '';
              hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
              return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
            }

            var proto$2 = Duration.prototype;
            proto$2.isValid = isValid$1;
            proto$2.abs = abs;
            proto$2.add = add$1;
            proto$2.subtract = subtract$1;
            proto$2.as = as;
            proto$2.asMilliseconds = asMilliseconds;
            proto$2.asSeconds = asSeconds;
            proto$2.asMinutes = asMinutes;
            proto$2.asHours = asHours;
            proto$2.asDays = asDays;
            proto$2.asWeeks = asWeeks;
            proto$2.asMonths = asMonths;
            proto$2.asQuarters = asQuarters;
            proto$2.asYears = asYears;
            proto$2.valueOf = valueOf$1;
            proto$2._bubble = bubble;
            proto$2.clone = clone$1;
            proto$2.get = get$2;
            proto$2.milliseconds = milliseconds;
            proto$2.seconds = seconds;
            proto$2.minutes = minutes;
            proto$2.hours = hours;
            proto$2.days = days;
            proto$2.weeks = weeks;
            proto$2.months = months;
            proto$2.years = years;
            proto$2.humanize = humanize;
            proto$2.toISOString = toISOString$1;
            proto$2.toString = toISOString$1;
            proto$2.toJSON = toISOString$1;
            proto$2.locale = locale;
            proto$2.localeData = localeData;
            proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
            proto$2.lang = lang; // FORMATTING

            addFormatToken('X', 0, 0, 'unix');
            addFormatToken('x', 0, 0, 'valueOf'); // PARSING

            addRegexToken('x', matchSigned);
            addRegexToken('X', matchTimestamp);
            addParseToken('X', function (input, array, config) {
              config._d = new Date(parseFloat(input) * 1000);
            });
            addParseToken('x', function (input, array, config) {
              config._d = new Date(toInt(input));
            }); //! moment.js

            hooks.version = '2.29.1';
            setHookCallback(createLocal);
            hooks.fn = proto;
            hooks.min = min;
            hooks.max = max;
            hooks.now = now;
            hooks.utc = createUTC;
            hooks.unix = createUnix;
            hooks.months = listMonths;
            hooks.isDate = isDate;
            hooks.locale = getSetGlobalLocale;
            hooks.invalid = createInvalid;
            hooks.duration = createDuration;
            hooks.isMoment = isMoment;
            hooks.weekdays = listWeekdays;
            hooks.parseZone = createInZone;
            hooks.localeData = getLocale;
            hooks.isDuration = isDuration;
            hooks.monthsShort = listMonthsShort;
            hooks.weekdaysMin = listWeekdaysMin;
            hooks.defineLocale = defineLocale;
            hooks.updateLocale = updateLocale;
            hooks.locales = listLocales;
            hooks.weekdaysShort = listWeekdaysShort;
            hooks.normalizeUnits = normalizeUnits;
            hooks.relativeTimeRounding = getSetRelativeTimeRounding;
            hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
            hooks.calendarFormat = getCalendarFormat;
            hooks.prototype = proto; // currently HTML5 input type only supports 24-hour formats

            hooks.HTML5_FMT = {
              DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
              // <input type="datetime-local" />
              DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
              // <input type="datetime-local" step="1" />
              DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
              // <input type="datetime-local" step="0.001" />
              DATE: 'YYYY-MM-DD',
              // <input type="date" />
              TIME: 'HH:mm',
              // <input type="time" />
              TIME_SECONDS: 'HH:mm:ss',
              // <input type="time" step="1" />
              TIME_MS: 'HH:mm:ss.SSS',
              // <input type="time" step="0.001" />
              WEEK: 'GGGG-[W]WW',
              // <input type="week" />
              MONTH: 'YYYY-MM' // <input type="month" />

            };
            return hooks;
          });
          /***/

        },

        /***/
        3379:
        /***/
        function _(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var isOldIE = function isOldIE() {
            var memo;
            return function memorize() {
              if (typeof memo === 'undefined') {
                // Test for IE <= 9 as proposed by Browserhacks
                // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
                // Tests for existence of standard globals is to allow style-loader
                // to operate correctly into non-standard environments
                // @see https://github.com/webpack-contrib/style-loader/issues/177
                memo = Boolean(window && document && document.all && !window.atob);
              }

              return memo;
            };
          }();

          var getTarget = function getTarget() {
            var memo = {};
            return function memorize(target) {
              if (typeof memo[target] === 'undefined') {
                var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

                if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
                  try {
                    // This will throw an exception if access to iframe is blocked
                    // due to cross-origin restrictions
                    styleTarget = styleTarget.contentDocument.head;
                  } catch (e) {
                    // istanbul ignore next
                    styleTarget = null;
                  }
                }

                memo[target] = styleTarget;
              }

              return memo[target];
            };
          }();

          var stylesInDom = [];

          function getIndexByIdentifier(identifier) {
            var result = -1;

            for (var i = 0; i < stylesInDom.length; i++) {
              if (stylesInDom[i].identifier === identifier) {
                result = i;
                break;
              }
            }

            return result;
          }

          function modulesToDom(list, options) {
            var idCountMap = {};
            var identifiers = [];

            for (var i = 0; i < list.length; i++) {
              var item = list[i];
              var id = options.base ? item[0] + options.base : item[0];
              var count = idCountMap[id] || 0;
              var identifier = "".concat(id, " ").concat(count);
              idCountMap[id] = count + 1;
              var index = getIndexByIdentifier(identifier);
              var obj = {
                css: item[1],
                media: item[2],
                sourceMap: item[3]
              };

              if (index !== -1) {
                stylesInDom[index].references++;
                stylesInDom[index].updater(obj);
              } else {
                stylesInDom.push({
                  identifier: identifier,
                  updater: addStyle(obj, options),
                  references: 1
                });
              }

              identifiers.push(identifier);
            }

            return identifiers;
          }

          function insertStyleElement(options) {
            var style = document.createElement('style');
            var attributes = options.attributes || {};

            if (typeof attributes.nonce === 'undefined') {
              var nonce = true ? __webpack_require__.nc : 0;

              if (nonce) {
                attributes.nonce = nonce;
              }
            }

            Object.keys(attributes).forEach(function (key) {
              style.setAttribute(key, attributes[key]);
            });

            if (typeof options.insert === 'function') {
              options.insert(style);
            } else {
              var target = getTarget(options.insert || 'head');

              if (!target) {
                throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
              }

              target.appendChild(style);
            }

            return style;
          }

          function removeStyleElement(style) {
            // istanbul ignore if
            if (style.parentNode === null) {
              return false;
            }

            style.parentNode.removeChild(style);
          }
          /* istanbul ignore next  */


          var replaceText = function replaceText() {
            var textStore = [];
            return function replace(index, replacement) {
              textStore[index] = replacement;
              return textStore.filter(Boolean).join('\n');
            };
          }();

          function applyToSingletonTag(style, index, remove, obj) {
            var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

            /* istanbul ignore if  */

            if (style.styleSheet) {
              style.styleSheet.cssText = replaceText(index, css);
            } else {
              var cssNode = document.createTextNode(css);
              var childNodes = style.childNodes;

              if (childNodes[index]) {
                style.removeChild(childNodes[index]);
              }

              if (childNodes.length) {
                style.insertBefore(cssNode, childNodes[index]);
              } else {
                style.appendChild(cssNode);
              }
            }
          }

          function applyToTag(style, options, obj) {
            var css = obj.css;
            var media = obj.media;
            var sourceMap = obj.sourceMap;

            if (media) {
              style.setAttribute('media', media);
            } else {
              style.removeAttribute('media');
            }

            if (sourceMap && typeof btoa !== 'undefined') {
              css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
            } // For old IE

            /* istanbul ignore if  */


            if (style.styleSheet) {
              style.styleSheet.cssText = css;
            } else {
              while (style.firstChild) {
                style.removeChild(style.firstChild);
              }

              style.appendChild(document.createTextNode(css));
            }
          }

          var singleton = null;
          var singletonCounter = 0;

          function addStyle(obj, options) {
            var style;
            var update;
            var remove;

            if (options.singleton) {
              var styleIndex = singletonCounter++;
              style = singleton || (singleton = insertStyleElement(options));
              update = applyToSingletonTag.bind(null, style, styleIndex, false);
              remove = applyToSingletonTag.bind(null, style, styleIndex, true);
            } else {
              style = insertStyleElement(options);
              update = applyToTag.bind(null, style, options);

              remove = function remove() {
                removeStyleElement(style);
              };
            }

            update(obj);
            return function updateStyle(newObj) {
              if (newObj) {
                if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
                  return;
                }

                update(obj = newObj);
              } else {
                remove();
              }
            };
          }

          module.exports = function (list, options) {
            options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
            // tags it will allow on a page

            if (!options.singleton && typeof options.singleton !== 'boolean') {
              options.singleton = isOldIE();
            }

            list = list || [];
            var lastIdentifiers = modulesToDom(list, options);
            return function update(newList) {
              newList = newList || [];

              if (Object.prototype.toString.call(newList) !== '[object Array]') {
                return;
              }

              for (var i = 0; i < lastIdentifiers.length; i++) {
                var identifier = lastIdentifiers[i];
                var index = getIndexByIdentifier(identifier);
                stylesInDom[index].references--;
              }

              var newLastIdentifiers = modulesToDom(newList, options);

              for (var _i = 0; _i < lastIdentifiers.length; _i++) {
                var _identifier = lastIdentifiers[_i];

                var _index = getIndexByIdentifier(_identifier);

                if (stylesInDom[_index].references === 0) {
                  stylesInDom[_index].updater();

                  stylesInDom.splice(_index, 1);
                }
              }

              lastIdentifiers = newLastIdentifiers;
            };
          };
          /***/

        }
        /******/

      };
      /************************************************************************/

      /******/
      // The module cache

      /******/

      var __webpack_module_cache__ = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/
        // Check if module is in cache

        /******/
        var cachedModule = __webpack_module_cache__[moduleId];
        /******/

        if (cachedModule !== undefined) {
          /******/
          return cachedModule.exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = __webpack_module_cache__[moduleId] = {
          /******/
          id: moduleId,

          /******/
          loaded: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        __webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/


        module.loaded = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /************************************************************************/

      /******/

      /* webpack/runtime/compat get default export */

      /******/


      (function () {
        /******/
        // getDefaultExport function for compatibility with non-harmony modules

        /******/
        __webpack_require__.n = function (module) {
          /******/
          var getter = module && module.__esModule ?
          /******/
          function () {
            return module['default'];
          } :
          /******/
          function () {
            return module;
          };
          /******/

          __webpack_require__.d(getter, {
            a: getter
          });
          /******/


          return getter;
          /******/
        };
        /******/

      })();
      /******/

      /******/

      /* webpack/runtime/define property getters */

      /******/


      (function () {
        /******/
        // define getter functions for harmony exports

        /******/
        __webpack_require__.d = function (exports, definition) {
          /******/
          for (var key in definition) {
            /******/
            if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
              /******/
              Object.defineProperty(exports, key, {
                enumerable: true,
                get: definition[key]
              });
              /******/
            }
            /******/

          }
          /******/

        };
        /******/

      })();
      /******/

      /******/

      /* webpack/runtime/global */

      /******/


      (function () {
        /******/
        __webpack_require__.g = function () {
          /******/
          if ((typeof globalThis === "undefined" ? "undefined" : _typeof2(globalThis)) === 'object') return globalThis;
          /******/

          try {
            /******/
            return this || new Function('return this')();
            /******/
          } catch (e) {
            /******/
            if ((typeof window === "undefined" ? "undefined" : _typeof2(window)) === 'object') return window;
            /******/
          }
          /******/

        }();
        /******/

      })();
      /******/

      /******/

      /* webpack/runtime/hasOwnProperty shorthand */

      /******/


      (function () {
        /******/
        __webpack_require__.o = function (obj, prop) {
          return Object.prototype.hasOwnProperty.call(obj, prop);
        };
        /******/

      })();
      /******/

      /******/

      /* webpack/runtime/make namespace object */

      /******/


      (function () {
        /******/
        // define __esModule on exports

        /******/
        __webpack_require__.r = function (exports) {
          /******/
          if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
            /******/
            Object.defineProperty(exports, Symbol.toStringTag, {
              value: 'Module'
            });
            /******/
          }
          /******/


          Object.defineProperty(exports, '__esModule', {
            value: true
          });
          /******/
        };
        /******/

      })();
      /******/

      /******/

      /* webpack/runtime/node module decorator */

      /******/


      (function () {
        /******/
        __webpack_require__.nmd = function (module) {
          /******/
          module.paths = [];
          /******/

          if (!module.children) module.children = [];
          /******/

          return module;
          /******/
        };
        /******/

      })();
      /******/

      /************************************************************************/


      var __webpack_exports__ = {}; // This entry need to be wrapped in an IIFE because it need to be in strict mode.

      (function () {
        "use strict"; // ESM COMPAT FLAG

        var _marked = /*#__PURE__*/_regeneratorRuntime.mark(iterator),
            _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(numbers);

        __webpack_require__.r(__webpack_exports__); // EXPORTS


        __webpack_require__.d(__webpack_exports__, {
          "timeChart": function timeChart() {
            return (
              /* binding */
              _timeChart
            );
          }
        });

        ; // CONCATENATED MODULE: ./node_modules/d3/dist/package.js

        var package_name = "d3";
        var version = "6.7.0";
        var description = "Data-Driven Documents";
        var keywords =
        /* unused pure expression or super */
        null && ["dom", "visualization", "svg", "animation", "canvas"];
        var homepage = "https://d3js.org";
        var license = "BSD-3-Clause";
        var author = {
          "name": "Mike Bostock",
          "url": "https://bost.ocks.org/mike"
        };
        var main = "dist/d3.node.js";
        var unpkg = "dist/d3.min.js";
        var jsdelivr = "dist/d3.min.js";
        var package_module = "index.js";
        var repository = {
          "type": "git",
          "url": "https://github.com/d3/d3.git"
        };
        var files =
        /* unused pure expression or super */
        null && ["dist/**/*.js", "index.js"];
        var scripts = {
          "pretest": "rimraf dist && mkdir dist && json2module package.json > dist/package.js && rollup -c",
          "test": "tape 'test/**/*-test.js'",
          "prepublishOnly": "yarn test",
          "postpublish": "git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/dist/d3.js d3.v${npm_package_version%%.*}.js && cp ../d3/dist/d3.min.js d3.v${npm_package_version%%.*}.min.js && git add d3.v${npm_package_version%%.*}.js d3.v${npm_package_version%%.*}.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && zip -j dist/d3.zip -- LICENSE README.md API.md CHANGES.md dist/d3.js dist/d3.min.js"
        };
        var devDependencies = {
          "json2module": "0.0",
          "rimraf": "3",
          "rollup": "2",
          "rollup-plugin-ascii": "0.0",
          "rollup-plugin-node-resolve": "5",
          "rollup-plugin-terser": "7",
          "tape": "4",
          "tape-await": "0.1"
        };
        var dependencies = {
          "d3-array": "2",
          "d3-axis": "2",
          "d3-brush": "2",
          "d3-chord": "2",
          "d3-color": "2",
          "d3-contour": "2",
          "d3-delaunay": "5",
          "d3-dispatch": "2",
          "d3-drag": "2",
          "d3-dsv": "2",
          "d3-ease": "2",
          "d3-fetch": "2",
          "d3-force": "2",
          "d3-format": "2",
          "d3-geo": "2",
          "d3-hierarchy": "2",
          "d3-interpolate": "2",
          "d3-path": "2",
          "d3-polygon": "2",
          "d3-quadtree": "2",
          "d3-random": "2",
          "d3-scale": "3",
          "d3-scale-chromatic": "2",
          "d3-selection": "2",
          "d3-shape": "2",
          "d3-time": "2",
          "d3-time-format": "3",
          "d3-timer": "2",
          "d3-transition": "2",
          "d3-zoom": "2"
        };
        ; // CONCATENATED MODULE: ./node_modules/d3-array/src/ascending.js

        /* harmony default export */

        function ascending(a, b) {
          return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-array/src/bisector.js

        /* harmony default export */

        function bisector(f) {
          var delta = f;
          var compare = f;

          if (f.length === 1) {
            delta = function delta(d, x) {
              return f(d) - x;
            };

            compare = ascendingComparator(f);
          }

          function left(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;

            while (lo < hi) {
              var mid = lo + hi >>> 1;
              if (compare(a[mid], x) < 0) lo = mid + 1;else hi = mid;
            }

            return lo;
          }

          function right(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;

            while (lo < hi) {
              var mid = lo + hi >>> 1;
              if (compare(a[mid], x) > 0) hi = mid;else lo = mid + 1;
            }

            return lo;
          }

          function center(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            var i = left(a, x, lo, hi - 1);
            return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
          }

          return {
            left: left,
            center: center,
            right: right
          };
        }

        function ascendingComparator(f) {
          return function (d, x) {
            return ascending(f(d), x);
          };
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-array/src/extent.js

        /* harmony default export */

        function extent(values, valueof) {
          var min;
          var max;

          if (valueof === undefined) {
            var _iterator = _createForOfIteratorHelper(values),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _value = _step.value;

                if (_value != null) {
                  if (min === undefined) {
                    if (_value >= _value) min = max = _value;
                  } else {
                    if (min > _value) min = _value;
                    if (max < _value) max = _value;
                  }
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          } else {
            var _index2 = -1;

            var _iterator2 = _createForOfIteratorHelper(values),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _value2 = _step2.value;

                if ((_value2 = valueof(_value2, ++_index2, values)) != null) {
                  if (min === undefined) {
                    if (_value2 >= _value2) min = max = _value2;
                  } else {
                    if (min > _value2) min = _value2;
                    if (max < _value2) max = _value2;
                  }
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }

          return [min, max];
        }

        ; // CONCATENATED MODULE: ./node_modules/internmap/src/index.js

        var InternMap = /*#__PURE__*/function (_Map) {
          _inherits(InternMap, _Map);

          var _super = _createSuper(InternMap);

          function InternMap(entries) {
            var _this;

            var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : keyof;

            _classCallCheck(this, InternMap);

            _this = _super.call(this);
            Object.defineProperties(_assertThisInitialized(_this), {
              _intern: {
                value: new Map()
              },
              _key: {
                value: key
              }
            });

            if (entries != null) {
              var _iterator3 = _createForOfIteratorHelper(entries),
                  _step3;

              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var _ref3 = _step3.value;

                  var _ref2 = _slicedToArray2(_ref3, 2);

                  var _key2 = _ref2[0];
                  var _value3 = _ref2[1];

                  _this.set(_key2, _value3);
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            }

            return _this;
          }

          _createClass(InternMap, [{
            key: "get",
            value: function get(key) {
              return _get(_getPrototypeOf(InternMap.prototype), "get", this).call(this, intern_get(this, key));
            }
          }, {
            key: "has",
            value: function has(key) {
              return _get(_getPrototypeOf(InternMap.prototype), "has", this).call(this, intern_get(this, key));
            }
          }, {
            key: "set",
            value: function set(key, value) {
              return _get(_getPrototypeOf(InternMap.prototype), "set", this).call(this, intern_set(this, key), value);
            }
          }, {
            key: "delete",
            value: function _delete(key) {
              return _get(_getPrototypeOf(InternMap.prototype), "delete", this).call(this, intern_delete(this, key));
            }
          }]);

          return InternMap;
        }( /*#__PURE__*/_wrapNativeSuper(Map));

        var InternSet = /*#__PURE__*/function (_Set) {
          _inherits(InternSet, _Set);

          var _super2 = _createSuper(InternSet);

          function InternSet(values) {
            var _this2;

            var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : keyof;

            _classCallCheck(this, InternSet);

            _this2 = _super2.call(this);
            Object.defineProperties(_assertThisInitialized(_this2), {
              _intern: {
                value: new Map()
              },
              _key: {
                value: key
              }
            });

            if (values != null) {
              var _iterator4 = _createForOfIteratorHelper(values),
                  _step4;

              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  var _value4 = _step4.value;

                  _this2.add(_value4);
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
            }

            return _this2;
          }

          _createClass(InternSet, [{
            key: "has",
            value: function has(value) {
              return _get(_getPrototypeOf(InternSet.prototype), "has", this).call(this, intern_get(this, value));
            }
          }, {
            key: "add",
            value: function add(value) {
              return _get(_getPrototypeOf(InternSet.prototype), "add", this).call(this, intern_set(this, value));
            }
          }, {
            key: "delete",
            value: function _delete(value) {
              return _get(_getPrototypeOf(InternSet.prototype), "delete", this).call(this, intern_delete(this, value));
            }
          }]);

          return InternSet;
        }( /*#__PURE__*/_wrapNativeSuper(Set));

        function intern_get(_ref4, value) {
          var _intern = _ref4._intern,
              _key = _ref4._key;

          var key = _key(value);

          return _intern.has(key) ? _intern.get(key) : value;
        }

        function intern_set(_ref5, value) {
          var _intern = _ref5._intern,
              _key = _ref5._key;

          var key = _key(value);

          if (_intern.has(key)) return _intern.get(key);

          _intern.set(key, value);

          return value;
        }

        function intern_delete(_ref6, value) {
          var _intern = _ref6._intern,
              _key = _ref6._key;

          var key = _key(value);

          if (_intern.has(key)) {
            value = _intern.get(value);

            _intern.delete(key);
          }

          return value;
        }

        function keyof(value) {
          return value !== null && _typeof2(value) === "object" ? value.valueOf() : value;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-array/src/identity.js

        /* harmony default export */

        function src_identity(x) {
          return x;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-array/src/group.js

        function group(values) {
          for (var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key3 = 1; _key3 < _len; _key3++) {
            keys[_key3 - 1] = arguments[_key3];
          }

          return nest(values, src_identity, src_identity, keys);
        }

        function groups(values) {
          for (var _len2 = arguments.length, keys = new Array(_len2 > 1 ? _len2 - 1 : 0), _key4 = 1; _key4 < _len2; _key4++) {
            keys[_key4 - 1] = arguments[_key4];
          }

          return nest(values, Array.from, identity, keys);
        }

        function rollup(values, reduce) {
          for (var _len3 = arguments.length, keys = new Array(_len3 > 2 ? _len3 - 2 : 0), _key5 = 2; _key5 < _len3; _key5++) {
            keys[_key5 - 2] = arguments[_key5];
          }

          return nest(values, identity, reduce, keys);
        }

        function rollups(values, reduce) {
          for (var _len4 = arguments.length, keys = new Array(_len4 > 2 ? _len4 - 2 : 0), _key6 = 2; _key6 < _len4; _key6++) {
            keys[_key6 - 2] = arguments[_key6];
          }

          return nest(values, Array.from, reduce, keys);
        }

        function index(values) {
          for (var _len5 = arguments.length, keys = new Array(_len5 > 1 ? _len5 - 1 : 0), _key7 = 1; _key7 < _len5; _key7++) {
            keys[_key7 - 1] = arguments[_key7];
          }

          return nest(values, identity, unique, keys);
        }

        function indexes(values) {
          for (var _len6 = arguments.length, keys = new Array(_len6 > 1 ? _len6 - 1 : 0), _key8 = 1; _key8 < _len6; _key8++) {
            keys[_key8 - 1] = arguments[_key8];
          }

          return nest(values, Array.from, unique, keys);
        }

        function unique(values) {
          if (values.length !== 1) throw new Error("duplicate key");
          return values[0];
        }

        function nest(values, map, reduce, keys) {
          return function regroup(values, i) {
            if (i >= keys.length) return reduce(values);
            var groups = new InternMap();
            var keyof = keys[i++];
            var index = -1;

            var _iterator5 = _createForOfIteratorHelper(values),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var _value5 = _step5.value;
                var key = keyof(_value5, ++index, values);

                var _group = groups.get(key);

                if (_group) _group.push(_value5);else groups.set(key, [_value5]);
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }

            var _iterator6 = _createForOfIteratorHelper(groups),
                _step6;

            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var _ref9 = _step6.value;

                var _ref8 = _slicedToArray2(_ref9, 2);

                var _key9 = _ref8[0];
                var _values = _ref8[1];
                groups.set(_key9, regroup(_values, i));
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }

            return map(groups);
          }(values, 0);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-array/src/max.js

        function max_max(values, valueof) {
          var max;

          if (valueof === undefined) {
            var _iterator7 = _createForOfIteratorHelper(values),
                _step7;

            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var _value6 = _step7.value;

                if (_value6 != null && (max < _value6 || max === undefined && _value6 >= _value6)) {
                  max = _value6;
                }
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
          } else {
            var _index3 = -1;

            var _iterator8 = _createForOfIteratorHelper(values),
                _step8;

            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var _value7 = _step8.value;

                if ((_value7 = valueof(_value7, ++_index3, values)) != null && (max < _value7 || max === undefined && _value7 >= _value7)) {
                  max = _value7;
                }
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
          }

          return max;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-array/src/min.js

        function min_min(values, valueof) {
          var min;

          if (valueof === undefined) {
            var _iterator9 = _createForOfIteratorHelper(values),
                _step9;

            try {
              for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                var _value8 = _step9.value;

                if (_value8 != null && (min > _value8 || min === undefined && _value8 >= _value8)) {
                  min = _value8;
                }
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }
          } else {
            var _index4 = -1;

            var _iterator10 = _createForOfIteratorHelper(values),
                _step10;

            try {
              for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                var _value9 = _step10.value;

                if ((_value9 = valueof(_value9, ++_index4, values)) != null && (min > _value9 || min === undefined && _value9 >= _value9)) {
                  min = _value9;
                }
              }
            } catch (err) {
              _iterator10.e(err);
            } finally {
              _iterator10.f();
            }
          }

          return min;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-array/src/index.js
        // Deprecated; use bin.
        // Deprecated; use leastIndex.

        ; // CONCATENATED MODULE: ./node_modules/d3-axis/src/array.js

        var slice = Array.prototype.slice;
        ; // CONCATENATED MODULE: ./node_modules/d3-axis/src/identity.js

        /* harmony default export */

        function d3_axis_src_identity(x) {
          return x;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-axis/src/axis.js

        var axis_top = 1,
            right = 2,
            bottom = 3,
            left = 4,
            epsilon = 1e-6;

        function translateX(x) {
          return "translate(" + x + ",0)";
        }

        function translateY(y) {
          return "translate(0," + y + ")";
        }

        function number(scale) {
          return function (d) {
            return +scale(d);
          };
        }

        function center(scale, offset) {
          offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
          if (scale.round()) offset = Math.round(offset);
          return function (d) {
            return +scale(d) + offset;
          };
        }

        function entering() {
          return !this.__axis;
        }

        function axis(orient, scale) {
          var tickArguments = [],
              tickValues = null,
              tickFormat = null,
              tickSizeInner = 6,
              tickSizeOuter = 6,
              tickPadding = 3,
              offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5,
              k = orient === axis_top || orient === left ? -1 : 1,
              x = orient === left || orient === right ? "x" : "y",
              transform = orient === axis_top || orient === bottom ? translateX : translateY;

          function axis(context) {
            var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues,
                format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : d3_axis_src_identity : tickFormat,
                spacing = Math.max(tickSizeInner, 0) + tickPadding,
                range = scale.range(),
                range0 = +range[0] + offset,
                range1 = +range[range.length - 1] + offset,
                position = (scale.bandwidth ? center : number)(scale.copy(), offset),
                selection = context.selection ? context.selection() : context,
                path = selection.selectAll(".domain").data([null]),
                tick = selection.selectAll(".tick").data(values, scale).order(),
                tickExit = tick.exit(),
                tickEnter = tick.enter().append("g").attr("class", "tick"),
                line = tick.select("line"),
                text = tick.select("text");
            path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
            tick = tick.merge(tickEnter);
            line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
            text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === axis_top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));

            if (context !== selection) {
              path = path.transition(context);
              tick = tick.transition(context);
              line = line.transition(context);
              text = text.transition(context);
              tickExit = tickExit.transition(context).attr("opacity", epsilon).attr("transform", function (d) {
                return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
              });
              tickEnter.attr("opacity", epsilon).attr("transform", function (d) {
                var p = this.parentNode.__axis;
                return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
              });
            }

            tickExit.remove();
            path.attr("d", orient === left || orient === right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
            tick.attr("opacity", 1).attr("transform", function (d) {
              return transform(position(d) + offset);
            });
            line.attr(x + "2", k * tickSizeInner);
            text.attr(x, k * spacing).text(format);
            selection.filter(entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
            selection.each(function () {
              this.__axis = position;
            });
          }

          axis.scale = function (_) {
            return arguments.length ? (scale = _, axis) : scale;
          };

          axis.ticks = function () {
            return tickArguments = slice.call(arguments), axis;
          };

          axis.tickArguments = function (_) {
            return arguments.length ? (tickArguments = _ == null ? [] : slice.call(_), axis) : tickArguments.slice();
          };

          axis.tickValues = function (_) {
            return arguments.length ? (tickValues = _ == null ? null : slice.call(_), axis) : tickValues && tickValues.slice();
          };

          axis.tickFormat = function (_) {
            return arguments.length ? (tickFormat = _, axis) : tickFormat;
          };

          axis.tickSize = function (_) {
            return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
          };

          axis.tickSizeInner = function (_) {
            return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
          };

          axis.tickSizeOuter = function (_) {
            return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
          };

          axis.tickPadding = function (_) {
            return arguments.length ? (tickPadding = +_, axis) : tickPadding;
          };

          axis.offset = function (_) {
            return arguments.length ? (offset = +_, axis) : offset;
          };

          return axis;
        }

        function axisTop(scale) {
          return axis(axis_top, scale);
        }

        function axisRight(scale) {
          return axis(right, scale);
        }

        function axisBottom(scale) {
          return axis(bottom, scale);
        }

        function axisLeft(scale) {
          return axis(left, scale);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-axis/src/index.js

        ; // CONCATENATED MODULE: ./node_modules/d3-dispatch/src/dispatch.js

        var noop = {
          value: function value() {}
        };

        function dispatch_dispatch() {
          for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
            if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
            _[t] = [];
          }

          return new Dispatch(_);
        }

        function Dispatch(_) {
          this._ = _;
        }

        function parseTypenames(typenames, types) {
          return typenames.trim().split(/^|\s+/).map(function (t) {
            var name = "",
                i = t.indexOf(".");
            if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
            if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
            return {
              type: t,
              name: name
            };
          });
        }

        Dispatch.prototype = dispatch_dispatch.prototype = {
          constructor: Dispatch,
          on: function on(typename, callback) {
            var _ = this._,
                T = parseTypenames(typename + "", _),
                t,
                i = -1,
                n = T.length; // If no callback was specified, return the callback of the given type and name.

            if (arguments.length < 2) {
              while (++i < n) {
                if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
              }

              return;
            } // If a type was specified, set the callback for the given type and name.
            // Otherwise, if a null callback was specified, remove callbacks of the given name.


            if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);

            while (++i < n) {
              if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);else if (callback == null) for (t in _) {
                _[t] = set(_[t], typename.name, null);
              }
            }

            return this;
          },
          copy: function copy() {
            var copy = {},
                _ = this._;

            for (var t in _) {
              copy[t] = _[t].slice();
            }

            return new Dispatch(copy);
          },
          call: function call(type, that) {
            if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) {
              args[i] = arguments[i + 2];
            }
            if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);

            for (t = this._[type], i = 0, n = t.length; i < n; ++i) {
              t[i].value.apply(that, args);
            }
          },
          apply: function apply(type, that, args) {
            if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);

            for (var t = this._[type], i = 0, n = t.length; i < n; ++i) {
              t[i].value.apply(that, args);
            }
          }
        };

        function get(type, name) {
          for (var i = 0, n = type.length, c; i < n; ++i) {
            if ((c = type[i]).name === name) {
              return c.value;
            }
          }
        }

        function set(type, name, callback) {
          for (var i = 0, n = type.length; i < n; ++i) {
            if (type[i].name === name) {
              type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
              break;
            }
          }

          if (callback != null) type.push({
            name: name,
            value: callback
          });
          return type;
        }
        /* harmony default export */


        var src_dispatch = dispatch_dispatch;
        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selector.js

        function none() {}
        /* harmony default export */


        function selector(selector) {
          return selector == null ? none : function () {
            return this.querySelector(selector);
          };
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/select.js

        /* harmony default export */

        function selection_select(select) {
          if (typeof select !== "function") select = selector(select);

          for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
            for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
              if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
              }
            }
          }

          return new Selection(subgroups, this._parents);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/array.js

        /* harmony default export */

        function array(x) {
          return _typeof2(x) === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
          : Array.from(x); // Map, Set, iterable, string, or anything else
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selectorAll.js

        function empty() {
          return [];
        }
        /* harmony default export */


        function selectorAll(selector) {
          return selector == null ? empty : function () {
            return this.querySelectorAll(selector);
          };
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/selectAll.js

        function arrayAll(select) {
          return function () {
            var group = select.apply(this, arguments);
            return group == null ? [] : array(group);
          };
        }
        /* harmony default export */


        function selectAll(select) {
          if (typeof select === "function") select = arrayAll(select);else select = selectorAll(select);

          for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
            for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
              if (node = group[i]) {
                subgroups.push(select.call(node, node.__data__, i, group));
                parents.push(node);
              }
            }
          }

          return new Selection(subgroups, parents);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/matcher.js

        /* harmony default export */

        function matcher(selector) {
          return function () {
            return this.matches(selector);
          };
        }

        function childMatcher(selector) {
          return function (node) {
            return node.matches(selector);
          };
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/selectChild.js

        var find = Array.prototype.find;

        function childFind(match) {
          return function () {
            return find.call(this.children, match);
          };
        }

        function childFirst() {
          return this.firstElementChild;
        }
        /* harmony default export */


        function selectChild(match) {
          return this.select(match == null ? childFirst : childFind(typeof match === "function" ? match : childMatcher(match)));
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/selectChildren.js

        var filter = Array.prototype.filter;

        function children() {
          return this.children;
        }

        function childrenFilter(match) {
          return function () {
            return filter.call(this.children, match);
          };
        }
        /* harmony default export */


        function selectChildren(match) {
          return this.selectAll(match == null ? children : childrenFilter(typeof match === "function" ? match : childMatcher(match)));
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/filter.js

        /* harmony default export */

        function selection_filter(match) {
          if (typeof match !== "function") match = matcher(match);

          for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
            for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
              if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
                subgroup.push(node);
              }
            }
          }

          return new Selection(subgroups, this._parents);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/sparse.js

        /* harmony default export */

        function sparse(update) {
          return new Array(update.length);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/enter.js

        /* harmony default export */

        function enter() {
          return new Selection(this._enter || this._groups.map(sparse), this._parents);
        }

        function EnterNode(parent, datum) {
          this.ownerDocument = parent.ownerDocument;
          this.namespaceURI = parent.namespaceURI;
          this._next = null;
          this._parent = parent;
          this.__data__ = datum;
        }

        EnterNode.prototype = {
          constructor: EnterNode,
          appendChild: function appendChild(child) {
            return this._parent.insertBefore(child, this._next);
          },
          insertBefore: function insertBefore(child, next) {
            return this._parent.insertBefore(child, next);
          },
          querySelector: function querySelector(selector) {
            return this._parent.querySelector(selector);
          },
          querySelectorAll: function querySelectorAll(selector) {
            return this._parent.querySelectorAll(selector);
          }
        };
        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/constant.js

        /* harmony default export */

        function src_constant(x) {
          return function () {
            return x;
          };
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/data.js

        function bindIndex(parent, group, enter, update, exit, data) {
          var i = 0,
              node,
              groupLength = group.length,
              dataLength = data.length; // Put any non-null nodes that fit into update.
          // Put any null nodes into enter.
          // Put any remaining data into enter.

          for (; i < dataLength; ++i) {
            if (node = group[i]) {
              node.__data__ = data[i];
              update[i] = node;
            } else {
              enter[i] = new EnterNode(parent, data[i]);
            }
          } // Put any non-null nodes that don’t fit into exit.


          for (; i < groupLength; ++i) {
            if (node = group[i]) {
              exit[i] = node;
            }
          }
        }

        function bindKey(parent, group, enter, update, exit, data, key) {
          var i,
              node,
              nodeByKeyValue = new Map(),
              groupLength = group.length,
              dataLength = data.length,
              keyValues = new Array(groupLength),
              keyValue; // Compute the key for each node.
          // If multiple nodes have the same key, the duplicates are added to exit.

          for (i = 0; i < groupLength; ++i) {
            if (node = group[i]) {
              keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";

              if (nodeByKeyValue.has(keyValue)) {
                exit[i] = node;
              } else {
                nodeByKeyValue.set(keyValue, node);
              }
            }
          } // Compute the key for each datum.
          // If there a node associated with this key, join and add it to update.
          // If there is not (or the key is a duplicate), add it to enter.


          for (i = 0; i < dataLength; ++i) {
            keyValue = key.call(parent, data[i], i, data) + "";

            if (node = nodeByKeyValue.get(keyValue)) {
              update[i] = node;
              node.__data__ = data[i];
              nodeByKeyValue.delete(keyValue);
            } else {
              enter[i] = new EnterNode(parent, data[i]);
            }
          } // Add any remaining nodes that were not bound to data to exit.


          for (i = 0; i < groupLength; ++i) {
            if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) {
              exit[i] = node;
            }
          }
        }

        function datum(node) {
          return node.__data__;
        }
        /* harmony default export */


        function data(value, key) {
          if (!arguments.length) return Array.from(this, datum);
          var bind = key ? bindKey : bindIndex,
              parents = this._parents,
              groups = this._groups;
          if (typeof value !== "function") value = src_constant(value);

          for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
            var parent = parents[j],
                group = groups[j],
                groupLength = group.length,
                data = array(value.call(parent, parent && parent.__data__, j, parents)),
                dataLength = data.length,
                enterGroup = enter[j] = new Array(dataLength),
                updateGroup = update[j] = new Array(dataLength),
                exitGroup = exit[j] = new Array(groupLength);
            bind(parent, group, enterGroup, updateGroup, exitGroup, data, key); // Now connect the enter nodes to their following update node, such that
            // appendChild can insert the materialized enter node before this node,
            // rather than at the end of the parent node.

            for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
              if (previous = enterGroup[i0]) {
                if (i0 >= i1) i1 = i0 + 1;

                while (!(next = updateGroup[i1]) && ++i1 < dataLength) {
                  ;
                }

                previous._next = next || null;
              }
            }
          }

          update = new Selection(update, parents);
          update._enter = enter;
          update._exit = exit;
          return update;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/exit.js

        /* harmony default export */

        function exit() {
          return new Selection(this._exit || this._groups.map(sparse), this._parents);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/join.js

        /* harmony default export */

        function join(onenter, onupdate, onexit) {
          var enter = this.enter(),
              update = this,
              exit = this.exit();
          enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
          if (onupdate != null) update = onupdate(update);
          if (onexit == null) exit.remove();else onexit(exit);
          return enter && update ? enter.merge(update).order() : update;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/merge.js

        /* harmony default export */

        function merge(selection) {
          if (!(selection instanceof Selection)) throw new Error("invalid merge");

          for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
            for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
              if (node = group0[i] || group1[i]) {
                merge[i] = node;
              }
            }
          }

          for (; j < m0; ++j) {
            merges[j] = groups0[j];
          }

          return new Selection(merges, this._parents);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/order.js

        /* harmony default export */

        function order() {
          for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
            for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
              if (node = group[i]) {
                if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
                next = node;
              }
            }
          }

          return this;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/sort.js

        /* harmony default export */

        function sort(compare) {
          if (!compare) compare = sort_ascending;

          function compareNode(a, b) {
            return a && b ? compare(a.__data__, b.__data__) : !a - !b;
          }

          for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
            for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
              if (node = group[i]) {
                sortgroup[i] = node;
              }
            }

            sortgroup.sort(compareNode);
          }

          return new Selection(sortgroups, this._parents).order();
        }

        function sort_ascending(a, b) {
          return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/call.js

        /* harmony default export */

        function call() {
          var callback = arguments[0];
          arguments[0] = this;
          callback.apply(null, arguments);
          return this;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/nodes.js

        /* harmony default export */

        function nodes() {
          return Array.from(this);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/node.js

        /* harmony default export */

        function node() {
          for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
            for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
              var node = group[i];
              if (node) return node;
            }
          }

          return null;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/size.js

        /* harmony default export */

        function size() {
          var size = 0;

          var _iterator11 = _createForOfIteratorHelper(this),
              _step11;

          try {
            for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
              var _node = _step11.value;
              ++size;
            } // eslint-disable-line no-unused-vars

          } catch (err) {
            _iterator11.e(err);
          } finally {
            _iterator11.f();
          }

          return size;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/empty.js

        /* harmony default export */

        function selection_empty() {
          return !this.node();
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/each.js

        /* harmony default export */

        function each(callback) {
          for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
            for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
              if (node = group[i]) callback.call(node, node.__data__, i, group);
            }
          }

          return this;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/namespaces.js

        var xhtml = "http://www.w3.org/1999/xhtml";
        /* harmony default export */

        var namespaces = {
          svg: "http://www.w3.org/2000/svg",
          xhtml: xhtml,
          xlink: "http://www.w3.org/1999/xlink",
          xml: "http://www.w3.org/XML/1998/namespace",
          xmlns: "http://www.w3.org/2000/xmlns/"
        };
        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/namespace.js

        /* harmony default export */

        function namespace(name) {
          var prefix = name += "",
              i = prefix.indexOf(":");
          if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
          return namespaces.hasOwnProperty(prefix) ? {
            space: namespaces[prefix],
            local: name
          } : name; // eslint-disable-line no-prototype-builtins
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/attr.js

        function attrRemove(name) {
          return function () {
            this.removeAttribute(name);
          };
        }

        function attrRemoveNS(fullname) {
          return function () {
            this.removeAttributeNS(fullname.space, fullname.local);
          };
        }

        function attrConstant(name, value) {
          return function () {
            this.setAttribute(name, value);
          };
        }

        function attrConstantNS(fullname, value) {
          return function () {
            this.setAttributeNS(fullname.space, fullname.local, value);
          };
        }

        function attrFunction(name, value) {
          return function () {
            var v = value.apply(this, arguments);
            if (v == null) this.removeAttribute(name);else this.setAttribute(name, v);
          };
        }

        function attrFunctionNS(fullname, value) {
          return function () {
            var v = value.apply(this, arguments);
            if (v == null) this.removeAttributeNS(fullname.space, fullname.local);else this.setAttributeNS(fullname.space, fullname.local, v);
          };
        }
        /* harmony default export */


        function attr(name, value) {
          var fullname = namespace(name);

          if (arguments.length < 2) {
            var node = this.node();
            return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
          }

          return this.each((value == null ? fullname.local ? attrRemoveNS : attrRemove : typeof value === "function" ? fullname.local ? attrFunctionNS : attrFunction : fullname.local ? attrConstantNS : attrConstant)(fullname, value));
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/window.js

        /* harmony default export */

        function src_window(node) {
          return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
          || node.document && node // node is a Window
          || node.defaultView; // node is a Document
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/style.js

        function styleRemove(name) {
          return function () {
            this.style.removeProperty(name);
          };
        }

        function styleConstant(name, value, priority) {
          return function () {
            this.style.setProperty(name, value, priority);
          };
        }

        function styleFunction(name, value, priority) {
          return function () {
            var v = value.apply(this, arguments);
            if (v == null) this.style.removeProperty(name);else this.style.setProperty(name, v, priority);
          };
        }
        /* harmony default export */


        function style(name, value, priority) {
          return arguments.length > 1 ? this.each((value == null ? styleRemove : typeof value === "function" ? styleFunction : styleConstant)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
        }

        function styleValue(node, name) {
          return node.style.getPropertyValue(name) || src_window(node).getComputedStyle(node, null).getPropertyValue(name);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/property.js

        function propertyRemove(name) {
          return function () {
            delete this[name];
          };
        }

        function propertyConstant(name, value) {
          return function () {
            this[name] = value;
          };
        }

        function propertyFunction(name, value) {
          return function () {
            var v = value.apply(this, arguments);
            if (v == null) delete this[name];else this[name] = v;
          };
        }
        /* harmony default export */


        function property(name, value) {
          return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/classed.js

        function classArray(string) {
          return string.trim().split(/^|\s+/);
        }

        function classList(node) {
          return node.classList || new ClassList(node);
        }

        function ClassList(node) {
          this._node = node;
          this._names = classArray(node.getAttribute("class") || "");
        }

        ClassList.prototype = {
          add: function add(name) {
            var i = this._names.indexOf(name);

            if (i < 0) {
              this._names.push(name);

              this._node.setAttribute("class", this._names.join(" "));
            }
          },
          remove: function remove(name) {
            var i = this._names.indexOf(name);

            if (i >= 0) {
              this._names.splice(i, 1);

              this._node.setAttribute("class", this._names.join(" "));
            }
          },
          contains: function contains(name) {
            return this._names.indexOf(name) >= 0;
          }
        };

        function classedAdd(node, names) {
          var list = classList(node),
              i = -1,
              n = names.length;

          while (++i < n) {
            list.add(names[i]);
          }
        }

        function classedRemove(node, names) {
          var list = classList(node),
              i = -1,
              n = names.length;

          while (++i < n) {
            list.remove(names[i]);
          }
        }

        function classedTrue(names) {
          return function () {
            classedAdd(this, names);
          };
        }

        function classedFalse(names) {
          return function () {
            classedRemove(this, names);
          };
        }

        function classedFunction(names, value) {
          return function () {
            (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
          };
        }
        /* harmony default export */


        function classed(name, value) {
          var names = classArray(name + "");

          if (arguments.length < 2) {
            var list = classList(this.node()),
                i = -1,
                n = names.length;

            while (++i < n) {
              if (!list.contains(names[i])) return false;
            }

            return true;
          }

          return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/text.js

        function textRemove() {
          this.textContent = "";
        }

        function textConstant(value) {
          return function () {
            this.textContent = value;
          };
        }

        function textFunction(value) {
          return function () {
            var v = value.apply(this, arguments);
            this.textContent = v == null ? "" : v;
          };
        }
        /* harmony default export */


        function selection_text(value) {
          return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction : textConstant)(value)) : this.node().textContent;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/html.js

        function htmlRemove() {
          this.innerHTML = "";
        }

        function htmlConstant(value) {
          return function () {
            this.innerHTML = value;
          };
        }

        function htmlFunction(value) {
          return function () {
            var v = value.apply(this, arguments);
            this.innerHTML = v == null ? "" : v;
          };
        }
        /* harmony default export */


        function html(value) {
          return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/raise.js

        function raise() {
          if (this.nextSibling) this.parentNode.appendChild(this);
        }
        /* harmony default export */


        function selection_raise() {
          return this.each(raise);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/lower.js

        function lower() {
          if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
        }
        /* harmony default export */


        function selection_lower() {
          return this.each(lower);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/creator.js

        function creatorInherit(name) {
          return function () {
            var document = this.ownerDocument,
                uri = this.namespaceURI;
            return uri === xhtml && document.documentElement.namespaceURI === xhtml ? document.createElement(name) : document.createElementNS(uri, name);
          };
        }

        function creatorFixed(fullname) {
          return function () {
            return this.ownerDocument.createElementNS(fullname.space, fullname.local);
          };
        }
        /* harmony default export */


        function creator(name) {
          var fullname = namespace(name);
          return (fullname.local ? creatorFixed : creatorInherit)(fullname);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/append.js

        /* harmony default export */

        function append(name) {
          var create = typeof name === "function" ? name : creator(name);
          return this.select(function () {
            return this.appendChild(create.apply(this, arguments));
          });
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/insert.js

        function constantNull() {
          return null;
        }
        /* harmony default export */


        function insert(name, before) {
          var create = typeof name === "function" ? name : creator(name),
              select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
          return this.select(function () {
            return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
          });
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/remove.js

        function remove() {
          var parent = this.parentNode;
          if (parent) parent.removeChild(this);
        }
        /* harmony default export */


        function selection_remove() {
          return this.each(remove);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/clone.js

        function selection_cloneShallow() {
          var clone = this.cloneNode(false),
              parent = this.parentNode;
          return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
        }

        function selection_cloneDeep() {
          var clone = this.cloneNode(true),
              parent = this.parentNode;
          return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
        }
        /* harmony default export */


        function clone(deep) {
          return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/datum.js

        /* harmony default export */

        function selection_datum(value) {
          return arguments.length ? this.property("__data__", value) : this.node().__data__;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/on.js

        function contextListener(listener) {
          return function (event) {
            listener.call(this, event, this.__data__);
          };
        }

        function on_parseTypenames(typenames) {
          return typenames.trim().split(/^|\s+/).map(function (t) {
            var name = "",
                i = t.indexOf(".");
            if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
            return {
              type: t,
              name: name
            };
          });
        }

        function onRemove(typename) {
          return function () {
            var on = this.__on;
            if (!on) return;

            for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
              if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
              } else {
                on[++i] = o;
              }
            }

            if (++i) on.length = i;else delete this.__on;
          };
        }

        function onAdd(typename, value, options) {
          return function () {
            var on = this.__on,
                o,
                listener = contextListener(value);
            if (on) for (var j = 0, m = on.length; j < m; ++j) {
              if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
              }
            }
            this.addEventListener(typename.type, listener, options);
            o = {
              type: typename.type,
              name: typename.name,
              value: value,
              listener: listener,
              options: options
            };
            if (!on) this.__on = [o];else on.push(o);
          };
        }
        /* harmony default export */


        function on(typename, value, options) {
          var typenames = on_parseTypenames(typename + ""),
              i,
              n = typenames.length,
              t;

          if (arguments.length < 2) {
            var on = this.node().__on;

            if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
              for (i = 0, o = on[j]; i < n; ++i) {
                if ((t = typenames[i]).type === o.type && t.name === o.name) {
                  return o.value;
                }
              }
            }
            return;
          }

          on = value ? onAdd : onRemove;

          for (i = 0; i < n; ++i) {
            this.each(on(typenames[i], value, options));
          }

          return this;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/dispatch.js

        function dispatchEvent(node, type, params) {
          var window = src_window(node),
              event = window.CustomEvent;

          if (typeof event === "function") {
            event = new event(type, params);
          } else {
            event = window.document.createEvent("Event");
            if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;else event.initEvent(type, false, false);
          }

          node.dispatchEvent(event);
        }

        function dispatchConstant(type, params) {
          return function () {
            return dispatchEvent(this, type, params);
          };
        }

        function dispatchFunction(type, params) {
          return function () {
            return dispatchEvent(this, type, params.apply(this, arguments));
          };
        }
        /* harmony default export */


        function selection_dispatch(type, params) {
          return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type, params));
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/iterator.js

        /* harmony default export */

        function iterator() {
          var groups, j, m, group, i, n, node;
          return _regeneratorRuntime.wrap(function iterator$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  groups = this._groups, j = 0, m = groups.length;

                case 1:
                  if (!(j < m)) {
                    _context.next = 13;
                    break;
                  }

                  group = groups[j], i = 0, n = group.length;

                case 3:
                  if (!(i < n)) {
                    _context.next = 10;
                    break;
                  }

                  if (!(node = group[i])) {
                    _context.next = 7;
                    break;
                  }

                  _context.next = 7;
                  return node;

                case 7:
                  ++i;
                  _context.next = 3;
                  break;

                case 10:
                  ++j;
                  _context.next = 1;
                  break;

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _marked, this);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/index.js

        var root = [null];

        function Selection(groups, parents) {
          this._groups = groups;
          this._parents = parents;
        }

        function selection() {
          return new Selection([[document.documentElement]], root);
        }

        function selection_selection() {
          return this;
        }

        Selection.prototype = selection.prototype = _defineProperty2({
          constructor: Selection,
          select: selection_select,
          selectAll: selectAll,
          selectChild: selectChild,
          selectChildren: selectChildren,
          filter: selection_filter,
          data: data,
          enter: enter,
          exit: exit,
          join: join,
          merge: merge,
          selection: selection_selection,
          order: order,
          sort: sort,
          call: call,
          nodes: nodes,
          node: node,
          size: size,
          empty: selection_empty,
          each: each,
          attr: attr,
          style: style,
          property: property,
          classed: classed,
          text: selection_text,
          html: html,
          raise: selection_raise,
          lower: selection_lower,
          append: append,
          insert: insert,
          remove: selection_remove,
          clone: clone,
          datum: selection_datum,
          on: on,
          dispatch: selection_dispatch
        }, Symbol.iterator, iterator);
        /* harmony default export */

        var src_selection = selection;
        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/select.js

        /* harmony default export */

        function src_select(selector) {
          return typeof selector === "string" ? new Selection([[document.querySelector(selector)]], [document.documentElement]) : new Selection([[selector]], root);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-drag/src/noevent.js

        function noevent_nopropagation(event) {
          event.stopImmediatePropagation();
        }
        /* harmony default export */


        function src_noevent(event) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-drag/src/nodrag.js

        /* harmony default export */

        function nodrag(view) {
          var root = view.document.documentElement,
              selection = src_select(view).on("dragstart.drag", src_noevent, true);

          if ("onselectstart" in root) {
            selection.on("selectstart.drag", src_noevent, true);
          } else {
            root.__noselect = root.style.MozUserSelect;
            root.style.MozUserSelect = "none";
          }
        }

        function yesdrag(view, noclick) {
          var root = view.document.documentElement,
              selection = src_select(view).on("dragstart.drag", null);

          if (noclick) {
            selection.on("click.drag", src_noevent, true);
            setTimeout(function () {
              selection.on("click.drag", null);
            }, 0);
          }

          if ("onselectstart" in root) {
            selection.on("selectstart.drag", null);
          } else {
            root.style.MozUserSelect = root.__noselect;
            delete root.__noselect;
          }
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-color/src/define.js

        /* harmony default export */

        function src_define(constructor, factory, prototype) {
          constructor.prototype = factory.prototype = prototype;
          prototype.constructor = constructor;
        }

        function extend(parent, definition) {
          var prototype = Object.create(parent.prototype);

          for (var key in definition) {
            prototype[key] = definition[key];
          }

          return prototype;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-color/src/color.js

        function Color() {}

        var _darker = 0.7;

        var _brighter = 1 / _darker;

        var reI = "\\s*([+-]?\\d+)\\s*",
            reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
            reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
            reHex = /^#([0-9a-f]{3,8})$/,
            reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
            reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
            reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
            reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
            reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
            reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
        var named = {
          aliceblue: 0xf0f8ff,
          antiquewhite: 0xfaebd7,
          aqua: 0x00ffff,
          aquamarine: 0x7fffd4,
          azure: 0xf0ffff,
          beige: 0xf5f5dc,
          bisque: 0xffe4c4,
          black: 0x000000,
          blanchedalmond: 0xffebcd,
          blue: 0x0000ff,
          blueviolet: 0x8a2be2,
          brown: 0xa52a2a,
          burlywood: 0xdeb887,
          cadetblue: 0x5f9ea0,
          chartreuse: 0x7fff00,
          chocolate: 0xd2691e,
          coral: 0xff7f50,
          cornflowerblue: 0x6495ed,
          cornsilk: 0xfff8dc,
          crimson: 0xdc143c,
          cyan: 0x00ffff,
          darkblue: 0x00008b,
          darkcyan: 0x008b8b,
          darkgoldenrod: 0xb8860b,
          darkgray: 0xa9a9a9,
          darkgreen: 0x006400,
          darkgrey: 0xa9a9a9,
          darkkhaki: 0xbdb76b,
          darkmagenta: 0x8b008b,
          darkolivegreen: 0x556b2f,
          darkorange: 0xff8c00,
          darkorchid: 0x9932cc,
          darkred: 0x8b0000,
          darksalmon: 0xe9967a,
          darkseagreen: 0x8fbc8f,
          darkslateblue: 0x483d8b,
          darkslategray: 0x2f4f4f,
          darkslategrey: 0x2f4f4f,
          darkturquoise: 0x00ced1,
          darkviolet: 0x9400d3,
          deeppink: 0xff1493,
          deepskyblue: 0x00bfff,
          dimgray: 0x696969,
          dimgrey: 0x696969,
          dodgerblue: 0x1e90ff,
          firebrick: 0xb22222,
          floralwhite: 0xfffaf0,
          forestgreen: 0x228b22,
          fuchsia: 0xff00ff,
          gainsboro: 0xdcdcdc,
          ghostwhite: 0xf8f8ff,
          gold: 0xffd700,
          goldenrod: 0xdaa520,
          gray: 0x808080,
          green: 0x008000,
          greenyellow: 0xadff2f,
          grey: 0x808080,
          honeydew: 0xf0fff0,
          hotpink: 0xff69b4,
          indianred: 0xcd5c5c,
          indigo: 0x4b0082,
          ivory: 0xfffff0,
          khaki: 0xf0e68c,
          lavender: 0xe6e6fa,
          lavenderblush: 0xfff0f5,
          lawngreen: 0x7cfc00,
          lemonchiffon: 0xfffacd,
          lightblue: 0xadd8e6,
          lightcoral: 0xf08080,
          lightcyan: 0xe0ffff,
          lightgoldenrodyellow: 0xfafad2,
          lightgray: 0xd3d3d3,
          lightgreen: 0x90ee90,
          lightgrey: 0xd3d3d3,
          lightpink: 0xffb6c1,
          lightsalmon: 0xffa07a,
          lightseagreen: 0x20b2aa,
          lightskyblue: 0x87cefa,
          lightslategray: 0x778899,
          lightslategrey: 0x778899,
          lightsteelblue: 0xb0c4de,
          lightyellow: 0xffffe0,
          lime: 0x00ff00,
          limegreen: 0x32cd32,
          linen: 0xfaf0e6,
          magenta: 0xff00ff,
          maroon: 0x800000,
          mediumaquamarine: 0x66cdaa,
          mediumblue: 0x0000cd,
          mediumorchid: 0xba55d3,
          mediumpurple: 0x9370db,
          mediumseagreen: 0x3cb371,
          mediumslateblue: 0x7b68ee,
          mediumspringgreen: 0x00fa9a,
          mediumturquoise: 0x48d1cc,
          mediumvioletred: 0xc71585,
          midnightblue: 0x191970,
          mintcream: 0xf5fffa,
          mistyrose: 0xffe4e1,
          moccasin: 0xffe4b5,
          navajowhite: 0xffdead,
          navy: 0x000080,
          oldlace: 0xfdf5e6,
          olive: 0x808000,
          olivedrab: 0x6b8e23,
          orange: 0xffa500,
          orangered: 0xff4500,
          orchid: 0xda70d6,
          palegoldenrod: 0xeee8aa,
          palegreen: 0x98fb98,
          paleturquoise: 0xafeeee,
          palevioletred: 0xdb7093,
          papayawhip: 0xffefd5,
          peachpuff: 0xffdab9,
          peru: 0xcd853f,
          pink: 0xffc0cb,
          plum: 0xdda0dd,
          powderblue: 0xb0e0e6,
          purple: 0x800080,
          rebeccapurple: 0x663399,
          red: 0xff0000,
          rosybrown: 0xbc8f8f,
          royalblue: 0x4169e1,
          saddlebrown: 0x8b4513,
          salmon: 0xfa8072,
          sandybrown: 0xf4a460,
          seagreen: 0x2e8b57,
          seashell: 0xfff5ee,
          sienna: 0xa0522d,
          silver: 0xc0c0c0,
          skyblue: 0x87ceeb,
          slateblue: 0x6a5acd,
          slategray: 0x708090,
          slategrey: 0x708090,
          snow: 0xfffafa,
          springgreen: 0x00ff7f,
          steelblue: 0x4682b4,
          tan: 0xd2b48c,
          teal: 0x008080,
          thistle: 0xd8bfd8,
          tomato: 0xff6347,
          turquoise: 0x40e0d0,
          violet: 0xee82ee,
          wheat: 0xf5deb3,
          white: 0xffffff,
          whitesmoke: 0xf5f5f5,
          yellow: 0xffff00,
          yellowgreen: 0x9acd32
        };
        src_define(Color, color, {
          copy: function copy(channels) {
            return Object.assign(new this.constructor(), this, channels);
          },
          displayable: function displayable() {
            return this.rgb().displayable();
          },
          hex: color_formatHex,
          // Deprecated! Use color.formatHex.
          formatHex: color_formatHex,
          formatHsl: color_formatHsl,
          formatRgb: color_formatRgb,
          toString: color_formatRgb
        });

        function color_formatHex() {
          return this.rgb().formatHex();
        }

        function color_formatHsl() {
          return hslConvert(this).formatHsl();
        }

        function color_formatRgb() {
          return this.rgb().formatRgb();
        }

        function color(format) {
          var m, l;
          format = (format + "").trim().toLowerCase();
          return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
          : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
          : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
          : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
          : null // invalid hex
          ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
          : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
          : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
          : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
          : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
          : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
          : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
          : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
        }

        function rgbn(n) {
          return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
        }

        function rgba(r, g, b, a) {
          if (a <= 0) r = g = b = NaN;
          return new Rgb(r, g, b, a);
        }

        function rgbConvert(o) {
          if (!(o instanceof Color)) o = color(o);
          if (!o) return new Rgb();
          o = o.rgb();
          return new Rgb(o.r, o.g, o.b, o.opacity);
        }

        function color_rgb(r, g, b, opacity) {
          return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
        }

        function Rgb(r, g, b, opacity) {
          this.r = +r;
          this.g = +g;
          this.b = +b;
          this.opacity = +opacity;
        }

        src_define(Rgb, color_rgb, extend(Color, {
          brighter: function brighter(k) {
            k = k == null ? _brighter : Math.pow(_brighter, k);
            return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
          },
          darker: function darker(k) {
            k = k == null ? _darker : Math.pow(_darker, k);
            return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
          },
          rgb: function rgb() {
            return this;
          },
          displayable: function displayable() {
            return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
          },
          hex: rgb_formatHex,
          // Deprecated! Use color.formatHex.
          formatHex: rgb_formatHex,
          formatRgb: rgb_formatRgb,
          toString: rgb_formatRgb
        }));

        function rgb_formatHex() {
          return "#" + hex(this.r) + hex(this.g) + hex(this.b);
        }

        function rgb_formatRgb() {
          var a = this.opacity;
          a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
          return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
        }

        function hex(value) {
          value = Math.max(0, Math.min(255, Math.round(value) || 0));
          return (value < 16 ? "0" : "") + value.toString(16);
        }

        function hsla(h, s, l, a) {
          if (a <= 0) h = s = l = NaN;else if (l <= 0 || l >= 1) h = s = NaN;else if (s <= 0) h = NaN;
          return new Hsl(h, s, l, a);
        }

        function hslConvert(o) {
          if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
          if (!(o instanceof Color)) o = color(o);
          if (!o) return new Hsl();
          if (o instanceof Hsl) return o;
          o = o.rgb();
          var r = o.r / 255,
              g = o.g / 255,
              b = o.b / 255,
              min = Math.min(r, g, b),
              max = Math.max(r, g, b),
              h = NaN,
              s = max - min,
              l = (max + min) / 2;

          if (s) {
            if (r === max) h = (g - b) / s + (g < b) * 6;else if (g === max) h = (b - r) / s + 2;else h = (r - g) / s + 4;
            s /= l < 0.5 ? max + min : 2 - max - min;
            h *= 60;
          } else {
            s = l > 0 && l < 1 ? 0 : h;
          }

          return new Hsl(h, s, l, o.opacity);
        }

        function hsl(h, s, l, opacity) {
          return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
        }

        function Hsl(h, s, l, opacity) {
          this.h = +h;
          this.s = +s;
          this.l = +l;
          this.opacity = +opacity;
        }

        src_define(Hsl, hsl, extend(Color, {
          brighter: function brighter(k) {
            k = k == null ? _brighter : Math.pow(_brighter, k);
            return new Hsl(this.h, this.s, this.l * k, this.opacity);
          },
          darker: function darker(k) {
            k = k == null ? _darker : Math.pow(_darker, k);
            return new Hsl(this.h, this.s, this.l * k, this.opacity);
          },
          rgb: function rgb() {
            var h = this.h % 360 + (this.h < 0) * 360,
                s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
                l = this.l,
                m2 = l + (l < 0.5 ? l : 1 - l) * s,
                m1 = 2 * l - m2;
            return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
          },
          displayable: function displayable() {
            return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
          },
          formatHsl: function formatHsl() {
            var a = this.opacity;
            a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
            return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
          }
        }));
        /* From FvD 13.37, CSS Color Module Level 3 */

        function hsl2rgb(h, m1, m2) {
          return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/basis.js

        function basis(t1, v0, v1, v2, v3) {
          var t2 = t1 * t1,
              t3 = t2 * t1;
          return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
        }
        /* harmony default export */


        function src_basis(values) {
          var n = values.length - 1;
          return function (t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
                v1 = values[i],
                v2 = values[i + 1],
                v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
                v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis((t - i / n) * n, v0, v1, v2, v3);
          };
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/basisClosed.js

        /* harmony default export */

        function basisClosed(values) {
          var n = values.length;
          return function (t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
                v0 = values[(i + n - 1) % n],
                v1 = values[i % n],
                v2 = values[(i + 1) % n],
                v3 = values[(i + 2) % n];
            return basis((t - i / n) * n, v0, v1, v2, v3);
          };
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/constant.js

        /* harmony default export */

        var d3_interpolate_src_constant = function d3_interpolate_src_constant(x) {
          return function () {
            return x;
          };
        };

        ; // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/color.js

        function linear(a, d) {
          return function (t) {
            return a + t * d;
          };
        }

        function exponential(a, b, y) {
          return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function (t) {
            return Math.pow(a + t * b, y);
          };
        }

        function hue(a, b) {
          var d = b - a;
          return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
        }

        function gamma(y) {
          return (y = +y) === 1 ? nogamma : function (a, b) {
            return b - a ? exponential(a, b, y) : d3_interpolate_src_constant(isNaN(a) ? b : a);
          };
        }

        function nogamma(a, b) {
          var d = b - a;
          return d ? linear(a, d) : d3_interpolate_src_constant(isNaN(a) ? b : a);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/rgb.js

        /* harmony default export */

        var rgb = function rgbGamma(y) {
          var color = gamma(y);

          function rgb(start, end) {
            var r = color((start = color_rgb(start)).r, (end = color_rgb(end)).r),
                g = color(start.g, end.g),
                b = color(start.b, end.b),
                opacity = nogamma(start.opacity, end.opacity);
            return function (t) {
              start.r = r(t);
              start.g = g(t);
              start.b = b(t);
              start.opacity = opacity(t);
              return start + "";
            };
          }

          rgb.gamma = rgbGamma;
          return rgb;
        }(1);

        function rgbSpline(spline) {
          return function (colors) {
            var n = colors.length,
                r = new Array(n),
                g = new Array(n),
                b = new Array(n),
                i,
                color;

            for (i = 0; i < n; ++i) {
              color = color_rgb(colors[i]);
              r[i] = color.r || 0;
              g[i] = color.g || 0;
              b[i] = color.b || 0;
            }

            r = spline(r);
            g = spline(g);
            b = spline(b);
            color.opacity = 1;
            return function (t) {
              color.r = r(t);
              color.g = g(t);
              color.b = b(t);
              return color + "";
            };
          };
        }

        var rgbBasis = rgbSpline(src_basis);
        var rgbBasisClosed = rgbSpline(basisClosed);
        ; // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/array.js

        /* harmony default export */

        function src_array(a, b) {
          return (isNumberArray(b) ? numberArray : genericArray)(a, b);
        }

        function genericArray(a, b) {
          var nb = b ? b.length : 0,
              na = a ? Math.min(nb, a.length) : 0,
              x = new Array(na),
              c = new Array(nb),
              i;

          for (i = 0; i < na; ++i) {
            x[i] = value(a[i], b[i]);
          }

          for (; i < nb; ++i) {
            c[i] = b[i];
          }

          return function (t) {
            for (i = 0; i < na; ++i) {
              c[i] = x[i](t);
            }

            return c;
          };
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/date.js

        /* harmony default export */

        function date(a, b) {
          var d = new Date();
          return a = +a, b = +b, function (t) {
            return d.setTime(a * (1 - t) + b * t), d;
          };
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/number.js

        /* harmony default export */

        function src_number(a, b) {
          return a = +a, b = +b, function (t) {
            return a * (1 - t) + b * t;
          };
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/object.js

        /* harmony default export */

        function object(a, b) {
          var i = {},
              c = {},
              k;
          if (a === null || _typeof2(a) !== "object") a = {};
          if (b === null || _typeof2(b) !== "object") b = {};

          for (k in b) {
            if (k in a) {
              i[k] = value(a[k], b[k]);
            } else {
              c[k] = b[k];
            }
          }

          return function (t) {
            for (k in i) {
              c[k] = i[k](t);
            }

            return c;
          };
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/string.js

        var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
            reB = new RegExp(reA.source, "g");

        function zero(b) {
          return function () {
            return b;
          };
        }

        function one(b) {
          return function (t) {
            return b(t) + "";
          };
        }
        /* harmony default export */


        function string(a, b) {
          var bi = reA.lastIndex = reB.lastIndex = 0,
              // scan index for next number in b
          am,
              // current match in a
          bm,
              // current match in b
          bs,
              // string preceding current number in b, if any
          i = -1,
              // index in s
          s = [],
              // string constants and placeholders
          q = []; // number interpolators
          // Coerce inputs to strings.

          a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.

          while ((am = reA.exec(a)) && (bm = reB.exec(b))) {
            if ((bs = bm.index) > bi) {
              // a string precedes the next number in b
              bs = b.slice(bi, bs);
              if (s[i]) s[i] += bs; // coalesce with previous string
              else s[++i] = bs;
            }

            if ((am = am[0]) === (bm = bm[0])) {
              // numbers in a & b match
              if (s[i]) s[i] += bm; // coalesce with previous string
              else s[++i] = bm;
            } else {
              // interpolate non-matching numbers
              s[++i] = null;
              q.push({
                i: i,
                x: src_number(am, bm)
              });
            }

            bi = reB.lastIndex;
          } // Add remains of b.


          if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
          } // Special optimization for only a single match.
          // Otherwise, interpolate each of the numbers and rejoin the string.


          return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function (t) {
            for (var i = 0, o; i < b; ++i) {
              s[(o = q[i]).i] = o.x(t);
            }

            return s.join("");
          });
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/numberArray.js

        /* harmony default export */

        function src_numberArray(a, b) {
          if (!b) b = [];
          var n = a ? Math.min(b.length, a.length) : 0,
              c = b.slice(),
              i;
          return function (t) {
            for (i = 0; i < n; ++i) {
              c[i] = a[i] * (1 - t) + b[i] * t;
            }

            return c;
          };
        }

        function numberArray_isNumberArray(x) {
          return ArrayBuffer.isView(x) && !(x instanceof DataView);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/value.js

        /* harmony default export */

        function value(a, b) {
          var t = _typeof2(b),
              c;

          return b == null || t === "boolean" ? d3_interpolate_src_constant(b) : (t === "number" ? src_number : t === "string" ? (c = color(b)) ? (b = c, rgb) : string : b instanceof color ? rgb : b instanceof Date ? date : numberArray_isNumberArray(b) ? src_numberArray : Array.isArray(b) ? genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object : src_number)(a, b);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/sourceEvent.js

        /* harmony default export */

        function sourceEvent(event) {
          var sourceEvent;

          while (sourceEvent = event.sourceEvent) {
            event = sourceEvent;
          }

          return event;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/pointer.js

        /* harmony default export */

        function src_pointer(event, node) {
          event = sourceEvent(event);
          if (node === undefined) node = event.currentTarget;

          if (node) {
            var svg = node.ownerSVGElement || node;

            if (svg.createSVGPoint) {
              var point = svg.createSVGPoint();
              point.x = event.clientX, point.y = event.clientY;
              point = point.matrixTransform(node.getScreenCTM().inverse());
              return [point.x, point.y];
            }

            if (node.getBoundingClientRect) {
              var rect = node.getBoundingClientRect();
              return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
            }
          }

          return [event.pageX, event.pageY];
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-timer/src/timer.js

        var timer_frame = 0,
            // is an animation frame pending?
        timeout = 0,
            // is a timeout pending?
        interval = 0,
            // are any timers active?
        pokeDelay = 1000,
            // how frequently we check for clock skew
        taskHead,
            taskTail,
            clockLast = 0,
            clockNow = 0,
            clockSkew = 0,
            clock = (typeof performance === "undefined" ? "undefined" : _typeof2(performance)) === "object" && performance.now ? performance : Date,
            setFrame = (typeof window === "undefined" ? "undefined" : _typeof2(window)) === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (f) {
          setTimeout(f, 17);
        };

        function now() {
          return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
        }

        function clearNow() {
          clockNow = 0;
        }

        function Timer() {
          this._call = this._time = this._next = null;
        }

        Timer.prototype = timer.prototype = {
          constructor: Timer,
          restart: function restart(callback, delay, time) {
            if (typeof callback !== "function") throw new TypeError("callback is not a function");
            time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);

            if (!this._next && taskTail !== this) {
              if (taskTail) taskTail._next = this;else taskHead = this;
              taskTail = this;
            }

            this._call = callback;
            this._time = time;
            sleep();
          },
          stop: function stop() {
            if (this._call) {
              this._call = null;
              this._time = Infinity;
              sleep();
            }
          }
        };

        function timer(callback, delay, time) {
          var t = new Timer();
          t.restart(callback, delay, time);
          return t;
        }

        function timerFlush() {
          now(); // Get the current time, if not already set.

          ++timer_frame; // Pretend we’ve set an alarm, if we haven’t already.

          var t = taskHead,
              e;

          while (t) {
            if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
            t = t._next;
          }

          --timer_frame;
        }

        function wake() {
          clockNow = (clockLast = clock.now()) + clockSkew;
          timer_frame = timeout = 0;

          try {
            timerFlush();
          } finally {
            timer_frame = 0;
            nap();
            clockNow = 0;
          }
        }

        function poke() {
          var now = clock.now(),
              delay = now - clockLast;
          if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
        }

        function nap() {
          var t0,
              t1 = taskHead,
              t2,
              time = Infinity;

          while (t1) {
            if (t1._call) {
              if (time > t1._time) time = t1._time;
              t0 = t1, t1 = t1._next;
            } else {
              t2 = t1._next, t1._next = null;
              t1 = t0 ? t0._next = t2 : taskHead = t2;
            }
          }

          taskTail = t0;
          sleep(time);
        }

        function sleep(time) {
          if (timer_frame) return; // Soonest alarm already set, or will be.

          if (timeout) timeout = clearTimeout(timeout);
          var delay = time - clockNow; // Strictly less than if we recomputed clockNow.

          if (delay > 24) {
            if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
            if (interval) interval = clearInterval(interval);
          } else {
            if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
            timer_frame = 1, setFrame(wake);
          }
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-timer/src/timeout.js

        /* harmony default export */

        function src_timeout(callback, delay, time) {
          var t = new Timer();
          delay = delay == null ? 0 : +delay;
          t.restart(function (elapsed) {
            t.stop();
            callback(elapsed + delay);
          }, delay, time);
          return t;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/schedule.js

        var emptyOn = src_dispatch("start", "end", "cancel", "interrupt");
        var emptyTween = [];
        var CREATED = 0;
        var schedule_SCHEDULED = 1;
        var STARTING = 2;
        var STARTED = 3;
        var RUNNING = 4;
        var ENDING = 5;
        var ENDED = 6;
        /* harmony default export */

        function schedule(node, name, id, index, group, timing) {
          var schedules = node.__transition;
          if (!schedules) node.__transition = {};else if (id in schedules) return;
          create(node, id, {
            name: name,
            index: index,
            // For context during callback.
            group: group,
            // For context during callback.
            on: emptyOn,
            tween: emptyTween,
            time: timing.time,
            delay: timing.delay,
            duration: timing.duration,
            ease: timing.ease,
            timer: null,
            state: CREATED
          });
        }

        function init(node, id) {
          var schedule = schedule_get(node, id);
          if (schedule.state > CREATED) throw new Error("too late; already scheduled");
          return schedule;
        }

        function schedule_set(node, id) {
          var schedule = schedule_get(node, id);
          if (schedule.state > STARTED) throw new Error("too late; already running");
          return schedule;
        }

        function schedule_get(node, id) {
          var schedule = node.__transition;
          if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
          return schedule;
        }

        function create(node, id, self) {
          var schedules = node.__transition,
              tween; // Initialize the self timer when the transition is created.
          // Note the actual delay is not known until the first callback!

          schedules[id] = self;
          self.timer = timer(schedule, 0, self.time);

          function schedule(elapsed) {
            self.state = schedule_SCHEDULED;
            self.timer.restart(start, self.delay, self.time); // If the elapsed delay is less than our first sleep, start immediately.

            if (self.delay <= elapsed) start(elapsed - self.delay);
          }

          function start(elapsed) {
            var i, j, n, o; // If the state is not SCHEDULED, then we previously errored on start.

            if (self.state !== schedule_SCHEDULED) return stop();

            for (i in schedules) {
              o = schedules[i];
              if (o.name !== self.name) continue; // While this element already has a starting transition during this frame,
              // defer starting an interrupting transition until that transition has a
              // chance to tick (and possibly end); see d3/d3-transition#54!

              if (o.state === STARTED) return src_timeout(start); // Interrupt the active transition, if any.

              if (o.state === RUNNING) {
                o.state = ENDED;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
              } // Cancel any pre-empted transitions.
              else if (+i < id) {
                o.state = ENDED;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
              }
            } // Defer the first tick to end of the current frame; see d3/d3#1576.
            // Note the transition may be canceled after start and before the first tick!
            // Note this must be scheduled before the start event; see d3/d3-transition#16!
            // Assuming this is successful, subsequent callbacks go straight to tick.


            src_timeout(function () {
              if (self.state === STARTED) {
                self.state = RUNNING;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
              }
            }); // Dispatch the start event.
            // Note this must be done before the tween are initialized.

            self.state = STARTING;
            self.on.call("start", node, node.__data__, self.index, self.group);
            if (self.state !== STARTING) return; // interrupted

            self.state = STARTED; // Initialize the tween, deleting null tween.

            tween = new Array(n = self.tween.length);

            for (i = 0, j = -1; i < n; ++i) {
              if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
                tween[++j] = o;
              }
            }

            tween.length = j + 1;
          }

          function tick(elapsed) {
            var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
                i = -1,
                n = tween.length;

            while (++i < n) {
              tween[i].call(node, t);
            } // Dispatch the end event.


            if (self.state === ENDING) {
              self.on.call("end", node, node.__data__, self.index, self.group);
              stop();
            }
          }

          function stop() {
            self.state = ENDED;
            self.timer.stop();
            delete schedules[id];

            for (var i in schedules) {
              return;
            } // eslint-disable-line no-unused-vars


            delete node.__transition;
          }
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/interrupt.js

        /* harmony default export */

        function src_interrupt(node, name) {
          var schedules = node.__transition,
              schedule,
              active,
              empty = true,
              i;
          if (!schedules) return;
          name = name == null ? null : name + "";

          for (i in schedules) {
            if ((schedule = schedules[i]).name !== name) {
              empty = false;
              continue;
            }

            active = schedule.state > STARTING && schedule.state < ENDING;
            schedule.state = ENDED;
            schedule.timer.stop();
            schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
            delete schedules[i];
          }

          if (empty) delete node.__transition;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/selection/interrupt.js

        /* harmony default export */

        function selection_interrupt(name) {
          return this.each(function () {
            src_interrupt(this, name);
          });
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/transform/decompose.js

        var degrees = 180 / Math.PI;
        var decompose_identity = {
          translateX: 0,
          translateY: 0,
          rotate: 0,
          skewX: 0,
          scaleX: 1,
          scaleY: 1
        };
        /* harmony default export */

        function decompose(a, b, c, d, e, f) {
          var scaleX, scaleY, skewX;
          if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
          if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
          if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
          if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
          return {
            translateX: e,
            translateY: f,
            rotate: Math.atan2(b, a) * degrees,
            skewX: Math.atan(skewX) * degrees,
            scaleX: scaleX,
            scaleY: scaleY
          };
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/transform/parse.js

        var svgNode;
        /* eslint-disable no-undef */

        function parseCss(value) {
          var m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
          return m.isIdentity ? decompose_identity : decompose(m.a, m.b, m.c, m.d, m.e, m.f);
        }

        function parseSvg(value) {
          if (value == null) return decompose_identity;
          if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
          svgNode.setAttribute("transform", value);
          if (!(value = svgNode.transform.baseVal.consolidate())) return decompose_identity;
          value = value.matrix;
          return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/transform/index.js

        function interpolateTransform(parse, pxComma, pxParen, degParen) {
          function pop(s) {
            return s.length ? s.pop() + " " : "";
          }

          function translate(xa, ya, xb, yb, s, q) {
            if (xa !== xb || ya !== yb) {
              var i = s.push("translate(", null, pxComma, null, pxParen);
              q.push({
                i: i - 4,
                x: src_number(xa, xb)
              }, {
                i: i - 2,
                x: src_number(ya, yb)
              });
            } else if (xb || yb) {
              s.push("translate(" + xb + pxComma + yb + pxParen);
            }
          }

          function rotate(a, b, s, q) {
            if (a !== b) {
              if (a - b > 180) b += 360;else if (b - a > 180) a += 360; // shortest path

              q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: src_number(a, b)
              });
            } else if (b) {
              s.push(pop(s) + "rotate(" + b + degParen);
            }
          }

          function skewX(a, b, s, q) {
            if (a !== b) {
              q.push({
                i: s.push(pop(s) + "skewX(", null, degParen) - 2,
                x: src_number(a, b)
              });
            } else if (b) {
              s.push(pop(s) + "skewX(" + b + degParen);
            }
          }

          function scale(xa, ya, xb, yb, s, q) {
            if (xa !== xb || ya !== yb) {
              var i = s.push(pop(s) + "scale(", null, ",", null, ")");
              q.push({
                i: i - 4,
                x: src_number(xa, xb)
              }, {
                i: i - 2,
                x: src_number(ya, yb)
              });
            } else if (xb !== 1 || yb !== 1) {
              s.push(pop(s) + "scale(" + xb + "," + yb + ")");
            }
          }

          return function (a, b) {
            var s = [],
                // string constants and placeholders
            q = []; // number interpolators

            a = parse(a), b = parse(b);
            translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
            rotate(a.rotate, b.rotate, s, q);
            skewX(a.skewX, b.skewX, s, q);
            scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
            a = b = null; // gc

            return function (t) {
              var i = -1,
                  n = q.length,
                  o;

              while (++i < n) {
                s[(o = q[i]).i] = o.x(t);
              }

              return s.join("");
            };
          };
        }

        var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
        var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/tween.js

        function tweenRemove(id, name) {
          var tween0, tween1;
          return function () {
            var schedule = schedule_set(this, id),
                tween = schedule.tween; // If this node shared tween with the previous node,
            // just assign the updated shared tween and we’re done!
            // Otherwise, copy-on-write.

            if (tween !== tween0) {
              tween1 = tween0 = tween;

              for (var i = 0, n = tween1.length; i < n; ++i) {
                if (tween1[i].name === name) {
                  tween1 = tween1.slice();
                  tween1.splice(i, 1);
                  break;
                }
              }
            }

            schedule.tween = tween1;
          };
        }

        function tweenFunction(id, name, value) {
          var tween0, tween1;
          if (typeof value !== "function") throw new Error();
          return function () {
            var schedule = schedule_set(this, id),
                tween = schedule.tween; // If this node shared tween with the previous node,
            // just assign the updated shared tween and we’re done!
            // Otherwise, copy-on-write.

            if (tween !== tween0) {
              tween1 = (tween0 = tween).slice();

              for (var t = {
                name: name,
                value: value
              }, i = 0, n = tween1.length; i < n; ++i) {
                if (tween1[i].name === name) {
                  tween1[i] = t;
                  break;
                }
              }

              if (i === n) tween1.push(t);
            }

            schedule.tween = tween1;
          };
        }
        /* harmony default export */


        function tween(name, value) {
          var id = this._id;
          name += "";

          if (arguments.length < 2) {
            var tween = schedule_get(this.node(), id).tween;

            for (var i = 0, n = tween.length, t; i < n; ++i) {
              if ((t = tween[i]).name === name) {
                return t.value;
              }
            }

            return null;
          }

          return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
        }

        function tweenValue(transition, name, value) {
          var id = transition._id;
          transition.each(function () {
            var schedule = schedule_set(this, id);
            (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
          });
          return function (node) {
            return schedule_get(node, id).value[name];
          };
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/interpolate.js

        /* harmony default export */

        function interpolate(a, b) {
          var c;
          return (typeof b === "number" ? src_number : b instanceof color ? rgb : (c = color(b)) ? (b = c, rgb) : string)(a, b);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/attr.js

        function attr_attrRemove(name) {
          return function () {
            this.removeAttribute(name);
          };
        }

        function attr_attrRemoveNS(fullname) {
          return function () {
            this.removeAttributeNS(fullname.space, fullname.local);
          };
        }

        function attr_attrConstant(name, interpolate, value1) {
          var string00,
              string1 = value1 + "",
              interpolate0;
          return function () {
            var string0 = this.getAttribute(name);
            return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
          };
        }

        function attr_attrConstantNS(fullname, interpolate, value1) {
          var string00,
              string1 = value1 + "",
              interpolate0;
          return function () {
            var string0 = this.getAttributeNS(fullname.space, fullname.local);
            return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
          };
        }

        function attr_attrFunction(name, interpolate, value) {
          var string00, string10, interpolate0;
          return function () {
            var string0,
                value1 = value(this),
                string1;
            if (value1 == null) return void this.removeAttribute(name);
            string0 = this.getAttribute(name);
            string1 = value1 + "";
            return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
          };
        }

        function attr_attrFunctionNS(fullname, interpolate, value) {
          var string00, string10, interpolate0;
          return function () {
            var string0,
                value1 = value(this),
                string1;
            if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
            string0 = this.getAttributeNS(fullname.space, fullname.local);
            string1 = value1 + "";
            return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
          };
        }
        /* harmony default export */


        function transition_attr(name, value) {
          var fullname = namespace(name),
              i = fullname === "transform" ? interpolateTransformSvg : interpolate;
          return this.attrTween(name, typeof value === "function" ? (fullname.local ? attr_attrFunctionNS : attr_attrFunction)(fullname, i, tweenValue(this, "attr." + name, value)) : value == null ? (fullname.local ? attr_attrRemoveNS : attr_attrRemove)(fullname) : (fullname.local ? attr_attrConstantNS : attr_attrConstant)(fullname, i, value));
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/attrTween.js

        function attrInterpolate(name, i) {
          return function (t) {
            this.setAttribute(name, i.call(this, t));
          };
        }

        function attrInterpolateNS(fullname, i) {
          return function (t) {
            this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
          };
        }

        function attrTweenNS(fullname, value) {
          var t0, i0;

          function tween() {
            var i = value.apply(this, arguments);
            if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
            return t0;
          }

          tween._value = value;
          return tween;
        }

        function attrTween(name, value) {
          var t0, i0;

          function tween() {
            var i = value.apply(this, arguments);
            if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
            return t0;
          }

          tween._value = value;
          return tween;
        }
        /* harmony default export */


        function transition_attrTween(name, value) {
          var key = "attr." + name;
          if (arguments.length < 2) return (key = this.tween(key)) && key._value;
          if (value == null) return this.tween(key, null);
          if (typeof value !== "function") throw new Error();
          var fullname = namespace(name);
          return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/delay.js

        function delayFunction(id, value) {
          return function () {
            init(this, id).delay = +value.apply(this, arguments);
          };
        }

        function delayConstant(id, value) {
          return value = +value, function () {
            init(this, id).delay = value;
          };
        }
        /* harmony default export */


        function delay(value) {
          var id = this._id;
          return arguments.length ? this.each((typeof value === "function" ? delayFunction : delayConstant)(id, value)) : schedule_get(this.node(), id).delay;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/duration.js

        function durationFunction(id, value) {
          return function () {
            schedule_set(this, id).duration = +value.apply(this, arguments);
          };
        }

        function durationConstant(id, value) {
          return value = +value, function () {
            schedule_set(this, id).duration = value;
          };
        }
        /* harmony default export */


        function duration(value) {
          var id = this._id;
          return arguments.length ? this.each((typeof value === "function" ? durationFunction : durationConstant)(id, value)) : schedule_get(this.node(), id).duration;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/ease.js

        function easeConstant(id, value) {
          if (typeof value !== "function") throw new Error();
          return function () {
            schedule_set(this, id).ease = value;
          };
        }
        /* harmony default export */


        function ease(value) {
          var id = this._id;
          return arguments.length ? this.each(easeConstant(id, value)) : schedule_get(this.node(), id).ease;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/easeVarying.js

        function easeVarying(id, value) {
          return function () {
            var v = value.apply(this, arguments);
            if (typeof v !== "function") throw new Error();
            schedule_set(this, id).ease = v;
          };
        }
        /* harmony default export */


        function transition_easeVarying(value) {
          if (typeof value !== "function") throw new Error();
          return this.each(easeVarying(this._id, value));
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/filter.js

        /* harmony default export */

        function transition_filter(match) {
          if (typeof match !== "function") match = matcher(match);

          for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
            for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
              if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
                subgroup.push(node);
              }
            }
          }

          return new transition_Transition(subgroups, this._parents, this._name, this._id);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/merge.js

        /* harmony default export */

        function transition_merge(transition) {
          if (transition._id !== this._id) throw new Error();

          for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
            for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
              if (node = group0[i] || group1[i]) {
                merge[i] = node;
              }
            }
          }

          for (; j < m0; ++j) {
            merges[j] = groups0[j];
          }

          return new transition_Transition(merges, this._parents, this._name, this._id);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/on.js

        function start(name) {
          return (name + "").trim().split(/^|\s+/).every(function (t) {
            var i = t.indexOf(".");
            if (i >= 0) t = t.slice(0, i);
            return !t || t === "start";
          });
        }

        function onFunction(id, name, listener) {
          var on0,
              on1,
              sit = start(name) ? init : schedule_set;
          return function () {
            var schedule = sit(this, id),
                on = schedule.on; // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.

            if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
            schedule.on = on1;
          };
        }
        /* harmony default export */


        function transition_on(name, listener) {
          var id = this._id;
          return arguments.length < 2 ? schedule_get(this.node(), id).on.on(name) : this.each(onFunction(id, name, listener));
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/remove.js

        function removeFunction(id) {
          return function () {
            var parent = this.parentNode;

            for (var i in this.__transition) {
              if (+i !== id) return;
            }

            if (parent) parent.removeChild(this);
          };
        }
        /* harmony default export */


        function transition_remove() {
          return this.on("end.remove", removeFunction(this._id));
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/select.js

        /* harmony default export */

        function transition_select(select) {
          var name = this._name,
              id = this._id;
          if (typeof select !== "function") select = selector(select);

          for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
            for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
              if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
                schedule(subgroup[i], name, id, i, subgroup, schedule_get(node, id));
              }
            }
          }

          return new transition_Transition(subgroups, this._parents, name, id);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/selectAll.js

        /* harmony default export */

        function transition_selectAll(select) {
          var name = this._name,
              id = this._id;
          if (typeof select !== "function") select = selectorAll(select);

          for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
            for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
              if (node = group[i]) {
                for (var children = select.call(node, node.__data__, i, group), child, inherit = schedule_get(node, id), k = 0, l = children.length; k < l; ++k) {
                  if (child = children[k]) {
                    schedule(child, name, id, k, children, inherit);
                  }
                }

                subgroups.push(children);
                parents.push(node);
              }
            }
          }

          return new transition_Transition(subgroups, parents, name, id);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/selection.js

        var selection_Selection = src_selection.prototype.constructor;
        /* harmony default export */

        function transition_selection() {
          return new selection_Selection(this._groups, this._parents);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/style.js

        function styleNull(name, interpolate) {
          var string00, string10, interpolate0;
          return function () {
            var string0 = styleValue(this, name),
                string1 = (this.style.removeProperty(name), styleValue(this, name));
            return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
          };
        }

        function style_styleRemove(name) {
          return function () {
            this.style.removeProperty(name);
          };
        }

        function style_styleConstant(name, interpolate, value1) {
          var string00,
              string1 = value1 + "",
              interpolate0;
          return function () {
            var string0 = styleValue(this, name);
            return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
          };
        }

        function style_styleFunction(name, interpolate, value) {
          var string00, string10, interpolate0;
          return function () {
            var string0 = styleValue(this, name),
                value1 = value(this),
                string1 = value1 + "";
            if (value1 == null) string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
            return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
          };
        }

        function styleMaybeRemove(id, name) {
          var on0,
              on1,
              listener0,
              key = "style." + name,
              event = "end." + key,
              remove;
          return function () {
            var schedule = schedule_set(this, id),
                on = schedule.on,
                listener = schedule.value[key] == null ? remove || (remove = style_styleRemove(name)) : undefined; // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.

            if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
            schedule.on = on1;
          };
        }
        /* harmony default export */


        function transition_style(name, value, priority) {
          var i = (name += "") === "transform" ? interpolateTransformCss : interpolate;
          return value == null ? this.styleTween(name, styleNull(name, i)).on("end.style." + name, style_styleRemove(name)) : typeof value === "function" ? this.styleTween(name, style_styleFunction(name, i, tweenValue(this, "style." + name, value))).each(styleMaybeRemove(this._id, name)) : this.styleTween(name, style_styleConstant(name, i, value), priority).on("end.style." + name, null);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/styleTween.js

        function styleInterpolate(name, i, priority) {
          return function (t) {
            this.style.setProperty(name, i.call(this, t), priority);
          };
        }

        function styleTween(name, value, priority) {
          var t, i0;

          function tween() {
            var i = value.apply(this, arguments);
            if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
            return t;
          }

          tween._value = value;
          return tween;
        }
        /* harmony default export */


        function transition_styleTween(name, value, priority) {
          var key = "style." + (name += "");
          if (arguments.length < 2) return (key = this.tween(key)) && key._value;
          if (value == null) return this.tween(key, null);
          if (typeof value !== "function") throw new Error();
          return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/text.js

        function text_textConstant(value) {
          return function () {
            this.textContent = value;
          };
        }

        function text_textFunction(value) {
          return function () {
            var value1 = value(this);
            this.textContent = value1 == null ? "" : value1;
          };
        }
        /* harmony default export */


        function transition_text(value) {
          return this.tween("text", typeof value === "function" ? text_textFunction(tweenValue(this, "text", value)) : text_textConstant(value == null ? "" : value + ""));
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/textTween.js

        function textInterpolate(i) {
          return function (t) {
            this.textContent = i.call(this, t);
          };
        }

        function textTween(value) {
          var t0, i0;

          function tween() {
            var i = value.apply(this, arguments);
            if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
            return t0;
          }

          tween._value = value;
          return tween;
        }
        /* harmony default export */


        function transition_textTween(value) {
          var key = "text";
          if (arguments.length < 1) return (key = this.tween(key)) && key._value;
          if (value == null) return this.tween(key, null);
          if (typeof value !== "function") throw new Error();
          return this.tween(key, textTween(value));
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/transition.js

        /* harmony default export */

        function transition() {
          var name = this._name,
              id0 = this._id,
              id1 = newId();

          for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
            for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
              if (node = group[i]) {
                var inherit = schedule_get(node, id0);
                schedule(node, name, id1, i, group, {
                  time: inherit.time + inherit.delay + inherit.duration,
                  delay: 0,
                  duration: inherit.duration,
                  ease: inherit.ease
                });
              }
            }
          }

          return new transition_Transition(groups, this._parents, name, id1);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/end.js

        /* harmony default export */

        function end() {
          var on0,
              on1,
              that = this,
              id = that._id,
              size = that.size();
          return new Promise(function (resolve, reject) {
            var cancel = {
              value: reject
            },
                end = {
              value: function value() {
                if (--size === 0) resolve();
              }
            };
            that.each(function () {
              var schedule = schedule_set(this, id),
                  on = schedule.on; // If this node shared a dispatch with the previous node,
              // just assign the updated shared dispatch and we’re done!
              // Otherwise, copy-on-write.

              if (on !== on0) {
                on1 = (on0 = on).copy();

                on1._.cancel.push(cancel);

                on1._.interrupt.push(cancel);

                on1._.end.push(end);
              }

              schedule.on = on1;
            }); // The selection was empty, resolve end immediately

            if (size === 0) resolve();
          });
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/index.js

        var id = 0;

        function transition_Transition(groups, parents, name, id) {
          this._groups = groups;
          this._parents = parents;
          this._name = name;
          this._id = id;
        }

        function transition_transition(name) {
          return src_selection().transition(name);
        }

        function newId() {
          return ++id;
        }

        var selection_prototype = src_selection.prototype;
        transition_Transition.prototype = transition_transition.prototype = _defineProperty2({
          constructor: transition_Transition,
          select: transition_select,
          selectAll: transition_selectAll,
          filter: transition_filter,
          merge: transition_merge,
          selection: transition_selection,
          transition: transition,
          call: selection_prototype.call,
          nodes: selection_prototype.nodes,
          node: selection_prototype.node,
          size: selection_prototype.size,
          empty: selection_prototype.empty,
          each: selection_prototype.each,
          on: transition_on,
          attr: transition_attr,
          attrTween: transition_attrTween,
          style: transition_style,
          styleTween: transition_styleTween,
          text: transition_text,
          textTween: transition_textTween,
          remove: transition_remove,
          tween: tween,
          delay: delay,
          duration: duration,
          ease: ease,
          easeVarying: transition_easeVarying,
          end: end
        }, Symbol.iterator, selection_prototype[Symbol.iterator]);
        ; // CONCATENATED MODULE: ./node_modules/d3-ease/src/cubic.js

        function cubicIn(t) {
          return t * t * t;
        }

        function cubicOut(t) {
          return --t * t * t + 1;
        }

        function cubicInOut(t) {
          return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/selection/transition.js

        var defaultTiming = {
          time: null,
          // Set on use.
          delay: 0,
          duration: 250,
          ease: cubicInOut
        };

        function inherit(node, id) {
          var timing;

          while (!(timing = node.__transition) || !(timing = timing[id])) {
            if (!(node = node.parentNode)) {
              throw new Error("transition ".concat(id, " not found"));
            }
          }

          return timing;
        }
        /* harmony default export */


        function selection_transition(name) {
          var id, timing;

          if (name instanceof transition_Transition) {
            id = name._id, name = name._name;
          } else {
            id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
          }

          for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
            for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
              if (node = group[i]) {
                schedule(node, name, id, i, group, timing || inherit(node, id));
              }
            }
          }

          return new transition_Transition(groups, this._parents, name, id);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/selection/index.js

        src_selection.prototype.interrupt = selection_interrupt;
        src_selection.prototype.transition = selection_transition;
        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/active.js

        var active_root =
        /* unused pure expression or super */
        null && [null];
        /* harmony default export */

        function active(node, name) {
          var schedules = node.__transition,
              schedule,
              i;

          if (schedules) {
            name = name == null ? null : name + "";

            for (i in schedules) {
              if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) {
                return new Transition([[node]], active_root, name, +i);
              }
            }
          }

          return null;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-transition/src/index.js

        ; // CONCATENATED MODULE: ./node_modules/d3-brush/src/constant.js

        /* harmony default export */

        var d3_brush_src_constant = function d3_brush_src_constant(x) {
          return function () {
            return x;
          };
        };

        ; // CONCATENATED MODULE: ./node_modules/d3-brush/src/event.js

        function BrushEvent(type, _ref10) {
          var sourceEvent = _ref10.sourceEvent,
              target = _ref10.target,
              selection = _ref10.selection,
              mode = _ref10.mode,
              dispatch = _ref10.dispatch;
          Object.defineProperties(this, {
            type: {
              value: type,
              enumerable: true,
              configurable: true
            },
            sourceEvent: {
              value: sourceEvent,
              enumerable: true,
              configurable: true
            },
            target: {
              value: target,
              enumerable: true,
              configurable: true
            },
            selection: {
              value: selection,
              enumerable: true,
              configurable: true
            },
            mode: {
              value: mode,
              enumerable: true,
              configurable: true
            },
            _: {
              value: dispatch
            }
          });
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-brush/src/noevent.js

        function src_noevent_nopropagation(event) {
          event.stopImmediatePropagation();
        }
        /* harmony default export */


        function d3_brush_src_noevent(event) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-brush/src/brush.js

        var MODE_DRAG = {
          name: "drag"
        },
            MODE_SPACE = {
          name: "space"
        },
            MODE_HANDLE = {
          name: "handle"
        },
            MODE_CENTER = {
          name: "center"
        };
        var abs = Math.abs,
            max = Math.max,
            min = Math.min;

        function number1(e) {
          return [+e[0], +e[1]];
        }

        function number2(e) {
          return [number1(e[0]), number1(e[1])];
        }

        var X = {
          name: "x",
          handles: ["w", "e"].map(type),
          input: function input(x, e) {
            return x == null ? null : [[+x[0], e[0][1]], [+x[1], e[1][1]]];
          },
          output: function output(xy) {
            return xy && [xy[0][0], xy[1][0]];
          }
        };
        var Y = {
          name: "y",
          handles: ["n", "s"].map(type),
          input: function input(y, e) {
            return y == null ? null : [[e[0][0], +y[0]], [e[1][0], +y[1]]];
          },
          output: function output(xy) {
            return xy && [xy[0][1], xy[1][1]];
          }
        };
        var XY = {
          name: "xy",
          handles: ["n", "w", "e", "s", "nw", "ne", "sw", "se"].map(type),
          input: function input(xy) {
            return xy == null ? null : number2(xy);
          },
          output: function output(xy) {
            return xy;
          }
        };
        var cursors = {
          overlay: "crosshair",
          selection: "move",
          n: "ns-resize",
          e: "ew-resize",
          s: "ns-resize",
          w: "ew-resize",
          nw: "nwse-resize",
          ne: "nesw-resize",
          se: "nwse-resize",
          sw: "nesw-resize"
        };
        var flipX = {
          e: "w",
          w: "e",
          nw: "ne",
          ne: "nw",
          se: "sw",
          sw: "se"
        };
        var flipY = {
          n: "s",
          s: "n",
          nw: "sw",
          ne: "se",
          se: "ne",
          sw: "nw"
        };
        var signsX = {
          overlay: +1,
          selection: +1,
          n: null,
          e: +1,
          s: null,
          w: -1,
          nw: -1,
          ne: +1,
          se: +1,
          sw: -1
        };
        var signsY = {
          overlay: +1,
          selection: +1,
          n: -1,
          e: null,
          s: +1,
          w: null,
          nw: -1,
          ne: -1,
          se: +1,
          sw: +1
        };

        function type(t) {
          return {
            type: t
          };
        } // Ignore right-click, since that should open the context menu.


        function defaultFilter(event) {
          return !event.ctrlKey && !event.button;
        }

        function defaultExtent() {
          var svg = this.ownerSVGElement || this;

          if (svg.hasAttribute("viewBox")) {
            svg = svg.viewBox.baseVal;
            return [[svg.x, svg.y], [svg.x + svg.width, svg.y + svg.height]];
          }

          return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
        }

        function defaultTouchable() {
          return navigator.maxTouchPoints || "ontouchstart" in this;
        } // Like d3.local, but with the name “__brush” rather than auto-generated.


        function local(node) {
          while (!node.__brush) {
            if (!(node = node.parentNode)) return;
          }

          return node.__brush;
        }

        function brush_empty(extent) {
          return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
        }

        function brushSelection(node) {
          var state = node.__brush;
          return state ? state.dim.output(state.selection) : null;
        }

        function brushX() {
          return brush_brush(X);
        }

        function brushY() {
          return brush_brush(Y);
        }
        /* harmony default export */


        function brush() {
          return brush_brush(XY);
        }

        function brush_brush(dim) {
          var extent = defaultExtent,
              filter = defaultFilter,
              touchable = defaultTouchable,
              keys = true,
              listeners = src_dispatch("start", "brush", "end"),
              handleSize = 6,
              touchending;

          function brush(group) {
            var overlay = group.property("__brush", initialize).selectAll(".overlay").data([type("overlay")]);
            overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", cursors.overlay).merge(overlay).each(function () {
              var extent = local(this).extent;
              src_select(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
            });
            group.selectAll(".selection").data([type("selection")]).enter().append("rect").attr("class", "selection").attr("cursor", cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
            var handle = group.selectAll(".handle").data(dim.handles, function (d) {
              return d.type;
            });
            handle.exit().remove();
            handle.enter().append("rect").attr("class", function (d) {
              return "handle handle--" + d.type;
            }).attr("cursor", function (d) {
              return cursors[d.type];
            });
            group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
          }

          brush.move = function (group, selection) {
            if (group.tween) {
              group.on("start.brush", function (event) {
                emitter(this, arguments).beforestart().start(event);
              }).on("interrupt.brush end.brush", function (event) {
                emitter(this, arguments).end(event);
              }).tween("brush", function () {
                var that = this,
                    state = that.__brush,
                    emit = emitter(that, arguments),
                    selection0 = state.selection,
                    selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent),
                    i = value(selection0, selection1);

                function tween(t) {
                  state.selection = t === 1 && selection1 === null ? null : i(t);
                  redraw.call(that);
                  emit.brush();
                }

                return selection0 !== null && selection1 !== null ? tween : tween(1);
              });
            } else {
              group.each(function () {
                var that = this,
                    args = arguments,
                    state = that.__brush,
                    selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent),
                    emit = emitter(that, args).beforestart();
                src_interrupt(that);
                state.selection = selection1 === null ? null : selection1;
                redraw.call(that);
                emit.start().brush().end();
              });
            }
          };

          brush.clear = function (group) {
            brush.move(group, null);
          };

          function redraw() {
            var group = src_select(this),
                selection = local(this).selection;

            if (selection) {
              group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
              group.selectAll(".handle").style("display", null).attr("x", function (d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
              }).attr("y", function (d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
              }).attr("width", function (d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
              }).attr("height", function (d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
              });
            } else {
              group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
            }
          }

          function emitter(that, args, clean) {
            var emit = that.__brush.emitter;
            return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
          }

          function Emitter(that, args, clean) {
            this.that = that;
            this.args = args;
            this.state = that.__brush;
            this.active = 0;
            this.clean = clean;
          }

          Emitter.prototype = {
            beforestart: function beforestart() {
              if (++this.active === 1) this.state.emitter = this, this.starting = true;
              return this;
            },
            start: function start(event, mode) {
              if (this.starting) this.starting = false, this.emit("start", event, mode);else this.emit("brush", event);
              return this;
            },
            brush: function brush(event, mode) {
              this.emit("brush", event, mode);
              return this;
            },
            end: function end(event, mode) {
              if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
              return this;
            },
            emit: function emit(type, event, mode) {
              var d = src_select(this.that).datum();
              listeners.call(type, this.that, new BrushEvent(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
              }), d);
            }
          };

          function started(event) {
            if (touchending && !event.touches) return;
            if (!filter.apply(this, arguments)) return;
            var that = this,
                type = event.target.__data__.type,
                mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : keys && event.altKey ? MODE_CENTER : MODE_HANDLE,
                signX = dim === Y ? null : signsX[type],
                signY = dim === X ? null : signsY[type],
                state = local(that),
                extent = state.extent,
                selection = state.selection,
                W = extent[0][0],
                w0,
                w1,
                N = extent[0][1],
                n0,
                n1,
                E = extent[1][0],
                e0,
                e1,
                S = extent[1][1],
                s0,
                s1,
                dx = 0,
                dy = 0,
                moving,
                shifting = signX && signY && keys && event.shiftKey,
                lockX,
                lockY,
                points = Array.from(event.touches || [event], function (t) {
              var i = t.identifier;
              t = src_pointer(t, that);
              t.point0 = t.slice();
              t.identifier = i;
              return t;
            });

            if (type === "overlay") {
              if (selection) moving = true;
              var pts = [points[0], points[1] || points[0]];
              state.selection = selection = [[w0 = dim === Y ? W : min(pts[0][0], pts[1][0]), n0 = dim === X ? N : min(pts[0][1], pts[1][1])], [e0 = dim === Y ? E : max(pts[0][0], pts[1][0]), s0 = dim === X ? S : max(pts[0][1], pts[1][1])]];
              if (points.length > 1) move();
            } else {
              w0 = selection[0][0];
              n0 = selection[0][1];
              e0 = selection[1][0];
              s0 = selection[1][1];
            }

            w1 = w0;
            n1 = n0;
            e1 = e0;
            s1 = s0;
            var group = src_select(that).attr("pointer-events", "none");
            var overlay = group.selectAll(".overlay").attr("cursor", cursors[type]);
            src_interrupt(that);
            var emit = emitter(that, arguments, true).beforestart();

            if (event.touches) {
              emit.moved = moved;
              emit.ended = ended;
            } else {
              var view = src_select(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
              if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
              nodrag(event.view);
            }

            redraw.call(that);
            emit.start(event, mode.name);

            function moved(event) {
              var _iterator12 = _createForOfIteratorHelper(event.changedTouches || [event]),
                  _step12;

              try {
                for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                  var p = _step12.value;

                  var _iterator14 = _createForOfIteratorHelper(points),
                      _step14;

                  try {
                    for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                      var d = _step14.value;
                      if (d.identifier === p.identifier) d.cur = src_pointer(p, that);
                    }
                  } catch (err) {
                    _iterator14.e(err);
                  } finally {
                    _iterator14.f();
                  }
                }
              } catch (err) {
                _iterator12.e(err);
              } finally {
                _iterator12.f();
              }

              if (shifting && !lockX && !lockY && points.length === 1) {
                var _point = points[0];
                if (abs(_point.cur[0] - _point[0]) > abs(_point.cur[1] - _point[1])) lockY = true;else lockX = true;
              }

              var _iterator13 = _createForOfIteratorHelper(points),
                  _step13;

              try {
                for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                  var _point2 = _step13.value;
                  if (_point2.cur) _point2[0] = _point2.cur[0], _point2[1] = _point2.cur[1];
                }
              } catch (err) {
                _iterator13.e(err);
              } finally {
                _iterator13.f();
              }

              moving = true;
              d3_brush_src_noevent(event);
              move(event);
            }

            function move(event) {
              var point = points[0],
                  point0 = point.point0;
              var t;
              dx = point[0] - point0[0];
              dy = point[1] - point0[1];

              switch (mode) {
                case MODE_SPACE:
                case MODE_DRAG:
                  {
                    if (signX) dx = max(W - w0, min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = max(N - n0, min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                  }

                case MODE_HANDLE:
                  {
                    if (points[1]) {
                      if (signX) w1 = max(W, min(E, points[0][0])), e1 = max(W, min(E, points[1][0])), signX = 1;
                      if (signY) n1 = max(N, min(S, points[0][1])), s1 = max(N, min(S, points[1][1])), signY = 1;
                    } else {
                      if (signX < 0) dx = max(W - w0, min(E - w0, dx)), w1 = w0 + dx, e1 = e0;else if (signX > 0) dx = max(W - e0, min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                      if (signY < 0) dy = max(N - n0, min(S - n0, dy)), n1 = n0 + dy, s1 = s0;else if (signY > 0) dy = max(N - s0, min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }

                    break;
                  }

                case MODE_CENTER:
                  {
                    if (signX) w1 = max(W, min(E, w0 - dx * signX)), e1 = max(W, min(E, e0 + dx * signX));
                    if (signY) n1 = max(N, min(S, n0 - dy * signY)), s1 = max(N, min(S, s0 + dy * signY));
                    break;
                  }
              }

              if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
              }

              if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
              }

              if (state.selection) selection = state.selection; // May be set by brush.move!

              if (lockX) w1 = selection[0][0], e1 = selection[1][0];
              if (lockY) n1 = selection[0][1], s1 = selection[1][1];

              if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [[w1, n1], [e1, s1]];
                redraw.call(that);
                emit.brush(event, mode.name);
              }
            }

            function ended(event) {
              src_noevent_nopropagation(event);

              if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function () {
                  touchending = null;
                }, 500); // Ghost clicks are delayed!
              } else {
                yesdrag(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
              }

              group.attr("pointer-events", "all");
              overlay.attr("cursor", cursors.overlay);
              if (state.selection) selection = state.selection; // May be set by brush.move (on start)!

              if (brush_empty(selection)) state.selection = null, redraw.call(that);
              emit.end(event, mode.name);
            }

            function keydowned(event) {
              switch (event.keyCode) {
                case 16:
                  {
                    // SHIFT
                    shifting = signX && signY;
                    break;
                  }

                case 18:
                  {
                    // ALT
                    if (mode === MODE_HANDLE) {
                      if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                      if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                      mode = MODE_CENTER;
                      move();
                    }

                    break;
                  }

                case 32:
                  {
                    // SPACE; takes priority over ALT
                    if (mode === MODE_HANDLE || mode === MODE_CENTER) {
                      if (signX < 0) e0 = e1 - dx;else if (signX > 0) w0 = w1 - dx;
                      if (signY < 0) s0 = s1 - dy;else if (signY > 0) n0 = n1 - dy;
                      mode = MODE_SPACE;
                      overlay.attr("cursor", cursors.selection);
                      move();
                    }

                    break;
                  }

                default:
                  return;
              }

              d3_brush_src_noevent(event);
            }

            function keyupped(event) {
              switch (event.keyCode) {
                case 16:
                  {
                    // SHIFT
                    if (shifting) {
                      lockX = lockY = shifting = false;
                      move();
                    }

                    break;
                  }

                case 18:
                  {
                    // ALT
                    if (mode === MODE_CENTER) {
                      if (signX < 0) e0 = e1;else if (signX > 0) w0 = w1;
                      if (signY < 0) s0 = s1;else if (signY > 0) n0 = n1;
                      mode = MODE_HANDLE;
                      move();
                    }

                    break;
                  }

                case 32:
                  {
                    // SPACE
                    if (mode === MODE_SPACE) {
                      if (event.altKey) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = MODE_CENTER;
                      } else {
                        if (signX < 0) e0 = e1;else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;else if (signY > 0) n0 = n1;
                        mode = MODE_HANDLE;
                      }

                      overlay.attr("cursor", cursors[type]);
                      move();
                    }

                    break;
                  }

                default:
                  return;
              }

              d3_brush_src_noevent(event);
            }
          }

          function touchmoved(event) {
            emitter(this, arguments).moved(event);
          }

          function touchended(event) {
            emitter(this, arguments).ended(event);
          }

          function initialize() {
            var state = this.__brush || {
              selection: null
            };
            state.extent = number2(extent.apply(this, arguments));
            state.dim = dim;
            return state;
          }

          brush.extent = function (_) {
            return arguments.length ? (extent = typeof _ === "function" ? _ : d3_brush_src_constant(number2(_)), brush) : extent;
          };

          brush.filter = function (_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : d3_brush_src_constant(!!_), brush) : filter;
          };

          brush.touchable = function (_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : d3_brush_src_constant(!!_), brush) : touchable;
          };

          brush.handleSize = function (_) {
            return arguments.length ? (handleSize = +_, brush) : handleSize;
          };

          brush.keyModifiers = function (_) {
            return arguments.length ? (keys = !!_, brush) : keys;
          };

          brush.on = function () {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? brush : value;
          };

          return brush;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-brush/src/index.js

        ; // CONCATENATED MODULE: ./node_modules/d3-array/src/range.js

        /* harmony default export */

        function range(start, stop, step) {
          start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
          var i = -1,
              n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
              range = new Array(n);

          while (++i < n) {
            range[i] = start + i * step;
          }

          return range;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-scale/src/init.js

        function initRange(domain, range) {
          switch (arguments.length) {
            case 0:
              break;

            case 1:
              this.range(domain);
              break;

            default:
              this.range(range).domain(domain);
              break;
          }

          return this;
        }

        function initInterpolator(domain, interpolator) {
          switch (arguments.length) {
            case 0:
              break;

            case 1:
              {
                if (typeof domain === "function") this.interpolator(domain);else this.range(domain);
                break;
              }

            default:
              {
                this.domain(domain);
                if (typeof interpolator === "function") this.interpolator(interpolator);else this.range(interpolator);
                break;
              }
          }

          return this;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-scale/src/ordinal.js

        var implicit = Symbol("implicit");

        function ordinal() {
          var index = new Map(),
              domain = [],
              range = [],
              unknown = implicit;

          function scale(d) {
            var key = d + "",
                i = index.get(key);

            if (!i) {
              if (unknown !== implicit) return unknown;
              index.set(key, i = domain.push(d));
            }

            return range[(i - 1) % range.length];
          }

          scale.domain = function (_) {
            if (!arguments.length) return domain.slice();
            domain = [], index = new Map();

            var _iterator15 = _createForOfIteratorHelper(_),
                _step15;

            try {
              for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                var _value10 = _step15.value;
                var key = _value10 + "";
                if (index.has(key)) continue;
                index.set(key, domain.push(_value10));
              }
            } catch (err) {
              _iterator15.e(err);
            } finally {
              _iterator15.f();
            }

            return scale;
          };

          scale.range = function (_) {
            return arguments.length ? (range = Array.from(_), scale) : range.slice();
          };

          scale.unknown = function (_) {
            return arguments.length ? (unknown = _, scale) : unknown;
          };

          scale.copy = function () {
            return ordinal(domain, range).unknown(unknown);
          };

          initRange.apply(scale, arguments);
          return scale;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-scale/src/band.js

        function band() {
          var scale = ordinal().unknown(undefined),
              domain = scale.domain,
              ordinalRange = scale.range,
              r0 = 0,
              r1 = 1,
              step,
              bandwidth,
              round = false,
              paddingInner = 0,
              paddingOuter = 0,
              align = 0.5;
          delete scale.unknown;

          function rescale() {
            var n = domain().length,
                reverse = r1 < r0,
                start = reverse ? r1 : r0,
                stop = reverse ? r0 : r1;
            step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
            if (round) step = Math.floor(step);
            start += (stop - start - step * (n - paddingInner)) * align;
            bandwidth = step * (1 - paddingInner);
            if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
            var values = range(n).map(function (i) {
              return start + step * i;
            });
            return ordinalRange(reverse ? values.reverse() : values);
          }

          scale.domain = function (_) {
            return arguments.length ? (domain(_), rescale()) : domain();
          };

          scale.range = function (_) {
            var _ref11, _ref12;

            return arguments.length ? ((_ref11 = _, _ref12 = _slicedToArray2(_ref11, 2), r0 = _ref12[0], r1 = _ref12[1], _ref11), r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
          };

          scale.rangeRound = function (_) {
            var _ref13, _ref14;

            return (_ref13 = _, _ref14 = _slicedToArray2(_ref13, 2), r0 = _ref14[0], r1 = _ref14[1], _ref13), r0 = +r0, r1 = +r1, round = true, rescale();
          };

          scale.bandwidth = function () {
            return bandwidth;
          };

          scale.step = function () {
            return step;
          };

          scale.round = function (_) {
            return arguments.length ? (round = !!_, rescale()) : round;
          };

          scale.padding = function (_) {
            return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
          };

          scale.paddingInner = function (_) {
            return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
          };

          scale.paddingOuter = function (_) {
            return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
          };

          scale.align = function (_) {
            return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
          };

          scale.copy = function () {
            return band(domain(), [r0, r1]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
          };

          return initRange.apply(rescale(), arguments);
        }

        function pointish(scale) {
          var copy = scale.copy;
          scale.padding = scale.paddingOuter;
          delete scale.paddingInner;
          delete scale.paddingOuter;

          scale.copy = function () {
            return pointish(copy());
          };

          return scale;
        }

        function point() {
          return pointish(band.apply(null, arguments).paddingInner(1));
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-array/src/ticks.js

        var e10 = Math.sqrt(50),
            e5 = Math.sqrt(10),
            e2 = Math.sqrt(2);
        /* harmony default export */

        function ticks(start, stop, count) {
          var reverse,
              i = -1,
              n,
              ticks,
              step;
          stop = +stop, start = +start, count = +count;
          if (start === stop && count > 0) return [start];
          if (reverse = stop < start) n = start, start = stop, stop = n;
          if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

          if (step > 0) {
            var r0 = Math.round(start / step),
                r1 = Math.round(stop / step);
            if (r0 * step < start) ++r0;
            if (r1 * step > stop) --r1;
            ticks = new Array(n = r1 - r0 + 1);

            while (++i < n) {
              ticks[i] = (r0 + i) * step;
            }
          } else {
            step = -step;

            var _r = Math.round(start * step),
                _r2 = Math.round(stop * step);

            if (_r / step < start) ++_r;
            if (_r2 / step > stop) --_r2;
            ticks = new Array(n = _r2 - _r + 1);

            while (++i < n) {
              ticks[i] = (_r + i) / step;
            }
          }

          if (reverse) ticks.reverse();
          return ticks;
        }

        function tickIncrement(start, stop, count) {
          var step = (stop - start) / Math.max(0, count),
              power = Math.floor(Math.log(step) / Math.LN10),
              error = step / Math.pow(10, power);
          return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
        }

        function tickStep(start, stop, count) {
          var step0 = Math.abs(stop - start) / Math.max(0, count),
              step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
              error = step0 / step1;
          if (error >= e10) step1 *= 10;else if (error >= e5) step1 *= 5;else if (error >= e2) step1 *= 2;
          return stop < start ? -step1 : step1;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-array/src/number.js

        /* harmony default export */

        function d3_array_src_number(x) {
          return x === null ? NaN : +x;
        }

        function numbers(values, valueof) {
          var _iterator16, _step16, _value11, _index5, _iterator17, _step17, _value12;

          return _regeneratorRuntime.wrap(function numbers$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(valueof === undefined)) {
                    _context2.next = 21;
                    break;
                  }

                  _iterator16 = _createForOfIteratorHelper(values);
                  _context2.prev = 2;

                  _iterator16.s();

                case 4:
                  if ((_step16 = _iterator16.n()).done) {
                    _context2.next = 11;
                    break;
                  }

                  _value11 = _step16.value;

                  if (!(_value11 != null && (_value11 = +_value11) >= _value11)) {
                    _context2.next = 9;
                    break;
                  }

                  _context2.next = 9;
                  return _value11;

                case 9:
                  _context2.next = 4;
                  break;

                case 11:
                  _context2.next = 16;
                  break;

                case 13:
                  _context2.prev = 13;
                  _context2.t0 = _context2["catch"](2);

                  _iterator16.e(_context2.t0);

                case 16:
                  _context2.prev = 16;

                  _iterator16.f();

                  return _context2.finish(16);

                case 19:
                  _context2.next = 40;
                  break;

                case 21:
                  _index5 = -1;
                  _iterator17 = _createForOfIteratorHelper(values);
                  _context2.prev = 23;

                  _iterator17.s();

                case 25:
                  if ((_step17 = _iterator17.n()).done) {
                    _context2.next = 32;
                    break;
                  }

                  _value12 = _step17.value;

                  if (!((_value12 = valueof(_value12, ++_index5, values)) != null && (_value12 = +_value12) >= _value12)) {
                    _context2.next = 30;
                    break;
                  }

                  _context2.next = 30;
                  return _value12;

                case 30:
                  _context2.next = 25;
                  break;

                case 32:
                  _context2.next = 37;
                  break;

                case 34:
                  _context2.prev = 34;
                  _context2.t1 = _context2["catch"](23);

                  _iterator17.e(_context2.t1);

                case 37:
                  _context2.prev = 37;

                  _iterator17.f();

                  return _context2.finish(37);

                case 40:
                case "end":
                  return _context2.stop();
              }
            }
          }, _marked2, null, [[2, 13, 16, 19], [23, 34, 37, 40]]);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-array/src/bisect.js

        var ascendingBisect = bisector(ascending);
        var bisectRight = ascendingBisect.right;
        var bisectLeft = ascendingBisect.left;
        var bisectCenter = bisector(d3_array_src_number).center;
        /* harmony default export */

        var bisect = bisectRight;
        ; // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/round.js

        /* harmony default export */

        function round(a, b) {
          return a = +a, b = +b, function (t) {
            return Math.round(a * (1 - t) + b * t);
          };
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-scale/src/constant.js

        function constants(x) {
          return function () {
            return x;
          };
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-scale/src/number.js

        function number_number(x) {
          return +x;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-scale/src/continuous.js

        var unit = [0, 1];

        function continuous_identity(x) {
          return x;
        }

        function normalize(a, b) {
          return (b -= a = +a) ? function (x) {
            return (x - a) / b;
          } : constants(isNaN(b) ? NaN : 0.5);
        }

        function clamper(a, b) {
          var t;
          if (a > b) t = a, a = b, b = t;
          return function (x) {
            return Math.max(a, Math.min(b, x));
          };
        } // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
        // interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].


        function bimap(domain, range, interpolate) {
          var d0 = domain[0],
              d1 = domain[1],
              r0 = range[0],
              r1 = range[1];
          if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
          return function (x) {
            return r0(d0(x));
          };
        }

        function polymap(domain, range, interpolate) {
          var j = Math.min(domain.length, range.length) - 1,
              d = new Array(j),
              r = new Array(j),
              i = -1; // Reverse descending domains.

          if (domain[j] < domain[0]) {
            domain = domain.slice().reverse();
            range = range.slice().reverse();
          }

          while (++i < j) {
            d[i] = normalize(domain[i], domain[i + 1]);
            r[i] = interpolate(range[i], range[i + 1]);
          }

          return function (x) {
            var i = bisect(domain, x, 1, j) - 1;
            return r[i](d[i](x));
          };
        }

        function copy(source, target) {
          return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
        }

        function transformer() {
          var domain = unit,
              range = unit,
              interpolate = value,
              transform,
              untransform,
              unknown,
              clamp = continuous_identity,
              piecewise,
              output,
              input;

          function rescale() {
            var n = Math.min(domain.length, range.length);
            if (clamp !== continuous_identity) clamp = clamper(domain[0], domain[n - 1]);
            piecewise = n > 2 ? polymap : bimap;
            output = input = null;
            return scale;
          }

          function scale(x) {
            return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
          }

          scale.invert = function (y) {
            return clamp(untransform((input || (input = piecewise(range, domain.map(transform), src_number)))(y)));
          };

          scale.domain = function (_) {
            return arguments.length ? (domain = Array.from(_, number_number), rescale()) : domain.slice();
          };

          scale.range = function (_) {
            return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
          };

          scale.rangeRound = function (_) {
            return range = Array.from(_), interpolate = round, rescale();
          };

          scale.clamp = function (_) {
            return arguments.length ? (clamp = _ ? true : continuous_identity, rescale()) : clamp !== continuous_identity;
          };

          scale.interpolate = function (_) {
            return arguments.length ? (interpolate = _, rescale()) : interpolate;
          };

          scale.unknown = function (_) {
            return arguments.length ? (unknown = _, scale) : unknown;
          };

          return function (t, u) {
            transform = t, untransform = u;
            return rescale();
          };
        }

        function continuous() {
          return transformer()(continuous_identity, continuous_identity);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-format/src/formatSpecifier.js
        // [[fill]align][sign][symbol][0][width][,][.precision][~][type]

        var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

        function formatSpecifier(specifier) {
          if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
          var match;
          return new FormatSpecifier({
            fill: match[1],
            align: match[2],
            sign: match[3],
            symbol: match[4],
            zero: match[5],
            width: match[6],
            comma: match[7],
            precision: match[8] && match[8].slice(1),
            trim: match[9],
            type: match[10]
          });
        }

        formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

        function FormatSpecifier(specifier) {
          this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
          this.align = specifier.align === undefined ? ">" : specifier.align + "";
          this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
          this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
          this.zero = !!specifier.zero;
          this.width = specifier.width === undefined ? undefined : +specifier.width;
          this.comma = !!specifier.comma;
          this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
          this.trim = !!specifier.trim;
          this.type = specifier.type === undefined ? "" : specifier.type + "";
        }

        FormatSpecifier.prototype.toString = function () {
          return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
        };

        ; // CONCATENATED MODULE: ./node_modules/d3-format/src/formatDecimal.js

        /* harmony default export */

        function formatDecimal(x) {
          return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
        } // Computes the decimal coefficient and exponent of the specified number x with
        // significant digits p, where x is positive and p is in [1, 21] or undefined.
        // For example, formatDecimalParts(1.23) returns ["123", 0].


        function formatDecimalParts(x, p) {
          if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity

          var i,
              coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
          // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).

          return [coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient, +x.slice(i + 1)];
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-format/src/exponent.js

        /* harmony default export */

        function exponent(x) {
          return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-format/src/precisionPrefix.js

        /* harmony default export */

        function precisionPrefix(step, value) {
          return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-format/src/formatGroup.js

        /* harmony default export */

        function formatGroup(grouping, thousands) {
          return function (value, width) {
            var i = value.length,
                t = [],
                j = 0,
                g = grouping[0],
                length = 0;

            while (i > 0 && g > 0) {
              if (length + g + 1 > width) g = Math.max(1, width - length);
              t.push(value.substring(i -= g, i + g));
              if ((length += g + 1) > width) break;
              g = grouping[j = (j + 1) % grouping.length];
            }

            return t.reverse().join(thousands);
          };
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-format/src/formatNumerals.js

        /* harmony default export */

        function formatNumerals(numerals) {
          return function (value) {
            return value.replace(/[0-9]/g, function (i) {
              return numerals[+i];
            });
          };
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-format/src/formatTrim.js
        // Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.

        /* harmony default export */

        function formatTrim(s) {
          out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
            switch (s[i]) {
              case ".":
                i0 = i1 = i;
                break;

              case "0":
                if (i0 === 0) i0 = i;
                i1 = i;
                break;

              default:
                if (!+s[i]) break out;
                if (i0 > 0) i0 = 0;
                break;
            }
          }

          return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-format/src/formatPrefixAuto.js

        var prefixExponent;
        /* harmony default export */

        function formatPrefixAuto(x, p) {
          var d = formatDecimalParts(x, p);
          if (!d) return x + "";
          var coefficient = d[0],
              exponent = d[1],
              i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
              n = coefficient.length;
          return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-format/src/formatRounded.js

        /* harmony default export */

        function formatRounded(x, p) {
          var d = formatDecimalParts(x, p);
          if (!d) return x + "";
          var coefficient = d[0],
              exponent = d[1];
          return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-format/src/formatTypes.js

        /* harmony default export */

        var formatTypes = {
          "%": function _(x, p) {
            return (x * 100).toFixed(p);
          },
          "b": function b(x) {
            return Math.round(x).toString(2);
          },
          "c": function c(x) {
            return x + "";
          },
          "d": formatDecimal,
          "e": function e(x, p) {
            return x.toExponential(p);
          },
          "f": function f(x, p) {
            return x.toFixed(p);
          },
          "g": function g(x, p) {
            return x.toPrecision(p);
          },
          "o": function o(x) {
            return Math.round(x).toString(8);
          },
          "p": function p(x, _p) {
            return formatRounded(x * 100, _p);
          },
          "r": formatRounded,
          "s": formatPrefixAuto,
          "X": function X(x) {
            return Math.round(x).toString(16).toUpperCase();
          },
          "x": function x(_x) {
            return Math.round(_x).toString(16);
          }
        };
        ; // CONCATENATED MODULE: ./node_modules/d3-format/src/identity.js

        /* harmony default export */

        function d3_format_src_identity(x) {
          return x;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-format/src/locale.js

        var map = Array.prototype.map,
            prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
        /* harmony default export */

        function locale(locale) {
          var group = locale.grouping === undefined || locale.thousands === undefined ? d3_format_src_identity : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
              currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
              currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
              decimal = locale.decimal === undefined ? "." : locale.decimal + "",
              numerals = locale.numerals === undefined ? d3_format_src_identity : formatNumerals(map.call(locale.numerals, String)),
              percent = locale.percent === undefined ? "%" : locale.percent + "",
              minus = locale.minus === undefined ? "−" : locale.minus + "",
              nan = locale.nan === undefined ? "NaN" : locale.nan + "";

          function newFormat(specifier) {
            specifier = formatSpecifier(specifier);
            var fill = specifier.fill,
                align = specifier.align,
                sign = specifier.sign,
                symbol = specifier.symbol,
                zero = specifier.zero,
                width = specifier.width,
                comma = specifier.comma,
                precision = specifier.precision,
                trim = specifier.trim,
                type = specifier.type; // The "n" type is an alias for ",g".

            if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
            else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.

            if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
            // For SI-prefix, the suffix is lazily computed.

            var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
                suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
            // Is this an integer type?
            // Can this type generate exponential notation?

            var formatType = formatTypes[type],
                maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
            // or clamp the specified precision to the supported range.
            // For significant precision, it must be in [1, 21].
            // For fixed precision, it must be in [0, 20].

            precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));

            function format(value) {
              var valuePrefix = prefix,
                  valueSuffix = suffix,
                  i,
                  n,
                  c;

              if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
              } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!

                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.

                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.

                if (trim) value = formatTrim(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.

                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.

                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.

                if (maybeSuffix) {
                  i = -1, n = value.length;

                  while (++i < n) {
                    if (c = value.charCodeAt(i), 48 > c || c > 57) {
                      valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                      value = value.slice(0, i);
                      break;
                    }
                  }
                }
              } // If the fill character is not "0", grouping is applied before padding.


              if (comma && !zero) value = group(value, Infinity); // Compute the padding.

              var length = valuePrefix.length + value.length + valueSuffix.length,
                  padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.

              if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.

              switch (align) {
                case "<":
                  value = valuePrefix + value + valueSuffix + padding;
                  break;

                case "=":
                  value = valuePrefix + padding + value + valueSuffix;
                  break;

                case "^":
                  value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                  break;

                default:
                  value = padding + valuePrefix + value + valueSuffix;
                  break;
              }

              return numerals(value);
            }

            format.toString = function () {
              return specifier + "";
            };

            return format;
          }

          function formatPrefix(specifier, value) {
            var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
                e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
                k = Math.pow(10, -e),
                prefix = prefixes[8 + e / 3];
            return function (value) {
              return f(k * value) + prefix;
            };
          }

          return {
            format: newFormat,
            formatPrefix: formatPrefix
          };
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-format/src/defaultLocale.js

        var defaultLocale_locale;
        var format;
        var formatPrefix;
        defaultLocale({
          thousands: ",",
          grouping: [3],
          currency: ["$", ""]
        });

        function defaultLocale(definition) {
          defaultLocale_locale = locale(definition);
          format = defaultLocale_locale.format;
          formatPrefix = defaultLocale_locale.formatPrefix;
          return defaultLocale_locale;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-format/src/precisionRound.js

        /* harmony default export */

        function precisionRound(step, max) {
          step = Math.abs(step), max = Math.abs(max) - step;
          return Math.max(0, exponent(max) - exponent(step)) + 1;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-format/src/precisionFixed.js

        /* harmony default export */

        function precisionFixed(step) {
          return Math.max(0, -exponent(Math.abs(step)));
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-scale/src/tickFormat.js

        function tickFormat(start, stop, count, specifier) {
          var step = tickStep(start, stop, count),
              precision;
          specifier = formatSpecifier(specifier == null ? ",f" : specifier);

          switch (specifier.type) {
            case "s":
              {
                var value = Math.max(Math.abs(start), Math.abs(stop));
                if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
                return formatPrefix(specifier, value);
              }

            case "":
            case "e":
            case "g":
            case "p":
            case "r":
              {
                if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
                break;
              }

            case "f":
            case "%":
              {
                if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
                break;
              }
          }

          return format(specifier);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-scale/src/linear.js

        function linearish(scale) {
          var domain = scale.domain;

          scale.ticks = function (count) {
            var d = domain();
            return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
          };

          scale.tickFormat = function (count, specifier) {
            var d = domain();
            return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
          };

          scale.nice = function (count) {
            if (count == null) count = 10;
            var d = domain();
            var i0 = 0;
            var i1 = d.length - 1;
            var start = d[i0];
            var stop = d[i1];
            var prestep;
            var step;
            var maxIter = 10;

            if (stop < start) {
              step = start, start = stop, stop = step;
              step = i0, i0 = i1, i1 = step;
            }

            while (maxIter-- > 0) {
              step = tickIncrement(start, stop, count);

              if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
              } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
              } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
              } else {
                break;
              }

              prestep = step;
            }

            return scale;
          };

          return scale;
        }

        function linear_linear() {
          var scale = continuous();

          scale.copy = function () {
            return copy(scale, linear_linear());
          };

          initRange.apply(scale, arguments);
          return linearish(scale);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-time/src/duration.js

        var durationSecond = 1000;
        var durationMinute = durationSecond * 60;
        var durationHour = durationMinute * 60;
        var durationDay = durationHour * 24;
        var durationWeek = durationDay * 7;
        var durationMonth = durationDay * 30;
        var durationYear = durationDay * 365;
        ; // CONCATENATED MODULE: ./node_modules/d3-time/src/interval.js

        var t0 = new Date(),
            t1 = new Date();

        function newInterval(floori, offseti, count, field) {
          function interval(date) {
            return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
          }

          interval.floor = function (date) {
            return floori(date = new Date(+date)), date;
          };

          interval.ceil = function (date) {
            return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
          };

          interval.round = function (date) {
            var d0 = interval(date),
                d1 = interval.ceil(date);
            return date - d0 < d1 - date ? d0 : d1;
          };

          interval.offset = function (date, step) {
            return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
          };

          interval.range = function (start, stop, step) {
            var range = [],
                previous;
            start = interval.ceil(start);
            step = step == null ? 1 : Math.floor(step);
            if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date

            do {
              range.push(previous = new Date(+start)), offseti(start, step), floori(start);
            } while (previous < start && start < stop);

            return range;
          };

          interval.filter = function (test) {
            return newInterval(function (date) {
              if (date >= date) while (floori(date), !test(date)) {
                date.setTime(date - 1);
              }
            }, function (date, step) {
              if (date >= date) {
                if (step < 0) while (++step <= 0) {
                  while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty

                } else while (--step >= 0) {
                  while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty

                }
              }
            });
          };

          if (count) {
            interval.count = function (start, end) {
              t0.setTime(+start), t1.setTime(+end);
              floori(t0), floori(t1);
              return Math.floor(count(t0, t1));
            };

            interval.every = function (step) {
              step = Math.floor(step);
              return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function (d) {
                return field(d) % step === 0;
              } : function (d) {
                return interval.count(0, d) % step === 0;
              });
            };
          }

          return interval;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-time/src/millisecond.js

        var millisecond = newInterval(function () {// noop
        }, function (date, step) {
          date.setTime(+date + step);
        }, function (start, end) {
          return end - start;
        }); // An optimized implementation for this simple case.

        millisecond.every = function (k) {
          k = Math.floor(k);
          if (!isFinite(k) || !(k > 0)) return null;
          if (!(k > 1)) return millisecond;
          return newInterval(function (date) {
            date.setTime(Math.floor(date / k) * k);
          }, function (date, step) {
            date.setTime(+date + step * k);
          }, function (start, end) {
            return (end - start) / k;
          });
        };
        /* harmony default export */


        var src_millisecond = millisecond;
        var milliseconds = millisecond.range;
        ; // CONCATENATED MODULE: ./node_modules/d3-time/src/second.js

        var second = newInterval(function (date) {
          date.setTime(date - date.getMilliseconds());
        }, function (date, step) {
          date.setTime(+date + step * durationSecond);
        }, function (start, end) {
          return (end - start) / durationSecond;
        }, function (date) {
          return date.getUTCSeconds();
        });
        /* harmony default export */

        var src_second = second;
        var seconds = second.range;
        ; // CONCATENATED MODULE: ./node_modules/d3-time/src/minute.js

        var minute = newInterval(function (date) {
          date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
        }, function (date, step) {
          date.setTime(+date + step * durationMinute);
        }, function (start, end) {
          return (end - start) / durationMinute;
        }, function (date) {
          return date.getMinutes();
        });
        /* harmony default export */

        var src_minute = minute;
        var minutes = minute.range;
        ; // CONCATENATED MODULE: ./node_modules/d3-time/src/hour.js

        var hour = newInterval(function (date) {
          date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
        }, function (date, step) {
          date.setTime(+date + step * durationHour);
        }, function (start, end) {
          return (end - start) / durationHour;
        }, function (date) {
          return date.getHours();
        });
        /* harmony default export */

        var src_hour = hour;
        var hours = hour.range;
        ; // CONCATENATED MODULE: ./node_modules/d3-time/src/day.js

        var day = newInterval(function (date) {
          return date.setHours(0, 0, 0, 0);
        }, function (date, step) {
          return date.setDate(date.getDate() + step);
        }, function (start, end) {
          return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
        }, function (date) {
          return date.getDate() - 1;
        });
        /* harmony default export */

        var src_day = day;
        var days = day.range;
        ; // CONCATENATED MODULE: ./node_modules/d3-time/src/week.js

        function weekday(i) {
          return newInterval(function (date) {
            date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
            date.setHours(0, 0, 0, 0);
          }, function (date, step) {
            date.setDate(date.getDate() + step * 7);
          }, function (start, end) {
            return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
          });
        }

        var sunday = weekday(0);
        var monday = weekday(1);
        var tuesday = weekday(2);
        var wednesday = weekday(3);
        var thursday = weekday(4);
        var friday = weekday(5);
        var saturday = weekday(6);
        var sundays = sunday.range;
        var mondays = monday.range;
        var tuesdays = tuesday.range;
        var wednesdays = wednesday.range;
        var thursdays = thursday.range;
        var fridays = friday.range;
        var saturdays = saturday.range;
        ; // CONCATENATED MODULE: ./node_modules/d3-time/src/month.js

        var month = newInterval(function (date) {
          date.setDate(1);
          date.setHours(0, 0, 0, 0);
        }, function (date, step) {
          date.setMonth(date.getMonth() + step);
        }, function (start, end) {
          return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
        }, function (date) {
          return date.getMonth();
        });
        /* harmony default export */

        var src_month = month;
        var months = month.range;
        ; // CONCATENATED MODULE: ./node_modules/d3-time/src/year.js

        var year = newInterval(function (date) {
          date.setMonth(0, 1);
          date.setHours(0, 0, 0, 0);
        }, function (date, step) {
          date.setFullYear(date.getFullYear() + step);
        }, function (start, end) {
          return end.getFullYear() - start.getFullYear();
        }, function (date) {
          return date.getFullYear();
        }); // An optimized implementation for this simple case.

        year.every = function (k) {
          return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function (date) {
            date.setFullYear(Math.floor(date.getFullYear() / k) * k);
            date.setMonth(0, 1);
            date.setHours(0, 0, 0, 0);
          }, function (date, step) {
            date.setFullYear(date.getFullYear() + step * k);
          });
        };
        /* harmony default export */


        var src_year = year;
        var years = year.range;
        ; // CONCATENATED MODULE: ./node_modules/d3-time/src/utcMinute.js

        var utcMinute = newInterval(function (date) {
          date.setUTCSeconds(0, 0);
        }, function (date, step) {
          date.setTime(+date + step * durationMinute);
        }, function (start, end) {
          return (end - start) / durationMinute;
        }, function (date) {
          return date.getUTCMinutes();
        });
        /* harmony default export */

        var src_utcMinute = utcMinute;
        var utcMinutes = utcMinute.range;
        ; // CONCATENATED MODULE: ./node_modules/d3-time/src/utcHour.js

        var utcHour = newInterval(function (date) {
          date.setUTCMinutes(0, 0, 0);
        }, function (date, step) {
          date.setTime(+date + step * durationHour);
        }, function (start, end) {
          return (end - start) / durationHour;
        }, function (date) {
          return date.getUTCHours();
        });
        /* harmony default export */

        var src_utcHour = utcHour;
        var utcHours = utcHour.range;
        ; // CONCATENATED MODULE: ./node_modules/d3-time/src/utcDay.js

        var utcDay = newInterval(function (date) {
          date.setUTCHours(0, 0, 0, 0);
        }, function (date, step) {
          date.setUTCDate(date.getUTCDate() + step);
        }, function (start, end) {
          return (end - start) / durationDay;
        }, function (date) {
          return date.getUTCDate() - 1;
        });
        /* harmony default export */

        var src_utcDay = utcDay;
        var utcDays = utcDay.range;
        ; // CONCATENATED MODULE: ./node_modules/d3-time/src/utcWeek.js

        function utcWeekday(i) {
          return newInterval(function (date) {
            date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
            date.setUTCHours(0, 0, 0, 0);
          }, function (date, step) {
            date.setUTCDate(date.getUTCDate() + step * 7);
          }, function (start, end) {
            return (end - start) / durationWeek;
          });
        }

        var utcSunday = utcWeekday(0);
        var utcMonday = utcWeekday(1);
        var utcTuesday = utcWeekday(2);
        var utcWednesday = utcWeekday(3);
        var utcThursday = utcWeekday(4);
        var utcFriday = utcWeekday(5);
        var utcSaturday = utcWeekday(6);
        var utcSundays = utcSunday.range;
        var utcMondays = utcMonday.range;
        var utcTuesdays = utcTuesday.range;
        var utcWednesdays = utcWednesday.range;
        var utcThursdays = utcThursday.range;
        var utcFridays = utcFriday.range;
        var utcSaturdays = utcSaturday.range;
        ; // CONCATENATED MODULE: ./node_modules/d3-time/src/utcMonth.js

        var utcMonth = newInterval(function (date) {
          date.setUTCDate(1);
          date.setUTCHours(0, 0, 0, 0);
        }, function (date, step) {
          date.setUTCMonth(date.getUTCMonth() + step);
        }, function (start, end) {
          return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
        }, function (date) {
          return date.getUTCMonth();
        });
        /* harmony default export */

        var src_utcMonth = utcMonth;
        var utcMonths = utcMonth.range;
        ; // CONCATENATED MODULE: ./node_modules/d3-time/src/utcYear.js

        var utcYear = newInterval(function (date) {
          date.setUTCMonth(0, 1);
          date.setUTCHours(0, 0, 0, 0);
        }, function (date, step) {
          date.setUTCFullYear(date.getUTCFullYear() + step);
        }, function (start, end) {
          return end.getUTCFullYear() - start.getUTCFullYear();
        }, function (date) {
          return date.getUTCFullYear();
        }); // An optimized implementation for this simple case.

        utcYear.every = function (k) {
          return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function (date) {
            date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
            date.setUTCMonth(0, 1);
            date.setUTCHours(0, 0, 0, 0);
          }, function (date, step) {
            date.setUTCFullYear(date.getUTCFullYear() + step * k);
          });
        };
        /* harmony default export */


        var src_utcYear = utcYear;
        var utcYears = utcYear.range;
        ; // CONCATENATED MODULE: ./node_modules/d3-time/src/ticks.js

        function ticker(year, month, week, day, hour, minute) {
          var tickIntervals = [[src_second, 1, durationSecond], [src_second, 5, 5 * durationSecond], [src_second, 15, 15 * durationSecond], [src_second, 30, 30 * durationSecond], [minute, 1, durationMinute], [minute, 5, 5 * durationMinute], [minute, 15, 15 * durationMinute], [minute, 30, 30 * durationMinute], [hour, 1, durationHour], [hour, 3, 3 * durationHour], [hour, 6, 6 * durationHour], [hour, 12, 12 * durationHour], [day, 1, durationDay], [day, 2, 2 * durationDay], [week, 1, durationWeek], [month, 1, durationMonth], [month, 3, 3 * durationMonth], [year, 1, durationYear]];

          function ticks(start, stop, count) {
            var reverse = stop < start;

            if (reverse) {
              var _ref15 = [stop, start];
              start = _ref15[0];
              stop = _ref15[1];
            }

            var interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
            var ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop

            return reverse ? ticks.reverse() : ticks;
          }

          function tickInterval(start, stop, count) {
            var target = Math.abs(stop - start) / count;
            var i = bisector(function (_ref16) {
              var _ref17 = _slicedToArray2(_ref16, 3),
                  step = _ref17[2];

              return step;
            }).right(tickIntervals, target);
            if (i === tickIntervals.length) return year.every(tickStep(start / durationYear, stop / durationYear, count));
            if (i === 0) return src_millisecond.every(Math.max(tickStep(start, stop, count), 1));

            var _tickIntervals = _slicedToArray2(tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i], 2),
                t = _tickIntervals[0],
                step = _tickIntervals[1];

            return t.every(step);
          }

          return [ticks, tickInterval];
        }

        var _ticker = ticker(src_utcYear, src_utcMonth, utcSunday, src_utcDay, src_utcHour, src_utcMinute),
            _ticker2 = _slicedToArray2(_ticker, 2),
            utcTicks = _ticker2[0],
            utcTickInterval = _ticker2[1];

        var _ticker3 = ticker(src_year, src_month, sunday, src_day, src_hour, src_minute),
            _ticker4 = _slicedToArray2(_ticker3, 2),
            timeTicks = _ticker4[0],
            timeTickInterval = _ticker4[1];

        ; // CONCATENATED MODULE: ./node_modules/d3-time-format/src/locale.js

        function localDate(d) {
          if (0 <= d.y && d.y < 100) {
            var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
            date.setFullYear(d.y);
            return date;
          }

          return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
        }

        function utcDate(d) {
          if (0 <= d.y && d.y < 100) {
            var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
            date.setUTCFullYear(d.y);
            return date;
          }

          return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
        }

        function newDate(y, m, d) {
          return {
            y: y,
            m: m,
            d: d,
            H: 0,
            M: 0,
            S: 0,
            L: 0
          };
        }

        function formatLocale(locale) {
          var locale_dateTime = locale.dateTime,
              locale_date = locale.date,
              locale_time = locale.time,
              locale_periods = locale.periods,
              locale_weekdays = locale.days,
              locale_shortWeekdays = locale.shortDays,
              locale_months = locale.months,
              locale_shortMonths = locale.shortMonths;
          var periodRe = formatRe(locale_periods),
              periodLookup = formatLookup(locale_periods),
              weekdayRe = formatRe(locale_weekdays),
              weekdayLookup = formatLookup(locale_weekdays),
              shortWeekdayRe = formatRe(locale_shortWeekdays),
              shortWeekdayLookup = formatLookup(locale_shortWeekdays),
              monthRe = formatRe(locale_months),
              monthLookup = formatLookup(locale_months),
              shortMonthRe = formatRe(locale_shortMonths),
              shortMonthLookup = formatLookup(locale_shortMonths);
          var formats = {
            "a": formatShortWeekday,
            "A": formatWeekday,
            "b": formatShortMonth,
            "B": formatMonth,
            "c": null,
            "d": formatDayOfMonth,
            "e": formatDayOfMonth,
            "f": formatMicroseconds,
            "g": formatYearISO,
            "G": formatFullYearISO,
            "H": formatHour24,
            "I": formatHour12,
            "j": formatDayOfYear,
            "L": formatMilliseconds,
            "m": formatMonthNumber,
            "M": formatMinutes,
            "p": formatPeriod,
            "q": formatQuarter,
            "Q": formatUnixTimestamp,
            "s": formatUnixTimestampSeconds,
            "S": formatSeconds,
            "u": formatWeekdayNumberMonday,
            "U": formatWeekNumberSunday,
            "V": formatWeekNumberISO,
            "w": formatWeekdayNumberSunday,
            "W": formatWeekNumberMonday,
            "x": null,
            "X": null,
            "y": formatYear,
            "Y": formatFullYear,
            "Z": formatZone,
            "%": formatLiteralPercent
          };
          var utcFormats = {
            "a": formatUTCShortWeekday,
            "A": formatUTCWeekday,
            "b": formatUTCShortMonth,
            "B": formatUTCMonth,
            "c": null,
            "d": formatUTCDayOfMonth,
            "e": formatUTCDayOfMonth,
            "f": formatUTCMicroseconds,
            "g": formatUTCYearISO,
            "G": formatUTCFullYearISO,
            "H": formatUTCHour24,
            "I": formatUTCHour12,
            "j": formatUTCDayOfYear,
            "L": formatUTCMilliseconds,
            "m": formatUTCMonthNumber,
            "M": formatUTCMinutes,
            "p": formatUTCPeriod,
            "q": formatUTCQuarter,
            "Q": formatUnixTimestamp,
            "s": formatUnixTimestampSeconds,
            "S": formatUTCSeconds,
            "u": formatUTCWeekdayNumberMonday,
            "U": formatUTCWeekNumberSunday,
            "V": formatUTCWeekNumberISO,
            "w": formatUTCWeekdayNumberSunday,
            "W": formatUTCWeekNumberMonday,
            "x": null,
            "X": null,
            "y": formatUTCYear,
            "Y": formatUTCFullYear,
            "Z": formatUTCZone,
            "%": formatLiteralPercent
          };
          var parses = {
            "a": parseShortWeekday,
            "A": parseWeekday,
            "b": parseShortMonth,
            "B": parseMonth,
            "c": parseLocaleDateTime,
            "d": parseDayOfMonth,
            "e": parseDayOfMonth,
            "f": parseMicroseconds,
            "g": parseYear,
            "G": parseFullYear,
            "H": parseHour24,
            "I": parseHour24,
            "j": parseDayOfYear,
            "L": parseMilliseconds,
            "m": parseMonthNumber,
            "M": parseMinutes,
            "p": parsePeriod,
            "q": parseQuarter,
            "Q": parseUnixTimestamp,
            "s": parseUnixTimestampSeconds,
            "S": parseSeconds,
            "u": parseWeekdayNumberMonday,
            "U": parseWeekNumberSunday,
            "V": parseWeekNumberISO,
            "w": parseWeekdayNumberSunday,
            "W": parseWeekNumberMonday,
            "x": parseLocaleDate,
            "X": parseLocaleTime,
            "y": parseYear,
            "Y": parseFullYear,
            "Z": parseZone,
            "%": parseLiteralPercent
          }; // These recursive directive definitions must be deferred.

          formats.x = newFormat(locale_date, formats);
          formats.X = newFormat(locale_time, formats);
          formats.c = newFormat(locale_dateTime, formats);
          utcFormats.x = newFormat(locale_date, utcFormats);
          utcFormats.X = newFormat(locale_time, utcFormats);
          utcFormats.c = newFormat(locale_dateTime, utcFormats);

          function newFormat(specifier, formats) {
            return function (date) {
              var string = [],
                  i = -1,
                  j = 0,
                  n = specifier.length,
                  c,
                  pad,
                  format;
              if (!(date instanceof Date)) date = new Date(+date);

              while (++i < n) {
                if (specifier.charCodeAt(i) === 37) {
                  string.push(specifier.slice(j, i));
                  if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);else pad = c === "e" ? " " : "0";
                  if (format = formats[c]) c = format(date, pad);
                  string.push(c);
                  j = i + 1;
                }
              }

              string.push(specifier.slice(j, i));
              return string.join("");
            };
          }

          function newParse(specifier, Z) {
            return function (string) {
              var d = newDate(1900, undefined, 1),
                  i = parseSpecifier(d, specifier, string += "", 0),
                  week,
                  day;
              if (i != string.length) return null; // If a UNIX timestamp is specified, return it.

              if ("Q" in d) return new Date(d.Q);
              if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.

              if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.

              if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.

              if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.

              if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;

                if ("Z" in d) {
                  week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                  week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
                  week = src_utcDay.offset(week, (d.V - 1) * 7);
                  d.y = week.getUTCFullYear();
                  d.m = week.getUTCMonth();
                  d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                  week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                  week = day > 4 || day === 0 ? monday.ceil(week) : monday(week);
                  week = src_day.offset(week, (d.V - 1) * 7);
                  d.y = week.getFullYear();
                  d.m = week.getMonth();
                  d.d = week.getDate() + (d.w + 6) % 7;
                }
              } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
              } // If a time zone is specified, all fields are interpreted as UTC and then
              // offset according to the specified time zone.


              if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return utcDate(d);
              } // Otherwise, all fields are in local time.


              return localDate(d);
            };
          }

          function parseSpecifier(d, specifier, string, j) {
            var i = 0,
                n = specifier.length,
                m = string.length,
                c,
                parse;

            while (i < n) {
              if (j >= m) return -1;
              c = specifier.charCodeAt(i++);

              if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
              } else if (c != string.charCodeAt(j++)) {
                return -1;
              }
            }

            return j;
          }

          function parsePeriod(d, string, i) {
            var n = periodRe.exec(string.slice(i));
            return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
          }

          function parseShortWeekday(d, string, i) {
            var n = shortWeekdayRe.exec(string.slice(i));
            return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
          }

          function parseWeekday(d, string, i) {
            var n = weekdayRe.exec(string.slice(i));
            return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
          }

          function parseShortMonth(d, string, i) {
            var n = shortMonthRe.exec(string.slice(i));
            return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
          }

          function parseMonth(d, string, i) {
            var n = monthRe.exec(string.slice(i));
            return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
          }

          function parseLocaleDateTime(d, string, i) {
            return parseSpecifier(d, locale_dateTime, string, i);
          }

          function parseLocaleDate(d, string, i) {
            return parseSpecifier(d, locale_date, string, i);
          }

          function parseLocaleTime(d, string, i) {
            return parseSpecifier(d, locale_time, string, i);
          }

          function formatShortWeekday(d) {
            return locale_shortWeekdays[d.getDay()];
          }

          function formatWeekday(d) {
            return locale_weekdays[d.getDay()];
          }

          function formatShortMonth(d) {
            return locale_shortMonths[d.getMonth()];
          }

          function formatMonth(d) {
            return locale_months[d.getMonth()];
          }

          function formatPeriod(d) {
            return locale_periods[+(d.getHours() >= 12)];
          }

          function formatQuarter(d) {
            return 1 + ~~(d.getMonth() / 3);
          }

          function formatUTCShortWeekday(d) {
            return locale_shortWeekdays[d.getUTCDay()];
          }

          function formatUTCWeekday(d) {
            return locale_weekdays[d.getUTCDay()];
          }

          function formatUTCShortMonth(d) {
            return locale_shortMonths[d.getUTCMonth()];
          }

          function formatUTCMonth(d) {
            return locale_months[d.getUTCMonth()];
          }

          function formatUTCPeriod(d) {
            return locale_periods[+(d.getUTCHours() >= 12)];
          }

          function formatUTCQuarter(d) {
            return 1 + ~~(d.getUTCMonth() / 3);
          }

          return {
            format: function format(specifier) {
              var f = newFormat(specifier += "", formats);

              f.toString = function () {
                return specifier;
              };

              return f;
            },
            parse: function parse(specifier) {
              var p = newParse(specifier += "", false);

              p.toString = function () {
                return specifier;
              };

              return p;
            },
            utcFormat: function utcFormat(specifier) {
              var f = newFormat(specifier += "", utcFormats);

              f.toString = function () {
                return specifier;
              };

              return f;
            },
            utcParse: function utcParse(specifier) {
              var p = newParse(specifier += "", true);

              p.toString = function () {
                return specifier;
              };

              return p;
            }
          };
        }

        var pads = {
          "-": "",
          "_": " ",
          "0": "0"
        },
            numberRe = /^\s*\d+/,
            // note: ignores next directive
        percentRe = /^%/,
            requoteRe = /[\\^$*+?|[\]().{}]/g;

        function pad(value, fill, width) {
          var sign = value < 0 ? "-" : "",
              string = (sign ? -value : value) + "",
              length = string.length;
          return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
        }

        function requote(s) {
          return s.replace(requoteRe, "\\$&");
        }

        function formatRe(names) {
          return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
        }

        function formatLookup(names) {
          return new Map(names.map(function (name, i) {
            return [name.toLowerCase(), i];
          }));
        }

        function parseWeekdayNumberSunday(d, string, i) {
          var n = numberRe.exec(string.slice(i, i + 1));
          return n ? (d.w = +n[0], i + n[0].length) : -1;
        }

        function parseWeekdayNumberMonday(d, string, i) {
          var n = numberRe.exec(string.slice(i, i + 1));
          return n ? (d.u = +n[0], i + n[0].length) : -1;
        }

        function parseWeekNumberSunday(d, string, i) {
          var n = numberRe.exec(string.slice(i, i + 2));
          return n ? (d.U = +n[0], i + n[0].length) : -1;
        }

        function parseWeekNumberISO(d, string, i) {
          var n = numberRe.exec(string.slice(i, i + 2));
          return n ? (d.V = +n[0], i + n[0].length) : -1;
        }

        function parseWeekNumberMonday(d, string, i) {
          var n = numberRe.exec(string.slice(i, i + 2));
          return n ? (d.W = +n[0], i + n[0].length) : -1;
        }

        function parseFullYear(d, string, i) {
          var n = numberRe.exec(string.slice(i, i + 4));
          return n ? (d.y = +n[0], i + n[0].length) : -1;
        }

        function parseYear(d, string, i) {
          var n = numberRe.exec(string.slice(i, i + 2));
          return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
        }

        function parseZone(d, string, i) {
          var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
          return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
        }

        function parseQuarter(d, string, i) {
          var n = numberRe.exec(string.slice(i, i + 1));
          return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
        }

        function parseMonthNumber(d, string, i) {
          var n = numberRe.exec(string.slice(i, i + 2));
          return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
        }

        function parseDayOfMonth(d, string, i) {
          var n = numberRe.exec(string.slice(i, i + 2));
          return n ? (d.d = +n[0], i + n[0].length) : -1;
        }

        function parseDayOfYear(d, string, i) {
          var n = numberRe.exec(string.slice(i, i + 3));
          return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
        }

        function parseHour24(d, string, i) {
          var n = numberRe.exec(string.slice(i, i + 2));
          return n ? (d.H = +n[0], i + n[0].length) : -1;
        }

        function parseMinutes(d, string, i) {
          var n = numberRe.exec(string.slice(i, i + 2));
          return n ? (d.M = +n[0], i + n[0].length) : -1;
        }

        function parseSeconds(d, string, i) {
          var n = numberRe.exec(string.slice(i, i + 2));
          return n ? (d.S = +n[0], i + n[0].length) : -1;
        }

        function parseMilliseconds(d, string, i) {
          var n = numberRe.exec(string.slice(i, i + 3));
          return n ? (d.L = +n[0], i + n[0].length) : -1;
        }

        function parseMicroseconds(d, string, i) {
          var n = numberRe.exec(string.slice(i, i + 6));
          return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
        }

        function parseLiteralPercent(d, string, i) {
          var n = percentRe.exec(string.slice(i, i + 1));
          return n ? i + n[0].length : -1;
        }

        function parseUnixTimestamp(d, string, i) {
          var n = numberRe.exec(string.slice(i));
          return n ? (d.Q = +n[0], i + n[0].length) : -1;
        }

        function parseUnixTimestampSeconds(d, string, i) {
          var n = numberRe.exec(string.slice(i));
          return n ? (d.s = +n[0], i + n[0].length) : -1;
        }

        function formatDayOfMonth(d, p) {
          return pad(d.getDate(), p, 2);
        }

        function formatHour24(d, p) {
          return pad(d.getHours(), p, 2);
        }

        function formatHour12(d, p) {
          return pad(d.getHours() % 12 || 12, p, 2);
        }

        function formatDayOfYear(d, p) {
          return pad(1 + src_day.count(src_year(d), d), p, 3);
        }

        function formatMilliseconds(d, p) {
          return pad(d.getMilliseconds(), p, 3);
        }

        function formatMicroseconds(d, p) {
          return formatMilliseconds(d, p) + "000";
        }

        function formatMonthNumber(d, p) {
          return pad(d.getMonth() + 1, p, 2);
        }

        function formatMinutes(d, p) {
          return pad(d.getMinutes(), p, 2);
        }

        function formatSeconds(d, p) {
          return pad(d.getSeconds(), p, 2);
        }

        function formatWeekdayNumberMonday(d) {
          var day = d.getDay();
          return day === 0 ? 7 : day;
        }

        function formatWeekNumberSunday(d, p) {
          return pad(sunday.count(src_year(d) - 1, d), p, 2);
        }

        function dISO(d) {
          var day = d.getDay();
          return day >= 4 || day === 0 ? thursday(d) : thursday.ceil(d);
        }

        function formatWeekNumberISO(d, p) {
          d = dISO(d);
          return pad(thursday.count(src_year(d), d) + (src_year(d).getDay() === 4), p, 2);
        }

        function formatWeekdayNumberSunday(d) {
          return d.getDay();
        }

        function formatWeekNumberMonday(d, p) {
          return pad(monday.count(src_year(d) - 1, d), p, 2);
        }

        function formatYear(d, p) {
          return pad(d.getFullYear() % 100, p, 2);
        }

        function formatYearISO(d, p) {
          d = dISO(d);
          return pad(d.getFullYear() % 100, p, 2);
        }

        function formatFullYear(d, p) {
          return pad(d.getFullYear() % 10000, p, 4);
        }

        function formatFullYearISO(d, p) {
          var day = d.getDay();
          d = day >= 4 || day === 0 ? thursday(d) : thursday.ceil(d);
          return pad(d.getFullYear() % 10000, p, 4);
        }

        function formatZone(d) {
          var z = d.getTimezoneOffset();
          return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
        }

        function formatUTCDayOfMonth(d, p) {
          return pad(d.getUTCDate(), p, 2);
        }

        function formatUTCHour24(d, p) {
          return pad(d.getUTCHours(), p, 2);
        }

        function formatUTCHour12(d, p) {
          return pad(d.getUTCHours() % 12 || 12, p, 2);
        }

        function formatUTCDayOfYear(d, p) {
          return pad(1 + src_utcDay.count(src_utcYear(d), d), p, 3);
        }

        function formatUTCMilliseconds(d, p) {
          return pad(d.getUTCMilliseconds(), p, 3);
        }

        function formatUTCMicroseconds(d, p) {
          return formatUTCMilliseconds(d, p) + "000";
        }

        function formatUTCMonthNumber(d, p) {
          return pad(d.getUTCMonth() + 1, p, 2);
        }

        function formatUTCMinutes(d, p) {
          return pad(d.getUTCMinutes(), p, 2);
        }

        function formatUTCSeconds(d, p) {
          return pad(d.getUTCSeconds(), p, 2);
        }

        function formatUTCWeekdayNumberMonday(d) {
          var dow = d.getUTCDay();
          return dow === 0 ? 7 : dow;
        }

        function formatUTCWeekNumberSunday(d, p) {
          return pad(utcSunday.count(src_utcYear(d) - 1, d), p, 2);
        }

        function UTCdISO(d) {
          var day = d.getUTCDay();
          return day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
        }

        function formatUTCWeekNumberISO(d, p) {
          d = UTCdISO(d);
          return pad(utcThursday.count(src_utcYear(d), d) + (src_utcYear(d).getUTCDay() === 4), p, 2);
        }

        function formatUTCWeekdayNumberSunday(d) {
          return d.getUTCDay();
        }

        function formatUTCWeekNumberMonday(d, p) {
          return pad(utcMonday.count(src_utcYear(d) - 1, d), p, 2);
        }

        function formatUTCYear(d, p) {
          return pad(d.getUTCFullYear() % 100, p, 2);
        }

        function formatUTCYearISO(d, p) {
          d = UTCdISO(d);
          return pad(d.getUTCFullYear() % 100, p, 2);
        }

        function formatUTCFullYear(d, p) {
          return pad(d.getUTCFullYear() % 10000, p, 4);
        }

        function formatUTCFullYearISO(d, p) {
          var day = d.getUTCDay();
          d = day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
          return pad(d.getUTCFullYear() % 10000, p, 4);
        }

        function formatUTCZone() {
          return "+0000";
        }

        function formatLiteralPercent() {
          return "%";
        }

        function formatUnixTimestamp(d) {
          return +d;
        }

        function formatUnixTimestampSeconds(d) {
          return Math.floor(+d / 1000);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-time-format/src/defaultLocale.js

        var src_defaultLocale_locale;
        var timeFormat;
        var timeParse;
        var utcFormat;
        var utcParse;
        defaultLocale_defaultLocale({
          dateTime: "%x, %X",
          date: "%-m/%-d/%Y",
          time: "%-I:%M:%S %p",
          periods: ["AM", "PM"],
          days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        });

        function defaultLocale_defaultLocale(definition) {
          src_defaultLocale_locale = formatLocale(definition);
          timeFormat = src_defaultLocale_locale.format;
          timeParse = src_defaultLocale_locale.parse;
          utcFormat = src_defaultLocale_locale.utcFormat;
          utcParse = src_defaultLocale_locale.utcParse;
          return src_defaultLocale_locale;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-scale/src/nice.js

        function nice(domain, interval) {
          domain = domain.slice();
          var i0 = 0,
              i1 = domain.length - 1,
              x0 = domain[i0],
              x1 = domain[i1],
              t;

          if (x1 < x0) {
            t = i0, i0 = i1, i1 = t;
            t = x0, x0 = x1, x1 = t;
          }

          domain[i0] = interval.floor(x0);
          domain[i1] = interval.ceil(x1);
          return domain;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-scale/src/time.js

        function time_date(t) {
          return new Date(t);
        }

        function time_number(t) {
          return t instanceof Date ? +t : +new Date(+t);
        }

        function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
          var scale = continuous(),
              invert = scale.invert,
              domain = scale.domain;
          var formatMillisecond = format(".%L"),
              formatSecond = format(":%S"),
              formatMinute = format("%I:%M"),
              formatHour = format("%I %p"),
              formatDay = format("%a %d"),
              formatWeek = format("%b %d"),
              formatMonth = format("%B"),
              formatYear = format("%Y");

          function tickFormat(date) {
            return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
          }

          scale.invert = function (y) {
            return new Date(invert(y));
          };

          scale.domain = function (_) {
            return arguments.length ? domain(Array.from(_, time_number)) : domain().map(time_date);
          };

          scale.ticks = function (interval) {
            var d = domain();
            return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
          };

          scale.tickFormat = function (count, specifier) {
            return specifier == null ? tickFormat : format(specifier);
          };

          scale.nice = function (interval) {
            var d = domain();
            if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
            return interval ? domain(nice(d, interval)) : scale;
          };

          scale.copy = function () {
            return copy(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
          };

          return scale;
        }

        function time() {
          return initRange.apply(calendar(timeTicks, timeTickInterval, src_year, src_month, sunday, src_day, src_hour, src_minute, src_second, timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-scale/src/index.js

        ; // CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/colors.js

        /* harmony default export */

        function colors(specifier) {
          var n = specifier.length / 6 | 0,
              colors = new Array(n),
              i = 0;

          while (i < n) {
            colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
          }

          return colors;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/categorical/category10.js

        /* harmony default export */

        var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
        ; // CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/index.js

        ; // CONCATENATED MODULE: ./node_modules/d3-selection/src/index.js

        ; // CONCATENATED MODULE: ./node_modules/d3-path/src/path.js

        var pi = Math.PI,
            tau = 2 * pi,
            path_epsilon = 1e-6,
            tauEpsilon = tau - path_epsilon;

        function Path() {
          this._x0 = this._y0 = // start of current subpath
          this._x1 = this._y1 = null; // end of current subpath

          this._ = "";
        }

        function path() {
          return new Path();
        }

        Path.prototype = path.prototype = {
          constructor: Path,
          moveTo: function moveTo(x, y) {
            this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
          },
          closePath: function closePath() {
            if (this._x1 !== null) {
              this._x1 = this._x0, this._y1 = this._y0;
              this._ += "Z";
            }
          },
          lineTo: function lineTo(x, y) {
            this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
          },
          quadraticCurveTo: function quadraticCurveTo(x1, y1, x, y) {
            this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
          },
          bezierCurveTo: function bezierCurveTo(x1, y1, x2, y2, x, y) {
            this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
          },
          arcTo: function arcTo(x1, y1, x2, y2, r) {
            x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
            var x0 = this._x1,
                y0 = this._y1,
                x21 = x2 - x1,
                y21 = y2 - y1,
                x01 = x0 - x1,
                y01 = y0 - y1,
                l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.

            if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).

            if (this._x1 === null) {
              this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
            } // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
            else if (!(l01_2 > path_epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
            // Equivalently, is (x1,y1) coincident with (x2,y2)?
            // Or, is the radius zero? Line to (x1,y1).
            else if (!(Math.abs(y01 * x21 - y21 * x01) > path_epsilon) || !r) {
              this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
            } // Otherwise, draw an arc!
            else {
              var x20 = x2 - x0,
                  y20 = y2 - y0,
                  l21_2 = x21 * x21 + y21 * y21,
                  l20_2 = x20 * x20 + y20 * y20,
                  l21 = Math.sqrt(l21_2),
                  l01 = Math.sqrt(l01_2),
                  l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
                  t01 = l / l01,
                  t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.

              if (Math.abs(t01 - 1) > path_epsilon) {
                this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
              }

              this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
            }
          },
          arc: function arc(x, y, r, a0, a1, ccw) {
            x = +x, y = +y, r = +r, ccw = !!ccw;
            var dx = r * Math.cos(a0),
                dy = r * Math.sin(a0),
                x0 = x + dx,
                y0 = y + dy,
                cw = 1 ^ ccw,
                da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.

            if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).

            if (this._x1 === null) {
              this._ += "M" + x0 + "," + y0;
            } // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
            else if (Math.abs(this._x1 - x0) > path_epsilon || Math.abs(this._y1 - y0) > path_epsilon) {
              this._ += "L" + x0 + "," + y0;
            } // Is this arc empty? We’re done.


            if (!r) return; // Does the angle go the wrong way? Flip the direction.

            if (da < 0) da = da % tau + tau; // Is this a complete circle? Draw two arcs to complete the circle.

            if (da > tauEpsilon) {
              this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
            } // Is this arc non-empty? Draw an arc!
            else if (da > path_epsilon) {
              this._ += "A" + r + "," + r + ",0," + +(da >= pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
            }
          },
          rect: function rect(x, y, w, h) {
            this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
          },
          toString: function toString() {
            return this._;
          }
        };
        /* harmony default export */

        var src_path = path;
        ; // CONCATENATED MODULE: ./node_modules/d3-shape/src/array.js

        var array_slice = Array.prototype.slice;
        /* harmony default export */

        function d3_shape_src_array(x) {
          return _typeof2(x) === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
          : Array.from(x); // Map, Set, iterable, string, or anything else
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-shape/src/constant.js

        /* harmony default export */

        function d3_shape_src_constant(x) {
          return function constant() {
            return x;
          };
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/linear.js

        function Linear(context) {
          this._context = context;
        }

        Linear.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._point = 0;
          },
          lineEnd: function lineEnd() {
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            this._line = 1 - this._line;
          },
          point: function point(x, y) {
            x = +x, y = +y;

            switch (this._point) {
              case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;

              case 1:
                this._point = 2;
              // proceed

              default:
                this._context.lineTo(x, y);

                break;
            }
          }
        };
        /* harmony default export */

        function curve_linear(context) {
          return new Linear(context);
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-shape/src/point.js

        function point_x(p) {
          return p[0];
        }

        function point_y(p) {
          return p[1];
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-shape/src/line.js

        /* harmony default export */

        function src_line(x, y) {
          var defined = d3_shape_src_constant(true),
              context = null,
              curve = curve_linear,
              output = null;
          x = typeof x === "function" ? x : x === undefined ? point_x : d3_shape_src_constant(x);
          y = typeof y === "function" ? y : y === undefined ? point_y : d3_shape_src_constant(y);

          function line(data) {
            var i,
                n = (data = d3_shape_src_array(data)).length,
                d,
                defined0 = false,
                buffer;
            if (context == null) output = curve(buffer = src_path());

            for (i = 0; i <= n; ++i) {
              if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();else output.lineEnd();
              }

              if (defined0) output.point(+x(d, i, data), +y(d, i, data));
            }

            if (buffer) return output = null, buffer + "" || null;
          }

          line.x = function (_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : d3_shape_src_constant(+_), line) : x;
          };

          line.y = function (_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : d3_shape_src_constant(+_), line) : y;
          };

          line.defined = function (_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : d3_shape_src_constant(!!_), line) : defined;
          };

          line.curve = function (_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
          };

          line.context = function (_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
          };

          return line;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-shape/src/offset/none.js

        /* harmony default export */

        function offset_none(series, order) {
          if (!((n = series.length) > 1)) return;

          for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
            s0 = s1, s1 = series[order[i]];

            for (j = 0; j < m; ++j) {
              s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
            }
          }
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-shape/src/order/none.js

        /* harmony default export */

        function order_none(series) {
          var n = series.length,
              o = new Array(n);

          while (--n >= 0) {
            o[n] = n;
          }

          return o;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-shape/src/stack.js

        function stackValue(d, key) {
          return d[key];
        }

        function stackSeries(key) {
          var series = [];
          series.key = key;
          return series;
        }
        /* harmony default export */


        function stack() {
          var keys = d3_shape_src_constant([]),
              order = order_none,
              offset = offset_none,
              value = stackValue;

          function stack(data) {
            var sz = Array.from(keys.apply(this, arguments), stackSeries),
                i,
                n = sz.length,
                j = -1,
                oz;

            var _iterator18 = _createForOfIteratorHelper(data),
                _step18;

            try {
              for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                var d = _step18.value;

                for (i = 0, ++j; i < n; ++i) {
                  (sz[i][j] = [0, +value(d, sz[i].key, j, data)]).data = d;
                }
              }
            } catch (err) {
              _iterator18.e(err);
            } finally {
              _iterator18.f();
            }

            for (i = 0, oz = d3_shape_src_array(order(sz)); i < n; ++i) {
              sz[oz[i]].index = i;
            }

            offset(sz, oz);
            return sz;
          }

          stack.keys = function (_) {
            return arguments.length ? (keys = typeof _ === "function" ? _ : d3_shape_src_constant(Array.from(_)), stack) : keys;
          };

          stack.value = function (_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : d3_shape_src_constant(+_), stack) : value;
          };

          stack.order = function (_) {
            return arguments.length ? (order = _ == null ? order_none : typeof _ === "function" ? _ : d3_shape_src_constant(Array.from(_)), stack) : order;
          };

          stack.offset = function (_) {
            return arguments.length ? (offset = _ == null ? offset_none : _, stack) : offset;
          };

          return stack;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-shape/src/index.js
        // Note: radialArea is deprecated!
        // Note: radialLine is deprecated!

        ; // CONCATENATED MODULE: ./node_modules/d3-time/src/index.js

        ; // CONCATENATED MODULE: ./node_modules/d3-time-format/src/index.js

        ; // CONCATENATED MODULE: ./node_modules/d3-zoom/src/transform.js

        function transform_Transform(k, x, y) {
          this.k = k;
          this.x = x;
          this.y = y;
        }

        transform_Transform.prototype = {
          constructor: transform_Transform,
          scale: function scale(k) {
            return k === 1 ? this : new transform_Transform(this.k * k, this.x, this.y);
          },
          translate: function translate(x, y) {
            return x === 0 & y === 0 ? this : new transform_Transform(this.k, this.x + this.k * x, this.y + this.k * y);
          },
          apply: function apply(point) {
            return [point[0] * this.k + this.x, point[1] * this.k + this.y];
          },
          applyX: function applyX(x) {
            return x * this.k + this.x;
          },
          applyY: function applyY(y) {
            return y * this.k + this.y;
          },
          invert: function invert(location) {
            return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
          },
          invertX: function invertX(x) {
            return (x - this.x) / this.k;
          },
          invertY: function invertY(y) {
            return (y - this.y) / this.k;
          },
          rescaleX: function rescaleX(x) {
            return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
          },
          rescaleY: function rescaleY(y) {
            return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
          },
          toString: function toString() {
            return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
          }
        };
        var transform_identity = new transform_Transform(1, 0, 0);
        transform.prototype = transform_Transform.prototype;

        function transform(node) {
          while (!node.__zoom) {
            if (!(node = node.parentNode)) return transform_identity;
          }

          return node.__zoom;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-zoom/src/zoom.js
        // Ignore right-click, since that should open the context menu.
        // except for pinch-to-zoom, which is sent as a wheel+ctrlKey event

        function zoom_defaultFilter(event) {
          return (!event.ctrlKey || event.type === 'wheel') && !event.button;
        }

        function zoom_defaultExtent() {
          var e = this;

          if (e instanceof SVGElement) {
            e = e.ownerSVGElement || e;

            if (e.hasAttribute("viewBox")) {
              e = e.viewBox.baseVal;
              return [[e.x, e.y], [e.x + e.width, e.y + e.height]];
            }

            return [[0, 0], [e.width.baseVal.value, e.height.baseVal.value]];
          }

          return [[0, 0], [e.clientWidth, e.clientHeight]];
        }

        function defaultTransform() {
          return this.__zoom || identity;
        }

        function defaultWheelDelta(event) {
          return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
        }

        function zoom_defaultTouchable() {
          return navigator.maxTouchPoints || "ontouchstart" in this;
        }

        function defaultConstrain(transform, extent, translateExtent) {
          var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0],
              dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0],
              dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1],
              dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
          return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
        }
        /* harmony default export */


        function zoom() {
          var filter = zoom_defaultFilter,
              extent = zoom_defaultExtent,
              constrain = defaultConstrain,
              wheelDelta = defaultWheelDelta,
              touchable = zoom_defaultTouchable,
              scaleExtent = [0, Infinity],
              translateExtent = [[-Infinity, -Infinity], [Infinity, Infinity]],
              duration = 250,
              interpolate = interpolateZoom,
              listeners = dispatch("start", "zoom", "end"),
              touchstarting,
              touchfirst,
              touchending,
              touchDelay = 500,
              wheelDelay = 150,
              clickDistance2 = 0,
              tapDistance = 10;

          function zoom(selection) {
            selection.property("__zoom", defaultTransform).on("wheel.zoom", wheeled).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
          }

          zoom.transform = function (collection, transform, point, event) {
            var selection = collection.selection ? collection.selection() : collection;
            selection.property("__zoom", defaultTransform);

            if (collection !== selection) {
              schedule(collection, transform, point, event);
            } else {
              selection.interrupt().each(function () {
                gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
              });
            }
          };

          zoom.scaleBy = function (selection, k, p, event) {
            zoom.scaleTo(selection, function () {
              var k0 = this.__zoom.k,
                  k1 = typeof k === "function" ? k.apply(this, arguments) : k;
              return k0 * k1;
            }, p, event);
          };

          zoom.scaleTo = function (selection, k, p, event) {
            zoom.transform(selection, function () {
              var e = extent.apply(this, arguments),
                  t0 = this.__zoom,
                  p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p,
                  p1 = t0.invert(p0),
                  k1 = typeof k === "function" ? k.apply(this, arguments) : k;
              return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
            }, p, event);
          };

          zoom.translateBy = function (selection, x, y, event) {
            zoom.transform(selection, function () {
              return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
            }, null, event);
          };

          zoom.translateTo = function (selection, x, y, p, event) {
            zoom.transform(selection, function () {
              var e = extent.apply(this, arguments),
                  t = this.__zoom,
                  p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
              return constrain(identity.translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
            }, p, event);
          };

          function scale(transform, k) {
            k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
            return k === transform.k ? transform : new Transform(k, transform.x, transform.y);
          }

          function translate(transform, p0, p1) {
            var x = p0[0] - p1[0] * transform.k,
                y = p0[1] - p1[1] * transform.k;
            return x === transform.x && y === transform.y ? transform : new Transform(transform.k, x, y);
          }

          function centroid(extent) {
            return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
          }

          function schedule(transition, transform, point, event) {
            transition.on("start.zoom", function () {
              gesture(this, arguments).event(event).start();
            }).on("interrupt.zoom end.zoom", function () {
              gesture(this, arguments).event(event).end();
            }).tween("zoom", function () {
              var that = this,
                  args = arguments,
                  g = gesture(that, args).event(event),
                  e = extent.apply(that, args),
                  p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point,
                  w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
                  a = that.__zoom,
                  b = typeof transform === "function" ? transform.apply(that, args) : transform,
                  i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
              return function (t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                  var l = i(t),
                      k = w / l[2];
                  t = new Transform(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
              };
            });
          }

          function gesture(that, args, clean) {
            return !clean && that.__zooming || new Gesture(that, args);
          }

          function Gesture(that, args) {
            this.that = that;
            this.args = args;
            this.active = 0;
            this.sourceEvent = null;
            this.extent = extent.apply(that, args);
            this.taps = 0;
          }

          Gesture.prototype = {
            event: function event(_event) {
              if (_event) this.sourceEvent = _event;
              return this;
            },
            start: function start() {
              if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
              }

              return this;
            },
            zoom: function zoom(key, transform) {
              if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
              if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
              if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
              this.that.__zoom = transform;
              this.emit("zoom");
              return this;
            },
            end: function end() {
              if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
              }

              return this;
            },
            emit: function emit(type) {
              var d = select(this.that).datum();
              listeners.call(type, this.that, new ZoomEvent(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
              }), d);
            }
          };

          function wheeled(event) {
            for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key10 = 1; _key10 < _len7; _key10++) {
              args[_key10 - 1] = arguments[_key10];
            }

            if (!filter.apply(this, arguments)) return;
            var g = gesture(this, args).event(event),
                t = this.__zoom,
                k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))),
                p = pointer(event); // If the mouse is in the same location as before, reuse it.
            // If there were recent wheel events, reset the wheel idle timeout.

            if (g.wheel) {
              if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
                g.mouse[1] = t.invert(g.mouse[0] = p);
              }

              clearTimeout(g.wheel);
            } // If this wheel event won’t trigger a transform change, ignore it.
            else if (t.k === k) return; // Otherwise, capture the mouse point and location at the start.
            else {
              g.mouse = [p, t.invert(p)];
              interrupt(this);
              g.start();
            }

            noevent(event);
            g.wheel = setTimeout(wheelidled, wheelDelay);
            g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));

            function wheelidled() {
              g.wheel = null;
              g.end();
            }
          }

          function mousedowned(event) {
            for (var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key11 = 1; _key11 < _len8; _key11++) {
              args[_key11 - 1] = arguments[_key11];
            }

            if (touchending || !filter.apply(this, arguments)) return;
            var g = gesture(this, args, true).event(event),
                v = select(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
                p = pointer(event, currentTarget),
                currentTarget = event.currentTarget,
                x0 = event.clientX,
                y0 = event.clientY;
            dragDisable(event.view);
            nopropagation(event);
            g.mouse = [p, this.__zoom.invert(p)];
            interrupt(this);
            g.start();

            function mousemoved(event) {
              noevent(event);

              if (!g.moved) {
                var dx = event.clientX - x0,
                    dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
              }

              g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = pointer(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
            }

            function mouseupped(event) {
              v.on("mousemove.zoom mouseup.zoom", null);
              dragEnable(event.view, g.moved);
              noevent(event);
              g.event(event).end();
            }
          }

          function dblclicked(event) {
            for (var _len9 = arguments.length, args = new Array(_len9 > 1 ? _len9 - 1 : 0), _key12 = 1; _key12 < _len9; _key12++) {
              args[_key12 - 1] = arguments[_key12];
            }

            if (!filter.apply(this, arguments)) return;
            var t0 = this.__zoom,
                p0 = pointer(event.changedTouches ? event.changedTouches[0] : event, this),
                p1 = t0.invert(p0),
                k1 = t0.k * (event.shiftKey ? 0.5 : 2),
                t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
            noevent(event);
            if (duration > 0) select(this).transition().duration(duration).call(schedule, t1, p0, event);else select(this).call(zoom.transform, t1, p0, event);
          }

          function touchstarted(event) {
            for (var _len10 = arguments.length, args = new Array(_len10 > 1 ? _len10 - 1 : 0), _key13 = 1; _key13 < _len10; _key13++) {
              args[_key13 - 1] = arguments[_key13];
            }

            if (!filter.apply(this, arguments)) return;
            var touches = event.touches,
                n = touches.length,
                g = gesture(this, args, event.changedTouches.length === n).event(event),
                started,
                i,
                t,
                p;
            nopropagation(event);

            for (i = 0; i < n; ++i) {
              t = touches[i], p = pointer(t, this);
              p = [p, this.__zoom.invert(p), t.identifier];
              if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
            }

            if (touchstarting) touchstarting = clearTimeout(touchstarting);

            if (started) {
              if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function () {
                touchstarting = null;
              }, touchDelay);
              interrupt(this);
              g.start();
            }
          }

          function touchmoved(event) {
            if (!this.__zooming) return;

            for (var _len11 = arguments.length, args = new Array(_len11 > 1 ? _len11 - 1 : 0), _key14 = 1; _key14 < _len11; _key14++) {
              args[_key14 - 1] = arguments[_key14];
            }

            var g = gesture(this, args).event(event),
                touches = event.changedTouches,
                n = touches.length,
                i,
                t,
                p,
                l;
            noevent(event);

            for (i = 0; i < n; ++i) {
              t = touches[i], p = pointer(t, this);
              if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
            }

            t = g.that.__zoom;

            if (g.touch1) {
              var p0 = g.touch0[0],
                  l0 = g.touch0[1],
                  p1 = g.touch1[0],
                  l1 = g.touch1[1],
                  dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
                  dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
              t = scale(t, Math.sqrt(dp / dl));
              p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
              l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
            } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];else return;

            g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
          }

          function touchended(event) {
            for (var _len12 = arguments.length, args = new Array(_len12 > 1 ? _len12 - 1 : 0), _key15 = 1; _key15 < _len12; _key15++) {
              args[_key15 - 1] = arguments[_key15];
            }

            if (!this.__zooming) return;
            var g = gesture(this, args).event(event),
                touches = event.changedTouches,
                n = touches.length,
                i,
                t;
            nopropagation(event);
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function () {
              touchending = null;
            }, touchDelay);

            for (i = 0; i < n; ++i) {
              t = touches[i];
              if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
            }

            if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
            if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);else {
              g.end(); // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.

              if (g.taps === 2) {
                t = pointer(t, this);

                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                  var p = select(this).on("dblclick.zoom");
                  if (p) p.apply(this, arguments);
                }
              }
            }
          }

          zoom.wheelDelta = function (_) {
            return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : constant(+_), zoom) : wheelDelta;
          };

          zoom.filter = function (_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : constant(!!_), zoom) : filter;
          };

          zoom.touchable = function (_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : constant(!!_), zoom) : touchable;
          };

          zoom.extent = function (_) {
            return arguments.length ? (extent = typeof _ === "function" ? _ : constant([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
          };

          zoom.scaleExtent = function (_) {
            return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [scaleExtent[0], scaleExtent[1]];
          };

          zoom.translateExtent = function (_) {
            return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [[translateExtent[0][0], translateExtent[0][1]], [translateExtent[1][0], translateExtent[1][1]]];
          };

          zoom.constrain = function (_) {
            return arguments.length ? (constrain = _, zoom) : constrain;
          };

          zoom.duration = function (_) {
            return arguments.length ? (duration = +_, zoom) : duration;
          };

          zoom.interpolate = function (_) {
            return arguments.length ? (interpolate = _, zoom) : interpolate;
          };

          zoom.on = function () {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? zoom : value;
          };

          zoom.clickDistance = function (_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
          };

          zoom.tapDistance = function (_) {
            return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
          };

          return zoom;
        }

        ; // CONCATENATED MODULE: ./node_modules/d3-zoom/src/index.js

        ; // CONCATENATED MODULE: ./node_modules/d3/index.js
        // EXTERNAL MODULE: ./node_modules/lodash/lodash.js

        var lodash = __webpack_require__(6486); // EXTERNAL MODULE: ./node_modules/moment/moment.js


        var moment = __webpack_require__(381);

        var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

        ; // CONCATENATED MODULE: ./src/util/formatNumber.js

        function formatNumber(num) {
          // num = num.toFixed(2)
          // return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
          return num;
        } // EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js


        var injectStylesIntoStyleTag = __webpack_require__(3379);

        var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag); // EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./src/style.scss


        var cjs_ruleSet_1_rules_1_use_2_src_style = __webpack_require__(539);

        ; // CONCATENATED MODULE: ./src/style.scss

        var options = {};
        options.insert = "head";
        options.singleton = false;
        var update = injectStylesIntoStyleTag_default()(cjs_ruleSet_1_rules_1_use_2_src_style
        /* default */
        .Z, options);
        /* harmony default export */

        var src_style = cjs_ruleSet_1_rules_1_use_2_src_style
        /* default.locals */
        .Z.locals || {};
        ; // CONCATENATED MODULE: ./src/index.js

        function _typeof(obj) {
          "@babel/helpers - typeof";

          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function _typeof(obj) {
              return typeof obj;
            };
          } else {
            _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
          }

          return _typeof(obj);
        }

        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }

          return obj;
        }

        function _timeChart(selector, dataSource, displayedData, options) {
          dataSource = lodash.cloneDeep(dataSource);
          var margin = {
            top: 10,
            right: 50,
            bottom: 40,
            left: 100
          },
              width = src_select(selector).node().getBoundingClientRect().width - margin.left - margin.right,
              height = src_select(selector).node().getBoundingClientRect().height - margin.top - margin.bottom;
          var data = dataSource.values;
          var pathToDate = options.x.field;
          var pathToYField = options.y.field;
          data.forEach(function (d) {
            d.date = new Date(moment_default()(lodash.get(d, pathToDate)));
            lodash.set(d, pathToYField, Number(lodash.get(d, pathToYField)));
          });
          var dt = {
            ms: (data[data.length - 1].date - data[0].date) / (data.length > 2 ? data.length - 2 : data.length),
            s: (data[data.length - 1].date - data[0].date) / (data.length > 2 ? data.length - 2 : data.length) / 1000,
            min: (data[data.length - 1].date - data[0].date) / (data.length > 2 ? data.length - 2 : data.length) / (1000 * 60),
            h: (data[data.length - 1].date - data[0].date) / (data.length > 2 ? data.length - 2 : data.length) / (1000 * 60 * 60),
            d: (data[data.length - 1].date - data[0].date) / (data.length > 2 ? data.length - 2 : data.length) / (1000 * 60 * 60 * 24),
            m: (data[data.length - 1].date - data[0].date) / (data.length > 2 ? data.length - 2 : data.length) / (1000 * 60 * 60 * 24 * 30),
            y: (data[data.length - 1].date - data[0].date) / (data.length > 2 ? data.length - 2 : data.length) / (1000 * 60 * 60 * 24 * 365)
          };
          var tickByNumber = dt.s < 1 ? 0 : dt.min < 1 ? 1 : dt.hour < 1 ? 2 : dt.d < 1 ? 3 : dt.m < 1 ? 4 : dt.y < 1 ? 5 : 6;
          var tickBy = [src_millisecond, src_second, src_minute, src_hour, src_day, src_month, src_year];
          src_select(selector).html('');

          switch (options.chartType) {
            case 'Bar':
              bar();
              break;

            case 'Line':
              line();
              break;

            case 'Scatter':
              scatter();
              break;

            case 'Stacked Bar':
              stackedBar();
              break;

            default:
              break;
          }

          function bar() {
            var svg = src_select(selector).append('svg').attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
            var x = band().domain(data.map(function (d) {
              return d.date;
            })).range([0, width]).paddingInner(0.1);
            var y = linear_linear().domain([0, max_max(data, function (d) {
              return lodash.get(d, pathToYField);
            })]).range([height, 0]).nice();
            var xAxis = axisBottom(x).tickSize(-height).tickValues(data.map(function (d, i) {
              return i % (Math.round(data.length / 5) + 1) == 0 ? d.date : null;
            }).filter(function (d) {
              return !!d;
            })).tickFormat(function (date) {
              return tickByNumber == 6 ? timeFormat('%Y')(date) : tickByNumber == 5 ? timeFormat('%m/%y')(date) : tickByNumber == 4 ? timeFormat('%d/%m/%y')(date) : tickByNumber == 3 ? timeFormat('%H %d%/%m/%y')(date) : tickByNumber == 2 ? timeFormat('%H:%M %d%/%m/%y')(date) : timeFormat('%H:%M:%S %d%/%m/%y')(date);
            });
            var yAxis = axisLeft(y).tickSize(-width);
            var xAxisGrid = svg.append('g').call(xAxis).attr('transform', 'translate(0,' + height + ')');
            xAxisGrid.selectAll('.tick text').attr('transform', 'translate(0, 5)');
            var yAxisGrid = svg.append('g').call(yAxis);
            yAxisGrid.selectAll('line').attr('class', 'y-axis-grid');
            var clip = svg.append('defs').append('svg:clipPath').attr('id', 'clip').append('svg:rect').attr('width', width).attr('height', height).attr('x', 0).attr('y', 0);
            var brush = brushX().extent([[0, 0], [width, height]]).on('end', updateChart);
            svg.append('g').attr('class', 'brush').call(brush);
            var bars = svg.append('g').attr('clip-path', 'url(#clip)').attr('class', 'bars');
            bars.selectAll('rect').data(data).enter().append('rect').attr('x', function (d) {
              return x(d.date);
            }).attr('width', x.bandwidth()).attr('y', function (d) {
              return y(lodash.get(d, pathToYField));
            }).attr('height', function (d) {
              return height - y(lodash.get(d, pathToYField));
            }).attr('class', 'bar').attr('fill', '#28a745').on('mouseover', mouseover).on('mousemove', mousemove).on('mouseout', mouseout);
            svg.append('text').attr('transform', 'translate(' + width / 2 + ' ,' + (height + margin.top + 20) + ')').style('text-anchor', 'middle').style('font-size', '12').attr('font-family', 'Nunito, Arial, sans-serif').text(pathToDate);
            svg.append('text').attr('transform', 'rotate(-90)').attr('y', 0 - margin.left).attr('x', 0 - height / 2).attr('dy', '1em').style('text-anchor', 'middle').attr('font-family', 'Nunito, Arial, sans-serif').style('font-size', '12').text(pathToYField);
            var tooltip = src_select('body').append('div').attr('class', 'tooltip').style('display', 'none');

            function mouseover() {
              src_select(this).attr('stroke', 'black').attr('stroke-width', 0.6);
              tooltip.style('display', null).style('visibility', 'visible');
            }

            function mousemove(e, d) {
              tooltip.html("<ul>\n\t\t\t\t\t\t<li>Date: ".concat(tickByNumber == 6 ? timeFormat('%Y')(d.date) : tickByNumber == 5 ? timeFormat('%m/%y')(d.date) : tickByNumber == 4 ? timeFormat('%d/%m/%y')(d.date) : tickByNumber == 3 ? timeFormat('%H %d%/%m/%y')(d.date) : tickByNumber == 2 ? timeFormat('%H:%M %d%/%m/%y')(d.date) : timeFormat('%H:%M:%S %d%/%m/%y')(d.date), "</li>\n\t\t\t\t\t\t<li>").concat(pathToYField, ": ").concat(formatNumber(lodash.get(d, pathToYField)), "</li>\n\t\t\t\t\t</ul>"));
              var bodyWidth = src_select('body').style('width').slice(0, -2);
              var tooltipheight = e.pageY - tooltip.style('height').slice(0, -2) - 10;
              var tooltipWidth = tooltip.style('width').slice(0, -2);
              var tooltipX = e.pageX < tooltipWidth / 2 ? 0 : e.pageX + tooltipWidth / 2 > bodyWidth ? bodyWidth - tooltipWidth : e.pageX - tooltipWidth / 2;
              tooltip.style('top', tooltipheight + 'px').style('left', tooltipX + 'px');
            }

            function mouseout() {
              tooltip.style('display', 'none').style('visibility', null);
              src_select(this).attr('stroke', 'none');
            }

            function updateChart(event) {
              var extent = event.selection;
              var idleTimeout;

              function idled() {
                idleTimeout = null;
              }

              var newData;

              if (!extent) {
                if (!idleTimeout) return idleTimeout = setTimeout(idled, 350);
                x.domain([4, 8]);
              } else {
                svg.select('.brush').call(brush.move, null);
                newData = data.map(function (d, i) {
                  var pos = x(d.date);

                  if (pos > extent[0] && pos < extent[1]) {
                    return d;
                  } else {
                    return null;
                  }
                }).filter(function (d) {
                  return !!d;
                });
                x.domain(newData.map(function (d) {
                  return d.date;
                }));
              }

              y.domain([0, max_max(newData, function (d) {
                return lodash.get(d, pathToYField);
              })]).nice();
              xAxis.tickValues(newData.map(function (d, i) {
                return i % (Math.round(newData.length / 5) + 1) == 0 || i == newData.length - 1 ? d.date : null;
              }).filter(function (d) {
                return !!d;
              }));
              xAxisGrid.transition().duration(1000).call(xAxis);
              xAxisGrid.selectAll('.tick text').attr('transform', 'translate(0, 5)');
              yAxisGrid.transition().duration(1000).call(yAxis);
              bars.selectAll('rect').style('display', function (d) {
                var max = max_max(x.domain());
                var min = min_min(x.domain());

                if (d.date >= min && d.date <= max) {
                  return null;
                } else {
                  return 'none';
                }
              });
              bars.selectAll('rect').transition().duration(1000).attr('x', function (d) {
                return x(d.date);
              }).attr('width', function (d) {
                return x.bandwidth();
              }).attr('y', function (d) {
                return y(lodash.get(d, pathToYField));
              }).attr('height', function (d) {
                return height - y(lodash.get(d, pathToYField));
              });
            }

            svg.on('dblclick', function () {
              x.domain(data.map(function (d) {
                return d.date;
              }));
              y.domain([0, max_max(data, function (d) {
                return lodash.get(d, pathToYField);
              })]).nice();
              xAxis.tickValues(data.map(function (d, i) {
                return i % (Math.round(data.length / 5) + 1) == 0 || i == data.length - 1 ? d.date : null;
              }).filter(function (d) {
                return !!d;
              }));
              xAxisGrid.transition().call(xAxis);
              xAxisGrid.selectAll('.tick text').attr('transform', 'translate(0, 5)');
              yAxisGrid.transition().call(yAxis);
              bars.selectAll('rect').transition().style('display', null).attr('x', function (d) {
                return x(d.date);
              }).attr('width', function (d) {
                return x.bandwidth();
              }).attr('y', function (d) {
                return y(lodash.get(d, pathToYField));
              }).attr('height', function (d) {
                return height - y(lodash.get(d, pathToYField));
              });
            });
          }

          function line() {
            var svg = src_select(selector).append('svg').attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
            var x = time().domain(extent(data, function (d) {
              return d.date;
            })).range([0, width]).nice(tickBy[tickByNumber]);
            var y = linear_linear().domain([0, max_max(data, function (d) {
              return lodash.get(d, pathToYField);
            })]).range([height, 0]).nice();
            var xAxis = axisBottom(x).tickSize(-height).ticks(5).tickFormat(function (date) {
              return tickByNumber == 6 ? timeFormat('%Y')(date) : tickByNumber == 5 ? timeFormat('%m/%y')(date) : tickByNumber == 4 ? timeFormat('%d/%m/%y')(date) : tickByNumber == 3 ? timeFormat('%H %d%/%m/%y')(date) : tickByNumber == 2 ? timeFormat('%H:%M %d%/%m/%y')(date) : timeFormat('%H:%M:%S %d%/%m/%y')(date);
            });
            var yAxis = axisLeft(y).tickSize(-width);
            var xAxisGrid = svg.append('g').call(xAxis).attr('transform', 'translate(0,' + height + ')');
            xAxisGrid.selectAll('.tick text').attr('transform', 'translate(0, 5)');
            var yAxisGrid = svg.append('g').call(yAxis);
            yAxisGrid.selectAll('line').attr('class', 'y-axis-grid');
            var clip = svg.append('defs').append('svg:clipPath').attr('id', 'clip').append('svg:rect').attr('width', width).attr('height', height).attr('x', 0).attr('y', 0);
            var brush = brushX().extent([[0, 0], [width, height]]).on('end', updateChart);
            svg.append('g').attr('class', 'brush').call(brush);
            var line = svg.append('g').attr('clip-path', 'url(#clip)');
            line.append('path').datum(data).attr('class', 'line').attr('fill', 'none').attr('stroke', '#28a745').attr('stroke-width', 1.5).attr('d', src_line().x(function (d) {
              return x(d.date);
            }).y(function (d) {
              return y(lodash.get(d, pathToYField));
            }));
            svg.append('text').attr('transform', 'translate(' + width / 2 + ' ,' + (height + margin.top + 20) + ')').style('text-anchor', 'middle').attr('font-family', 'Nunito, Arial, sans-serif').style('font-size', '12').text(pathToDate);
            svg.append('text').attr('transform', 'rotate(-90)').attr('y', 0 - margin.left).attr('x', 0 - height / 2).attr('dy', '1em').style('text-anchor', 'middle').attr('font-family', 'Nunito, Arial, sans-serif').style('font-size', '12').text(pathToYField);
            var tooltip = src_select('body').append('div').attr('class', 'tooltip').style('display', 'none');
            var bisectDate = bisector(function (d) {
              return d.date;
            }).left;
            var focus = svg.append('g').attr('class', 'focus').style('display', 'none');
            focus.append('circle').attr('r', 3);
            svg.on('mouseover', mouseover).on('mouseout', mouseout).on('mousemove', mousemove);

            function mouseover() {
              focus.style('display', null);
              tooltip.style('display', null).style('visibility', 'visible');
            }

            function mouseout() {
              focus.style('display', 'none');
              tooltip.style('display', 'none').style('visibility', null);
            }

            function mousemove(e) {
              var x0 = x.invert(src_pointer(e)[0]),
                  i = bisectDate(data, x0, 1),
                  d0 = data[i - 1],
                  d1 = data[i] || d0,
                  d = x0 - d0.date > d1.date - x0 ? d1 : d0;
              focus.attr('transform', 'translate(' + x(d.date) + ',' + y(lodash.get(d, pathToYField)) + ')');
              var tooltipheight = tooltip.style('height').slice(0, -2);
              var tooltipWidth = tooltip.style('width').slice(0, -2);
              tooltip.style('left', src_select(selector).node().getBoundingClientRect().x + x(d.date) + 10 + 'px').style('top', src_select(selector).node().getBoundingClientRect().y + y(lodash.get(d, pathToYField)) - tooltipheight - 5 + 'px');
              tooltip.html("<ul>\n\t\t\t\t\t<li>Date: ".concat(tickByNumber == 6 ? timeFormat('%Y')(d.date) : tickByNumber == 5 ? timeFormat('%m/%y')(d.date) : tickByNumber == 4 ? timeFormat('%d/%m/%y')(d.date) : tickByNumber == 3 ? timeFormat('%H %d%/%m/%y')(d.date) : tickByNumber == 2 ? timeFormat('%H:%M %d%/%m/%y')(d.date) : timeFormat('%H:%M:%S %d%/%m/%y')(d.date), "</li>\n\t\t\t\t\t<li>").concat(pathToYField, ": ").concat(formatNumber(lodash.get(d, pathToYField)), "</li>\n\t\t\t\t</ul>"));
            }

            function updateChart(event) {
              var extent = event.selection;
              var idleTimeout;

              function idled() {
                idleTimeout = null;
              }

              if (!extent) {
                if (!idleTimeout) return idleTimeout = setTimeout(idled, 350);
                x.domain([4, 8]);
              } else {
                svg.select('.brush').call(brush.move, null);
                x.domain([x.invert(extent[0]), x.invert(extent[1])]).nice(tickBy[tickByNumber]);
              }

              y.domain([0, max_max(data.map(function (d) {
                var domain = x.domain();

                if (d.date >= domain[0] && d.date <= domain[1]) {
                  return lodash.get(d, pathToYField);
                } else {
                  return 0;
                }
              }))]).nice();
              xAxisGrid.transition().duration(1000).call(xAxis);
              yAxisGrid.transition().duration(1000).call(yAxis);
              line.select('.line').transition().duration(1000).attr('d', src_line().x(function (d) {
                return x(d.date);
              }).y(function (d) {
                return y(lodash.get(d, pathToYField));
              }));
            }

            svg.on('dblclick', function () {
              x.domain(extent(data, function (d) {
                return d.date;
              })).nice(tickBy[tickByNumber]);
              y.domain([0, max_max(data.map(function (d) {
                var domain = x.domain();

                if (d.date >= domain[0] && d.date <= domain[1]) {
                  return lodash.get(d, pathToYField);
                } else {
                  return 0;
                }
              }))]).nice();
              xAxisGrid.transition().call(xAxis);
              yAxisGrid.transition().call(yAxis);
              line.select('.line').transition().attr('d', src_line().x(function (d) {
                return x(d.date);
              }).y(function (d) {
                return y(lodash.get(d, pathToYField));
              }));
            });
          }

          function scatter() {
            var svg = src_select(selector).append('svg').attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
            var x = time().domain(extent(data, function (d) {
              return d.date;
            })).range([0, width]).nice(tickBy[tickByNumber]);
            var y = linear_linear().domain([0, max_max(data, function (d) {
              return lodash.get(d, pathToYField);
            })]).range([height, 0]).nice();
            var xAxis = axisBottom(x).tickSize(-height).ticks(5).tickFormat(function (date) {
              return tickByNumber == 6 ? timeFormat('%Y')(date) : tickByNumber == 5 ? timeFormat('%m/%y')(date) : tickByNumber == 4 ? timeFormat('%d/%m/%y')(date) : tickByNumber == 3 ? timeFormat('%H %d%/%m/%y')(date) : tickByNumber == 2 ? timeFormat('%H:%M %d%/%m/%y')(date) : timeFormat('%H:%M:%S %d%/%m/%y')(date);
            });
            var yAxis = axisLeft(y).tickSize(-width);
            var xAxisGrid = svg.append('g').call(xAxis).attr('transform', 'translate(0,' + height + ')');
            xAxisGrid.selectAll('.tick text').attr('transform', 'translate(0, 5)');
            var yAxisGrid = svg.append('g').call(yAxis);
            yAxisGrid.selectAll('line').attr('class', 'y-axis-grid');
            var clip = svg.append('defs').append('svg:clipPath').attr('id', 'clip').append('svg:rect').attr('width', width).attr('height', height).attr('x', 0).attr('y', 0);
            var brush = brushX().extent([[0, 0], [width, height]]).on('end', updateChart);
            svg.append('g').attr('class', 'brush').call(brush);
            var circles = svg.append('g').attr('clip-path', 'url(#clip)').attr('class', 'circles');
            circles.selectAll('circle').data(data).enter().append('circle').attr('cx', function (d) {
              return x(d.date);
            }).attr('cy', function (d) {
              return y(lodash.get(d, pathToYField));
            }).attr('r', function (d) {
              return 4;
            }).attr('class', 'circle').attr('fill', '#28a745').on('mouseover', mouseover).on('mousemove', mousemove).on('mouseout', mouseout);
            svg.append('text').attr('transform', 'translate(' + width / 2 + ' ,' + (height + margin.top + 20) + ')').style('text-anchor', 'middle').attr('font-family', 'Nunito, Arial, sans-serif').style('font-size', '12').text(pathToDate);
            svg.append('text').attr('transform', 'rotate(-90)').attr('y', 0 - margin.left).attr('x', 0 - height / 2).attr('dy', '1em').style('text-anchor', 'middle').attr('font-family', 'Nunito, Arial, sans-serif').style('font-size', '12').text(pathToYField);
            var tooltip = src_select('body').append('div').attr('class', 'tooltip').style('display', 'none');

            function mouseover() {
              src_select(this).attr('stroke', 'black').attr('stroke-width', 0.6);
              tooltip.style('display', null).style('visibility', 'visible');
            }

            function mousemove(e, d) {
              tooltip.html("<ul>\n\t\t\t\t\t<li>Date: ".concat(tickByNumber == 6 ? timeFormat('%Y')(d.date) : tickByNumber == 5 ? timeFormat('%m/%y')(d.date) : tickByNumber == 4 ? timeFormat('%d/%m/%y')(d.date) : tickByNumber == 3 ? timeFormat('%H %d%/%m/%y')(d.date) : tickByNumber == 2 ? timeFormat('%H:%M %d%/%m/%y')(d.date) : timeFormat('%H:%M:%S %d%/%m/%y')(d.date), "</li>\n\t\t\t\t\t\t<li>").concat(pathToYField, ": ").concat(formatNumber(lodash.get(d, pathToYField)), "</li>\n\t\t\t\t\t</ul>"));
              var bodyWidth = src_select('body').style('width').slice(0, -2);
              var tooltipheight = e.pageY - tooltip.style('height').slice(0, -2) - 10;
              var tooltipWidth = tooltip.style('width').slice(0, -2);
              var tooltipX = e.pageX < tooltipWidth / 2 ? 0 : e.pageX + tooltipWidth / 2 > bodyWidth ? bodyWidth - tooltipWidth : e.pageX - tooltipWidth / 2;
              tooltip.style('top', tooltipheight + 'px').style('left', tooltipX + 'px');
            }

            function mouseout() {
              tooltip.style('display', 'none').style('visibility', null);
              src_select(this).attr('stroke', 'none');
            }

            function updateChart(event) {
              var extent = event.selection;
              var idleTimeout;

              function idled() {
                idleTimeout = null;
              }

              if (!extent) {
                if (!idleTimeout) return idleTimeout = setTimeout(idled, 350);
                x.domain([4, 8]);
              } else {
                svg.select('.brush').call(brush.move, null);
                x.domain([x.invert(extent[0]), x.invert(extent[1])]).nice(tickBy[tickByNumber]);
              }

              y.domain([0, max_max(data.map(function (d) {
                var domain = x.domain();

                if (d.date >= domain[0] && d.date <= domain[1]) {
                  return lodash.get(d, pathToYField);
                } else {
                  return 0;
                }
              }))]).nice();
              xAxisGrid.transition().duration(1000).call(xAxis);
              yAxisGrid.transition().duration(1000).call(yAxis);
              circles.selectAll('.circle').transition().duration(1000).attr('cx', function (d) {
                return x(d.date);
              }).attr('cy', function (d) {
                return y(lodash.get(d, pathToYField));
              }).attr('r', function (d) {
                return 4;
              });
            }

            svg.on('dblclick', function () {
              x.domain(extent(data, function (d) {
                return d.date;
              })).nice(tickBy[tickByNumber]);
              y.domain([0, max_max(data.map(function (d) {
                var domain = x.domain();

                if (d.date >= domain[0] && d.date <= domain[1]) {
                  return lodash.get(d, pathToYField);
                } else {
                  return 0;
                }
              }))]).nice();
              xAxisGrid.transition().call(xAxis);
              yAxisGrid.transition().call(yAxis);
              circles.selectAll('.circle').transition().attr('cx', function (d) {
                return x(d.date);
              }).attr('cy', function (d) {
                return y(lodash.get(d, pathToYField));
              }).attr('r', function (d) {
                return 4;
              });
            });
          }

          function stackedBar() {
            var pathToSubgroupField = options.subgroupField;
            var subgroups = lodash.uniq(data.map(function (d) {
              return lodash.get(d, pathToSubgroupField);
            }));
            var wide = Array.from(group(data, function (d) {
              return d.date;
            })).map(function (d) {
              var newVal = {
                date: d[0]
              };
              d[1].forEach(function (d) {
                Object.assign(newVal, _defineProperty({}, lodash.get(d, pathToSubgroupField), lodash.get(d, pathToYField)));
              });
              subgroups.forEach(function (name) {
                if (!(name in newVal)) {
                  Object.assign(newVal, _defineProperty({}, name, 0));
                }
              });
              return newVal;
            });
            dt = {
              ms: (wide[wide.length - 1].date - wide[0].date) / (wide.length > 2 ? wide.length - 2 : wide.length),
              s: (wide[wide.length - 1].date - wide[0].date) / (wide.length > 2 ? wide.length - 2 : wide.length) / 1000,
              min: (wide[wide.length - 1].date - wide[0].date) / (wide.length > 2 ? wide.length - 2 : wide.length) / (1000 * 60),
              h: (wide[wide.length - 1].date - wide[0].date) / (wide.length > 2 ? wide.length - 2 : wide.length) / (1000 * 60 * 60),
              d: (wide[wide.length - 1].date - wide[0].date) / (wide.length > 2 ? wide.length - 2 : wide.length) / (1000 * 60 * 60 * 24),
              m: (wide[wide.length - 1].date - wide[0].date) / (wide.length > 2 ? wide.length - 2 : wide.length) / (1000 * 60 * 60 * 24 * 30),
              y: (wide[wide.length - 1].date - wide[0].date) / (wide.length > 2 ? wide.length - 2 : wide.length) / (1000 * 60 * 60 * 24 * 365)
            };
            tickByNumber = dt.s < 1 ? 0 : dt.min < 1 ? 1 : dt.hour < 1 ? 2 : dt.d < 1 ? 3 : dt.m < 1 ? 4 : dt.y < 1 ? 5 : 6;
            var groups = wide.map(function (d) {
              return d.date;
            });
            var color = ordinal(category10);
            var stackedData = stack().keys(subgroups)(wide);
            stackedData.forEach(function (layer) {
              layer.forEach(function (a) {
                a.key = layer.key;
              });
            });
            var yMax = max_max(wide.map(function (d) {
              var acc = 0;

              for (var k in d) {
                if (_typeof(d[k]) !== 'object') {
                  acc += d[k];
                }
              }

              return acc;
            }));
            var svg = src_select(selector).append('svg').attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
            var x = band().domain(wide.map(function (d) {
              return d.date;
            })).range([0, width]).paddingInner(0.1);
            var y = linear_linear().domain([0, max_max(wide.map(function (d) {
              var acc = 0;

              for (var k in d) {
                if (_typeof(d[k]) !== 'object') {
                  acc += d[k];
                }
              }

              return acc;
            }))]).range([height, 0]).nice();
            var xAxis = axisBottom(x).tickSize(-height).tickValues(wide.map(function (d, i) {
              return i % (Math.round(wide.length / 5) + 1) == 0 ? d.date : null;
            }).filter(function (d) {
              return !!d;
            })).tickFormat(function (date) {
              return tickByNumber == 6 ? timeFormat('%Y')(date) : tickByNumber == 5 ? timeFormat('%m/%y')(date) : tickByNumber == 4 ? timeFormat('%d/%m/%y')(date) : tickByNumber == 3 ? timeFormat('%H %d%/%m/%y')(date) : tickByNumber == 2 ? timeFormat('%H:%M %d%/%m/%y')(date) : timeFormat('%H:%M:%S %d%/%m/%y')(date);
            });
            var yAxis = axisLeft(y).tickSize(-width);
            var xAxisGrid = svg.append('g').call(xAxis).attr('transform', 'translate(0,' + height + ')');
            xAxisGrid.selectAll('.tick text').attr('transform', 'translate(0, 5)');
            var yAxisGrid = svg.append('g').call(yAxis);
            yAxisGrid.selectAll('line').attr('class', 'y-axis-grid');
            var clip = svg.append('defs').append('svg:clipPath').attr('id', 'clip').append('svg:rect').attr('width', width).attr('height', height).attr('x', 0).attr('y', 0);
            var brush = brushX().extent([[0, 0], [width, height]]).on('end', updateChart);
            svg.append('g').attr('class', 'brush').call(brush);
            var barsLayers = svg.append('g').attr('clip-path', 'url(#clip)').attr('class', 'bars');
            var bars = barsLayers.selectAll('g').data(stackedData).join('g').attr('fill', function (d) {
              return color(d.key);
            });
            bars.selectAll('rect').data(function (d) {
              return d;
            }).enter().append('rect').attr('x', function (d) {
              return x(d.data.date);
            }).attr('width', x.bandwidth()).attr('y', function (d) {
              return y(d[1]);
            }).attr('height', function (d) {
              return y(d[0]) - y(d[1]);
            }).attr('class', 'bar').attr('pointer-events', 'all').on('mouseover', mouseover).on('mousemove', mousemove).on('mouseout', mouseout);
            svg.append('text').attr('transform', 'translate(' + width / 2 + ' ,' + (height + margin.top + 20) + ')').style('text-anchor', 'middle').attr('font-family', 'Nunito, Arial, sans-serif').style('font-size', '12').text(pathToDate);
            svg.append('text').attr('transform', 'rotate(-90)').attr('y', 0 - margin.left).attr('x', 0 - height / 2).attr('dy', '1em').style('text-anchor', 'middle').attr('font-family', 'Nunito, Arial, sans-serif').style('font-size', '12').text(pathToYField);
            var tooltip = src_select('body').append('div').attr('class', 'tooltip').style('display', 'none');

            function mouseover() {
              src_select(this).attr('stroke', 'black').attr('stroke-width', 0.6);
              tooltip.style('display', null).style('visibility', 'visible');
            }

            function mousemove(e, d) {
              tooltip.html("<ul>\n\t\t\t\t\t<li>Date: ".concat(tickByNumber == 6 ? timeFormat('%Y')(d.data.date) : tickByNumber == 5 ? timeFormat('%m/%y')(d.data.date) : tickByNumber == 4 ? timeFormat('%d/%m/%y')(d.data.date) : tickByNumber == 3 ? timeFormat('%H %d%/%m/%y')(d.data.date) : tickByNumber == 2 ? timeFormat('%H:%M %d%/%m/%y')(d.data.date) : timeFormat('%H:%M:%S %d%/%m/%y')(d.data.date), "</li>\n\t\t\t\t\t\t").concat(d.key ? "<li>Subgroup: ".concat(d.key && d.key.replace(/</g, '&lt;').replace(/>/g, '&gt;'), "</li>") : '', "\n\t\t\t\t\t\t<li>").concat(pathToYField, ": ").concat(formatNumber(d[1] - d[0]), "</li>\n\t\t\t\t\t</ul>"));
              var bodyWidth = src_select('body').style('width').slice(0, -2);
              var tooltipheight = e.pageY - tooltip.style('height').slice(0, -2) - 10;
              var tooltipWidth = tooltip.style('width').slice(0, -2);
              var tooltipX = e.pageX < tooltipWidth / 2 ? 0 : e.pageX + tooltipWidth / 2 > bodyWidth ? bodyWidth - tooltipWidth : e.pageX - tooltipWidth / 2;
              tooltip.style('top', tooltipheight + 'px').style('left', tooltipX + 'px');
            }

            function mouseout() {
              tooltip.style('display', 'none').style('visibility', null);
              src_select(this).attr('stroke', 'none');
            }

            function updateChart(event) {
              var extent = event.selection;
              var idleTimeout;

              function idled() {
                idleTimeout = null;
              }

              var newData;

              if (!extent) {
                if (!idleTimeout) return idleTimeout = setTimeout(idled, 350);
                x.domain([4, 8]);
              } else {
                svg.select('.brush').call(brush.move, null);
                newData = wide.map(function (d, i) {
                  var pos = x(d.date);

                  if (pos > extent[0] && pos < extent[1]) {
                    return d;
                  } else {
                    return null;
                  }
                }).filter(function (d) {
                  return !!d;
                });
                x.domain(newData.map(function (d) {
                  return d.date;
                }));
              }

              y.domain([0, max_max(newData.map(function (d) {
                var acc = 0;

                for (var k in d) {
                  if (_typeof(d[k]) !== 'object') {
                    acc += d[k];
                  }
                }

                return acc;
              }))]).nice();
              xAxis.tickValues(newData.map(function (d, i) {
                return i % (Math.round(newData.length / 5) + 1) == 0 || i == newData.length - 1 ? d.date : null;
              }).filter(function (d) {
                return !!d;
              }));
              xAxisGrid.transition().duration(1000).call(xAxis);
              xAxisGrid.selectAll('.tick text').attr('transform', 'translate(0, 5)');
              yAxisGrid.transition().duration(1000).call(yAxis);
              bars.selectAll('rect').style('display', function (d) {
                var max = max_max(x.domain());
                var min = min_min(x.domain());

                if (d.data.date >= min && d.data.date <= max) {
                  return null;
                } else {
                  return 'none';
                }
              });
              bars.selectAll('rect').transition().duration(1000).attr('x', function (d) {
                return x(d.data.date);
              }).attr('width', x.bandwidth()).attr('y', function (d) {
                return y(d[1]);
              }).attr('height', function (d) {
                return y(d[0]) - y(d[1]);
              });
            }

            svg.on('dblclick', function () {
              x.domain(wide.map(function (d) {
                return d.date;
              }));
              y.domain([0, max_max(wide.map(function (d) {
                var acc = 0;

                for (var k in d) {
                  if (_typeof(d[k]) !== 'object') {
                    acc += d[k];
                  }
                }

                return acc;
              }))]).nice();
              xAxis.tickValues(wide.map(function (d, i) {
                return i % (Math.round(wide.length / 5) + 1) == 0 ? d.date : null;
              }).filter(function (d) {
                return !!d;
              }));
              xAxisGrid.transition().call(xAxis);
              xAxisGrid.selectAll('.tick text').attr('transform', 'translate(0, 5)');
              yAxisGrid.transition().call(yAxis);
              bars.selectAll('.bar').transition().style('display', null).attr('x', function (d) {
                return x(d.data.date);
              }).attr('width', x.bandwidth()).attr('y', function (d) {
                return y(d[1]);
              }).attr('height', function (d) {
                return y(d[0]) - y(d[1]);
              });
            });
          }
        }
      })();
      /******/


      return __webpack_exports__;
      /******/
    }()
  );
});